
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $f0b5fa422dff3899$export$59e1210cf9f377b3 = /*#__PURE__*/ function(PlayerAction) {
    PlayerAction[PlayerAction["NONE"] = 0] = "NONE";
    PlayerAction[PlayerAction["TOGGLE_FOW"] = 1] = "TOGGLE_FOW";
    PlayerAction[PlayerAction["ADD_ELIXIR"] = 2] = "ADD_ELIXIR";
    PlayerAction[PlayerAction["ADD_XP"] = 3] = "ADD_XP";
    PlayerAction[PlayerAction["UNLOCK_ALL_ITEMS"] = 4] = "UNLOCK_ALL_ITEMS";
    PlayerAction[PlayerAction["COMPLETE_TAPESTRY"] = 5] = "COMPLETE_TAPESTRY";
    PlayerAction[PlayerAction["DELETE_LOCALSTORAGE"] = 6] = "DELETE_LOCALSTORAGE";
    PlayerAction[PlayerAction["GO_HOME"] = 7] = "GO_HOME";
    PlayerAction[PlayerAction["CYCLE_OPTIC"] = 8] = "CYCLE_OPTIC";
    PlayerAction[PlayerAction["EQUIP_TOOL"] = 9] = "EQUIP_TOOL";
    PlayerAction[PlayerAction["USE_GIZMO"] = 10] = "USE_GIZMO";
    PlayerAction[PlayerAction["MOVE_LEFT"] = 11] = "MOVE_LEFT";
    PlayerAction[PlayerAction["MOVE_RIGHT"] = 12] = "MOVE_RIGHT";
    PlayerAction[PlayerAction["MOVE_UP"] = 13] = "MOVE_UP";
    PlayerAction[PlayerAction["MOVE_DOWN"] = 14] = "MOVE_DOWN";
    PlayerAction[PlayerAction["ROTATE_COUNTER_CLOCKWISE"] = 15] = "ROTATE_COUNTER_CLOCKWISE";
    PlayerAction[PlayerAction["ROTATE_CLOCKWISE"] = 16] = "ROTATE_CLOCKWISE";
    PlayerAction[PlayerAction["TOGGLE_WEAPON"] = 17] = "TOGGLE_WEAPON";
    PlayerAction[PlayerAction["UNEQUIP_TOOL"] = 18] = "UNEQUIP_TOOL";
    PlayerAction[PlayerAction["INTERACT"] = 19] = "INTERACT";
    PlayerAction[PlayerAction["CLOSE_POPUP"] = 20] = "CLOSE_POPUP";
    PlayerAction[PlayerAction["USE_ELIXIR"] = 21] = "USE_ELIXIR";
    PlayerAction[PlayerAction["USE_PORTAL_SCROLL"] = 22] = "USE_PORTAL_SCROLL";
    PlayerAction[PlayerAction["BIND_PIGMENT"] = 23] = "BIND_PIGMENT";
    PlayerAction[PlayerAction["VIEW_LOADOUT"] = 24] = "VIEW_LOADOUT";
    PlayerAction[PlayerAction["CONFIRM_YES"] = 25] = "CONFIRM_YES";
    PlayerAction[PlayerAction["CONFIRM_NO"] = 26] = "CONFIRM_NO";
    return PlayerAction;
}({});
var $f0b5fa422dff3899$export$e8d5f23e889970f8 = /*#__PURE__*/ function(AIAction) {
    AIAction[AIAction["ATTACKING"] = 0] = "ATTACKING";
    AIAction[AIAction["DIED"] = 1] = "DIED";
    AIAction[AIAction["MOVING"] = 2] = "MOVING";
    AIAction[AIAction["WAITING"] = 3] = "WAITING";
    return AIAction;
}({});
var $f0b5fa422dff3899$export$cacd6541cfeeb6c1 = /*#__PURE__*/ function(Direction) {
    Direction[Direction["UP"] = 0] = "UP";
    Direction[Direction["DOWN"] = 1] = "DOWN";
    Direction[Direction["LEFT"] = 2] = "LEFT";
    Direction[Direction["RIGHT"] = 3] = "RIGHT";
    return Direction;
}({});
var $f0b5fa422dff3899$export$8800d5c3a30bb568 = /*#__PURE__*/ function(MapID) {
    MapID[MapID["Playground"] = 0] = "Playground";
    MapID[MapID["Portals"] = 1] = "Portals";
    MapID[MapID["January"] = 2] = "January";
    MapID[MapID["February"] = 3] = "February";
    MapID[MapID["March"] = 4] = "March";
    MapID[MapID["April"] = 5] = "April";
    MapID[MapID["May"] = 6] = "May";
    MapID[MapID["June"] = 7] = "June";
    MapID[MapID["July"] = 8] = "July";
    MapID[MapID["August"] = 9] = "August";
    MapID[MapID["September"] = 10] = "September";
    MapID[MapID["October"] = 11] = "October";
    MapID[MapID["November"] = 12] = "November";
    MapID[MapID["December"] = 13] = "December";
    return MapID;
}({});
var $f0b5fa422dff3899$export$9b18cdab1ebfcb11 = /*#__PURE__*/ function(OneshotID) {
    OneshotID[OneshotID["ESCAPE_ROPE"] = 0] = "ESCAPE_ROPE";
    return OneshotID;
}({});
var $f0b5fa422dff3899$export$b1b64d948644442b = /*#__PURE__*/ function(PaletteColor) {
    PaletteColor[PaletteColor["YELLOW"] = 0] = "YELLOW";
    PaletteColor[PaletteColor["RED"] = 1] = "RED";
    PaletteColor[PaletteColor["MAGENTA"] = 2] = "MAGENTA";
    PaletteColor[PaletteColor["BLUE"] = 3] = "BLUE";
    PaletteColor[PaletteColor["CYAN"] = 4] = "CYAN";
    PaletteColor[PaletteColor["GREEN"] = 5] = "GREEN";
    PaletteColor[PaletteColor["BLACK"] = 6] = "BLACK";
    PaletteColor[PaletteColor["WHITE"] = 7] = "WHITE";
    PaletteColor[PaletteColor["NONE"] = 8] = "NONE";
    return PaletteColor;
}({});
var $f0b5fa422dff3899$export$45e36ab1b645cb80 = /*#__PURE__*/ function(PlayerBody) {
    PlayerBody[PlayerBody["HEAD"] = 0] = "HEAD";
    PlayerBody[PlayerBody["TORSO"] = 1] = "TORSO";
    PlayerBody[PlayerBody["FEET"] = 2] = "FEET";
    PlayerBody[PlayerBody["LEFT_HAND"] = 3] = "LEFT_HAND";
    PlayerBody[PlayerBody["RIGHT_HAND"] = 4] = "RIGHT_HAND";
    return PlayerBody;
}({});
var $f0b5fa422dff3899$export$fe68bdb23e385108 = /*#__PURE__*/ function(PopupID) {
    PopupID[PopupID["TAPESTRY"] = 0] = "TAPESTRY";
    PopupID[PopupID["ARCHIVE"] = 1] = "ARCHIVE";
    PopupID[PopupID["BESTIARY"] = 2] = "BESTIARY";
    PopupID[PopupID["ARSENAL"] = 3] = "ARSENAL";
    PopupID[PopupID["WARDROBE"] = 4] = "WARDROBE";
    PopupID[PopupID["COMMON_FINDS"] = 5] = "COMMON_FINDS";
    PopupID[PopupID["MYTHIC_FINDS"] = 6] = "MYTHIC_FINDS";
    PopupID[PopupID["GIZMOS"] = 7] = "GIZMOS";
    PopupID[PopupID["VIEW_LOADOUT"] = 8] = "VIEW_LOADOUT";
    PopupID[PopupID["NONE"] = 9] = "NONE";
    return PopupID;
}({});
var $f0b5fa422dff3899$export$fc131e7dfc19bffe = /*#__PURE__*/ function(EntryLocation) {
    EntryLocation[EntryLocation["NONE"] = 0] = "NONE";
    EntryLocation[EntryLocation["TOP_CENTER"] = 1] = "TOP_CENTER";
    EntryLocation[EntryLocation["RIGHT_CENTER"] = 2] = "RIGHT_CENTER";
    EntryLocation[EntryLocation["BOTTOM_CENTER"] = 3] = "BOTTOM_CENTER";
    EntryLocation[EntryLocation["LEFT_CENTER"] = 4] = "LEFT_CENTER";
    return EntryLocation;
}({});
var $f0b5fa422dff3899$export$889fea6127a16d48 = /*#__PURE__*/ function(AttackType) {
    AttackType[AttackType["NONE"] = 0] = "NONE";
    AttackType[AttackType["DEVOUR"] = 1] = "DEVOUR";
    AttackType[AttackType["DRAIN_ESSENCE"] = 2] = "DRAIN_ESSENCE";
    AttackType[AttackType["DRAIN_PIGMENT"] = 3] = "DRAIN_PIGMENT";
    AttackType[AttackType["DRAIN_ESSENCE_AND_PIGMENT"] = 4] = "DRAIN_ESSENCE_AND_PIGMENT";
    return AttackType;
}({});
var $f0b5fa422dff3899$export$1a91c501cca01afe = /*#__PURE__*/ function(EnemyType) {
    EnemyType[EnemyType["NONE"] = 0] = "NONE";
    EnemyType[EnemyType["RIFT_ESSENCE"] = 1] = "RIFT_ESSENCE";
    EnemyType[EnemyType["RIFT_PIGMENT"] = 2] = "RIFT_PIGMENT";
    EnemyType[EnemyType["RIFT_BOTH"] = 3] = "RIFT_BOTH";
    EnemyType[EnemyType["SPECTRE_ESSENCE"] = 4] = "SPECTRE_ESSENCE";
    EnemyType[EnemyType["SPECTRE_PIGMENT"] = 5] = "SPECTRE_PIGMENT";
    EnemyType[EnemyType["SPECTRE_BOTH"] = 6] = "SPECTRE_BOTH";
    EnemyType[EnemyType["REAVER_ESSENCE"] = 7] = "REAVER_ESSENCE";
    EnemyType[EnemyType["REAVER_PIGMENT"] = 8] = "REAVER_PIGMENT";
    EnemyType[EnemyType["REAVER_BOTH"] = 9] = "REAVER_BOTH";
    EnemyType[EnemyType["BLADE_ESSENCE"] = 10] = "BLADE_ESSENCE";
    EnemyType[EnemyType["BLADE_PIGMENT"] = 11] = "BLADE_PIGMENT";
    EnemyType[EnemyType["BLADE_BOTH"] = 12] = "BLADE_BOTH";
    EnemyType[EnemyType["VOID_ESSENCE"] = 13] = "VOID_ESSENCE";
    EnemyType[EnemyType["VOID_PIGMENT"] = 14] = "VOID_PIGMENT";
    EnemyType[EnemyType["VOID_BOTH"] = 15] = "VOID_BOTH";
    EnemyType[EnemyType["DEVOURER"] = 16] = "DEVOURER";
    return EnemyType;
}({});
var $f0b5fa422dff3899$export$1fc8f52ad1810e52 = /*#__PURE__*/ function(ItemType) {
    ItemType[ItemType["BOMB_PIGMENT"] = 0] = "BOMB_PIGMENT";
    ItemType[ItemType["BOMB_ESSENCE"] = 1] = "BOMB_ESSENCE";
    ItemType[ItemType["HINT_INFO"] = 2] = "HINT_INFO";
    ItemType[ItemType["HINT_COLLECTIBLE"] = 3] = "HINT_COLLECTIBLE";
    ItemType[ItemType["HINT_WARNING"] = 4] = "HINT_WARNING";
    ItemType[ItemType["ENTRANCE"] = 5] = "ENTRANCE";
    ItemType[ItemType["ESSENCE"] = 6] = "ESSENCE";
    ItemType[ItemType["ESSENCE_OR_PIGMENT"] = 7] = "ESSENCE_OR_PIGMENT";
    ItemType[ItemType["KEY"] = 8] = "KEY";
    // COLLECTIBLES
    ItemType[ItemType["COLLECTIBLE_COMMON"] = 9] = "COLLECTIBLE_COMMON";
    ItemType[ItemType["COLLECTIBLE_MYTHIC"] = 10] = "COLLECTIBLE_MYTHIC";
    // EQUIPMENT (HEADGEAR)
    ItemType[ItemType["EQUIPMENT_HEAD_NONE"] = 11] = "EQUIPMENT_HEAD_NONE";
    ItemType[ItemType["EQUIPMENT_HEAD1"] = 12] = "EQUIPMENT_HEAD1";
    ItemType[ItemType["EQUIPMENT_HEAD2"] = 13] = "EQUIPMENT_HEAD2";
    ItemType[ItemType["EQUIPMENT_HEAD3"] = 14] = "EQUIPMENT_HEAD3";
    ItemType[ItemType["EQUIPMENT_HEAD4"] = 15] = "EQUIPMENT_HEAD4";
    ItemType[ItemType["EQUIPMENT_HEAD5"] = 16] = "EQUIPMENT_HEAD5";
    ItemType[ItemType["EQUIPMENT_HEAD6"] = 17] = "EQUIPMENT_HEAD6";
    ItemType[ItemType["EQUIPMENT_HEAD7"] = 18] = "EQUIPMENT_HEAD7";
    ItemType[ItemType["EQUIPMENT_HEAD8"] = 19] = "EQUIPMENT_HEAD8";
    // EQUIPMENT (TORSO)
    ItemType[ItemType["EQUIPMENT_TORSO_NONE"] = 20] = "EQUIPMENT_TORSO_NONE";
    ItemType[ItemType["EQUIPMENT_TORSO1"] = 21] = "EQUIPMENT_TORSO1";
    ItemType[ItemType["EQUIPMENT_TORSO2"] = 22] = "EQUIPMENT_TORSO2";
    ItemType[ItemType["EQUIPMENT_TORSO3"] = 23] = "EQUIPMENT_TORSO3";
    ItemType[ItemType["EQUIPMENT_TORSO4"] = 24] = "EQUIPMENT_TORSO4";
    ItemType[ItemType["EQUIPMENT_TORSO5"] = 25] = "EQUIPMENT_TORSO5";
    ItemType[ItemType["EQUIPMENT_TORSO6"] = 26] = "EQUIPMENT_TORSO6";
    ItemType[ItemType["EQUIPMENT_TORSO7"] = 27] = "EQUIPMENT_TORSO7";
    ItemType[ItemType["EQUIPMENT_TORSO8"] = 28] = "EQUIPMENT_TORSO8";
    // EQUIPMENT (FEET)
    ItemType[ItemType["EQUIPMENT_FEET_NONE"] = 29] = "EQUIPMENT_FEET_NONE";
    ItemType[ItemType["EQUIPMENT_FEET1"] = 30] = "EQUIPMENT_FEET1";
    ItemType[ItemType["EQUIPMENT_FEET2"] = 31] = "EQUIPMENT_FEET2";
    ItemType[ItemType["EQUIPMENT_FEET3"] = 32] = "EQUIPMENT_FEET3";
    ItemType[ItemType["EQUIPMENT_FEET4"] = 33] = "EQUIPMENT_FEET4";
    ItemType[ItemType["EQUIPMENT_FEET5"] = 34] = "EQUIPMENT_FEET5";
    ItemType[ItemType["EQUIPMENT_FEET6"] = 35] = "EQUIPMENT_FEET6";
    ItemType[ItemType["EQUIPMENT_FEET7"] = 36] = "EQUIPMENT_FEET7";
    ItemType[ItemType["EQUIPMENT_FEET8"] = 37] = "EQUIPMENT_FEET8";
    // EQUIPMENT (GIZMOS)
    ItemType[ItemType["EQUIPMENT_GIZMO_NONE"] = 38] = "EQUIPMENT_GIZMO_NONE";
    ItemType[ItemType["EQUIPMENT_GIZMO1"] = 39] = "EQUIPMENT_GIZMO1";
    ItemType[ItemType["EQUIPMENT_GIZMO2"] = 40] = "EQUIPMENT_GIZMO2";
    ItemType[ItemType["EQUIPMENT_GIZMO3"] = 41] = "EQUIPMENT_GIZMO3";
    ItemType[ItemType["EQUIPMENT_GIZMO4"] = 42] = "EQUIPMENT_GIZMO4";
    ItemType[ItemType["EQUIPMENT_GIZMO5"] = 43] = "EQUIPMENT_GIZMO5";
    ItemType[ItemType["EQUIPMENT_GIZMO6"] = 44] = "EQUIPMENT_GIZMO6";
    // EQUIPMENT (WEAPONS)
    ItemType[ItemType["EQUIPMENT_WEAPON_NONE"] = 45] = "EQUIPMENT_WEAPON_NONE";
    ItemType[ItemType["EQUIPMENT_WEAPON1"] = 46] = "EQUIPMENT_WEAPON1";
    ItemType[ItemType["EQUIPMENT_WEAPON2"] = 47] = "EQUIPMENT_WEAPON2";
    ItemType[ItemType["EQUIPMENT_WEAPON3"] = 48] = "EQUIPMENT_WEAPON3";
    ItemType[ItemType["EQUIPMENT_WEAPON4"] = 49] = "EQUIPMENT_WEAPON4";
    ItemType[ItemType["EQUIPMENT_WEAPON5"] = 50] = "EQUIPMENT_WEAPON5";
    ItemType[ItemType["EQUIPMENT_WEAPON6"] = 51] = "EQUIPMENT_WEAPON6";
    ItemType[ItemType["EQUIPMENT_WEAPON7"] = 52] = "EQUIPMENT_WEAPON7";
    // OPTICS
    ItemType[ItemType["OPTIC_YELLOW"] = 53] = "OPTIC_YELLOW";
    ItemType[ItemType["OPTIC_NONE"] = 54] = "OPTIC_NONE";
    ItemType[ItemType["OPTIC_RED"] = 55] = "OPTIC_RED";
    ItemType[ItemType["OPTIC_MAGENTA"] = 56] = "OPTIC_MAGENTA";
    ItemType[ItemType["OPTIC_BLUE"] = 57] = "OPTIC_BLUE";
    ItemType[ItemType["OPTIC_CYAN"] = 58] = "OPTIC_CYAN";
    ItemType[ItemType["OPTIC_GREEN"] = 59] = "OPTIC_GREEN";
    ItemType[ItemType["OPTIC_RANDOM"] = 60] = "OPTIC_RANDOM";
    ItemType[ItemType["NONE"] = 61] = "NONE";
    // PIGMENTS
    ItemType[ItemType["PIGMENT_YELLOW"] = 62] = "PIGMENT_YELLOW";
    ItemType[ItemType["PIGMENT_RED"] = 63] = "PIGMENT_RED";
    ItemType[ItemType["PIGMENT_MAGENTA"] = 64] = "PIGMENT_MAGENTA";
    ItemType[ItemType["PIGMENT_BLUE"] = 65] = "PIGMENT_BLUE";
    ItemType[ItemType["PIGMENT_CYAN"] = 66] = "PIGMENT_CYAN";
    ItemType[ItemType["PIGMENT_GREEN"] = 67] = "PIGMENT_GREEN";
    ItemType[ItemType["PIGMENT_MATCH_OPTIC"] = 68] = "PIGMENT_MATCH_OPTIC";
    ItemType[ItemType["PIGMENT_RANDOM"] = 69] = "PIGMENT_RANDOM";
    ItemType[ItemType["BINDER"] = 70] = "BINDER";
    ItemType[ItemType["ELIXIR"] = 71] = "ELIXIR";
    ItemType[ItemType["PORTAL"] = 72] = "PORTAL";
    ItemType[ItemType["CASE_ACHIEVEMENTS"] = 73] = "CASE_ACHIEVEMENTS";
    ItemType[ItemType["TAPESTRY"] = 74] = "TAPESTRY";
    return ItemType;
}({});
var $f0b5fa422dff3899$export$ded4562bce86da45 = /*#__PURE__*/ function(MapType) {
    MapType[MapType["STATIC"] = 0] = "STATIC";
    MapType[MapType["DYNAMIC"] = 1] = "DYNAMIC";
    return MapType;
}({});
function $f0b5fa422dff3899$export$4881cbfa38820e12(type) {
    return type == 63 || type == 67 || type == 65 || type == 64 || type == 66 || type == 62;
}


/**
 * This code is an implementation of Alea algorithm; (C) 2010 Johannes Baagøe.
 * Alea is licensed according to the http://en.wikipedia.org/wiki/MIT_License.
 */ const $edda5dda3fa6766c$var$FRAC = 2.3283064365386963e-10; /* 2^-32 */ 
class $edda5dda3fa6766c$var$RNG {
    constructor(){
        this._seed = 0;
        this._s0 = 0;
        this._s1 = 0;
        this._s2 = 0;
        this._c = 0;
    }
    getSeed() {
        return this._seed;
    }
    /**
     * Seed the number generator
     */ setSeed(seed) {
        seed = seed < 1 ? 1 / seed : seed;
        this._seed = seed;
        this._s0 = (seed >>> 0) * $edda5dda3fa6766c$var$FRAC;
        seed = seed * 69069 + 1 >>> 0;
        this._s1 = seed * $edda5dda3fa6766c$var$FRAC;
        seed = seed * 69069 + 1 >>> 0;
        this._s2 = seed * $edda5dda3fa6766c$var$FRAC;
        this._c = 1;
        return this;
    }
    /**
     * @returns Pseudorandom value [0,1), uniformly distributed
     */ getUniform() {
        let t = 2091639 * this._s0 + this._c * $edda5dda3fa6766c$var$FRAC;
        this._s0 = this._s1;
        this._s1 = this._s2;
        this._c = t | 0;
        this._s2 = t - this._c;
        return this._s2;
    }
    /**
     * @param lowerBound The lower end of the range to return a value from, inclusive
     * @param upperBound The upper end of the range to return a value from, inclusive
     * @returns Pseudorandom value [lowerBound, upperBound], using ROT.RNG.getUniform() to distribute the value
     */ getUniformInt(lowerBound, upperBound) {
        let max = Math.max(lowerBound, upperBound);
        let min = Math.min(lowerBound, upperBound);
        return Math.floor(this.getUniform() * (max - min + 1)) + min;
    }
    /**
     * @param mean Mean value
     * @param stddev Standard deviation. ~95% of the absolute values will be lower than 2*stddev.
     * @returns A normally distributed pseudorandom value
     */ getNormal(mean = 0, stddev = 1) {
        let u, v, r;
        do {
            u = 2 * this.getUniform() - 1;
            v = 2 * this.getUniform() - 1;
            r = u * u + v * v;
        }while (r > 1 || r == 0);
        let gauss = u * Math.sqrt(-2 * Math.log(r) / r);
        return mean + gauss * stddev;
    }
    /**
     * @returns Pseudorandom value [1,100] inclusive, uniformly distributed
     */ getPercentage() {
        return 1 + Math.floor(this.getUniform() * 100);
    }
    /**
     * @returns Randomly picked item, null when length=0
     */ getItem(array) {
        if (!array.length) return null;
        return array[Math.floor(this.getUniform() * array.length)];
    }
    /**
     * @returns New array with randomized items
     */ shuffle(array) {
        let result = [];
        let clone = array.slice();
        while(clone.length){
            let index = clone.indexOf(this.getItem(clone));
            result.push(clone.splice(index, 1)[0]);
        }
        return result;
    }
    /**
     * @param data key=whatever, value=weight (relative probability)
     * @returns whatever
     */ getWeightedValue(data) {
        let total = 0;
        for(let id in data)total += data[id];
        let random = this.getUniform() * total;
        let id, part = 0;
        for(id in data){
            part += data[id];
            if (random < part) return id;
        }
        // If by some floating-point annoyance we have
        // random >= total, just return the last id.
        return id;
    }
    /**
     * Get RNG state. Useful for storing the state and re-setting it via setState.
     * @returns Internal state
     */ getState() {
        return [
            this._s0,
            this._s1,
            this._s2,
            this._c
        ];
    }
    /**
     * Set a previously retrieved state.
     */ setState(state) {
        this._s0 = state[0];
        this._s1 = state[1];
        this._s2 = state[2];
        this._c = state[3];
        return this;
    }
    /**
     * Returns a cloned RNG
     */ clone() {
        let clone = new $edda5dda3fa6766c$var$RNG();
        return clone.setState(this.getState());
    }
}
var $edda5dda3fa6766c$export$2e2bcd8739ae039 = new $edda5dda3fa6766c$var$RNG().setSeed(Date.now());


/**
 * @class Abstract display backend module
 * @private
 */ class $d5ea979d8ccf4ab7$export$2e2bcd8739ae039 {
    getContainer() {
        return null;
    }
    setOptions(options) {
        this._options = options;
    }
}


class $16f54ac46faba368$export$2e2bcd8739ae039 extends (0, $d5ea979d8ccf4ab7$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._ctx = document.createElement("canvas").getContext("2d");
    }
    schedule(cb) {
        requestAnimationFrame(cb);
    }
    getContainer() {
        return this._ctx.canvas;
    }
    setOptions(opts) {
        super.setOptions(opts);
        const style = opts.fontStyle ? `${opts.fontStyle} ` : ``;
        const font = `${style} ${opts.fontSize}px ${opts.fontFamily}`;
        this._ctx.font = font;
        this._updateSize();
        this._ctx.font = font;
        this._ctx.textAlign = "center";
        this._ctx.textBaseline = "middle";
    }
    clear() {
        const oldComposite = this._ctx.globalCompositeOperation;
        this._ctx.globalCompositeOperation = "copy";
        this._ctx.fillStyle = this._options.bg;
        this._ctx.fillRect(0, 0, this._ctx.canvas.width, this._ctx.canvas.height);
        this._ctx.globalCompositeOperation = oldComposite;
    }
    eventToPosition(x, y) {
        let canvas = this._ctx.canvas;
        let rect = canvas.getBoundingClientRect();
        x -= rect.left;
        y -= rect.top;
        x *= canvas.width / rect.width;
        y *= canvas.height / rect.height;
        if (x < 0 || y < 0 || x >= canvas.width || y >= canvas.height) return [
            -1,
            -1
        ];
        return this._normalizedEventToPosition(x, y);
    }
}


var $0901a3208c7d141c$exports = {};

$parcel$export($0901a3208c7d141c$exports, "mod", () => $0901a3208c7d141c$export$842a2cf37af977e1);
$parcel$export($0901a3208c7d141c$exports, "clamp", () => $0901a3208c7d141c$export$7d15b64cf5a3a4c4);
$parcel$export($0901a3208c7d141c$exports, "capitalize", () => $0901a3208c7d141c$export$9a00dee1beb8f576);
$parcel$export($0901a3208c7d141c$exports, "format", () => $0901a3208c7d141c$export$d9468344d3651243);
/**
 * Always positive modulus
 * @param x Operand
 * @param n Modulus
 * @returns x modulo n
 */ function $0901a3208c7d141c$export$842a2cf37af977e1(x, n) {
    return (x % n + n) % n;
}
function $0901a3208c7d141c$export$7d15b64cf5a3a4c4(val, min = 0, max = 1) {
    if (val < min) return min;
    if (val > max) return max;
    return val;
}
function $0901a3208c7d141c$export$9a00dee1beb8f576(string) {
    return string.charAt(0).toUpperCase() + string.substring(1);
}
function $0901a3208c7d141c$export$d9468344d3651243(template, ...args) {
    let map = $0901a3208c7d141c$export$d9468344d3651243.map;
    let replacer = function(match, group1, group2, index) {
        if (template.charAt(index - 1) == "%") return match.substring(1);
        if (!args.length) return match;
        let obj = args[0];
        let group = group1 || group2;
        let parts = group.split(",");
        let name = parts.shift() || "";
        let method = map[name.toLowerCase()];
        if (!method) return match;
        obj = args.shift();
        let replaced = obj[method].apply(obj, parts);
        let first = name.charAt(0);
        if (first != first.toLowerCase()) replaced = $0901a3208c7d141c$export$9a00dee1beb8f576(replaced);
        return replaced;
    };
    return template.replace(/%(?:([a-z]+)|(?:{([^}]+)}))/gi, replacer);
}
$0901a3208c7d141c$export$d9468344d3651243.map = {
    "s": "toString"
};


class $98dd8589dbcaea88$export$2e2bcd8739ae039 extends (0, $16f54ac46faba368$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._spacingX = 0;
        this._spacingY = 0;
        this._hexSize = 0;
    }
    draw(data, clearBefore) {
        let [x, y, ch, fg, bg] = data;
        let px = [
            (x + 1) * this._spacingX,
            y * this._spacingY + this._hexSize
        ];
        if (this._options.transpose) px.reverse();
        if (clearBefore) {
            this._ctx.fillStyle = bg;
            this._fill(px[0], px[1]);
        }
        if (!ch) return;
        this._ctx.fillStyle = fg;
        let chars = [].concat(ch);
        for(let i = 0; i < chars.length; i++)this._ctx.fillText(chars[i], px[0], Math.ceil(px[1]));
    }
    computeSize(availWidth, availHeight) {
        if (this._options.transpose) {
            availWidth += availHeight;
            availHeight = availWidth - availHeight;
            availWidth -= availHeight;
        }
        let width = Math.floor(availWidth / this._spacingX) - 1;
        let height = Math.floor((availHeight - 2 * this._hexSize) / this._spacingY + 1);
        return [
            width,
            height
        ];
    }
    computeFontSize(availWidth, availHeight) {
        if (this._options.transpose) {
            availWidth += availHeight;
            availHeight = availWidth - availHeight;
            availWidth -= availHeight;
        }
        let hexSizeWidth = 2 * availWidth / ((this._options.width + 1) * Math.sqrt(3)) - 1;
        let hexSizeHeight = availHeight / (2 + 1.5 * (this._options.height - 1));
        let hexSize = Math.min(hexSizeWidth, hexSizeHeight);
        // compute char ratio
        let oldFont = this._ctx.font;
        this._ctx.font = "100px " + this._options.fontFamily;
        let width = Math.ceil(this._ctx.measureText("W").width);
        this._ctx.font = oldFont;
        let ratio = width / 100;
        hexSize = Math.floor(hexSize) + 1; // closest larger hexSize
        // FIXME char size computation does not respect transposed hexes
        let fontSize = 2 * hexSize / (this._options.spacing * (1 + ratio / Math.sqrt(3)));
        // closest smaller fontSize
        return Math.ceil(fontSize) - 1;
    }
    _normalizedEventToPosition(x, y) {
        let nodeSize;
        if (this._options.transpose) {
            x += y;
            y = x - y;
            x -= y;
            nodeSize = this._ctx.canvas.width;
        } else nodeSize = this._ctx.canvas.height;
        let size = nodeSize / this._options.height;
        y = Math.floor(y / size);
        if ((0, $0901a3208c7d141c$export$842a2cf37af977e1)(y, 2)) {
            x -= this._spacingX;
            x = 1 + 2 * Math.floor(x / (2 * this._spacingX));
        } else x = 2 * Math.floor(x / (2 * this._spacingX));
        return [
            x,
            y
        ];
    }
    /**
     * Arguments are pixel values. If "transposed" mode is enabled, then these two are already swapped.
     */ _fill(cx, cy) {
        let a = this._hexSize;
        let b = this._options.border;
        const ctx = this._ctx;
        ctx.beginPath();
        if (this._options.transpose) {
            ctx.moveTo(cx - a + b, cy);
            ctx.lineTo(cx - a / 2 + b, cy + this._spacingX - b);
            ctx.lineTo(cx + a / 2 - b, cy + this._spacingX - b);
            ctx.lineTo(cx + a - b, cy);
            ctx.lineTo(cx + a / 2 - b, cy - this._spacingX + b);
            ctx.lineTo(cx - a / 2 + b, cy - this._spacingX + b);
            ctx.lineTo(cx - a + b, cy);
        } else {
            ctx.moveTo(cx, cy - a + b);
            ctx.lineTo(cx + this._spacingX - b, cy - a / 2 + b);
            ctx.lineTo(cx + this._spacingX - b, cy + a / 2 - b);
            ctx.lineTo(cx, cy + a - b);
            ctx.lineTo(cx - this._spacingX + b, cy + a / 2 - b);
            ctx.lineTo(cx - this._spacingX + b, cy - a / 2 + b);
            ctx.lineTo(cx, cy - a + b);
        }
        ctx.fill();
    }
    _updateSize() {
        const opts = this._options;
        const charWidth = Math.ceil(this._ctx.measureText("W").width);
        this._hexSize = Math.floor(opts.spacing * (opts.fontSize + charWidth / Math.sqrt(3)) / 2);
        this._spacingX = this._hexSize * Math.sqrt(3) / 2;
        this._spacingY = this._hexSize * 1.5;
        let xprop;
        let yprop;
        if (opts.transpose) {
            xprop = "height";
            yprop = "width";
        } else {
            xprop = "width";
            yprop = "height";
        }
        this._ctx.canvas[xprop] = Math.ceil((opts.width + 1) * this._spacingX);
        this._ctx.canvas[yprop] = Math.ceil((opts.height - 1) * this._spacingY + 2 * this._hexSize);
    }
}



class $091354b8cd104fa5$export$2e2bcd8739ae039 extends (0, $16f54ac46faba368$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._spacingX = 0;
        this._spacingY = 0;
        this._canvasCache = {};
    }
    setOptions(options) {
        super.setOptions(options);
        this._canvasCache = {};
    }
    draw(data, clearBefore) {
        if ($091354b8cd104fa5$export$2e2bcd8739ae039.cache) this._drawWithCache(data);
        else this._drawNoCache(data, clearBefore);
    }
    _drawWithCache(data) {
        let [x, y, ch, fg, bg] = data;
        let hash = "" + ch + fg + bg;
        let canvas;
        if (hash in this._canvasCache) canvas = this._canvasCache[hash];
        else {
            let b = this._options.border;
            canvas = document.createElement("canvas");
            let ctx = canvas.getContext("2d");
            canvas.width = this._spacingX;
            canvas.height = this._spacingY;
            ctx.fillStyle = bg;
            ctx.fillRect(b, b, canvas.width - b, canvas.height - b);
            if (ch) {
                ctx.fillStyle = fg;
                ctx.font = this._ctx.font;
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";
                let chars = [].concat(ch);
                for(let i = 0; i < chars.length; i++)ctx.fillText(chars[i], this._spacingX / 2, Math.ceil(this._spacingY / 2));
            }
            this._canvasCache[hash] = canvas;
        }
        this._ctx.drawImage(canvas, x * this._spacingX, y * this._spacingY);
    }
    _drawNoCache(data, clearBefore) {
        let [x, y, ch, fg, bg] = data;
        if (clearBefore) {
            let b = this._options.border;
            this._ctx.fillStyle = bg;
            this._ctx.fillRect(x * this._spacingX + b, y * this._spacingY + b, this._spacingX - b, this._spacingY - b);
        }
        if (!ch) return;
        this._ctx.fillStyle = fg;
        let chars = [].concat(ch);
        for(let i = 0; i < chars.length; i++)this._ctx.fillText(chars[i], (x + 0.5) * this._spacingX, Math.ceil((y + 0.5) * this._spacingY));
    }
    computeSize(availWidth, availHeight) {
        let width = Math.floor(availWidth / this._spacingX);
        let height = Math.floor(availHeight / this._spacingY);
        return [
            width,
            height
        ];
    }
    computeFontSize(availWidth, availHeight) {
        let boxWidth = Math.floor(availWidth / this._options.width);
        let boxHeight = Math.floor(availHeight / this._options.height);
        /* compute char ratio */ let oldFont = this._ctx.font;
        this._ctx.font = "100px " + this._options.fontFamily;
        let width = Math.ceil(this._ctx.measureText("W").width);
        this._ctx.font = oldFont;
        let ratio = width / 100;
        let widthFraction = ratio * boxHeight / boxWidth;
        if (widthFraction > 1) boxHeight = Math.floor(boxHeight / widthFraction);
        return Math.floor(boxHeight / this._options.spacing);
    }
    _normalizedEventToPosition(x, y) {
        return [
            Math.floor(x / this._spacingX),
            Math.floor(y / this._spacingY)
        ];
    }
    _updateSize() {
        const opts = this._options;
        const charWidth = Math.ceil(this._ctx.measureText("W").width);
        this._spacingX = Math.ceil(opts.spacing * charWidth);
        this._spacingY = Math.ceil(opts.spacing * opts.fontSize);
        if (opts.forceSquareRatio) this._spacingX = this._spacingY = Math.max(this._spacingX, this._spacingY);
        this._ctx.canvas.width = opts.width * this._spacingX;
        this._ctx.canvas.height = opts.height * this._spacingY;
    }
}
$091354b8cd104fa5$export$2e2bcd8739ae039.cache = false;



class $cdd36850d1486376$export$2e2bcd8739ae039 extends (0, $16f54ac46faba368$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._colorCanvas = document.createElement("canvas");
    }
    draw(data, clearBefore) {
        let [x, y, ch, fg, bg] = data;
        let tileWidth = this._options.tileWidth;
        let tileHeight = this._options.tileHeight;
        if (clearBefore) {
            if (this._options.tileColorize) this._ctx.clearRect(x * tileWidth, y * tileHeight, tileWidth, tileHeight);
            else {
                this._ctx.fillStyle = bg;
                this._ctx.fillRect(x * tileWidth, y * tileHeight, tileWidth, tileHeight);
            }
        }
        if (!ch) return;
        let chars = [].concat(ch);
        let fgs = [].concat(fg);
        let bgs = [].concat(bg);
        for(let i = 0; i < chars.length; i++){
            let tile = this._options.tileMap[chars[i]];
            if (!tile) throw new Error(`Char "${chars[i]}" not found in tileMap`);
            if (this._options.tileColorize) {
                let canvas = this._colorCanvas;
                let context = canvas.getContext("2d");
                context.globalCompositeOperation = "source-over";
                context.clearRect(0, 0, tileWidth, tileHeight);
                let fg = fgs[i];
                let bg = bgs[i];
                context.drawImage(this._options.tileSet, tile[0], tile[1], tileWidth, tileHeight, 0, 0, tileWidth, tileHeight);
                if (fg != "transparent") {
                    context.fillStyle = fg;
                    context.globalCompositeOperation = "source-atop";
                    context.fillRect(0, 0, tileWidth, tileHeight);
                }
                if (bg != "transparent") {
                    context.fillStyle = bg;
                    context.globalCompositeOperation = "destination-over";
                    context.fillRect(0, 0, tileWidth, tileHeight);
                }
                this._ctx.drawImage(canvas, x * tileWidth, y * tileHeight, tileWidth, tileHeight);
            } else this._ctx.drawImage(this._options.tileSet, tile[0], tile[1], tileWidth, tileHeight, x * tileWidth, y * tileHeight, tileWidth, tileHeight);
        }
    }
    computeSize(availWidth, availHeight) {
        let width = Math.floor(availWidth / this._options.tileWidth);
        let height = Math.floor(availHeight / this._options.tileHeight);
        return [
            width,
            height
        ];
    }
    computeFontSize() {
        throw new Error("Tile backend does not understand font size");
    }
    _normalizedEventToPosition(x, y) {
        return [
            Math.floor(x / this._options.tileWidth),
            Math.floor(y / this._options.tileHeight)
        ];
    }
    _updateSize() {
        const opts = this._options;
        this._ctx.canvas.width = opts.width * opts.tileWidth;
        this._ctx.canvas.height = opts.height * opts.tileHeight;
        this._colorCanvas.width = opts.tileWidth;
        this._colorCanvas.height = opts.tileHeight;
    }
}



var $f4089545ec769444$exports = {};

$parcel$export($f4089545ec769444$exports, "fromString", () => $f4089545ec769444$export$3004f64547af360e);
$parcel$export($f4089545ec769444$exports, "add", () => $f4089545ec769444$export$e16d8520af44a096);
$parcel$export($f4089545ec769444$exports, "add_", () => $f4089545ec769444$export$bc24ee9de1357795);
$parcel$export($f4089545ec769444$exports, "multiply", () => $f4089545ec769444$export$2060d2db72cce88f);
$parcel$export($f4089545ec769444$exports, "multiply_", () => $f4089545ec769444$export$1d5190495a5e1224);
$parcel$export($f4089545ec769444$exports, "interpolate", () => $f4089545ec769444$export$89e29e4ab65e70a9);
$parcel$export($f4089545ec769444$exports, "lerp", () => $f4089545ec769444$export$3a89f8d6f6bf6c9f);
$parcel$export($f4089545ec769444$exports, "interpolateHSL", () => $f4089545ec769444$export$20923c8288a77f0a);
$parcel$export($f4089545ec769444$exports, "rgb2hsl", () => $f4089545ec769444$export$b5ba70b240f8f7f);
$parcel$export($f4089545ec769444$exports, "hsl2rgb", () => $f4089545ec769444$export$4c15bd42559b811d);
$parcel$export($f4089545ec769444$exports, "lerpHSL", () => $f4089545ec769444$export$d1f6d182b0a7d941);
$parcel$export($f4089545ec769444$exports, "randomize", () => $f4089545ec769444$export$a477072d5b4aa0b);
$parcel$export($f4089545ec769444$exports, "toRGB", () => $f4089545ec769444$export$c0374a851d79f51b);
$parcel$export($f4089545ec769444$exports, "toHex", () => $f4089545ec769444$export$7ea66e3774a60b67);


function $f4089545ec769444$export$3004f64547af360e(str) {
    let cached, r;
    if (str in $f4089545ec769444$var$CACHE) cached = $f4089545ec769444$var$CACHE[str];
    else {
        if (str.charAt(0) == "#") {
            let matched = str.match(/[0-9a-f]/gi) || [];
            let values = matched.map((x)=>parseInt(x, 16));
            if (values.length == 3) cached = values.map((x)=>x * 17);
            else {
                for(let i = 0; i < 3; i++){
                    values[i + 1] += 16 * values[i];
                    values.splice(i, 1);
                }
                cached = values;
            }
        } else if (r = str.match(/rgb\(([0-9, ]+)\)/i)) cached = r[1].split(/\s*,\s*/).map((x)=>parseInt(x));
        else cached = [
            0,
            0,
            0
        ];
        $f4089545ec769444$var$CACHE[str] = cached;
    }
    return cached.slice();
}
function $f4089545ec769444$export$e16d8520af44a096(color1, ...colors) {
    let result = color1.slice();
    for(let i = 0; i < 3; i++)for(let j = 0; j < colors.length; j++)result[i] += colors[j][i];
    return result;
}
function $f4089545ec769444$export$bc24ee9de1357795(color1, ...colors) {
    for(let i = 0; i < 3; i++)for(let j = 0; j < colors.length; j++)color1[i] += colors[j][i];
    return color1;
}
function $f4089545ec769444$export$2060d2db72cce88f(color1, ...colors) {
    let result = color1.slice();
    for(let i = 0; i < 3; i++){
        for(let j = 0; j < colors.length; j++)result[i] *= colors[j][i] / 255;
        result[i] = Math.round(result[i]);
    }
    return result;
}
function $f4089545ec769444$export$1d5190495a5e1224(color1, ...colors) {
    for(let i = 0; i < 3; i++){
        for(let j = 0; j < colors.length; j++)color1[i] *= colors[j][i] / 255;
        color1[i] = Math.round(color1[i]);
    }
    return color1;
}
function $f4089545ec769444$export$89e29e4ab65e70a9(color1, color2, factor = 0.5) {
    let result = color1.slice();
    for(let i = 0; i < 3; i++)result[i] = Math.round(result[i] + factor * (color2[i] - color1[i]));
    return result;
}
const $f4089545ec769444$export$3a89f8d6f6bf6c9f = $f4089545ec769444$export$89e29e4ab65e70a9;
function $f4089545ec769444$export$20923c8288a77f0a(color1, color2, factor = 0.5) {
    let hsl1 = $f4089545ec769444$export$b5ba70b240f8f7f(color1);
    let hsl2 = $f4089545ec769444$export$b5ba70b240f8f7f(color2);
    for(let i = 0; i < 3; i++)hsl1[i] += factor * (hsl2[i] - hsl1[i]);
    return $f4089545ec769444$export$4c15bd42559b811d(hsl1);
}
const $f4089545ec769444$export$d1f6d182b0a7d941 = $f4089545ec769444$export$20923c8288a77f0a;
function $f4089545ec769444$export$a477072d5b4aa0b(color, diff) {
    if (!(diff instanceof Array)) diff = Math.round((0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getNormal(0, diff));
    let result = color.slice();
    for(let i = 0; i < 3; i++)result[i] += diff instanceof Array ? Math.round((0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getNormal(0, diff[i])) : diff;
    return result;
}
function $f4089545ec769444$export$b5ba70b240f8f7f(color) {
    let r = color[0] / 255;
    let g = color[1] / 255;
    let b = color[2] / 255;
    let max = Math.max(r, g, b), min = Math.min(r, g, b);
    let h = 0, s, l = (max + min) / 2;
    if (max == min) s = 0; // achromatic
    else {
        let d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return [
        h,
        s,
        l
    ];
}
function $f4089545ec769444$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $f4089545ec769444$export$4c15bd42559b811d(color) {
    let l = color[2];
    if (color[1] == 0) {
        l = Math.round(l * 255);
        return [
            l,
            l,
            l
        ];
    } else {
        let s = color[1];
        let q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        let p = 2 * l - q;
        let r = $f4089545ec769444$var$hue2rgb(p, q, color[0] + 1 / 3);
        let g = $f4089545ec769444$var$hue2rgb(p, q, color[0]);
        let b = $f4089545ec769444$var$hue2rgb(p, q, color[0] - 1 / 3);
        return [
            Math.round(r * 255),
            Math.round(g * 255),
            Math.round(b * 255)
        ];
    }
}
function $f4089545ec769444$export$c0374a851d79f51b(color) {
    let clamped = color.map((x)=>(0, $0901a3208c7d141c$export$7d15b64cf5a3a4c4)(x, 0, 255));
    return `rgb(${clamped.join(",")})`;
}
function $f4089545ec769444$export$7ea66e3774a60b67(color) {
    let clamped = color.map((x)=>(0, $0901a3208c7d141c$export$7d15b64cf5a3a4c4)(x, 0, 255).toString(16).padStart(2, "0"));
    return `#${clamped.join("")}`;
}
const $f4089545ec769444$var$CACHE = {
    "black": [
        0,
        0,
        0
    ],
    "navy": [
        0,
        0,
        128
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "green": [
        0,
        128,
        0
    ],
    "teal": [
        0,
        128,
        128
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "lime": [
        0,
        255,
        0
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "purple": [
        128,
        0,
        128
    ],
    "olive": [
        128,
        128,
        0
    ],
    "gray": [
        128,
        128,
        128
    ],
    "grey": [
        128,
        128,
        128
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "mediumpurple": [
        147,
        112,
        216
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "yellowgreen": [
        154,
        205,
        50
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "brown": [
        165,
        42,
        42
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "silver": [
        192,
        192,
        192
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "peru": [
        205,
        133,
        63
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "tan": [
        210,
        180,
        140
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "palevioletred": [
        216,
        112,
        147
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "plum": [
        221,
        160,
        221
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "violet": [
        238,
        130,
        238
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "aliceblue": [
        240,
        248,
        255
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "azure": [
        240,
        255,
        255
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "beige": [
        245,
        245,
        220
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "linen": [
        250,
        240,
        230
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "red": [
        255,
        0,
        0
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "coral": [
        255,
        127,
        80
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "orange": [
        255,
        165,
        0
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "pink": [
        255,
        192,
        203
    ],
    "gold": [
        255,
        215,
        0
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "snow": [
        255,
        250,
        250
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "white": [
        255,
        255,
        255
    ]
};


class $5f92596fc543b7f0$export$2e2bcd8739ae039 extends (0, $d5ea979d8ccf4ab7$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._uniforms = {};
        try {
            this._gl = this._initWebGL();
        } catch (e) {
            if (typeof e === "string") alert(e);
            else if (e instanceof Error) alert(e.message);
        }
    }
    static isSupported() {
        return !!document.createElement("canvas").getContext("webgl2", {
            preserveDrawingBuffer: true
        });
    }
    schedule(cb) {
        requestAnimationFrame(cb);
    }
    getContainer() {
        return this._gl.canvas;
    }
    setOptions(opts) {
        super.setOptions(opts);
        this._updateSize();
        let tileSet = this._options.tileSet;
        if (tileSet && "complete" in tileSet && !tileSet.complete) tileSet.addEventListener("load", ()=>this._updateTexture(tileSet));
        else this._updateTexture(tileSet);
    }
    draw(data, clearBefore) {
        const gl = this._gl;
        const opts = this._options;
        let [x, y, ch, fg, bg] = data;
        let scissorY = gl.canvas.height - (y + 1) * opts.tileHeight;
        gl.scissor(x * opts.tileWidth, scissorY, opts.tileWidth, opts.tileHeight);
        if (clearBefore) {
            if (opts.tileColorize) gl.clearColor(0, 0, 0, 0);
            else gl.clearColor(...$5f92596fc543b7f0$var$parseColor(bg));
            gl.clear(gl.COLOR_BUFFER_BIT);
        }
        if (!ch) return;
        let chars = [].concat(ch);
        let bgs = [].concat(bg);
        let fgs = [].concat(fg);
        gl.uniform2fv(this._uniforms["targetPosRel"], [
            x,
            y
        ]);
        for(let i = 0; i < chars.length; i++){
            let tile = this._options.tileMap[chars[i]];
            if (!tile) throw new Error(`Char "${chars[i]}" not found in tileMap`);
            gl.uniform1f(this._uniforms["colorize"], opts.tileColorize ? 1 : 0);
            gl.uniform2fv(this._uniforms["tilesetPosAbs"], tile);
            if (opts.tileColorize) {
                gl.uniform4fv(this._uniforms["tint"], $5f92596fc543b7f0$var$parseColor(fgs[i]));
                gl.uniform4fv(this._uniforms["bg"], $5f92596fc543b7f0$var$parseColor(bgs[i]));
            }
            gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
        }
    /*
        
        
                for (let i=0;i<chars.length;i++) {
        
                    if (this._options.tileColorize) { // apply colorization
                        let canvas = this._colorCanvas;
                        let context = canvas.getContext("2d") as CanvasRenderingContext2D;
                        context.globalCompositeOperation = "source-over";
                        context.clearRect(0, 0, tileWidth, tileHeight);
        
                        let fg = fgs[i];
                        let bg = bgs[i];
        
                        context.drawImage(
                            this._options.tileSet!,
                            tile[0], tile[1], tileWidth, tileHeight,
                            0, 0, tileWidth, tileHeight
                        );
        
                        if (fg != "transparent") {
                            context.fillStyle = fg;
                            context.globalCompositeOperation = "source-atop";
                            context.fillRect(0, 0, tileWidth, tileHeight);
                        }
        
                        if (bg != "transparent") {
                            context.fillStyle = bg;
                            context.globalCompositeOperation = "destination-over";
                            context.fillRect(0, 0, tileWidth, tileHeight);
                        }
        
                        this._ctx.drawImage(canvas, x*tileWidth, y*tileHeight, tileWidth, tileHeight);
                    } else { // no colorizing, easy
                        this._ctx.drawImage(
                            this._options.tileSet!,
                            tile[0], tile[1], tileWidth, tileHeight,
                            x*tileWidth, y*tileHeight, tileWidth, tileHeight
                        );
                    }
                }
        
        */ }
    clear() {
        const gl = this._gl;
        gl.clearColor(...$5f92596fc543b7f0$var$parseColor(this._options.bg));
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.clear(gl.COLOR_BUFFER_BIT);
    }
    computeSize(availWidth, availHeight) {
        let width = Math.floor(availWidth / this._options.tileWidth);
        let height = Math.floor(availHeight / this._options.tileHeight);
        return [
            width,
            height
        ];
    }
    computeFontSize() {
        throw new Error("Tile backend does not understand font size");
    }
    eventToPosition(x, y) {
        let canvas = this._gl.canvas;
        let rect = canvas.getBoundingClientRect();
        x -= rect.left;
        y -= rect.top;
        x *= canvas.width / rect.width;
        y *= canvas.height / rect.height;
        if (x < 0 || y < 0 || x >= canvas.width || y >= canvas.height) return [
            -1,
            -1
        ];
        return this._normalizedEventToPosition(x, y);
    }
    _initWebGL() {
        let gl = document.createElement("canvas").getContext("webgl2", {
            preserveDrawingBuffer: true
        });
        window.gl = gl;
        let program = $5f92596fc543b7f0$var$createProgram(gl, $5f92596fc543b7f0$var$VS, $5f92596fc543b7f0$var$FS);
        gl.useProgram(program);
        $5f92596fc543b7f0$var$createQuad(gl);
        $5f92596fc543b7f0$var$UNIFORMS.forEach((name)=>this._uniforms[name] = gl.getUniformLocation(program, name));
        this._program = program;
        gl.enable(gl.BLEND);
        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
        gl.enable(gl.SCISSOR_TEST);
        return gl;
    }
    _normalizedEventToPosition(x, y) {
        return [
            Math.floor(x / this._options.tileWidth),
            Math.floor(y / this._options.tileHeight)
        ];
    }
    _updateSize() {
        const gl = this._gl;
        const opts = this._options;
        const canvasSize = [
            opts.width * opts.tileWidth,
            opts.height * opts.tileHeight
        ];
        gl.canvas.width = canvasSize[0];
        gl.canvas.height = canvasSize[1];
        gl.viewport(0, 0, canvasSize[0], canvasSize[1]);
        gl.uniform2fv(this._uniforms["tileSize"], [
            opts.tileWidth,
            opts.tileHeight
        ]);
        gl.uniform2fv(this._uniforms["targetSize"], canvasSize);
    }
    _updateTexture(tileSet) {
        $5f92596fc543b7f0$var$createTexture(this._gl, tileSet);
    }
}
const $5f92596fc543b7f0$var$UNIFORMS = [
    "targetPosRel",
    "tilesetPosAbs",
    "tileSize",
    "targetSize",
    "colorize",
    "bg",
    "tint"
];
const $5f92596fc543b7f0$var$VS = `
#version 300 es

in vec2 tilePosRel;
out vec2 tilesetPosPx;

uniform vec2 tilesetPosAbs;
uniform vec2 tileSize;
uniform vec2 targetSize;
uniform vec2 targetPosRel;

void main() {
	vec2 targetPosPx = (targetPosRel + tilePosRel) * tileSize;
	vec2 targetPosNdc = ((targetPosPx / targetSize)-0.5)*2.0;
	targetPosNdc.y *= -1.0;

	gl_Position = vec4(targetPosNdc, 0.0, 1.0);
	tilesetPosPx = tilesetPosAbs + tilePosRel * tileSize;
}`.trim();
const $5f92596fc543b7f0$var$FS = `
#version 300 es
precision highp float;

in vec2 tilesetPosPx;
out vec4 fragColor;
uniform sampler2D image;
uniform bool colorize;
uniform vec4 bg;
uniform vec4 tint;

void main() {
	fragColor = vec4(0, 0, 0, 1);

	vec4 texel = texelFetch(image, ivec2(tilesetPosPx), 0);

	if (colorize) {
		texel.rgb = tint.a * tint.rgb + (1.0-tint.a) * texel.rgb;
		fragColor.rgb = texel.a*texel.rgb + (1.0-texel.a)*bg.rgb;
		fragColor.a = texel.a + (1.0-texel.a)*bg.a;
	} else {
		fragColor = texel;
	}
}`.trim();
function $5f92596fc543b7f0$var$createProgram(gl, vss, fss) {
    const vs = gl.createShader(gl.VERTEX_SHADER);
    gl.shaderSource(vs, vss);
    gl.compileShader(vs);
    if (!gl.getShaderParameter(vs, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(vs) || "");
    const fs = gl.createShader(gl.FRAGMENT_SHADER);
    gl.shaderSource(fs, fss);
    gl.compileShader(fs);
    if (!gl.getShaderParameter(fs, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(fs) || "");
    const p = gl.createProgram();
    gl.attachShader(p, vs);
    gl.attachShader(p, fs);
    gl.linkProgram(p);
    if (!gl.getProgramParameter(p, gl.LINK_STATUS)) throw new Error(gl.getProgramInfoLog(p) || "");
    return p;
}
function $5f92596fc543b7f0$var$createQuad(gl) {
    const pos = new Float32Array([
        0,
        0,
        1,
        0,
        0,
        1,
        1,
        1
    ]);
    const buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, pos, gl.STATIC_DRAW);
    gl.enableVertexAttribArray(0);
    gl.vertexAttribPointer(0, 2, gl.FLOAT, false, 0, 0);
}
function $5f92596fc543b7f0$var$createTexture(gl, data) {
    let t = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, t);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.REPEAT);
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, 0);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, data);
    return t;
}
let $5f92596fc543b7f0$var$colorCache = {};
function $5f92596fc543b7f0$var$parseColor(color) {
    if (!(color in $5f92596fc543b7f0$var$colorCache)) {
        let parsed;
        if (color == "transparent") parsed = [
            0,
            0,
            0,
            0
        ];
        else if (color.indexOf("rgba") > -1) {
            parsed = (color.match(/[\d.]+/g) || []).map(Number);
            for(let i = 0; i < 3; i++)parsed[i] = parsed[i] / 255;
        } else {
            parsed = $f4089545ec769444$export$3004f64547af360e(color).map(($)=>$ / 255);
            parsed.push(1);
        }
        $5f92596fc543b7f0$var$colorCache[color] = parsed;
    }
    return $5f92596fc543b7f0$var$colorCache[color];
}




var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


function $49c3275b7b0ba585$var$clearToAnsi(bg) {
    return `\x1b[0;48;5;${$49c3275b7b0ba585$var$termcolor(bg)}m\x1b[2J`;
}
function $49c3275b7b0ba585$var$colorToAnsi(fg, bg) {
    return `\x1b[0;38;5;${$49c3275b7b0ba585$var$termcolor(fg)};48;5;${$49c3275b7b0ba585$var$termcolor(bg)}m`;
}
function $49c3275b7b0ba585$var$positionToAnsi(x, y) {
    return `\x1b[${y + 1};${x + 1}H`;
}
function $49c3275b7b0ba585$var$termcolor(color) {
    const SRC_COLORS = 256.0;
    const DST_COLORS = 6.0;
    const COLOR_RATIO = DST_COLORS / SRC_COLORS;
    let rgb = $f4089545ec769444$export$3004f64547af360e(color);
    let r = Math.floor(rgb[0] * COLOR_RATIO);
    let g = Math.floor(rgb[1] * COLOR_RATIO);
    let b = Math.floor(rgb[2] * COLOR_RATIO);
    return r * 36 + g * 6 + b * 1 + 16;
}
class $49c3275b7b0ba585$export$2e2bcd8739ae039 extends (0, $d5ea979d8ccf4ab7$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._offset = [
            0,
            0
        ];
        this._cursor = [
            -1,
            -1
        ];
        this._lastColor = "";
    }
    schedule(cb) {
        setTimeout(cb, 1000 / 60);
    }
    setOptions(options) {
        super.setOptions(options);
        let size = [
            options.width,
            options.height
        ];
        let avail = this.computeSize();
        this._offset = avail.map((val, index)=>Math.floor((val - size[index]) / 2));
    }
    clear() {
        $cfae44f0dfdf62c0$exports.stdout.write($49c3275b7b0ba585$var$clearToAnsi(this._options.bg));
    }
    draw(data, clearBefore) {
        // determine where to draw what with what colors
        let [x, y, ch, fg, bg] = data;
        // determine if we need to move the terminal cursor
        let dx = this._offset[0] + x;
        let dy = this._offset[1] + y;
        let size = this.computeSize();
        if (dx < 0 || dx >= size[0]) return;
        if (dy < 0 || dy >= size[1]) return;
        if (dx !== this._cursor[0] || dy !== this._cursor[1]) {
            $cfae44f0dfdf62c0$exports.stdout.write($49c3275b7b0ba585$var$positionToAnsi(dx, dy));
            this._cursor[0] = dx;
            this._cursor[1] = dy;
        }
        // terminals automatically clear, but if we're clearing when we're
        // not otherwise provided with a character, just use a space instead
        if (clearBefore) {
            if (!ch) ch = " ";
        }
        // if we're not clearing and not provided with a character, do nothing
        if (!ch) return;
        // determine if we need to change colors
        let newColor = $49c3275b7b0ba585$var$colorToAnsi(fg, bg);
        if (newColor !== this._lastColor) {
            $cfae44f0dfdf62c0$exports.stdout.write(newColor);
            this._lastColor = newColor;
        }
        if (ch != '\t') {
            // write the provided symbol to the display
            let chars = [].concat(ch);
            $cfae44f0dfdf62c0$exports.stdout.write(chars[0]);
        }
        // update our position, given that we wrote a character
        this._cursor[0]++;
        if (this._cursor[0] >= size[0]) {
            this._cursor[0] = 0;
            this._cursor[1]++;
        }
    }
    computeFontSize() {
        throw new Error("Terminal backend has no notion of font size");
    }
    eventToPosition(x, y) {
        return [
            x,
            y
        ];
    }
    computeSize() {
        return [
            $cfae44f0dfdf62c0$exports.stdout.columns,
            $cfae44f0dfdf62c0$exports.stdout.rows
        ];
    }
}


var $6af2e28c2767fdb6$exports = {};

$parcel$export($6af2e28c2767fdb6$exports, "TYPE_TEXT", () => $6af2e28c2767fdb6$export$4a456486b6351d94);
$parcel$export($6af2e28c2767fdb6$exports, "TYPE_NEWLINE", () => $6af2e28c2767fdb6$export$36a062e8a76f00a);
$parcel$export($6af2e28c2767fdb6$exports, "TYPE_FG", () => $6af2e28c2767fdb6$export$30c6693dcdbe7e89);
$parcel$export($6af2e28c2767fdb6$exports, "TYPE_BG", () => $6af2e28c2767fdb6$export$3c726a5680a46b90);
$parcel$export($6af2e28c2767fdb6$exports, "measure", () => $6af2e28c2767fdb6$export$83602b44513dc228);
$parcel$export($6af2e28c2767fdb6$exports, "tokenize", () => $6af2e28c2767fdb6$export$660b2ee2d4fb4eff);
/**
 * @namespace
 * Contains text tokenization and breaking routines
 */ const $6af2e28c2767fdb6$var$RE_COLORS = /%([bc]){([^}]*)}/g;
const $6af2e28c2767fdb6$export$4a456486b6351d94 = 0;
const $6af2e28c2767fdb6$export$36a062e8a76f00a = 1;
const $6af2e28c2767fdb6$export$30c6693dcdbe7e89 = 2;
const $6af2e28c2767fdb6$export$3c726a5680a46b90 = 3;
function $6af2e28c2767fdb6$export$83602b44513dc228(str, maxWidth) {
    let result = {
        width: 0,
        height: 1
    };
    let tokens = $6af2e28c2767fdb6$export$660b2ee2d4fb4eff(str, maxWidth);
    let lineWidth = 0;
    for(let i = 0; i < tokens.length; i++){
        let token = tokens[i];
        switch(token.type){
            case $6af2e28c2767fdb6$export$4a456486b6351d94:
                lineWidth += token.value.length;
                break;
            case $6af2e28c2767fdb6$export$36a062e8a76f00a:
                result.height++;
                result.width = Math.max(result.width, lineWidth);
                lineWidth = 0;
                break;
        }
    }
    result.width = Math.max(result.width, lineWidth);
    return result;
}
function $6af2e28c2767fdb6$export$660b2ee2d4fb4eff(str, maxWidth) {
    let result = [];
    /* first tokenization pass - split texts and color formatting commands */ let offset = 0;
    str.replace($6af2e28c2767fdb6$var$RE_COLORS, function(match, type, name, index) {
        /* string before */ let part = str.substring(offset, index);
        if (part.length) result.push({
            type: $6af2e28c2767fdb6$export$4a456486b6351d94,
            value: part
        });
        /* color command */ result.push({
            type: type == "c" ? $6af2e28c2767fdb6$export$30c6693dcdbe7e89 : $6af2e28c2767fdb6$export$3c726a5680a46b90,
            value: name.trim()
        });
        offset = index + match.length;
        return "";
    });
    /* last remaining part */ let part = str.substring(offset);
    if (part.length) result.push({
        type: $6af2e28c2767fdb6$export$4a456486b6351d94,
        value: part
    });
    return $6af2e28c2767fdb6$var$breakLines(result, maxWidth);
}
/* insert line breaks into first-pass tokenized data */ function $6af2e28c2767fdb6$var$breakLines(tokens, maxWidth) {
    if (!maxWidth) maxWidth = Infinity;
    let i = 0;
    let lineLength = 0;
    let lastTokenWithSpace = -1;
    while(i < tokens.length){
        let token = tokens[i];
        if (token.type == $6af2e28c2767fdb6$export$36a062e8a76f00a) {
            lineLength = 0;
            lastTokenWithSpace = -1;
        }
        if (token.type != $6af2e28c2767fdb6$export$4a456486b6351d94) {
            i++;
            continue;
        }
        /* remove spaces at the beginning of line */ while(lineLength == 0 && token.value.charAt(0) == " ")token.value = token.value.substring(1);
        /* forced newline? insert two new tokens after this one */ let index = token.value.indexOf("\n");
        if (index != -1) {
            token.value = $6af2e28c2767fdb6$var$breakInsideToken(tokens, i, index, true);
            /* if there are spaces at the end, we must remove them (we do not want the line too long) */ let arr = token.value.split("");
            while(arr.length && arr[arr.length - 1] == " ")arr.pop();
            token.value = arr.join("");
        }
        /* token degenerated? */ if (!token.value.length) {
            tokens.splice(i, 1);
            continue;
        }
        if (lineLength + token.value.length > maxWidth) {
            /* is it possible to break within this token? */ let index = -1;
            while(true){
                let nextIndex = token.value.indexOf(" ", index + 1);
                if (nextIndex == -1) break;
                if (lineLength + nextIndex > maxWidth) break;
                index = nextIndex;
            }
            if (index != -1) token.value = $6af2e28c2767fdb6$var$breakInsideToken(tokens, i, index, true);
            else if (lastTokenWithSpace != -1) {
                let token = tokens[lastTokenWithSpace];
                let breakIndex = token.value.lastIndexOf(" ");
                token.value = $6af2e28c2767fdb6$var$breakInsideToken(tokens, lastTokenWithSpace, breakIndex, true);
                i = lastTokenWithSpace;
            } else token.value = $6af2e28c2767fdb6$var$breakInsideToken(tokens, i, maxWidth - lineLength, false);
        } else {
            lineLength += token.value.length;
            if (token.value.indexOf(" ") != -1) lastTokenWithSpace = i;
        }
        i++; /* advance to next token */ 
    }
    tokens.push({
        type: $6af2e28c2767fdb6$export$36a062e8a76f00a
    }); /* insert fake newline to fix the last text line */ 
    /* remove trailing space from text tokens before newlines */ let lastTextToken = null;
    for(let i = 0; i < tokens.length; i++){
        let token = tokens[i];
        switch(token.type){
            case $6af2e28c2767fdb6$export$4a456486b6351d94:
                lastTextToken = token;
                break;
            case $6af2e28c2767fdb6$export$36a062e8a76f00a:
                if (lastTextToken) {
                    let arr = lastTextToken.value.split("");
                    while(arr.length && arr[arr.length - 1] == " ")arr.pop();
                    lastTextToken.value = arr.join("");
                }
                lastTextToken = null;
                break;
        }
    }
    tokens.pop(); /* remove fake token */ 
    return tokens;
}
/**
 * Create new tokens and insert them into the stream
 * @param {object[]} tokens
 * @param {int} tokenIndex Token being processed
 * @param {int} breakIndex Index within current token's value
 * @param {bool} removeBreakChar Do we want to remove the breaking character?
 * @returns {string} remaining unbroken token value
 */ function $6af2e28c2767fdb6$var$breakInsideToken(tokens, tokenIndex, breakIndex, removeBreakChar) {
    let newBreakToken = {
        type: $6af2e28c2767fdb6$export$36a062e8a76f00a
    };
    let newTextToken = {
        type: $6af2e28c2767fdb6$export$4a456486b6351d94,
        value: tokens[tokenIndex].value.substring(breakIndex + (removeBreakChar ? 1 : 0))
    };
    tokens.splice(tokenIndex + 1, 0, newBreakToken, newTextToken);
    return tokens[tokenIndex].value.substring(0, breakIndex);
}


/** Default with for display and map generators */ let $55a6f72eb77f658c$export$aa4eace044cdfdbf = 80;
let $55a6f72eb77f658c$export$611c894df53833b0 = 25;
const $55a6f72eb77f658c$export$a2cefd738759134a = {
    4: [
        [
            0,
            -1
        ],
        [
            1,
            0
        ],
        [
            0,
            1
        ],
        [
            -1,
            0
        ]
    ],
    8: [
        [
            0,
            -1
        ],
        [
            1,
            -1
        ],
        [
            1,
            0
        ],
        [
            1,
            1
        ],
        [
            0,
            1
        ],
        [
            -1,
            1
        ],
        [
            -1,
            0
        ],
        [
            -1,
            -1
        ]
    ],
    6: [
        [
            -1,
            -1
        ],
        [
            1,
            -1
        ],
        [
            2,
            0
        ],
        [
            1,
            1
        ],
        [
            -1,
            1
        ],
        [
            -2,
            0
        ]
    ]
};
const $55a6f72eb77f658c$export$f9ba527e25c2bc92 = {
    /** Cancel key. */ VK_CANCEL: 3,
    /** Help key. */ VK_HELP: 6,
    /** Backspace key. */ VK_BACK_SPACE: 8,
    /** Tab key. */ VK_TAB: 9,
    /** 5 key on Numpad when NumLock is unlocked. Or on Mac, clear key which is positioned at NumLock key. */ VK_CLEAR: 12,
    /** Return/enter key on the main keyboard. */ VK_RETURN: 13,
    /** Reserved, but not used. */ VK_ENTER: 14,
    /** Shift key. */ VK_SHIFT: 16,
    /** Control key. */ VK_CONTROL: 17,
    /** Alt (Option on Mac) key. */ VK_ALT: 18,
    /** Pause key. */ VK_PAUSE: 19,
    /** Caps lock. */ VK_CAPS_LOCK: 20,
    /** Escape key. */ VK_ESCAPE: 27,
    /** Space bar. */ VK_SPACE: 32,
    /** Page Up key. */ VK_PAGE_UP: 33,
    /** Page Down key. */ VK_PAGE_DOWN: 34,
    /** End key. */ VK_END: 35,
    /** Home key. */ VK_HOME: 36,
    /** Left arrow. */ VK_LEFT: 37,
    /** Up arrow. */ VK_UP: 38,
    /** Right arrow. */ VK_RIGHT: 39,
    /** Down arrow. */ VK_DOWN: 40,
    /** Print Screen key. */ VK_PRINTSCREEN: 44,
    /** Ins(ert) key. */ VK_INSERT: 45,
    /** Del(ete) key. */ VK_DELETE: 46,
    /***/ VK_0: 48,
    /***/ VK_1: 49,
    /***/ VK_2: 50,
    /***/ VK_3: 51,
    /***/ VK_4: 52,
    /***/ VK_5: 53,
    /***/ VK_6: 54,
    /***/ VK_7: 55,
    /***/ VK_8: 56,
    /***/ VK_9: 57,
    /** Colon (:) key. Requires Gecko 15.0 */ VK_COLON: 58,
    /** Semicolon (;) key. */ VK_SEMICOLON: 59,
    /** Less-than (<) key. Requires Gecko 15.0 */ VK_LESS_THAN: 60,
    /** Equals (=) key. */ VK_EQUALS: 61,
    /** Greater-than (>) key. Requires Gecko 15.0 */ VK_GREATER_THAN: 62,
    /** Question mark (?) key. Requires Gecko 15.0 */ VK_QUESTION_MARK: 63,
    /** Atmark (@) key. Requires Gecko 15.0 */ VK_AT: 64,
    /***/ VK_A: 65,
    /***/ VK_B: 66,
    /***/ VK_C: 67,
    /***/ VK_D: 68,
    /***/ VK_E: 69,
    /***/ VK_F: 70,
    /***/ VK_G: 71,
    /***/ VK_H: 72,
    /***/ VK_I: 73,
    /***/ VK_J: 74,
    /***/ VK_K: 75,
    /***/ VK_L: 76,
    /***/ VK_M: 77,
    /***/ VK_N: 78,
    /***/ VK_O: 79,
    /***/ VK_P: 80,
    /***/ VK_Q: 81,
    /***/ VK_R: 82,
    /***/ VK_S: 83,
    /***/ VK_T: 84,
    /***/ VK_U: 85,
    /***/ VK_V: 86,
    /***/ VK_W: 87,
    /***/ VK_X: 88,
    /***/ VK_Y: 89,
    /***/ VK_Z: 90,
    /***/ VK_CONTEXT_MENU: 93,
    /** 0 on the numeric keypad. */ VK_NUMPAD0: 96,
    /** 1 on the numeric keypad. */ VK_NUMPAD1: 97,
    /** 2 on the numeric keypad. */ VK_NUMPAD2: 98,
    /** 3 on the numeric keypad. */ VK_NUMPAD3: 99,
    /** 4 on the numeric keypad. */ VK_NUMPAD4: 100,
    /** 5 on the numeric keypad. */ VK_NUMPAD5: 101,
    /** 6 on the numeric keypad. */ VK_NUMPAD6: 102,
    /** 7 on the numeric keypad. */ VK_NUMPAD7: 103,
    /** 8 on the numeric keypad. */ VK_NUMPAD8: 104,
    /** 9 on the numeric keypad. */ VK_NUMPAD9: 105,
    /** * on the numeric keypad. */ VK_MULTIPLY: 106,
    /** + on the numeric keypad. */ VK_ADD: 107,
    /***/ VK_SEPARATOR: 108,
    /** - on the numeric keypad. */ VK_SUBTRACT: 109,
    /** Decimal point on the numeric keypad. */ VK_DECIMAL: 110,
    /** / on the numeric keypad. */ VK_DIVIDE: 111,
    /** F1 key. */ VK_F1: 112,
    /** F2 key. */ VK_F2: 113,
    /** F3 key. */ VK_F3: 114,
    /** F4 key. */ VK_F4: 115,
    /** F5 key. */ VK_F5: 116,
    /** F6 key. */ VK_F6: 117,
    /** F7 key. */ VK_F7: 118,
    /** F8 key. */ VK_F8: 119,
    /** F9 key. */ VK_F9: 120,
    /** F10 key. */ VK_F10: 121,
    /** F11 key. */ VK_F11: 122,
    /** F12 key. */ VK_F12: 123,
    /** F13 key. */ VK_F13: 124,
    /** F14 key. */ VK_F14: 125,
    /** F15 key. */ VK_F15: 126,
    /** F16 key. */ VK_F16: 127,
    /** F17 key. */ VK_F17: 128,
    /** F18 key. */ VK_F18: 129,
    /** F19 key. */ VK_F19: 130,
    /** F20 key. */ VK_F20: 131,
    /** F21 key. */ VK_F21: 132,
    /** F22 key. */ VK_F22: 133,
    /** F23 key. */ VK_F23: 134,
    /** F24 key. */ VK_F24: 135,
    /** Num Lock key. */ VK_NUM_LOCK: 144,
    /** Scroll Lock key. */ VK_SCROLL_LOCK: 145,
    /** Circumflex (^) key. Requires Gecko 15.0 */ VK_CIRCUMFLEX: 160,
    /** Exclamation (!) key. Requires Gecko 15.0 */ VK_EXCLAMATION: 161,
    /** Double quote () key. Requires Gecko 15.0 */ VK_DOUBLE_QUOTE: 162,
    /** Hash (#) key. Requires Gecko 15.0 */ VK_HASH: 163,
    /** Dollar sign ($) key. Requires Gecko 15.0 */ VK_DOLLAR: 164,
    /** Percent (%) key. Requires Gecko 15.0 */ VK_PERCENT: 165,
    /** Ampersand (&) key. Requires Gecko 15.0 */ VK_AMPERSAND: 166,
    /** Underscore (_) key. Requires Gecko 15.0 */ VK_UNDERSCORE: 167,
    /** Open parenthesis (() key. Requires Gecko 15.0 */ VK_OPEN_PAREN: 168,
    /** Close parenthesis ()) key. Requires Gecko 15.0 */ VK_CLOSE_PAREN: 169,
    /* Asterisk (*) key. Requires Gecko 15.0 */ VK_ASTERISK: 170,
    /** Plus (+) key. Requires Gecko 15.0 */ VK_PLUS: 171,
    /** Pipe (|) key. Requires Gecko 15.0 */ VK_PIPE: 172,
    /** Hyphen-US/docs/Minus (-) key. Requires Gecko 15.0 */ VK_HYPHEN_MINUS: 173,
    /** Open curly bracket ({) key. Requires Gecko 15.0 */ VK_OPEN_CURLY_BRACKET: 174,
    /** Close curly bracket (}) key. Requires Gecko 15.0 */ VK_CLOSE_CURLY_BRACKET: 175,
    /** Tilde (~) key. Requires Gecko 15.0 */ VK_TILDE: 176,
    /** Comma (,) key. */ VK_COMMA: 188,
    /** Period (.) key. */ VK_PERIOD: 190,
    /** Slash (/) key. */ VK_SLASH: 191,
    /** Back tick (`) key. */ VK_BACK_QUOTE: 192,
    /** Open square bracket ([) key. */ VK_OPEN_BRACKET: 219,
    /** Back slash (\) key. */ VK_BACK_SLASH: 220,
    /** Close square bracket (]) key. */ VK_CLOSE_BRACKET: 221,
    /** Quote (''') key. */ VK_QUOTE: 222,
    /** Meta key on Linux, Command key on Mac. */ VK_META: 224,
    /** AltGr key on Linux. Requires Gecko 15.0 */ VK_ALTGR: 225,
    /** Windows logo key on Windows. Or Super or Hyper key on Linux. Requires Gecko 15.0 */ VK_WIN: 91,
    /** Linux support for this keycode was added in Gecko 4.0. */ VK_KANA: 21,
    /** Linux support for this keycode was added in Gecko 4.0. */ VK_HANGUL: 21,
    /** 英数 key on Japanese Mac keyboard. Requires Gecko 15.0 */ VK_EISU: 22,
    /** Linux support for this keycode was added in Gecko 4.0. */ VK_JUNJA: 23,
    /** Linux support for this keycode was added in Gecko 4.0. */ VK_FINAL: 24,
    /** Linux support for this keycode was added in Gecko 4.0. */ VK_HANJA: 25,
    /** Linux support for this keycode was added in Gecko 4.0. */ VK_KANJI: 25,
    /** Linux support for this keycode was added in Gecko 4.0. */ VK_CONVERT: 28,
    /** Linux support for this keycode was added in Gecko 4.0. */ VK_NONCONVERT: 29,
    /** Linux support for this keycode was added in Gecko 4.0. */ VK_ACCEPT: 30,
    /** Linux support for this keycode was added in Gecko 4.0. */ VK_MODECHANGE: 31,
    /** Linux support for this keycode was added in Gecko 4.0. */ VK_SELECT: 41,
    /** Linux support for this keycode was added in Gecko 4.0. */ VK_PRINT: 42,
    /** Linux support for this keycode was added in Gecko 4.0. */ VK_EXECUTE: 43,
    /** Linux support for this keycode was added in Gecko 4.0.	 */ VK_SLEEP: 95
};


const $c6091c547a8eac13$var$BACKENDS = {
    "hex": (0, $98dd8589dbcaea88$export$2e2bcd8739ae039),
    "rect": (0, $091354b8cd104fa5$export$2e2bcd8739ae039),
    "tile": (0, $cdd36850d1486376$export$2e2bcd8739ae039),
    "tile-gl": (0, $5f92596fc543b7f0$export$2e2bcd8739ae039),
    "term": (0, $49c3275b7b0ba585$export$2e2bcd8739ae039)
};
const $c6091c547a8eac13$var$DEFAULT_OPTIONS = {
    width: (0, $55a6f72eb77f658c$export$aa4eace044cdfdbf),
    height: (0, $55a6f72eb77f658c$export$611c894df53833b0),
    transpose: false,
    layout: "rect",
    fontSize: 15,
    spacing: 1,
    border: 0,
    forceSquareRatio: false,
    fontFamily: "monospace",
    fontStyle: "",
    fg: "#ccc",
    bg: "#000",
    tileWidth: 32,
    tileHeight: 32,
    tileMap: {},
    tileSet: null,
    tileColorize: false
};
class $c6091c547a8eac13$export$2e2bcd8739ae039 {
    constructor(options = {}){
        this._data = {};
        this._dirty = false; // false = nothing, true = all, object = dirty cells
        this._options = {};
        options = Object.assign({}, $c6091c547a8eac13$var$DEFAULT_OPTIONS, options);
        this.setOptions(options);
        this.DEBUG = this.DEBUG.bind(this);
        this._tick = this._tick.bind(this);
        this._backend.schedule(this._tick);
    }
    /**
     * Debug helper, ideal as a map generator callback. Always bound to this.
     * @param {int} x
     * @param {int} y
     * @param {int} what
     */ DEBUG(x, y, what) {
        let colors = [
            this._options.bg,
            this._options.fg
        ];
        this.draw(x, y, null, null, colors[what % colors.length]);
    }
    /**
     * Clear the whole display (cover it with background color)
     */ clear() {
        this._data = {};
        this._dirty = true;
    }
    /**
     * @see ROT.Display
     */ setOptions(options) {
        Object.assign(this._options, options);
        if (options.width || options.height || options.fontSize || options.fontFamily || options.spacing || options.layout) {
            if (options.layout) {
                let ctor = $c6091c547a8eac13$var$BACKENDS[options.layout];
                this._backend = new ctor();
            }
            this._backend.setOptions(this._options);
            this._dirty = true;
        }
        return this;
    }
    /**
     * Returns currently set options
     */ getOptions() {
        return this._options;
    }
    /**
     * Returns the DOM node of this display
     */ getContainer() {
        return this._backend.getContainer();
    }
    /**
     * Compute the maximum width/height to fit into a set of given constraints
     * @param {int} availWidth Maximum allowed pixel width
     * @param {int} availHeight Maximum allowed pixel height
     * @returns {int[2]} cellWidth,cellHeight
     */ computeSize(availWidth, availHeight) {
        return this._backend.computeSize(availWidth, availHeight);
    }
    /**
     * Compute the maximum font size to fit into a set of given constraints
     * @param {int} availWidth Maximum allowed pixel width
     * @param {int} availHeight Maximum allowed pixel height
     * @returns {int} fontSize
     */ computeFontSize(availWidth, availHeight) {
        return this._backend.computeFontSize(availWidth, availHeight);
    }
    computeTileSize(availWidth, availHeight) {
        let width = Math.floor(availWidth / this._options.width);
        let height = Math.floor(availHeight / this._options.height);
        return [
            width,
            height
        ];
    }
    /**
     * Convert a DOM event (mouse or touch) to map coordinates. Uses first touch for multi-touch.
     * @param {Event} e event
     * @returns {int[2]} -1 for values outside of the canvas
     */ eventToPosition(e) {
        let x, y;
        if ("touches" in e) {
            x = e.touches[0].clientX;
            y = e.touches[0].clientY;
        } else {
            x = e.clientX;
            y = e.clientY;
        }
        return this._backend.eventToPosition(x, y);
    }
    /**
     * @param {int} x
     * @param {int} y
     * @param {string || string[]} ch One or more chars (will be overlapping themselves)
     * @param {string} [fg] foreground color
     * @param {string} [bg] background color
     */ draw(x, y, ch, fg, bg) {
        if (!fg) fg = this._options.fg;
        if (!bg) bg = this._options.bg;
        let key = `${x},${y}`;
        this._data[key] = [
            x,
            y,
            ch,
            fg,
            bg
        ];
        if (this._dirty === true) return;
         // will already redraw everything 
        if (!this._dirty) this._dirty = {};
         // first!
        this._dirty[key] = true;
    }
    /**
     * @param {int} x
     * @param {int} y
     * @param {string || string[]} ch One or more chars (will be overlapping themselves)
     * @param {string || null} [fg] foreground color
     * @param {string || null} [bg] background color
     */ drawOver(x, y, ch, fg, bg) {
        const key = `${x},${y}`;
        const existing = this._data[key];
        if (existing) {
            existing[2] = ch || existing[2];
            existing[3] = fg || existing[3];
            existing[4] = bg || existing[4];
        } else this.draw(x, y, ch, fg, bg);
    }
    /**
     * Draws a text at given position. Optionally wraps at a maximum length. Currently does not work with hex layout.
     * @param {int} x
     * @param {int} y
     * @param {string} text May contain color/background format specifiers, %c{name}/%b{name}, both optional. %c{}/%b{} resets to default.
     * @param {int} [maxWidth] wrap at what width?
     * @returns {int} lines drawn
     */ drawText(x, y, text, maxWidth) {
        let fg = null;
        let bg = null;
        let cx = x;
        let cy = y;
        let lines = 1;
        if (!maxWidth) maxWidth = this._options.width - x;
        let tokens = $6af2e28c2767fdb6$export$660b2ee2d4fb4eff(text, maxWidth);
        while(tokens.length){
            let token = tokens.shift();
            switch(token.type){
                case $6af2e28c2767fdb6$export$4a456486b6351d94:
                    let isSpace = false, isPrevSpace = false, isFullWidth = false, isPrevFullWidth = false;
                    for(let i = 0; i < token.value.length; i++){
                        let cc = token.value.charCodeAt(i);
                        let c = token.value.charAt(i);
                        if (this._options.layout === "term") {
                            let cch = cc >> 8;
                            let isCJK = cch === 0x11 || cch >= 0x2e && cch <= 0x9f || cch >= 0xac && cch <= 0xd7 || cc >= 0xA960 && cc <= 0xA97F;
                            if (isCJK) {
                                this.draw(cx + 0, cy, c, fg, bg);
                                this.draw(cx + 1, cy, "\t", fg, bg);
                                cx += 2;
                                continue;
                            }
                        }
                        // Assign to `true` when the current char is full-width.
                        isFullWidth = cc > 0xff00 && cc < 0xff61 || cc > 0xffdc && cc < 0xffe8 || cc > 0xffee;
                        // Current char is space, whatever full-width or half-width both are OK.
                        isSpace = c.charCodeAt(0) == 0x20 || c.charCodeAt(0) == 0x3000;
                        // The previous char is full-width and
                        // current char is nether half-width nor a space.
                        if (isPrevFullWidth && !isFullWidth && !isSpace) cx++;
                         // add an extra position
                        // The current char is full-width and
                        // the previous char is not a space.
                        if (isFullWidth && !isPrevSpace) cx++;
                         // add an extra position
                        this.draw(cx++, cy, c, fg, bg);
                        isPrevSpace = isSpace;
                        isPrevFullWidth = isFullWidth;
                    }
                    break;
                case $6af2e28c2767fdb6$export$30c6693dcdbe7e89:
                    fg = token.value || null;
                    break;
                case $6af2e28c2767fdb6$export$3c726a5680a46b90:
                    bg = token.value || null;
                    break;
                case $6af2e28c2767fdb6$export$36a062e8a76f00a:
                    cx = x;
                    cy++;
                    lines++;
                    break;
            }
        }
        return lines;
    }
    /**
     * Timer tick: update dirty parts
     */ _tick() {
        this._backend.schedule(this._tick);
        if (!this._dirty) return;
        if (this._dirty === true) {
            this._backend.clear();
            for(let id in this._data)this._draw(id, false);
             // redraw cached data 
        } else for(let key in this._dirty)this._draw(key, true);
        this._dirty = false;
    }
    /**
     * @param {string} key What to draw
     * @param {bool} clearBefore Is it necessary to clean before?
     */ _draw(key, clearBefore) {
        let data = this._data[key];
        if (data[4] != this._options.bg) clearBefore = true;
        this._backend.draw(data, clearBefore);
    }
}
$c6091c547a8eac13$export$2e2bcd8739ae039.Rect = (0, $091354b8cd104fa5$export$2e2bcd8739ae039);
$c6091c547a8eac13$export$2e2bcd8739ae039.Hex = (0, $98dd8589dbcaea88$export$2e2bcd8739ae039);
$c6091c547a8eac13$export$2e2bcd8739ae039.Tile = (0, $cdd36850d1486376$export$2e2bcd8739ae039);
$c6091c547a8eac13$export$2e2bcd8739ae039.TileGL = (0, $5f92596fc543b7f0$export$2e2bcd8739ae039);
$c6091c547a8eac13$export$2e2bcd8739ae039.Term = (0, $49c3275b7b0ba585$export$2e2bcd8739ae039);



class $064a1552e70403c8$export$2e2bcd8739ae039 {
    constructor(options){
        this._options = {
            words: false,
            order: 3,
            prior: 0.001
        };
        Object.assign(this._options, options);
        this._boundary = String.fromCharCode(0);
        this._suffix = this._boundary;
        this._prefix = [];
        for(let i = 0; i < this._options.order; i++)this._prefix.push(this._boundary);
        this._priorValues = {};
        this._priorValues[this._boundary] = this._options.prior;
        this._data = {};
    }
    /**
     * Remove all learning data
     */ clear() {
        this._data = {};
        this._priorValues = {};
    }
    /**
     * @returns {string} Generated string
     */ generate() {
        let result = [
            this._sample(this._prefix)
        ];
        while(result[result.length - 1] != this._boundary)result.push(this._sample(result));
        return this._join(result.slice(0, -1));
    }
    /**
     * Observe (learn) a string from a training set
     */ observe(string) {
        let tokens = this._split(string);
        for(let i = 0; i < tokens.length; i++)this._priorValues[tokens[i]] = this._options.prior;
        tokens = this._prefix.concat(tokens).concat(this._suffix); /* add boundary symbols */ 
        for(let i = this._options.order; i < tokens.length; i++){
            let context = tokens.slice(i - this._options.order, i);
            let event = tokens[i];
            for(let j = 0; j < context.length; j++){
                let subcontext = context.slice(j);
                this._observeEvent(subcontext, event);
            }
        }
    }
    getStats() {
        let parts = [];
        let priorCount = Object.keys(this._priorValues).length;
        priorCount--; // boundary
        parts.push("distinct samples: " + priorCount);
        let dataCount = Object.keys(this._data).length;
        let eventCount = 0;
        for(let p in this._data)eventCount += Object.keys(this._data[p]).length;
        parts.push("dictionary size (contexts): " + dataCount);
        parts.push("dictionary size (events): " + eventCount);
        return parts.join(", ");
    }
    /**
     * @param {string}
     * @returns {string[]}
     */ _split(str) {
        return str.split(this._options.words ? /\s+/ : "");
    }
    /**
     * @param {string[]}
     * @returns {string}
     */ _join(arr) {
        return arr.join(this._options.words ? " " : "");
    }
    /**
     * @param {string[]} context
     * @param {string} event
     */ _observeEvent(context, event) {
        let key = this._join(context);
        if (!(key in this._data)) this._data[key] = {};
        let data = this._data[key];
        if (!(event in data)) data[event] = 0;
        data[event]++;
    }
    /**
     * @param {string[]}
     * @returns {string}
     */ _sample(context) {
        context = this._backoff(context);
        let key = this._join(context);
        let data = this._data[key];
        let available = {};
        if (this._options.prior) {
            for(let event in this._priorValues)available[event] = this._priorValues[event];
            for(let event in data)available[event] += data[event];
        } else available = data;
        return (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getWeightedValue(available);
    }
    /**
     * @param {string[]}
     * @returns {string[]}
     */ _backoff(context) {
        if (context.length > this._options.order) context = context.slice(-this._options.order);
        else if (context.length < this._options.order) context = this._prefix.slice(0, this._options.order - context.length).concat(context);
        while(!(this._join(context) in this._data) && context.length > 0)context = context.slice(1);
        return context;
    }
}


class $356bdaa38ef77da5$export$457b0b5893773add {
    constructor(){
        this.heap = [];
        this.timestamp = 0;
    }
    lessThan(a, b) {
        return a.key == b.key ? a.timestamp < b.timestamp : a.key < b.key;
    }
    shift(v) {
        this.heap = this.heap.map(({ key: key, value: value, timestamp: timestamp })=>({
                key: key + v,
                value: value,
                timestamp: timestamp
            }));
    }
    len() {
        return this.heap.length;
    }
    push(value, key) {
        this.timestamp += 1;
        const loc = this.len();
        this.heap.push({
            value: value,
            timestamp: this.timestamp,
            key: key
        });
        this.updateUp(loc);
    }
    pop() {
        if (this.len() == 0) throw new Error("no element to pop");
        const top = this.heap[0];
        if (this.len() > 1) {
            this.heap[0] = this.heap.pop();
            this.updateDown(0);
        } else this.heap.pop();
        return top;
    }
    find(v) {
        for(let i = 0; i < this.len(); i++){
            if (v == this.heap[i].value) return this.heap[i];
        }
        return null;
    }
    remove(v) {
        let index = null;
        for(let i = 0; i < this.len(); i++)if (v == this.heap[i].value) index = i;
        if (index === null) return false;
        if (this.len() > 1) {
            let last = this.heap.pop();
            if (last.value != v) {
                this.heap[index] = last;
                this.updateDown(index);
            }
            return true;
        } else this.heap.pop();
        return true;
    }
    parentNode(x) {
        return Math.floor((x - 1) / 2);
    }
    leftChildNode(x) {
        return 2 * x + 1;
    }
    rightChildNode(x) {
        return 2 * x + 2;
    }
    existNode(x) {
        return x >= 0 && x < this.heap.length;
    }
    swap(x, y) {
        const t = this.heap[x];
        this.heap[x] = this.heap[y];
        this.heap[y] = t;
    }
    minNode(numbers) {
        const validnumbers = numbers.filter(this.existNode.bind(this));
        let minimal = validnumbers[0];
        for (const i of validnumbers)if (this.lessThan(this.heap[i], this.heap[minimal])) minimal = i;
        return minimal;
    }
    updateUp(x) {
        if (x == 0) return;
        const parent = this.parentNode(x);
        if (this.existNode(parent) && this.lessThan(this.heap[x], this.heap[parent])) {
            this.swap(x, parent);
            this.updateUp(parent);
        }
    }
    updateDown(x) {
        const leftChild = this.leftChildNode(x);
        const rightChild = this.rightChildNode(x);
        if (!this.existNode(leftChild)) return;
        const m = this.minNode([
            x,
            leftChild,
            rightChild
        ]);
        if (m != x) {
            this.swap(x, m);
            this.updateDown(m);
        }
    }
    debugPrint() {
        console.log(this.heap);
    }
}


class $47a984ba762a2b79$export$2e2bcd8739ae039 {
    /**
     * @class Generic event queue: stores events and retrieves them based on their time
     */ constructor(){
        this._time = 0;
        this._events = new (0, $356bdaa38ef77da5$export$457b0b5893773add)();
    }
    /**
     * @returns {number} Elapsed time
     */ getTime() {
        return this._time;
    }
    /**
     * Clear all scheduled events
     */ clear() {
        this._events = new (0, $356bdaa38ef77da5$export$457b0b5893773add)();
        return this;
    }
    /**
     * @param {?} event
     * @param {number} time
     */ add(event, time) {
        this._events.push(event, time);
    }
    /**
     * Locates the nearest event, advances time if necessary. Returns that event and removes it from the queue.
     * @returns {? || null} The event previously added by addEvent, null if no event available
     */ get() {
        if (!this._events.len()) return null;
        let { key: time, value: event } = this._events.pop();
        if (time > 0) {
            this._time += time;
            this._events.shift(-time);
        }
        return event;
    }
    /**
     * Get the time associated with the given event
     * @param {?} event
     * @returns {number} time
     */ getEventTime(event) {
        const r = this._events.find(event);
        if (r) {
            const { key: key } = r;
            return key;
        }
        return undefined;
    }
    /**
     * Remove an event from the queue
     * @param {?} event
     * @returns {bool} success?
     */ remove(event) {
        return this._events.remove(event);
    }
}



class $5adaeb30db96749e$export$2e2bcd8739ae039 {
    /**
     * @class Abstract scheduler
     */ constructor(){
        this._queue = new (0, $47a984ba762a2b79$export$2e2bcd8739ae039)();
        this._repeat = [];
        this._current = null;
    }
    /**
     * @see ROT.EventQueue#getTime
     */ getTime() {
        return this._queue.getTime();
    }
    /**
     * @param {?} item
     * @param {bool} repeat
     */ add(item, repeat) {
        if (repeat) this._repeat.push(item);
        return this;
    }
    /**
     * Get the time the given item is scheduled for
     * @param {?} item
     * @returns {number} time
     */ getTimeOf(item) {
        return this._queue.getEventTime(item);
    }
    /**
     * Clear all items
     */ clear() {
        this._queue.clear();
        this._repeat = [];
        this._current = null;
        return this;
    }
    /**
     * Remove a previously added item
     * @param {?} item
     * @returns {bool} successful?
     */ remove(item) {
        let result = this._queue.remove(item);
        let index = this._repeat.indexOf(item);
        if (index != -1) this._repeat.splice(index, 1);
        if (this._current == item) this._current = null;
        return result;
    }
    /**
     * Schedule next item
     * @returns {?}
     */ next() {
        this._current = this._queue.get();
        return this._current;
    }
}


class $6fcdf682d54dd4f5$export$2e2bcd8739ae039 extends (0, $5adaeb30db96749e$export$2e2bcd8739ae039) {
    add(item, repeat) {
        this._queue.add(item, 0);
        return super.add(item, repeat);
    }
    next() {
        if (this._current !== null && this._repeat.indexOf(this._current) != -1) this._queue.add(this._current, 0);
        return super.next();
    }
}



class $df67c8c0c1d541f5$export$2e2bcd8739ae039 extends (0, $5adaeb30db96749e$export$2e2bcd8739ae039) {
    /**
     * @param {object} item anything with "getSpeed" method
     * @param {bool} repeat
     * @param {number} [time=1/item.getSpeed()]
     * @see ROT.Scheduler#add
     */ add(item, repeat, time) {
        this._queue.add(item, time !== undefined ? time : 1 / item.getSpeed());
        return super.add(item, repeat);
    }
    /**
     * @see ROT.Scheduler#next
     */ next() {
        if (this._current && this._repeat.indexOf(this._current) != -1) this._queue.add(this._current, 1 / this._current.getSpeed());
        return super.next();
    }
}



class $80d73fc5008aa3f9$export$2e2bcd8739ae039 extends (0, $5adaeb30db96749e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._defaultDuration = 1; /* for newly added */ 
        this._duration = this._defaultDuration; /* for this._current */ 
    }
    /**
     * @param {object} item
     * @param {bool} repeat
     * @param {number} [time=1]
     * @see ROT.Scheduler#add
     */ add(item, repeat, time) {
        this._queue.add(item, time || this._defaultDuration);
        return super.add(item, repeat);
    }
    clear() {
        this._duration = this._defaultDuration;
        return super.clear();
    }
    remove(item) {
        if (item == this._current) this._duration = this._defaultDuration;
        return super.remove(item);
    }
    /**
     * @see ROT.Scheduler#next
     */ next() {
        if (this._current !== null && this._repeat.indexOf(this._current) != -1) {
            this._queue.add(this._current, this._duration || this._defaultDuration);
            this._duration = this._defaultDuration;
        }
        return super.next();
    }
    /**
     * Set duration for the active item
     */ setDuration(time) {
        if (this._current) this._duration = time;
        return this;
    }
}


var $982e60695e119ce0$export$2e2bcd8739ae039 = {
    Simple: $6fcdf682d54dd4f5$export$2e2bcd8739ae039,
    Speed: $df67c8c0c1d541f5$export$2e2bcd8739ae039,
    Action: $80d73fc5008aa3f9$export$2e2bcd8739ae039
};



class $ca01f25fe6ee188c$export$2e2bcd8739ae039 {
    /**
     * @class Abstract FOV algorithm
     * @param {function} lightPassesCallback Does the light pass through x,y?
     * @param {object} [options]
     * @param {int} [options.topology=8] 4/6/8
     */ constructor(lightPassesCallback, options = {}){
        this._lightPasses = lightPassesCallback;
        this._options = Object.assign({
            topology: 8
        }, options);
    }
    /**
     * Return all neighbors in a concentric ring
     * @param {int} cx center-x
     * @param {int} cy center-y
     * @param {int} r range
     */ _getCircle(cx, cy, r) {
        let result = [];
        let dirs, countFactor, startOffset;
        switch(this._options.topology){
            case 4:
                countFactor = 1;
                startOffset = [
                    0,
                    1
                ];
                dirs = [
                    (0, $55a6f72eb77f658c$export$a2cefd738759134a)[8][7],
                    (0, $55a6f72eb77f658c$export$a2cefd738759134a)[8][1],
                    (0, $55a6f72eb77f658c$export$a2cefd738759134a)[8][3],
                    (0, $55a6f72eb77f658c$export$a2cefd738759134a)[8][5]
                ];
                break;
            case 6:
                dirs = (0, $55a6f72eb77f658c$export$a2cefd738759134a)[6];
                countFactor = 1;
                startOffset = [
                    -1,
                    1
                ];
                break;
            case 8:
                dirs = (0, $55a6f72eb77f658c$export$a2cefd738759134a)[4];
                countFactor = 2;
                startOffset = [
                    -1,
                    1
                ];
                break;
            default:
                throw new Error("Incorrect topology for FOV computation");
        }
        /* starting neighbor */ let x = cx + startOffset[0] * r;
        let y = cy + startOffset[1] * r;
        /* circle */ for(let i = 0; i < dirs.length; i++)for(let j = 0; j < r * countFactor; j++){
            result.push([
                x,
                y
            ]);
            x += dirs[i][0];
            y += dirs[i][1];
        }
        return result;
    }
}


class $27ef97f5c136fb5c$export$2e2bcd8739ae039 extends (0, $ca01f25fe6ee188c$export$2e2bcd8739ae039) {
    compute(x, y, R, callback) {
        /* this place is always visible */ callback(x, y, 0, 1);
        /* standing in a dark place. FIXME is this a good idea?  */ if (!this._lightPasses(x, y)) return;
        /* start and end angles */ let DATA = [];
        let A, B, cx, cy, blocks;
        /* analyze surrounding cells in concentric rings, starting from the center */ for(let r = 1; r <= R; r++){
            let neighbors = this._getCircle(x, y, r);
            let angle = 360 / neighbors.length;
            for(let i = 0; i < neighbors.length; i++){
                cx = neighbors[i][0];
                cy = neighbors[i][1];
                A = angle * (i - 0.5);
                B = A + angle;
                blocks = !this._lightPasses(cx, cy);
                if (this._visibleCoords(Math.floor(A), Math.ceil(B), blocks, DATA)) callback(cx, cy, r, 1);
                if (DATA.length == 2 && DATA[0] == 0 && DATA[1] == 360) return;
                 /* cutoff? */ 
            } /* for all cells in this ring */ 
        } /* for all rings */ 
    }
    /**
     * @param {int} A start angle
     * @param {int} B end angle
     * @param {bool} blocks Does current cell block visibility?
     * @param {int[][]} DATA shadowed angle pairs
     */ _visibleCoords(A, B, blocks, DATA) {
        if (A < 0) {
            let v1 = this._visibleCoords(0, B, blocks, DATA);
            let v2 = this._visibleCoords(360 + A, 360, blocks, DATA);
            return v1 || v2;
        }
        let index = 0;
        while(index < DATA.length && DATA[index] < A)index++;
        if (index == DATA.length) {
            if (blocks) DATA.push(A, B);
            return true;
        }
        let count = 0;
        if (index % 2) {
            while(index < DATA.length && DATA[index] < B){
                index++;
                count++;
            }
            if (count == 0) return false;
            if (blocks) {
                if (count % 2) DATA.splice(index - count, count, B);
                else DATA.splice(index - count, count);
            }
            return true;
        } else {
            while(index < DATA.length && DATA[index] < B){
                index++;
                count++;
            }
            /* visible when outside an existing shadow, or when overlapping */ if (A == DATA[index - count] && count == 1) return false;
            if (blocks) {
                if (count % 2) DATA.splice(index - count, count, A);
                else DATA.splice(index - count, count, A, B);
            }
            return true;
        }
    }
}



class $e5a11f508f5a3e80$export$2e2bcd8739ae039 extends (0, $ca01f25fe6ee188c$export$2e2bcd8739ae039) {
    compute(x, y, R, callback) {
        /* this place is always visible */ callback(x, y, 0, 1);
        /* standing in a dark place. FIXME is this a good idea?  */ if (!this._lightPasses(x, y)) return;
        /* list of all shadows */ let SHADOWS = [];
        let cx, cy, blocks, A1, A2, visibility;
        /* analyze surrounding cells in concentric rings, starting from the center */ for(let r = 1; r <= R; r++){
            let neighbors = this._getCircle(x, y, r);
            let neighborCount = neighbors.length;
            for(let i = 0; i < neighborCount; i++){
                cx = neighbors[i][0];
                cy = neighbors[i][1];
                /* shift half-an-angle backwards to maintain consistency of 0-th cells */ A1 = [
                    i ? 2 * i - 1 : 2 * neighborCount - 1,
                    2 * neighborCount
                ];
                A2 = [
                    2 * i + 1,
                    2 * neighborCount
                ];
                blocks = !this._lightPasses(cx, cy);
                visibility = this._checkVisibility(A1, A2, blocks, SHADOWS);
                if (visibility) callback(cx, cy, r, visibility);
                if (SHADOWS.length == 2 && SHADOWS[0][0] == 0 && SHADOWS[1][0] == SHADOWS[1][1]) return;
                 /* cutoff? */ 
            } /* for all cells in this ring */ 
        } /* for all rings */ 
    }
    /**
     * @param {int[2]} A1 arc start
     * @param {int[2]} A2 arc end
     * @param {bool} blocks Does current arc block visibility?
     * @param {int[][]} SHADOWS list of active shadows
     */ _checkVisibility(A1, A2, blocks, SHADOWS) {
        if (A1[0] > A2[0]) {
            let v1 = this._checkVisibility(A1, [
                A1[1],
                A1[1]
            ], blocks, SHADOWS);
            let v2 = this._checkVisibility([
                0,
                1
            ], A2, blocks, SHADOWS);
            return (v1 + v2) / 2;
        }
        /* index1: first shadow >= A1 */ let index1 = 0, edge1 = false;
        while(index1 < SHADOWS.length){
            let old = SHADOWS[index1];
            let diff = old[0] * A1[1] - A1[0] * old[1];
            if (diff >= 0) {
                if (diff == 0 && !(index1 % 2)) edge1 = true;
                break;
            }
            index1++;
        }
        /* index2: last shadow <= A2 */ let index2 = SHADOWS.length, edge2 = false;
        while(index2--){
            let old = SHADOWS[index2];
            let diff = A2[0] * old[1] - old[0] * A2[1];
            if (diff >= 0) {
                if (diff == 0 && index2 % 2) edge2 = true;
                break;
            }
        }
        let visible = true;
        if (index1 == index2 && (edge1 || edge2)) visible = false;
        else if (edge1 && edge2 && index1 + 1 == index2 && index2 % 2) visible = false;
        else if (index1 > index2 && index1 % 2) visible = false;
        if (!visible) return 0;
         /* fast case: not visible */ 
        let visibleLength;
        /* compute the length of visible arc, adjust list of shadows (if blocking) */ let remove = index2 - index1 + 1;
        if (remove % 2) {
            if (index1 % 2) {
                let P = SHADOWS[index1];
                visibleLength = (A2[0] * P[1] - P[0] * A2[1]) / (P[1] * A2[1]);
                if (blocks) SHADOWS.splice(index1, remove, A2);
            } else {
                let P = SHADOWS[index2];
                visibleLength = (P[0] * A1[1] - A1[0] * P[1]) / (A1[1] * P[1]);
                if (blocks) SHADOWS.splice(index1, remove, A1);
            }
        } else if (index1 % 2) {
            let P1 = SHADOWS[index1];
            let P2 = SHADOWS[index2];
            visibleLength = (P2[0] * P1[1] - P1[0] * P2[1]) / (P1[1] * P2[1]);
            if (blocks) SHADOWS.splice(index1, remove);
        } else {
            if (blocks) SHADOWS.splice(index1, remove, A1, A2);
            return 1; /* whole arc visible! */ 
        }
        let arcLength = (A2[0] * A1[1] - A1[0] * A2[1]) / (A1[1] * A2[1]);
        return visibleLength / arcLength;
    }
}



/** Octants used for translating recursive shadowcasting offsets */ const $1c9a9fc905a1c50b$var$OCTANTS = [
    [
        -1,
        0,
        0,
        1
    ],
    [
        0,
        -1,
        1,
        0
    ],
    [
        0,
        -1,
        -1,
        0
    ],
    [
        -1,
        0,
        0,
        -1
    ],
    [
        1,
        0,
        0,
        -1
    ],
    [
        0,
        1,
        -1,
        0
    ],
    [
        0,
        1,
        1,
        0
    ],
    [
        1,
        0,
        0,
        1
    ]
];
class $1c9a9fc905a1c50b$export$2e2bcd8739ae039 extends (0, $ca01f25fe6ee188c$export$2e2bcd8739ae039) {
    /**
     * Compute visibility for a 360-degree circle
     * @param {int} x
     * @param {int} y
     * @param {int} R Maximum visibility radius
     * @param {function} callback
     */ compute(x, y, R, callback) {
        //You can always see your own tile
        callback(x, y, 0, 1);
        for(let i = 0; i < $1c9a9fc905a1c50b$var$OCTANTS.length; i++)this._renderOctant(x, y, $1c9a9fc905a1c50b$var$OCTANTS[i], R, callback);
    }
    /**
     * Compute visibility for a 180-degree arc
     * @param {int} x
     * @param {int} y
     * @param {int} R Maximum visibility radius
     * @param {int} dir Direction to look in (expressed in a ROT.DIRS value);
     * @param {function} callback
     */ compute180(x, y, R, dir, callback) {
        //You can always see your own tile
        callback(x, y, 0, 1);
        let previousOctant = (dir - 1 + 8) % 8; //Need to retrieve the previous octant to render a full 180 degrees
        let nextPreviousOctant = (dir - 2 + 8) % 8; //Need to retrieve the previous two octants to render a full 180 degrees
        let nextOctant = (dir + 1 + 8) % 8; //Need to grab to next octant to render a full 180 degrees
        this._renderOctant(x, y, $1c9a9fc905a1c50b$var$OCTANTS[nextPreviousOctant], R, callback);
        this._renderOctant(x, y, $1c9a9fc905a1c50b$var$OCTANTS[previousOctant], R, callback);
        this._renderOctant(x, y, $1c9a9fc905a1c50b$var$OCTANTS[dir], R, callback);
        this._renderOctant(x, y, $1c9a9fc905a1c50b$var$OCTANTS[nextOctant], R, callback);
    }
    /**
     * Compute visibility for a 90-degree arc
     * @param {int} x
     * @param {int} y
     * @param {int} R Maximum visibility radius
     * @param {int} dir Direction to look in (expressed in a ROT.DIRS value);
     * @param {function} callback
     */ compute90(x, y, R, dir, callback) {
        //You can always see your own tile
        callback(x, y, 0, 1);
        let previousOctant = (dir - 1 + 8) % 8; //Need to retrieve the previous octant to render a full 90 degrees
        this._renderOctant(x, y, $1c9a9fc905a1c50b$var$OCTANTS[dir], R, callback);
        this._renderOctant(x, y, $1c9a9fc905a1c50b$var$OCTANTS[previousOctant], R, callback);
    }
    /**
     * Render one octant (45-degree arc) of the viewshed
     * @param {int} x
     * @param {int} y
     * @param {int} octant Octant to be rendered
     * @param {int} R Maximum visibility radius
     * @param {function} callback
     */ _renderOctant(x, y, octant, R, callback) {
        //Radius incremented by 1 to provide same coverage area as other shadowcasting radiuses
        this._castVisibility(x, y, 1, 1.0, 0.0, R + 1, octant[0], octant[1], octant[2], octant[3], callback);
    }
    /**
     * Actually calculates the visibility
     * @param {int} startX The starting X coordinate
     * @param {int} startY The starting Y coordinate
     * @param {int} row The row to render
     * @param {float} visSlopeStart The slope to start at
     * @param {float} visSlopeEnd The slope to end at
     * @param {int} radius The radius to reach out to
     * @param {int} xx
     * @param {int} xy
     * @param {int} yx
     * @param {int} yy
     * @param {function} callback The callback to use when we hit a block that is visible
     */ _castVisibility(startX, startY, row, visSlopeStart, visSlopeEnd, radius, xx, xy, yx, yy, callback) {
        if (visSlopeStart < visSlopeEnd) return;
        for(let i = row; i <= radius; i++){
            let dx = -i - 1;
            let dy = -i;
            let blocked = false;
            let newStart = 0;
            //'Row' could be column, names here assume octant 0 and would be flipped for half the octants
            while(dx <= 0){
                dx += 1;
                //Translate from relative coordinates to map coordinates
                let mapX = startX + dx * xx + dy * xy;
                let mapY = startY + dx * yx + dy * yy;
                //Range of the row
                let slopeStart = (dx - 0.5) / (dy + 0.5);
                let slopeEnd = (dx + 0.5) / (dy - 0.5);
                //Ignore if not yet at left edge of Octant
                if (slopeEnd > visSlopeStart) continue;
                //Done if past right edge
                if (slopeStart < visSlopeEnd) break;
                //If it's in range, it's visible
                if (dx * dx + dy * dy < radius * radius) callback(mapX, mapY, i, 1);
                if (!blocked) //If tile is a blocking tile, cast around it
                {
                    if (!this._lightPasses(mapX, mapY) && i < radius) {
                        blocked = true;
                        this._castVisibility(startX, startY, i + 1, visSlopeStart, slopeStart, radius, xx, xy, yx, yy, callback);
                        newStart = slopeEnd;
                    }
                } else {
                    //Keep narrowing if scanning across a block
                    if (!this._lightPasses(mapX, mapY)) {
                        newStart = slopeEnd;
                        continue;
                    }
                    //Block has ended
                    blocked = false;
                    visSlopeStart = newStart;
                }
            }
            if (blocked) break;
        }
    }
}


var $9976061c5a87d4df$export$2e2bcd8739ae039 = {
    DiscreteShadowcasting: $27ef97f5c136fb5c$export$2e2bcd8739ae039,
    PreciseShadowcasting: $e5a11f508f5a3e80$export$2e2bcd8739ae039,
    RecursiveShadowcasting: $1c9a9fc905a1c50b$export$2e2bcd8739ae039
};



class $df9181f833546cd2$export$2e2bcd8739ae039 {
    /**
     * @class Base map generator
     * @param {int} [width=ROT.DEFAULT_WIDTH]
     * @param {int} [height=ROT.DEFAULT_HEIGHT]
     */ constructor(width = (0, $55a6f72eb77f658c$export$aa4eace044cdfdbf), height = (0, $55a6f72eb77f658c$export$611c894df53833b0)){
        this._width = width;
        this._height = height;
    }
    _fillMap(value) {
        let map = [];
        for(let i = 0; i < this._width; i++){
            map.push([]);
            for(let j = 0; j < this._height; j++)map[i].push(value);
        }
        return map;
    }
}


class $b774f1bd0a75509d$export$2e2bcd8739ae039 extends (0, $df9181f833546cd2$export$2e2bcd8739ae039) {
    create(callback) {
        let w = this._width - 1;
        let h = this._height - 1;
        for(let i = 0; i <= w; i++)for(let j = 0; j <= h; j++){
            let empty = i && j && i < w && j < h;
            callback(i, j, empty ? 0 : 1);
        }
        return this;
    }
}



class $da0395133104d08c$export$2e2bcd8739ae039 extends (0, $df9181f833546cd2$export$2e2bcd8739ae039) {
    constructor(width, height){
        super(width, height);
        this._rooms = [];
        this._corridors = [];
    }
    /**
     * Get all generated rooms
     * @returns {ROT.Map.Feature.Room[]}
     */ getRooms() {
        return this._rooms;
    }
    /**
     * Get all generated corridors
     * @returns {ROT.Map.Feature.Corridor[]}
     */ getCorridors() {
        return this._corridors;
    }
}



/**
 * @class Dungeon feature; has own .create() method
 */ class $94296ece9a6a8d0e$var$Feature {
}
class $94296ece9a6a8d0e$export$525628e68e798fb4 extends $94296ece9a6a8d0e$var$Feature {
    constructor(x1, y1, x2, y2, doorX, doorY){
        super();
        this._x1 = x1;
        this._y1 = y1;
        this._x2 = x2;
        this._y2 = y2;
        this._doors = {};
        if (doorX !== undefined && doorY !== undefined) this.addDoor(doorX, doorY);
    }
    /**
     * Room of random size, with a given doors and direction
     */ static createRandomAt(x, y, dx, dy, options) {
        let min = options.roomWidth[0];
        let max = options.roomWidth[1];
        let width = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniformInt(min, max);
        min = options.roomHeight[0];
        max = options.roomHeight[1];
        let height = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniformInt(min, max);
        if (dx == 1) {
            let y2 = y - Math.floor((0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniform() * height);
            return new this(x + 1, y2, x + width, y2 + height - 1, x, y);
        }
        if (dx == -1) {
            let y2 = y - Math.floor((0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniform() * height);
            return new this(x - width, y2, x - 1, y2 + height - 1, x, y);
        }
        if (dy == 1) {
            let x2 = x - Math.floor((0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniform() * width);
            return new this(x2, y + 1, x2 + width - 1, y + height, x, y);
        }
        if (dy == -1) {
            let x2 = x - Math.floor((0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniform() * width);
            return new this(x2, y - height, x2 + width - 1, y - 1, x, y);
        }
        throw new Error("dx or dy must be 1 or -1");
    }
    /**
     * Room of random size, positioned around center coords
     */ static createRandomCenter(cx, cy, options) {
        let min = options.roomWidth[0];
        let max = options.roomWidth[1];
        let width = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniformInt(min, max);
        min = options.roomHeight[0];
        max = options.roomHeight[1];
        let height = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniformInt(min, max);
        let x1 = cx - Math.floor((0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniform() * width);
        let y1 = cy - Math.floor((0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniform() * height);
        let x2 = x1 + width - 1;
        let y2 = y1 + height - 1;
        return new this(x1, y1, x2, y2);
    }
    /**
     * Room of random size within a given dimensions
     */ static createRandom(availWidth, availHeight, options) {
        let min = options.roomWidth[0];
        let max = options.roomWidth[1];
        let width = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniformInt(min, max);
        min = options.roomHeight[0];
        max = options.roomHeight[1];
        let height = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniformInt(min, max);
        let left = availWidth - width - 1;
        let top = availHeight - height - 1;
        let x1 = 1 + Math.floor((0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniform() * left);
        let y1 = 1 + Math.floor((0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniform() * top);
        let x2 = x1 + width - 1;
        let y2 = y1 + height - 1;
        return new this(x1, y1, x2, y2);
    }
    addDoor(x, y) {
        this._doors[x + "," + y] = 1;
        return this;
    }
    /**
     * @param {function}
     */ getDoors(cb) {
        for(let key in this._doors){
            let parts = key.split(",");
            cb(parseInt(parts[0]), parseInt(parts[1]));
        }
        return this;
    }
    clearDoors() {
        this._doors = {};
        return this;
    }
    addDoors(isWallCallback) {
        let left = this._x1 - 1;
        let right = this._x2 + 1;
        let top = this._y1 - 1;
        let bottom = this._y2 + 1;
        for(let x = left; x <= right; x++)for(let y = top; y <= bottom; y++){
            if (x != left && x != right && y != top && y != bottom) continue;
            if (isWallCallback(x, y)) continue;
            this.addDoor(x, y);
        }
        return this;
    }
    debug() {
        console.log("room", this._x1, this._y1, this._x2, this._y2);
    }
    isValid(isWallCallback, canBeDugCallback) {
        let left = this._x1 - 1;
        let right = this._x2 + 1;
        let top = this._y1 - 1;
        let bottom = this._y2 + 1;
        for(let x = left; x <= right; x++){
            for(let y = top; y <= bottom; y++)if (x == left || x == right || y == top || y == bottom) {
                if (!isWallCallback(x, y)) return false;
            } else {
                if (!canBeDugCallback(x, y)) return false;
            }
        }
        return true;
    }
    /**
     * @param {function} digCallback Dig callback with a signature (x, y, value). Values: 0 = empty, 1 = wall, 2 = door. Multiple doors are allowed.
     */ create(digCallback) {
        let left = this._x1 - 1;
        let right = this._x2 + 1;
        let top = this._y1 - 1;
        let bottom = this._y2 + 1;
        let value = 0;
        for(let x = left; x <= right; x++)for(let y = top; y <= bottom; y++){
            if (x + "," + y in this._doors) value = 2;
            else if (x == left || x == right || y == top || y == bottom) value = 1;
            else value = 0;
            digCallback(x, y, value);
        }
    }
    getCenter() {
        return [
            Math.round((this._x1 + this._x2) / 2),
            Math.round((this._y1 + this._y2) / 2)
        ];
    }
    getLeft() {
        return this._x1;
    }
    getRight() {
        return this._x2;
    }
    getTop() {
        return this._y1;
    }
    getBottom() {
        return this._y2;
    }
}
class $94296ece9a6a8d0e$export$9f2f205dded93c1a extends $94296ece9a6a8d0e$var$Feature {
    constructor(startX, startY, endX, endY){
        super();
        this._startX = startX;
        this._startY = startY;
        this._endX = endX;
        this._endY = endY;
        this._endsWithAWall = true;
    }
    static createRandomAt(x, y, dx, dy, options) {
        let min = options.corridorLength[0];
        let max = options.corridorLength[1];
        let length = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniformInt(min, max);
        return new this(x, y, x + dx * length, y + dy * length);
    }
    debug() {
        console.log("corridor", this._startX, this._startY, this._endX, this._endY);
    }
    isValid(isWallCallback, canBeDugCallback) {
        let sx = this._startX;
        let sy = this._startY;
        let dx = this._endX - sx;
        let dy = this._endY - sy;
        let length = 1 + Math.max(Math.abs(dx), Math.abs(dy));
        if (dx) dx = dx / Math.abs(dx);
        if (dy) dy = dy / Math.abs(dy);
        let nx = dy;
        let ny = -dx;
        let ok = true;
        for(let i = 0; i < length; i++){
            let x = sx + i * dx;
            let y = sy + i * dy;
            if (!canBeDugCallback(x, y)) ok = false;
            if (!isWallCallback(x + nx, y + ny)) ok = false;
            if (!isWallCallback(x - nx, y - ny)) ok = false;
            if (!ok) {
                length = i;
                this._endX = x - dx;
                this._endY = y - dy;
                break;
            }
        }
        /**
         * If the length degenerated, this corridor might be invalid
         */ /* not supported */ if (length == 0) return false;
        /* length 1 allowed only if the next space is empty */ if (length == 1 && isWallCallback(this._endX + dx, this._endY + dy)) return false;
        /**
         * We do not want the corridor to crash into a corner of a room;
         * if any of the ending corners is empty, the N+1th cell of this corridor must be empty too.
         *
         * Situation:
         * #######1
         * .......?
         * #######2
         *
         * The corridor was dug from left to right.
         * 1, 2 - problematic corners, ? = N+1th cell (not dug)
         */ let firstCornerBad = !isWallCallback(this._endX + dx + nx, this._endY + dy + ny);
        let secondCornerBad = !isWallCallback(this._endX + dx - nx, this._endY + dy - ny);
        this._endsWithAWall = isWallCallback(this._endX + dx, this._endY + dy);
        if ((firstCornerBad || secondCornerBad) && this._endsWithAWall) return false;
        return true;
    }
    /**
     * @param {function} digCallback Dig callback with a signature (x, y, value). Values: 0 = empty.
     */ create(digCallback) {
        let sx = this._startX;
        let sy = this._startY;
        let dx = this._endX - sx;
        let dy = this._endY - sy;
        let length = 1 + Math.max(Math.abs(dx), Math.abs(dy));
        if (dx) dx = dx / Math.abs(dx);
        if (dy) dy = dy / Math.abs(dy);
        for(let i = 0; i < length; i++){
            let x = sx + i * dx;
            let y = sy + i * dy;
            digCallback(x, y, 0);
        }
        return true;
    }
    createPriorityWalls(priorityWallCallback) {
        if (!this._endsWithAWall) return;
        let sx = this._startX;
        let sy = this._startY;
        let dx = this._endX - sx;
        let dy = this._endY - sy;
        if (dx) dx = dx / Math.abs(dx);
        if (dy) dy = dy / Math.abs(dy);
        let nx = dy;
        let ny = -dx;
        priorityWallCallback(this._endX + dx, this._endY + dy);
        priorityWallCallback(this._endX + nx, this._endY + ny);
        priorityWallCallback(this._endX - nx, this._endY - ny);
    }
}



class $cb051b1375226126$export$2e2bcd8739ae039 extends (0, $da0395133104d08c$export$2e2bcd8739ae039) {
    constructor(width, height, options){
        super(width, height);
        this._options = {
            roomWidth: [
                3,
                9
            ],
            roomHeight: [
                3,
                5
            ],
            roomDugPercentage: 0.1,
            timeLimit: 1000 /* we stop after this much time has passed (msec) */ 
        };
        Object.assign(this._options, options);
        this._map = [];
        this._dug = 0;
        this._roomAttempts = 20; /* new room is created N-times until is considered as impossible to generate */ 
        this._corridorAttempts = 20; /* corridors are tried N-times until the level is considered as impossible to connect */ 
        this._connected = []; /* list of already connected rooms */ 
        this._unconnected = []; /* list of remaining unconnected rooms */ 
        this._digCallback = this._digCallback.bind(this);
        this._canBeDugCallback = this._canBeDugCallback.bind(this);
        this._isWallCallback = this._isWallCallback.bind(this);
    }
    /**
     * Create a map. If the time limit has been hit, returns null.
     * @see ROT.Map#create
     */ create(callback) {
        let t1 = Date.now();
        while(true){
            let t2 = Date.now();
            if (t2 - t1 > this._options.timeLimit) return null;
             /* time limit! */ 
            this._map = this._fillMap(1);
            this._dug = 0;
            this._rooms = [];
            this._unconnected = [];
            this._generateRooms();
            if (this._rooms.length < 2) continue;
            if (this._generateCorridors()) break;
        }
        if (callback) {
            for(let i = 0; i < this._width; i++)for(let j = 0; j < this._height; j++)callback(i, j, this._map[i][j]);
        }
        return this;
    }
    /**
     * Generates a suitable amount of rooms
     */ _generateRooms() {
        let w = this._width - 2;
        let h = this._height - 2;
        let room;
        do {
            room = this._generateRoom();
            if (this._dug / (w * h) > this._options.roomDugPercentage) break;
             /* achieved requested amount of free space */ 
        }while (room);
    /* either enough rooms, or not able to generate more of them :) */ }
    /**
     * Try to generate one room
     */ _generateRoom() {
        let count = 0;
        while(count < this._roomAttempts){
            count++;
            let room = (0, $94296ece9a6a8d0e$export$525628e68e798fb4).createRandom(this._width, this._height, this._options);
            if (!room.isValid(this._isWallCallback, this._canBeDugCallback)) continue;
            room.create(this._digCallback);
            this._rooms.push(room);
            return room;
        }
        /* no room was generated in a given number of attempts */ return null;
    }
    /**
     * Generates connectors beween rooms
     * @returns {bool} success Was this attempt successfull?
     */ _generateCorridors() {
        let cnt = 0;
        while(cnt < this._corridorAttempts){
            cnt++;
            this._corridors = [];
            /* dig rooms into a clear map */ this._map = this._fillMap(1);
            for(let i = 0; i < this._rooms.length; i++){
                let room = this._rooms[i];
                room.clearDoors();
                room.create(this._digCallback);
            }
            this._unconnected = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).shuffle(this._rooms.slice());
            this._connected = [];
            if (this._unconnected.length) this._connected.push(this._unconnected.pop());
             /* first one is always connected */ 
            while(true){
                /* 1. pick random connected room */ let connected = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getItem(this._connected);
                if (!connected) break;
                /* 2. find closest unconnected */ let room1 = this._closestRoom(this._unconnected, connected);
                if (!room1) break;
                /* 3. connect it to closest connected */ let room2 = this._closestRoom(this._connected, room1);
                if (!room2) break;
                let ok = this._connectRooms(room1, room2);
                if (!ok) break;
                 /* stop connecting, re-shuffle */ 
                if (!this._unconnected.length) return true;
                 /* done; no rooms remain */ 
            }
        }
        return false;
    }
    /**
     * For a given room, find the closest one from the list
     */ _closestRoom(rooms, room) {
        let dist = Infinity;
        let center = room.getCenter();
        let result = null;
        for(let i = 0; i < rooms.length; i++){
            let r = rooms[i];
            let c = r.getCenter();
            let dx = c[0] - center[0];
            let dy = c[1] - center[1];
            let d = dx * dx + dy * dy;
            if (d < dist) {
                dist = d;
                result = r;
            }
        }
        return result;
    }
    _connectRooms(room1, room2) {
        /*
            room1.debug();
            room2.debug();
        */ let center1 = room1.getCenter();
        let center2 = room2.getCenter();
        let diffX = center2[0] - center1[0];
        let diffY = center2[1] - center1[1];
        let start;
        let end;
        let dirIndex1, dirIndex2, min, max, index;
        if (Math.abs(diffX) < Math.abs(diffY)) {
            dirIndex1 = diffY > 0 ? 2 : 0;
            dirIndex2 = (dirIndex1 + 2) % 4;
            min = room2.getLeft();
            max = room2.getRight();
            index = 0;
        } else {
            dirIndex1 = diffX > 0 ? 1 : 3;
            dirIndex2 = (dirIndex1 + 2) % 4;
            min = room2.getTop();
            max = room2.getBottom();
            index = 1;
        }
        start = this._placeInWall(room1, dirIndex1); /* corridor will start here */ 
        if (!start) return false;
        if (start[index] >= min && start[index] <= max) {
            end = start.slice();
            let value = 0;
            switch(dirIndex2){
                case 0:
                    value = room2.getTop() - 1;
                    break;
                case 1:
                    value = room2.getRight() + 1;
                    break;
                case 2:
                    value = room2.getBottom() + 1;
                    break;
                case 3:
                    value = room2.getLeft() - 1;
                    break;
            }
            end[(index + 1) % 2] = value;
            this._digLine([
                start,
                end
            ]);
        } else if (start[index] < min - 1 || start[index] > max + 1) {
            let diff = start[index] - center2[index];
            let rotation = 0;
            switch(dirIndex2){
                case 0:
                case 1:
                    rotation = diff < 0 ? 3 : 1;
                    break;
                case 2:
                case 3:
                    rotation = diff < 0 ? 1 : 3;
                    break;
            }
            dirIndex2 = (dirIndex2 + rotation) % 4;
            end = this._placeInWall(room2, dirIndex2);
            if (!end) return false;
            let mid = [
                0,
                0
            ];
            mid[index] = start[index];
            let index2 = (index + 1) % 2;
            mid[index2] = end[index2];
            this._digLine([
                start,
                mid,
                end
            ]);
        } else {
            let index2 = (index + 1) % 2;
            end = this._placeInWall(room2, dirIndex2);
            if (!end) return false;
            let mid = Math.round((end[index2] + start[index2]) / 2);
            let mid1 = [
                0,
                0
            ];
            let mid2 = [
                0,
                0
            ];
            mid1[index] = start[index];
            mid1[index2] = mid;
            mid2[index] = end[index];
            mid2[index2] = mid;
            this._digLine([
                start,
                mid1,
                mid2,
                end
            ]);
        }
        room1.addDoor(start[0], start[1]);
        room2.addDoor(end[0], end[1]);
        index = this._unconnected.indexOf(room1);
        if (index != -1) {
            this._unconnected.splice(index, 1);
            this._connected.push(room1);
        }
        index = this._unconnected.indexOf(room2);
        if (index != -1) {
            this._unconnected.splice(index, 1);
            this._connected.push(room2);
        }
        return true;
    }
    _placeInWall(room, dirIndex) {
        let start = [
            0,
            0
        ];
        let dir = [
            0,
            0
        ];
        let length = 0;
        switch(dirIndex){
            case 0:
                dir = [
                    1,
                    0
                ];
                start = [
                    room.getLeft(),
                    room.getTop() - 1
                ];
                length = room.getRight() - room.getLeft() + 1;
                break;
            case 1:
                dir = [
                    0,
                    1
                ];
                start = [
                    room.getRight() + 1,
                    room.getTop()
                ];
                length = room.getBottom() - room.getTop() + 1;
                break;
            case 2:
                dir = [
                    1,
                    0
                ];
                start = [
                    room.getLeft(),
                    room.getBottom() + 1
                ];
                length = room.getRight() - room.getLeft() + 1;
                break;
            case 3:
                dir = [
                    0,
                    1
                ];
                start = [
                    room.getLeft() - 1,
                    room.getTop()
                ];
                length = room.getBottom() - room.getTop() + 1;
                break;
        }
        let avail = [];
        let lastBadIndex = -2;
        for(let i = 0; i < length; i++){
            let x = start[0] + i * dir[0];
            let y = start[1] + i * dir[1];
            avail.push(null);
            let isWall = this._map[x][y] == 1;
            if (isWall) {
                if (lastBadIndex != i - 1) avail[i] = [
                    x,
                    y
                ];
            } else {
                lastBadIndex = i;
                if (i) avail[i - 1] = null;
            }
        }
        for(let i = avail.length - 1; i >= 0; i--)if (!avail[i]) avail.splice(i, 1);
        return avail.length ? (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getItem(avail) : null;
    }
    /**
     * Dig a polyline.
     */ _digLine(points) {
        for(let i = 1; i < points.length; i++){
            let start = points[i - 1];
            let end = points[i];
            let corridor = new (0, $94296ece9a6a8d0e$export$9f2f205dded93c1a)(start[0], start[1], end[0], end[1]);
            corridor.create(this._digCallback);
            this._corridors.push(corridor);
        }
    }
    _digCallback(x, y, value) {
        this._map[x][y] = value;
        if (value == 0) this._dug++;
    }
    _isWallCallback(x, y) {
        if (x < 0 || y < 0 || x >= this._width || y >= this._height) return false;
        return this._map[x][y] == 1;
    }
    _canBeDugCallback(x, y) {
        if (x < 1 || y < 1 || x + 1 >= this._width || y + 1 >= this._height) return false;
        return this._map[x][y] == 1;
    }
}





class $d36d4746484d411e$export$2e2bcd8739ae039 extends (0, $df9181f833546cd2$export$2e2bcd8739ae039) {
    constructor(width, height, options = {}){
        super(width, height);
        this._options = {
            born: [
                5,
                6,
                7,
                8
            ],
            survive: [
                4,
                5,
                6,
                7,
                8
            ],
            topology: 8
        };
        this.setOptions(options);
        this._dirs = (0, $55a6f72eb77f658c$export$a2cefd738759134a)[this._options.topology];
        this._map = this._fillMap(0);
    }
    /**
     * Fill the map with random values
     * @param {float} probability Probability for a cell to become alive; 0 = all empty, 1 = all full
     */ randomize(probability) {
        for(let i = 0; i < this._width; i++)for(let j = 0; j < this._height; j++)this._map[i][j] = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniform() < probability ? 1 : 0;
        return this;
    }
    /**
     * Change options.
     * @see ROT.Map.Cellular
     */ setOptions(options) {
        Object.assign(this._options, options);
    }
    set(x, y, value) {
        this._map[x][y] = value;
    }
    create(callback) {
        let newMap = this._fillMap(0);
        let born = this._options.born;
        let survive = this._options.survive;
        for(let j = 0; j < this._height; j++){
            let widthStep = 1;
            let widthStart = 0;
            if (this._options.topology == 6) {
                widthStep = 2;
                widthStart = j % 2;
            }
            for(let i = widthStart; i < this._width; i += widthStep){
                let cur = this._map[i][j];
                let ncount = this._getNeighbors(i, j);
                if (cur && survive.indexOf(ncount) != -1) newMap[i][j] = 1;
                else if (!cur && born.indexOf(ncount) != -1) newMap[i][j] = 1;
            }
        }
        this._map = newMap;
        callback && this._serviceCallback(callback);
    }
    _serviceCallback(callback) {
        for(let j = 0; j < this._height; j++){
            let widthStep = 1;
            let widthStart = 0;
            if (this._options.topology == 6) {
                widthStep = 2;
                widthStart = j % 2;
            }
            for(let i = widthStart; i < this._width; i += widthStep)callback(i, j, this._map[i][j]);
        }
    }
    /**
     * Get neighbor count at [i,j] in this._map
     */ _getNeighbors(cx, cy) {
        let result = 0;
        for(let i = 0; i < this._dirs.length; i++){
            let dir = this._dirs[i];
            let x = cx + dir[0];
            let y = cy + dir[1];
            if (x < 0 || x >= this._width || y < 0 || y >= this._height) continue;
            result += this._map[x][y] == 1 ? 1 : 0;
        }
        return result;
    }
    /**
     * Make sure every non-wall space is accessible.
     * @param {function} callback to call to display map when do
     * @param {int} value to consider empty space - defaults to 0
     * @param {function} callback to call when a new connection is made
     */ connect(callback, value, connectionCallback) {
        if (!value) value = 0;
        let allFreeSpace = [];
        let notConnected = {};
        // find all free space
        let widthStep = 1;
        let widthStarts = [
            0,
            0
        ];
        if (this._options.topology == 6) {
            widthStep = 2;
            widthStarts = [
                0,
                1
            ];
        }
        for(let y = 0; y < this._height; y++){
            for(let x = widthStarts[y % 2]; x < this._width; x += widthStep)if (this._freeSpace(x, y, value)) {
                let p = [
                    x,
                    y
                ];
                notConnected[this._pointKey(p)] = p;
                allFreeSpace.push([
                    x,
                    y
                ]);
            }
        }
        let start = allFreeSpace[(0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniformInt(0, allFreeSpace.length - 1)];
        let key = this._pointKey(start);
        let connected = {};
        connected[key] = start;
        delete notConnected[key];
        // find what's connected to the starting point
        this._findConnected(connected, notConnected, [
            start
        ], false, value);
        while(Object.keys(notConnected).length > 0){
            // find two points from notConnected to connected
            let p = this._getFromTo(connected, notConnected);
            let from = p[0]; // notConnected
            let to = p[1]; // connected
            // find everything connected to the starting point
            let local = {};
            local[this._pointKey(from)] = from;
            this._findConnected(local, notConnected, [
                from
            ], true, value);
            // connect to a connected cell
            let tunnelFn = this._options.topology == 6 ? this._tunnelToConnected6 : this._tunnelToConnected;
            tunnelFn.call(this, to, from, connected, notConnected, value, connectionCallback);
            // now all of local is connected
            for(let k in local){
                let pp = local[k];
                this._map[pp[0]][pp[1]] = value;
                connected[k] = pp;
                delete notConnected[k];
            }
        }
        callback && this._serviceCallback(callback);
    }
    /**
     * Find random points to connect. Search for the closest point in the larger space.
     * This is to minimize the length of the passage while maintaining good performance.
     */ _getFromTo(connected, notConnected) {
        let from = [
            0,
            0
        ], to = [
            0,
            0
        ], d;
        let connectedKeys = Object.keys(connected);
        let notConnectedKeys = Object.keys(notConnected);
        for(let i = 0; i < 5; i++){
            if (connectedKeys.length < notConnectedKeys.length) {
                let keys = connectedKeys;
                to = connected[keys[(0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniformInt(0, keys.length - 1)]];
                from = this._getClosest(to, notConnected);
            } else {
                let keys = notConnectedKeys;
                from = notConnected[keys[(0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniformInt(0, keys.length - 1)]];
                to = this._getClosest(from, connected);
            }
            d = (from[0] - to[0]) * (from[0] - to[0]) + (from[1] - to[1]) * (from[1] - to[1]);
            if (d < 64) break;
        }
        // console.log(">>> connected=" + to + " notConnected=" + from + " dist=" + d);
        return [
            from,
            to
        ];
    }
    _getClosest(point, space) {
        let minPoint = null;
        let minDist = null;
        for(let k in space){
            let p = space[k];
            let d = (p[0] - point[0]) * (p[0] - point[0]) + (p[1] - point[1]) * (p[1] - point[1]);
            if (minDist == null || d < minDist) {
                minDist = d;
                minPoint = p;
            }
        }
        return minPoint;
    }
    _findConnected(connected, notConnected, stack, keepNotConnected, value) {
        while(stack.length > 0){
            let p = stack.splice(0, 1)[0];
            let tests;
            if (this._options.topology == 6) tests = [
                [
                    p[0] + 2,
                    p[1]
                ],
                [
                    p[0] + 1,
                    p[1] - 1
                ],
                [
                    p[0] - 1,
                    p[1] - 1
                ],
                [
                    p[0] - 2,
                    p[1]
                ],
                [
                    p[0] - 1,
                    p[1] + 1
                ],
                [
                    p[0] + 1,
                    p[1] + 1
                ]
            ];
            else tests = [
                [
                    p[0] + 1,
                    p[1]
                ],
                [
                    p[0] - 1,
                    p[1]
                ],
                [
                    p[0],
                    p[1] + 1
                ],
                [
                    p[0],
                    p[1] - 1
                ]
            ];
            for(let i = 0; i < tests.length; i++){
                let key = this._pointKey(tests[i]);
                if (connected[key] == null && this._freeSpace(tests[i][0], tests[i][1], value)) {
                    connected[key] = tests[i];
                    if (!keepNotConnected) delete notConnected[key];
                    stack.push(tests[i]);
                }
            }
        }
    }
    _tunnelToConnected(to, from, connected, notConnected, value, connectionCallback) {
        let a, b;
        if (from[0] < to[0]) {
            a = from;
            b = to;
        } else {
            a = to;
            b = from;
        }
        for(let xx = a[0]; xx <= b[0]; xx++){
            this._map[xx][a[1]] = value;
            let p = [
                xx,
                a[1]
            ];
            let pkey = this._pointKey(p);
            connected[pkey] = p;
            delete notConnected[pkey];
        }
        if (connectionCallback && a[0] < b[0]) connectionCallback(a, [
            b[0],
            a[1]
        ]);
        // x is now fixed
        let x = b[0];
        if (from[1] < to[1]) {
            a = from;
            b = to;
        } else {
            a = to;
            b = from;
        }
        for(let yy = a[1]; yy < b[1]; yy++){
            this._map[x][yy] = value;
            let p = [
                x,
                yy
            ];
            let pkey = this._pointKey(p);
            connected[pkey] = p;
            delete notConnected[pkey];
        }
        if (connectionCallback && a[1] < b[1]) connectionCallback([
            b[0],
            a[1]
        ], [
            b[0],
            b[1]
        ]);
    }
    _tunnelToConnected6(to, from, connected, notConnected, value, connectionCallback) {
        let a, b;
        if (from[0] < to[0]) {
            a = from;
            b = to;
        } else {
            a = to;
            b = from;
        }
        // tunnel diagonally until horizontally level
        let xx = a[0];
        let yy = a[1];
        while(!(xx == b[0] && yy == b[1])){
            let stepWidth = 2;
            if (yy < b[1]) {
                yy++;
                stepWidth = 1;
            } else if (yy > b[1]) {
                yy--;
                stepWidth = 1;
            }
            if (xx < b[0]) xx += stepWidth;
            else if (xx > b[0]) xx -= stepWidth;
            else if (b[1] % 2) // Won't step outside map if destination on is map's right edge
            xx -= stepWidth;
            else // ditto for left edge
            xx += stepWidth;
            this._map[xx][yy] = value;
            let p = [
                xx,
                yy
            ];
            let pkey = this._pointKey(p);
            connected[pkey] = p;
            delete notConnected[pkey];
        }
        if (connectionCallback) connectionCallback(from, to);
    }
    _freeSpace(x, y, value) {
        return x >= 0 && x < this._width && y >= 0 && y < this._height && this._map[x][y] == value;
    }
    _pointKey(p) {
        return p[0] + "." + p[1];
    }
}






const $4a7b23e4a65117fc$var$FEATURES = {
    "room": (0, $94296ece9a6a8d0e$export$525628e68e798fb4),
    "corridor": (0, $94296ece9a6a8d0e$export$9f2f205dded93c1a)
};
class $4a7b23e4a65117fc$export$2e2bcd8739ae039 extends (0, $da0395133104d08c$export$2e2bcd8739ae039) {
    constructor(width, height, options = {}){
        super(width, height);
        this._options = Object.assign({
            roomWidth: [
                3,
                9
            ],
            roomHeight: [
                3,
                5
            ],
            corridorLength: [
                3,
                10
            ],
            dugPercentage: 0.2,
            timeLimit: 1000 /* we stop after this much time has passed (msec) */ 
        }, options);
        this._features = {
            "room": 4,
            "corridor": 4
        };
        this._map = [];
        this._featureAttempts = 20; /* how many times do we try to create a feature on a suitable wall */ 
        this._walls = {}; /* these are available for digging */ 
        this._dug = 0;
        this._digCallback = this._digCallback.bind(this);
        this._canBeDugCallback = this._canBeDugCallback.bind(this);
        this._isWallCallback = this._isWallCallback.bind(this);
        this._priorityWallCallback = this._priorityWallCallback.bind(this);
    }
    create(callback) {
        this._rooms = [];
        this._corridors = [];
        this._map = this._fillMap(1);
        this._walls = {};
        this._dug = 0;
        let area = (this._width - 2) * (this._height - 2);
        this._firstRoom();
        let t1 = Date.now();
        let priorityWalls;
        do {
            priorityWalls = 0;
            let t2 = Date.now();
            if (t2 - t1 > this._options.timeLimit) break;
            /* find a good wall */ let wall = this._findWall();
            if (!wall) break;
             /* no more walls */ 
            let parts = wall.split(",");
            let x = parseInt(parts[0]);
            let y = parseInt(parts[1]);
            let dir = this._getDiggingDirection(x, y);
            if (!dir) continue;
             /* this wall is not suitable */ 
            //		console.log("wall", x, y);
            /* try adding a feature */ let featureAttempts = 0;
            do {
                featureAttempts++;
                if (this._tryFeature(x, y, dir[0], dir[1])) {
                    //if (this._rooms.length + this._corridors.length == 2) { this._rooms[0].addDoor(x, y); } /* first room oficially has doors */
                    this._removeSurroundingWalls(x, y);
                    this._removeSurroundingWalls(x - dir[0], y - dir[1]);
                    break;
                }
            }while (featureAttempts < this._featureAttempts);
            for(let id in this._walls)if (this._walls[id] > 1) priorityWalls++;
        }while (this._dug / area < this._options.dugPercentage || priorityWalls); /* fixme number of priority walls */ 
        this._addDoors();
        if (callback) {
            for(let i = 0; i < this._width; i++)for(let j = 0; j < this._height; j++)callback(i, j, this._map[i][j]);
        }
        this._walls = {};
        this._map = [];
        return this;
    }
    _digCallback(x, y, value) {
        if (value == 0 || value == 2) {
            this._map[x][y] = 0;
            this._dug++;
        } else this._walls[x + "," + y] = 1;
    }
    _isWallCallback(x, y) {
        if (x < 0 || y < 0 || x >= this._width || y >= this._height) return false;
        return this._map[x][y] == 1;
    }
    _canBeDugCallback(x, y) {
        if (x < 1 || y < 1 || x + 1 >= this._width || y + 1 >= this._height) return false;
        return this._map[x][y] == 1;
    }
    _priorityWallCallback(x, y) {
        this._walls[x + "," + y] = 2;
    }
    _firstRoom() {
        let cx = Math.floor(this._width / 2);
        let cy = Math.floor(this._height / 2);
        let room = (0, $94296ece9a6a8d0e$export$525628e68e798fb4).createRandomCenter(cx, cy, this._options);
        this._rooms.push(room);
        room.create(this._digCallback);
    }
    /**
     * Get a suitable wall
     */ _findWall() {
        let prio1 = [];
        let prio2 = [];
        for(let id in this._walls){
            let prio = this._walls[id];
            if (prio == 2) prio2.push(id);
            else prio1.push(id);
        }
        let arr = prio2.length ? prio2 : prio1;
        if (!arr.length) return null;
         /* no walls :/ */ 
        let id = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getItem(arr.sort()); // sort to make the order deterministic
        delete this._walls[id];
        return id;
    }
    /**
     * Tries adding a feature
     * @returns {bool} was this a successful try?
     */ _tryFeature(x, y, dx, dy) {
        let featureName = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getWeightedValue(this._features);
        let ctor = $4a7b23e4a65117fc$var$FEATURES[featureName];
        let feature = ctor.createRandomAt(x, y, dx, dy, this._options);
        if (!feature.isValid(this._isWallCallback, this._canBeDugCallback)) //		console.log("not valid");
        //		feature.debug();
        return false;
        feature.create(this._digCallback);
        //	feature.debug();
        if (feature instanceof (0, $94296ece9a6a8d0e$export$525628e68e798fb4)) this._rooms.push(feature);
        if (feature instanceof (0, $94296ece9a6a8d0e$export$9f2f205dded93c1a)) {
            feature.createPriorityWalls(this._priorityWallCallback);
            this._corridors.push(feature);
        }
        return true;
    }
    _removeSurroundingWalls(cx, cy) {
        let deltas = (0, $55a6f72eb77f658c$export$a2cefd738759134a)[4];
        for(let i = 0; i < deltas.length; i++){
            let delta = deltas[i];
            let x = cx + delta[0];
            let y = cy + delta[1];
            delete this._walls[x + "," + y];
            x = cx + 2 * delta[0];
            y = cy + 2 * delta[1];
            delete this._walls[x + "," + y];
        }
    }
    /**
     * Returns vector in "digging" direction, or false, if this does not exist (or is not unique)
     */ _getDiggingDirection(cx, cy) {
        if (cx <= 0 || cy <= 0 || cx >= this._width - 1 || cy >= this._height - 1) return null;
        let result = null;
        let deltas = (0, $55a6f72eb77f658c$export$a2cefd738759134a)[4];
        for(let i = 0; i < deltas.length; i++){
            let delta = deltas[i];
            let x = cx + delta[0];
            let y = cy + delta[1];
            if (!this._map[x][y]) {
                if (result) return null;
                result = delta;
            }
        }
        /* no empty neighbor */ if (!result) return null;
        return [
            -result[0],
            -result[1]
        ];
    }
    /**
     * Find empty spaces surrounding rooms, and apply doors.
     */ _addDoors() {
        let data = this._map;
        function isWallCallback(x, y) {
            return data[x][y] == 1;
        }
        for(let i = 0; i < this._rooms.length; i++){
            let room = this._rooms[i];
            room.clearDoors();
            room.addDoors(isWallCallback);
        }
    }
}




/**
 * Join lists with "i" and "i+1"
 */ function $5d1c0077210b6e07$var$addToList(i, L, R) {
    R[L[i + 1]] = R[i];
    L[R[i]] = L[i + 1];
    R[i] = i + 1;
    L[i + 1] = i;
}
/**
 * Remove "i" from its list
 */ function $5d1c0077210b6e07$var$removeFromList(i, L, R) {
    R[L[i]] = R[i];
    L[R[i]] = L[i];
    R[i] = i;
    L[i] = i;
}
class $5d1c0077210b6e07$export$2e2bcd8739ae039 extends (0, $df9181f833546cd2$export$2e2bcd8739ae039) {
    create(callback) {
        let map = this._fillMap(1);
        let w = Math.ceil((this._width - 2) / 2);
        let rand = 9 / 24;
        let L = [];
        let R = [];
        for(let i = 0; i < w; i++){
            L.push(i);
            R.push(i);
        }
        L.push(w - 1); /* fake stop-block at the right side */ 
        let j;
        for(j = 1; j + 3 < this._height; j += 2)/* one row */ for(let i = 0; i < w; i++){
            /* cell coords (will be always empty) */ let x = 2 * i + 1;
            let y = j;
            map[x][y] = 0;
            /* right connection */ if (i != L[i + 1] && (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniform() > rand) {
                $5d1c0077210b6e07$var$addToList(i, L, R);
                map[x + 1][y] = 0;
            }
            /* bottom connection */ if (i != L[i] && (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniform() > rand) /* remove connection */ $5d1c0077210b6e07$var$removeFromList(i, L, R);
            else /* create connection */ map[x][y + 1] = 0;
        }
        /* last row */ for(let i = 0; i < w; i++){
            /* cell coords (will be always empty) */ let x = 2 * i + 1;
            let y = j;
            map[x][y] = 0;
            /* right connection */ if (i != L[i + 1] && (i == L[i] || (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniform() > rand)) {
                /* dig right also if the cell is separated, so it gets connected to the rest of maze */ $5d1c0077210b6e07$var$addToList(i, L, R);
                map[x + 1][y] = 0;
            }
            $5d1c0077210b6e07$var$removeFromList(i, L, R);
        }
        for(let i = 0; i < this._width; i++)for(let j = 0; j < this._height; j++)callback(i, j, map[i][j]);
        return this;
    }
}




class $b0c12c1363ed87ca$export$2e2bcd8739ae039 extends (0, $df9181f833546cd2$export$2e2bcd8739ae039) {
    constructor(){
        super(...arguments);
        this._stack = [];
        this._map = [];
    }
    create(callback) {
        let w = this._width;
        let h = this._height;
        this._map = [];
        for(let i = 0; i < w; i++){
            this._map.push([]);
            for(let j = 0; j < h; j++){
                let border = i == 0 || j == 0 || i + 1 == w || j + 1 == h;
                this._map[i].push(border ? 1 : 0);
            }
        }
        this._stack = [
            [
                1,
                1,
                w - 2,
                h - 2
            ]
        ];
        this._process();
        for(let i = 0; i < w; i++)for(let j = 0; j < h; j++)callback(i, j, this._map[i][j]);
        this._map = [];
        return this;
    }
    _process() {
        while(this._stack.length){
            let room = this._stack.shift(); /* [left, top, right, bottom] */ 
            this._partitionRoom(room);
        }
    }
    _partitionRoom(room) {
        let availX = [];
        let availY = [];
        for(let i = room[0] + 1; i < room[2]; i++){
            let top = this._map[i][room[1] - 1];
            let bottom = this._map[i][room[3] + 1];
            if (top && bottom && !(i % 2)) availX.push(i);
        }
        for(let j = room[1] + 1; j < room[3]; j++){
            let left = this._map[room[0] - 1][j];
            let right = this._map[room[2] + 1][j];
            if (left && right && !(j % 2)) availY.push(j);
        }
        if (!availX.length || !availY.length) return;
        let x = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getItem(availX);
        let y = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getItem(availY);
        this._map[x][y] = 1;
        let walls = [];
        let w = [];
        walls.push(w); /* left part */ 
        for(let i = room[0]; i < x; i++){
            this._map[i][y] = 1;
            if (i % 2) w.push([
                i,
                y
            ]);
        }
        w = [];
        walls.push(w); /* right part */ 
        for(let i = x + 1; i <= room[2]; i++){
            this._map[i][y] = 1;
            if (i % 2) w.push([
                i,
                y
            ]);
        }
        w = [];
        walls.push(w); /* top part */ 
        for(let j = room[1]; j < y; j++){
            this._map[x][j] = 1;
            if (j % 2) w.push([
                x,
                j
            ]);
        }
        w = [];
        walls.push(w); /* bottom part */ 
        for(let j = y + 1; j <= room[3]; j++){
            this._map[x][j] = 1;
            if (j % 2) w.push([
                x,
                j
            ]);
        }
        let solid = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getItem(walls);
        for(let i = 0; i < walls.length; i++){
            let w = walls[i];
            if (w == solid) continue;
            let hole = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getItem(w);
            this._map[hole[0]][hole[1]] = 0;
        }
        this._stack.push([
            room[0],
            room[1],
            x - 1,
            y - 1
        ]); /* left top */ 
        this._stack.push([
            x + 1,
            room[1],
            room[2],
            y - 1
        ]); /* right top */ 
        this._stack.push([
            room[0],
            y + 1,
            x - 1,
            room[3]
        ]); /* left bottom */ 
        this._stack.push([
            x + 1,
            y + 1,
            room[2],
            room[3]
        ]); /* right bottom */ 
    }
}




class $0ae2066aecf8b59a$export$2e2bcd8739ae039 extends (0, $df9181f833546cd2$export$2e2bcd8739ae039) {
    constructor(width, height, regularity = 0){
        super(width, height);
        this._regularity = regularity;
        this._map = [];
    }
    create(callback) {
        let width = this._width;
        let height = this._height;
        let map = this._fillMap(1);
        width -= width % 2 ? 1 : 2;
        height -= height % 2 ? 1 : 2;
        let cx = 0;
        let cy = 0;
        let nx = 0;
        let ny = 0;
        let done = 0;
        let blocked = false;
        let dirs = [
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ]
        ];
        do {
            cx = 1 + 2 * Math.floor((0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniform() * (width - 1) / 2);
            cy = 1 + 2 * Math.floor((0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniform() * (height - 1) / 2);
            if (!done) map[cx][cy] = 0;
            if (!map[cx][cy]) {
                this._randomize(dirs);
                do {
                    if (Math.floor((0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniform() * (this._regularity + 1)) == 0) this._randomize(dirs);
                    blocked = true;
                    for(let i = 0; i < 4; i++){
                        nx = cx + dirs[i][0] * 2;
                        ny = cy + dirs[i][1] * 2;
                        if (this._isFree(map, nx, ny, width, height)) {
                            map[nx][ny] = 0;
                            map[cx + dirs[i][0]][cy + dirs[i][1]] = 0;
                            cx = nx;
                            cy = ny;
                            blocked = false;
                            done++;
                            break;
                        }
                    }
                }while (!blocked);
            }
        }while (done + 1 < width * height / 4);
        for(let i = 0; i < this._width; i++)for(let j = 0; j < this._height; j++)callback(i, j, map[i][j]);
        this._map = [];
        return this;
    }
    _randomize(dirs) {
        for(let i = 0; i < 4; i++){
            dirs[i][0] = 0;
            dirs[i][1] = 0;
        }
        switch(Math.floor((0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniform() * 4)){
            case 0:
                dirs[0][0] = -1;
                dirs[1][0] = 1;
                dirs[2][1] = -1;
                dirs[3][1] = 1;
                break;
            case 1:
                dirs[3][0] = -1;
                dirs[2][0] = 1;
                dirs[1][1] = -1;
                dirs[0][1] = 1;
                break;
            case 2:
                dirs[2][0] = -1;
                dirs[3][0] = 1;
                dirs[0][1] = -1;
                dirs[1][1] = 1;
                break;
            case 3:
                dirs[1][0] = -1;
                dirs[0][0] = 1;
                dirs[3][1] = -1;
                dirs[2][1] = 1;
                break;
        }
    }
    _isFree(map, x, y, width, height) {
        if (x < 1 || y < 1 || x >= width || y >= height) return false;
        return map[x][y];
    }
}





class $5d52422c6156ec44$export$2e2bcd8739ae039 extends (0, $df9181f833546cd2$export$2e2bcd8739ae039) {
    constructor(width, height, options){
        super(width, height);
        this.map = [];
        this.rooms = [];
        this.connectedCells = [];
        options = Object.assign({
            cellWidth: 3,
            cellHeight: 3 //     ie. as an array with min-max values for each direction....
        }, options);
        /*
        Set the room sizes according to the over-all width of the map,
        and the cell sizes.
        */ if (!options.hasOwnProperty("roomWidth")) options["roomWidth"] = this._calculateRoomSize(this._width, options["cellWidth"]);
        if (!options.hasOwnProperty("roomHeight")) options["roomHeight"] = this._calculateRoomSize(this._height, options["cellHeight"]);
        this._options = options;
    }
    create(callback) {
        this.map = this._fillMap(1);
        this.rooms = [];
        this.connectedCells = [];
        this._initRooms();
        this._connectRooms();
        this._connectUnconnectedRooms();
        this._createRandomRoomConnections();
        this._createRooms();
        this._createCorridors();
        if (callback) {
            for(let i = 0; i < this._width; i++)for(let j = 0; j < this._height; j++)callback(i, j, this.map[i][j]);
        }
        return this;
    }
    _calculateRoomSize(size, cell) {
        let max = Math.floor(size / cell * 0.8);
        let min = Math.floor(size / cell * 0.25);
        if (min < 2) min = 2;
        if (max < 2) max = 2;
        return [
            min,
            max
        ];
    }
    _initRooms() {
        // create rooms array. This is the "grid" list from the algo.
        for(let i = 0; i < this._options.cellWidth; i++){
            this.rooms.push([]);
            for(let j = 0; j < this._options.cellHeight; j++)this.rooms[i].push({
                "x": 0,
                "y": 0,
                "width": 0,
                "height": 0,
                "connections": [],
                "cellx": i,
                "celly": j
            });
        }
    }
    _connectRooms() {
        //pick random starting grid
        let cgx = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniformInt(0, this._options.cellWidth - 1);
        let cgy = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniformInt(0, this._options.cellHeight - 1);
        let idx;
        let ncgx;
        let ncgy;
        let found = false;
        let room;
        let otherRoom;
        let dirToCheck;
        // find  unconnected neighbour cells
        do {
            //dirToCheck = [0, 1, 2, 3, 4, 5, 6, 7];
            dirToCheck = [
                0,
                2,
                4,
                6
            ];
            dirToCheck = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).shuffle(dirToCheck);
            do {
                found = false;
                idx = dirToCheck.pop();
                ncgx = cgx + (0, $55a6f72eb77f658c$export$a2cefd738759134a)[8][idx][0];
                ncgy = cgy + (0, $55a6f72eb77f658c$export$a2cefd738759134a)[8][idx][1];
                if (ncgx < 0 || ncgx >= this._options.cellWidth) continue;
                if (ncgy < 0 || ncgy >= this._options.cellHeight) continue;
                room = this.rooms[cgx][cgy];
                if (room["connections"].length > 0) {
                    // as long as this room doesn't already coonect to me, we are ok with it.
                    if (room["connections"][0][0] == ncgx && room["connections"][0][1] == ncgy) break;
                }
                otherRoom = this.rooms[ncgx][ncgy];
                if (otherRoom["connections"].length == 0) {
                    otherRoom["connections"].push([
                        cgx,
                        cgy
                    ]);
                    this.connectedCells.push([
                        ncgx,
                        ncgy
                    ]);
                    cgx = ncgx;
                    cgy = ncgy;
                    found = true;
                }
            }while (dirToCheck.length > 0 && found == false);
        }while (dirToCheck.length > 0);
    }
    _connectUnconnectedRooms() {
        //While there are unconnected rooms, try to connect them to a random connected neighbor
        //(if a room has no connected neighbors yet, just keep cycling, you'll fill out to it eventually).
        let cw = this._options.cellWidth;
        let ch = this._options.cellHeight;
        this.connectedCells = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).shuffle(this.connectedCells);
        let room;
        let otherRoom;
        let validRoom;
        for(let i = 0; i < this._options.cellWidth; i++)for(let j = 0; j < this._options.cellHeight; j++){
            room = this.rooms[i][j];
            if (room["connections"].length == 0) {
                let directions = [
                    0,
                    2,
                    4,
                    6
                ];
                directions = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).shuffle(directions);
                validRoom = false;
                do {
                    let dirIdx = directions.pop();
                    let newI = i + (0, $55a6f72eb77f658c$export$a2cefd738759134a)[8][dirIdx][0];
                    let newJ = j + (0, $55a6f72eb77f658c$export$a2cefd738759134a)[8][dirIdx][1];
                    if (newI < 0 || newI >= cw || newJ < 0 || newJ >= ch) continue;
                    otherRoom = this.rooms[newI][newJ];
                    validRoom = true;
                    if (otherRoom["connections"].length == 0) break;
                    for(let k = 0; k < otherRoom["connections"].length; k++)if (otherRoom["connections"][k][0] == i && otherRoom["connections"][k][1] == j) {
                        validRoom = false;
                        break;
                    }
                    if (validRoom) break;
                }while (directions.length);
                if (validRoom) room["connections"].push([
                    otherRoom["cellx"],
                    otherRoom["celly"]
                ]);
                else console.log("-- Unable to connect room.");
            }
        }
    }
    _createRandomRoomConnections() {
    // Empty for now.
    }
    _createRooms() {
        let w = this._width;
        let h = this._height;
        let cw = this._options.cellWidth;
        let ch = this._options.cellHeight;
        let cwp = Math.floor(this._width / cw);
        let chp = Math.floor(this._height / ch);
        let roomw;
        let roomh;
        let roomWidth = this._options["roomWidth"];
        let roomHeight = this._options["roomHeight"];
        let sx;
        let sy;
        let otherRoom;
        for(let i = 0; i < cw; i++)for(let j = 0; j < ch; j++){
            sx = cwp * i;
            sy = chp * j;
            if (sx == 0) sx = 1;
            if (sy == 0) sy = 1;
            roomw = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniformInt(roomWidth[0], roomWidth[1]);
            roomh = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniformInt(roomHeight[0], roomHeight[1]);
            if (j > 0) {
                otherRoom = this.rooms[i][j - 1];
                while(sy - (otherRoom["y"] + otherRoom["height"]) < 3)sy++;
            }
            if (i > 0) {
                otherRoom = this.rooms[i - 1][j];
                while(sx - (otherRoom["x"] + otherRoom["width"]) < 3)sx++;
            }
            let sxOffset = Math.round((0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniformInt(0, cwp - roomw) / 2);
            let syOffset = Math.round((0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniformInt(0, chp - roomh) / 2);
            while(sx + sxOffset + roomw >= w)if (sxOffset) sxOffset--;
            else roomw--;
            while(sy + syOffset + roomh >= h)if (syOffset) syOffset--;
            else roomh--;
            sx = sx + sxOffset;
            sy = sy + syOffset;
            this.rooms[i][j]["x"] = sx;
            this.rooms[i][j]["y"] = sy;
            this.rooms[i][j]["width"] = roomw;
            this.rooms[i][j]["height"] = roomh;
            for(let ii = sx; ii < sx + roomw; ii++)for(let jj = sy; jj < sy + roomh; jj++)this.map[ii][jj] = 0;
        }
    }
    _getWallPosition(aRoom, aDirection) {
        let rx;
        let ry;
        let door;
        if (aDirection == 1 || aDirection == 3) {
            rx = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniformInt(aRoom["x"] + 1, aRoom["x"] + aRoom["width"] - 2);
            if (aDirection == 1) {
                ry = aRoom["y"] - 2;
                door = ry + 1;
            } else {
                ry = aRoom["y"] + aRoom["height"] + 1;
                door = ry - 1;
            }
            this.map[rx][door] = 0; // i'm not setting a specific 'door' tile value right now, just empty space.
        } else {
            ry = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniformInt(aRoom["y"] + 1, aRoom["y"] + aRoom["height"] - 2);
            if (aDirection == 2) {
                rx = aRoom["x"] + aRoom["width"] + 1;
                door = rx - 1;
            } else {
                rx = aRoom["x"] - 2;
                door = rx + 1;
            }
            this.map[door][ry] = 0; // i'm not setting a specific 'door' tile value right now, just empty space.
        }
        return [
            rx,
            ry
        ];
    }
    _drawCorridor(startPosition, endPosition) {
        let xOffset = endPosition[0] - startPosition[0];
        let yOffset = endPosition[1] - startPosition[1];
        let xpos = startPosition[0];
        let ypos = startPosition[1];
        let tempDist;
        let xDir;
        let yDir;
        let move; // 2 element array, element 0 is the direction, element 1 is the total value to move.
        let moves = []; // a list of 2 element arrays
        let xAbs = Math.abs(xOffset);
        let yAbs = Math.abs(yOffset);
        let percent = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniform(); // used to split the move at different places along the long axis
        let firstHalf = percent;
        let secondHalf = 1 - percent;
        xDir = xOffset > 0 ? 2 : 6;
        yDir = yOffset > 0 ? 4 : 0;
        if (xAbs < yAbs) {
            // move firstHalf of the y offset
            tempDist = Math.ceil(yAbs * firstHalf);
            moves.push([
                yDir,
                tempDist
            ]);
            // move all the x offset
            moves.push([
                xDir,
                xAbs
            ]);
            // move sendHalf of the  y offset
            tempDist = Math.floor(yAbs * secondHalf);
            moves.push([
                yDir,
                tempDist
            ]);
        } else {
            //  move firstHalf of the x offset
            tempDist = Math.ceil(xAbs * firstHalf);
            moves.push([
                xDir,
                tempDist
            ]);
            // move all the y offset
            moves.push([
                yDir,
                yAbs
            ]);
            // move secondHalf of the x offset.
            tempDist = Math.floor(xAbs * secondHalf);
            moves.push([
                xDir,
                tempDist
            ]);
        }
        this.map[xpos][ypos] = 0;
        while(moves.length > 0){
            move = moves.pop();
            while(move[1] > 0){
                xpos += (0, $55a6f72eb77f658c$export$a2cefd738759134a)[8][move[0]][0];
                ypos += (0, $55a6f72eb77f658c$export$a2cefd738759134a)[8][move[0]][1];
                this.map[xpos][ypos] = 0;
                move[1] = move[1] - 1;
            }
        }
    }
    _createCorridors() {
        // Draw Corridors between connected rooms
        let cw = this._options.cellWidth;
        let ch = this._options.cellHeight;
        let room;
        let connection;
        let otherRoom;
        let wall;
        let otherWall;
        for(let i = 0; i < cw; i++)for(let j = 0; j < ch; j++){
            room = this.rooms[i][j];
            for(let k = 0; k < room["connections"].length; k++){
                connection = room["connections"][k];
                otherRoom = this.rooms[connection[0]][connection[1]];
                // figure out what wall our corridor will start one.
                // figure out what wall our corridor will end on.
                if (otherRoom["cellx"] > room["cellx"]) {
                    wall = 2;
                    otherWall = 4;
                } else if (otherRoom["cellx"] < room["cellx"]) {
                    wall = 4;
                    otherWall = 2;
                } else if (otherRoom["celly"] > room["celly"]) {
                    wall = 3;
                    otherWall = 1;
                } else {
                    wall = 1;
                    otherWall = 3;
                }
                this._drawCorridor(this._getWallPosition(room, wall), this._getWallPosition(otherRoom, otherWall));
            }
        }
    }
}


var $df239f4fd3d66381$export$2e2bcd8739ae039 = {
    Arena: $b774f1bd0a75509d$export$2e2bcd8739ae039,
    Uniform: $cb051b1375226126$export$2e2bcd8739ae039,
    Cellular: $d36d4746484d411e$export$2e2bcd8739ae039,
    Digger: $4a7b23e4a65117fc$export$2e2bcd8739ae039,
    EllerMaze: $5d1c0077210b6e07$export$2e2bcd8739ae039,
    DividedMaze: $b0c12c1363ed87ca$export$2e2bcd8739ae039,
    IceyMaze: $0ae2066aecf8b59a$export$2e2bcd8739ae039,
    Rogue: $5d52422c6156ec44$export$2e2bcd8739ae039
};


/**
 * Base noise generator
 */ class $8c53f914f20d6847$export$2e2bcd8739ae039 {
}




const $c33a11e5a90fd838$var$F2 = 0.5 * (Math.sqrt(3) - 1);
const $c33a11e5a90fd838$var$G2 = (3 - Math.sqrt(3)) / 6;
class $c33a11e5a90fd838$export$2e2bcd8739ae039 extends (0, $8c53f914f20d6847$export$2e2bcd8739ae039) {
    /**
     * @param gradients Random gradients
     */ constructor(gradients = 256){
        super();
        this._gradients = [
            [
                0,
                -1
            ],
            [
                1,
                -1
            ],
            [
                1,
                0
            ],
            [
                1,
                1
            ],
            [
                0,
                1
            ],
            [
                -1,
                1
            ],
            [
                -1,
                0
            ],
            [
                -1,
                -1
            ]
        ];
        let permutations = [];
        for(let i = 0; i < gradients; i++)permutations.push(i);
        permutations = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).shuffle(permutations);
        this._perms = [];
        this._indexes = [];
        for(let i = 0; i < 2 * gradients; i++){
            this._perms.push(permutations[i % gradients]);
            this._indexes.push(this._perms[i] % this._gradients.length);
        }
    }
    get(xin, yin) {
        let perms = this._perms;
        let indexes = this._indexes;
        let count = perms.length / 2;
        let n0 = 0, n1 = 0, n2 = 0, gi; // Noise contributions from the three corners
        // Skew the input space to determine which simplex cell we're in
        let s = (xin + yin) * $c33a11e5a90fd838$var$F2; // Hairy factor for 2D
        let i = Math.floor(xin + s);
        let j = Math.floor(yin + s);
        let t = (i + j) * $c33a11e5a90fd838$var$G2;
        let X0 = i - t; // Unskew the cell origin back to (x,y) space
        let Y0 = j - t;
        let x0 = xin - X0; // The x,y distances from the cell origin
        let y0 = yin - Y0;
        // For the 2D case, the simplex shape is an equilateral triangle.
        // Determine which simplex we are in.
        let i1, j1; // Offsets for second (middle) corner of simplex in (i,j) coords
        if (x0 > y0) {
            i1 = 1;
            j1 = 0;
        } else {
            i1 = 0;
            j1 = 1;
        } // upper triangle, YX order: (0,0)->(0,1)->(1,1)
        // A step of (1,0) in (i,j) means a step of (1-c,-c) in (x,y), and
        // a step of (0,1) in (i,j) means a step of (-c,1-c) in (x,y), where
        // c = (3-sqrt(3))/6
        let x1 = x0 - i1 + $c33a11e5a90fd838$var$G2; // Offsets for middle corner in (x,y) unskewed coords
        let y1 = y0 - j1 + $c33a11e5a90fd838$var$G2;
        let x2 = x0 - 1 + 2 * $c33a11e5a90fd838$var$G2; // Offsets for last corner in (x,y) unskewed coords
        let y2 = y0 - 1 + 2 * $c33a11e5a90fd838$var$G2;
        // Work out the hashed gradient indices of the three simplex corners
        let ii = (0, $0901a3208c7d141c$export$842a2cf37af977e1)(i, count);
        let jj = (0, $0901a3208c7d141c$export$842a2cf37af977e1)(j, count);
        // Calculate the contribution from the three corners
        let t0 = 0.5 - x0 * x0 - y0 * y0;
        if (t0 >= 0) {
            t0 *= t0;
            gi = indexes[ii + perms[jj]];
            let grad = this._gradients[gi];
            n0 = t0 * t0 * (grad[0] * x0 + grad[1] * y0);
        }
        let t1 = 0.5 - x1 * x1 - y1 * y1;
        if (t1 >= 0) {
            t1 *= t1;
            gi = indexes[ii + i1 + perms[jj + j1]];
            let grad = this._gradients[gi];
            n1 = t1 * t1 * (grad[0] * x1 + grad[1] * y1);
        }
        let t2 = 0.5 - x2 * x2 - y2 * y2;
        if (t2 >= 0) {
            t2 *= t2;
            gi = indexes[ii + 1 + perms[jj + 1]];
            let grad = this._gradients[gi];
            n2 = t2 * t2 * (grad[0] * x2 + grad[1] * y2);
        }
        // Add contributions from each corner to get the final noise value.
        // The result is scaled to return values in the interval [-1,1].
        return 70 * (n0 + n1 + n2);
    }
}


var $9544581b78ebc8f6$export$2e2bcd8739ae039 = {
    Simplex: $c33a11e5a90fd838$export$2e2bcd8739ae039
};



class $78b6e6adffd02f95$export$2e2bcd8739ae039 {
    constructor(toX, toY, passableCallback, options = {}){
        this._toX = toX;
        this._toY = toY;
        this._passableCallback = passableCallback;
        this._options = Object.assign({
            topology: 8
        }, options);
        this._dirs = (0, $55a6f72eb77f658c$export$a2cefd738759134a)[this._options.topology];
        if (this._options.topology == 8) this._dirs = [
            this._dirs[0],
            this._dirs[2],
            this._dirs[4],
            this._dirs[6],
            this._dirs[1],
            this._dirs[3],
            this._dirs[5],
            this._dirs[7]
        ];
    }
    _getNeighbors(cx, cy) {
        let result = [];
        for(let i = 0; i < this._dirs.length; i++){
            let dir = this._dirs[i];
            let x = cx + dir[0];
            let y = cy + dir[1];
            if (!this._passableCallback(x, y)) continue;
            result.push([
                x,
                y
            ]);
        }
        return result;
    }
}


class $d6cdbd4ab2c570d3$export$2e2bcd8739ae039 extends (0, $78b6e6adffd02f95$export$2e2bcd8739ae039) {
    constructor(toX, toY, passableCallback, options){
        super(toX, toY, passableCallback, options);
        this._computed = {};
        this._todo = [];
        this._add(toX, toY, null);
    }
    /**
     * Compute a path from a given point
     * @see ROT.Path#compute
     */ compute(fromX, fromY, callback) {
        let key = fromX + "," + fromY;
        if (!(key in this._computed)) this._compute(fromX, fromY);
        if (!(key in this._computed)) return;
        let item = this._computed[key];
        while(item){
            callback(item.x, item.y);
            item = item.prev;
        }
    }
    /**
     * Compute a non-cached value
     */ _compute(fromX, fromY) {
        while(this._todo.length){
            let item = this._todo.shift();
            if (item.x == fromX && item.y == fromY) return;
            let neighbors = this._getNeighbors(item.x, item.y);
            for(let i = 0; i < neighbors.length; i++){
                let neighbor = neighbors[i];
                let x = neighbor[0];
                let y = neighbor[1];
                let id = x + "," + y;
                if (id in this._computed) continue;
                 /* already done */ 
                this._add(x, y, item);
            }
        }
    }
    _add(x, y, prev) {
        let obj = {
            x: x,
            y: y,
            prev: prev
        };
        this._computed[x + "," + y] = obj;
        this._todo.push(obj);
    }
}



class $e0b320c8672c3b81$export$2e2bcd8739ae039 extends (0, $78b6e6adffd02f95$export$2e2bcd8739ae039) {
    constructor(toX, toY, passableCallback, options = {}){
        super(toX, toY, passableCallback, options);
        this._todo = [];
        this._done = {};
    }
    /**
     * Compute a path from a given point
     * @see ROT.Path#compute
     */ compute(fromX, fromY, callback) {
        this._todo = [];
        this._done = {};
        this._fromX = fromX;
        this._fromY = fromY;
        this._add(this._toX, this._toY, null);
        while(this._todo.length){
            let item = this._todo.shift();
            let id = item.x + "," + item.y;
            if (id in this._done) continue;
            this._done[id] = item;
            if (item.x == fromX && item.y == fromY) break;
            let neighbors = this._getNeighbors(item.x, item.y);
            for(let i = 0; i < neighbors.length; i++){
                let neighbor = neighbors[i];
                let x = neighbor[0];
                let y = neighbor[1];
                let id = x + "," + y;
                if (id in this._done) continue;
                this._add(x, y, item);
            }
        }
        let item = this._done[fromX + "," + fromY];
        if (!item) return;
        while(item){
            callback(item.x, item.y);
            item = item.prev;
        }
    }
    _add(x, y, prev) {
        let h = this._distance(x, y);
        let obj = {
            x: x,
            y: y,
            prev: prev,
            g: prev ? prev.g + 1 : 0,
            h: h
        };
        /* insert into priority queue */ let f = obj.g + obj.h;
        for(let i = 0; i < this._todo.length; i++){
            let item = this._todo[i];
            let itemF = item.g + item.h;
            if (f < itemF || f == itemF && h < item.h) {
                this._todo.splice(i, 0, obj);
                return;
            }
        }
        this._todo.push(obj);
    }
    _distance(x, y) {
        switch(this._options.topology){
            case 4:
                return Math.abs(x - this._fromX) + Math.abs(y - this._fromY);
            case 6:
                let dx = Math.abs(x - this._fromX);
                let dy = Math.abs(y - this._fromY);
                return dy + Math.max(0, (dx - dy) / 2);
            case 8:
                return Math.max(Math.abs(x - this._fromX), Math.abs(y - this._fromY));
        }
    }
}


var $7a3802042b5f31ef$export$2e2bcd8739ae039 = {
    Dijkstra: $d6cdbd4ab2c570d3$export$2e2bcd8739ae039,
    AStar: $e0b320c8672c3b81$export$2e2bcd8739ae039
};


/**
 * @class Asynchronous main loop
 * @param {ROT.Scheduler} scheduler
 */ class $3a78b500a2aa4401$export$2e2bcd8739ae039 {
    constructor(scheduler){
        this._scheduler = scheduler;
        this._lock = 1;
    }
    /**
     * Start the main loop. When this call returns, the loop is locked.
     */ start() {
        return this.unlock();
    }
    /**
     * Interrupt the engine by an asynchronous action
     */ lock() {
        this._lock++;
        return this;
    }
    /**
     * Resume execution (paused by a previous lock)
     */ unlock() {
        if (!this._lock) throw new Error("Cannot unlock unlocked engine");
        this._lock--;
        while(!this._lock){
            let actor = this._scheduler.next();
            if (!actor) return this.lock();
             /* no actors */ 
            let result = actor.act();
            if (result && result.then) {
                this.lock();
                result.then(this.unlock.bind(this));
            }
        }
        return this;
    }
}



class $012ef90f5baafb7a$export$2e2bcd8739ae039 {
    constructor(reflectivityCallback, options = {}){
        this._reflectivityCallback = reflectivityCallback;
        this._options = {};
        options = Object.assign({
            passes: 1,
            emissionThreshold: 100,
            range: 10
        }, options);
        this._lights = {};
        this._reflectivityCache = {};
        this._fovCache = {};
        this.setOptions(options);
    }
    /**
     * Adjust options at runtime
     */ setOptions(options) {
        Object.assign(this._options, options);
        if (options && options.range) this.reset();
        return this;
    }
    /**
     * Set the used Field-Of-View algo
     */ setFOV(fov) {
        this._fov = fov;
        this._fovCache = {};
        return this;
    }
    /**
     * Set (or remove) a light source
     */ setLight(x, y, color) {
        let key = x + "," + y;
        if (color) this._lights[key] = typeof color == "string" ? $f4089545ec769444$export$3004f64547af360e(color) : color;
        else delete this._lights[key];
        return this;
    }
    /**
     * Remove all light sources
     */ clearLights() {
        this._lights = {};
    }
    /**
     * Reset the pre-computed topology values. Call whenever the underlying map changes its light-passability.
     */ reset() {
        this._reflectivityCache = {};
        this._fovCache = {};
        return this;
    }
    /**
     * Compute the lighting
     */ compute(lightingCallback) {
        let doneCells = {};
        let emittingCells = {};
        let litCells = {};
        for(let key in this._lights){
            let light = this._lights[key];
            emittingCells[key] = [
                0,
                0,
                0
            ];
            $f4089545ec769444$export$bc24ee9de1357795(emittingCells[key], light);
        }
        for(let i = 0; i < this._options.passes; i++){
            this._emitLight(emittingCells, litCells, doneCells);
            if (i + 1 == this._options.passes) continue;
             /* not for the last pass */ 
            emittingCells = this._computeEmitters(litCells, doneCells);
        }
        for(let litKey in litCells){
            let parts = litKey.split(",");
            let x = parseInt(parts[0]);
            let y = parseInt(parts[1]);
            lightingCallback(x, y, litCells[litKey]);
        }
        return this;
    }
    /**
     * Compute one iteration from all emitting cells
     * @param emittingCells These emit light
     * @param litCells Add projected light to these
     * @param doneCells These already emitted, forbid them from further calculations
     */ _emitLight(emittingCells, litCells, doneCells) {
        for(let key in emittingCells){
            let parts = key.split(",");
            let x = parseInt(parts[0]);
            let y = parseInt(parts[1]);
            this._emitLightFromCell(x, y, emittingCells[key], litCells);
            doneCells[key] = 1;
        }
        return this;
    }
    /**
     * Prepare a list of emitters for next pass
     */ _computeEmitters(litCells, doneCells) {
        let result = {};
        for(let key in litCells){
            if (key in doneCells) continue;
             /* already emitted */ 
            let color = litCells[key];
            let reflectivity;
            if (key in this._reflectivityCache) reflectivity = this._reflectivityCache[key];
            else {
                let parts = key.split(",");
                let x = parseInt(parts[0]);
                let y = parseInt(parts[1]);
                reflectivity = this._reflectivityCallback(x, y);
                this._reflectivityCache[key] = reflectivity;
            }
            if (reflectivity == 0) continue;
             /* will not reflect at all */ 
            /* compute emission color */ let emission = [
                0,
                0,
                0
            ];
            let intensity = 0;
            for(let i = 0; i < 3; i++){
                let part = Math.round(color[i] * reflectivity);
                emission[i] = part;
                intensity += part;
            }
            if (intensity > this._options.emissionThreshold) result[key] = emission;
        }
        return result;
    }
    /**
     * Compute one iteration from one cell
     */ _emitLightFromCell(x, y, color, litCells) {
        let key = x + "," + y;
        let fov;
        if (key in this._fovCache) fov = this._fovCache[key];
        else fov = this._updateFOV(x, y);
        for(let fovKey in fov){
            let formFactor = fov[fovKey];
            let result;
            if (fovKey in litCells) result = litCells[fovKey];
            else {
                result = [
                    0,
                    0,
                    0
                ];
                litCells[fovKey] = result;
            }
            for(let i = 0; i < 3; i++)result[i] += Math.round(color[i] * formFactor);
             /* add light color */ 
        }
        return this;
    }
    /**
     * Compute FOV ("form factor") for a potential light source at [x,y]
     */ _updateFOV(x, y) {
        let key1 = x + "," + y;
        let cache = {};
        this._fovCache[key1] = cache;
        let range = this._options.range;
        function cb(x, y, r, vis) {
            let key2 = x + "," + y;
            let formFactor = vis * (1 - r / range);
            if (formFactor == 0) return;
            cache[key2] = formFactor;
        }
        this._fov.compute(x, y, range, cb.bind(this));
        return cache;
    }
}






const $d8723fe0d23f9e05$export$f8f26dd395d7e1bd = $0901a3208c7d141c$exports;
const $d8723fe0d23f9e05$export$892596cec99bc70e = $f4089545ec769444$exports;
const $d8723fe0d23f9e05$export$5f1af8db9871e1d6 = $6af2e28c2767fdb6$exports;



const $248954e6cbd64b56$var$hex2rgb = (hex)=>{
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return {
        r: r,
        g: g,
        b: b,
        a: 1
    };
};
const $248954e6cbd64b56$export$892596cec99bc70e = {
    BLACK: "#000",
    DARK_GRAY: "#a9a9a9",
    STATS_BG: "#a9a9a9",
    CLOCK: "#fff",
    CASE_LIGHT: "#c97222",
    CASE_DARK: "#b87333",
    LIBRARY_BG: "#000",
    TRIGGER_LIGHT: "#000000",
    TRIGGER_DARK: "#696969",
    TAPESTRY_LIGHT: "#ffc60a",
    TAPESTRY_DARK: "#997706",
    HINT_LIGHT: "#000000",
    HINT_DARK: "#696969",
    HINT_CONTENTS: "#fff",
    HINT_DATE: "#0ff",
    COLLECTIBLE_COMMON: "#2e5984",
    COLLECTIBLE_COMMON_DARK: "#1e3f66",
    COLLECTIBLE_MYTHIC: "#2e5984",
    COLLECTIBLE_MYTHIC_DARK: "#1e3f66",
    FLOOR_TILE_BG: "#a38c6c",
    FLOOR_TILE_FG: "#ffffff",
    FLOOR_TILE_DARK_BG: "#877254",
    FLOOR_TILE_DARK_FG: "#ffffff",
    WALL_TILE_BG: "#4b3f2f",
    WALL_TILE_FG: "#ffffff",
    WALL_TILE_DARK_BG: "#2d261c",
    WALL_TILE_DARK_FG: "#ffffff",
    DANGER_TILE: "#ffbaba",
    DANGER_TILE_DARK: "#ff7b7b",
    HILITE_TILE_FG: "#ffffff",
    HILITE_TILE_BG: "#00edff",
    HILITE_TILE_DARK_FG: "#ffffff",
    HILITE_TILE_DARK_BG: "#00a6b3",
    ANY: "#ffa500",
    ANY_DARK: "#4d004c",
    ARMAMENT: "#00ffff",
    ARMAMENT_DARK: "#008b8b",
    GIZMO: "#0ff",
    GIZMO_DARK: "",
    WEARABLE: "",
    WEARABLE_DARK: "",
    KEY: "#000000",
    KEY_DARK: "#696969",
    ELIXIR: "#a741d7",
    ELIXIR_DARK: "#4f1669",
    BINDER: "#686868",
    BINDER_DARK: "#888888",
    OPTIC_YELLOW: "#ffff00",
    OPTIC_YELLOW_DARK: "#4d004c",
    OPTIC_RED: "#ff0000",
    OPTIC_RED_DARK: "#4d0000",
    OPTIC_MAGENTA: "#ff00ff",
    OPTIC_MAGENTA_DARK: "#4d004c",
    OPTIC_BLUE: "#0000ff",
    OPTIC_BLUE_DARK: "#00004d",
    OPTIC_CYAN: "#00ffffff",
    OPTIC_CYAN_DARK: "#004c4d",
    OPTIC_GREEN: "#00ff00",
    OPTIC_GREEN_DARK: "#004d00",
    OPTIC_WHITE: "#ffffff",
    OPTIC_WHITE_DARK: "#bfbfbf",
    OPTIC_BLACK: "#000000",
    OPTIC_BLACK_DARK: "#000000",
    DEVOURER: "#cc99a2",
    DEVOURER_DARK: "#997379",
    RIFT_ESSENCE: "#fb1e82",
    RIFT_ESSENCE_DARK: "#67556e",
    RIFT_PIGMENT: "#005b96",
    RIFT_PIGMENT_DARK: "#011f4b",
    RIFT_BOTH: "#246529",
    RIFT_BOTH_DARK: "#67556e",
    VOID_ESSENCE: "#fb1e82",
    VOID_ESSENCE_DARK: "#67556e",
    VOID_PIGMENT: "#005b96",
    VOID_PIGMENT_DARK: "#011f4b",
    VOID_BOTH: "#246529",
    VOID_BOTH_DARK: "#134314",
    BLADE_ESSENCE: "#fb1e82",
    BLADE_ESSENCE_DARK: "#67556e",
    BLADE_PIGMENT: "#005b96",
    BLADE_PIGMENT_DARK: "#011f4b",
    BLADE_BOTH: "#246529",
    BLADE_BOTH_DARK: "#134314",
    SPECTRE_ESSENCE: "#fb1e82",
    SPECTRE_ESSENCE_DARK: "#67556e",
    SPECTRE_PIGMENT: "#005b96",
    SPECTRE_PIGMENT_DARK: "#011f4b",
    SPECTRE_BOTH: "#246529",
    SPECTRE_BOTH_DARK: "#134314",
    REAVER_ESSENCE: "#fb1e82",
    REAVER_ESSENCE_DARK: "#67556e",
    REAVER_PIGMENT: "#005b96",
    REAVER_PIGMENT_DARK: "#011f4b",
    REAVER_BOTH: "#246529",
    REAVER_BOTH_DARK: "#134314",
    RESIDUE: "#400101",
    RESIDUE_DARK: "#2d0101",
    MESSAGE_ANY_FG: "#ffffff",
    MESSAGE_ITEM_FG: "#00ff00",
    MESSAGE_ITEM_BG: "#000000",
    PIGMENT_LIGHT_YELLOW: "#ffed00",
    PIGMENT_DARK_YELLOW: "#b3a600",
    PIGMENT_LIGHT_RED: "#ff0000",
    PIGMENT_DARK_RED: "#b30000",
    PIGMENT_LIGHT_MAGENTA: "#ff00ab",
    PIGMENT_DARK_MAGENTA: "#b30078",
    PIGMENT_LIGHT_BLUE: "#0047ab",
    PIGMENT_DARK_BLUE: "#003580",
    PIGMENT_LIGHT_CYAN: "#00edff",
    PIGMENT_DARK_CYAN: "#00a6b3",
    PIGMENT_LIGHT_GREEN: "#00b500",
    PIGMENT_DARK_GREEN: "#008000",
    PIGMENT_LIGHT_WHITE: "#ffffff",
    PIGMENT_DARK_WHITE: "#a6a6a6",
    PIGMENT_LIGHT_BLACK: "#000000",
    PIGMENT_DARK_BLACK: "#262626",
    PLAYER_NORMAL: "#ffffff",
    PORTAL_FG: "#00ffff",
    PORTAL_DARK_FG: "#a6a6a6",
    LOCKED_DOOR: "#ff0000",
    LOCKED_DOOR_DARK: "#990000",
    UNLOCKED_DOOR: "#00ff00",
    UNLOCKED_DOOR_DARK: "#009900"
};
// TODO: just YELLOW, RED, etc.
const $248954e6cbd64b56$export$b278fa1959b09b13 = {
    YELLOW: {
        r: 255,
        g: 255,
        b: 118
    },
    RED: {
        r: 255,
        g: 0,
        b: 0
    },
    MAGENTA: {
        r: 255,
        g: 0,
        b: 255
    },
    BLUE: {
        r: 0,
        g: 0,
        b: 255
    },
    CYAN: {
        r: 0,
        g: 255,
        b: 255
    },
    GREEN: {
        r: 0,
        g: 255,
        b: 0
    },
    WHITE: {
        r: 255,
        g: 255,
        b: 255
    },
    BLACK: {
        r: 0,
        g: 0,
        b: 0
    },
    GRAY: {
        r: 85,
        g: 85,
        b: 85
    },
    MESSAGE_GOOD: {
        r: 0,
        g: 255,
        b: 0
    },
    MESSAGE_INFO: {
        r: 255,
        g: 255,
        b: 255
    },
    MESSAGE_WARNING: {
        r: 255,
        g: 255,
        b: 118
    },
    MESSAGE_ERROR: {
        r: 255,
        g: 0,
        b: 0
    },
    TAPESTRY_BACKGROUND: $248954e6cbd64b56$var$hex2rgb($248954e6cbd64b56$export$892596cec99bc70e.FLOOR_TILE_BG),
    TAPESTRY_BORDER: $248954e6cbd64b56$var$hex2rgb($248954e6cbd64b56$export$892596cec99bc70e.WALL_TILE_BG),
    TAPESTRY_NOTHING: {
        r: 0,
        g: 0,
        b: 0,
        a: 1
    }
};
function $248954e6cbd64b56$export$39034d5acc75bbc1(r = 0, g = 0, b = 0, y = 0, m = 0, c = 0) {
    return {
        red: r,
        green: g,
        blue: b,
        yellow: y,
        magenta: m,
        cyan: c
    };
}




const $4df2accce7c7f382$var$MOVE_KEYS = {
    "1": (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).TOGGLE_FOW,
    "2": (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).ADD_XP,
    "3": (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).ADD_ELIXIR,
    "4": (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).UNLOCK_ALL_ITEMS,
    "9": (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).COMPLETE_TAPESTRY,
    "0": (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).DELETE_LOCALSTORAGE,
    H: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).GO_HOME,
    h: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).GO_HOME,
    " ": (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).CYCLE_OPTIC,
    Escape: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).CLOSE_POPUP,
    ArrowUp: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_UP,
    W: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_UP,
    w: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_UP,
    ArrowLeft: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_LEFT,
    A: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_LEFT,
    a: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_LEFT,
    ArrowDown: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_DOWN,
    S: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_DOWN,
    s: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_DOWN,
    ArrowRight: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_RIGHT,
    d: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_RIGHT,
    D: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_RIGHT,
    I: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).INTERACT,
    i: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).INTERACT,
    X: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).USE_ELIXIR,
    x: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).USE_ELIXIR,
    G: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).USE_GIZMO,
    g: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).USE_GIZMO,
    b: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).BIND_PIGMENT,
    B: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).BIND_PIGMENT,
    L: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).VIEW_LOADOUT,
    l: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).VIEW_LOADOUT,
    y: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).CONFIRM_YES,
    Y: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).CONFIRM_YES,
    n: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).CONFIRM_NO,
    N: (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).CONFIRM_NO
};
function $4df2accce7c7f382$export$412508d679148d5c(event) {
    if (event.key in $4df2accce7c7f382$var$MOVE_KEYS) return $4df2accce7c7f382$var$MOVE_KEYS[event.key];
    return (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).NONE;
}
function $4df2accce7c7f382$export$c5d7be0b11a66073(action) {
    return action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_LEFT || action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_RIGHT || action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_UP || action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_DOWN || action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).ROTATE_COUNTER_CLOCKWISE || action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).ROTATE_CLOCKWISE;
}
function $4df2accce7c7f382$export$8e0c55aa7806ac08(action) {
    return action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).TOGGLE_FOW || action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).ADD_XP || action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).ADD_ELIXIR || action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).UNLOCK_ALL_ITEMS || action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).COMPLETE_TAPESTRY || action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).DELETE_LOCALSTORAGE;
}




const $eb9de8f5086455e8$export$3e25e887b7a5b37b = {
    DEVOURER: "&",
    BLADE_1: "/",
    BLADE_2: "\\",
    REAVER_1: "{",
    REAVER_2: "}",
    RIFT_1: "-",
    RIFT_2: "~",
    SPECTRE_1: "(",
    SPECTRE_2: ")",
    VOID_HORZ_1: "<",
    VOID_HORZ_2: ">",
    VOID_VERT_1: "^",
    VOID_VERT_2: "v",
    RESIDUE: "_",
    TAPESTRY: "1",
    ARCHIVE: "2",
    BESTIARY: "3",
    WARDROBE: "4",
    ARSENAL: "5",
    GIZMOS: "6",
    COMMON_FINDS: "7",
    MYTHIC_FINDS: "8",
    BLANK: " ",
    ARMAMENT: "e",
    BINDER: "b",
    HINT: "h",
    COLLECTIBLE_COMMON: "c",
    COLLECTIBLE_MYTHIC: "C",
    GIZMO: "g",
    ITEM: "i",
    KEY: "k",
    OPTIC: "o",
    PLAYER: "@",
    PIGMENT: "p",
    PIGMENT_DROP: "P",
    PORTAL: "O",
    ELIXIR: "x",
    UNKNOWN: "?",
    WEARABLE: "e",
    LOCKED_DOOR: "x",
    ERROR_1: "\xe3",
    ERROR_2: "\xe4"
};


const $1a153cf88c479932$export$1c787534cb11aa3e = {
    MAX_ENEMY_DAMAGE: 1000
};
const $1a153cf88c479932$export$1986a3279c8087ed = {
    KEY_PLAYER: "tapestry_player",
    KEY_TAPESTRY: "tapestry_tapestry"
};
const $1a153cf88c479932$export$62d95f0373aed4f6 = {
    FOV: 5,
    ITEM_DROP_PROB: 0.25,
    ESSENCE_DROP_MIN: 1,
    ESSENCE_DROP_MAX: 3,
    PIGMENT_DROP_MIN: 1,
    PIGMENT_DROP_MAX: 5,
    MIN_FOV_RANGE: 10,
    MAX_FOV_RANGE: 14
};
const $1a153cf88c479932$export$cc91196ccdb51fef = {
    DISPLAY_OFFSETS: {
        xOffset: 1,
        yOffset: 0
    },
    UPDATE_FREQ: 500,
    WIDTH: 80,
    MESSAGES_HEIGHT: 5,
    GAME_HEIGHT: 30,
    STATS_HEIGHT: 5,
    TROPHY_CASE_WIDTH: 78,
    TROPHY_CASE_HEIGHT: 30
};
const $1a153cf88c479932$export$9d673184e63711e0 = {
    MAX_RANDOM_ITEM_PLACEMENT_TRIES: 100,
    ELIXIR_HEAL: 1
};
const $1a153cf88c479932$export$ba8e7803d5f50f58 = {
    COMMON: 0.2,
    MYTHIC: 0.025
};
const $1a153cf88c479932$export$19cee937b4034054 = {
    CORRIDOR_LENGTH: 6
};
const $1a153cf88c479932$export$88f18ddea8961844 = [
    (0, $f0b5fa422dff3899$export$b1b64d948644442b).RED,
    (0, $f0b5fa422dff3899$export$b1b64d948644442b).BLUE,
    (0, $f0b5fa422dff3899$export$b1b64d948644442b).GREEN,
    (0, $f0b5fa422dff3899$export$b1b64d948644442b).YELLOW,
    (0, $f0b5fa422dff3899$export$b1b64d948644442b).MAGENTA,
    (0, $f0b5fa422dff3899$export$b1b64d948644442b).CYAN
];
const $1a153cf88c479932$export$f78a7bc9efcc5615 = {
    NONE: {
        type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).NONE,
        name: "NONE",
        equipped: false,
        twoHanded: false,
        minEssenceAttack: 0,
        maxEssenceAttack: 0,
        essenceDefense: 0,
        minPigmentAttack: 0,
        maxPigmentAttack: 0,
        pigmentDefense: 0,
        stealthRange: 0
    },
    HEAD: {
        HEAD_NONE: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD_NONE,
            name: "none",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 0,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 0,
            stealthRange: 0
        },
        HEAD1: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD1,
            name: "Trader Cloth Hat",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 0,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 3,
            stealthRange: 2
        },
        HEAD2: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD2,
            name: "Trader Leather Hat",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 1,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 2,
            stealthRange: 1
        },
        HEAD3: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD3,
            name: "Explorer Cloth Hood",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 2,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 0,
            stealthRange: 0
        },
        HEAD4: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD4,
            name: "Explorer Leather Hood",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 2,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 1,
            stealthRange: 0
        },
        HEAD5: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD5,
            name: "Mender Cap",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 0,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 4,
            stealthRange: 0
        },
        HEAD6: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD6,
            name: "Mender Curing Cap",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 1,
            maxEssenceAttack: 1,
            essenceDefense: 2,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 4,
            stealthRange: 0
        },
        HEAD7: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD7,
            name: "Reviver Fez",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 1,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 3,
            stealthRange: 2
        },
        HEAD8: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD8,
            name: "Fez of Finality",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 1,
            maxEssenceAttack: 1,
            essenceDefense: 1,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 4,
            stealthRange: 3
        }
    },
    TORSO: {
        TORSO_NONE: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO_NONE,
            name: "none",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 0,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 0,
            stealthRange: 0
        },
        TORSO1: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO1,
            name: "Trader Cloth Robe",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 2,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 0,
            stealthRange: 2
        },
        TORSO2: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO2,
            name: "Trader Leather Vest",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 3,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 1,
            stealthRange: 2
        },
        TORSO3: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO3,
            name: "Explorer Cloth Cloak",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 4,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 0,
            stealthRange: 0
        },
        TORSO4: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO4,
            name: "Explorer Leather Cloak",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 5,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 0,
            stealthRange: -1
        },
        TORSO5: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO5,
            name: "Mender Robe",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 3,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 3,
            stealthRange: 0
        },
        TORSO6: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO6,
            name: "Mender Repair Robe",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 1,
            maxEssenceAttack: 1,
            essenceDefense: 3,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 3,
            stealthRange: 2
        },
        TORSO7: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO7,
            name: "Reviver Tunic",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 4,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 3,
            stealthRange: 4
        },
        TORSO8: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO8,
            name: "Tunic of Terminus",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 1,
            maxEssenceAttack: 1,
            essenceDefense: 4,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 2,
            stealthRange: 5
        }
    },
    FEET: {
        FEET_NONE: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET_NONE,
            name: "none",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 0,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 0,
            stealthRange: 0
        },
        FEET1: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET1,
            name: "Trader Sandals",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 0,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 0,
            stealthRange: 5
        },
        FEET2: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET2,
            name: "Trader Cloth Slippers",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 0,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 0,
            stealthRange: 6
        },
        FEET3: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET3,
            name: "Explorer Moccasins",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 1,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 0,
            stealthRange: 0
        },
        FEET4: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET4,
            name: "Explorer Chukkas",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 2,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 2,
            stealthRange: -2
        },
        FEET5: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET5,
            name: "Mender Boots",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 0,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 2,
            stealthRange: 3
        },
        FEET6: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET6,
            name: "Mender Better Boots",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 1,
            maxEssenceAttack: 1,
            essenceDefense: 1,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 2,
            stealthRange: 4
        },
        FEET7: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET7,
            name: "Reviver Clogs",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 3,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 2,
            stealthRange: 1
        },
        FEET8: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET8,
            name: "Clogs of Conclusion",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 1,
            maxEssenceAttack: 1,
            essenceDefense: 3,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 2,
            stealthRange: 1
        }
    },
    GIZMO: {
        GIZMO_NONE: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO_NONE,
            name: "none",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 0,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 0,
            stealthRange: 0
        },
        GIZMO1: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO1,
            name: "Escape Rope",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 0,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 0,
            stealthRange: 0
        },
        GIZMO2: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO2,
            name: "Map Scanner",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 0,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 0,
            stealthRange: 0
        },
        GIZMO3: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO3,
            name: "Polychrome Optic",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 0,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 0,
            stealthRange: 0
        },
        GIZMO4: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO4,
            name: "Ring of Invincibility",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 0,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 0,
            stealthRange: 0
        },
        GIZMO5: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO5,
            name: "Anti-theft Charm",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 0,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 0,
            stealthRange: 0
        }
    },
    WEAPON: {
        WEAPON_NONE: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON_NONE,
            name: "none",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 0,
            maxEssenceAttack: 0,
            essenceDefense: 0,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 0,
            stealthRange: 0
        },
        WEAPON1: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON1,
            name: "Knife",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 1,
            maxEssenceAttack: 1,
            essenceDefense: 0,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 0,
            stealthRange: 0
        },
        WEAPON2: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON2,
            name: "Dagger",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 1,
            maxEssenceAttack: 2,
            essenceDefense: 0,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 0,
            stealthRange: 0
        },
        WEAPON3: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON3,
            name: "Scimitar",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 2,
            maxEssenceAttack: 4,
            essenceDefense: 0,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 0,
            stealthRange: 0
        },
        WEAPON4: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON4,
            name: "Rapier",
            equipped: false,
            twoHanded: false,
            minEssenceAttack: 2,
            maxEssenceAttack: 6,
            essenceDefense: 0,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 0,
            stealthRange: 0
        },
        WEAPON5: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON5,
            name: "Spear",
            equipped: false,
            twoHanded: true,
            minEssenceAttack: 4,
            maxEssenceAttack: 6,
            essenceDefense: 0,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 0,
            stealthRange: 0
        },
        WEAPON6: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON6,
            name: "Glaive",
            equipped: false,
            twoHanded: true,
            minEssenceAttack: 4,
            maxEssenceAttack: 8,
            essenceDefense: 0,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 0,
            stealthRange: 0
        },
        WEAPON7: {
            type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON7,
            name: "Great Axe",
            equipped: false,
            twoHanded: true,
            minEssenceAttack: 6,
            maxEssenceAttack: 10,
            essenceDefense: 0,
            minPigmentAttack: 0,
            maxPigmentAttack: 0,
            pigmentDefense: 0,
            stealthRange: 0
        }
    }
};
const $1a153cf88c479932$export$2e8fd7f1bc5e2154 = {
    GIZMO3: {
        // Polychrome Optic
        ACTIVE: 500,
        COOLDOWN: 15000
    },
    GIZMO4: {
        // Ring of Invincibility
        ACTIVE: 1000,
        COOLDOWN: 8000
    },
    GIZMO5: {
        ACTIVE: 1000,
        COOLDOWN: 3000
    }
};
const $1a153cf88c479932$export$29ad37babd04e544 = {
    MUSIC: {
        source: "01 Tapestry.ogg",
        title: "Tapestry [needs title]"
    },
    PIGMENT_PER_BIND: 40,
    TILES_PER_BIND: 5,
    PIGMENT_BUMP: 1.0,
    BLINK_GROUPS: 2,
    BLINK_SYMBOL: "*",
    BLINK_COLORS: [
        (0, $248954e6cbd64b56$export$b278fa1959b09b13).WHITE,
        (0, $248954e6cbd64b56$export$b278fa1959b09b13).RED,
        (0, $248954e6cbd64b56$export$b278fa1959b09b13).BLUE,
        (0, $248954e6cbd64b56$export$b278fa1959b09b13).GREEN,
        (0, $248954e6cbd64b56$export$b278fa1959b09b13).YELLOW,
        (0, $248954e6cbd64b56$export$b278fa1959b09b13).MAGENTA,
        (0, $248954e6cbd64b56$export$b278fa1959b09b13).CYAN
    ]
};
const $1a153cf88c479932$export$82c0c1b9df90530f = 5;
const $1a153cf88c479932$export$4906643e6c3605fc = {
    MAX_STAT: 10,
    MAX_ELIXIRS: 10,
    MAX_ESSENCE: 100,
    MAX_LEVEL: 10,
    MAX_PIGMENT: 100,
    MAX_PIGMENT_CHARS: 3,
    MAX_BINDER_CHARS: 3,
    STEALTH_MODIFIER: 0.8,
    ELIXIR_HEALING: 3,
    YELLOW_THRESHHOLD: 100,
    MAGENTA_THRESHHOLD: 100,
    RED_THRESHHOLD: 100,
    BLUE_THRESHHOLD: 100,
    CYAN_THRESHHOLD: 100,
    GREEN_THRESHHOLD: 100,
    COMBAT: {
        LEVEL1: {
            essence: 15,
            maxEssence: 15,
            essenceDefense: 0,
            pigmentDefense: 0,
            stealthRange: 0,
            minAttack: 1,
            maxAttack: 1,
            attackType: (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_ESSENCE,
            attackMessage: "drain essence"
        },
        LEVEL2: {
            essence: 17,
            maxEssence: 17,
            essenceDefense: 0,
            pigmentDefense: 0,
            stealthRange: 0,
            minAttack: 1,
            maxAttack: 1,
            attackType: (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_ESSENCE,
            attackMessage: "drain essence"
        },
        LEVEL3: {
            essence: 18,
            maxEssence: 18,
            essenceDefense: 0,
            pigmentDefense: 0,
            stealthRange: 0,
            minAttack: 1,
            maxAttack: 1,
            attackType: (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_ESSENCE,
            attackMessage: "drain essence"
        },
        LEVEL4: {
            essence: 20,
            maxEssence: 20,
            essenceDefense: 0,
            pigmentDefense: 0,
            stealthRange: 0,
            minAttack: 1,
            maxAttack: 2,
            attackType: (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_ESSENCE,
            attackMessage: "drain essence"
        },
        LEVEL5: {
            essence: 22,
            maxEssence: 22,
            essenceDefense: 0,
            pigmentDefense: 0,
            stealthRange: 0,
            minAttack: 2,
            maxAttack: 2,
            attackType: (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_ESSENCE,
            attackMessage: "drain essence"
        },
        LEVEL6: {
            essence: 24,
            maxEssence: 24,
            essenceDefense: 0,
            pigmentDefense: 0,
            stealthRange: 0,
            minAttack: 2,
            maxAttack: 2,
            attackType: (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_ESSENCE,
            attackMessage: "drain essence"
        },
        LEVEL7: {
            essence: 25,
            maxEssence: 25,
            essenceDefense: 0,
            pigmentDefense: 0,
            stealthRange: 0,
            minAttack: 2,
            maxAttack: 3,
            attackType: (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_ESSENCE,
            attackMessage: "drain essence"
        },
        LEVEL8: {
            essence: 27,
            maxEssence: 27,
            essenceDefense: 0,
            pigmentDefense: 0,
            stealthRange: 0,
            minAttack: 2,
            maxAttack: 4,
            attackType: (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_ESSENCE,
            attackMessage: "drain essence"
        },
        LEVEL9: {
            essence: 29,
            maxEssence: 29,
            essenceDefense: 0,
            pigmentDefense: 0,
            stealthRange: 0,
            minAttack: 2,
            maxAttack: 4,
            attackType: (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_ESSENCE,
            attackMessage: "drain essence"
        },
        LEVEL10: {
            essence: 30,
            maxEssence: 30,
            essenceDefense: 0,
            pigmentDefense: 0,
            stealthRange: 0,
            minAttack: 3,
            maxAttack: 5,
            attackType: (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_ESSENCE,
            attackMessage: "drain essence"
        }
    },
    EXP_LEVEL2: 300,
    EXP_LEVEL3: 750,
    EXP_LEVEL4: 1425,
    EXP_LEVEL5: 2450,
    EXP_LEVEL6: 4000,
    EXP_LEVEL7: 6250,
    EXP_LEVEL8: 9700,
    EXP_LEVEL9: 15000,
    EXP_LEVEL10: 22500,
    RENDER: {
        symbol: [
            (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).PLAYER
        ],
        light: (0, $248954e6cbd64b56$export$892596cec99bc70e).PLAYER_NORMAL,
        dark: (0, $248954e6cbd64b56$export$892596cec99bc70e).PLAYER_NORMAL
    },
    START_ELIXIRS: 1,
    START_VISION: 4,
    START_BINDER: 0,
    START_BINDERS_COLLECTED: {
        jan: 0,
        feb: 0,
        mar: 0,
        apr: 0,
        may: 0,
        jun: 0,
        jul: 0,
        aug: 0,
        sep: 0,
        oct: 0,
        nov: 0,
        dec: 0
    }
};
const $1a153cf88c479932$export$2ef8aa71201ee06b = {
    COLLECTIBLES_COLUMNS: 4,
    COLLECTIBLES_ROWS: 3,
    PADDING_TOP: 3,
    PADDING_LEFT: 5,
    CUBBIE_COL_SPACING: 5,
    CUBBIE_WIDTH: 13,
    CUBBIE_ROW_SPACING: 3,
    CUBBIE_HEIGHT: 6,
    MIN_REQ_LEVEL: 1
};
const $1a153cf88c479932$export$31acd2ae5bbde00f = {
    MUSIC: "music/"
};
const $1a153cf88c479932$export$db8153d4765fc5bb = {
    DEFAULT_VIEWPORT_WIDTH: 80,
    DEFAULT_VIEWPORT_HEIGHT: 30,
    MAX_VIEWPORT_HEIGHT: 30,
    MAX_VIEWPORT_WIDTH: 80,
    DEFAULT_DYNAMIC_MAP_WIDTH: 160,
    DEFAULT_DYNAMIC_MAP_HEIGHT: 40
};
const $1a153cf88c479932$export$a568d24c6bb32da8 = {
    RIFT_ESSENCE: "immobile; drain essence",
    RIFT_PIGMENT: "immobile; drain pigment",
    RIFT_BOTH: "immobile; drain essence+pigment",
    SPECTRE_ESSENCE: "chase, sync; drain essence",
    SPECTRE_PIGMENT: "chase, sync; drain pigment",
    SPECTRE_BOTH: "chase, sync; drain essence+pigment",
    REAVER_ESSENCE: "chase, auto; drain essence",
    REAVER_PIGMENT: "chase, auto; drain pigment",
    REAVER_BOTH: "chase, auto; drain essence+pigment",
    BLADE_ESSENCE: "bounce, auto; drain essence",
    BLADE_PIGMENT: "bounce, auto; drain pigment",
    BLADE_BOTH: "bounce, auto; drain essence+pigment",
    VOID_ESSENCE: "bounce, sync; drain essence",
    VOID_PIGMENT: "bounce, sync; drain pigment",
    VOID_BOTH: "bounce, sync; drain essence+pigment",
    DEVOURER: "immobile; drain all essence"
};



class $b36b515e341ce35e$export$c57e9b2d8b9e4de {
    constructor(duration){
        this.timerId = undefined;
        this._isInterval = false;
        this.duration = duration;
    }
    start(repeat = false, callback) {
        this._isInterval = repeat ? true : false;
        if (this.timerId === undefined) {
            if (repeat) this.timerId = window.setInterval(()=>{
                callback();
            }, this.duration);
            else this.timerId = window.setTimeout(()=>{
                callback();
            }, this.duration);
        }
    }
    stop() {
        if (this.timerId !== undefined) {
            if (this._isInterval) clearInterval(this.timerId);
            else clearTimeout(this.timerId);
            this.timerId = undefined;
        }
    }
}




function $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5(min, max) {
    return Math.floor((0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniform() * (max - min + 1) + min);
}
function $0eb0e6f5b56b7df1$export$dd9aaf1372304467() {
    return (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getUniform();
}





class $f35331c222125435$export$bc644a473284d944 {
    constructor(position, blocks, render, displayName, optic){
        this.blocks = blocks;
        this.displayName = displayName;
        this.optic = optic;
        this.baseClass = "Entity";
        this._symbolIndex = 0;
        this._position = position;
        // this._render = cloneDeep(render)
        this._render = {
            ...render
        };
        this._symbolIndex = (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(0, render.symbol.length - 1);
    }
    get position() {
        return this._position;
    }
    render() {
        return this._render;
    }
    renderLight() {
        const symbol = this.nextSymbol();
        return {
            symbol: symbol,
            color: this._render.light
        };
    }
    renderDark() {
        const symbol = this.nextSymbol();
        return {
            symbol: symbol,
            color: this._render.dark
        };
    }
    nextSymbol() {
        const symbol = this._render.symbol[this._symbolIndex];
        this._symbolIndex += 1;
        if (this._symbolIndex >= this._render.symbol.length) this._symbolIndex = 0;
        return symbol;
    }
}


class $aa947e9a2977a9e5$export$eefe978c73a9a6 extends (0, $f35331c222125435$export$bc644a473284d944) {
    static{
        this.ATTACK_RANGE = 1;
    }
    constructor(type, experience, combat, position, render, name, optic){
        super(position, true, render, name, optic), this.type = type;
        this.baseClass = "Enemy";
        this._combat = {
            ...combat
        };
        this._experience = experience;
        this._state = (0, $f0b5fa422dff3899$export$e8d5f23e889970f8).WAITING;
    }
    get attack() {
        const hit = (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(this._combat.minAttack, this._combat.maxAttack);
        return {
            amount: hit,
            type: this.combat.attackType
        };
    }
    get combat() {
        return this._combat;
    }
    get drop() {
        return this._drop;
    }
    get experience() {
        return this._experience;
    }
    isAlive() {
        return this.combat.essence > 0;
    }
    takeHit(attack) {
        let essenceLost = 0;
        if (attack > this.combat.essenceDefense) {
            essenceLost = attack - this.combat.essenceDefense;
            this.combat.essence -= essenceLost;
        }
        return essenceLost;
    }
}


class $27b2a3f73bee1001$export$36d19ae78ae37ef3 extends (0, $aa947e9a2977a9e5$export$eefe978c73a9a6) {
    constructor(type, experience, combat, position, render, name, optic){
        super(type, experience, combat, position, render, name, optic);
    }
}


class $cc102d2f55e05a0f$export$3bd1ca1da4df1199 extends (0, $27b2a3f73bee1001$export$36d19ae78ae37ef3) {
    constructor(type, experience, combat, position, render, name, direction, optic){
        super(type, experience, combat, position, render, name, optic);
        if (direction !== undefined) this._direction = direction;
        else {
            const randomDirection = (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(0, 3);
            switch(randomDirection){
                case 0:
                    this._direction = (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).UP;
                    break;
                case 1:
                    this._direction = (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).DOWN;
                    break;
                case 2:
                    this._direction = (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).LEFT;
                    break;
                default:
                    this._direction = (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).RIGHT;
            }
        }
    }
    projectMove() {
        this._state = (0, $f0b5fa422dff3899$export$e8d5f23e889970f8).WAITING;
        let targetX = this.position.x;
        let targetY = this.position.y;
        if (this._direction == (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).UP) targetY -= 1;
        else if (this._direction == (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).DOWN) targetY += 1;
        else if (this._direction == (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).LEFT) targetX -= 1;
        else if (this._direction == (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).RIGHT) targetX += 1;
        const player = window.engine.getPlayer();
        if (targetX == player.position.x && targetY == player.position.y) {
            window.engine.processEnemyAttack(this, true);
            this._state = (0, $f0b5fa422dff3899$export$e8d5f23e889970f8).ATTACKING;
        } else if (!window.engine.inBounds(targetX, targetY)) {
            if (this._direction == (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).UP) this._direction = (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).DOWN;
            else if (this._direction == (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).DOWN) this._direction = (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).UP;
            else if (this._direction == (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).LEFT) this._direction = (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).RIGHT;
            else if (this._direction == (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).RIGHT) this._direction = (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).LEFT;
        } else {
            this.position.x = targetX;
            this.position.y = targetY;
            this._state = (0, $f0b5fa422dff3899$export$e8d5f23e889970f8).MOVING;
            window.engine.requestUpdate();
        }
        return this._state;
    }
}


class $c0d3e0f22e872a9a$export$2dd8a177a759b9f9 extends (0, $cc102d2f55e05a0f$export$3bd1ca1da4df1199) {
    static{
        this.BASE_TIMER = 1000;
    }
    constructor(type, experience, combat, position, render, name, direction, optic){
        super(type, experience, combat, position, render, name, direction, optic);
        this._timer = new (0, $b36b515e341ce35e$export$c57e9b2d8b9e4de)($c0d3e0f22e872a9a$export$2dd8a177a759b9f9.BASE_TIMER);
        this._timer.start(true, ()=>{
            this.checkState();
        });
    }
    checkState() {
        this._state = this.projectMove();
        if (this._state == (0, $f0b5fa422dff3899$export$e8d5f23e889970f8).ATTACKING) {
            if (!this.isAlive()) {
                this._state = (0, $f0b5fa422dff3899$export$e8d5f23e889970f8).DIED;
                window.engine.removeEntityAtLocation(this.position);
                window.engine.requestUpdate();
            }
        }
    }
    stopTimer() {
        this._timer.stop();
    }
}









class $4aa987f8d897c47e$export$259b7805beaca3fe extends (0, $27b2a3f73bee1001$export$36d19ae78ae37ef3) {
    constructor(type, experience, combat, position, render, name, fov, optic){
        super(type, experience, combat, position, render, name, optic);
        this._dx = 0;
        this._dy = 0;
        this._path = [];
        if (fov !== undefined) this._fov = fov;
        else this._fov = (0, $1a153cf88c479932$export$62d95f0373aed4f6).FOV;
        this._state = (0, $f0b5fa422dff3899$export$e8d5f23e889970f8).WAITING;
    }
    get fov() {
        return this._fov;
    }
    getPathTo(x, y) {
        const isPassable = (x, y)=>window.engine.inBounds(x, y);
        const dijkstra = new (0, $7a3802042b5f31ef$export$2e2bcd8739ae039).Dijkstra(x, y, isPassable, {});
        this._path = [];
        dijkstra.compute(this.position.x, this.position.y, (x, y)=>{
            this._path.push([
                x,
                y
            ]);
        });
        this._path.shift();
    }
    projectMove() {
        this._state = (0, $f0b5fa422dff3899$export$e8d5f23e889970f8).WAITING;
        const player = window.engine.getPlayer();
        const targetX = player.position.x;
        const targetY = player.position.y;
        const dx = targetX - this.position.x;
        const dy = targetY - this.position.y;
        const distance = Math.max(Math.abs(dx), Math.abs(dy));
        if (distance <= this._fov - player.stealth * (0, $1a153cf88c479932$export$4906643e6c3605fc).STEALTH_MODIFIER) {
            if (distance <= (0, $aa947e9a2977a9e5$export$eefe978c73a9a6).ATTACK_RANGE) // only allow attacks on the horz/vert
            {
                if (this.position.x == targetX || this.position.y == targetY) {
                    window.engine.processEnemyAttack(this, true);
                    this._state = (0, $f0b5fa422dff3899$export$e8d5f23e889970f8).ATTACKING;
                }
            } else {
                this.getPathTo(targetX, targetY);
                this._path.pop();
            }
        }
        if (this._path.length > 0) {
            const [destX, destY] = this._path[0];
            this._path.shift();
            this.move(destX - this.position.x, destY - this.position.y);
            this._state = (0, $f0b5fa422dff3899$export$e8d5f23e889970f8).MOVING;
        }
        return this._state;
    }
    move(x, y) {
        const destX = this.position.x + x;
        const destY = this.position.y + y;
        if (!window.engine.inBounds(destX, destY)) return;
        const e = window.engine.getEntitiesAtLocation({
            x: destX,
            y: destY
        });
        if (e !== undefined && e.length > 0 && e[0].blocks) return;
        this.position.x = destX;
        this.position.y = destY;
    }
}


class $f049ee08ee081312$export$7b6a390f24537dda extends (0, $4aa987f8d897c47e$export$259b7805beaca3fe) {
    static{
        this.BASE_TIMER = 1000;
    }
    constructor(type, experience, combat, position, render, name, fov, optic){
        super(type, experience, combat, position, render, name, fov, optic);
        this._timer = new (0, $b36b515e341ce35e$export$c57e9b2d8b9e4de)($f049ee08ee081312$export$7b6a390f24537dda.BASE_TIMER);
        this._timer.start(true, ()=>{
            this.checkState();
        });
    }
    checkState() {
        this._state = this.projectMove();
        if (this._state == (0, $f0b5fa422dff3899$export$e8d5f23e889970f8).MOVING) window.engine.requestUpdate();
        else if (this._state == (0, $f0b5fa422dff3899$export$e8d5f23e889970f8).ATTACKING) {
            if (!this.isAlive()) {
                this._state = (0, $f0b5fa422dff3899$export$e8d5f23e889970f8).DIED;
                window.engine.removeEntityAtLocation(this.position);
                window.engine.requestUpdate();
            }
        }
    }
    stopTimer() {
        this._timer.stop();
    }
}








function $70726f29900f2aba$var$standardRandomOptions() {
    const width = [
        12,
        15
    ];
    const height = [
        9,
        12
    ];
    return {
        roomWidthRange: width,
        roomHeightRange: height,
        maxFillPercentage: 0.9,
        timeLimit: 3000.0
    };
}
// Account for these offsets!
// HOFFSET = 1
// VOFFSET = 5
const $70726f29900f2aba$export$d545c020b8b7b251 = {
    portals: {
        type: (0, $f0b5fa422dff3899$export$ded4562bce86da45).STATIC,
        music: {
            source: "14 Portals.ogg",
            title: "Portals [needs title]"
        },
        width: 80,
        height: 40,
        viewportWidth: 80,
        viewportHeight: 40,
        enableFogOfWar: false,
        items: [
            {
                row: 7,
                column: 26,
                keyTarget: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).January,
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).KEY
            },
            // {
            //   type: ItemType.HINT_INFO,
            //   textContents: "Instructions linked below.",
            //   row: 13,
            //   column: 40,
            // },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).HINT_INFO,
                textContents: "Find and use the key to January.",
                row: 8,
                column: 27
            }
        ],
        rooms: [
            {
                x: 20,
                y: 7,
                width: 37,
                height: 17
            },
            {
                x: 23,
                y: 1,
                width: 7,
                height: 5,
                name: "Jan",
                entry: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).TOP_CENTER
            },
            {
                x: 35,
                y: 1,
                width: 7,
                height: 5,
                name: "Feb",
                entry: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).TOP_CENTER
            },
            {
                x: 47,
                y: 1,
                width: 7,
                height: 5,
                name: "Mar",
                entry: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).TOP_CENTER
            },
            {
                x: 60,
                y: 7,
                width: 7,
                height: 5,
                name: "Apr",
                entry: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).TOP_CENTER
            },
            {
                x: 60,
                y: 13,
                width: 7,
                height: 5,
                name: "May",
                entry: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).TOP_CENTER
            },
            {
                x: 60,
                y: 19,
                width: 7,
                height: 5,
                name: "Jun",
                entry: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).TOP_CENTER
            },
            {
                x: 47,
                y: 25,
                width: 7,
                height: 5,
                name: "Jul",
                entry: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).BOTTOM_CENTER
            },
            {
                x: 35,
                y: 25,
                width: 7,
                height: 5,
                name: "Aug",
                entry: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).BOTTOM_CENTER
            },
            {
                x: 23,
                y: 25,
                width: 7,
                height: 5,
                name: "Sep",
                entry: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).BOTTOM_CENTER
            },
            {
                x: 10,
                y: 19,
                width: 7,
                height: 5,
                name: "Oct",
                entry: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).TOP_CENTER
            },
            {
                x: 10,
                y: 13,
                width: 7,
                height: 5,
                name: "Nov",
                entry: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).TOP_CENTER
            },
            {
                x: 10,
                y: 7,
                width: 7,
                height: 5,
                name: "Dec",
                entry: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).TOP_CENTER
            }
        ],
        corridors: [
            {
                room: 1,
                length: (0, $1a153cf88c479932$export$19cee937b4034054).CORRIDOR_LENGTH,
                entry: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).BOTTOM_CENTER,
                direction: (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).DOWN
            },
            {
                room: 2,
                length: (0, $1a153cf88c479932$export$19cee937b4034054).CORRIDOR_LENGTH,
                entry: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).BOTTOM_CENTER,
                direction: (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).DOWN
            },
            {
                room: 3,
                length: (0, $1a153cf88c479932$export$19cee937b4034054).CORRIDOR_LENGTH,
                entry: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).BOTTOM_CENTER,
                direction: (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).DOWN
            },
            {
                room: 4,
                length: (0, $1a153cf88c479932$export$19cee937b4034054).CORRIDOR_LENGTH,
                entry: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).LEFT_CENTER,
                direction: (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).LEFT
            },
            {
                room: 5,
                length: (0, $1a153cf88c479932$export$19cee937b4034054).CORRIDOR_LENGTH,
                entry: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).LEFT_CENTER,
                direction: (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).LEFT
            },
            {
                room: 6,
                length: (0, $1a153cf88c479932$export$19cee937b4034054).CORRIDOR_LENGTH,
                entry: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).LEFT_CENTER,
                direction: (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).LEFT
            },
            {
                room: 7,
                length: (0, $1a153cf88c479932$export$19cee937b4034054).CORRIDOR_LENGTH,
                entry: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).TOP_CENTER,
                direction: (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).UP
            },
            {
                room: 8,
                length: (0, $1a153cf88c479932$export$19cee937b4034054).CORRIDOR_LENGTH,
                entry: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).TOP_CENTER,
                direction: (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).UP
            },
            {
                room: 9,
                length: (0, $1a153cf88c479932$export$19cee937b4034054).CORRIDOR_LENGTH,
                entry: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).TOP_CENTER,
                direction: (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).UP
            },
            {
                room: 10,
                length: (0, $1a153cf88c479932$export$19cee937b4034054).CORRIDOR_LENGTH,
                entry: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).RIGHT_CENTER,
                direction: (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).RIGHT
            },
            {
                room: 11,
                length: (0, $1a153cf88c479932$export$19cee937b4034054).CORRIDOR_LENGTH,
                entry: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).RIGHT_CENTER,
                direction: (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).RIGHT
            },
            {
                room: 12,
                length: (0, $1a153cf88c479932$export$19cee937b4034054).CORRIDOR_LENGTH,
                entry: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).RIGHT_CENTER,
                direction: (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).RIGHT
            }
        ],
        doors: [
            {
                room: 1,
                location: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).BOTTOM_CENTER,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).January,
                unlockDate: "2025-01-01"
            },
            {
                room: 2,
                location: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).BOTTOM_CENTER,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).February,
                unlockDate: "2025-02-01"
            },
            {
                room: 3,
                location: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).BOTTOM_CENTER,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).March,
                unlockDate: "2025-03-01"
            },
            {
                room: 4,
                location: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).LEFT_CENTER,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).April,
                unlockDate: "2025-04-01"
            },
            {
                room: 5,
                location: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).LEFT_CENTER,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).May,
                unlockDate: "2025-05-01"
            },
            {
                room: 6,
                location: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).LEFT_CENTER,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).June,
                unlockDate: "2025-06-01"
            },
            {
                room: 7,
                location: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).TOP_CENTER,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).July,
                unlockDate: "2025-07-01"
            },
            {
                room: 8,
                location: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).TOP_CENTER,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).August,
                unlockDate: "2025-08-01"
            },
            {
                room: 9,
                location: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).TOP_CENTER,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).September,
                unlockDate: "2025-09-01"
            },
            {
                room: 10,
                location: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).RIGHT_CENTER,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).October,
                unlockDate: "2025-10-01"
            },
            {
                room: 11,
                location: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).RIGHT_CENTER,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).November,
                unlockDate: "2025-11-01"
            },
            {
                room: 12,
                location: (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).RIGHT_CENTER,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).December,
                unlockDate: "2025-12-01"
            }
        ],
        portals: [
            {
                room: 0,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).Portals
            },
            {
                room: 1,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).January
            },
            {
                room: 2,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).February
            },
            {
                room: 3,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).March
            },
            {
                room: 4,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).April
            },
            {
                room: 5,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).May
            },
            {
                room: 6,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).June
            },
            {
                room: 7,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).July
            },
            {
                room: 8,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).August
            },
            {
                room: 9,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).September
            },
            {
                room: 10,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).October
            },
            {
                room: 11,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).November
            },
            {
                room: 12,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).December
            }
        ],
        popups: [
            {
                row: 12,
                column: 29,
                target: (0, $f0b5fa422dff3899$export$fe68bdb23e385108).TAPESTRY,
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).ENTRANCE
            },
            {
                row: 14,
                column: 29,
                target: (0, $f0b5fa422dff3899$export$fe68bdb23e385108).ARCHIVE,
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).ENTRANCE
            },
            {
                row: 16,
                column: 29,
                target: (0, $f0b5fa422dff3899$export$fe68bdb23e385108).BESTIARY,
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).ENTRANCE
            },
            {
                row: 18,
                column: 29,
                target: (0, $f0b5fa422dff3899$export$fe68bdb23e385108).WARDROBE,
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).ENTRANCE
            },
            {
                row: 12,
                column: 48,
                target: (0, $f0b5fa422dff3899$export$fe68bdb23e385108).ARSENAL,
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).ENTRANCE
            },
            {
                row: 14,
                column: 48,
                target: (0, $f0b5fa422dff3899$export$fe68bdb23e385108).GIZMOS,
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).ENTRANCE
            },
            {
                row: 16,
                column: 48,
                target: (0, $f0b5fa422dff3899$export$fe68bdb23e385108).COMMON_FINDS,
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).ENTRANCE
            },
            {
                row: 18,
                column: 48,
                target: (0, $f0b5fa422dff3899$export$fe68bdb23e385108).MYTHIC_FINDS,
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).ENTRANCE
            }
        ],
        player: 0
    },
    playground: {
        type: (0, $f0b5fa422dff3899$export$ded4562bce86da45).STATIC,
        width: 80,
        height: 40,
        viewportWidth: 80,
        viewportHeight: 40,
        enableFogOfWar: false,
        rooms: [
            {
                x: 20,
                y: 7,
                width: 37,
                height: 17
            }
        ],
        portals: [
            {
                room: 0,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).Playground
            }
        ],
        enemies: [],
        items: [
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_RED
            }
        ],
        player: 0
    },
    january: {
        type: (0, $f0b5fa422dff3899$export$ded4562bce86da45).DYNAMIC,
        music: {
            source: "02 January.ogg",
            title: "January [needs title]"
        },
        width: (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_DYNAMIC_MAP_WIDTH,
        height: (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_DYNAMIC_MAP_HEIGHT,
        viewportWidth: (0, $1a153cf88c479932$export$db8153d4765fc5bb).MAX_VIEWPORT_WIDTH,
        viewportHeight: (0, $1a153cf88c479932$export$db8153d4765fc5bb).MAX_VIEWPORT_HEIGHT,
        enableFogOfWar: true,
        randomOptions: $70726f29900f2aba$var$standardRandomOptions(),
        palette: {
            red: {
                range: {
                    min: 3,
                    max: 4
                },
                mapMax: 40
            },
            green: {
                range: {
                    min: 0,
                    max: 1
                },
                mapMax: 10
            }
        },
        mazeRooms: [
            {
                colors: [
                    [
                        "red",
                        5
                    ],
                    [
                        "green",
                        1
                    ]
                ]
            }
        ],
        equipment: [
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD1
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET1
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON1
            }
        ],
        binder: {
            minMap: 1,
            maxMap: 1,
            maxEver: 5
        },
        items: [
            {
                keyTarget: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).February,
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).KEY
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_RED
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).HINT_INFO,
                textContents: "Find an optic; cycle optics with [SPACE] key.",
                dropNearPlayer: true
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).HINT_WARNING,
                textContents: "%c{#fff}%b{#000}Beware the devourers (" + `%c{#f00}%b{${(0, $248954e6cbd64b56$export$892596cec99bc70e).DANGER_TILE}} ` + "%c{#fff}%b{#000}) in the maze",
                dropNearPlayer: true
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).ELIXIR,
                minMax: {
                    min: 1,
                    max: 2
                }
            }
        ],
        enemies: [
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_ESSENCE,
                min: 0,
                max: 2,
                mapMax: 8
            }
        ],
        portals: [
            {
                room: 0,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).Portals
            }
        ],
        player: 0
    },
    february: {
        type: (0, $f0b5fa422dff3899$export$ded4562bce86da45).DYNAMIC,
        music: {
            source: "03 February.ogg",
            title: "February [needs title]"
        },
        width: (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_DYNAMIC_MAP_WIDTH,
        height: (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_DYNAMIC_MAP_HEIGHT,
        enableFogOfWar: true,
        viewportWidth: (0, $1a153cf88c479932$export$db8153d4765fc5bb).MAX_VIEWPORT_WIDTH,
        viewportHeight: (0, $1a153cf88c479932$export$db8153d4765fc5bb).MAX_VIEWPORT_HEIGHT,
        palette: {
            red: {
                range: {
                    min: 1,
                    max: 2
                },
                mapMax: 20
            },
            green: {
                range: {
                    min: 3,
                    max: 4
                },
                mapMax: 40
            },
            blue: {
                range: {
                    min: 0,
                    max: 1
                },
                mapMax: 10
            }
        },
        randomOptions: $70726f29900f2aba$var$standardRandomOptions(),
        mazeRooms: [
            {
                colors: [
                    [
                        "red",
                        1
                    ],
                    [
                        "green",
                        4
                    ],
                    [
                        "blue",
                        1
                    ]
                ]
            }
        ],
        equipment: [
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO1
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET2
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON2
            }
        ],
        binder: {
            minMap: 1,
            maxMap: 1,
            maxEver: 5
        },
        items: [
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).KEY,
                keyTarget: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).March
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_GREEN
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).HINT_WARNING,
                textContents: "Some enemies drain essence. Others drain pigment.",
                dropNearPlayer: true
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).ELIXIR,
                minMax: {
                    min: 1,
                    max: 2
                }
            }
        ],
        enemies: [
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_ESSENCE,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_PIGMENT,
                min: 0,
                max: 2,
                mapMax: 8
            }
        ],
        portals: [
            {
                room: 0,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).Portals
            }
        ],
        player: 0
    },
    march: {
        type: (0, $f0b5fa422dff3899$export$ded4562bce86da45).DYNAMIC,
        music: {
            source: "04 March.ogg",
            title: "March [needs title]"
        },
        width: (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_DYNAMIC_MAP_WIDTH,
        height: (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_DYNAMIC_MAP_HEIGHT,
        enableFogOfWar: true,
        viewportWidth: (0, $1a153cf88c479932$export$db8153d4765fc5bb).MAX_VIEWPORT_WIDTH,
        viewportHeight: (0, $1a153cf88c479932$export$db8153d4765fc5bb).MAX_VIEWPORT_HEIGHT,
        palette: {
            green: {
                range: {
                    min: 1,
                    max: 2
                },
                mapMax: 20
            },
            blue: {
                range: {
                    min: 3,
                    max: 4
                },
                mapMax: 40
            }
        },
        randomOptions: $70726f29900f2aba$var$standardRandomOptions(),
        mazeRooms: [
            {
                colors: [
                    [
                        "red",
                        1
                    ],
                    [
                        "green",
                        1
                    ],
                    [
                        "blue",
                        4
                    ]
                ]
            }
        ],
        equipment: [
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD2
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET3
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON3
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO1
            }
        ],
        binder: {
            minMap: 1,
            maxMap: 1,
            maxEver: 6
        },
        items: [
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).KEY,
                keyTarget: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).April
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_BLUE
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).HINT_WARNING,
                textContents: "Some enemies drain essence+pigment.",
                dropNearPlayer: true
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).ELIXIR,
                minMax: {
                    min: 1,
                    max: 2
                }
            }
        ],
        enemies: [
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_ESSENCE,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_PIGMENT,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_BOTH,
                min: 0,
                max: 2,
                mapMax: 8
            }
        ],
        portals: [
            {
                room: 0,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).Portals
            }
        ],
        player: 0
    },
    april: {
        type: (0, $f0b5fa422dff3899$export$ded4562bce86da45).DYNAMIC,
        music: {
            source: "05 April.ogg",
            title: "April [needs title]"
        },
        width: (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_DYNAMIC_MAP_WIDTH,
        height: (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_DYNAMIC_MAP_HEIGHT,
        enableFogOfWar: true,
        randomOptions: $70726f29900f2aba$var$standardRandomOptions(),
        mazeRooms: [
            {
                colors: [
                    [
                        "red",
                        2
                    ],
                    [
                        "green",
                        2
                    ],
                    [
                        "blue",
                        2
                    ],
                    [
                        "yellow",
                        1
                    ]
                ]
            }
        ],
        viewportWidth: (0, $1a153cf88c479932$export$db8153d4765fc5bb).MAX_VIEWPORT_WIDTH,
        viewportHeight: (0, $1a153cf88c479932$export$db8153d4765fc5bb).MAX_VIEWPORT_HEIGHT,
        palette: {
            red: {
                range: {
                    min: 1,
                    max: 2
                },
                mapMax: 20
            },
            blue: {
                range: {
                    min: 1,
                    max: 2
                },
                mapMax: 20
            },
            yellow: {
                range: {
                    min: 0,
                    max: 1
                },
                mapMax: 10
            }
        },
        equipment: [
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD3
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO2
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO2
            }
        ],
        binder: {
            minMap: 1,
            maxMap: 1,
            maxEver: 7
        },
        items: [
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).KEY,
                keyTarget: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).May
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).ELIXIR,
                minMax: {
                    min: 1,
                    max: 2
                }
            }
        ],
        enemies: [
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_ESSENCE,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_PIGMENT,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_BOTH,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_ESSENCE,
                min: 0,
                max: 1,
                mapMax: 6
            }
        ],
        portals: [
            {
                room: 0,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).Portals
            }
        ],
        player: 0
    },
    may: {
        type: (0, $f0b5fa422dff3899$export$ded4562bce86da45).DYNAMIC,
        music: {
            source: "06 May.ogg",
            title: "May [needs title]"
        },
        width: (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_DYNAMIC_MAP_WIDTH,
        height: (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_DYNAMIC_MAP_HEIGHT,
        enableFogOfWar: true,
        randomOptions: $70726f29900f2aba$var$standardRandomOptions(),
        mazeRooms: [
            {
                colors: [
                    [
                        "red",
                        1
                    ],
                    [
                        "green",
                        1
                    ],
                    [
                        "blue",
                        1
                    ],
                    [
                        "yellow",
                        7
                    ]
                ]
            }
        ],
        viewportWidth: (0, $1a153cf88c479932$export$db8153d4765fc5bb).MAX_VIEWPORT_WIDTH,
        viewportHeight: (0, $1a153cf88c479932$export$db8153d4765fc5bb).MAX_VIEWPORT_HEIGHT,
        palette: {
            green: {
                range: {
                    min: 1,
                    max: 2
                },
                mapMax: 20
            },
            yellow: {
                range: {
                    min: 3,
                    max: 4
                },
                mapMax: 40
            }
        },
        equipment: [
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO3
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON4
            }
        ],
        binder: {
            minMap: 1,
            maxMap: 1,
            maxEver: 8
        },
        items: [
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).KEY,
                keyTarget: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).June
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_YELLOW
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).ELIXIR,
                minMax: {
                    min: 1,
                    max: 2
                }
            }
        ],
        enemies: [
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_ESSENCE,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_PIGMENT,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_BOTH,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_ESSENCE,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_PIGMENT,
                min: 0,
                max: 1,
                mapMax: 6
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_ESSENCE,
                min: 0,
                max: 1,
                mapMax: 6
            }
        ],
        portals: [
            {
                room: 0,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).Portals
            }
        ],
        player: 0
    },
    june: {
        type: (0, $f0b5fa422dff3899$export$ded4562bce86da45).DYNAMIC,
        music: {
            source: "07 June.ogg",
            title: "June [needs title]"
        },
        width: (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_DYNAMIC_MAP_WIDTH,
        height: (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_DYNAMIC_MAP_HEIGHT,
        enableFogOfWar: true,
        randomOptions: $70726f29900f2aba$var$standardRandomOptions(),
        mazeRooms: [
            {
                colors: [
                    [
                        "red",
                        1
                    ],
                    [
                        "green",
                        3
                    ],
                    [
                        "blue",
                        3
                    ],
                    [
                        "yellow",
                        3
                    ],
                    [
                        "magenta",
                        1
                    ]
                ]
            }
        ],
        viewportWidth: (0, $1a153cf88c479932$export$db8153d4765fc5bb).MAX_VIEWPORT_WIDTH,
        viewportHeight: (0, $1a153cf88c479932$export$db8153d4765fc5bb).MAX_VIEWPORT_HEIGHT,
        palette: {
            green: {
                range: {
                    min: 0,
                    max: 1
                },
                mapMax: 10
            },
            blue: {
                range: {
                    min: 0,
                    max: 1
                },
                mapMax: 10
            },
            yellow: {
                range: {
                    min: 1,
                    max: 2
                },
                mapMax: 20
            },
            magenta: {
                range: {
                    min: 0,
                    max: 1
                },
                mapMax: 10
            }
        },
        equipment: [
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON5
            }
        ],
        binder: {
            minMap: 1,
            maxMap: 1,
            maxEver: 8
        },
        items: [
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).KEY,
                keyTarget: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).July
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).ELIXIR,
                minMax: {
                    min: 1,
                    max: 2
                }
            }
        ],
        enemies: [
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_ESSENCE,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_PIGMENT,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_BOTH,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_ESSENCE,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_PIGMENT,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_BOTH,
                min: 0,
                max: 1,
                mapMax: 6
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_ESSENCE,
                min: 0,
                max: 1,
                mapMax: 6
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_PIGMENT,
                min: 0,
                max: 1,
                mapMax: 6
            }
        ],
        portals: [
            {
                room: 0,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).Portals
            }
        ],
        player: 0
    },
    july: {
        type: (0, $f0b5fa422dff3899$export$ded4562bce86da45).DYNAMIC,
        music: {
            source: "08 July.ogg",
            title: "July [needs title]"
        },
        width: (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_DYNAMIC_MAP_WIDTH,
        height: (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_DYNAMIC_MAP_HEIGHT,
        enableFogOfWar: true,
        randomOptions: $70726f29900f2aba$var$standardRandomOptions(),
        mazeRooms: [
            {
                colors: [
                    [
                        "red",
                        1
                    ],
                    [
                        "green",
                        1
                    ],
                    [
                        "blue",
                        1
                    ],
                    [
                        "yellow",
                        1
                    ],
                    [
                        "magenta",
                        6
                    ]
                ]
            }
        ],
        viewportWidth: (0, $1a153cf88c479932$export$db8153d4765fc5bb).MAX_VIEWPORT_WIDTH,
        viewportHeight: (0, $1a153cf88c479932$export$db8153d4765fc5bb).MAX_VIEWPORT_HEIGHT,
        palette: {
            red: {
                range: {
                    min: 0,
                    max: 1
                },
                mapMax: 10
            },
            blue: {
                range: {
                    min: 0,
                    max: 1
                },
                mapMax: 10
            },
            magenta: {
                range: {
                    min: 3,
                    max: 4
                },
                mapMax: 40
            }
        },
        equipment: [
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD5
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET5
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO3
            }
        ],
        binder: {
            minMap: 1,
            maxMap: 1,
            maxEver: 9
        },
        items: [
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).KEY,
                keyTarget: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).August
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_MAGENTA
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).ELIXIR,
                minMax: {
                    min: 1,
                    max: 2
                }
            }
        ],
        enemies: [
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_ESSENCE,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_PIGMENT,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_BOTH,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_ESSENCE,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_PIGMENT,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_BOTH,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_ESSENCE,
                min: 0,
                max: 1,
                mapMax: 6
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_PIGMENT,
                min: 0,
                max: 1,
                mapMax: 6
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_BOTH,
                min: 0,
                max: 1,
                mapMax: 6
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).SPECTRE_ESSENCE,
                min: 0,
                max: 1,
                mapMax: 4
            }
        ],
        portals: [
            {
                room: 0,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).Portals
            }
        ],
        player: 0
    },
    august: {
        type: (0, $f0b5fa422dff3899$export$ded4562bce86da45).DYNAMIC,
        music: {
            source: "09 August.ogg",
            title: "August [needs title]"
        },
        width: (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_DYNAMIC_MAP_WIDTH,
        height: (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_DYNAMIC_MAP_HEIGHT,
        enableFogOfWar: true,
        randomOptions: $70726f29900f2aba$var$standardRandomOptions(),
        mazeRooms: [
            {
                colors: [
                    [
                        "red",
                        1
                    ],
                    [
                        "green",
                        1
                    ],
                    [
                        "blue",
                        2
                    ],
                    [
                        "yellow",
                        3
                    ],
                    [
                        "magenta",
                        3
                    ]
                ]
            }
        ],
        viewportWidth: (0, $1a153cf88c479932$export$db8153d4765fc5bb).MAX_VIEWPORT_WIDTH,
        viewportHeight: (0, $1a153cf88c479932$export$db8153d4765fc5bb).MAX_VIEWPORT_HEIGHT,
        palette: {
            yellow: {
                range: {
                    min: 0,
                    max: 1
                },
                mapMax: 10
            },
            magenta: {
                range: {
                    min: 1,
                    max: 2
                },
                mapMax: 20
            }
        },
        equipment: [
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD6
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO5
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON6
            }
        ],
        binder: {
            minMap: 1,
            maxMap: 1,
            maxEver: 9
        },
        items: [
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).KEY,
                keyTarget: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).September
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).ELIXIR,
                minMax: {
                    min: 1,
                    max: 2
                }
            }
        ],
        enemies: [
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_ESSENCE,
                min: 0,
                max: 1,
                mapMax: 2
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_PIGMENT,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_BOTH,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_ESSENCE,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_PIGMENT,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_BOTH,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_ESSENCE,
                min: 0,
                max: 2,
                mapMax: 8
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_PIGMENT,
                min: 0,
                max: 1,
                mapMax: 6
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_BOTH,
                min: 0,
                max: 1,
                mapMax: 6
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).SPECTRE_ESSENCE,
                min: 0,
                max: 2,
                mapMax: 6
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).SPECTRE_PIGMENT,
                min: 0,
                max: 1,
                mapMax: 4
            }
        ],
        portals: [
            {
                room: 0,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).Portals
            }
        ],
        player: 0
    },
    september: {
        type: (0, $f0b5fa422dff3899$export$ded4562bce86da45).DYNAMIC,
        music: {
            source: "10 September.ogg",
            title: "September [needs title]"
        },
        width: (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_DYNAMIC_MAP_WIDTH,
        height: (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_DYNAMIC_MAP_HEIGHT,
        enableFogOfWar: true,
        randomOptions: $70726f29900f2aba$var$standardRandomOptions(),
        mazeRooms: [
            {
                colors: [
                    [
                        "red",
                        2
                    ],
                    [
                        "green",
                        2
                    ],
                    [
                        "blue",
                        2
                    ],
                    [
                        "yellow",
                        2
                    ],
                    [
                        "magenta",
                        2
                    ],
                    [
                        "cyan",
                        2
                    ]
                ]
            }
        ],
        viewportWidth: (0, $1a153cf88c479932$export$db8153d4765fc5bb).MAX_VIEWPORT_WIDTH,
        viewportHeight: (0, $1a153cf88c479932$export$db8153d4765fc5bb).MAX_VIEWPORT_HEIGHT,
        palette: {
            green: {
                range: {
                    min: 0,
                    max: 1
                },
                mapMax: 10
            },
            yellow: {
                range: {
                    min: 0,
                    max: 1
                },
                mapMax: 10
            },
            magenta: {
                range: {
                    min: 0,
                    max: 1
                },
                mapMax: 10
            },
            cyan: {
                range: {
                    min: 0,
                    max: 1
                },
                mapMax: 10
            }
        },
        equipment: [
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO6
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET6
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO4
            }
        ],
        binder: {
            minMap: 1,
            maxMap: 1,
            maxEver: 8
        },
        items: [
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).KEY,
                keyTarget: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).October
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).ELIXIR,
                minMax: {
                    min: 1,
                    max: 2
                }
            }
        ],
        enemies: [
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_PIGMENT,
                min: 0,
                max: 1,
                mapMax: 2
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_BOTH,
                min: 0,
                max: 1,
                mapMax: 2
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_PIGMENT,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_BOTH,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_ESSENCE,
                min: 0,
                max: 2,
                mapMax: 8
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_PIGMENT,
                min: 0,
                max: 2,
                mapMax: 8
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_BOTH,
                min: 0,
                max: 1,
                mapMax: 6
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).SPECTRE_ESSENCE,
                min: 0,
                max: 2,
                mapMax: 6
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).SPECTRE_PIGMENT,
                min: 0,
                max: 2,
                mapMax: 6
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).SPECTRE_BOTH,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).REAVER_ESSENCE,
                min: 0,
                max: 1,
                mapMax: 4
            }
        ],
        portals: [
            {
                room: 0,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).Portals
            }
        ],
        player: 0
    },
    october: {
        type: (0, $f0b5fa422dff3899$export$ded4562bce86da45).DYNAMIC,
        music: {
            source: "11 October.ogg",
            title: "October [needs title]"
        },
        width: (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_DYNAMIC_MAP_WIDTH,
        height: (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_DYNAMIC_MAP_HEIGHT,
        enableFogOfWar: true,
        randomOptions: $70726f29900f2aba$var$standardRandomOptions(),
        mazeRooms: [
            {
                colors: [
                    [
                        "red",
                        1
                    ],
                    [
                        "green",
                        1
                    ],
                    [
                        "blue",
                        1
                    ],
                    [
                        "yellow",
                        1
                    ],
                    [
                        "magenta",
                        4
                    ],
                    [
                        "cyan",
                        12
                    ]
                ]
            }
        ],
        viewportWidth: (0, $1a153cf88c479932$export$db8153d4765fc5bb).MAX_VIEWPORT_WIDTH,
        viewportHeight: (0, $1a153cf88c479932$export$db8153d4765fc5bb).MAX_VIEWPORT_HEIGHT,
        palette: {
            green: {
                range: {
                    min: 0,
                    max: 1
                },
                mapMax: 10
            },
            blue: {
                range: {
                    min: 0,
                    max: 1
                },
                mapMax: 10
            },
            cyan: {
                range: {
                    min: 3,
                    max: 4
                },
                mapMax: 40
            }
        },
        equipment: [
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD7
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET7
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON7
            }
        ],
        binder: {
            minMap: 1,
            maxMap: 1,
            maxEver: 8
        },
        items: [
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).KEY,
                keyTarget: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).November
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_CYAN
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).ELIXIR,
                minMax: {
                    min: 1,
                    max: 2
                }
            }
        ],
        enemies: [
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_BOTH,
                min: 0,
                max: 1,
                mapMax: 2
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_BOTH,
                min: 0,
                max: 1,
                mapMax: 2
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_ESSENCE,
                min: 0,
                max: 1,
                mapMax: 2
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_PIGMENT,
                min: 0,
                max: 2,
                mapMax: 8
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_BOTH,
                min: 0,
                max: 2,
                mapMax: 8
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).SPECTRE_ESSENCE,
                min: 0,
                max: 2,
                mapMax: 6
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).SPECTRE_PIGMENT,
                min: 0,
                max: 2,
                mapMax: 6
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).SPECTRE_BOTH,
                min: 0,
                max: 2,
                mapMax: 6
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).REAVER_ESSENCE,
                min: 0,
                max: 2,
                mapMax: 6
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).REAVER_PIGMENT,
                min: 0,
                max: 1,
                mapMax: 4
            }
        ],
        portals: [
            {
                room: 0,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).Portals
            }
        ],
        player: 0
    },
    november: {
        type: (0, $f0b5fa422dff3899$export$ded4562bce86da45).DYNAMIC,
        music: {
            source: "12 November.ogg",
            title: "November [needs title]"
        },
        width: (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_DYNAMIC_MAP_WIDTH,
        height: (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_DYNAMIC_MAP_HEIGHT,
        enableFogOfWar: true,
        randomOptions: $70726f29900f2aba$var$standardRandomOptions(),
        mazeRooms: [
            {
                colors: [
                    [
                        "red",
                        1
                    ],
                    [
                        "green",
                        1
                    ],
                    [
                        "blue",
                        1
                    ],
                    [
                        "yellow",
                        1
                    ],
                    [
                        "magenta",
                        2
                    ],
                    [
                        "cyan",
                        4
                    ]
                ]
            }
        ],
        viewportWidth: (0, $1a153cf88c479932$export$db8153d4765fc5bb).MAX_VIEWPORT_WIDTH,
        viewportHeight: (0, $1a153cf88c479932$export$db8153d4765fc5bb).MAX_VIEWPORT_HEIGHT,
        palette: {
            red: {
                range: {
                    min: 3,
                    max: 4
                },
                mapMax: 40
            },
            green: {
                range: {
                    min: 3,
                    max: 4
                },
                mapMax: 40
            },
            blue: {
                range: {
                    min: 3,
                    max: 4
                },
                mapMax: 40
            }
        },
        equipment: [
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO7
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO5
            }
        ],
        binder: {
            minMap: 1,
            maxMap: 1,
            maxEver: 7
        },
        items: [
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).KEY,
                keyTarget: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).December
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).ELIXIR,
                minMax: {
                    min: 1,
                    max: 2
                }
            }
        ],
        enemies: [
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_BOTH,
                min: 0,
                max: 1,
                mapMax: 2
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_BOTH,
                min: 0,
                max: 1,
                mapMax: 2
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_PIGMENT,
                min: 0,
                max: 1,
                mapMax: 2
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_BOTH,
                min: 0,
                max: 2,
                mapMax: 8
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).SPECTRE_ESSENCE,
                min: 0,
                max: 1,
                mapMax: 2
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).SPECTRE_PIGMENT,
                min: 0,
                max: 1,
                mapMax: 2
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).SPECTRE_BOTH,
                min: 0,
                max: 2,
                mapMax: 6
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).REAVER_ESSENCE,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).REAVER_PIGMENT,
                min: 0,
                max: 2,
                mapMax: 6
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).REAVER_BOTH,
                min: 0,
                max: 1,
                mapMax: 4
            }
        ],
        portals: [
            {
                room: 0,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).Portals
            }
        ],
        player: 0
    },
    december: {
        type: (0, $f0b5fa422dff3899$export$ded4562bce86da45).DYNAMIC,
        music: {
            source: "13 December.ogg",
            title: "December [needs title]"
        },
        width: (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_DYNAMIC_MAP_WIDTH,
        height: (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_DYNAMIC_MAP_HEIGHT,
        enableFogOfWar: true,
        randomOptions: $70726f29900f2aba$var$standardRandomOptions(),
        mazeRooms: [
            {
                colors: [
                    [
                        "red",
                        1
                    ],
                    [
                        "green",
                        1
                    ],
                    [
                        "blue",
                        1
                    ],
                    [
                        "yellow",
                        1
                    ],
                    [
                        "magenta",
                        1
                    ],
                    [
                        "cyan",
                        1
                    ]
                ]
            }
        ],
        viewportWidth: (0, $1a153cf88c479932$export$db8153d4765fc5bb).MAX_VIEWPORT_WIDTH,
        viewportHeight: (0, $1a153cf88c479932$export$db8153d4765fc5bb).MAX_VIEWPORT_HEIGHT,
        palette: {
            yellow: {
                range: {
                    min: 3,
                    max: 4
                },
                mapMax: 40
            },
            magenta: {
                range: {
                    min: 3,
                    max: 4
                },
                mapMax: 40
            },
            cyan: {
                range: {
                    min: 3,
                    max: 4
                },
                mapMax: 40
            }
        },
        equipment: [
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD8
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO8
            },
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET8
            }
        ],
        binder: {
            minMap: 1,
            maxMap: 1,
            maxEver: 6
        },
        enemies: [
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_BOTH,
                min: 0,
                max: 1,
                mapMax: 2
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_BOTH,
                min: 0,
                max: 1,
                mapMax: 2
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_BOTH,
                min: 0,
                max: 1,
                mapMax: 2
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).SPECTRE_PIGMENT,
                min: 0,
                max: 1,
                mapMax: 2
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).SPECTRE_BOTH,
                min: 0,
                max: 1,
                mapMax: 4
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).REAVER_ESSENCE,
                min: 0,
                max: 1,
                mapMax: 2
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).REAVER_PIGMENT,
                min: 0,
                max: 1,
                mapMax: 2
            },
            {
                type: (0, $f0b5fa422dff3899$export$1a91c501cca01afe).REAVER_BOTH,
                min: 0,
                max: 2,
                mapMax: 6
            }
        ],
        items: [
            {
                type: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).ELIXIR,
                minMax: {
                    min: 1,
                    max: 2
                }
            }
        ],
        portals: [
            {
                room: 0,
                target: (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).Portals
            }
        ],
        player: 0
    }
};






const $fb83a523a87c4ade$export$6c05c5050be0f1f7 = {
    BORDER: 1
};
const $fb83a523a87c4ade$export$298ba07e5203e3b7 = [
    [
        "++++++++++",
        "+ &     &+",
        "+ & &&& &+",
        "+   &i  &+",
        "+ &&&&& &+",
        "+     & &+",
        "++++++++++"
    ],
    [
        "++++++++++",
        "+ &   & &+",
        "+ & &&& &+",
        "+ &    i&+",
        "+ & &&&&&+",
        "+       &+",
        "++++++++++"
    ],
    [
        "++++++++++",
        "+       &+",
        "+&&&&&& &+",
        "+   i&  &+",
        "+ &&& &&&+",
        "+       &+",
        "++++++++++"
    ],
    [
        "++++++++++",
        "+     & &+",
        "+ & &&& &+",
        "+ &   &i&+",
        "+&& & & &+",
        "+   &   &+",
        "++++++++++"
    ],
    [
        "++++++++++",
        "+     & &+",
        "+&&&& &i&+",
        "+   &   &+",
        "+&& & &&&+",
        "+       &+",
        "++++++++++"
    ],
    [
        "++++++++++",
        "+   &   &+",
        "+&& &&& &+",
        "+ &i  & &+",
        "+ & &&& &+",
        "+       &+",
        "++++++++++"
    ],
    [
        "++++++++++",
        "+     & &+",
        "+&& & & &+",
        "+   &i  &+",
        "+ & &&& &+",
        "+ &   & &+",
        "++++++++++"
    ],
    [
        "++++++++++",
        "+     & &+",
        "+&& &&& &+",
        "+ &i&   &+",
        "+ & &&& &+",
        "+       &+",
        "++++++++++"
    ],
    [
        "++++++++++",
        "+ & &   &+",
        "+ & &&& &+",
        "+   &i  &+",
        "+ &&&&& &+",
        "+       &+",
        "++++++++++"
    ],
    [
        "++++++++++",
        "+   &   &+",
        "+&& &&& &+",
        "+ i &   &+",
        "+&& & &&&+",
        "+       &+",
        "++++++++++"
    ]
];










class $ab13c19c3aeb9f68$export$de0da80dabe2df86 extends (0, $cc102d2f55e05a0f$export$3bd1ca1da4df1199) {
    constructor(type, experience, combat, position, render, name, direction, optic){
        super(type, experience, combat, position, render, name, direction, optic);
        if (this._direction == (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).UP || this._direction == (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).DOWN) this.render().symbol = [
            (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).VOID_VERT_1,
            (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).VOID_VERT_2
        ];
        else this.render().symbol = [
            (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).VOID_HORZ_1,
            (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).VOID_HORZ_2
        ];
    }
}




class $512bb79c6d4dfa91$export$d7113546b6694564 extends (0, $4aa987f8d897c47e$export$259b7805beaca3fe) {
    constructor(type, experience, combat, position, render, name, fov, optic){
        super(type, experience, combat, position, render, name, fov, optic);
    }
}






class $51ac2b1cc9acd541$export$6d08773d2e66f8f2 extends (0, $f35331c222125435$export$bc644a473284d944) {
    constructor(type, levelRequired, position, render, name, optic){
        super(position, false, render, name, optic), this.type = type, this.levelRequired = levelRequired;
    }
}


class $92da5905bb1565d7$export$be5c6394b8b5ed45 extends (0, $51ac2b1cc9acd541$export$6d08773d2e66f8f2) {
    constructor(position){
        const render = {
            symbol: [
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).ELIXIR
            ],
            light: (0, $248954e6cbd64b56$export$892596cec99bc70e).ELIXIR,
            dark: (0, $248954e6cbd64b56$export$892596cec99bc70e).ELIXIR_DARK
        };
        const levelRequired = 1;
        super((0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).ELIXIR, levelRequired, position, render, "elixir");
    }
}







class $517927198014b318$export$6d91f4614964de77 extends (0, $51ac2b1cc9acd541$export$6d08773d2e66f8f2) {
    constructor(color, position, useOptic = true){
        const type = $517927198014b318$var$getTypeForColor(color);
        const optic = useOptic ? $517927198014b318$var$getOpticForColor(color) : undefined;
        const render = $517927198014b318$var$getPigmentRenderConfig(color);
        const levelRequired = 1;
        super(type, levelRequired, position, render, color + " pigment", optic);
    }
}
function $517927198014b318$var$getTypeForColor(color) {
    let type = (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).PIGMENT_RED;
    switch(color){
        case "magenta":
            type = (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).PIGMENT_MAGENTA;
            break;
        case "blue":
            type = (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).PIGMENT_BLUE;
            break;
        case "cyan":
            type = (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).PIGMENT_CYAN;
            break;
        case "green":
            type = (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).PIGMENT_GREEN;
            break;
        case "yellow":
            type = (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).PIGMENT_YELLOW;
        default:
            break;
    }
    return type;
}
function $517927198014b318$var$getPigmentRenderConfig(color) {
    let light = (0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_YELLOW;
    let dark = (0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_DARK_YELLOW;
    switch(color){
        case "red":
            light = (0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_RED;
            dark = (0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_DARK_RED;
            break;
        case "magenta":
            light = (0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_MAGENTA;
            dark = (0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_DARK_MAGENTA;
            break;
        case "blue":
            light = (0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_BLUE;
            dark = (0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_DARK_BLUE;
            break;
        case "cyan":
            light = (0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_CYAN;
            dark = (0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_DARK_CYAN;
            break;
        case "green":
            light = (0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_GREEN;
            dark = (0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_DARK_GREEN;
            break;
        default:
            break;
    }
    return {
        symbol: [
            (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).PIGMENT
        ],
        light: light,
        dark: dark
    };
}
function $517927198014b318$var$getOpticForColor(color) {
    let optic = (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_RED;
    switch(color){
        case "magenta":
            optic = (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_MAGENTA;
            break;
        case "blue":
            optic = (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_BLUE;
            break;
        case "cyan":
            optic = (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_CYAN;
            break;
        case "green":
            optic = (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_GREEN;
            break;
        case "yellow":
            optic = (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_YELLOW;
        default:
            break;
    }
    return optic;
}



class $3ef95fa959568bd4$export$9e1c3038ae586738 extends (0, $517927198014b318$export$6d91f4614964de77) {
    constructor(color, position, amount = 1){
        super(color, position, false);
        this._amount = amount;
    }
    get amount() {
        return this._amount;
    }
}






class $cdaf355186b7e8f3$export$ee92a44c6f1de009 extends (0, $f35331c222125435$export$bc644a473284d944) {
    constructor(target, position){
        const render = {
            symbol: [
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).PORTAL
            ],
            light: (0, $248954e6cbd64b56$export$892596cec99bc70e).PORTAL_FG,
            dark: (0, $248954e6cbd64b56$export$892596cec99bc70e).PORTAL_DARK_FG
        };
        super(position, true, render, "Portal to " + (0, $b296c6d74f581bce$export$32f6dae5310d379c)(target)), this.target = target;
    }
}






class $cb91172ccfffa818$export$95d4acdbab2fc6ef extends (0, $f35331c222125435$export$bc644a473284d944) {
    constructor(target, position){
        const render = $cb91172ccfffa818$var$triggerRenderConfig(target);
        super(position, true, render, "Entrance to " + $cb91172ccfffa818$var$popupIDToString(target)), this.target = target;
    }
}
function $cb91172ccfffa818$var$popupIDToString(target) {
    let tag = "";
    switch(target){
        case (0, $f0b5fa422dff3899$export$fe68bdb23e385108).TAPESTRY:
            tag = "Tapestry Room";
            break;
        case (0, $f0b5fa422dff3899$export$fe68bdb23e385108).ARCHIVE:
            tag = "Archive";
            break;
        case (0, $f0b5fa422dff3899$export$fe68bdb23e385108).BESTIARY:
            tag = "Bestiary";
            break;
        case (0, $f0b5fa422dff3899$export$fe68bdb23e385108).ARSENAL:
            tag = "Arsenal";
            break;
        case (0, $f0b5fa422dff3899$export$fe68bdb23e385108).WARDROBE:
            tag = "Wardrobe";
            break;
        case (0, $f0b5fa422dff3899$export$fe68bdb23e385108).COMMON_FINDS:
            tag = "Common Finds";
            break;
        case (0, $f0b5fa422dff3899$export$fe68bdb23e385108).MYTHIC_FINDS:
            tag = "Mythic Finds";
            break;
        case (0, $f0b5fa422dff3899$export$fe68bdb23e385108).GIZMOS:
            tag = "Gizmos";
            break;
        default:
            break;
    }
    return tag;
}
function $cb91172ccfffa818$var$triggerRenderConfig(target) {
    let symbol = "";
    switch(target){
        case (0, $f0b5fa422dff3899$export$fe68bdb23e385108).TAPESTRY:
            symbol = (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).TAPESTRY;
            break;
        case (0, $f0b5fa422dff3899$export$fe68bdb23e385108).ARCHIVE:
            symbol = (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).ARCHIVE;
            break;
        case (0, $f0b5fa422dff3899$export$fe68bdb23e385108).BESTIARY:
            symbol = (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).BESTIARY;
            break;
        case (0, $f0b5fa422dff3899$export$fe68bdb23e385108).ARSENAL:
            symbol = (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).ARSENAL;
            break;
        case (0, $f0b5fa422dff3899$export$fe68bdb23e385108).WARDROBE:
            symbol = (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).WARDROBE;
            break;
        case (0, $f0b5fa422dff3899$export$fe68bdb23e385108).COMMON_FINDS:
            symbol = (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).COMMON_FINDS;
            break;
        case (0, $f0b5fa422dff3899$export$fe68bdb23e385108).MYTHIC_FINDS:
            symbol = (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).MYTHIC_FINDS;
            break;
        case (0, $f0b5fa422dff3899$export$fe68bdb23e385108).GIZMOS:
            symbol = (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).GIZMOS;
            break;
        default:
            break;
    }
    return {
        symbol: [
            symbol
        ],
        light: (0, $248954e6cbd64b56$export$892596cec99bc70e).TRIGGER_LIGHT,
        dark: (0, $248954e6cbd64b56$export$892596cec99bc70e).TRIGGER_DARK
    };
}





class $d66f070054175cf7$export$4aa8d1180ba213b0 extends (0, $f35331c222125435$export$bc644a473284d944) {
    constructor(position, name){
        super(position, false, {
            symbol: [
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).RESIDUE
            ],
            light: (0, $248954e6cbd64b56$export$892596cec99bc70e).RESIDUE,
            dark: (0, $248954e6cbd64b56$export$892596cec99bc70e).RESIDUE_DARK
        }, "residue of " + name);
    }
}


// REQUIRE 12 wide by 6 tall
// 12 items, 3 rows x 4 columns
const $d2641ced5019691c$export$fa99cf963d65f434 = {
    blank: [
        `             `,
        `             `,
        `             `,
        `             `,
        `             `,
        `             `
    ],
    bottle: [
        "     mm     ",
        "     )(     ",
        "    (  )    ",
        "    |  |    ",
        "    |  |    ",
        "    |__|    "
    ],
    camera: [
        "            ",
        "  _n_||_,_  ",
        " |===..===| ",
        " |  (())  | ",
        " '===''===' ",
        "            "
    ],
    candle: [
        "    )       ",
        "   (_)      ",
        "   |`|      ",
        "   | |  _() ",
        " \\_|_|_/    ",
        "            "
    ],
    coffeecup: [
        "            ",
        "    ;)( ;   ",
        "   :----:   ",
        "  C|====|   ",
        "   |    |   ",
        "   `----'   "
    ],
    dice: [
        "   _____    ",
        "  / .  /\\   ",
        " /____/..\\  ",
        " \\'  '\\  /  ",
        "  \\'__'\\/   ",
        "            "
    ],
    drum: [
        " ===o  o=== ",
        "  ________  ",
        " |________| ",
        "  |\\  /\\ |  ",
        "  | \\/__\\|  ",
        " |________| "
    ],
    feather: [
        "            ",
        "   (`/\\     ",
        "   `=\\/\\    ",
        "    `=\\/\\   ",
        "     `=\\/   ",
        "        \\   "
    ],
    flower: [
        "    _.._    ",
        "   (_\\\\_)   ",
        "  (__<__{}  ",
        "   (_//_)   ",
        "     ||     ",
        "     ||/    "
    ],
    hammer: [
        "   ______   ",
        "  |_,.,--\\  ",
        "     ||     ",
        "     ||     ",
        "     ##     ",
        "     ##     "
    ],
    hourglass: [
        "   .____.   ",
        "   |(__)|   ",
        "   | )( |   ",
        "   |(::)|   ",
        "   .____.   ",
        "            "
    ],
    leaf: [
        "     ||     ",
        "   .'||'.   ",
        "  /.'||\\ \\  ",
        "  | /||'.|  ",
        "   \\ ||\\/   ",
        "    \\||/    "
    ],
    phone: [
        "  ________  ",
        " (_]----[_) ",
        ".~ |.''.|   ",
        "~. |'..'|   ",
        " `~`----`   ",
        "            "
    ],
    pineapple: [
        "            ",
        "    \\||/    ",
        "    AXXA    ",
        "   /XXXX\\   ",
        "   \\XXXX/   ",
        "    `^^'    "
    ],
    pocketknife: [
        "       _    ",
        "     /|o|   ",
        "    / | |   ",
        "   / /| |   ",
        "  / / |+|   ",
        " /.'  [_]   "
    ]
};
const $d2641ced5019691c$export$7518b3a3e015df51 = {
    blank: [
        `             `,
        `             `,
        `             `,
        `             `,
        `             `,
        `             `
    ],
    ant: [
        "            ",
        "  _  _  ,,  ",
        " (_)(_)-O   ",
        "  L L L     ",
        " `````--..  ",
        "            "
    ],
    bee: [
        "      __    ",
        "     // \\   ",
        "     \\\\_/ //",
        "... -(||)(')",
        "    '''     ",
        "            "
    ],
    butterfly: [
        "            ",
        "    \\  /    ",
        "  (.\\\\//.)  ",
        "   \\ () /   ",
        "   (_/\\_)   ",
        "            "
    ],
    canary: [
        "    .-.     ",
        "   /'v'\\    ",
        "  (/   \\)   ",
        ' =\'="="===< ',
        "    |_|     ",
        "            "
    ],
    chicken: [
        ' /""\\      ,',
        "<>^  L____/|",
        " `) /`   , /",
        "  \\ `---' / ",
        "   `'\";\\)`  ",
        "     _/_Y   "
    ],
    duck: [
        "            ",
        "   _        ",
        " >(')____,  ",
        "   (` =~~/  ",
        "~^~^`---'~^~",
        "            "
    ],
    eagle: [
        "  .`.   _ _ ",
        "__;_ \\ /,//`",
        "--, `._) (  ",
        " '//,,,  |  ",
        "      )_/   ",
        "     /_|    "
    ],
    falcon: [
        "     __     ",
        "    /'{>    ",
        "  ___)(___  ",
        " /'-;  ;-'\\ ",
        "////\\__/\\\\\\\\",
        "     mm     "
    ],
    frog: [
        "            ",
        "    ()()    ",
        "  .-(__)-.  ",
        "   _<  >_   ",
        "   \\/  \\/   ",
        "            "
    ],
    owl: [
        "            ",
        "    ,_,     ",
        "   (O,O)    ",
        "   (   )    ",
        '   -"-"--   ',
        "            "
    ],
    parakeets: [
        "      \\\\    ",
        " \\\\   (o>   ",
        " (o>  //\\   ",
        "_(()__V_/___",
        " ||   ||    ",
        "      ||    "
    ],
    parrot: [
        "            ",
        "     (@>    ",
        "    {||     ",
        '   --""--   ',
        "     ||     ",
        "     ||     "
    ],
    penguin: [
        "    __      ",
        " -=(o '.    ",
        "    '.-.\\   ",
        "    /|  \\\\  ",
        "    '|  ||  ",
        "     _\\_):,_"
    ],
    spider: [
        "            ",
        "   ||  ||   ",
        "   \\\\()//   ",
        "  //(__)\\\\  ",
        "  ||    ||  ",
        "            "
    ]
};
const $d2641ced5019691c$export$3bac4e187a4a8ffd = [
    "",
    "",
    "    y*                y*         y*                   y*",
    "          y*                      y*        y*                         y*",
    "  y*             y*                                         y*             y*",
    "     y*             m_m_m_",
    "                 m_m/cXcXcXm\\        y*",
    "                m/cXcXcXcXcXcXm\\m_                                    m_m_         y*",
    "  m\\m_m_    m_m_    m/cX cXcXcXcX cXcXm\\               y*          m_       m/cXcXm\\m_m_   y*",
    "      m\\m_m_m/  m\\m_m/m_m_       m\\ m\\                       m_m/cXm\\m_m_   m/cXcX cXcXcXm\\m_m_m_m_m/cXcXcXm\\",
    "    m\\  m_m_m_   m\\m/  m\\m_      m\\ m\\               m_m_   m_m/      m\\m_m/  m_m/  m-   m_m_  m-  ",
    "   r_r_r_r/   r\\r_r_r/   r\\ r\\r_r_     r\\r\\    y*        r/  r\\r_r/r/  r_ r_ r\\  r\\     r_r_  r/  r\\r_r_r_r_",
    "  r/  r_r_    r\\  r/     r\\ r\\r_   r_r/r/r_r\\r_r_r_     r_r/    r/r/           r\\r_r_r_r/  r\\r/     r_r_r/",
    "  b_b_b/b_b_b_b_b_b_b_b\\b_b_b_b_b_b_b_b_b\\b_b_b\\b_b/b_b_b_b_b_b_b_b_b\\b_ b_b/b_b_b_b_b_b/b_b_b_b_b_b_b_b_b_b_b_b_b_b/b_b_b_b_b_b_b_b\\b_b_b_b_b/b_b_b_",
    "                                    c/c|c\\",
    "     g|g|                            c/ c| c\\                         y*",
    "     g|g|      y*                    c/  c|  c\\              g|        y*g|y*",
    "  g|g| g|g|     y*g|y*                  c/   c|   c\\            g|g|g.",
    "  g|g| g|g|                         c/    c|    c\\           g`g|g|",
    "  g|g| g|g|  g|g|                    c/     c|     c\\           g|g'               g|",
    "   g\\g\\g|g|  g|g|        r*          c/      c|      c\\          g|               g|g|g.",
    "    g\\g|g| g/g/        r*g|r*        c/       c|       c\\        y;y;y;              g`g|g|",
    "     g|g|g/g/                   c/        c|        c\\            y(y(y_y)y)        g|g'",
    "     g|g|g/                   c/         c|         c\\           y(yo yoy)        g|",
    "     g|g|                   c/          c|          c\\           y\\y_y/        y;y;y;",
    "     g|g|     y_y_yQyQ       r_r_r_      y_   m_  c_c_ y_y_y_ r_",
    '    y;y;y;y;   y(y_y)y_y"y>       r|  g/g\\  y|y_y) m|m_ c(c_   y| r|r_r) g\\g_g/',
    "           y_y)           r| g/g-g-g\\ y|   m|m_ c_c_c)  y| r| r\\  g|",
    ""
];






function $0a0c617bf4bc5c84$export$f36491830a303fe5(type, name) {
    const now = new Intl.DateTimeFormat("en-US", {
        dateStyle: "long",
        timeStyle: "long",
        timeZone: "America/New_York"
    }).format(new Date());
    return {
        type: type,
        name: name,
        found: now
    };
}
function $0a0c617bf4bc5c84$export$11c1b9f01df47363(type, key) {
    let result = [];
    let set = type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).COLLECTIBLE_COMMON ? (0, $d2641ced5019691c$export$fa99cf963d65f434) : (0, $d2641ced5019691c$export$7518b3a3e015df51);
    set[key];
    result = set[key];
    return result;
}
function $0a0c617bf4bc5c84$export$84f0ff61e0acf68(type) {
    if (type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).COLLECTIBLE_COMMON) return {
        symbol: [
            (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).COLLECTIBLE_COMMON
        ],
        light: (0, $248954e6cbd64b56$export$892596cec99bc70e).COLLECTIBLE_COMMON,
        dark: (0, $248954e6cbd64b56$export$892596cec99bc70e).COLLECTIBLE_COMMON_DARK
    };
    else if (type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).COLLECTIBLE_MYTHIC) return {
        symbol: [
            (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).COLLECTIBLE_MYTHIC
        ],
        light: (0, $248954e6cbd64b56$export$892596cec99bc70e).COLLECTIBLE_MYTHIC,
        dark: (0, $248954e6cbd64b56$export$892596cec99bc70e).COLLECTIBLE_MYTHIC_DARK
    };
    return undefined;
}
function $0a0c617bf4bc5c84$export$1617645e1caec7ff(player) {
    const have = player.commonCollectibles;
    let possibles = [];
    Object.keys((0, $d2641ced5019691c$export$fa99cf963d65f434)).forEach((c)=>{
        const found = have.find((cc)=>{
            return c == cc.name;
        });
        if (found === undefined) possibles.push(c);
    });
    if (possibles.length > 0) {
        const idx = (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(0, possibles.length - 1);
        return $0a0c617bf4bc5c84$export$f36491830a303fe5((0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).COLLECTIBLE_COMMON, possibles[idx]);
    }
    return undefined;
}
function $0a0c617bf4bc5c84$export$a2b74886b4ba8bb3(player) {
    const have = player.mythicCollectibles;
    let possibles = [];
    Object.keys((0, $d2641ced5019691c$export$7518b3a3e015df51)).forEach((c)=>{
        const found = have.find((cc)=>{
            return c == cc.name;
        });
        if (found === undefined) possibles.push(c);
    });
    if (possibles.length > 0) {
        const idx = (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(0, possibles.length - 1);
        return $0a0c617bf4bc5c84$export$f36491830a303fe5((0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).COLLECTIBLE_MYTHIC, possibles[idx]);
    }
    return undefined;
}
function $0a0c617bf4bc5c84$export$c2867dfeeb3beaf9() {
    return {
        jan: undefined,
        feb: undefined,
        mar: undefined,
        apr: undefined,
        may: undefined,
        jun: undefined,
        jul: undefined,
        aug: undefined,
        sep: undefined,
        oct: undefined,
        nov: undefined,
        dec: undefined
    };
}
function $0a0c617bf4bc5c84$export$73682718bdc832e8(type) {
    return $0a0c617bf4bc5c84$export$fd176820b8063053(type) || $0a0c617bf4bc5c84$export$23f70935b329f7fd(type);
}
function $0a0c617bf4bc5c84$export$fd176820b8063053(type) {
    return type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).COLLECTIBLE_COMMON;
}
function $0a0c617bf4bc5c84$export$23f70935b329f7fd(type) {
    return type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).COLLECTIBLE_MYTHIC;
}













class $b57ed82ad2b089c0$export$c73930c4dbc20a69 extends (0, $aa947e9a2977a9e5$export$eefe978c73a9a6) {
    constructor(position, render, optic){
        const combat = {
            essence: 0,
            maxEssence: 0,
            essenceDefense: 0,
            minAttack: (0, $1a153cf88c479932$export$1c787534cb11aa3e).MAX_ENEMY_DAMAGE,
            maxAttack: (0, $1a153cf88c479932$export$1c787534cb11aa3e).MAX_ENEMY_DAMAGE,
            attackType: (0, $f0b5fa422dff3899$export$889fea6127a16d48).DEVOUR,
            attackMessage: "devoured"
        };
        super((0, $f0b5fa422dff3899$export$1a91c501cca01afe).DEVOURER, 0, combat, position, render, "trap", optic);
    }
    isAlive() {
        return true;
    }
    takeHit(_amount) {
        return 0;
    }
}





function $2de2e4dc08289f56$var$getOptic(optic) {
    const optics = [
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_RED,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_GREEN,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_BLUE,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_MAGENTA,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_CYAN,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_YELLOW
    ];
    if (optic === undefined) return undefined;
    else if (optic == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_RANDOM) return optics[(0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(0, optics.length - 1)];
    return optic;
}
// RIFT    -- static
// VOID    -- sync bounce
// BLADE   -- async bounce
// SPECTRE -- sync  path & chase
// REAVER  -- async path & chase
const $2de2e4dc08289f56$var$EnemyConfigs = {
    RIFT_ESSENCE: {
        name: "Essence Rift",
        experience: 10,
        combat: {
            essence: 6,
            maxEssence: 6,
            essenceDefense: 0,
            minAttack: 1,
            maxAttack: 2,
            attackType: (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_ESSENCE,
            attackMessage: "essence drained"
        },
        render: {
            symbol: [
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).RIFT_1,
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).RIFT_2
            ],
            light: (0, $248954e6cbd64b56$export$892596cec99bc70e).RIFT_ESSENCE,
            dark: (0, $248954e6cbd64b56$export$892596cec99bc70e).RIFT_ESSENCE_DARK
        }
    },
    RIFT_PIGMENT: {
        name: "Color Rift",
        experience: 10,
        combat: {
            essence: 6,
            maxEssence: 6,
            essenceDefense: 0,
            minAttack: 1,
            maxAttack: 1,
            attackType: (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_PIGMENT,
            attackMessage: "pigment drained"
        },
        render: {
            symbol: [
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).RIFT_1,
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).RIFT_2
            ],
            light: (0, $248954e6cbd64b56$export$892596cec99bc70e).RIFT_PIGMENT,
            dark: (0, $248954e6cbd64b56$export$892596cec99bc70e).RIFT_PIGMENT_DARK
        }
    },
    RIFT_BOTH: {
        name: "Corrupt Rift",
        experience: 12,
        combat: {
            essence: 7,
            maxEssence: 7,
            essenceDefense: 0,
            minAttack: 1,
            maxAttack: 2,
            attackType: (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_ESSENCE_AND_PIGMENT,
            attackMessage: "essence drained"
        },
        render: {
            symbol: [
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).RIFT_1,
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).RIFT_2
            ],
            light: (0, $248954e6cbd64b56$export$892596cec99bc70e).RIFT_BOTH,
            dark: (0, $248954e6cbd64b56$export$892596cec99bc70e).RIFT_BOTH_DARK
        }
    },
    SPECTRE_ESSENCE: {
        name: "Essence Spectre",
        experience: 65,
        combat: {
            essence: 29,
            maxEssence: 29,
            essenceDefense: 0,
            minAttack: 8,
            maxAttack: 12,
            attackType: (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_ESSENCE,
            attackMessage: "essence drained"
        },
        render: {
            symbol: [
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).SPECTRE_1,
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).SPECTRE_2
            ],
            light: (0, $248954e6cbd64b56$export$892596cec99bc70e).SPECTRE_ESSENCE,
            dark: (0, $248954e6cbd64b56$export$892596cec99bc70e).SPECTRE_ESSENCE_DARK
        }
    },
    SPECTRE_PIGMENT: {
        name: "Color Spectre",
        experience: 65,
        combat: {
            essence: 29,
            maxEssence: 29,
            essenceDefense: 0,
            minAttack: 1,
            maxAttack: 1,
            attackType: (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_PIGMENT,
            attackMessage: "essence drained"
        },
        render: {
            symbol: [
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).SPECTRE_1,
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).SPECTRE_2
            ],
            light: (0, $248954e6cbd64b56$export$892596cec99bc70e).SPECTRE_PIGMENT,
            dark: (0, $248954e6cbd64b56$export$892596cec99bc70e).SPECTRE_PIGMENT_DARK
        },
        optic: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_RANDOM
    },
    SPECTRE_BOTH: {
        name: "Elite Spectre",
        experience: 72,
        combat: {
            essence: 32,
            maxEssence: 32,
            essenceDefense: 0,
            minAttack: 8,
            maxAttack: 12,
            attackType: (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_ESSENCE_AND_PIGMENT,
            attackMessage: "essence drained"
        },
        render: {
            symbol: [
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).SPECTRE_1,
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).SPECTRE_2
            ],
            light: (0, $248954e6cbd64b56$export$892596cec99bc70e).SPECTRE_BOTH,
            dark: (0, $248954e6cbd64b56$export$892596cec99bc70e).SPECTRE_BOTH_DARK
        },
        optic: (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_RANDOM
    },
    REAVER_ESSENCE: {
        name: "Essence Reaver",
        experience: 90,
        combat: {
            essence: 36,
            maxEssence: 36,
            essenceDefense: 0,
            minAttack: 10,
            maxAttack: 15,
            attackType: (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_ESSENCE,
            attackMessage: "essence drained"
        },
        render: {
            symbol: [
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).REAVER_1,
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).REAVER_2
            ],
            light: (0, $248954e6cbd64b56$export$892596cec99bc70e).REAVER_ESSENCE,
            dark: (0, $248954e6cbd64b56$export$892596cec99bc70e).REAVER_ESSENCE_DARK
        }
    },
    REAVER_PIGMENT: {
        name: "Color Reaver",
        experience: 90,
        combat: {
            essence: 36,
            maxEssence: 36,
            essenceDefense: 0,
            minAttack: 1,
            maxAttack: 1,
            attackType: (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_PIGMENT,
            attackMessage: "essence drained"
        },
        render: {
            symbol: [
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).REAVER_1,
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).REAVER_2
            ],
            light: (0, $248954e6cbd64b56$export$892596cec99bc70e).REAVER_PIGMENT,
            dark: (0, $248954e6cbd64b56$export$892596cec99bc70e).REAVER_PIGMENT_DARK
        }
    },
    REAVER_BOTH: {
        name: "Elite Reaver",
        experience: 100,
        combat: {
            essence: 45,
            maxEssence: 45,
            essenceDefense: 0,
            minAttack: 10,
            maxAttack: 18,
            attackType: (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_ESSENCE_AND_PIGMENT,
            attackMessage: "essence drained"
        },
        render: {
            symbol: [
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).REAVER_1,
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).REAVER_2
            ],
            light: (0, $248954e6cbd64b56$export$892596cec99bc70e).REAVER_BOTH,
            dark: (0, $248954e6cbd64b56$export$892596cec99bc70e).REAVER_BOTH_DARK
        }
    },
    BLADE_ESSENCE: {
        name: "Essence Blade",
        experience: 29,
        combat: {
            essence: 18,
            maxEssence: 18,
            essenceDefense: 0,
            minAttack: 5,
            maxAttack: 8,
            attackType: (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_ESSENCE,
            attackMessage: "essence drained"
        },
        render: {
            symbol: [
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).BLADE_1,
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).BLADE_2
            ],
            light: (0, $248954e6cbd64b56$export$892596cec99bc70e).BLADE_ESSENCE,
            dark: (0, $248954e6cbd64b56$export$892596cec99bc70e).BLADE_ESSENCE_DARK
        }
    },
    BLADE_PIGMENT: {
        name: "Color Blade",
        experience: 29,
        combat: {
            essence: 18,
            maxEssence: 18,
            essenceDefense: 0,
            minAttack: 1,
            maxAttack: 1,
            attackType: (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_PIGMENT,
            attackMessage: "essence drained"
        },
        render: {
            symbol: [
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).BLADE_1,
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).BLADE_2
            ],
            light: (0, $248954e6cbd64b56$export$892596cec99bc70e).BLADE_PIGMENT,
            dark: (0, $248954e6cbd64b56$export$892596cec99bc70e).BLADE_PIGMENT_DARK
        }
    },
    BLADE_BOTH: {
        name: "Corrupt Blade",
        experience: 32,
        combat: {
            essence: 20,
            maxEssence: 20,
            essenceDefense: 0,
            minAttack: 5,
            maxAttack: 8,
            attackType: (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_ESSENCE_AND_PIGMENT,
            attackMessage: "essence drained"
        },
        render: {
            symbol: [
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).BLADE_1,
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).BLADE_2
            ],
            light: (0, $248954e6cbd64b56$export$892596cec99bc70e).BLADE_BOTH,
            dark: (0, $248954e6cbd64b56$export$892596cec99bc70e).BLADE_BOTH_DARK
        }
    },
    VOID_ESSENCE: {
        name: "Essence Void",
        experience: 23,
        combat: {
            essence: 8,
            maxEssence: 8,
            essenceDefense: 0,
            minAttack: 3,
            maxAttack: 5,
            attackType: (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_ESSENCE,
            attackMessage: "essence drained"
        },
        render: {
            symbol: [
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).VOID_HORZ_1,
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).VOID_HORZ_2
            ],
            light: (0, $248954e6cbd64b56$export$892596cec99bc70e).VOID_ESSENCE,
            dark: (0, $248954e6cbd64b56$export$892596cec99bc70e).VOID_ESSENCE_DARK
        }
    },
    VOID_PIGMENT: {
        name: "Color Void",
        experience: 23,
        combat: {
            essence: 8,
            maxEssence: 8,
            essenceDefense: 0,
            minAttack: 1,
            maxAttack: 1,
            attackType: (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_PIGMENT,
            attackMessage: "essence drained"
        },
        render: {
            symbol: [
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).VOID_HORZ_1,
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).VOID_HORZ_2
            ],
            light: (0, $248954e6cbd64b56$export$892596cec99bc70e).VOID_PIGMENT,
            dark: (0, $248954e6cbd64b56$export$892596cec99bc70e).VOID_PIGMENT_DARK
        }
    },
    VOID_BOTH: {
        name: "Corrupt Void",
        experience: 26,
        combat: {
            essence: 9,
            maxEssence: 9,
            essenceDefense: 0,
            minAttack: 3,
            maxAttack: 5,
            attackType: (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_ESSENCE_AND_PIGMENT,
            attackMessage: "essence drained"
        },
        render: {
            symbol: [
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).VOID_HORZ_1,
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).VOID_HORZ_2
            ],
            light: (0, $248954e6cbd64b56$export$892596cec99bc70e).VOID_BOTH,
            dark: (0, $248954e6cbd64b56$export$892596cec99bc70e).VOID_BOTH_DARK
        }
    }
};
function $2de2e4dc08289f56$export$4bf5c6c4018de228(type) {
    switch(type){
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_ESSENCE:
            return $2de2e4dc08289f56$var$EnemyConfigs.RIFT_ESSENCE;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_PIGMENT:
            return $2de2e4dc08289f56$var$EnemyConfigs.RIFT_PIGMENT;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_BOTH:
            return $2de2e4dc08289f56$var$EnemyConfigs.RIFT_BOTH;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).SPECTRE_ESSENCE:
            return $2de2e4dc08289f56$var$EnemyConfigs.SPECTRE_ESSENCE;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).SPECTRE_PIGMENT:
            return $2de2e4dc08289f56$var$EnemyConfigs.SPECTRE_PIGMENT;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).SPECTRE_BOTH:
            return $2de2e4dc08289f56$var$EnemyConfigs.SPECTRE_BOTH;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).REAVER_ESSENCE:
            return $2de2e4dc08289f56$var$EnemyConfigs.REAVER_ESSENCE;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).REAVER_PIGMENT:
            return $2de2e4dc08289f56$var$EnemyConfigs.REAVER_PIGMENT;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).REAVER_BOTH:
            return $2de2e4dc08289f56$var$EnemyConfigs.REAVER_BOTH;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_ESSENCE:
            return $2de2e4dc08289f56$var$EnemyConfigs.BLADE_ESSENCE;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_PIGMENT:
            return $2de2e4dc08289f56$var$EnemyConfigs.BLADE_PIGMENT;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_BOTH:
            return $2de2e4dc08289f56$var$EnemyConfigs.BLADE_BOTH;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_ESSENCE:
            return $2de2e4dc08289f56$var$EnemyConfigs.VOID_ESSENCE;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_PIGMENT:
            return $2de2e4dc08289f56$var$EnemyConfigs.VOID_PIGMENT;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_BOTH:
            return $2de2e4dc08289f56$var$EnemyConfigs.VOID_BOTH;
        default:
    }
    return undefined;
}
function $2de2e4dc08289f56$export$3c01d2d482c086cf(type) {
    switch(type){
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).REAVER_ESSENCE:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).REAVER_PIGMENT:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).REAVER_BOTH:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_ESSENCE:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_PIGMENT:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_BOTH:
            return true;
    }
    return false;
}
function $2de2e4dc08289f56$export$b538f9901a66528d(type) {
    switch(type){
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_ESSENCE:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_PIGMENT:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_BOTH:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).SPECTRE_ESSENCE:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).SPECTRE_PIGMENT:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).SPECTRE_BOTH:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).REAVER_ESSENCE:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).REAVER_PIGMENT:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).REAVER_BOTH:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_ESSENCE:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_PIGMENT:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_BOTH:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_ESSENCE:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_PIGMENT:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_BOTH:
            return true;
    }
    return false;
}
function $2de2e4dc08289f56$export$882a7bddd66b9432(position, spec, player) {
    const config = $2de2e4dc08289f56$export$4bf5c6c4018de228(spec.type);
    if (config === undefined) return undefined;
    let enemy = undefined;
    const fov = (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)((0, $1a153cf88c479932$export$62d95f0373aed4f6).MIN_FOV_RANGE, (0, $1a153cf88c479932$export$62d95f0373aed4f6).MAX_FOV_RANGE);
    const optic = undefined // getOptic(config.optic)
    ;
    switch(spec.type){
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_ESSENCE:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_PIGMENT:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_BOTH:
            enemy = new (0, $aa947e9a2977a9e5$export$eefe978c73a9a6)(spec.type, config.experience, config.combat, position, config.render, config.name, optic);
            break;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).SPECTRE_ESSENCE:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).SPECTRE_PIGMENT:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).SPECTRE_BOTH:
            enemy = new (0, $512bb79c6d4dfa91$export$d7113546b6694564)(spec.type, config.experience, config.combat, position, config.render, config.name, fov, optic);
            break;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).REAVER_ESSENCE:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).REAVER_PIGMENT:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).REAVER_BOTH:
            enemy = new (0, $f049ee08ee081312$export$7b6a390f24537dda)(spec.type, config.experience, config.combat, position, config.render, config.name, fov, optic);
            break;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_ESSENCE:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_PIGMENT:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_BOTH:
            enemy = new (0, $ab13c19c3aeb9f68$export$de0da80dabe2df86)(spec.type, config.experience, config.combat, position, config.render, config.name, config.direction, optic);
            break;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_ESSENCE:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_PIGMENT:
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_BOTH:
            enemy = new (0, $c0d3e0f22e872a9a$export$2dd8a177a759b9f9)(spec.type, config.experience, config.combat, position, config.render, config.name, config.direction, optic);
            break;
        default:
            break;
    }
    return enemy;
}
function $2de2e4dc08289f56$export$6c3120dd01429c5d(position, colors) {
    let name = (0, $edda5dda3fa6766c$export$2e2bcd8739ae039).getWeightedValue(Object.fromEntries(colors));
    if (name === undefined) return undefined;
    let light = (0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_YELLOW;
    let dark = (0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_DARK_YELLOW;
    let optic = (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_YELLOW;
    switch(name){
        case "red":
            light = (0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_RED;
            dark = (0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_DARK_RED;
            optic = (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_RED;
            break;
        case "magenta":
            light = (0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_MAGENTA;
            dark = (0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_DARK_MAGENTA;
            optic = (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_MAGENTA;
            break;
        case "blue":
            light = (0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_BLUE;
            dark = (0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_DARK_BLUE;
            optic = (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_BLUE;
            break;
        case "cyan":
            light = (0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_CYAN;
            dark = (0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_DARK_CYAN;
            optic = (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_CYAN;
            break;
        case "green":
            light = (0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_GREEN;
            dark = (0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_DARK_GREEN;
            optic = (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_GREEN;
            break;
        default:
            break;
    }
    const render = {
        symbol: [
            (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).DEVOURER
        ],
        light: light,
        dark: dark
    };
    return new (0, $b57ed82ad2b089c0$export$c73930c4dbc20a69)(position, render, optic);
}







class $30ba2372b2d807f2$export$ed38ddda6ae2a7ea extends (0, $51ac2b1cc9acd541$export$6d08773d2e66f8f2) {
    constructor(position){
        const render = {
            symbol: [
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).BINDER
            ],
            light: (0, $248954e6cbd64b56$export$892596cec99bc70e).BINDER,
            dark: (0, $248954e6cbd64b56$export$892596cec99bc70e).BINDER
        };
        const levelRequired = 1;
        super((0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).BINDER, levelRequired, position, render, "pigment binder");
    }
}







function $95a3e0019f5651ca$export$f8e8d6996b9c24dc(type) {
    switch(type){
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD_NONE:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).HEAD.HEAD_NONE;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD1:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).HEAD.HEAD1;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD2:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).HEAD.HEAD2;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD3:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).HEAD.HEAD3;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD4:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).HEAD.HEAD4;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD5:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).HEAD.HEAD5;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD6:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).HEAD.HEAD6;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD7:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).HEAD.HEAD7;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD8:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).HEAD.HEAD8;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO_NONE:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).TORSO.TORSO_NONE;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO1:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).TORSO.TORSO1;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO2:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).TORSO.TORSO2;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO3:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).TORSO.TORSO3;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO4:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).TORSO.TORSO4;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO5:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).TORSO.TORSO5;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO6:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).TORSO.TORSO6;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO7:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).TORSO.TORSO7;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO8:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).TORSO.TORSO8;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET_NONE:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).FEET.FEET_NONE;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET1:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).FEET.FEET1;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET2:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).FEET.FEET2;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET3:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).FEET.FEET3;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET4:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).FEET.FEET4;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET5:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).FEET.FEET5;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET6:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).FEET.FEET6;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET7:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).FEET.FEET7;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET8:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).FEET.FEET8;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO_NONE:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).GIZMO.GIZMO_NONE;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO1:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).GIZMO.GIZMO1;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO2:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).GIZMO.GIZMO2;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO3:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).GIZMO.GIZMO3;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO4:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).GIZMO.GIZMO4;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO5:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).GIZMO.GIZMO5;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON_NONE:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).WEAPON.WEAPON_NONE;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON1:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).WEAPON.WEAPON1;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON2:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).WEAPON.WEAPON2;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON3:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).WEAPON.WEAPON3;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON4:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).WEAPON.WEAPON4;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON5:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).WEAPON.WEAPON5;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON6:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).WEAPON.WEAPON6;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON7:
            return (0, $1a153cf88c479932$export$f78a7bc9efcc5615).WEAPON.WEAPON7;
    }
    return undefined;
}
function $95a3e0019f5651ca$export$adfefe58e28a2b91(item) {
    return $95a3e0019f5651ca$export$e3ce0fc4f88b9ece(item) || $95a3e0019f5651ca$export$b22d0746a791758f(item) || $95a3e0019f5651ca$export$59222e1cac6d5d6d(item);
}
function $95a3e0019f5651ca$export$e3ce0fc4f88b9ece(item) {
    return $95a3e0019f5651ca$export$f7147161cc4c402f(item) || $95a3e0019f5651ca$export$39fd1bf1c7e0a20d(item) || $95a3e0019f5651ca$export$6f5c86f1bae3a2f4(item);
}
function $95a3e0019f5651ca$export$b22d0746a791758f(item) {
    switch(item){
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON_NONE:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON1:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON2:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON3:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON4:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON5:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON6:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON7:
            return true;
    }
    return false;
}
function $95a3e0019f5651ca$export$59222e1cac6d5d6d(item) {
    switch(item){
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO_NONE:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO1:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO2:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO3:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO4:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO5:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO6:
            return true;
    }
    return false;
}
function $95a3e0019f5651ca$export$f7147161cc4c402f(item) {
    switch(item){
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD_NONE:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD1:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD2:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD3:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD4:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD5:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD6:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD7:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD8:
            return true;
    }
    return false;
}
function $95a3e0019f5651ca$export$39fd1bf1c7e0a20d(item) {
    switch(item){
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO_NONE:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO1:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO2:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO3:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO4:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO5:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO6:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO7:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO8:
            return true;
    }
    return false;
}
function $95a3e0019f5651ca$export$6f5c86f1bae3a2f4(item) {
    switch(item){
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET_NONE:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET1:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET2:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET3:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET4:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET5:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET6:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET7:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET8:
            return true;
    }
    return false;
}



class $e3fe6d379840d8da$export$671c4d75d51eb219 extends (0, $51ac2b1cc9acd541$export$6d08773d2e66f8f2) {
    constructor(type, levelRequired, position){
        const render = {
            symbol: $e3fe6d379840d8da$var$getSymbol(type),
            light: $e3fe6d379840d8da$var$getLightColor(type),
            dark: $e3fe6d379840d8da$var$getDarkColor(type)
        };
        super(type, levelRequired, position, render, $e3fe6d379840d8da$var$getName(type));
    }
}
function $e3fe6d379840d8da$var$getSymbol(type) {
    let symbol = (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).ARMAMENT;
    if ((0, $95a3e0019f5651ca$export$e3ce0fc4f88b9ece)(type)) symbol = (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).WEARABLE;
    else if ((0, $95a3e0019f5651ca$export$59222e1cac6d5d6d)(type)) symbol = (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).GIZMO;
    return [
        symbol
    ];
}
function $e3fe6d379840d8da$var$getLightColor(type) {
    let color = (0, $248954e6cbd64b56$export$892596cec99bc70e).ARMAMENT;
    if ((0, $95a3e0019f5651ca$export$e3ce0fc4f88b9ece)(type)) color = (0, $248954e6cbd64b56$export$892596cec99bc70e).WEARABLE;
    else if ((0, $95a3e0019f5651ca$export$59222e1cac6d5d6d)(type)) color = (0, $248954e6cbd64b56$export$892596cec99bc70e).GIZMO;
    return color;
}
function $e3fe6d379840d8da$var$getDarkColor(type) {
    let color = (0, $248954e6cbd64b56$export$892596cec99bc70e).ARMAMENT_DARK;
    if ((0, $95a3e0019f5651ca$export$e3ce0fc4f88b9ece)(type)) color = (0, $248954e6cbd64b56$export$892596cec99bc70e).WEARABLE_DARK;
    else if ((0, $95a3e0019f5651ca$export$59222e1cac6d5d6d)(type)) color = (0, $248954e6cbd64b56$export$892596cec99bc70e).GIZMO_DARK;
    return color;
}
function $e3fe6d379840d8da$var$getName(type) {
    const e = (0, $95a3e0019f5651ca$export$f8e8d6996b9c24dc)(type);
    if (e !== undefined) return e.name;
    else return "";
}






class $9e760da142a553a6$export$8d13340382210b65 extends (0, $51ac2b1cc9acd541$export$6d08773d2e66f8f2) {
    constructor(contents, type, position){
        const name = type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).HINT_COLLECTIBLE ? "collectible hint" : "hint";
        const render = {
            symbol: [
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).HINT
            ],
            light: (0, $248954e6cbd64b56$export$892596cec99bc70e).HINT_LIGHT,
            dark: (0, $248954e6cbd64b56$export$892596cec99bc70e).HINT_DARK
        };
        const levelRequired = 1;
        super(type, levelRequired, position, render, name), this.contents = contents;
    }
    renderText() {
        let color = (0, $248954e6cbd64b56$export$b278fa1959b09b13).MESSAGE_INFO;
        let tag = "INFO";
        if (this.type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).HINT_COLLECTIBLE) {
            color = (0, $248954e6cbd64b56$export$b278fa1959b09b13).MESSAGE_GOOD;
            tag = "COLL";
        } else if (this.type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).HINT_WARNING) {
            color = (0, $248954e6cbd64b56$export$b278fa1959b09b13).MESSAGE_WARNING;
            tag = "WARN";
        }
        return {
            text: "[" + tag + "] " + this.contents,
            color: color
        };
    }
}







class $debb5793f226d08f$export$cd0f44441c3b7719 extends (0, $51ac2b1cc9acd541$export$6d08773d2e66f8f2) {
    constructor(target, position){
        const render = {
            symbol: [
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).KEY
            ],
            light: (0, $248954e6cbd64b56$export$892596cec99bc70e).KEY,
            dark: (0, $248954e6cbd64b56$export$892596cec99bc70e).KEY_DARK
        };
        const levelRequired = 1;
        super((0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).KEY, levelRequired, position, render, "key to " + (0, $b296c6d74f581bce$export$32f6dae5310d379c)(target)), this.target = target;
    }
}






class $5c81942153c3b66e$export$753ff581ff35bf97 extends (0, $51ac2b1cc9acd541$export$6d08773d2e66f8f2) {
    constructor(type, position){
        const render = $5c81942153c3b66e$var$getOpticRenderConfig(type);
        const name = $5c81942153c3b66e$var$getOpticName(type);
        const levelRequired = 1;
        super(type, levelRequired, position, render, name);
    }
}
function $5c81942153c3b66e$var$getOpticRenderConfig(type) {
    let light = (0, $248954e6cbd64b56$export$892596cec99bc70e).ANY;
    let dark = (0, $248954e6cbd64b56$export$892596cec99bc70e).ANY_DARK;
    switch(type){
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_RED:
            light = (0, $248954e6cbd64b56$export$892596cec99bc70e).OPTIC_RED;
            dark = (0, $248954e6cbd64b56$export$892596cec99bc70e).OPTIC_RED_DARK;
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_GREEN:
            light = (0, $248954e6cbd64b56$export$892596cec99bc70e).OPTIC_GREEN;
            dark = (0, $248954e6cbd64b56$export$892596cec99bc70e).OPTIC_GREEN_DARK;
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_BLUE:
            light = (0, $248954e6cbd64b56$export$892596cec99bc70e).OPTIC_BLUE;
            dark = (0, $248954e6cbd64b56$export$892596cec99bc70e).OPTIC_BLUE_DARK;
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_MAGENTA:
            light = (0, $248954e6cbd64b56$export$892596cec99bc70e).OPTIC_MAGENTA;
            dark = (0, $248954e6cbd64b56$export$892596cec99bc70e).OPTIC_MAGENTA_DARK;
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_CYAN:
            light = (0, $248954e6cbd64b56$export$892596cec99bc70e).OPTIC_CYAN;
            dark = (0, $248954e6cbd64b56$export$892596cec99bc70e).OPTIC_CYAN_DARK;
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_YELLOW:
            light = (0, $248954e6cbd64b56$export$892596cec99bc70e).OPTIC_YELLOW;
            dark = (0, $248954e6cbd64b56$export$892596cec99bc70e).OPTIC_YELLOW_DARK;
            break;
        default:
            break;
    }
    return {
        symbol: [
            (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).OPTIC
        ],
        light: light,
        dark: dark
    };
}
function $5c81942153c3b66e$var$getOpticName(type) {
    let name = "";
    switch(type){
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_RED:
            name = "red optic";
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_GREEN:
            name = "green optic";
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_BLUE:
            name = "blue optic";
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_MAGENTA:
            name = "magenta optic";
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_CYAN:
            name = "cyan optic";
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_YELLOW:
            name = "yellow optic";
            break;
        default:
            break;
    }
    return name;
}




function $d6d4dd36e67b7d9f$export$a016f02ec78ebd6e(position) {
    return new (0, $30ba2372b2d807f2$export$ed38ddda6ae2a7ea)(position);
}
function $d6d4dd36e67b7d9f$export$a49abd71bb21d219(config, position) {
    let item = undefined;
    if ($d6d4dd36e67b7d9f$var$isNormalHint(config.type)) {
        if (config.textContents === undefined) throw new Error("Hint must have textContents");
        else if (position === undefined && config.row === undefined && config.column === undefined) throw new Error("Hint must set column+row or position argument");
        else {
            let x = 0;
            let y = 0;
            if (position !== undefined) {
                x = position.x + 1;
                y = position.y;
            } else if (config.row !== undefined && config.column !== undefined) {
                y = config.row;
                x = config.column;
            }
            const actualPosition = {
                x: x,
                y: y
            };
            item = new (0, $9e760da142a553a6$export$8d13340382210b65)(config.textContents, config.type, actualPosition);
        }
    } else if (config.type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).HINT_COLLECTIBLE) {
        if (position === undefined) throw new Error("Collectible hint must have a position");
        else if (!config.textContents) throw new Error("Collectible hint must have textContents");
        else item = new (0, $9e760da142a553a6$export$8d13340382210b65)(config.textContents, config.type, position);
    } else if (config.type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).ELIXIR) {
        if (position === undefined) throw new Error("Elixir must have a position");
        else item = new (0, $92da5905bb1565d7$export$be5c6394b8b5ed45)(position);
    } else if (config.type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).KEY) {
        if (config.keyTarget === undefined) throw new Error("Key items must have keyTarget");
        else if (position === undefined) throw new Error("Key item not given a valid position");
        else item = new (0, $debb5793f226d08f$export$cd0f44441c3b7719)(config.keyTarget, position);
    } else if ($d6d4dd36e67b7d9f$var$isOptic(config.type)) {
        if (position === undefined) throw new Error("Optic must have a position");
        else item = new (0, $5c81942153c3b66e$export$753ff581ff35bf97)(config.type, position);
    } else if ((0, $95a3e0019f5651ca$export$adfefe58e28a2b91)(config.type)) {
        if (position === undefined) throw new Error("Equipment must have a position");
        else {
            const e = (0, $95a3e0019f5651ca$export$f8e8d6996b9c24dc)(config.type);
            if (e !== undefined) {
                const levelUnlock = e.levelUnlock ? e.levelUnlock : 1;
                item = new (0, $e3fe6d379840d8da$export$671c4d75d51eb219)(config.type, levelUnlock, position);
            }
        }
    }
    return item;
}
function $d6d4dd36e67b7d9f$var$isNormalHint(type) {
    return type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).HINT_INFO || type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).HINT_WARNING;
}
function $d6d4dd36e67b7d9f$var$isOptic(type) {
    return type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_RED || type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_GREEN || type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_BLUE || type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_MAGENTA || type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_CYAN || type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_YELLOW;
}
function $d6d4dd36e67b7d9f$export$90369041977f2003(item) {
    return !item.dropNearPlayer && !item.column && !item.row;
}
function $d6d4dd36e67b7d9f$var$isPigment(type) {
    return type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).PIGMENT_RED || type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).PIGMENT_GREEN || type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).PIGMENT_BLUE || type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).PIGMENT_MAGENTA || type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).PIGMENT_CYAN || type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).PIGMENT_YELLOW;
}
function $d6d4dd36e67b7d9f$export$a6cefe4269ad87ee(item) {
    let pigment = (0, $f0b5fa422dff3899$export$b1b64d948644442b).YELLOW;
    switch(item){
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).PIGMENT_RED:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_RED:
            pigment = (0, $f0b5fa422dff3899$export$b1b64d948644442b).RED;
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).PIGMENT_MAGENTA:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_MAGENTA:
            pigment = (0, $f0b5fa422dff3899$export$b1b64d948644442b).MAGENTA;
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).PIGMENT_BLUE:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_BLUE:
            pigment = (0, $f0b5fa422dff3899$export$b1b64d948644442b).BLUE;
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).PIGMENT_CYAN:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_CYAN:
            pigment = (0, $f0b5fa422dff3899$export$b1b64d948644442b).CYAN;
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).PIGMENT_GREEN:
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_GREEN:
            pigment = (0, $f0b5fa422dff3899$export$b1b64d948644442b).GREEN;
            break;
        default:
            break;
    }
    return pigment;
}
function $d6d4dd36e67b7d9f$export$42cefdd8cf2c3f4(optic) {
    switch(optic){
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_RED:
            return (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).PIGMENT_RED;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_BLUE:
            return (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).PIGMENT_BLUE;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_GREEN:
            return (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).PIGMENT_GREEN;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_MAGENTA:
            return (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).PIGMENT_MAGENTA;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_CYAN:
            return (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).PIGMENT_CYAN;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_YELLOW:
            return (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).PIGMENT_YELLOW;
    }
    return (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_NONE;
}
function $d6d4dd36e67b7d9f$export$9ab0e2978797e6b() {
    const pigments = [
        "red",
        "green",
        "blue",
        "yellow",
        "magenta",
        "cyan"
    ];
    return pigments[(0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(0, pigments.length - 1)];
}








function $0584ddc2e3cbe9e6$export$299ae9f00a8be38d() {
    return {
        jan: $0584ddc2e3cbe9e6$var$getMaxBindersForMonth("jan"),
        feb: $0584ddc2e3cbe9e6$var$getMaxBindersForMonth("feb"),
        mar: $0584ddc2e3cbe9e6$var$getMaxBindersForMonth("mar"),
        apr: $0584ddc2e3cbe9e6$var$getMaxBindersForMonth("apr"),
        may: $0584ddc2e3cbe9e6$var$getMaxBindersForMonth("may"),
        jun: $0584ddc2e3cbe9e6$var$getMaxBindersForMonth("jun"),
        jul: $0584ddc2e3cbe9e6$var$getMaxBindersForMonth("jul"),
        aug: $0584ddc2e3cbe9e6$var$getMaxBindersForMonth("aug"),
        sep: $0584ddc2e3cbe9e6$var$getMaxBindersForMonth("sep"),
        oct: $0584ddc2e3cbe9e6$var$getMaxBindersForMonth("oct"),
        nov: $0584ddc2e3cbe9e6$var$getMaxBindersForMonth("nov"),
        dec: $0584ddc2e3cbe9e6$var$getMaxBindersForMonth("dec")
    };
}
function $0584ddc2e3cbe9e6$var$getMaxBindersForMonth(month) {
    let binders = 0;
    Object.entries((0, $70726f29900f2aba$export$d545c020b8b7b251)).every(([m, config])=>{
        if (m.substring(0, 3).toUpperCase() == month.toUpperCase()) {
            if (config.binder !== undefined) {
                binders = config.binder.maxEver;
                return false;
            }
        }
        return true;
    });
    return binders;
}
function $0584ddc2e3cbe9e6$export$904e998f31f2e9b(p1, p2) {
    return p1.x == p2.x && p1.y == p2.y;
}
function $0584ddc2e3cbe9e6$export$3185aabe0f558101(item) {
    return item == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_YELLOW || item == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_RED || item == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_MAGENTA || item == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_BLUE || item == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_CYAN || item == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_GREEN;
}
function $0584ddc2e3cbe9e6$export$ec7119b58ffe87c8(optic) {
    let output = "undefined";
    if (optic !== undefined) switch(optic){
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_RED:
            output = "red";
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_BLUE:
            output = "blue";
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_GREEN:
            output = "green";
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_MAGENTA:
            output = "magenta";
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_CYAN:
            output = "cyan";
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_YELLOW:
            output = "yellow";
            break;
    }
    return output;
}
function $0584ddc2e3cbe9e6$export$f7e588a49d664180(e) {
    return e.name;
}
function $0584ddc2e3cbe9e6$export$98bc0edab7e91143() {
    return (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)((0, $1a153cf88c479932$export$62d95f0373aed4f6).ESSENCE_DROP_MIN, (0, $1a153cf88c479932$export$62d95f0373aed4f6).ESSENCE_DROP_MAX);
}
function $0584ddc2e3cbe9e6$export$c5946c1c8844ff16(optics) {
    const pigment = (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)((0, $1a153cf88c479932$export$62d95f0373aed4f6).PIGMENT_DROP_MIN, (0, $1a153cf88c479932$export$62d95f0373aed4f6).PIGMENT_DROP_MAX);
    let pigmentItems = [];
    optics.map((o, _, pigmentItems)=>{
        pigmentItems.push((0, $d6d4dd36e67b7d9f$export$42cefdd8cf2c3f4)(o));
    });
    const pigmentType = pigmentItems[(0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(0, pigmentItems.length - 1)];
    return {
        type: pigmentType,
        amount: pigment
    };
}
function $0584ddc2e3cbe9e6$export$448332262467e042(array) {
    let currentIndex = array.length;
    while(currentIndex != 0){
        let randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex],
            array[currentIndex]
        ];
    }
}
function $0584ddc2e3cbe9e6$export$deba16b6f81aa4a3(start, current) {
    let output = "";
    let indicator = " ";
    if (current.maxEssenceAttack > start.maxEssenceAttack) indicator = "^";
    else if (current.maxEssenceAttack < start.maxEssenceAttack) indicator = "v";
    let pAttack = current.maxEssenceAttack.toString().padStart(3);
    output = "Atk: " + indicator + pAttack + ", ";
    indicator = " ";
    if (current.essenceDefense > start.essenceDefense) indicator = "^";
    else if (current.essenceDefense < start.essenceDefense) indicator = "v";
    let pEssDef = current.essenceDefense?.toString().padStart(3);
    output += "Ess def: " + indicator + pEssDef + ", ";
    indicator = " ";
    if (current.pigmentDefense > start.pigmentDefense) indicator = "^";
    else if (current.pigmentDefense < start.pigmentDefense) indicator = "v";
    let pColDef = current.pigmentDefense?.toString().padStart(3);
    output += "Col def: " + indicator + pColDef + ", ";
    indicator = " ";
    if (current.stealthRange > start.stealthRange) indicator = "^";
    else if (current.stealthRange < start.stealthRange) indicator = "v";
    let pStealth = current.stealthRange.toString().padStart(3);
    output += "Stlh: " + indicator + pStealth;
    return output;
}







function $25f08219a36211c0$export$f374c483405f4ec8(tile) {
    return tile.light.symbol == (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).DEVOURER || tile == $25f08219a36211c0$export$2307bef266fe885b;
}
const $25f08219a36211c0$export$99f00248b59b2065 = {
    walkable: true,
    dark: {
        symbol: "",
        fg: (0, $248954e6cbd64b56$export$892596cec99bc70e).FLOOR_TILE_DARK_FG,
        bg: (0, $248954e6cbd64b56$export$892596cec99bc70e).FLOOR_TILE_DARK_BG
    },
    light: {
        symbol: "",
        fg: (0, $248954e6cbd64b56$export$892596cec99bc70e).FLOOR_TILE_FG,
        bg: (0, $248954e6cbd64b56$export$892596cec99bc70e).FLOOR_TILE_BG
    },
    transparent: true,
    visible: false,
    seen: false
};
const $25f08219a36211c0$export$2307bef266fe885b = {
    walkable: false,
    dark: {
        symbol: "",
        fg: (0, $248954e6cbd64b56$export$892596cec99bc70e).WALL_TILE_DARK_FG,
        bg: (0, $248954e6cbd64b56$export$892596cec99bc70e).WALL_TILE_DARK_BG
    },
    light: {
        symbol: "",
        fg: (0, $248954e6cbd64b56$export$892596cec99bc70e).WALL_TILE_FG,
        bg: (0, $248954e6cbd64b56$export$892596cec99bc70e).WALL_TILE_BG
    },
    transparent: false,
    visible: false,
    seen: false
};
const $25f08219a36211c0$export$f05d53afeead257e = {
    walkable: true,
    dark: {
        symbol: "",
        fg: (0, $248954e6cbd64b56$export$892596cec99bc70e).DANGER_TILE_DARK,
        bg: (0, $248954e6cbd64b56$export$892596cec99bc70e).DANGER_TILE_DARK
    },
    light: {
        symbol: "",
        fg: (0, $248954e6cbd64b56$export$892596cec99bc70e).DANGER_TILE,
        bg: (0, $248954e6cbd64b56$export$892596cec99bc70e).DANGER_TILE
    },
    transparent: true,
    visible: false,
    seen: false
};
const $25f08219a36211c0$export$dbec788495c5680c = {
    walkable: true,
    dark: {
        symbol: " ",
        fg: (0, $248954e6cbd64b56$export$892596cec99bc70e).HILITE_TILE_DARK_FG,
        bg: (0, $248954e6cbd64b56$export$892596cec99bc70e).HILITE_TILE_DARK_BG
    },
    light: {
        symbol: " ",
        fg: (0, $248954e6cbd64b56$export$892596cec99bc70e).HILITE_TILE_FG,
        bg: (0, $248954e6cbd64b56$export$892596cec99bc70e).HILITE_TILE_BG
    },
    transparent: true,
    visible: false,
    seen: false
};
const $25f08219a36211c0$export$d6ce1c9bca519fc5 = {
    symbol: " ",
    fg: (0, $248954e6cbd64b56$export$b278fa1959b09b13).TAPESTRY_NOTHING,
    bg: (0, $248954e6cbd64b56$export$b278fa1959b09b13).TAPESTRY_BACKGROUND
};
const $25f08219a36211c0$export$c203f9d0903db330 = {
    symbol: " ",
    fg: (0, $248954e6cbd64b56$export$b278fa1959b09b13).TAPESTRY_NOTHING,
    bg: (0, $248954e6cbd64b56$export$b278fa1959b09b13).TAPESTRY_NOTHING
};
const $25f08219a36211c0$export$60b208235972906d = {
    symbol: " ",
    fg: (0, $248954e6cbd64b56$export$b278fa1959b09b13).GRAY,
    bg: (0, $248954e6cbd64b56$export$b278fa1959b09b13).GRAY
};
const $25f08219a36211c0$export$c3247160a5feeab2 = {
    symbol: " ",
    fg: (0, $248954e6cbd64b56$export$b278fa1959b09b13).TAPESTRY_NOTHING,
    bg: (0, $248954e6cbd64b56$export$b278fa1959b09b13).TAPESTRY_BORDER
};


class $b0909b9e9a636c9e$export$41bbd75702e612ef {
    constructor(mapID, display, player, width, height, viewportWidth, viewportHeight, enableFogOfWar){
        this.mapID = mapID;
        this.display = display;
        this.player = player;
        this.width = width;
        this.height = height;
        this.viewportWidth = viewportWidth;
        this.viewportHeight = viewportHeight;
        this.enableFogOfWar = enableFogOfWar;
        this._dropNearX = -3;
        this._dropNearXStart = -3;
        this._dropNearXStop = 2;
        this._dropNearY = -2;
        this._dropNearYStart = -2;
        this._dropNearYStop = 2;
        this._entities = [];
        this._tiles = new Array(this.height);
        for(let y = 0; y < this.height; y++){
            const row = new Array(this.width);
            for(let x = 0; x < this.width; x++)row[x] = {
                ...(0, $25f08219a36211c0$export$2307bef266fe885b)
            };
            this._tiles[y] = row;
        }
    }
    destroy() {
        this._entities.forEach((stack)=>{
            stack.stack.forEach((e)=>{
                if (e instanceof (0, $c0d3e0f22e872a9a$export$2dd8a177a759b9f9) || e instanceof (0, $f049ee08ee081312$export$7b6a390f24537dda)) e.stopTimer();
            });
        });
    }
    get toString() {
        return (0, $b296c6d74f581bce$export$32f6dae5310d379c)(this.mapID);
    }
    placeBinder(binder, max, rooms) {
        const amount = (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(binder.minMap, binder.maxMap);
        let placed = 0;
        let placedIdx = [];
        while(placed < amount && placed < max){
            let idx = (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(1, rooms.length - 1);
            while(idx in placedIdx)idx = (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(1, rooms.length - 1);
            placedIdx.push(idx);
            const bounds = rooms[idx].bounds;
            while(true){
                const x = (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(bounds.x1 + 1, bounds.x2 - 1);
                const y = (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(bounds.y1 + 1, bounds.y2 - 1);
                if (this.canPlace({
                    x: x,
                    y: y
                })) {
                    const position = {
                        x: x,
                        y: y
                    };
                    this.addEntity((0, $d6d4dd36e67b7d9f$export$a016f02ec78ebd6e)(position));
                    placed += 1;
                    break;
                }
            }
        }
    }
    shouldPlaceCollectible() {
        // common
        if (!this.player.hasCommonCollectible(this.mapID)) {
            const prob = (0, $0eb0e6f5b56b7df1$export$dd9aaf1372304467)();
            if (prob < (0, $1a153cf88c479932$export$ba8e7803d5f50f58).COMMON) return (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).COLLECTIBLE_COMMON;
        }
        // mythic
        if (!this.player.hasMythicCollectible(this.mapID)) {
            const prob = (0, $0eb0e6f5b56b7df1$export$dd9aaf1372304467)();
            if (prob < (0, $1a153cf88c479932$export$ba8e7803d5f50f58).MYTHIC) return (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).COLLECTIBLE_MYTHIC;
        }
        return (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).NONE;
    }
    placeCollectible(type, position) {
        const render = (0, $0a0c617bf4bc5c84$export$84f0ff61e0acf68)(type);
        if (render === undefined) return;
        let name = type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).COLLECTIBLE_COMMON ? "common" : "mythic";
        name += " collectible";
        const item = new (0, $51ac2b1cc9acd541$export$6d08773d2e66f8f2)(type, (0, $1a153cf88c479932$export$2ef8aa71201ee06b).MIN_REQ_LEVEL, position, render, name);
        this.addEntity(item);
    }
    placeEnemies(enemies, rooms) {
        enemies.forEach((e)=>{
            let placed = 0;
            let placedIdx = [];
            let idx = Array.from(rooms.keys());
            (0, $0584ddc2e3cbe9e6$export$448332262467e042)(idx);
            for(let i = 0; i < idx.length; ++i){
                placed += this.placeEnemy(rooms[idx[i]], e);
                if (placed >= e.mapMax) break;
            }
        });
    }
    placeEquipment(equip, rooms) {
        this.placeItems(equip, rooms);
    }
    placeItems(items, rooms) {
        if (items !== undefined && items.length > 0) {
            // drops are placed in a "box" around the player
            // 0: LR across the top of the box
            // 1: OR across the bottom of the box
            // 2: TB left side of box
            // 3: TB right side of box
            let dropPlacement = 0;
            for(let x = 0; x < items.length; ++x){
                const i = items[x];
                if (this.player.hasMapItem(i)) continue;
                let times = 1;
                if (i.minMax !== undefined) times = (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(i.minMax.min, i.minMax.max);
                let position = undefined;
                let item = undefined;
                for(let t = 0; t < times; ++t){
                    if ((0, $d6d4dd36e67b7d9f$export$90369041977f2003)(i)) {
                        const idx = (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(0, rooms.length - 1);
                        position = this.placeItem(rooms[idx]);
                    } else {
                        if (i.dropNearPlayer !== undefined) {
                            position = {
                                x: this.player.position.x + this._dropNearX,
                                y: this.player.position.y + this._dropNearY
                            };
                            if (dropPlacement == 0) {
                                // top of box
                                this._dropNearX += 1;
                                if (this._dropNearX == this._dropNearXStop) {
                                    this._dropNearX = this._dropNearXStart;
                                    this._dropNearY = this._dropNearYStop;
                                    dropPlacement += 1;
                                }
                            } else if (dropPlacement == 1) {
                                // bottom of box
                                this._dropNearX += 1;
                                if (this._dropNearX == this._dropNearXStop) {
                                    this._dropNearX = this._dropNearXStart;
                                    this._dropNearY = this._dropNearYStart + 1;
                                    dropPlacement += 1;
                                }
                            } else if (dropPlacement == 2) {
                                // left side of box
                                this._dropNearY += 1;
                                if (this._dropNearY == this._dropNearYStop - 1) {
                                    this._dropNearX = this._dropNearXStop;
                                    this._dropNearY = this._dropNearYStart + 1;
                                    dropPlacement += 1;
                                }
                            } else if (dropPlacement == 3) {
                                // right side of box
                                this._dropNearY += 1;
                                if (this._dropNearY == this._dropNearYStop - 1) {
                                    // unlikely, but this will restart at top of box
                                    this._dropNearX = this._dropNearXStart;
                                    this._dropNearY = this._dropNearYStart;
                                    dropPlacement = 0;
                                }
                            }
                        } else if (i.column !== undefined && i.row !== undefined) position = {
                            x: i.column,
                            y: i.row
                        };
                    }
                    if (position !== undefined) {
                        item = (0, $d6d4dd36e67b7d9f$export$a49abd71bb21d219)(i, position);
                        if (item !== undefined) this.addEntity(item);
                    }
                }
            }
        }
    }
    placePigments(palette, rooms) {
        Object.entries(palette).forEach(([color, config])=>{
            let placed = 0;
            let placedIdx = [];
            let idx = Array.from(rooms.keys());
            (0, $0584ddc2e3cbe9e6$export$448332262467e042)(idx);
            for(let i = 0; i < idx.length; ++i){
                placed += this.placePigment(rooms[idx[i]], color, config.range.min, config.range.max);
                if (placed >= config.mapMax) break;
            }
        });
    }
    placePopups(popups, rooms) {
        popups.forEach((p)=>{
            this.addEntity(new (0, $cb91172ccfffa818$export$95d4acdbab2fc6ef)(p.target, {
                x: p.column,
                y: p.row
            }));
        });
    }
    placePortals(portals, rooms) {
        if (portals.length == 0) throw new Error("Map must have a portal to somewhere");
        portals.forEach((portal)=>{
            this.placePortal(rooms[portal.room].center, portal.target);
        });
        const startPoint = rooms[portals[0].room].center;
        return startPoint;
    }
    addMazeRooms(mazeRooms, rooms) {
        let mazeRoomIndexes = [];
        mazeRooms.forEach((room)=>{
            const mazeRoomIndex = this.addMazeRoom(room, rooms);
            mazeRoomIndexes.push(mazeRoomIndex);
        });
        return mazeRoomIndexes;
    }
    addRoom(x, y, roomTiles) {
        for(let curY = y; curY < y + roomTiles.length; curY++){
            const mapRow = this._tiles[curY];
            const roomRow = roomTiles[curY - y];
            for(let curX = x; curX < x + roomRow.length; curX++){
                mapRow[curX] = roomRow[curX - x];
                if (!this.enableFogOfWar) mapRow[curX].visible = true;
            }
        }
    }
    addMazeRoom(roomOptions, rooms) {
        let prefabIndex = (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(0, (0, $fb83a523a87c4ade$export$298ba07e5203e3b7).length - 1);
        if (roomOptions.prefabSelection !== undefined) prefabIndex = roomOptions.prefabSelection;
        const prefab = (0, $fb83a523a87c4ade$export$298ba07e5203e3b7)[prefabIndex];
        // avoid rooms[0] since this will have the portal
        const mazeRoomIndex = (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(1, rooms.length - 1);
        const room = rooms[mazeRoomIndex];
        for(let y = 0; y < prefab.length; ++y)for(let x = 0; x < prefab[y].length; ++x){
            if (prefab[y][x] == (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).DEVOURER) {
                const trap = (0, $2de2e4dc08289f56$export$6c3120dd01429c5d)({
                    x: room.x + x + (0, $fb83a523a87c4ade$export$6c05c5050be0f1f7).BORDER,
                    y: room.y + y + (0, $fb83a523a87c4ade$export$6c05c5050be0f1f7).BORDER
                }, roomOptions.colors);
                if (trap !== undefined) this.addEntity(trap);
            } else if (prefab[y][x] == (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).ITEM) {
                const position = {
                    x: room.x + x + (0, $fb83a523a87c4ade$export$6c05c5050be0f1f7).BORDER,
                    y: room.y + y + (0, $fb83a523a87c4ade$export$6c05c5050be0f1f7).BORDER
                };
                let item = this.shouldPlaceCollectible();
                if (item == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).NONE) {
                    const entity = $b0909b9e9a636c9e$var$buildItem(position.x, position.y, (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).PIGMENT_RANDOM, (0, $1a153cf88c479932$export$82c0c1b9df90530f));
                    if (entity) this.addEntity(entity);
                } else this.placeCollectible(item, position);
            }
            this._tiles[room.y + y + (0, $fb83a523a87c4ade$export$6c05c5050be0f1f7).BORDER][room.x + x + (0, $fb83a523a87c4ade$export$6c05c5050be0f1f7).BORDER] = {
                ...(0, $25f08219a36211c0$export$f05d53afeead257e)
            };
        }
        return mazeRoomIndex;
    }
    canWalk(x, y) {
        return this._tiles[y][x].walkable;
    }
    hasBlockingEntity(stack) {
        if (stack.length == 0) return false;
        else return stack[0].blocks;
    }
    // Add an Entity to the stack at e.y, e.x.
    //   A stack can only have a single blocking Entity,
    //   and that Entity will be at the "top" [0] of the stack.
    addEntity(e) {
        for(let i = 0; i < this._entities.length; ++i){
            const group = this._entities[i];
            if (group.position.x == e.position.x && group.position.y == e.position.y) {
                if (e.blocks) {
                    if (this.hasBlockingEntity(group.stack)) return false;
                    else {
                        // put blocking entity on "top"
                        group.stack.unshift(e);
                        return true;
                    }
                } else {
                    // this entity can go on the "bottom"
                    group.stack.push(e);
                    return true;
                }
            }
        }
        // new stack
        this._entities.push({
            position: e.position,
            stack: [
                e
            ]
        });
        return true;
    }
    findEntities(position) {
        let entities = [];
        for(let i = 0; i < this._entities.length; ++i){
            const group = this._entities[i];
            if (group.stack && (0, $0584ddc2e3cbe9e6$export$904e998f31f2e9b)(position, group.position)) group.stack.forEach((s)=>{
                entities.push(s);
            });
        }
        return entities;
    }
    findInteractables(position, direction) {
        let targetX = position.x;
        let targetY = position.y;
        switch(direction){
            case (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).UP:
                targetY = position.y - 1;
                break;
            case (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).DOWN:
                targetY = position.y + 1;
                break;
            case (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).RIGHT:
                targetX = position.x + 1;
                break;
            case (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).LEFT:
                targetX = position.x - 1;
                break;
            default:
                break;
        }
        return this.findEntities({
            x: targetX,
            y: targetY
        });
    }
    placeResidues() {
        // place the corpses on top, so corpses render over top
        //   i.e., other items are underneath and not visible
        for(let i = 0; i < this._entities.length; ++i){
            const group = this._entities[i];
            if (group.stack) for(let j = 0; j < group.stack.length; ++j){
                const e = group.stack[j];
                if (e.baseClass == "Enemy") {
                    const enemy = e;
                    if (!enemy.isAlive()) {
                        group.stack.splice(j, 1);
                        group.stack.unshift(new (0, $d66f070054175cf7$export$4aa8d1180ba213b0)(enemy.position, enemy.displayName));
                        return;
                    }
                }
            }
        }
    }
    removeTopmostEntity(position) {
        for(let i = 0; i < this._entities.length; ++i){
            const group = this._entities[i];
            if ((0, $0584ddc2e3cbe9e6$export$904e998f31f2e9b)(position, group.position) && group.stack) {
                group.stack.splice(0, 1);
                return;
            }
        }
    }
    removeItem(position, type) {
        for(let i = 0; i < this._entities.length; ++i){
            const group = this._entities[i];
            if ((0, $0584ddc2e3cbe9e6$export$904e998f31f2e9b)(position, group.position) && group.stack) for(let j = 0; j < group.stack.length; ++j){
                const e = group.stack[j];
                if (e.type == type) {
                    group.stack.splice(j, 1);
                    return;
                }
            }
        }
    }
    removeEntities(position) {
        for(let i = 0; i < this._entities.length; ++i){
            const group = this._entities[i];
            if ((0, $0584ddc2e3cbe9e6$export$904e998f31f2e9b)(position, group.position)) {
                this._entities.splice(i, 1);
                return;
            }
        }
    }
    inBounds(x, y) {
        return x >= 0 && x < this.width && y >= 0 && y < this.height && this.canWalk(x, y);
    }
    isVisible(x, y) {
        if (this._tiles[y] === undefined || (this._tiles[y][x], false)) return false;
        return this._tiles[y][x].visible;
    }
    lightPasses(x, y) {
        if (this.inBounds(x, y)) return this._tiles[y][x].transparent;
        return false;
    }
    get pathSyncEnemies() {
        let chasers = [];
        this._entities.forEach((group)=>{
            if (group.stack) {
                const moreChasers = group.stack.filter((e)=>e instanceof (0, $512bb79c6d4dfa91$export$d7113546b6694564)).map((e)=>e).filter((e)=>e.isAlive());
                chasers = chasers.concat(moreChasers);
            }
        });
        return chasers;
    }
    get bounceSyncEnemies() {
        let chasers = [];
        this._entities.forEach((group)=>{
            if (group.stack) {
                const moreChasers = group.stack.filter((e)=>e instanceof (0, $ab13c19c3aeb9f68$export$de0da80dabe2df86)).map((e)=>e).filter((e)=>e.isAlive());
                chasers = chasers.concat(moreChasers);
            }
        });
        return chasers;
    }
    canPlace(position) {
        return !this._entities.some((e)=>(0, $0584ddc2e3cbe9e6$export$904e998f31f2e9b)(e.position, position)) && !(0, $0584ddc2e3cbe9e6$export$904e998f31f2e9b)(position, this.player.position);
    }
    placePigment(room, color, min, max) {
        const bounds = room.bounds;
        const toPlace = (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(min, max);
        let placed = 0;
        while(placed < toPlace){
            const x = (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(bounds.x1 + 1, bounds.x2 - 1);
            const y = (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(bounds.y1 + 1, bounds.y2 - 1);
            if (this.canPlace({
                x: x,
                y: y
            })) {
                const position = {
                    x: x,
                    y: y
                };
                this.addEntity(new (0, $517927198014b318$export$6d91f4614964de77)(color, position));
                placed += 1;
            }
        }
        return placed;
    }
    placeItem(room) {
        const bounds = room.bounds;
        let tries = 0;
        while(tries < (0, $1a153cf88c479932$export$9d673184e63711e0).MAX_RANDOM_ITEM_PLACEMENT_TRIES){
            const x = (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(bounds.x1 + 1, bounds.x2 - 1);
            const y = (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(bounds.y1 + 1, bounds.y2 - 1);
            if (this.canPlace({
                x: x,
                y: y
            })) return {
                x: x,
                y: y
            };
            tries += 1;
        }
        return undefined;
    }
    placeEnemy(room, enemy) {
        const bounds = room.bounds;
        const toPlace = (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(enemy.min, enemy.max);
        let placed = 0;
        while(placed < toPlace){
            const x = (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(bounds.x1 + 1, bounds.x2 - 1);
            const y = (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(bounds.y1 + 1, bounds.y2 - 1);
            if (this.canPlace({
                x: x,
                y: y
            })) {
                const position = {
                    x: x,
                    y: y
                };
                const nextEnemy = (0, $2de2e4dc08289f56$export$882a7bddd66b9432)(position, enemy, this.player);
                if (nextEnemy) {
                    this.addEntity(nextEnemy);
                    window.engine.addBeastToBestiary(enemy.type);
                    placed += 1;
                }
            }
        }
        return placed;
    }
    placePortal(position, mapID) {
        this.addEntity(new (0, $cdaf355186b7e8f3$export$ee92a44c6f1de009)(mapID, position));
    }
    getCameraOffsets(position) {
        let half = this.viewportWidth / 2;
        let cameraX = position.x - half;
        if (position.x < half) cameraX = 0;
        else if (position.x > this.width - half) cameraX = this.width - this.viewportWidth;
        half = this.viewportHeight / 2;
        let cameraY = position.y - half;
        if (position.y < half) cameraY = 0;
        else if (position.y >= this.height - half) cameraY = this.height - this.viewportHeight;
        return {
            xOffset: cameraX,
            yOffset: cameraY
        };
    }
    clearTile(x, y, display, player) {
        const camera = this.getCameraOffsets(player.position);
        const row = this._tiles[y];
        const tile = row[x];
        if (tile.visible) display.draw(camera.xOffset + x, camera.yOffset + y, ".", tile.light.fg, tile.light.bg);
        else display.draw(camera.xOffset + x, camera.yOffset + y, ".", tile.dark.fg, tile.dark.bg);
    }
    getCollectibleCount() {
        let count = 0;
        this._entities.forEach((stack)=>{
            stack.stack.forEach((e)=>{
                if (e instanceof (0, $51ac2b1cc9acd541$export$6d08773d2e66f8f2) && (0, $0a0c617bf4bc5c84$export$73682718bdc832e8)(e.type)) count += 1;
            });
        });
        return count;
    }
    getEnemyCount() {
        let count = 0;
        this._entities.forEach((stack)=>{
            stack.stack.forEach((e)=>{
                if (e.baseClass == "Enemy") count += 1;
            });
        });
        return count;
    }
    getItemCount() {
        let count = 0;
        this._entities.forEach((stack)=>{
            stack.stack.forEach((e)=>{
                if (e instanceof (0, $51ac2b1cc9acd541$export$6d08773d2e66f8f2) && !(0, $f0b5fa422dff3899$export$4881cbfa38820e12)(e.type) && !(0, $0a0c617bf4bc5c84$export$73682718bdc832e8)(e.type)) count += 1;
            });
        });
        return count;
    }
    getPigmentCount() {
        let count = 0;
        this._entities.forEach((stack)=>{
            stack.stack.forEach((e)=>{
                if (e instanceof (0, $51ac2b1cc9acd541$export$6d08773d2e66f8f2) && (0, $f0b5fa422dff3899$export$4881cbfa38820e12)(e.type)) count += 1;
            });
        });
        return count;
    }
    render() {
        const camera = this.getCameraOffsets(this.player.position);
        for(let y = 0; y < this.viewportHeight; y++){
            const row = this._tiles[camera.yOffset + y];
            for(let x = 0; x < this.viewportWidth; x++){
                const tile = row[camera.xOffset + x];
                if (window.debug) this.debugDraw({
                    x: x,
                    y: y
                }, tile);
                else this.fovDraw({
                    x: x,
                    y: y
                }, tile);
            }
        }
        this._entities.forEach((group)=>{
            if (group.stack.length > 0) {
                const entity = group.stack[0];
                this.renderEntity(entity, camera);
            }
        });
        return camera;
    }
    getEnemyAtPosition(pos) {
        for(let i = 0; i < this._entities.length; ++i){
            const group = this._entities[i];
            for(let j = 0; j < group.stack.length; ++j){
                const entity = group.stack[j];
                if (entity.position.x == pos.x && entity.position.y == pos.y) return entity;
            }
        }
        return undefined;
    }
    renderEntity(e, cameraOffset) {
        let camera = cameraOffset;
        if (camera === undefined) camera = this.getCameraOffsets(this.player.position);
        if (window.debug) {
            const render = e.renderLight();
            this.display.drawOver(e.position.x - camera.xOffset, e.position.y - camera.yOffset, render.symbol, render.color, null);
        } else if (e.optic !== undefined) this.renderOpticEntity(e, camera);
        else this.renderNonOpticEntity(e, camera);
    }
    updateFov() {
        if (this.enableFogOfWar) {
            for(let y = 0; y < this.height; y++)for(let x = 0; x < this.width; x++)this._tiles[y][x].visible = false;
            const fov = new (0, $9976061c5a87d4df$export$2e2bcd8739ae039).PreciseShadowcasting(this.lightPasses.bind(this));
            fov.compute(this.player.position.x, this.player.position.y, this.player.vision, (x, y, _r, visibility)=>{
                if (visibility === 1) {
                    this._tiles[y][x].visible = true;
                    this._tiles[y][x].seen = true;
                    const enemy = this.getEnemyAtPosition({
                        x: x,
                        y: y
                    });
                    if (enemy !== undefined) window.engine.seeBeast(enemy.type);
                }
            });
        }
    }
    renderOpticEntity(e, offset) {
        if (e.optic !== undefined && this.player.hasVision(e.optic)) {
            let render = undefined;
            if (this._tiles[e.position.y][e.position.x].visible) render = e.renderLight();
            else if (this._tiles[e.position.y][e.position.x].seen) render = e.renderDark();
            if (render !== undefined) this.display.drawOver(e.position.x - offset.xOffset, e.position.y - offset.yOffset, render.symbol, render.color, null);
        }
    }
    renderNonOpticEntity(e, offset) {
        let render = undefined;
        if (this._tiles[e.position.y][e.position.x].visible) render = e.renderLight();
        else if (this._tiles[e.position.y][e.position.x].seen) render = e.renderDark();
        if (render !== undefined) this.display.drawOver(e.position.x - offset.xOffset, e.position.y - offset.yOffset, render.symbol, render.color, null);
    }
    debugDraw(position, tile) {
        this.display.draw(position.x, position.y, tile.light.symbol, tile.light.fg, tile.light.bg);
    }
    fovDraw(position, tile) {
        let symbol = (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).BLANK;
        let fg = (0, $248954e6cbd64b56$export$892596cec99bc70e).BLACK;
        let bg = (0, $248954e6cbd64b56$export$892596cec99bc70e).BLACK;
        if (tile.visible) {
            symbol = tile.light.symbol;
            fg = tile.light.fg;
            bg = tile.light.bg;
        } else if (tile.seen) {
            symbol = tile.dark.symbol;
            fg = tile.dark.fg;
            bg = tile.dark.bg;
        }
        this.display.draw(position.x, position.y, symbol, fg, bg);
    }
}
function $b0909b9e9a636c9e$export$1b54bd80463a60ae(room, loc) {
    let position = room.topCenter;
    switch(loc){
        case (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).RIGHT_CENTER:
            position = room.rightCenter;
            break;
        case (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).BOTTOM_CENTER:
            position = room.bottomCenter;
            break;
        case (0, $f0b5fa422dff3899$export$fc131e7dfc19bffe).LEFT_CENTER:
            position = room.leftCenter;
            break;
        default:
            break;
    }
    return position;
}
function $b0909b9e9a636c9e$var$buildItem(x, y, type, amount) {
    const position = {
        x: x,
        y: y
    };
    let item = undefined;
    switch(type){
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).ELIXIR:
            item = new (0, $92da5905bb1565d7$export$be5c6394b8b5ed45)(position);
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).PIGMENT_RANDOM:
            item = new (0, $3ef95fa959568bd4$export$9e1c3038ae586738)((0, $d6d4dd36e67b7d9f$export$9ab0e2978797e6b)(), position, amount);
            break;
        default:
            break;
    }
    return item;
}


class $6e99b65e9f82c196$export$1d61da4fb9a8035b extends (0, $b0909b9e9a636c9e$export$41bbd75702e612ef) {
    constructor(mapData, mapID, display, player, offsets){
        const viewportWidth = mapData.viewportWidth ? mapData.viewportWidth : (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_VIEWPORT_WIDTH;
        const viewportHeight = mapData.viewportHeight ? mapData.viewportHeight : (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_VIEWPORT_HEIGHT;
        super(mapID, display, player, mapData.width, mapData.height, viewportWidth, viewportHeight, mapData.enableFogOfWar);
        // 1. Build rooms
        let rooms = this.buildRooms(offsets, mapData.randomOptions);
        // 2. Add maze room(s)
        if (mapData.mazeRooms !== undefined) {
            const mazeRoomIndexes = this.addMazeRooms(mapData.mazeRooms, rooms);
            // exclude maze rooms for rest of build
            rooms = rooms.filter((_, idx)=>mazeRoomIndexes.includes(idx) == false);
        }
        // 3. Place portals
        let startPoint = this.placePortals(mapData.portals, rooms);
        // 4. Place the player (+1 to move right of the portal)
        startPoint.x += 1;
        this.player.setPosition(startPoint);
        // 5. Place pigments
        if (mapData.palette !== undefined) this.placePigments(mapData.palette, rooms);
        // 6. Place items
        if (mapData.items !== undefined) this.placeItems(mapData.items, rooms);
        // 7. Place binders
        if (mapData.binder !== undefined) {
            const diff = mapData.binder.maxEver - this.player.getBindersCollected(this.mapID);
            if (diff > 0) this.placeBinder(mapData.binder, diff, rooms);
            else window.engine.sendMessage("You have found all of the binders for " + (0, $b296c6d74f581bce$export$32f6dae5310d379c)(this.mapID));
        }
        // 8. Place equipment
        if (mapData.equipment !== undefined) this.placeEquipment(mapData.equipment, rooms);
        // 9. Place enemies
        if (mapData.enemies !== undefined) {
            const result = this.placeEnemies(mapData.enemies, rooms);
        }
    }
    buildRooms(offsets, options) {
        let rooms;
        let tiles;
        [rooms, tiles] = (0, $b296c6d74f581bce$export$acb17e9331e64c57)(this.width - offsets.xOffset * 2, this.height - offsets.yOffset * 2, options.roomWidthRange, options.roomHeightRange, options.maxFillPercentage, options.timeLimit);
        window.engine.displayRandomRoomsGenerated(rooms.length);
        // fix tiles for offets
        for(let y = 0; y < tiles.length; ++y)for(let x = 0; x < tiles[y].length; ++x)this._tiles[y + offsets.yOffset][x + offsets.xOffset] = tiles[y][x];
        // fix rooms, accounting for offets
        rooms.forEach((room)=>{
            room.x += offsets.xOffset;
            room.y += offsets.yOffset;
        });
        return rooms;
    }
}



class $482590bcd9882d9a$export$525628e68e798fb4 {
    static fromTiles(x, y, tiles) {
        if (tiles.length == 0 || tiles[0].length == 0) throw new Error("Invalid tileset for creating Room instance");
        let room = new this(x, y, tiles[0].length, tiles.length);
        room._tiles = tiles;
        return room;
    }
    constructor(x, y, width, height, label){
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.label = label;
        this._tiles = [];
        this.buildRoom();
    }
    get bounds() {
        return {
            x1: this.x,
            y1: this.y,
            x2: this.x + this.width,
            y2: this.y + this.height
        };
    }
    buildRoom() {
        this._tiles = new Array(this.height);
        for(let y = 0; y < this.height; y++){
            const row = new Array(this.width);
            for(let x = 0; x < this.width; x++){
                const isWall = x === 0 || x === this.width - 1 || y === 0 || y === this.height - 1;
                row[x] = isWall ? {
                    ...(0, $25f08219a36211c0$export$2307bef266fe885b)
                } : {
                    ...(0, $25f08219a36211c0$export$99f00248b59b2065)
                };
            }
            this._tiles[y] = row;
        }
    }
    intersects(other) {
        return this.x <= other.x + other.width && this.x + this.width >= other.x && this.y <= other.y + other.height && this.y + this.width >= other.y;
    }
    get center() {
        const x = this.x + Math.floor(this.width / 2);
        const y = this.y + Math.floor(this.height / 2);
        return {
            x: x,
            y: y
        };
    }
    get topCenter() {
        const x = this.x + Math.floor(this.width / 2);
        const y = this.y;
        return {
            x: x,
            y: y
        };
    }
    get rightCenter() {
        const x = this.x + this.width - 1;
        const y = this.y + Math.floor(this.height / 2);
        return {
            x: x,
            y: y
        };
    }
    get bottomCenter() {
        const x = this.x + Math.floor(this.width / 2);
        const y = this.y + this.height - 1;
        return {
            x: x,
            y: y
        };
    }
    get leftCenter() {
        const x = this.x;
        const y = this.y + Math.floor(this.height / 2);
        return {
            x: x,
            y: y
        };
    }
    get tiles() {
        return this._tiles;
    }
}


/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $77dc29417ac8d032$export$e67a095c620b86fe(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}
var // Fallback for modularized imports:
$77dc29417ac8d032$export$2e2bcd8739ae039 = $77dc29417ac8d032$export$e67a095c620b86fe;


function $6a377fdb36b5bd3e$export$fe114145ae75d197(dateLeft, dateRight) {
    const _dateLeft = (0, $77dc29417ac8d032$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $77dc29417ac8d032$export$e67a095c620b86fe)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
var // Fallback for modularized imports:
$6a377fdb36b5bd3e$export$2e2bcd8739ae039 = $6a377fdb36b5bd3e$export$fe114145ae75d197;

/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $e24aa25ccaa7cb1c$export$dfd9b671c89acc8e = 7;
const $e24aa25ccaa7cb1c$export$3913210603d8e9ae = 365.2425;
const $e24aa25ccaa7cb1c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $e24aa25ccaa7cb1c$export$4dec998e48f9c246 = -$e24aa25ccaa7cb1c$export$81caae6e1cc7a622;
const $e24aa25ccaa7cb1c$export$4fad13613e88edc8 = 604800000;
const $e24aa25ccaa7cb1c$export$b76b1809a2898f9a = 86400000;
const $e24aa25ccaa7cb1c$export$91246f0b9bd9beff = 60000;
const $e24aa25ccaa7cb1c$export$7f72910d6dfd237a = 3600000;
const $e24aa25ccaa7cb1c$export$397c2d5776aa9055 = 1000;
const $e24aa25ccaa7cb1c$export$3633035e63cee86a = 525600;
const $e24aa25ccaa7cb1c$export$ab7da2ccd1075c38 = 43200;
const $e24aa25ccaa7cb1c$export$2423174df8cd3cd2 = 1440;
const $e24aa25ccaa7cb1c$export$f2f5ae5a8e2d8f9f = 60;
const $e24aa25ccaa7cb1c$export$3c58128db900d44e = 3;
const $e24aa25ccaa7cb1c$export$80d7e435f744f319 = 12;
const $e24aa25ccaa7cb1c$export$4db7641526e3241f = 4;
const $e24aa25ccaa7cb1c$export$698aec755e92c695 = 3600;
const $e24aa25ccaa7cb1c$export$a77c1a7ebebe2a5a = 60;
const $e24aa25ccaa7cb1c$export$815a9362476d2fe3 = $e24aa25ccaa7cb1c$export$698aec755e92c695 * 24;
const $e24aa25ccaa7cb1c$export$34804a017b31e2fe = $e24aa25ccaa7cb1c$export$815a9362476d2fe3 * 7;
const $e24aa25ccaa7cb1c$export$7271e9e3478110d1 = $e24aa25ccaa7cb1c$export$815a9362476d2fe3 * $e24aa25ccaa7cb1c$export$3913210603d8e9ae;
const $e24aa25ccaa7cb1c$export$8e6600bbdee7dabb = $e24aa25ccaa7cb1c$export$7271e9e3478110d1 / 12;
const $e24aa25ccaa7cb1c$export$be1dccf2de902d31 = $e24aa25ccaa7cb1c$export$8e6600bbdee7dabb * 3;


function $b2d0c66f58a40ae9$export$4393d2ccbbedb219(argument, options) {
    const additionalDigits = options?.additionalDigits ?? 2;
    const dateStrings = $b2d0c66f58a40ae9$var$splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = $b2d0c66f58a40ae9$var$parseYear(dateStrings.date, additionalDigits);
        date = $b2d0c66f58a40ae9$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    const timestamp = date.getTime();
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = $b2d0c66f58a40ae9$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $b2d0c66f58a40ae9$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        const dirtyDate = new Date(timestamp + time);
        // JS parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        const result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
const $b2d0c66f58a40ae9$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const $b2d0c66f58a40ae9$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const $b2d0c66f58a40ae9$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const $b2d0c66f58a40ae9$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $b2d0c66f58a40ae9$var$splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split($b2d0c66f58a40ae9$var$patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($b2d0c66f58a40ae9$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($b2d0c66f58a40ae9$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = $b2d0c66f58a40ae9$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $b2d0c66f58a40ae9$var$parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $b2d0c66f58a40ae9$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match($b2d0c66f58a40ae9$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = $b2d0c66f58a40ae9$var$parseDateUnit(captures[1]);
    const month = $b2d0c66f58a40ae9$var$parseDateUnit(captures[2]) - 1;
    const day = $b2d0c66f58a40ae9$var$parseDateUnit(captures[3]);
    const week = $b2d0c66f58a40ae9$var$parseDateUnit(captures[4]);
    const dayOfWeek = $b2d0c66f58a40ae9$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$b2d0c66f58a40ae9$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $b2d0c66f58a40ae9$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!$b2d0c66f58a40ae9$var$validateDate(year, month, day) || !$b2d0c66f58a40ae9$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $b2d0c66f58a40ae9$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $b2d0c66f58a40ae9$var$parseTime(timeString) {
    const captures = timeString.match($b2d0c66f58a40ae9$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = $b2d0c66f58a40ae9$var$parseTimeUnit(captures[1]);
    const minutes = $b2d0c66f58a40ae9$var$parseTimeUnit(captures[2]);
    const seconds = $b2d0c66f58a40ae9$var$parseTimeUnit(captures[3]);
    if (!$b2d0c66f58a40ae9$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $e24aa25ccaa7cb1c$export$7f72910d6dfd237a) + minutes * (0, $e24aa25ccaa7cb1c$export$91246f0b9bd9beff) + seconds * 1000;
}
function $b2d0c66f58a40ae9$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $b2d0c66f58a40ae9$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match($b2d0c66f58a40ae9$var$timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$b2d0c66f58a40ae9$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $e24aa25ccaa7cb1c$export$7f72910d6dfd237a) + minutes * (0, $e24aa25ccaa7cb1c$export$91246f0b9bd9beff));
}
function $b2d0c66f58a40ae9$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const $b2d0c66f58a40ae9$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $b2d0c66f58a40ae9$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $b2d0c66f58a40ae9$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($b2d0c66f58a40ae9$var$daysInMonths[month] || ($b2d0c66f58a40ae9$var$isLeapYearIndex(year) ? 29 : 28));
}
function $b2d0c66f58a40ae9$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($b2d0c66f58a40ae9$var$isLeapYearIndex(year) ? 366 : 365);
}
function $b2d0c66f58a40ae9$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $b2d0c66f58a40ae9$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $b2d0c66f58a40ae9$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}
var // Fallback for modularized imports:
$b2d0c66f58a40ae9$export$2e2bcd8739ae039 = $b2d0c66f58a40ae9$export$4393d2ccbbedb219;


function $08eadd31071dba99$export$63fa379ae8a9ba2(date) {
    const _date = (0, $77dc29417ac8d032$export$e67a095c620b86fe)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$08eadd31071dba99$export$2e2bcd8739ae039 = $08eadd31071dba99$export$63fa379ae8a9ba2;


var $303ba10db2c74ab4$exports = {};
"use strict";
$303ba10db2c74ab4$exports.format = $303ba10db2c74ab4$exports.formatDate = $303ba10db2c74ab4$var$format;
Object.defineProperty($303ba10db2c74ab4$exports, "formatters", {
    enumerable: true,
    get: function() {
        return $008fe800ab658844$export$fe98a034cfb96d55;
    }
});
Object.defineProperty($303ba10db2c74ab4$exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $54cd66db3e5e74df$export$70cc8fd02856fd58;
    }
});
var $e9531067c80a48a0$exports = {};
"use strict";
Object.defineProperty($e9531067c80a48a0$exports, "defaultLocale", {
    enumerable: true,
    get: function() {
        return $cd0c27002eb93234$export$137380d9ce54f7f;
    }
});
var $cd0c27002eb93234$export$137380d9ce54f7f;
"use strict";
$cd0c27002eb93234$export$137380d9ce54f7f = void 0;
var $0bc92389da5ca8f2$export$2c14ff85d6318973;
"use strict";
$0bc92389da5ca8f2$export$2c14ff85d6318973 = void 0;
const $0bc92389da5ca8f2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $0bc92389da5ca8f2$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $0bc92389da5ca8f2$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
$0bc92389da5ca8f2$export$2c14ff85d6318973 = $0bc92389da5ca8f2$var$formatDistance;


var $63c01f9040a729a9$export$cbf60ecb96cbb82f;
"use strict";
$63c01f9040a729a9$export$cbf60ecb96cbb82f = void 0;
var $46af55383084911e$export$38e44e97ce4dbb7d;
"use strict";
$46af55383084911e$export$38e44e97ce4dbb7d = $46af55383084911e$var$buildFormatLongFn;
function $46af55383084911e$var$buildFormatLongFn(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $63c01f9040a729a9$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $63c01f9040a729a9$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $63c01f9040a729a9$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $63c01f9040a729a9$var$formatLong = $63c01f9040a729a9$export$cbf60ecb96cbb82f = {
    date: (0, $46af55383084911e$export$38e44e97ce4dbb7d)({
        formats: $63c01f9040a729a9$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $46af55383084911e$export$38e44e97ce4dbb7d)({
        formats: $63c01f9040a729a9$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $46af55383084911e$export$38e44e97ce4dbb7d)({
        formats: $63c01f9040a729a9$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $f529b3bee3f6d835$export$8fbbfd65594f46a0;
"use strict";
$f529b3bee3f6d835$export$8fbbfd65594f46a0 = void 0;
const $f529b3bee3f6d835$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $f529b3bee3f6d835$var$formatRelative = (token, _date, _baseDate, _options)=>$f529b3bee3f6d835$var$formatRelativeLocale[token];
$f529b3bee3f6d835$export$8fbbfd65594f46a0 = $f529b3bee3f6d835$var$formatRelative;


var $eb9cac2ee97a0b54$export$b3bd0bc58e36cd63;
"use strict";
$eb9cac2ee97a0b54$export$b3bd0bc58e36cd63 = void 0;
var $39a1e2b6239b09b3$export$63596d6ee8878b25;
"use strict";
$39a1e2b6239b09b3$export$63596d6ee8878b25 = $39a1e2b6239b09b3$var$buildLocalizeFn; /* eslint-disable no-unused-vars */ 
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $39a1e2b6239b09b3$var$buildLocalizeFn(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $eb9cac2ee97a0b54$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $eb9cac2ee97a0b54$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $eb9cac2ee97a0b54$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $eb9cac2ee97a0b54$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $eb9cac2ee97a0b54$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $eb9cac2ee97a0b54$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $eb9cac2ee97a0b54$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $eb9cac2ee97a0b54$var$localize = $eb9cac2ee97a0b54$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $eb9cac2ee97a0b54$var$ordinalNumber,
    era: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $eb9cac2ee97a0b54$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $d2fa28259adb3ab1$export$4659b591c19bdf3d;
"use strict";
$d2fa28259adb3ab1$export$4659b591c19bdf3d = void 0;
var $e4df69a5a2d494a3$export$1430a0f35710914d;
"use strict";
$e4df69a5a2d494a3$export$1430a0f35710914d = $e4df69a5a2d494a3$var$buildMatchFn;
function $e4df69a5a2d494a3$var$buildMatchFn(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $e4df69a5a2d494a3$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $e4df69a5a2d494a3$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $e4df69a5a2d494a3$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $e4df69a5a2d494a3$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


var $2594a2c0202dabc6$export$fdaf2fd6d7edde95;
"use strict";
$2594a2c0202dabc6$export$fdaf2fd6d7edde95 = $2594a2c0202dabc6$var$buildMatchPatternFn;
function $2594a2c0202dabc6$var$buildMatchPatternFn(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $d2fa28259adb3ab1$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $d2fa28259adb3ab1$var$parseOrdinalNumberPattern = /\d+/i;
const $d2fa28259adb3ab1$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $d2fa28259adb3ab1$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $d2fa28259adb3ab1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $d2fa28259adb3ab1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $d2fa28259adb3ab1$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $d2fa28259adb3ab1$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $d2fa28259adb3ab1$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $d2fa28259adb3ab1$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $d2fa28259adb3ab1$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $d2fa28259adb3ab1$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $d2fa28259adb3ab1$var$match = $d2fa28259adb3ab1$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $2594a2c0202dabc6$export$fdaf2fd6d7edde95)({
        matchPattern: $d2fa28259adb3ab1$var$matchOrdinalNumberPattern,
        parsePattern: $d2fa28259adb3ab1$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $d2fa28259adb3ab1$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */ const $cd0c27002eb93234$var$enUS = $cd0c27002eb93234$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: $0bc92389da5ca8f2$export$2c14ff85d6318973,
    formatLong: $63c01f9040a729a9$export$cbf60ecb96cbb82f,
    formatRelative: $f529b3bee3f6d835$export$8fbbfd65594f46a0,
    localize: $eb9cac2ee97a0b54$export$b3bd0bc58e36cd63,
    match: $d2fa28259adb3ab1$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};




var $39440020b58e1ef8$export$430a3269e24b912e;
var $39440020b58e1ef8$export$95365be1b0704abc;
"use strict";
$39440020b58e1ef8$export$430a3269e24b912e = $39440020b58e1ef8$var$getDefaultOptions;
$39440020b58e1ef8$export$95365be1b0704abc = $39440020b58e1ef8$var$setDefaultOptions;
let $39440020b58e1ef8$var$defaultOptions = {};
function $39440020b58e1ef8$var$getDefaultOptions() {
    return $39440020b58e1ef8$var$defaultOptions;
}
function $39440020b58e1ef8$var$setDefaultOptions(newOptions) {
    $39440020b58e1ef8$var$defaultOptions = newOptions;
}


var $008fe800ab658844$export$fe98a034cfb96d55;
"use strict";
$008fe800ab658844$export$fe98a034cfb96d55 = void 0;
var $306b88ce50904f9c$exports = {};

$parcel$export($306b88ce50904f9c$exports, "getDayOfYear", () => $306b88ce50904f9c$export$d3b42cd8452deec, (v) => $306b88ce50904f9c$export$d3b42cd8452deec = v);
var $306b88ce50904f9c$export$d3b42cd8452deec;
"use strict";
$306b88ce50904f9c$export$d3b42cd8452deec = $306b88ce50904f9c$var$getDayOfYear;
var $737f54e9ffaddc15$exports = {};

$parcel$export($737f54e9ffaddc15$exports, "differenceInCalendarDays", () => $737f54e9ffaddc15$export$4a02e9c37dab4871, (v) => $737f54e9ffaddc15$export$4a02e9c37dab4871 = v);
var $737f54e9ffaddc15$export$4a02e9c37dab4871;
"use strict";
$737f54e9ffaddc15$export$4a02e9c37dab4871 = $737f54e9ffaddc15$var$differenceInCalendarDays;
var $8540a44f59a4af84$export$7271e9e3478110d1;
var $8540a44f59a4af84$export$34804a017b31e2fe;
var $8540a44f59a4af84$export$be1dccf2de902d31;
var $8540a44f59a4af84$export$8e6600bbdee7dabb;
var $8540a44f59a4af84$export$a77c1a7ebebe2a5a;
var $8540a44f59a4af84$export$698aec755e92c695;
var $8540a44f59a4af84$export$815a9362476d2fe3;
var $8540a44f59a4af84$export$4db7641526e3241f;
var $8540a44f59a4af84$export$80d7e435f744f319;
var $8540a44f59a4af84$export$3c58128db900d44e;
var $8540a44f59a4af84$export$3633035e63cee86a;
var $8540a44f59a4af84$export$ab7da2ccd1075c38;
var $8540a44f59a4af84$export$f2f5ae5a8e2d8f9f;
var $8540a44f59a4af84$export$2423174df8cd3cd2;
var $8540a44f59a4af84$export$4dec998e48f9c246;
var $8540a44f59a4af84$export$4fad13613e88edc8;
var $8540a44f59a4af84$export$397c2d5776aa9055;
var $8540a44f59a4af84$export$91246f0b9bd9beff;
var $8540a44f59a4af84$export$7f72910d6dfd237a;
var $8540a44f59a4af84$export$b76b1809a2898f9a;
var $8540a44f59a4af84$export$81caae6e1cc7a622;
var $8540a44f59a4af84$export$3913210603d8e9ae;
var $8540a44f59a4af84$export$dfd9b671c89acc8e;
"use strict";
$8540a44f59a4af84$export$7271e9e3478110d1 = $8540a44f59a4af84$export$34804a017b31e2fe = $8540a44f59a4af84$export$be1dccf2de902d31 = $8540a44f59a4af84$export$8e6600bbdee7dabb = $8540a44f59a4af84$export$a77c1a7ebebe2a5a = $8540a44f59a4af84$export$698aec755e92c695 = $8540a44f59a4af84$export$815a9362476d2fe3 = $8540a44f59a4af84$export$4db7641526e3241f = $8540a44f59a4af84$export$80d7e435f744f319 = $8540a44f59a4af84$export$3c58128db900d44e = $8540a44f59a4af84$export$3633035e63cee86a = $8540a44f59a4af84$export$ab7da2ccd1075c38 = $8540a44f59a4af84$export$f2f5ae5a8e2d8f9f = $8540a44f59a4af84$export$2423174df8cd3cd2 = $8540a44f59a4af84$export$4dec998e48f9c246 = $8540a44f59a4af84$export$4fad13613e88edc8 = $8540a44f59a4af84$export$397c2d5776aa9055 = $8540a44f59a4af84$export$91246f0b9bd9beff = $8540a44f59a4af84$export$7f72910d6dfd237a = $8540a44f59a4af84$export$b76b1809a2898f9a = $8540a44f59a4af84$export$81caae6e1cc7a622 = $8540a44f59a4af84$export$3913210603d8e9ae = $8540a44f59a4af84$export$dfd9b671c89acc8e = void 0; /**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ 
/**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $8540a44f59a4af84$var$daysInWeek = $8540a44f59a4af84$export$dfd9b671c89acc8e = 7;
/**
 * @constant
 * @name daysInYear
 * @summary Days in 1 year.
 *
 * @description
 * How many days in a year.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 */ const $8540a44f59a4af84$var$daysInYear = $8540a44f59a4af84$export$3913210603d8e9ae = 365.2425;
/**
 * @constant
 * @name maxTime
 * @summary Maximum allowed time.
 *
 * @example
 * import { maxTime } from "date-fns/constants";
 *
 * const isValid = 8640000000000001 <= maxTime;
 * //=> false
 *
 * new Date(8640000000000001);
 * //=> Invalid Date
 */ const $8540a44f59a4af84$var$maxTime = $8540a44f59a4af84$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
/**
 * @constant
 * @name minTime
 * @summary Minimum allowed time.
 *
 * @example
 * import { minTime } from "date-fns/constants";
 *
 * const isValid = -8640000000000001 >= minTime;
 * //=> false
 *
 * new Date(-8640000000000001)
 * //=> Invalid Date
 */ const $8540a44f59a4af84$var$minTime = $8540a44f59a4af84$export$4dec998e48f9c246 = -$8540a44f59a4af84$var$maxTime;
/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */ const $8540a44f59a4af84$var$millisecondsInWeek = $8540a44f59a4af84$export$4fad13613e88edc8 = 604800000;
/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */ const $8540a44f59a4af84$var$millisecondsInDay = $8540a44f59a4af84$export$b76b1809a2898f9a = 86400000;
/**
 * @constant
 * @name millisecondsInMinute
 * @summary Milliseconds in 1 minute
 */ const $8540a44f59a4af84$var$millisecondsInMinute = $8540a44f59a4af84$export$91246f0b9bd9beff = 60000;
/**
 * @constant
 * @name millisecondsInHour
 * @summary Milliseconds in 1 hour
 */ const $8540a44f59a4af84$var$millisecondsInHour = $8540a44f59a4af84$export$7f72910d6dfd237a = 3600000;
/**
 * @constant
 * @name millisecondsInSecond
 * @summary Milliseconds in 1 second
 */ const $8540a44f59a4af84$var$millisecondsInSecond = $8540a44f59a4af84$export$397c2d5776aa9055 = 1000;
/**
 * @constant
 * @name minutesInYear
 * @summary Minutes in 1 year.
 */ const $8540a44f59a4af84$var$minutesInYear = $8540a44f59a4af84$export$3633035e63cee86a = 525600;
/**
 * @constant
 * @name minutesInMonth
 * @summary Minutes in 1 month.
 */ const $8540a44f59a4af84$var$minutesInMonth = $8540a44f59a4af84$export$ab7da2ccd1075c38 = 43200;
/**
 * @constant
 * @name minutesInDay
 * @summary Minutes in 1 day.
 */ const $8540a44f59a4af84$var$minutesInDay = $8540a44f59a4af84$export$2423174df8cd3cd2 = 1440;
/**
 * @constant
 * @name minutesInHour
 * @summary Minutes in 1 hour.
 */ const $8540a44f59a4af84$var$minutesInHour = $8540a44f59a4af84$export$f2f5ae5a8e2d8f9f = 60;
/**
 * @constant
 * @name monthsInQuarter
 * @summary Months in 1 quarter.
 */ const $8540a44f59a4af84$var$monthsInQuarter = $8540a44f59a4af84$export$3c58128db900d44e = 3;
/**
 * @constant
 * @name monthsInYear
 * @summary Months in 1 year.
 */ const $8540a44f59a4af84$var$monthsInYear = $8540a44f59a4af84$export$80d7e435f744f319 = 12;
/**
 * @constant
 * @name quartersInYear
 * @summary Quarters in 1 year
 */ const $8540a44f59a4af84$var$quartersInYear = $8540a44f59a4af84$export$4db7641526e3241f = 4;
/**
 * @constant
 * @name secondsInHour
 * @summary Seconds in 1 hour.
 */ const $8540a44f59a4af84$var$secondsInHour = $8540a44f59a4af84$export$698aec755e92c695 = 3600;
/**
 * @constant
 * @name secondsInMinute
 * @summary Seconds in 1 minute.
 */ const $8540a44f59a4af84$var$secondsInMinute = $8540a44f59a4af84$export$a77c1a7ebebe2a5a = 60;
/**
 * @constant
 * @name secondsInDay
 * @summary Seconds in 1 day.
 */ const $8540a44f59a4af84$var$secondsInDay = $8540a44f59a4af84$export$815a9362476d2fe3 = $8540a44f59a4af84$var$secondsInHour * 24;
/**
 * @constant
 * @name secondsInWeek
 * @summary Seconds in 1 week.
 */ const $8540a44f59a4af84$var$secondsInWeek = $8540a44f59a4af84$export$34804a017b31e2fe = $8540a44f59a4af84$var$secondsInDay * 7;
/**
 * @constant
 * @name secondsInYear
 * @summary Seconds in 1 year.
 */ const $8540a44f59a4af84$var$secondsInYear = $8540a44f59a4af84$export$7271e9e3478110d1 = $8540a44f59a4af84$var$secondsInDay * $8540a44f59a4af84$var$daysInYear;
/**
 * @constant
 * @name secondsInMonth
 * @summary Seconds in 1 month
 */ const $8540a44f59a4af84$var$secondsInMonth = $8540a44f59a4af84$export$8e6600bbdee7dabb = $8540a44f59a4af84$var$secondsInYear / 12;
/**
 * @constant
 * @name secondsInQuarter
 * @summary Seconds in 1 quarter.
 */ const $8540a44f59a4af84$var$secondsInQuarter = $8540a44f59a4af84$export$be1dccf2de902d31 = $8540a44f59a4af84$var$secondsInMonth * 3;


var $b6caff0bf13dcaf5$exports = {};

$parcel$export($b6caff0bf13dcaf5$exports, "startOfDay", () => $b6caff0bf13dcaf5$export$63fa379ae8a9ba2, (v) => $b6caff0bf13dcaf5$export$63fa379ae8a9ba2 = v);
var $b6caff0bf13dcaf5$export$63fa379ae8a9ba2;
"use strict";
$b6caff0bf13dcaf5$export$63fa379ae8a9ba2 = $b6caff0bf13dcaf5$var$startOfDay;
var $231bfb8d72679740$exports = {};

$parcel$export($231bfb8d72679740$exports, "toDate", () => $231bfb8d72679740$export$e67a095c620b86fe, (v) => $231bfb8d72679740$export$e67a095c620b86fe = v);
var $231bfb8d72679740$export$e67a095c620b86fe;
"use strict";
$231bfb8d72679740$export$e67a095c620b86fe = $231bfb8d72679740$var$toDate;
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $231bfb8d72679740$var$toDate(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ function $b6caff0bf13dcaf5$var$startOfDay(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


var $92dc0740ffabe180$export$113002b5eff6e430;
"use strict";
$92dc0740ffabe180$export$113002b5eff6e430 = $92dc0740ffabe180$var$getTimezoneOffsetInMilliseconds;

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $92dc0740ffabe180$var$getTimezoneOffsetInMilliseconds(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}


/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */ function $737f54e9ffaddc15$var$differenceInCalendarDays(dateLeft, dateRight) {
    const startOfDayLeft = (0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(dateLeft);
    const startOfDayRight = (0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(dateRight);
    const timestampLeft = +startOfDayLeft - (0, $92dc0740ffabe180$export$113002b5eff6e430)(startOfDayLeft);
    const timestampRight = +startOfDayRight - (0, $92dc0740ffabe180$export$113002b5eff6e430)(startOfDayRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $8540a44f59a4af84$export$b76b1809a2898f9a);
}


var $29cc086f79701cd9$exports = {};

$parcel$export($29cc086f79701cd9$exports, "startOfYear", () => $29cc086f79701cd9$export$f91e89d3d0406102, (v) => $29cc086f79701cd9$export$f91e89d3d0406102 = v);
var $29cc086f79701cd9$export$f91e89d3d0406102;
"use strict";
$29cc086f79701cd9$export$f91e89d3d0406102 = $29cc086f79701cd9$var$startOfYear;

var $abb9adbdb26342b3$exports = {};

$parcel$export($abb9adbdb26342b3$exports, "constructFrom", () => $abb9adbdb26342b3$export$ead8a1812b171991, (v) => $abb9adbdb26342b3$export$ead8a1812b171991 = v);
var $abb9adbdb26342b3$export$ead8a1812b171991;
"use strict";
$abb9adbdb26342b3$export$ead8a1812b171991 = $abb9adbdb26342b3$var$constructFrom;
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ function $abb9adbdb26342b3$var$constructFrom(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}


/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */ function $29cc086f79701cd9$var$startOfYear(date) {
    const cleanDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const _date = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
    _date.setFullYear(cleanDate.getFullYear(), 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}



/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */ function $306b88ce50904f9c$var$getDayOfYear(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const diff = (0, $737f54e9ffaddc15$export$4a02e9c37dab4871)(_date, (0, $29cc086f79701cd9$export$f91e89d3d0406102)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}


var $83e11b0db4cec366$exports = {};

$parcel$export($83e11b0db4cec366$exports, "getISOWeek", () => $83e11b0db4cec366$export$7cabdc5698b63e2f, (v) => $83e11b0db4cec366$export$7cabdc5698b63e2f = v);
var $83e11b0db4cec366$export$7cabdc5698b63e2f;
"use strict";
$83e11b0db4cec366$export$7cabdc5698b63e2f = $83e11b0db4cec366$var$getISOWeek;

var $1c9d32c6cb108460$exports = {};

$parcel$export($1c9d32c6cb108460$exports, "startOfISOWeek", () => $1c9d32c6cb108460$export$6173213f95a4431e, (v) => $1c9d32c6cb108460$export$6173213f95a4431e = v);
var $1c9d32c6cb108460$export$6173213f95a4431e;
"use strict";
$1c9d32c6cb108460$export$6173213f95a4431e = $1c9d32c6cb108460$var$startOfISOWeek;
var $61f11f7a26b3ab78$exports = {};

$parcel$export($61f11f7a26b3ab78$exports, "startOfWeek", () => $61f11f7a26b3ab78$export$42c81a444fbfb5d4, (v) => $61f11f7a26b3ab78$export$42c81a444fbfb5d4 = v);
var $61f11f7a26b3ab78$export$42c81a444fbfb5d4;
"use strict";
$61f11f7a26b3ab78$export$42c81a444fbfb5d4 = $61f11f7a26b3ab78$var$startOfWeek;


/**
 * The {@link startOfWeek} function options.
 */ /**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */ function $61f11f7a26b3ab78$var$startOfWeek(date, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $1c9d32c6cb108460$var$startOfISOWeek(date) {
    return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(date, {
        weekStartsOn: 1
    });
}


var $3b2e6199275b27d6$exports = {};

$parcel$export($3b2e6199275b27d6$exports, "startOfISOWeekYear", () => $3b2e6199275b27d6$export$236bdfa374eb69a9, (v) => $3b2e6199275b27d6$export$236bdfa374eb69a9 = v);
var $3b2e6199275b27d6$export$236bdfa374eb69a9;
"use strict";
$3b2e6199275b27d6$export$236bdfa374eb69a9 = $3b2e6199275b27d6$var$startOfISOWeekYear;
var $c95dff76bf2f692a$exports = {};

$parcel$export($c95dff76bf2f692a$exports, "getISOWeekYear", () => $c95dff76bf2f692a$export$3dbc52535f6f8fcc, (v) => $c95dff76bf2f692a$export$3dbc52535f6f8fcc = v);
var $c95dff76bf2f692a$export$3dbc52535f6f8fcc;
"use strict";
$c95dff76bf2f692a$export$3dbc52535f6f8fcc = $c95dff76bf2f692a$var$getISOWeekYear;



/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */ function $c95dff76bf2f692a$var$getISOWeekYear(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $1c9d32c6cb108460$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $1c9d32c6cb108460$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */ function $3b2e6199275b27d6$var$startOfISOWeekYear(date) {
    const year = (0, $c95dff76bf2f692a$export$3dbc52535f6f8fcc)(date);
    const fourthOfJanuary = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $1c9d32c6cb108460$export$6173213f95a4431e)(fourthOfJanuary);
}



/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */ function $83e11b0db4cec366$var$getISOWeek(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const diff = +(0, $1c9d32c6cb108460$export$6173213f95a4431e)(_date) - +(0, $3b2e6199275b27d6$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $8540a44f59a4af84$export$4fad13613e88edc8) + 1;
}



var $11b38d723fd57381$exports = {};

$parcel$export($11b38d723fd57381$exports, "getWeek", () => $11b38d723fd57381$export$efe19b760242b2fc, (v) => $11b38d723fd57381$export$efe19b760242b2fc = v);
var $11b38d723fd57381$export$efe19b760242b2fc;
"use strict";
$11b38d723fd57381$export$efe19b760242b2fc = $11b38d723fd57381$var$getWeek;


var $ac7640a7ade5a435$exports = {};

$parcel$export($ac7640a7ade5a435$exports, "startOfWeekYear", () => $ac7640a7ade5a435$export$bb7b45bb8e74da0f, (v) => $ac7640a7ade5a435$export$bb7b45bb8e74da0f = v);
var $ac7640a7ade5a435$export$bb7b45bb8e74da0f;
"use strict";
$ac7640a7ade5a435$export$bb7b45bb8e74da0f = $ac7640a7ade5a435$var$startOfWeekYear;

var $0170e230c8468ebb$exports = {};

$parcel$export($0170e230c8468ebb$exports, "getWeekYear", () => $0170e230c8468ebb$export$12d572480ceb6e58, (v) => $0170e230c8468ebb$export$12d572480ceb6e58 = v);
var $0170e230c8468ebb$export$12d572480ceb6e58;
"use strict";
$0170e230c8468ebb$export$12d572480ceb6e58 = $0170e230c8468ebb$var$getWeekYear;




/**
 * The {@link getWeekYear} function options.
 */ /**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */ function $0170e230c8468ebb$var$getWeekYear(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




/**
 * The {@link startOfWeekYear} function options.
 */ /**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */ function $ac7640a7ade5a435$var$startOfWeekYear(date, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $0170e230c8468ebb$export$12d572480ceb6e58)(date, options);
    const firstWeek = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}



/**
 * The {@link getWeek} function options.
 */ /**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */ function $11b38d723fd57381$var$getWeek(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const diff = +(0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(_date, options) - +(0, $ac7640a7ade5a435$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $8540a44f59a4af84$export$4fad13613e88edc8) + 1;
}



var $03d75ed55eeb99fa$export$c8306e720e213c0f;
"use strict";
$03d75ed55eeb99fa$export$c8306e720e213c0f = $03d75ed55eeb99fa$var$addLeadingZeros;
function $03d75ed55eeb99fa$var$addLeadingZeros(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}


var $71a5e81f1193b7a8$export$b0d4b338e1516f13;
"use strict";
$71a5e81f1193b7a8$export$b0d4b338e1516f13 = void 0;

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ const $71a5e81f1193b7a8$var$lightFormatters = $71a5e81f1193b7a8$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


const $008fe800ab658844$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ const $008fe800ab658844$var$formatters = $008fe800ab658844$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return $71a5e81f1193b7a8$export$b0d4b338e1516f13.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $0170e230c8468ebb$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $c95dff76bf2f692a$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return $71a5e81f1193b7a8$export$b0d4b338e1516f13.M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $11b38d723fd57381$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $83e11b0db4cec366$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return $71a5e81f1193b7a8$export$b0d4b338e1516f13.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $306b88ce50904f9c$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return $71a5e81f1193b7a8$export$b0d4b338e1516f13.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return $71a5e81f1193b7a8$export$b0d4b338e1516f13.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return $71a5e81f1193b7a8$export$b0d4b338e1516f13.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return $71a5e81f1193b7a8$export$b0d4b338e1516f13.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $71a5e81f1193b7a8$export$b0d4b338e1516f13.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $008fe800ab658844$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $008fe800ab658844$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $008fe800ab658844$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $008fe800ab658844$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $008fe800ab658844$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $008fe800ab658844$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(date.getTime() / 1000);
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        const timestamp = date.getTime();
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(timestamp, token.length);
    }
};
function $008fe800ab658844$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(minutes, 2);
}
function $008fe800ab658844$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $008fe800ab658844$var$formatTimezone(offset, delimiter);
}
function $008fe800ab658844$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}


var $54cd66db3e5e74df$export$70cc8fd02856fd58;
"use strict";
$54cd66db3e5e74df$export$70cc8fd02856fd58 = void 0;
const $54cd66db3e5e74df$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $54cd66db3e5e74df$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $54cd66db3e5e74df$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $54cd66db3e5e74df$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $54cd66db3e5e74df$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $54cd66db3e5e74df$var$timeLongFormatter(timePattern, formatLong));
};
const $54cd66db3e5e74df$var$longFormatters = $54cd66db3e5e74df$export$70cc8fd02856fd58 = {
    p: $54cd66db3e5e74df$var$timeLongFormatter,
    P: $54cd66db3e5e74df$var$dateTimeLongFormatter
};


var $7e8a5b0b77bf77b9$export$c6cc36aa33304772;
var $7e8a5b0b77bf77b9$export$c6b49d6dceb604a1;
var $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879;
"use strict";
$7e8a5b0b77bf77b9$export$c6cc36aa33304772 = $7e8a5b0b77bf77b9$var$isProtectedDayOfYearToken;
$7e8a5b0b77bf77b9$export$c6b49d6dceb604a1 = $7e8a5b0b77bf77b9$var$isProtectedWeekYearToken;
$7e8a5b0b77bf77b9$export$f5f38f90ecaaf879 = $7e8a5b0b77bf77b9$var$warnOrThrowProtectedError;
const $7e8a5b0b77bf77b9$var$dayOfYearTokenRE = /^D+$/;
const $7e8a5b0b77bf77b9$var$weekYearTokenRE = /^Y+$/;
const $7e8a5b0b77bf77b9$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $7e8a5b0b77bf77b9$var$isProtectedDayOfYearToken(token) {
    return $7e8a5b0b77bf77b9$var$dayOfYearTokenRE.test(token);
}
function $7e8a5b0b77bf77b9$var$isProtectedWeekYearToken(token) {
    return $7e8a5b0b77bf77b9$var$weekYearTokenRE.test(token);
}
function $7e8a5b0b77bf77b9$var$warnOrThrowProtectedError(token, format, input) {
    const _message = $7e8a5b0b77bf77b9$var$message(token, format, input);
    console.warn(_message);
    if ($7e8a5b0b77bf77b9$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $7e8a5b0b77bf77b9$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}


var $f2a682b251363bc2$exports = {};

$parcel$export($f2a682b251363bc2$exports, "isValid", () => $f2a682b251363bc2$export$1ea939691cdc45b8, (v) => $f2a682b251363bc2$export$1ea939691cdc45b8 = v);
var $f2a682b251363bc2$export$1ea939691cdc45b8;
"use strict";
$f2a682b251363bc2$export$1ea939691cdc45b8 = $f2a682b251363bc2$var$isValid;
var $1896b5e28554d57b$exports = {};

$parcel$export($1896b5e28554d57b$exports, "isDate", () => $1896b5e28554d57b$export$871608497c498473, (v) => $1896b5e28554d57b$export$871608497c498473 = v);
var $1896b5e28554d57b$export$871608497c498473;
"use strict";
$1896b5e28554d57b$export$871608497c498473 = $1896b5e28554d57b$var$isDate; /**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ 
function $1896b5e28554d57b$var$isDate(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function $f2a682b251363bc2$var$isValid(date) {
    if (!(0, $1896b5e28554d57b$export$871608497c498473)(date) && typeof date !== "number") return false;
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    return !isNaN(Number(_date));
}



// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $303ba10db2c74ab4$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $303ba10db2c74ab4$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $303ba10db2c74ab4$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $303ba10db2c74ab4$var$doubleQuoteRegExp = /''/g;
const $303ba10db2c74ab4$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * The {@link format} function options.
 */ /**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $303ba10db2c74ab4$var$format(date, formatStr, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? $e9531067c80a48a0$exports.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    if (!(0, $f2a682b251363bc2$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($303ba10db2c74ab4$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = $54cd66db3e5e74df$export$70cc8fd02856fd58[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($303ba10db2c74ab4$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $303ba10db2c74ab4$var$cleanEscapedString(substring)
        };
        if ($008fe800ab658844$export$fe98a034cfb96d55[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($303ba10db2c74ab4$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $7e8a5b0b77bf77b9$export$c6b49d6dceb604a1)(token) || !options?.useAdditionalDayOfYearTokens && (0, $7e8a5b0b77bf77b9$export$c6cc36aa33304772)(token)) (0, $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        const formatter = $008fe800ab658844$export$fe98a034cfb96d55[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $303ba10db2c74ab4$var$cleanEscapedString(input) {
    const matched = input.match($303ba10db2c74ab4$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($303ba10db2c74ab4$var$doubleQuoteRegExp, "'");
}


var $5b2b72156d2e39b5$exports = {};
"use strict";
var $543e4b3aa35bec3b$exports = {};

$parcel$export($543e4b3aa35bec3b$exports, "add", () => $543e4b3aa35bec3b$export$e16d8520af44a096, (v) => $543e4b3aa35bec3b$export$e16d8520af44a096 = v);
var $543e4b3aa35bec3b$export$e16d8520af44a096;
"use strict";
$543e4b3aa35bec3b$export$e16d8520af44a096 = $543e4b3aa35bec3b$var$add;
var $a351150ce2eb3ddb$exports = {};

$parcel$export($a351150ce2eb3ddb$exports, "addDays", () => $a351150ce2eb3ddb$export$dd412b56f1e4d8aa, (v) => $a351150ce2eb3ddb$export$dd412b56f1e4d8aa = v);
var $a351150ce2eb3ddb$export$dd412b56f1e4d8aa;
"use strict";
$a351150ce2eb3ddb$export$dd412b56f1e4d8aa = $a351150ce2eb3ddb$var$addDays;


/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */ function $a351150ce2eb3ddb$var$addDays(date, amount) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    if (isNaN(amount)) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}


var $8fcd3b0bf5df7635$exports = {};

$parcel$export($8fcd3b0bf5df7635$exports, "addMonths", () => $8fcd3b0bf5df7635$export$17c93e242b2d3a22, (v) => $8fcd3b0bf5df7635$export$17c93e242b2d3a22 = v);
var $8fcd3b0bf5df7635$export$17c93e242b2d3a22;
"use strict";
$8fcd3b0bf5df7635$export$17c93e242b2d3a22 = $8fcd3b0bf5df7635$var$addMonths;


/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */ function $8fcd3b0bf5df7635$var$addMonths(date, amount) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    if (isNaN(amount)) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}




/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added        |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,\\-7
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */ function $543e4b3aa35bec3b$var$add(date, duration) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Add years and months
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const dateWithMonths = months || years ? (0, $8fcd3b0bf5df7635$export$17c93e242b2d3a22)(_date, months + years * 12) : _date;
    // Add weeks and days
    const dateWithDays = days || weeks ? (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    const minutesToAdd = minutes + hours * 60;
    const secondsToAdd = seconds + minutesToAdd * 60;
    const msToAdd = secondsToAdd * 1000;
    const finalDate = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, dateWithDays.getTime() + msToAdd);
    return finalDate;
}


Object.keys($543e4b3aa35bec3b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $543e4b3aa35bec3b$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $543e4b3aa35bec3b$exports[key];
        }
    });
});
var $370ee6dc5d0513ee$exports = {};

$parcel$export($370ee6dc5d0513ee$exports, "addBusinessDays", () => $370ee6dc5d0513ee$export$f087b9ada3136ae9, (v) => $370ee6dc5d0513ee$export$f087b9ada3136ae9 = v);
var $370ee6dc5d0513ee$export$f087b9ada3136ae9;
"use strict";
$370ee6dc5d0513ee$export$f087b9ada3136ae9 = $370ee6dc5d0513ee$var$addBusinessDays;

var $d84241a3868bd79f$exports = {};

$parcel$export($d84241a3868bd79f$exports, "isSaturday", () => $d84241a3868bd79f$export$def9f260655b3a76, (v) => $d84241a3868bd79f$export$def9f260655b3a76 = v);
var $d84241a3868bd79f$export$def9f260655b3a76;
"use strict";
$d84241a3868bd79f$export$def9f260655b3a76 = $d84241a3868bd79f$var$isSaturday;

/**
 * @name isSaturday
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * const result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */ function $d84241a3868bd79f$var$isSaturday(date) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date).getDay() === 6;
}


var $971b91a830c22187$exports = {};

$parcel$export($971b91a830c22187$exports, "isSunday", () => $971b91a830c22187$export$70f720dfc6028987, (v) => $971b91a830c22187$export$70f720dfc6028987 = v);
var $971b91a830c22187$export$70f720dfc6028987;
"use strict";
$971b91a830c22187$export$70f720dfc6028987 = $971b91a830c22187$var$isSunday;

/**
 * @name isSunday
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * const result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */ function $971b91a830c22187$var$isSunday(date) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date).getDay() === 0;
}


var $126e0ee47695e680$exports = {};

$parcel$export($126e0ee47695e680$exports, "isWeekend", () => $126e0ee47695e680$export$618d60ea299da42, (v) => $126e0ee47695e680$export$618d60ea299da42 = v);
var $126e0ee47695e680$export$618d60ea299da42;
"use strict";
$126e0ee47695e680$export$618d60ea299da42 = $126e0ee47695e680$var$isWeekend;

/**
 * @name isWeekend
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * const result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */ function $126e0ee47695e680$var$isWeekend(date) {
    const day = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date).getDay();
    return day === 0 || day === 6;
}



/**
 * @name addBusinessDays
 * @category Date Extension Helpers
 * @summary Add the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be added.
 *
 * @returns The new date with the business days added
 *
 * @example
 * // Add 10 business days to 1 September 2014:
 * const result = addBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
 */ function $370ee6dc5d0513ee$var$addBusinessDays(date, amount) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const startedOnWeekend = (0, $126e0ee47695e680$export$618d60ea299da42)(_date);
    if (isNaN(amount)) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, NaN);
    const hours = _date.getHours();
    const sign = amount < 0 ? -1 : 1;
    const fullWeeks = Math.trunc(amount / 5);
    _date.setDate(_date.getDate() + fullWeeks * 7);
    // Get remaining days not part of a full week
    let restDays = Math.abs(amount % 5);
    // Loops over remaining days
    while(restDays > 0){
        _date.setDate(_date.getDate() + sign);
        if (!(0, $126e0ee47695e680$export$618d60ea299da42)(_date)) restDays -= 1;
    }
    // If the date is a weekend day and we reduce a dividable of
    // 5 from it, we land on a weekend date.
    // To counter this, we add days accordingly to land on the next business day
    if (startedOnWeekend && (0, $126e0ee47695e680$export$618d60ea299da42)(_date) && amount !== 0) {
        // If we're reducing days, we want to add days until we land on a weekday
        // If we're adding days we want to reduce days until we land on a weekday
        if ((0, $d84241a3868bd79f$export$def9f260655b3a76)(_date)) _date.setDate(_date.getDate() + (sign < 0 ? 2 : -1));
        if ((0, $971b91a830c22187$export$70f720dfc6028987)(_date)) _date.setDate(_date.getDate() + (sign < 0 ? 1 : -2));
    }
    // Restore hours to avoid DST lag
    _date.setHours(hours);
    return _date;
}


Object.keys($370ee6dc5d0513ee$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $370ee6dc5d0513ee$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $370ee6dc5d0513ee$exports[key];
        }
    });
});

Object.keys($a351150ce2eb3ddb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a351150ce2eb3ddb$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a351150ce2eb3ddb$exports[key];
        }
    });
});
var $dada8b88b0873e8d$exports = {};

$parcel$export($dada8b88b0873e8d$exports, "addHours", () => $dada8b88b0873e8d$export$4a4306ad4fa0e5e6, (v) => $dada8b88b0873e8d$export$4a4306ad4fa0e5e6 = v);
var $dada8b88b0873e8d$export$4a4306ad4fa0e5e6;
"use strict";
$dada8b88b0873e8d$export$4a4306ad4fa0e5e6 = $dada8b88b0873e8d$var$addHours;
var $a1665abf6052bbc9$exports = {};

$parcel$export($a1665abf6052bbc9$exports, "addMilliseconds", () => $a1665abf6052bbc9$export$baf757aaf0c95c94, (v) => $a1665abf6052bbc9$export$baf757aaf0c95c94 = v);
var $a1665abf6052bbc9$export$baf757aaf0c95c94;
"use strict";
$a1665abf6052bbc9$export$baf757aaf0c95c94 = $a1665abf6052bbc9$var$addMilliseconds;


/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be added.
 *
 * @returns The new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $a1665abf6052bbc9$var$addMilliseconds(date, amount) {
    const timestamp = +(0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, timestamp + amount);
}



/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be added.
 *
 * @returns The new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */ function $dada8b88b0873e8d$var$addHours(date, amount) {
    return (0, $a1665abf6052bbc9$export$baf757aaf0c95c94)(date, amount * $8540a44f59a4af84$export$7f72910d6dfd237a);
}


Object.keys($dada8b88b0873e8d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $dada8b88b0873e8d$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $dada8b88b0873e8d$exports[key];
        }
    });
});
var $bfbc76d70792463e$exports = {};

$parcel$export($bfbc76d70792463e$exports, "addISOWeekYears", () => $bfbc76d70792463e$export$c8240694da10d5f, (v) => $bfbc76d70792463e$export$c8240694da10d5f = v);
var $bfbc76d70792463e$export$c8240694da10d5f;
"use strict";
$bfbc76d70792463e$export$c8240694da10d5f = $bfbc76d70792463e$var$addISOWeekYears;

var $a1a2df6fabe9eb62$exports = {};

$parcel$export($a1a2df6fabe9eb62$exports, "setISOWeekYear", () => $a1a2df6fabe9eb62$export$814397aabf10ab77, (v) => $a1a2df6fabe9eb62$export$814397aabf10ab77 = v);
var $a1a2df6fabe9eb62$export$814397aabf10ab77;
"use strict";
$a1a2df6fabe9eb62$export$814397aabf10ab77 = $a1a2df6fabe9eb62$var$setISOWeekYear;




/**
 * @name setISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The ISO week-numbering year of the new date
 *
 * @returns The new date with the ISO week-numbering year set
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * const result = setISOWeekYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */ function $a1a2df6fabe9eb62$var$setISOWeekYear(date, weekYear) {
    let _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const diff = (0, $737f54e9ffaddc15$export$4a02e9c37dab4871)(_date, (0, $3b2e6199275b27d6$export$236bdfa374eb69a9)(_date));
    const fourthOfJanuary = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
    fourthOfJanuary.setFullYear(weekYear, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    _date = (0, $3b2e6199275b27d6$export$236bdfa374eb69a9)(fourthOfJanuary);
    _date.setDate(_date.getDate() + diff);
    return _date;
}


/**
 * @name addISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be added.
 *
 * @returns The new date with the ISO week-numbering years added
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * const result = addISOWeekYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jn 26 2015 00:00:00
 */ function $bfbc76d70792463e$var$addISOWeekYears(date, amount) {
    return (0, $a1a2df6fabe9eb62$export$814397aabf10ab77)(date, (0, $c95dff76bf2f692a$export$3dbc52535f6f8fcc)(date) + amount);
}


Object.keys($bfbc76d70792463e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $bfbc76d70792463e$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $bfbc76d70792463e$exports[key];
        }
    });
});

Object.keys($a1665abf6052bbc9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a1665abf6052bbc9$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a1665abf6052bbc9$exports[key];
        }
    });
});
var $e8dac3cf5df5dbc8$exports = {};

$parcel$export($e8dac3cf5df5dbc8$exports, "addMinutes", () => $e8dac3cf5df5dbc8$export$2287e3d29250119e, (v) => $e8dac3cf5df5dbc8$export$2287e3d29250119e = v);
var $e8dac3cf5df5dbc8$export$2287e3d29250119e;
"use strict";
$e8dac3cf5df5dbc8$export$2287e3d29250119e = $e8dac3cf5df5dbc8$var$addMinutes;


/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be added.
 *
 * @returns The new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */ function $e8dac3cf5df5dbc8$var$addMinutes(date, amount) {
    return (0, $a1665abf6052bbc9$export$baf757aaf0c95c94)(date, amount * $8540a44f59a4af84$export$91246f0b9bd9beff);
}


Object.keys($e8dac3cf5df5dbc8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $e8dac3cf5df5dbc8$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $e8dac3cf5df5dbc8$exports[key];
        }
    });
});

Object.keys($8fcd3b0bf5df7635$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $8fcd3b0bf5df7635$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $8fcd3b0bf5df7635$exports[key];
        }
    });
});
var $30e5a3aa581ecd23$exports = {};

$parcel$export($30e5a3aa581ecd23$exports, "addQuarters", () => $30e5a3aa581ecd23$export$c252a41d0fbed2ce, (v) => $30e5a3aa581ecd23$export$c252a41d0fbed2ce = v);
var $30e5a3aa581ecd23$export$c252a41d0fbed2ce;
"use strict";
$30e5a3aa581ecd23$export$c252a41d0fbed2ce = $30e5a3aa581ecd23$var$addQuarters;

/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be added.
 *
 * @returns The new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * const result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */ function $30e5a3aa581ecd23$var$addQuarters(date, amount) {
    const months = amount * 3;
    return (0, $8fcd3b0bf5df7635$export$17c93e242b2d3a22)(date, months);
}


Object.keys($30e5a3aa581ecd23$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $30e5a3aa581ecd23$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $30e5a3aa581ecd23$exports[key];
        }
    });
});
var $ec74b6b01c6372f4$exports = {};

$parcel$export($ec74b6b01c6372f4$exports, "addSeconds", () => $ec74b6b01c6372f4$export$3cb31b0df13be68, (v) => $ec74b6b01c6372f4$export$3cb31b0df13be68 = v);
var $ec74b6b01c6372f4$export$3cb31b0df13be68;
"use strict";
$ec74b6b01c6372f4$export$3cb31b0df13be68 = $ec74b6b01c6372f4$var$addSeconds;

/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be added.
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */ function $ec74b6b01c6372f4$var$addSeconds(date, amount) {
    return (0, $a1665abf6052bbc9$export$baf757aaf0c95c94)(date, amount * 1000);
}


Object.keys($ec74b6b01c6372f4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $ec74b6b01c6372f4$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $ec74b6b01c6372f4$exports[key];
        }
    });
});
var $bce641bd93181421$exports = {};

$parcel$export($bce641bd93181421$exports, "addWeeks", () => $bce641bd93181421$export$ef501a2bb4f3ee6b, (v) => $bce641bd93181421$export$ef501a2bb4f3ee6b = v);
var $bce641bd93181421$export$ef501a2bb4f3ee6b;
"use strict";
$bce641bd93181421$export$ef501a2bb4f3ee6b = $bce641bd93181421$var$addWeeks;

/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */ function $bce641bd93181421$var$addWeeks(date, amount) {
    const days = amount * 7;
    return (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(date, days);
}


Object.keys($bce641bd93181421$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $bce641bd93181421$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $bce641bd93181421$exports[key];
        }
    });
});
var $25460c542fb3bf74$exports = {};

$parcel$export($25460c542fb3bf74$exports, "addYears", () => $25460c542fb3bf74$export$3d83eec43f4ea476, (v) => $25460c542fb3bf74$export$3d83eec43f4ea476 = v);
var $25460c542fb3bf74$export$3d83eec43f4ea476;
"use strict";
$25460c542fb3bf74$export$3d83eec43f4ea476 = $25460c542fb3bf74$var$addYears;

/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */ function $25460c542fb3bf74$var$addYears(date, amount) {
    return (0, $8fcd3b0bf5df7635$export$17c93e242b2d3a22)(date, amount * 12);
}


Object.keys($25460c542fb3bf74$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $25460c542fb3bf74$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $25460c542fb3bf74$exports[key];
        }
    });
});
var $fab0ab4e3f2f210f$exports = {};

$parcel$export($fab0ab4e3f2f210f$exports, "areIntervalsOverlapping", () => $fab0ab4e3f2f210f$export$2bf3385645436101, (v) => $fab0ab4e3f2f210f$export$2bf3385645436101 = v);
var $fab0ab4e3f2f210f$export$2bf3385645436101;
"use strict";
$fab0ab4e3f2f210f$export$2bf3385645436101 = $fab0ab4e3f2f210f$var$areIntervalsOverlapping;

/**
 * The {@link areIntervalsOverlapping} function options.
 */ /**
 * @name areIntervalsOverlapping
 * @category Interval Helpers
 * @summary Is the given time interval overlapping with another time interval?
 *
 * @description
 * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping unless `inclusive` is set to `true`.
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 * @param options - The object with options
 *
 * @returns Whether the time intervals are overlapping
 *
 * @example
 * // For overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> false
 *
 * @example
 * // For adjacent time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
 * )
 * //=> false
 *
 * @example
 * // Using the inclusive option:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
 * )
 * //=> false
 *
 * @example
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
 *   { inclusive: true }
 * )
 * //=> true
 */ function $fab0ab4e3f2f210f$var$areIntervalsOverlapping(intervalLeft, intervalRight, options) {
    const [leftStartTime, leftEndTime] = [
        +(0, $231bfb8d72679740$export$e67a095c620b86fe)(intervalLeft.start),
        +(0, $231bfb8d72679740$export$e67a095c620b86fe)(intervalLeft.end)
    ].sort((a, b)=>a - b);
    const [rightStartTime, rightEndTime] = [
        +(0, $231bfb8d72679740$export$e67a095c620b86fe)(intervalRight.start),
        +(0, $231bfb8d72679740$export$e67a095c620b86fe)(intervalRight.end)
    ].sort((a, b)=>a - b);
    if (options?.inclusive) return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
    return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
}


Object.keys($fab0ab4e3f2f210f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $fab0ab4e3f2f210f$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $fab0ab4e3f2f210f$exports[key];
        }
    });
});
var $5a85a167b627226d$exports = {};

$parcel$export($5a85a167b627226d$exports, "clamp", () => $5a85a167b627226d$export$7d15b64cf5a3a4c4, (v) => $5a85a167b627226d$export$7d15b64cf5a3a4c4 = v);
var $5a85a167b627226d$export$7d15b64cf5a3a4c4;
"use strict";
$5a85a167b627226d$export$7d15b64cf5a3a4c4 = $5a85a167b627226d$var$clamp;
var $b70baca84fc92b6d$exports = {};

$parcel$export($b70baca84fc92b6d$exports, "max", () => $b70baca84fc92b6d$export$8960430cfd85939f, (v) => $b70baca84fc92b6d$export$8960430cfd85939f = v);
var $b70baca84fc92b6d$export$8960430cfd85939f;
"use strict";
$b70baca84fc92b6d$export$8960430cfd85939f = $b70baca84fc92b6d$var$max;

/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */ function $b70baca84fc92b6d$var$max(dates) {
    let result;
    dates.forEach(function(dirtyDate) {
        const currentDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}


var $5d373ce01680b655$exports = {};

$parcel$export($5d373ce01680b655$exports, "min", () => $5d373ce01680b655$export$96ec731ed4dcb222, (v) => $5d373ce01680b655$export$96ec731ed4dcb222 = v);
var $5d373ce01680b655$export$96ec731ed4dcb222;
"use strict";
$5d373ce01680b655$export$96ec731ed4dcb222 = $5d373ce01680b655$var$min;

/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */ function $5d373ce01680b655$var$min(dates) {
    let result;
    dates.forEach((dirtyDate)=>{
        const date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dirtyDate);
        if (!result || result > date || isNaN(+date)) result = date;
    });
    return result || new Date(NaN);
}


/**
 * @name clamp
 * @category Interval Helpers
 * @summary Return a date bounded by the start and the end of the given interval
 *
 * @description
 * Clamps a date to the lower bound with the start of the interval and the upper
 * bound with the end of the interval.
 *
 * - When the date is less than the start of the interval, the start is returned.
 * - When the date is greater than the end of the interval, the end is returned.
 * - Otherwise the date is returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be bounded
 * @param interval - The interval to bound to
 *
 * @returns The date bounded by the start and the end of the interval
 *
 * @example
 * // What is Mar, 21, 2021 bounded to an interval starting at Mar, 22, 2021 and ending at Apr, 01, 2021
 * const result = clamp(new Date(2021, 2, 21), {
 *   start: new Date(2021, 2, 22),
 *   end: new Date(2021, 3, 1),
 * })
 * //=> Mon Mar 22 2021 00:00:00
 */ function $5a85a167b627226d$var$clamp(date, interval) {
    return (0, $5d373ce01680b655$export$96ec731ed4dcb222)([
        (0, $b70baca84fc92b6d$export$8960430cfd85939f)([
            date,
            interval.start
        ]),
        interval.end
    ]);
}


Object.keys($5a85a167b627226d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $5a85a167b627226d$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $5a85a167b627226d$exports[key];
        }
    });
});
var $0a8ccabde02ae96a$exports = {};

$parcel$export($0a8ccabde02ae96a$exports, "closestIndexTo", () => $0a8ccabde02ae96a$export$42127b72a9d091c7, (v) => $0a8ccabde02ae96a$export$42127b72a9d091c7 = v);
var $0a8ccabde02ae96a$export$42127b72a9d091c7;
"use strict";
$0a8ccabde02ae96a$export$42127b72a9d091c7 = $0a8ccabde02ae96a$var$closestIndexTo;

/**
 * @name closestIndexTo
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns An index of the date closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * const dateToCompare = new Date(2015, 8, 6)
 * const datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * const result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */ function $0a8ccabde02ae96a$var$closestIndexTo(dateToCompare, dates) {
    const date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateToCompare);
    if (isNaN(Number(date))) return NaN;
    const timeToCompare = date.getTime();
    let result;
    let minDistance;
    dates.forEach(function(dirtyDate, index) {
        const currentDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = NaN;
            minDistance = NaN;
            return;
        }
        const distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < minDistance) {
            result = index;
            minDistance = distance;
        }
    });
    return result;
}


Object.keys($0a8ccabde02ae96a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $0a8ccabde02ae96a$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $0a8ccabde02ae96a$exports[key];
        }
    });
});
var $a5d88e0ec96e8c2a$exports = {};

$parcel$export($a5d88e0ec96e8c2a$exports, "closestTo", () => $a5d88e0ec96e8c2a$export$73858b464497125a, (v) => $a5d88e0ec96e8c2a$export$73858b464497125a = v);
var $a5d88e0ec96e8c2a$export$73858b464497125a;
"use strict";
$a5d88e0ec96e8c2a$export$73858b464497125a = $a5d88e0ec96e8c2a$var$closestTo;


/**
 * @name closestTo
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns The date from the array closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * const dateToCompare = new Date(2015, 8, 6)
 * const result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */ function $a5d88e0ec96e8c2a$var$closestTo(dateToCompare, dates) {
    const date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateToCompare);
    if (isNaN(Number(date))) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(dateToCompare, NaN);
    const timeToCompare = date.getTime();
    let result;
    let minDistance;
    dates.forEach((dirtyDate)=>{
        const currentDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(dateToCompare, NaN);
            minDistance = NaN;
            return;
        }
        const distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < minDistance) {
            result = currentDate;
            minDistance = distance;
        }
    });
    return result;
}


Object.keys($a5d88e0ec96e8c2a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a5d88e0ec96e8c2a$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a5d88e0ec96e8c2a$exports[key];
        }
    });
});
var $e9cff913190bd013$exports = {};

$parcel$export($e9cff913190bd013$exports, "compareAsc", () => $e9cff913190bd013$export$fe114145ae75d197, (v) => $e9cff913190bd013$export$fe114145ae75d197 = v);
var $e9cff913190bd013$export$fe114145ae75d197;
"use strict";
$e9cff913190bd013$export$fe114145ae75d197 = $e9cff913190bd013$var$compareAsc;

/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */ function $e9cff913190bd013$var$compareAsc(dateLeft, dateRight) {
    const _dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}


Object.keys($e9cff913190bd013$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $e9cff913190bd013$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $e9cff913190bd013$exports[key];
        }
    });
});
var $14d58ffa6ac05331$exports = {};

$parcel$export($14d58ffa6ac05331$exports, "compareDesc", () => $14d58ffa6ac05331$export$ed84005ac9356f7a, (v) => $14d58ffa6ac05331$export$ed84005ac9356f7a = v);
var $14d58ffa6ac05331$export$ed84005ac9356f7a;
"use strict";
$14d58ffa6ac05331$export$ed84005ac9356f7a = $14d58ffa6ac05331$var$compareDesc;

/**
 * @name compareDesc
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * const result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */ function $14d58ffa6ac05331$var$compareDesc(dateLeft, dateRight) {
    const _dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff > 0) return -1;
    else if (diff < 0) return 1;
    else return diff;
}


Object.keys($14d58ffa6ac05331$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $14d58ffa6ac05331$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $14d58ffa6ac05331$exports[key];
        }
    });
});

Object.keys($abb9adbdb26342b3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $abb9adbdb26342b3$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $abb9adbdb26342b3$exports[key];
        }
    });
});
var $d8623e255497753b$exports = {};

$parcel$export($d8623e255497753b$exports, "constructNow", () => $d8623e255497753b$export$18c3c6510fb97afc, (v) => $d8623e255497753b$export$18c3c6510fb97afc = v);
var $d8623e255497753b$export$18c3c6510fb97afc;
"use strict";
$d8623e255497753b$export$18c3c6510fb97afc = $d8623e255497753b$var$constructNow;

/**
 * @name constructNow
 * @category Generic Helpers
 * @summary Constructs a new current date using the passed value constructor.
 * @pure false
 *
 * @description
 * The function constructs a new current date using the constructor from
 * the reference date. It helps to build generic functions that accept date
 * extensions and use the current date.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 *
 * @returns Current date initialized using the given date constructor
 *
 * @example
 * import { constructNow, isSameDay } from 'date-fns'
 *
 * function isToday<DateType extends Date>(
 *   date: DateType | number | string,
 * ): boolean {
 *   // If we were to use `new Date()` directly, the function would  behave
 *   // differently in different timezones and return false for the same date.
 *   return isSameDay(date, constructNow(date));
 * }
 */ function $d8623e255497753b$var$constructNow(date) {
    return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, Date.now());
}


Object.keys($d8623e255497753b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d8623e255497753b$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d8623e255497753b$exports[key];
        }
    });
});
var $316e04d0ee94a61b$exports = {};

$parcel$export($316e04d0ee94a61b$exports, "daysToWeeks", () => $316e04d0ee94a61b$export$66d8b66cbb6006a8, (v) => $316e04d0ee94a61b$export$66d8b66cbb6006a8 = v);
var $316e04d0ee94a61b$export$66d8b66cbb6006a8;
"use strict";
$316e04d0ee94a61b$export$66d8b66cbb6006a8 = $316e04d0ee94a61b$var$daysToWeeks;

/**
 * @name daysToWeeks
 * @category Conversion Helpers
 * @summary Convert days to weeks.
 *
 * @description
 * Convert a number of days to a full number of weeks.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param days - The number of days to be converted
 *
 * @returns The number of days converted in weeks
 *
 * @example
 * // Convert 14 days to weeks:
 * const result = daysToWeeks(14)
 * //=> 2
 *
 * @example
 * // It uses trunc rounding:
 * const result = daysToWeeks(13)
 * //=> 1
 */ function $316e04d0ee94a61b$var$daysToWeeks(days) {
    const weeks = days / $8540a44f59a4af84$export$dfd9b671c89acc8e;
    const result = Math.trunc(weeks);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


Object.keys($316e04d0ee94a61b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $316e04d0ee94a61b$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $316e04d0ee94a61b$exports[key];
        }
    });
});
var $7609e09e1797fdf5$exports = {};

$parcel$export($7609e09e1797fdf5$exports, "differenceInBusinessDays", () => $7609e09e1797fdf5$export$f30d3269a6c53cb9, (v) => $7609e09e1797fdf5$export$f30d3269a6c53cb9 = v);
var $7609e09e1797fdf5$export$f30d3269a6c53cb9;
"use strict";
$7609e09e1797fdf5$export$f30d3269a6c53cb9 = $7609e09e1797fdf5$var$differenceInBusinessDays;


var $27a7db21eafd685b$exports = {};

$parcel$export($27a7db21eafd685b$exports, "isSameDay", () => $27a7db21eafd685b$export$ea39ec197993aef0, (v) => $27a7db21eafd685b$export$ea39ec197993aef0 = v);
var $27a7db21eafd685b$export$ea39ec197993aef0;
"use strict";
$27a7db21eafd685b$export$ea39ec197993aef0 = $27a7db21eafd685b$var$isSameDay;

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */ function $27a7db21eafd685b$var$isSameDay(dateLeft, dateRight) {
    const dateLeftStartOfDay = (0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(dateLeft);
    const dateRightStartOfDay = (0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(dateRight);
    return +dateLeftStartOfDay === +dateRightStartOfDay;
}





/**
 * @name differenceInBusinessDays
 * @category Day Helpers
 * @summary Get the number of business days between the given dates.
 *
 * @description
 * Get the number of business day periods between the given dates.
 * Business days being days that arent in the weekend.
 * Like `differenceInCalendarDays`, the function removes the times from
 * the dates before calculating the difference.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of business days
 *
 * @example
 * // How many business days are between
 * // 10 January 2014 and 20 July 2014?
 * const result = differenceInBusinessDays(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 0, 10)
 * )
 * //=> 136
 *
 * // How many business days are between
 * // 30 November 2021 and 1 November 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 30),
 *   new Date(2021, 10, 1)
 * )
 * //=> 21
 *
 * // How many business days are between
 * // 1 November 2021 and 1 December 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 11, 1)
 * )
 * //=> -22
 *
 * // How many business days are between
 * // 1 November 2021 and 1 November 2021 ?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 10, 1)
 * )
 * //=> 0
 */ function $7609e09e1797fdf5$var$differenceInBusinessDays(dateLeft, dateRight) {
    const _dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft);
    let _dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    if (!(0, $f2a682b251363bc2$export$1ea939691cdc45b8)(_dateLeft) || !(0, $f2a682b251363bc2$export$1ea939691cdc45b8)(_dateRight)) return NaN;
    const calendarDifference = (0, $737f54e9ffaddc15$export$4a02e9c37dab4871)(_dateLeft, _dateRight);
    const sign = calendarDifference < 0 ? -1 : 1;
    const weeks = Math.trunc(calendarDifference / 7);
    let result = weeks * 5;
    _dateRight = (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(_dateRight, weeks * 7);
    // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week
    while(!(0, $27a7db21eafd685b$export$ea39ec197993aef0)(_dateLeft, _dateRight)){
        // sign is used to account for both negative and positive differences
        result += (0, $126e0ee47695e680$export$618d60ea299da42)(_dateRight) ? 0 : sign;
        _dateRight = (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(_dateRight, sign);
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


Object.keys($7609e09e1797fdf5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $7609e09e1797fdf5$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $7609e09e1797fdf5$exports[key];
        }
    });
});

Object.keys($737f54e9ffaddc15$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $737f54e9ffaddc15$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $737f54e9ffaddc15$exports[key];
        }
    });
});
var $e1e14fdea06c0988$exports = {};

$parcel$export($e1e14fdea06c0988$exports, "differenceInCalendarISOWeekYears", () => $e1e14fdea06c0988$export$7f8a73dc2e50a070, (v) => $e1e14fdea06c0988$export$7f8a73dc2e50a070 = v);
var $e1e14fdea06c0988$export$7f8a73dc2e50a070;
"use strict";
$e1e14fdea06c0988$export$7f8a73dc2e50a070 = $e1e14fdea06c0988$var$differenceInCalendarISOWeekYears;

/**
 * @name differenceInCalendarISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO week-numbering years
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * const result = differenceInCalendarISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */ function $e1e14fdea06c0988$var$differenceInCalendarISOWeekYears(dateLeft, dateRight) {
    return (0, $c95dff76bf2f692a$export$3dbc52535f6f8fcc)(dateLeft) - (0, $c95dff76bf2f692a$export$3dbc52535f6f8fcc)(dateRight);
}


Object.keys($e1e14fdea06c0988$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $e1e14fdea06c0988$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $e1e14fdea06c0988$exports[key];
        }
    });
});
var $6f59510051d42333$exports = {};

$parcel$export($6f59510051d42333$exports, "differenceInCalendarISOWeeks", () => $6f59510051d42333$export$28df1cb58b17e450, (v) => $6f59510051d42333$export$28df1cb58b17e450 = v);
var $6f59510051d42333$export$28df1cb58b17e450;
"use strict";
$6f59510051d42333$export$28df1cb58b17e450 = $6f59510051d42333$var$differenceInCalendarISOWeeks;



/**
 * @name differenceInCalendarISOWeeks
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO weeks
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * const result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */ function $6f59510051d42333$var$differenceInCalendarISOWeeks(dateLeft, dateRight) {
    const startOfISOWeekLeft = (0, $1c9d32c6cb108460$export$6173213f95a4431e)(dateLeft);
    const startOfISOWeekRight = (0, $1c9d32c6cb108460$export$6173213f95a4431e)(dateRight);
    const timestampLeft = +startOfISOWeekLeft - (0, $92dc0740ffabe180$export$113002b5eff6e430)(startOfISOWeekLeft);
    const timestampRight = +startOfISOWeekRight - (0, $92dc0740ffabe180$export$113002b5eff6e430)(startOfISOWeekRight);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $8540a44f59a4af84$export$4fad13613e88edc8);
}


Object.keys($6f59510051d42333$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $6f59510051d42333$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $6f59510051d42333$exports[key];
        }
    });
});
var $8aa264ebd3f03841$exports = {};

$parcel$export($8aa264ebd3f03841$exports, "differenceInCalendarMonths", () => $8aa264ebd3f03841$export$489984ac7c996389, (v) => $8aa264ebd3f03841$export$489984ac7c996389 = v);
var $8aa264ebd3f03841$export$489984ac7c996389;
"use strict";
$8aa264ebd3f03841$export$489984ac7c996389 = $8aa264ebd3f03841$var$differenceInCalendarMonths;

/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */ function $8aa264ebd3f03841$var$differenceInCalendarMonths(dateLeft, dateRight) {
    const _dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const monthDiff = _dateLeft.getMonth() - _dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}


Object.keys($8aa264ebd3f03841$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $8aa264ebd3f03841$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $8aa264ebd3f03841$exports[key];
        }
    });
});
var $5806b276dadb0858$exports = {};

$parcel$export($5806b276dadb0858$exports, "differenceInCalendarQuarters", () => $5806b276dadb0858$export$f62ae9fb13958c7a, (v) => $5806b276dadb0858$export$f62ae9fb13958c7a = v);
var $5806b276dadb0858$export$f62ae9fb13958c7a;
"use strict";
$5806b276dadb0858$export$f62ae9fb13958c7a = $5806b276dadb0858$var$differenceInCalendarQuarters;
var $763325f0c93713da$exports = {};

$parcel$export($763325f0c93713da$exports, "getQuarter", () => $763325f0c93713da$export$de90a4bb31c25221, (v) => $763325f0c93713da$export$de90a4bb31c25221 = v);
var $763325f0c93713da$export$de90a4bb31c25221;
"use strict";
$763325f0c93713da$export$de90a4bb31c25221 = $763325f0c93713da$var$getQuarter;

/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */ function $763325f0c93713da$var$getQuarter(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const quarter = Math.trunc(_date.getMonth() / 3) + 1;
    return quarter;
}



/**
 * @name differenceInCalendarQuarters
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */ function $5806b276dadb0858$var$differenceInCalendarQuarters(dateLeft, dateRight) {
    const _dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const quarterDiff = (0, $763325f0c93713da$export$de90a4bb31c25221)(_dateLeft) - (0, $763325f0c93713da$export$de90a4bb31c25221)(_dateRight);
    return yearDiff * 4 + quarterDiff;
}


Object.keys($5806b276dadb0858$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $5806b276dadb0858$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $5806b276dadb0858$exports[key];
        }
    });
});
var $c8670ac5b8c1edee$exports = {};

$parcel$export($c8670ac5b8c1edee$exports, "differenceInCalendarWeeks", () => $c8670ac5b8c1edee$export$6ed034ce62348e4, (v) => $c8670ac5b8c1edee$export$6ed034ce62348e4 = v);
var $c8670ac5b8c1edee$export$6ed034ce62348e4;
"use strict";
$c8670ac5b8c1edee$export$6ed034ce62348e4 = $c8670ac5b8c1edee$var$differenceInCalendarWeeks;



/**
 * The {@link differenceInCalendarWeeks} function options.
 */ /**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */ function $c8670ac5b8c1edee$var$differenceInCalendarWeeks(dateLeft, dateRight, options) {
    const startOfWeekLeft = (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(dateLeft, options);
    const startOfWeekRight = (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(dateRight, options);
    const timestampLeft = +startOfWeekLeft - (0, $92dc0740ffabe180$export$113002b5eff6e430)(startOfWeekLeft);
    const timestampRight = +startOfWeekRight - (0, $92dc0740ffabe180$export$113002b5eff6e430)(startOfWeekRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a days is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $8540a44f59a4af84$export$4fad13613e88edc8);
}


Object.keys($c8670ac5b8c1edee$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c8670ac5b8c1edee$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c8670ac5b8c1edee$exports[key];
        }
    });
});
var $539ce3f7450453a1$exports = {};

$parcel$export($539ce3f7450453a1$exports, "differenceInCalendarYears", () => $539ce3f7450453a1$export$c06dce8b38891685, (v) => $539ce3f7450453a1$export$c06dce8b38891685 = v);
var $539ce3f7450453a1$export$c06dce8b38891685;
"use strict";
$539ce3f7450453a1$export$c06dce8b38891685 = $539ce3f7450453a1$var$differenceInCalendarYears;

/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */ function $539ce3f7450453a1$var$differenceInCalendarYears(dateLeft, dateRight) {
    const _dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    return _dateLeft.getFullYear() - _dateRight.getFullYear();
}


Object.keys($539ce3f7450453a1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $539ce3f7450453a1$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $539ce3f7450453a1$exports[key];
        }
    });
});
var $21c2b10d84e6b5ad$exports = {};

$parcel$export($21c2b10d84e6b5ad$exports, "differenceInDays", () => $21c2b10d84e6b5ad$export$86415ebf4eb36b8c, (v) => $21c2b10d84e6b5ad$export$86415ebf4eb36b8c = v);
var $21c2b10d84e6b5ad$export$86415ebf4eb36b8c;
"use strict";
$21c2b10d84e6b5ad$export$86415ebf4eb36b8c = $21c2b10d84e6b5ad$var$differenceInDays;


/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full days according to the local timezone
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 *
 * @example
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
 * //=> 92
 */ function $21c2b10d84e6b5ad$var$differenceInDays(dateLeft, dateRight) {
    const _dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    const sign = $21c2b10d84e6b5ad$var$compareLocalAsc(_dateLeft, _dateRight);
    const difference = Math.abs((0, $737f54e9ffaddc15$export$4a02e9c37dab4871)(_dateLeft, _dateRight));
    _dateLeft.setDate(_dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastDayNotFull = Number($21c2b10d84e6b5ad$var$compareLocalAsc(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $21c2b10d84e6b5ad$var$compareLocalAsc(dateLeft, dateRight) {
    const diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}


Object.keys($21c2b10d84e6b5ad$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $21c2b10d84e6b5ad$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $21c2b10d84e6b5ad$exports[key];
        }
    });
});
var $f1e71fcc3bd0bed6$exports = {};

$parcel$export($f1e71fcc3bd0bed6$exports, "differenceInHours", () => $f1e71fcc3bd0bed6$export$5436ca250d4d6872, (v) => $f1e71fcc3bd0bed6$export$5436ca250d4d6872 = v);
var $f1e71fcc3bd0bed6$export$5436ca250d4d6872;
"use strict";
$f1e71fcc3bd0bed6$export$5436ca250d4d6872 = $f1e71fcc3bd0bed6$var$differenceInHours;
var $495af4000bb18bf7$export$b6474a47258c1211;
"use strict";
$495af4000bb18bf7$export$b6474a47258c1211 = $495af4000bb18bf7$var$getRoundingMethod;
function $495af4000bb18bf7$var$getRoundingMethod(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}



var $b7913fc338fe28ad$exports = {};

$parcel$export($b7913fc338fe28ad$exports, "differenceInMilliseconds", () => $b7913fc338fe28ad$export$7be94d13716b4bf6, (v) => $b7913fc338fe28ad$export$7be94d13716b4bf6 = v);
var $b7913fc338fe28ad$export$7be94d13716b4bf6;
"use strict";
$b7913fc338fe28ad$export$7be94d13716b4bf6 = $b7913fc338fe28ad$var$differenceInMilliseconds;

/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */ function $b7913fc338fe28ad$var$differenceInMilliseconds(dateLeft, dateRight) {
    return +(0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft) - +(0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
}


/**
 * The {@link differenceInHours} function options.
 */ /**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * const result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */ function $f1e71fcc3bd0bed6$var$differenceInHours(dateLeft, dateRight, options) {
    const diff = (0, $b7913fc338fe28ad$export$7be94d13716b4bf6)(dateLeft, dateRight) / $8540a44f59a4af84$export$7f72910d6dfd237a;
    return (0, $495af4000bb18bf7$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}


Object.keys($f1e71fcc3bd0bed6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $f1e71fcc3bd0bed6$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $f1e71fcc3bd0bed6$exports[key];
        }
    });
});
var $c4e072f0adb8f68e$exports = {};

$parcel$export($c4e072f0adb8f68e$exports, "differenceInISOWeekYears", () => $c4e072f0adb8f68e$export$bf7bde0b3bf8913a, (v) => $c4e072f0adb8f68e$export$bf7bde0b3bf8913a = v);
var $c4e072f0adb8f68e$export$bf7bde0b3bf8913a;
"use strict";
$c4e072f0adb8f68e$export$bf7bde0b3bf8913a = $c4e072f0adb8f68e$var$differenceInISOWeekYears;


var $0ee59b8ff17647f3$exports = {};

$parcel$export($0ee59b8ff17647f3$exports, "subISOWeekYears", () => $0ee59b8ff17647f3$export$4f7d47b952f4a0aa, (v) => $0ee59b8ff17647f3$export$4f7d47b952f4a0aa = v);
var $0ee59b8ff17647f3$export$4f7d47b952f4a0aa;
"use strict";
$0ee59b8ff17647f3$export$4f7d47b952f4a0aa = $0ee59b8ff17647f3$var$subISOWeekYears;

/**
 * @name subISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be subtracted.
 *
 * @returns The new date with the ISO week-numbering years subtracted
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * const result = subISOWeekYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */ function $0ee59b8ff17647f3$var$subISOWeekYears(date, amount) {
    return (0, $bfbc76d70792463e$export$c8240694da10d5f)(date, -amount);
}



/**
 * @name differenceInISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full ISO week-numbering years
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * const result = differenceInISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */ function $c4e072f0adb8f68e$var$differenceInISOWeekYears(dateLeft, dateRight) {
    let _dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    const sign = (0, $e9cff913190bd013$export$fe114145ae75d197)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $e1e14fdea06c0988$export$7f8a73dc2e50a070)(_dateLeft, _dateRight));
    _dateLeft = (0, $0ee59b8ff17647f3$export$4f7d47b952f4a0aa)(_dateLeft, sign * difference);
    // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
    // if last calendar ISO year is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastISOWeekYearNotFull = Number((0, $e9cff913190bd013$export$fe114145ae75d197)(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastISOWeekYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


Object.keys($c4e072f0adb8f68e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c4e072f0adb8f68e$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c4e072f0adb8f68e$exports[key];
        }
    });
});

Object.keys($b7913fc338fe28ad$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $b7913fc338fe28ad$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $b7913fc338fe28ad$exports[key];
        }
    });
});
var $67e743be56b112ce$exports = {};

$parcel$export($67e743be56b112ce$exports, "differenceInMinutes", () => $67e743be56b112ce$export$d904251335be481a, (v) => $67e743be56b112ce$export$d904251335be481a = v);
var $67e743be56b112ce$export$d904251335be481a;
"use strict";
$67e743be56b112ce$export$d904251335be481a = $67e743be56b112ce$var$differenceInMinutes;



/**
 * The {@link differenceInMinutes} function options.
 */ /**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * const result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are between 10:01:59 and 10:00:00
 * const result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */ function $67e743be56b112ce$var$differenceInMinutes(dateLeft, dateRight, options) {
    const diff = (0, $b7913fc338fe28ad$export$7be94d13716b4bf6)(dateLeft, dateRight) / $8540a44f59a4af84$export$91246f0b9bd9beff;
    return (0, $495af4000bb18bf7$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}


Object.keys($67e743be56b112ce$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $67e743be56b112ce$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $67e743be56b112ce$exports[key];
        }
    });
});
var $4bb5df50b9b59298$exports = {};

$parcel$export($4bb5df50b9b59298$exports, "differenceInMonths", () => $4bb5df50b9b59298$export$fc1ed482c2861792, (v) => $4bb5df50b9b59298$export$fc1ed482c2861792 = v);
var $4bb5df50b9b59298$export$fc1ed482c2861792;
"use strict";
$4bb5df50b9b59298$export$fc1ed482c2861792 = $4bb5df50b9b59298$var$differenceInMonths;


var $d2050f4e5c1a3003$exports = {};

$parcel$export($d2050f4e5c1a3003$exports, "isLastDayOfMonth", () => $d2050f4e5c1a3003$export$c817d0312007ea5e, (v) => $d2050f4e5c1a3003$export$c817d0312007ea5e = v);
var $d2050f4e5c1a3003$export$c817d0312007ea5e;
"use strict";
$d2050f4e5c1a3003$export$c817d0312007ea5e = $d2050f4e5c1a3003$var$isLastDayOfMonth;
var $b6a2419fd0059687$exports = {};

$parcel$export($b6a2419fd0059687$exports, "endOfDay", () => $b6a2419fd0059687$export$eb9a03f0e9aa6cea, (v) => $b6a2419fd0059687$export$eb9a03f0e9aa6cea = v);
var $b6a2419fd0059687$export$eb9a03f0e9aa6cea;
"use strict";
$b6a2419fd0059687$export$eb9a03f0e9aa6cea = $b6a2419fd0059687$var$endOfDay;

/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */ function $b6a2419fd0059687$var$endOfDay(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setHours(23, 59, 59, 999);
    return _date;
}


var $e58340063d97ab50$exports = {};

$parcel$export($e58340063d97ab50$exports, "endOfMonth", () => $e58340063d97ab50$export$a2258d9c4118825c, (v) => $e58340063d97ab50$export$a2258d9c4118825c = v);
var $e58340063d97ab50$export$a2258d9c4118825c;
"use strict";
$e58340063d97ab50$export$a2258d9c4118825c = $e58340063d97ab50$var$endOfMonth;

/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function $e58340063d97ab50$var$endOfMonth(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}



/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * const result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */ function $d2050f4e5c1a3003$var$isLastDayOfMonth(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    return +(0, $b6a2419fd0059687$export$eb9a03f0e9aa6cea)(_date) === +(0, $e58340063d97ab50$export$a2258d9c4118825c)(_date);
}



/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */ function $4bb5df50b9b59298$var$differenceInMonths(dateLeft, dateRight) {
    const _dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    const sign = (0, $e9cff913190bd013$export$fe114145ae75d197)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $8aa264ebd3f03841$export$489984ac7c996389)(_dateLeft, _dateRight));
    let result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (_dateLeft.getMonth() === 1 && _dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        _dateLeft.setDate(30);
        _dateLeft.setMonth(_dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        let isLastMonthNotFull = (0, $e9cff913190bd013$export$fe114145ae75d197)(_dateLeft, _dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $d2050f4e5c1a3003$export$c817d0312007ea5e)((0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft)) && difference === 1 && (0, $e9cff913190bd013$export$fe114145ae75d197)(dateLeft, _dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


Object.keys($4bb5df50b9b59298$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $4bb5df50b9b59298$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $4bb5df50b9b59298$exports[key];
        }
    });
});
var $03f220a44a4339e3$exports = {};

$parcel$export($03f220a44a4339e3$exports, "differenceInQuarters", () => $03f220a44a4339e3$export$74b5c4055a405552, (v) => $03f220a44a4339e3$export$74b5c4055a405552 = v);
var $03f220a44a4339e3$export$74b5c4055a405552;
"use strict";
$03f220a44a4339e3$export$74b5c4055a405552 = $03f220a44a4339e3$var$differenceInQuarters;


/**
 * The {@link differenceInQuarters} function options.
 */ /**
 * @name differenceInQuarters
 * @category Quarter Helpers
 * @summary Get the number of quarters between the given dates.
 *
 * @description
 * Get the number of quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of full quarters
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
 * //=> 2
 */ function $03f220a44a4339e3$var$differenceInQuarters(dateLeft, dateRight, options) {
    const diff = (0, $4bb5df50b9b59298$export$fc1ed482c2861792)(dateLeft, dateRight) / 3;
    return (0, $495af4000bb18bf7$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}


Object.keys($03f220a44a4339e3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $03f220a44a4339e3$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $03f220a44a4339e3$exports[key];
        }
    });
});
var $e9186d0161460806$exports = {};

$parcel$export($e9186d0161460806$exports, "differenceInSeconds", () => $e9186d0161460806$export$c1889aec51783710, (v) => $e9186d0161460806$export$c1889aec51783710 = v);
var $e9186d0161460806$export$c1889aec51783710;
"use strict";
$e9186d0161460806$export$c1889aec51783710 = $e9186d0161460806$var$differenceInSeconds;


/**
 * The {@link differenceInSeconds} function options.
 */ /**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */ function $e9186d0161460806$var$differenceInSeconds(dateLeft, dateRight, options) {
    const diff = (0, $b7913fc338fe28ad$export$7be94d13716b4bf6)(dateLeft, dateRight) / 1000;
    return (0, $495af4000bb18bf7$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}


Object.keys($e9186d0161460806$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $e9186d0161460806$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $e9186d0161460806$exports[key];
        }
    });
});
var $84f21af906303191$exports = {};

$parcel$export($84f21af906303191$exports, "differenceInWeeks", () => $84f21af906303191$export$b5147a91dc40ddb7, (v) => $84f21af906303191$export$b5147a91dc40ddb7 = v);
var $84f21af906303191$export$b5147a91dc40ddb7;
"use strict";
$84f21af906303191$export$b5147a91dc40ddb7 = $84f21af906303191$var$differenceInWeeks;


/**
 * The {@link differenceInWeeks} function options.
 */ /**
 * @name differenceInWeeks
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between two dates. Fractional weeks are
 * truncated towards zero by default.
 *
 * One "full week" is the distance between a local time in one day to the same
 * local time 7 days earlier or later. A full week can sometimes be less than
 * or more than 7*24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options
 *
 * @returns The number of full weeks
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
 * //=> 2
 *
 * @example
 * // How many full weeks are between
 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 8 weeks (54 days),
 * // even if DST starts and the period has
 * // only 54*24-1 hours.
 * const result = differenceInWeeks(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 6)
 * )
 * //=> 8
 */ function $84f21af906303191$var$differenceInWeeks(dateLeft, dateRight, options) {
    const diff = (0, $21c2b10d84e6b5ad$export$86415ebf4eb36b8c)(dateLeft, dateRight) / 7;
    return (0, $495af4000bb18bf7$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}


Object.keys($84f21af906303191$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $84f21af906303191$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $84f21af906303191$exports[key];
        }
    });
});
var $bf315c5624a2ab0b$exports = {};

$parcel$export($bf315c5624a2ab0b$exports, "differenceInYears", () => $bf315c5624a2ab0b$export$ed6bf486f68899ca, (v) => $bf315c5624a2ab0b$export$ed6bf486f68899ca = v);
var $bf315c5624a2ab0b$export$ed6bf486f68899ca;
"use strict";
$bf315c5624a2ab0b$export$ed6bf486f68899ca = $bf315c5624a2ab0b$var$differenceInYears;



/**
 * @name differenceInYears
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
 * //=> 1
 */ function $bf315c5624a2ab0b$var$differenceInYears(dateLeft, dateRight) {
    const _dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    const sign = (0, $e9cff913190bd013$export$fe114145ae75d197)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $539ce3f7450453a1$export$c06dce8b38891685)(_dateLeft, _dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    _dateLeft.setFullYear(1584);
    _dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastYearNotFull = (0, $e9cff913190bd013$export$fe114145ae75d197)(_dateLeft, _dateRight) === -sign;
    const result = sign * (difference - +isLastYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


Object.keys($bf315c5624a2ab0b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $bf315c5624a2ab0b$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $bf315c5624a2ab0b$exports[key];
        }
    });
});
var $0adf5760eb71daea$exports = {};

$parcel$export($0adf5760eb71daea$exports, "eachDayOfInterval", () => $0adf5760eb71daea$export$7a337e5923c7ceb5, (v) => $0adf5760eb71daea$export$7a337e5923c7ceb5 = v);
var $0adf5760eb71daea$export$7a337e5923c7ceb5;
"use strict";
$0adf5760eb71daea$export$7a337e5923c7ceb5 = $0adf5760eb71daea$var$eachDayOfInterval;

/**
 * The {@link eachDayOfInterval} function options.
 */ /**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of days from the day of the interval start to the day of the interval end
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */ function $0adf5760eb71daea$var$eachDayOfInterval(interval, options) {
    const startDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $231bfb8d72679740$export$e67a095c620b86fe)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($0adf5760eb71daea$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $0adf5760eb71daea$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $0adf5760eb71daea$exports[key];
        }
    });
});
var $b0a3f99021d001ef$exports = {};

$parcel$export($b0a3f99021d001ef$exports, "eachHourOfInterval", () => $b0a3f99021d001ef$export$bb4f48fee90ea86e, (v) => $b0a3f99021d001ef$export$bb4f48fee90ea86e = v);
var $b0a3f99021d001ef$export$bb4f48fee90ea86e;
"use strict";
$b0a3f99021d001ef$export$bb4f48fee90ea86e = $b0a3f99021d001ef$var$eachHourOfInterval;


/**
 * The {@link eachHourOfInterval} function options.
 */ /**
 * @name eachHourOfInterval
 * @category Interval Helpers
 * @summary Return the array of hours within the specified time interval.
 *
 * @description
 * Return the array of hours within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of hours from the hour of the interval start to the hour of the interval end
 *
 * @example
 * // Each hour between 6 October 2014, 12:00 and 6 October 2014, 15:00
 * const result = eachHourOfInterval({
 *   start: new Date(2014, 9, 6, 12),
 *   end: new Date(2014, 9, 6, 15)
 * })
 * //=> [
 * //   Mon Oct 06 2014 12:00:00,
 * //   Mon Oct 06 2014 13:00:00,
 * //   Mon Oct 06 2014 14:00:00,
 * //   Mon Oct 06 2014 15:00:00
 * // ]
 */ function $b0a3f99021d001ef$var$eachHourOfInterval(interval, options) {
    const startDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    let currentDate = reversed ? endDate : startDate;
    currentDate.setMinutes(0, 0, 0);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $231bfb8d72679740$export$e67a095c620b86fe)(currentDate));
        currentDate = (0, $dada8b88b0873e8d$export$4a4306ad4fa0e5e6)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($b0a3f99021d001ef$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $b0a3f99021d001ef$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $b0a3f99021d001ef$exports[key];
        }
    });
});
var $14e3ae081dfb5d06$exports = {};

$parcel$export($14e3ae081dfb5d06$exports, "eachMinuteOfInterval", () => $14e3ae081dfb5d06$export$82e17d693ce9eb6c, (v) => $14e3ae081dfb5d06$export$82e17d693ce9eb6c = v);
var $14e3ae081dfb5d06$export$82e17d693ce9eb6c;
"use strict";
$14e3ae081dfb5d06$export$82e17d693ce9eb6c = $14e3ae081dfb5d06$var$eachMinuteOfInterval;

var $d1ad424e56672364$exports = {};

$parcel$export($d1ad424e56672364$exports, "startOfMinute", () => $d1ad424e56672364$export$c66440458c6aa793, (v) => $d1ad424e56672364$export$c66440458c6aa793 = v);
var $d1ad424e56672364$export$c66440458c6aa793;
"use strict";
$d1ad424e56672364$export$c66440458c6aa793 = $d1ad424e56672364$var$startOfMinute;

/**
 * @name startOfMinute
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */ function $d1ad424e56672364$var$startOfMinute(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setSeconds(0, 0);
    return _date;
}



/**
 * The {@link eachMinuteOfInterval} function options.
 */ /**
 * @name eachMinuteOfInterval
 * @category Interval Helpers
 * @summary Return the array of minutes within the specified time interval.
 *
 * @description
 * Returns the array of minutes within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of minutes from the minute of the interval start to the minute of the interval end
 *
 * @example
 * // Each minute between 14 October 2020, 13:00 and 14 October 2020, 13:03
 * const result = eachMinuteOfInterval({
 *   start: new Date(2014, 9, 14, 13),
 *   end: new Date(2014, 9, 14, 13, 3)
 * })
 * //=> [
 * //   Wed Oct 14 2014 13:00:00,
 * //   Wed Oct 14 2014 13:01:00,
 * //   Wed Oct 14 2014 13:02:00,
 * //   Wed Oct 14 2014 13:03:00
 * // ]
 */ function $14e3ae081dfb5d06$var$eachMinuteOfInterval(interval, options) {
    const startDate = (0, $d1ad424e56672364$export$c66440458c6aa793)((0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.start));
    const endDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    let currentDate = reversed ? endDate : startDate;
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $231bfb8d72679740$export$e67a095c620b86fe)(currentDate));
        currentDate = (0, $e8dac3cf5df5dbc8$export$2287e3d29250119e)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($14e3ae081dfb5d06$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $14e3ae081dfb5d06$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $14e3ae081dfb5d06$exports[key];
        }
    });
});
var $f17d32e46529568a$exports = {};

$parcel$export($f17d32e46529568a$exports, "eachMonthOfInterval", () => $f17d32e46529568a$export$1c9322f2d2a5eed3, (v) => $f17d32e46529568a$export$1c9322f2d2a5eed3 = v);
var $f17d32e46529568a$export$1c9322f2d2a5eed3;
"use strict";
$f17d32e46529568a$export$1c9322f2d2a5eed3 = $f17d32e46529568a$var$eachMonthOfInterval;

/**
 * The {@link eachMonthOfInterval} function options.
 */ /**
 * @name eachMonthOfInterval
 * @category Interval Helpers
 * @summary Return the array of months within the specified time interval.
 *
 * @description
 * Return the array of months within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of months from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each month between 6 February 2014 and 10 August 2014:
 * const result = eachMonthOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Sat Feb 01 2014 00:00:00,
 * //   Sat Mar 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Thu May 01 2014 00:00:00,
 * //   Sun Jun 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * //   Fri Aug 01 2014 00:00:00
 * // ]
 */ function $f17d32e46529568a$var$eachMonthOfInterval(interval, options) {
    const startDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setDate(1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $231bfb8d72679740$export$e67a095c620b86fe)(currentDate));
        currentDate.setMonth(currentDate.getMonth() + step);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($f17d32e46529568a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $f17d32e46529568a$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $f17d32e46529568a$exports[key];
        }
    });
});
var $787ee41e326f83b2$exports = {};

$parcel$export($787ee41e326f83b2$exports, "eachQuarterOfInterval", () => $787ee41e326f83b2$export$96790a0abfab0078, (v) => $787ee41e326f83b2$export$96790a0abfab0078 = v);
var $787ee41e326f83b2$export$96790a0abfab0078;
"use strict";
$787ee41e326f83b2$export$96790a0abfab0078 = $787ee41e326f83b2$var$eachQuarterOfInterval;

var $c922a15e7d8774a7$exports = {};

$parcel$export($c922a15e7d8774a7$exports, "startOfQuarter", () => $c922a15e7d8774a7$export$69be7267a042ecb3, (v) => $c922a15e7d8774a7$export$69be7267a042ecb3 = v);
var $c922a15e7d8774a7$export$69be7267a042ecb3;
"use strict";
$c922a15e7d8774a7$export$69be7267a042ecb3 = $c922a15e7d8774a7$var$startOfQuarter;

/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */ function $c922a15e7d8774a7$var$startOfQuarter(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3;
    _date.setMonth(month, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}



/**
 * The {@link eachQuarterOfInterval} function options.
 */ /**
 * @name eachQuarterOfInterval
 * @category Interval Helpers
 * @summary Return the array of quarters within the specified time interval.
 *
 * @description
 * Return the array of quarters within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of quarters from the quarter of the interval start to the quarter of the interval end
 *
 * @example
 * // Each quarter within interval 6 February 2014 - 10 August 2014:
 * const result = eachQuarterOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * // ]
 */ function $787ee41e326f83b2$var$eachQuarterOfInterval(interval, options) {
    const startDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +(0, $c922a15e7d8774a7$export$69be7267a042ecb3)(startDate) : +(0, $c922a15e7d8774a7$export$69be7267a042ecb3)(endDate);
    let currentDate = reversed ? (0, $c922a15e7d8774a7$export$69be7267a042ecb3)(endDate) : (0, $c922a15e7d8774a7$export$69be7267a042ecb3)(startDate);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $231bfb8d72679740$export$e67a095c620b86fe)(currentDate));
        currentDate = (0, $30e5a3aa581ecd23$export$c252a41d0fbed2ce)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($787ee41e326f83b2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $787ee41e326f83b2$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $787ee41e326f83b2$exports[key];
        }
    });
});
var $72c3bea95dec77b2$exports = {};

$parcel$export($72c3bea95dec77b2$exports, "eachWeekOfInterval", () => $72c3bea95dec77b2$export$d31a8caec75fa456, (v) => $72c3bea95dec77b2$export$d31a8caec75fa456 = v);
var $72c3bea95dec77b2$export$d31a8caec75fa456;
"use strict";
$72c3bea95dec77b2$export$d31a8caec75fa456 = $72c3bea95dec77b2$var$eachWeekOfInterval;



/**
 * The {@link eachWeekOfInterval} function options.
 */ /**
 * @name eachWeekOfInterval
 * @category Interval Helpers
 * @summary Return the array of weeks within the specified time interval.
 *
 * @description
 * Return the array of weeks within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of weeks from the week of the interval start to the week of the interval end
 *
 * @example
 * // Each week within interval 6 October 2014 - 23 November 2014:
 * const result = eachWeekOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 10, 23)
 * })
 * //=> [
 * //   Sun Oct 05 2014 00:00:00,
 * //   Sun Oct 12 2014 00:00:00,
 * //   Sun Oct 19 2014 00:00:00,
 * //   Sun Oct 26 2014 00:00:00,
 * //   Sun Nov 02 2014 00:00:00,
 * //   Sun Nov 09 2014 00:00:00,
 * //   Sun Nov 16 2014 00:00:00,
 * //   Sun Nov 23 2014 00:00:00
 * // ]
 */ function $72c3bea95dec77b2$var$eachWeekOfInterval(interval, options) {
    const startDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const startDateWeek = reversed ? (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(endDate, options) : (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(startDate, options);
    const endDateWeek = reversed ? (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(startDate, options) : (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(endDate, options);
    // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
    startDateWeek.setHours(15);
    endDateWeek.setHours(15);
    const endTime = +endDateWeek.getTime();
    let currentDate = startDateWeek;
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        currentDate.setHours(0);
        dates.push((0, $231bfb8d72679740$export$e67a095c620b86fe)(currentDate));
        currentDate = (0, $bce641bd93181421$export$ef501a2bb4f3ee6b)(currentDate, step);
        currentDate.setHours(15);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($72c3bea95dec77b2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $72c3bea95dec77b2$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $72c3bea95dec77b2$exports[key];
        }
    });
});
var $adb2f2b5832b8aeb$exports = {};

$parcel$export($adb2f2b5832b8aeb$exports, "eachWeekendOfInterval", () => $adb2f2b5832b8aeb$export$a2ae85dd849354a8, (v) => $adb2f2b5832b8aeb$export$a2ae85dd849354a8 = v);
var $adb2f2b5832b8aeb$export$a2ae85dd849354a8;
"use strict";
$adb2f2b5832b8aeb$export$a2ae85dd849354a8 = $adb2f2b5832b8aeb$var$eachWeekendOfInterval;


/**
 * @name eachWeekendOfInterval
 * @category Interval Helpers
 * @summary List all the Saturdays and Sundays in the given date interval.
 *
 * @description
 * Get all the Saturdays and Sundays in the given date interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The given interval
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given date interval
 * const result = eachWeekendOfInterval({
 *   start: new Date(2018, 8, 17),
 *   end: new Date(2018, 8, 30)
 * })
 * //=> [
 * //   Sat Sep 22 2018 00:00:00,
 * //   Sun Sep 23 2018 00:00:00,
 * //   Sat Sep 29 2018 00:00:00,
 * //   Sun Sep 30 2018 00:00:00
 * // ]
 */ function $adb2f2b5832b8aeb$var$eachWeekendOfInterval(interval) {
    const dateInterval = (0, $0adf5760eb71daea$export$7a337e5923c7ceb5)(interval);
    const weekends = [];
    let index = 0;
    while(index < dateInterval.length){
        const date = dateInterval[index++];
        if ((0, $126e0ee47695e680$export$618d60ea299da42)(date)) weekends.push(date);
    }
    return weekends;
}


Object.keys($adb2f2b5832b8aeb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $adb2f2b5832b8aeb$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $adb2f2b5832b8aeb$exports[key];
        }
    });
});
var $870fa59f10358ead$exports = {};

$parcel$export($870fa59f10358ead$exports, "eachWeekendOfMonth", () => $870fa59f10358ead$export$f9a185d0ad232d17, (v) => $870fa59f10358ead$export$f9a185d0ad232d17 = v);
var $870fa59f10358ead$export$f9a185d0ad232d17;
"use strict";
$870fa59f10358ead$export$f9a185d0ad232d17 = $870fa59f10358ead$var$eachWeekendOfMonth;


var $c0b4ec5551eca4c9$exports = {};

$parcel$export($c0b4ec5551eca4c9$exports, "startOfMonth", () => $c0b4ec5551eca4c9$export$a5a3b454ada2268e, (v) => $c0b4ec5551eca4c9$export$a5a3b454ada2268e = v);
var $c0b4ec5551eca4c9$export$a5a3b454ada2268e;
"use strict";
$c0b4ec5551eca4c9$export$a5a3b454ada2268e = $c0b4ec5551eca4c9$var$startOfMonth;

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $c0b4ec5551eca4c9$var$startOfMonth(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


/**
 * @name eachWeekendOfMonth
 * @category Month Helpers
 * @summary List all the Saturdays and Sundays in the given month.
 *
 * @description
 * Get all the Saturdays and Sundays in the given month.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given month
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given month
 * const result = eachWeekendOfMonth(new Date(2022, 1, 1))
 * //=> [
 * //   Sat Feb 05 2022 00:00:00,
 * //   Sun Feb 06 2022 00:00:00,
 * //   Sat Feb 12 2022 00:00:00,
 * //   Sun Feb 13 2022 00:00:00,
 * //   Sat Feb 19 2022 00:00:00,
 * //   Sun Feb 20 2022 00:00:00,
 * //   Sat Feb 26 2022 00:00:00,
 * //   Sun Feb 27 2022 00:00:00
 * // ]
 */ function $870fa59f10358ead$var$eachWeekendOfMonth(date) {
    const start = (0, $c0b4ec5551eca4c9$export$a5a3b454ada2268e)(date);
    const end = (0, $e58340063d97ab50$export$a2258d9c4118825c)(date);
    return (0, $adb2f2b5832b8aeb$export$a2ae85dd849354a8)({
        start: start,
        end: end
    });
}


Object.keys($870fa59f10358ead$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $870fa59f10358ead$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $870fa59f10358ead$exports[key];
        }
    });
});
var $eda896eb36e12788$exports = {};

$parcel$export($eda896eb36e12788$exports, "eachWeekendOfYear", () => $eda896eb36e12788$export$d4a9e5efc1ddceb9, (v) => $eda896eb36e12788$export$d4a9e5efc1ddceb9 = v);
var $eda896eb36e12788$export$d4a9e5efc1ddceb9;
"use strict";
$eda896eb36e12788$export$d4a9e5efc1ddceb9 = $eda896eb36e12788$var$eachWeekendOfYear;

var $6cbfdc6d008595cd$exports = {};

$parcel$export($6cbfdc6d008595cd$exports, "endOfYear", () => $6cbfdc6d008595cd$export$8b7aa55c66d5569e, (v) => $6cbfdc6d008595cd$export$8b7aa55c66d5569e = v);
var $6cbfdc6d008595cd$export$8b7aa55c66d5569e;
"use strict";
$6cbfdc6d008595cd$export$8b7aa55c66d5569e = $6cbfdc6d008595cd$var$endOfYear;

/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */ function $6cbfdc6d008595cd$var$endOfYear(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}



/**
 * @name eachWeekendOfYear
 * @category Year Helpers
 * @summary List all the Saturdays and Sundays in the year.
 *
 * @description
 * Get all the Saturdays and Sundays in the year.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given year
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the year
 * const result = eachWeekendOfYear(new Date(2020, 1, 1))
 * //=> [
 * //   Sat Jan 03 2020 00:00:00,
 * //   Sun Jan 04 2020 00:00:00,
 * //   ...
 * //   Sun Dec 27 2020 00:00:00
 * // ]
 * ]
 */ function $eda896eb36e12788$var$eachWeekendOfYear(date) {
    const start = (0, $29cc086f79701cd9$export$f91e89d3d0406102)(date);
    const end = (0, $6cbfdc6d008595cd$export$8b7aa55c66d5569e)(date);
    return (0, $adb2f2b5832b8aeb$export$a2ae85dd849354a8)({
        start: start,
        end: end
    });
}


Object.keys($eda896eb36e12788$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $eda896eb36e12788$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $eda896eb36e12788$exports[key];
        }
    });
});
var $fd60f2d8b17fd3e1$exports = {};

$parcel$export($fd60f2d8b17fd3e1$exports, "eachYearOfInterval", () => $fd60f2d8b17fd3e1$export$9b7f165f0a71d2a5, (v) => $fd60f2d8b17fd3e1$export$9b7f165f0a71d2a5 = v);
var $fd60f2d8b17fd3e1$export$9b7f165f0a71d2a5;
"use strict";
$fd60f2d8b17fd3e1$export$9b7f165f0a71d2a5 = $fd60f2d8b17fd3e1$var$eachYearOfInterval;

/**
 * The {@link eachYearOfInterval} function options.
 */ /**
 * @name eachYearOfInterval
 * @category Interval Helpers
 * @summary Return the array of yearly timestamps within the specified time interval.
 *
 * @description
 * Return the array of yearly timestamps within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 *
 * @returns The array with starts of yearly timestamps from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each year between 6 February 2014 and 10 August 2017:
 * const result = eachYearOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2017, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Thu Jan 01 2015 00:00:00,
 * //   Fri Jan 01 2016 00:00:00,
 * //   Sun Jan 01 2017 00:00:00
 * // ]
 */ function $fd60f2d8b17fd3e1$var$eachYearOfInterval(interval, options) {
    const startDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setMonth(0, 1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $231bfb8d72679740$export$e67a095c620b86fe)(currentDate));
        currentDate.setFullYear(currentDate.getFullYear() + step);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($fd60f2d8b17fd3e1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $fd60f2d8b17fd3e1$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $fd60f2d8b17fd3e1$exports[key];
        }
    });
});

Object.keys($b6a2419fd0059687$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $b6a2419fd0059687$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $b6a2419fd0059687$exports[key];
        }
    });
});
var $ebb5e0a078c03ed7$exports = {};

$parcel$export($ebb5e0a078c03ed7$exports, "endOfDecade", () => $ebb5e0a078c03ed7$export$b922ac31d5bbe7a6, (v) => $ebb5e0a078c03ed7$export$b922ac31d5bbe7a6 = v);
var $ebb5e0a078c03ed7$export$b922ac31d5bbe7a6;
"use strict";
$ebb5e0a078c03ed7$export$b922ac31d5bbe7a6 = $ebb5e0a078c03ed7$var$endOfDecade;

/**
 * @name endOfDecade
 * @category Decade Helpers
 * @summary Return the end of a decade for the given date.
 *
 * @description
 * Return the end of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a decade
 *
 * @example
 * // The end of a decade for 12 May 1984 00:00:00:
 * const result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
 * //=> Dec 31 1989 23:59:59.999
 */ function $ebb5e0a078c03ed7$var$endOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const decade = 9 + Math.floor(year / 10) * 10;
    _date.setFullYear(decade, 11, 31);
    _date.setHours(23, 59, 59, 999);
    return _date;
}


Object.keys($ebb5e0a078c03ed7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $ebb5e0a078c03ed7$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $ebb5e0a078c03ed7$exports[key];
        }
    });
});
var $49e734d34adabd84$exports = {};

$parcel$export($49e734d34adabd84$exports, "endOfHour", () => $49e734d34adabd84$export$95ae95d2176c5f0, (v) => $49e734d34adabd84$export$95ae95d2176c5f0 = v);
var $49e734d34adabd84$export$95ae95d2176c5f0;
"use strict";
$49e734d34adabd84$export$95ae95d2176c5f0 = $49e734d34adabd84$var$endOfHour;

/**
 * @name endOfHour
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an hour
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * const result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */ function $49e734d34adabd84$var$endOfHour(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setMinutes(59, 59, 999);
    return _date;
}


Object.keys($49e734d34adabd84$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $49e734d34adabd84$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $49e734d34adabd84$exports[key];
        }
    });
});
var $3505726b435bc449$exports = {};

$parcel$export($3505726b435bc449$exports, "endOfISOWeek", () => $3505726b435bc449$export$186cd934f32084be, (v) => $3505726b435bc449$export$186cd934f32084be = v);
var $3505726b435bc449$export$186cd934f32084be;
"use strict";
$3505726b435bc449$export$186cd934f32084be = $3505726b435bc449$var$endOfISOWeek;
var $d53308c42f1e4c62$exports = {};

$parcel$export($d53308c42f1e4c62$exports, "endOfWeek", () => $d53308c42f1e4c62$export$ef8b6d9133084f4e, (v) => $d53308c42f1e4c62$export$ef8b6d9133084f4e = v);
var $d53308c42f1e4c62$export$ef8b6d9133084f4e;
"use strict";
$d53308c42f1e4c62$export$ef8b6d9133084f4e = $d53308c42f1e4c62$var$endOfWeek;


/**
 * The {@link endOfWeek} function options.
 */ /**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function $d53308c42f1e4c62$var$endOfWeek(date, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}


/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * const result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function $3505726b435bc449$var$endOfISOWeek(date) {
    return (0, $d53308c42f1e4c62$export$ef8b6d9133084f4e)(date, {
        weekStartsOn: 1
    });
}


Object.keys($3505726b435bc449$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $3505726b435bc449$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $3505726b435bc449$exports[key];
        }
    });
});
var $78a8aecdbc55404d$exports = {};

$parcel$export($78a8aecdbc55404d$exports, "endOfISOWeekYear", () => $78a8aecdbc55404d$export$73068f3824c9c1d, (v) => $78a8aecdbc55404d$export$73068f3824c9c1d = v);
var $78a8aecdbc55404d$export$73068f3824c9c1d;
"use strict";
$78a8aecdbc55404d$export$73068f3824c9c1d = $78a8aecdbc55404d$var$endOfISOWeekYear;



/**
 * @name endOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * const result = endOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */ function $78a8aecdbc55404d$var$endOfISOWeekYear(date) {
    const year = (0, $c95dff76bf2f692a$export$3dbc52535f6f8fcc)(date);
    const fourthOfJanuaryOfNextYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const _date = (0, $1c9d32c6cb108460$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    _date.setMilliseconds(_date.getMilliseconds() - 1);
    return _date;
}


Object.keys($78a8aecdbc55404d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $78a8aecdbc55404d$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $78a8aecdbc55404d$exports[key];
        }
    });
});
var $9dff17d493896adc$exports = {};

$parcel$export($9dff17d493896adc$exports, "endOfMinute", () => $9dff17d493896adc$export$a06a772fc63bff07, (v) => $9dff17d493896adc$export$a06a772fc63bff07 = v);
var $9dff17d493896adc$export$a06a772fc63bff07;
"use strict";
$9dff17d493896adc$export$a06a772fc63bff07 = $9dff17d493896adc$var$endOfMinute;

/**
 * @name endOfMinute
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a minute
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * const result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */ function $9dff17d493896adc$var$endOfMinute(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setSeconds(59, 999);
    return _date;
}


Object.keys($9dff17d493896adc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $9dff17d493896adc$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $9dff17d493896adc$exports[key];
        }
    });
});

Object.keys($e58340063d97ab50$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $e58340063d97ab50$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $e58340063d97ab50$exports[key];
        }
    });
});
var $28fe4daca8fe3005$exports = {};

$parcel$export($28fe4daca8fe3005$exports, "endOfQuarter", () => $28fe4daca8fe3005$export$5f53493861eef879, (v) => $28fe4daca8fe3005$export$5f53493861eef879 = v);
var $28fe4daca8fe3005$export$5f53493861eef879;
"use strict";
$28fe4daca8fe3005$export$5f53493861eef879 = $28fe4daca8fe3005$var$endOfQuarter;

/**
 * @name endOfQuarter
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a quarter
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * const result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function $28fe4daca8fe3005$var$endOfQuarter(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}


Object.keys($28fe4daca8fe3005$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $28fe4daca8fe3005$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $28fe4daca8fe3005$exports[key];
        }
    });
});
var $ee0c9831f430316e$exports = {};

$parcel$export($ee0c9831f430316e$exports, "endOfSecond", () => $ee0c9831f430316e$export$ef560ab2fa7b52a2, (v) => $ee0c9831f430316e$export$ef560ab2fa7b52a2 = v);
var $ee0c9831f430316e$export$ef560ab2fa7b52a2;
"use strict";
$ee0c9831f430316e$export$ef560ab2fa7b52a2 = $ee0c9831f430316e$var$endOfSecond;

/**
 * @name endOfSecond
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a second
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * const result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */ function $ee0c9831f430316e$var$endOfSecond(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setMilliseconds(999);
    return _date;
}


Object.keys($ee0c9831f430316e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $ee0c9831f430316e$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $ee0c9831f430316e$exports[key];
        }
    });
});
var $c2770cefb072376e$exports = {};

$parcel$export($c2770cefb072376e$exports, "endOfToday", () => $c2770cefb072376e$export$1b7031a80bd92a6e, (v) => $c2770cefb072376e$export$1b7031a80bd92a6e = v);
var $c2770cefb072376e$export$1b7031a80bd92a6e;
"use strict";
$c2770cefb072376e$export$1b7031a80bd92a6e = $c2770cefb072376e$var$endOfToday;

/**
 * @name endOfToday
 * @category Day Helpers
 * @summary Return the end of today.
 * @pure false
 *
 * @description
 * Return the end of today.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */ function $c2770cefb072376e$var$endOfToday() {
    return (0, $b6a2419fd0059687$export$eb9a03f0e9aa6cea)(Date.now());
}


Object.keys($c2770cefb072376e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c2770cefb072376e$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c2770cefb072376e$exports[key];
        }
    });
});
var $42595d73b3e9f363$exports = {};

$parcel$export($42595d73b3e9f363$exports, "endOfTomorrow", () => $42595d73b3e9f363$export$d788ac27ae2a54ea, (v) => $42595d73b3e9f363$export$d788ac27ae2a54ea = v);
var $42595d73b3e9f363$export$d788ac27ae2a54ea;
"use strict";
$42595d73b3e9f363$export$d788ac27ae2a54ea = $42595d73b3e9f363$var$endOfTomorrow; /**
 * @name endOfTomorrow
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 * @pure false
 *
 * @description
 * Return the end of tomorrow.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */ 
function $42595d73b3e9f363$var$endOfTomorrow() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(23, 59, 59, 999);
    return date;
}


Object.keys($42595d73b3e9f363$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $42595d73b3e9f363$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $42595d73b3e9f363$exports[key];
        }
    });
});

Object.keys($d53308c42f1e4c62$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d53308c42f1e4c62$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d53308c42f1e4c62$exports[key];
        }
    });
});

Object.keys($6cbfdc6d008595cd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $6cbfdc6d008595cd$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $6cbfdc6d008595cd$exports[key];
        }
    });
});
var $81eecc2fe560ca77$exports = {};

$parcel$export($81eecc2fe560ca77$exports, "endOfYesterday", () => $81eecc2fe560ca77$export$45190faf1024f97a, (v) => $81eecc2fe560ca77$export$45190faf1024f97a = v);
var $81eecc2fe560ca77$export$45190faf1024f97a;
"use strict";
$81eecc2fe560ca77$export$45190faf1024f97a = $81eecc2fe560ca77$var$endOfYesterday; /**
 * @name endOfYesterday
 * @category Day Helpers
 * @summary Return the end of yesterday.
 * @pure false
 *
 * @description
 * Return the end of yesterday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */ 
function $81eecc2fe560ca77$var$endOfYesterday() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(23, 59, 59, 999);
    return date;
}


Object.keys($81eecc2fe560ca77$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $81eecc2fe560ca77$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $81eecc2fe560ca77$exports[key];
        }
    });
});

Object.keys($303ba10db2c74ab4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $303ba10db2c74ab4$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $303ba10db2c74ab4$exports[key];
        }
    });
});
var $9d83b4c514336dd1$exports = {};

$parcel$export($9d83b4c514336dd1$exports, "formatDistance", () => $9d83b4c514336dd1$export$2c14ff85d6318973, (v) => $9d83b4c514336dd1$export$2c14ff85d6318973 = v);
var $9d83b4c514336dd1$export$2c14ff85d6318973;
"use strict";
$9d83b4c514336dd1$export$2c14ff85d6318973 = $9d83b4c514336dd1$var$formatDistance;








/**
 * The {@link formatDistance} function options.
 */ /**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * const result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   { includeSeconds: true }
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> 'pli ol 1 jaro'
 */ function $9d83b4c514336dd1$var$formatDistance(date, baseDate, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? $e9531067c80a48a0$exports.defaultLocale;
    const minutesInAlmostTwoDays = 2520;
    const comparison = (0, $e9cff913190bd013$export$fe114145ae75d197)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    let dateLeft;
    let dateRight;
    if (comparison > 0) {
        dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(baseDate);
        dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    } else {
        dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
        dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(baseDate);
    }
    const seconds = (0, $e9186d0161460806$export$c1889aec51783710)(dateRight, dateLeft);
    const offsetInSeconds = ((0, $92dc0740ffabe180$export$113002b5eff6e430)(dateRight) - (0, $92dc0740ffabe180$export$113002b5eff6e430)(dateLeft)) / 1000;
    const minutes = Math.round((seconds - offsetInSeconds) / 60);
    let months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options?.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < $8540a44f59a4af84$export$2423174df8cd3cd2) {
        const hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < minutesInAlmostTwoDays) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < $8540a44f59a4af84$export$ab7da2ccd1075c38) {
        const days = Math.round(minutes / $8540a44f59a4af84$export$2423174df8cd3cd2);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < $8540a44f59a4af84$export$ab7da2ccd1075c38 * 2) {
        months = Math.round(minutes / $8540a44f59a4af84$export$ab7da2ccd1075c38);
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, $4bb5df50b9b59298$export$fc1ed482c2861792)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        const nearestMonth = Math.round(minutes / $8540a44f59a4af84$export$ab7da2ccd1075c38);
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        const monthsSinceStartOfYear = months % 12;
        const years = Math.trunc(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}


Object.keys($9d83b4c514336dd1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $9d83b4c514336dd1$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $9d83b4c514336dd1$exports[key];
        }
    });
});
var $95a606f89a9faad4$exports = {};

$parcel$export($95a606f89a9faad4$exports, "formatDistanceStrict", () => $95a606f89a9faad4$export$e4be225b8ee0a759, (v) => $95a606f89a9faad4$export$e4be225b8ee0a759 = v);
var $95a606f89a9faad4$export$e4be225b8ee0a759;
"use strict";
$95a606f89a9faad4$export$e4be225b8ee0a759 = $95a606f89a9faad4$var$formatDistanceStrict;







/**
 * The {@link formatDistanceStrict} function options.
 */ /**
 * The unit used to format the distance in {@link formatDistanceStrict}.
 */ /**
 * @name formatDistanceStrict
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * const result = formatDistanceStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
 *   unit: 'minute'
 * })
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2015
 * // to 28 January 2015, in months, rounded up?
 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> '1 jaro'
 */ function $95a606f89a9faad4$var$formatDistanceStrict(date, baseDate, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? $e9531067c80a48a0$exports.defaultLocale;
    const comparison = (0, $e9cff913190bd013$export$fe114145ae75d197)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    let dateLeft;
    let dateRight;
    if (comparison > 0) {
        dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(baseDate);
        dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    } else {
        dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
        dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(baseDate);
    }
    const roundingMethod = (0, $495af4000bb18bf7$export$b6474a47258c1211)(options?.roundingMethod ?? "round");
    const milliseconds = dateRight.getTime() - dateLeft.getTime();
    const minutes = milliseconds / $8540a44f59a4af84$export$91246f0b9bd9beff;
    const timezoneOffset = (0, $92dc0740ffabe180$export$113002b5eff6e430)(dateRight) - (0, $92dc0740ffabe180$export$113002b5eff6e430)(dateLeft);
    // Use DST-normalized difference in minutes for years, months and days;
    // use regular difference in minutes for hours, minutes and seconds.
    const dstNormalizedMinutes = (milliseconds - timezoneOffset) / $8540a44f59a4af84$export$91246f0b9bd9beff;
    const defaultUnit = options?.unit;
    let unit;
    if (!defaultUnit) {
        if (minutes < 1) unit = "second";
        else if (minutes < 60) unit = "minute";
        else if (minutes < $8540a44f59a4af84$export$2423174df8cd3cd2) unit = "hour";
        else if (dstNormalizedMinutes < $8540a44f59a4af84$export$ab7da2ccd1075c38) unit = "day";
        else if (dstNormalizedMinutes < $8540a44f59a4af84$export$3633035e63cee86a) unit = "month";
        else unit = "year";
    } else unit = defaultUnit;
    // 0 up to 60 seconds
    if (unit === "second") {
        const seconds = roundingMethod(milliseconds / 1000);
        return locale.formatDistance("xSeconds", seconds, localizeOptions);
    // 1 up to 60 mins
    } else if (unit === "minute") {
        const roundedMinutes = roundingMethod(minutes);
        return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);
    // 1 up to 24 hours
    } else if (unit === "hour") {
        const hours = roundingMethod(minutes / 60);
        return locale.formatDistance("xHours", hours, localizeOptions);
    // 1 up to 30 days
    } else if (unit === "day") {
        const days = roundingMethod(dstNormalizedMinutes / $8540a44f59a4af84$export$2423174df8cd3cd2);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 up to 12 months
    } else if (unit === "month") {
        const months = roundingMethod(dstNormalizedMinutes / $8540a44f59a4af84$export$ab7da2ccd1075c38);
        return months === 12 && defaultUnit !== "month" ? locale.formatDistance("xYears", 1, localizeOptions) : locale.formatDistance("xMonths", months, localizeOptions);
    // 1 year up to max Date
    } else {
        const years = roundingMethod(dstNormalizedMinutes / $8540a44f59a4af84$export$3633035e63cee86a);
        return locale.formatDistance("xYears", years, localizeOptions);
    }
}


Object.keys($95a606f89a9faad4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $95a606f89a9faad4$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $95a606f89a9faad4$exports[key];
        }
    });
});
var $b8de4dab140c0dd6$exports = {};

$parcel$export($b8de4dab140c0dd6$exports, "formatDistanceToNow", () => $b8de4dab140c0dd6$export$d130c20a256f8817, (v) => $b8de4dab140c0dd6$export$d130c20a256f8817 = v);
var $b8de4dab140c0dd6$export$d130c20a256f8817;
"use strict";
$b8de4dab140c0dd6$export$d130c20a256f8817 = $b8de4dab140c0dd6$var$formatDistanceToNow;


/**
 * The {@link formatDistanceToNow} function options.
 */ /**
 * @name formatDistanceToNow
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - The object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */ function $b8de4dab140c0dd6$var$formatDistanceToNow(date, options) {
    return (0, $9d83b4c514336dd1$export$2c14ff85d6318973)(date, (0, $d8623e255497753b$export$18c3c6510fb97afc)(date), options);
}


Object.keys($b8de4dab140c0dd6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $b8de4dab140c0dd6$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $b8de4dab140c0dd6$exports[key];
        }
    });
});
var $2869c75fd9cd8704$exports = {};

$parcel$export($2869c75fd9cd8704$exports, "formatDistanceToNowStrict", () => $2869c75fd9cd8704$export$d0e02d4eb1ad1e32, (v) => $2869c75fd9cd8704$export$d0e02d4eb1ad1e32 = v);
var $2869c75fd9cd8704$export$d0e02d4eb1ad1e32;
"use strict";
$2869c75fd9cd8704$export$d0e02d4eb1ad1e32 = $2869c75fd9cd8704$var$formatDistanceToNowStrict;


/**
 * The {@link formatDistanceToNowStrict} function options.
 */ /**
 * @name formatDistanceToNowStrict
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNowStrict(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNowStrict(
 *   new Date(2015, 0, 1, 0, 0, 15)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in 1 year'
 *
 * @example
 * // If today is 28 January 2015,
 * // what is the distance to 1 January 2015, in months, rounded up??
 * const result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */ function $2869c75fd9cd8704$var$formatDistanceToNowStrict(date, options) {
    return (0, $95a606f89a9faad4$export$e4be225b8ee0a759)(date, (0, $d8623e255497753b$export$18c3c6510fb97afc)(date), options);
}


Object.keys($2869c75fd9cd8704$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $2869c75fd9cd8704$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $2869c75fd9cd8704$exports[key];
        }
    });
});
var $55bdc14b4829f99f$exports = {};

$parcel$export($55bdc14b4829f99f$exports, "formatDuration", () => $55bdc14b4829f99f$export$bc733b0c5cbb3e8a, (v) => $55bdc14b4829f99f$export$bc733b0c5cbb3e8a = v);
var $55bdc14b4829f99f$export$bc733b0c5cbb3e8a;
"use strict";
$55bdc14b4829f99f$export$bc733b0c5cbb3e8a = $55bdc14b4829f99f$var$formatDuration;


/**
 * The {@link formatDuration} function options.
 */ const $55bdc14b4829f99f$var$defaultFormat = [
    "years",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds"
];
/**
 * @name formatDuration
 * @category Common Helpers
 * @summary Formats a duration in human-readable format
 *
 * @description
 * Return human-readable duration string i.e. "9 months 2 days"
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param duration - The duration to format
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @example
 * // Format full duration
 * formatDuration({
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds'
 *
 * @example
 * // Format partial duration
 * formatDuration({ months: 9, days: 2 })
 * //=> '9 months 2 days'
 *
 * @example
 * // Customize the format
 * formatDuration(
 *   {
 *     years: 2,
 *     months: 9,
 *     weeks: 1,
 *     days: 7,
 *     hours: 5,
 *     minutes: 9,
 *     seconds: 30
 *   },
 *   { format: ['months', 'weeks'] }
 * ) === '9 months 1 week'
 *
 * @example
 * // Customize the zeros presence
 * formatDuration({ years: 0, months: 9 })
 * //=> '9 months'
 * formatDuration({ years: 0, months: 9 }, { zero: true })
 * //=> '0 years 9 months'
 *
 * @example
 * // Customize the delimiter
 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
 * //=> '2 years, 9 months, 3 weeks'
 */ function $55bdc14b4829f99f$var$formatDuration(duration, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? $e9531067c80a48a0$exports.defaultLocale;
    const format = options?.format ?? $55bdc14b4829f99f$var$defaultFormat;
    const zero = options?.zero ?? false;
    const delimiter = options?.delimiter ?? " ";
    if (!locale.formatDistance) return "";
    const result = format.reduce((acc, unit)=>{
        const token = `x${unit.replace(/(^.)/, (m)=>m.toUpperCase())}`;
        const value = duration[unit];
        if (value !== undefined && (zero || duration[unit])) return acc.concat(locale.formatDistance(token, value));
        return acc;
    }, []).join(delimiter);
    return result;
}


Object.keys($55bdc14b4829f99f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $55bdc14b4829f99f$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $55bdc14b4829f99f$exports[key];
        }
    });
});
var $05555112c260885d$exports = {};

$parcel$export($05555112c260885d$exports, "formatISO", () => $05555112c260885d$export$3c826ac3ab9da76c, (v) => $05555112c260885d$export$3c826ac3ab9da76c = v);
var $05555112c260885d$export$3c826ac3ab9da76c;
"use strict";
$05555112c260885d$export$3c826ac3ab9da76c = $05555112c260885d$var$formatISO;


/**
 * The {@link formatISO} function options.
 */ /**
 * @name formatISO
 * @category Common Helpers
 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
 *
 * @description
 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string (in loca.l time zone)
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918T190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, date only:
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52Z'
 */ function $05555112c260885d$var$formatISO(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    if (isNaN(_date.getTime())) throw new RangeError("Invalid time value");
    const format = options?.format ?? "extended";
    const representation = options?.representation ?? "complete";
    let result = "";
    let tzOffset = "";
    const dateDelimiter = format === "extended" ? "-" : "";
    const timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        const day = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getDate(), 2);
        const month = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getMonth() + 1, 2);
        const year = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        // Add the timezone.
        const offset = _date.getTimezoneOffset();
        if (offset !== 0) {
            const absoluteOffset = Math.abs(offset);
            const hourOffset = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(Math.trunc(absoluteOffset / 60), 2);
            const minuteOffset = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            const sign = offset < 0 ? "+" : "-";
            tzOffset = `${sign}${hourOffset}:${minuteOffset}`;
        } else tzOffset = "Z";
        const hour = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getHours(), 2);
        const minute = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getMinutes(), 2);
        const second = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        const separator = result === "" ? "" : "T";
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        const time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = `${result}${separator}${time}${tzOffset}`;
    }
    return result;
}


Object.keys($05555112c260885d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $05555112c260885d$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $05555112c260885d$exports[key];
        }
    });
});
var $d5e05e4c82eadb91$exports = {};

$parcel$export($d5e05e4c82eadb91$exports, "formatISO9075", () => $d5e05e4c82eadb91$export$a673944250043fa4, (v) => $d5e05e4c82eadb91$export$a673944250043fa4 = v);
var $d5e05e4c82eadb91$export$a673944250043fa4;
"use strict";
$d5e05e4c82eadb91$export$a673944250043fa4 = $d5e05e4c82eadb91$var$formatISO9075;



/**
 * The {@link formatISO9075} function options.
 */ /**
 * @name formatISO9075
 * @category Common Helpers
 * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
 *
 * @description
 * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18 19:00:52'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075, short format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918 190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, date only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, time only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52'
 */ function $d5e05e4c82eadb91$var$formatISO9075(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    if (!(0, $f2a682b251363bc2$export$1ea939691cdc45b8)(_date)) throw new RangeError("Invalid time value");
    const format = options?.format ?? "extended";
    const representation = options?.representation ?? "complete";
    let result = "";
    const dateDelimiter = format === "extended" ? "-" : "";
    const timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        const day = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getDate(), 2);
        const month = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getMonth() + 1, 2);
        const year = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        const hour = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getHours(), 2);
        const minute = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getMinutes(), 2);
        const second = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with a space
        const separator = result === "" ? "" : " ";
        // HHmmss or HH:mm:ss.
        result = `${result}${separator}${hour}${timeDelimiter}${minute}${timeDelimiter}${second}`;
    }
    return result;
}


Object.keys($d5e05e4c82eadb91$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d5e05e4c82eadb91$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d5e05e4c82eadb91$exports[key];
        }
    });
});
var $6c1e8c5de50036eb$exports = {};

$parcel$export($6c1e8c5de50036eb$exports, "formatISODuration", () => $6c1e8c5de50036eb$export$437c31ab743f6b26, (v) => $6c1e8c5de50036eb$export$437c31ab743f6b26 = v);
var $6c1e8c5de50036eb$export$437c31ab743f6b26;
"use strict";
$6c1e8c5de50036eb$export$437c31ab743f6b26 = $6c1e8c5de50036eb$var$formatISODuration;
/**
 * @name formatISODuration
 * @category Common Helpers
 * @summary Format a duration object according as ISO 8601 duration string
 *
 * @description
 * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs//90001488-13/reference/r_iso_8601_duration_format.htm)
 *
 * @param duration - The duration to format
 *
 * @returns The ISO 8601 duration string
 *
 * @example
 * // Format the given duration as ISO 8601 string
 * const result = formatISODuration({
 *   years: 39,
 *   months: 2,
 *   days: 20,
 *   hours: 7,
 *   minutes: 5,
 *   seconds: 0
 * })
 * //=> 'P39Y2M20DT0H0M0S'
 */ function $6c1e8c5de50036eb$var$formatISODuration(duration) {
    const { years: years = 0, months: months = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    return `P${years}Y${months}M${days}DT${hours}H${minutes}M${seconds}S`;
}


Object.keys($6c1e8c5de50036eb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $6c1e8c5de50036eb$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $6c1e8c5de50036eb$exports[key];
        }
    });
});
var $d70debc21ba74612$exports = {};

$parcel$export($d70debc21ba74612$exports, "formatRFC3339", () => $d70debc21ba74612$export$6d441bffeec6bd6c, (v) => $d70debc21ba74612$export$6d441bffeec6bd6c = v);
var $d70debc21ba74612$export$6d441bffeec6bd6c;
"use strict";
$d70debc21ba74612$export$6d441bffeec6bd6c = $d70debc21ba74612$var$formatRFC3339;



/**
 * The {@link formatRFC3339} function options.
 */ /**
 * @name formatRFC3339
 * @category Common Helpers
 * @summary Format the date according to the RFC 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
 *
 * @description
 * Return the formatted date string in RFC 3339 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format:
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format, 3 digits of second fraction
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), {
 *   fractionDigits: 3
 * })
 * //=> '2019-09-18T19:00:52.234Z'
 */ function $d70debc21ba74612$var$formatRFC3339(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    if (!(0, $f2a682b251363bc2$export$1ea939691cdc45b8)(_date)) throw new RangeError("Invalid time value");
    const fractionDigits = options?.fractionDigits ?? 0;
    const day = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getDate(), 2);
    const month = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getMonth() + 1, 2);
    const year = _date.getFullYear();
    const hour = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getHours(), 2);
    const minute = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getMinutes(), 2);
    const second = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getSeconds(), 2);
    let fractionalSecond = "";
    if (fractionDigits > 0) {
        const milliseconds = _date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, fractionDigits - 3));
        fractionalSecond = "." + (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(fractionalSeconds, fractionDigits);
    }
    let offset = "";
    const tzOffset = _date.getTimezoneOffset();
    if (tzOffset !== 0) {
        const absoluteOffset = Math.abs(tzOffset);
        const hourOffset = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(Math.trunc(absoluteOffset / 60), 2);
        const minuteOffset = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(absoluteOffset % 60, 2);
        // If less than 0, the sign is +, because it is ahead of time.
        const sign = tzOffset < 0 ? "+" : "-";
        offset = `${sign}${hourOffset}:${minuteOffset}`;
    } else offset = "Z";
    return `${year}-${month}-${day}T${hour}:${minute}:${second}${fractionalSecond}${offset}`;
}


Object.keys($d70debc21ba74612$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d70debc21ba74612$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d70debc21ba74612$exports[key];
        }
    });
});
var $26db363d7fafee68$exports = {};

$parcel$export($26db363d7fafee68$exports, "formatRFC7231", () => $26db363d7fafee68$export$7add2e4539ce658a, (v) => $26db363d7fafee68$export$7add2e4539ce658a = v);
var $26db363d7fafee68$export$7add2e4539ce658a;
"use strict";
$26db363d7fafee68$export$7add2e4539ce658a = $26db363d7fafee68$var$formatRFC7231;



const $26db363d7fafee68$var$days = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $26db363d7fafee68$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
/**
 * @name formatRFC7231
 * @category Common Helpers
 * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
 *
 * @description
 * Return the formatted date string in RFC 7231 format.
 * The result will always be in UTC timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 7231 format:
 * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
 * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
 */ function $26db363d7fafee68$var$formatRFC7231(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    if (!(0, $f2a682b251363bc2$export$1ea939691cdc45b8)(_date)) throw new RangeError("Invalid time value");
    const dayName = $26db363d7fafee68$var$days[_date.getUTCDay()];
    const dayOfMonth = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getUTCDate(), 2);
    const monthName = $26db363d7fafee68$var$months[_date.getUTCMonth()];
    const year = _date.getUTCFullYear();
    const hour = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getUTCHours(), 2);
    const minute = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getUTCMinutes(), 2);
    const second = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getUTCSeconds(), 2);
    // Result variables.
    return `${dayName}, ${dayOfMonth} ${monthName} ${year} ${hour}:${minute}:${second} GMT`;
}


Object.keys($26db363d7fafee68$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $26db363d7fafee68$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $26db363d7fafee68$exports[key];
        }
    });
});
var $845a402345cd1b5f$exports = {};

$parcel$export($845a402345cd1b5f$exports, "formatRelative", () => $845a402345cd1b5f$export$8fbbfd65594f46a0, (v) => $845a402345cd1b5f$export$8fbbfd65594f46a0 = v);
var $845a402345cd1b5f$export$8fbbfd65594f46a0;
"use strict";
$845a402345cd1b5f$export$8fbbfd65594f46a0 = $845a402345cd1b5f$var$formatRelative;





/**
 * The {@link formatRelative} function options.
 */ /**
 * @name formatRelative
 * @category Common Helpers
 * @summary Represent the date in words relative to the given base date.
 *
 * @description
 * Represent the date in words relative to the given base date.
 *
 * | Distance to the base date | Result                    |
 * |---------------------------|---------------------------|
 * | Previous 6 days           | last Sunday at 04:30 AM   |
 * | Last day                  | yesterday at 04:30 AM     |
 * | Same day                  | today at 04:30 AM         |
 * | Next day                  | tomorrow at 04:30 AM      |
 * | Next 6 days               | Sunday at 04:30 AM        |
 * | Other                     | 12/31/2017                |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The date in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws `options.locale` must contain `formatRelative` property
 *
 * @example
 * // Represent the date of 6 days ago in words relative to the given base date. In this example, today is Wednesday
 * const result = formatRelative(subDays(new Date(), 6), new Date())
 * //=> "last Thursday at 12:45 AM"
 */ function $845a402345cd1b5f$var$formatRelative(date, baseDate, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const _baseDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(baseDate);
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? $e9531067c80a48a0$exports.defaultLocale;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const diff = (0, $737f54e9ffaddc15$export$4a02e9c37dab4871)(_date, _baseDate);
    if (isNaN(diff)) throw new RangeError("Invalid time value");
    let token;
    if (diff < -6) token = "other";
    else if (diff < -1) token = "lastWeek";
    else if (diff < 0) token = "yesterday";
    else if (diff < 1) token = "today";
    else if (diff < 2) token = "tomorrow";
    else if (diff < 7) token = "nextWeek";
    else token = "other";
    const formatStr = locale.formatRelative(token, _date, _baseDate, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    return (0, $303ba10db2c74ab4$exports.format)(_date, formatStr, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
}


Object.keys($845a402345cd1b5f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $845a402345cd1b5f$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $845a402345cd1b5f$exports[key];
        }
    });
});
var $75d4a1cbf32d45ba$exports = {};

$parcel$export($75d4a1cbf32d45ba$exports, "fromUnixTime", () => $75d4a1cbf32d45ba$export$3664df8597731ed4, (v) => $75d4a1cbf32d45ba$export$3664df8597731ed4 = v);
var $75d4a1cbf32d45ba$export$3664df8597731ed4;
"use strict";
$75d4a1cbf32d45ba$export$3664df8597731ed4 = $75d4a1cbf32d45ba$var$fromUnixTime;

/**
 * @name fromUnixTime
 * @category Timestamp Helpers
 * @summary Create a date from a Unix timestamp.
 *
 * @description
 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
 *
 * @param unixTime - The given Unix timestamp (in seconds)
 *
 * @returns The date
 *
 * @example
 * // Create the date 29 February 2012 11:45:05:
 * const result = fromUnixTime(1330515905)
 * //=> Wed Feb 29 2012 11:45:05
 */ function $75d4a1cbf32d45ba$var$fromUnixTime(unixTime) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(unixTime * 1000);
}


Object.keys($75d4a1cbf32d45ba$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $75d4a1cbf32d45ba$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $75d4a1cbf32d45ba$exports[key];
        }
    });
});
var $d60f4829c70cb6da$exports = {};

$parcel$export($d60f4829c70cb6da$exports, "getDate", () => $d60f4829c70cb6da$export$aa350b96d91cd94, (v) => $d60f4829c70cb6da$export$aa350b96d91cd94 = v);
var $d60f4829c70cb6da$export$aa350b96d91cd94;
"use strict";
$d60f4829c70cb6da$export$aa350b96d91cd94 = $d60f4829c70cb6da$var$getDate;

/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */ function $d60f4829c70cb6da$var$getDate(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const dayOfMonth = _date.getDate();
    return dayOfMonth;
}


Object.keys($d60f4829c70cb6da$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d60f4829c70cb6da$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d60f4829c70cb6da$exports[key];
        }
    });
});
var $bd335e725902b989$exports = {};

$parcel$export($bd335e725902b989$exports, "getDay", () => $bd335e725902b989$export$1b64bc9c5306ed54, (v) => $bd335e725902b989$export$1b64bc9c5306ed54 = v);
var $bd335e725902b989$export$1b64bc9c5306ed54;
"use strict";
$bd335e725902b989$export$1b64bc9c5306ed54 = $bd335e725902b989$var$getDay;

/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of week, 0 represents Sunday
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */ function $bd335e725902b989$var$getDay(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const day = _date.getDay();
    return day;
}


Object.keys($bd335e725902b989$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $bd335e725902b989$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $bd335e725902b989$exports[key];
        }
    });
});

Object.keys($306b88ce50904f9c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $306b88ce50904f9c$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $306b88ce50904f9c$exports[key];
        }
    });
});
var $57397b9e44500b87$exports = {};

$parcel$export($57397b9e44500b87$exports, "getDaysInMonth", () => $57397b9e44500b87$export$f645ddd439eb259d, (v) => $57397b9e44500b87$export$f645ddd439eb259d = v);
var $57397b9e44500b87$export$f645ddd439eb259d;
"use strict";
$57397b9e44500b87$export$f645ddd439eb259d = $57397b9e44500b87$var$getDaysInMonth;


/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */ function $57397b9e44500b87$var$getDaysInMonth(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const monthIndex = _date.getMonth();
    const lastDayOfMonth = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}


Object.keys($57397b9e44500b87$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $57397b9e44500b87$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $57397b9e44500b87$exports[key];
        }
    });
});
var $675848174151c5de$exports = {};

$parcel$export($675848174151c5de$exports, "getDaysInYear", () => $675848174151c5de$export$63a4a9fc49e3550e, (v) => $675848174151c5de$export$63a4a9fc49e3550e = v);
var $675848174151c5de$export$63a4a9fc49e3550e;
"use strict";
$675848174151c5de$export$63a4a9fc49e3550e = $675848174151c5de$var$getDaysInYear;
var $bf096f6f36c61b64$exports = {};

$parcel$export($bf096f6f36c61b64$exports, "isLeapYear", () => $bf096f6f36c61b64$export$553d7fa8e3805fc0, (v) => $bf096f6f36c61b64$export$553d7fa8e3805fc0 = v);
var $bf096f6f36c61b64$export$553d7fa8e3805fc0;
"use strict";
$bf096f6f36c61b64$export$553d7fa8e3805fc0 = $bf096f6f36c61b64$var$isLeapYear;

/**
 * @name isLeapYear
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the leap year
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * const result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */ function $bf096f6f36c61b64$var$isLeapYear(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}



/**
 * @name getDaysInYear
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * const result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */ function $675848174151c5de$var$getDaysInYear(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    if (String(new Date(_date)) === "Invalid Date") return NaN;
    return (0, $bf096f6f36c61b64$export$553d7fa8e3805fc0)(_date) ? 366 : 365;
}


Object.keys($675848174151c5de$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $675848174151c5de$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $675848174151c5de$exports[key];
        }
    });
});
var $6ffe5b46a49d8b61$exports = {};

$parcel$export($6ffe5b46a49d8b61$exports, "getDecade", () => $6ffe5b46a49d8b61$export$5bc0f4decfc52b64, (v) => $6ffe5b46a49d8b61$export$5bc0f4decfc52b64 = v);
var $6ffe5b46a49d8b61$export$5bc0f4decfc52b64;
"use strict";
$6ffe5b46a49d8b61$export$5bc0f4decfc52b64 = $6ffe5b46a49d8b61$var$getDecade;

/**
 * @name getDecade
 * @category Decade Helpers
 * @summary Get the decade of the given date.
 *
 * @description
 * Get the decade of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year of decade
 *
 * @example
 * // Which decade belongs 27 November 1942?
 * const result = getDecade(new Date(1942, 10, 27))
 * //=> 1940
 */ function $6ffe5b46a49d8b61$var$getDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const decade = Math.floor(year / 10) * 10;
    return decade;
}


Object.keys($6ffe5b46a49d8b61$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $6ffe5b46a49d8b61$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $6ffe5b46a49d8b61$exports[key];
        }
    });
});
var $f3e2f0f906df8397$exports = {};

$parcel$export($f3e2f0f906df8397$exports, "getDefaultOptions", () => $f3e2f0f906df8397$export$430a3269e24b912e, (v) => $f3e2f0f906df8397$export$430a3269e24b912e = v);
var $f3e2f0f906df8397$export$430a3269e24b912e;
"use strict";
$f3e2f0f906df8397$export$430a3269e24b912e = $f3e2f0f906df8397$var$getDefaultOptions;

/**
 * @name getDefaultOptions
 * @category Common Helpers
 * @summary Get default options.
 * @pure false
 *
 * @description
 * Returns an object that contains defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * You can change these with [setDefaultOptions](https://date-fns.org/docs/setDefaultOptions).
 *
 * @returns The default options
 *
 * @example
 * const result = getDefaultOptions()
 * //=> {}
 *
 * @example
 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
 * const result = getDefaultOptions()
 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
 */ function $f3e2f0f906df8397$var$getDefaultOptions() {
    return Object.assign({}, (0, $39440020b58e1ef8$export$430a3269e24b912e)());
}


Object.keys($f3e2f0f906df8397$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $f3e2f0f906df8397$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $f3e2f0f906df8397$exports[key];
        }
    });
});
var $fcf1b449283ad4a9$exports = {};

$parcel$export($fcf1b449283ad4a9$exports, "getHours", () => $fcf1b449283ad4a9$export$257b40f71c07d58f, (v) => $fcf1b449283ad4a9$export$257b40f71c07d58f = v);
var $fcf1b449283ad4a9$export$257b40f71c07d58f;
"use strict";
$fcf1b449283ad4a9$export$257b40f71c07d58f = $fcf1b449283ad4a9$var$getHours;

/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */ function $fcf1b449283ad4a9$var$getHours(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const hours = _date.getHours();
    return hours;
}


Object.keys($fcf1b449283ad4a9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $fcf1b449283ad4a9$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $fcf1b449283ad4a9$exports[key];
        }
    });
});
var $6f80ca66d6710e40$exports = {};

$parcel$export($6f80ca66d6710e40$exports, "getISODay", () => $6f80ca66d6710e40$export$c514f4c1a8ed5e9e, (v) => $6f80ca66d6710e40$export$c514f4c1a8ed5e9e = v);
var $6f80ca66d6710e40$export$c514f4c1a8ed5e9e;
"use strict";
$6f80ca66d6710e40$export$c514f4c1a8ed5e9e = $6f80ca66d6710e40$var$getISODay;

/**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * const result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */ function $6f80ca66d6710e40$var$getISODay(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    let day = _date.getDay();
    if (day === 0) day = 7;
    return day;
}


Object.keys($6f80ca66d6710e40$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $6f80ca66d6710e40$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $6f80ca66d6710e40$exports[key];
        }
    });
});

Object.keys($83e11b0db4cec366$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $83e11b0db4cec366$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $83e11b0db4cec366$exports[key];
        }
    });
});

Object.keys($c95dff76bf2f692a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c95dff76bf2f692a$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c95dff76bf2f692a$exports[key];
        }
    });
});
var $1116498c017852ec$exports = {};

$parcel$export($1116498c017852ec$exports, "getISOWeeksInYear", () => $1116498c017852ec$export$822983242a16750f, (v) => $1116498c017852ec$export$822983242a16750f = v);
var $1116498c017852ec$export$822983242a16750f;
"use strict";
$1116498c017852ec$export$822983242a16750f = $1116498c017852ec$var$getISOWeeksInYear;



/**
 * @name getISOWeeksInYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of ISO weeks in a year
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * const result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */ function $1116498c017852ec$var$getISOWeeksInYear(date) {
    const thisYear = (0, $3b2e6199275b27d6$export$236bdfa374eb69a9)(date);
    const nextYear = (0, $3b2e6199275b27d6$export$236bdfa374eb69a9)((0, $bce641bd93181421$export$ef501a2bb4f3ee6b)(thisYear, 60));
    const diff = +nextYear - +thisYear;
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $8540a44f59a4af84$export$4fad13613e88edc8);
}


Object.keys($1116498c017852ec$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $1116498c017852ec$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $1116498c017852ec$exports[key];
        }
    });
});
var $8c11bc9b369aea05$exports = {};

$parcel$export($8c11bc9b369aea05$exports, "getMilliseconds", () => $8c11bc9b369aea05$export$b8e4380f312797af, (v) => $8c11bc9b369aea05$export$b8e4380f312797af = v);
var $8c11bc9b369aea05$export$b8e4380f312797af;
"use strict";
$8c11bc9b369aea05$export$b8e4380f312797af = $8c11bc9b369aea05$var$getMilliseconds;

/**
 * @name getMilliseconds
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */ function $8c11bc9b369aea05$var$getMilliseconds(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const milliseconds = _date.getMilliseconds();
    return milliseconds;
}


Object.keys($8c11bc9b369aea05$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $8c11bc9b369aea05$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $8c11bc9b369aea05$exports[key];
        }
    });
});
var $0c14dd26da4d9afe$exports = {};

$parcel$export($0c14dd26da4d9afe$exports, "getMinutes", () => $0c14dd26da4d9afe$export$b7f1bc3ea3ac4145, (v) => $0c14dd26da4d9afe$export$b7f1bc3ea3ac4145 = v);
var $0c14dd26da4d9afe$export$b7f1bc3ea3ac4145;
"use strict";
$0c14dd26da4d9afe$export$b7f1bc3ea3ac4145 = $0c14dd26da4d9afe$var$getMinutes;

/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */ function $0c14dd26da4d9afe$var$getMinutes(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const minutes = _date.getMinutes();
    return minutes;
}


Object.keys($0c14dd26da4d9afe$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $0c14dd26da4d9afe$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $0c14dd26da4d9afe$exports[key];
        }
    });
});
var $6f30fa731c19b802$exports = {};

$parcel$export($6f30fa731c19b802$exports, "getMonth", () => $6f30fa731c19b802$export$6ce1b5acc29cb53b, (v) => $6f30fa731c19b802$export$6ce1b5acc29cb53b = v);
var $6f30fa731c19b802$export$6ce1b5acc29cb53b;
"use strict";
$6f30fa731c19b802$export$6ce1b5acc29cb53b = $6f30fa731c19b802$var$getMonth;

/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The month index (0-11)
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */ function $6f30fa731c19b802$var$getMonth(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const month = _date.getMonth();
    return month;
}


Object.keys($6f30fa731c19b802$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $6f30fa731c19b802$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $6f30fa731c19b802$exports[key];
        }
    });
});
var $a50ac61c155d82aa$exports = {};

$parcel$export($a50ac61c155d82aa$exports, "getOverlappingDaysInIntervals", () => $a50ac61c155d82aa$export$baae148532bd1d46, (v) => $a50ac61c155d82aa$export$baae148532bd1d46 = v);
var $a50ac61c155d82aa$export$baae148532bd1d46;
"use strict";
$a50ac61c155d82aa$export$baae148532bd1d46 = $a50ac61c155d82aa$var$getOverlappingDaysInIntervals;



/**
 * @name getOverlappingDaysInIntervals
 * @category Interval Helpers
 * @summary Get the number of days that overlap in two time intervals
 *
 * @description
 * Get the number of days that overlap in two time intervals. It uses the time
 * between dates to calculate the number of days, rounding it up to include
 * partial days.
 *
 * Two equal 0-length intervals will result in 0. Two equal 1ms intervals will
 * result in 1.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 *
 * @returns The number of days that overlap in two time intervals
 *
 * @example
 * // For overlapping time intervals adds 1 for each started overlapping day:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping time intervals returns 0:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> 0
 */ function $a50ac61c155d82aa$var$getOverlappingDaysInIntervals(intervalLeft, intervalRight) {
    const [leftStart, leftEnd] = [
        +(0, $231bfb8d72679740$export$e67a095c620b86fe)(intervalLeft.start),
        +(0, $231bfb8d72679740$export$e67a095c620b86fe)(intervalLeft.end)
    ].sort((a, b)=>a - b);
    const [rightStart, rightEnd] = [
        +(0, $231bfb8d72679740$export$e67a095c620b86fe)(intervalRight.start),
        +(0, $231bfb8d72679740$export$e67a095c620b86fe)(intervalRight.end)
    ].sort((a, b)=>a - b);
    // Prevent NaN result if intervals don't overlap at all.
    const isOverlapping = leftStart < rightEnd && rightStart < leftEnd;
    if (!isOverlapping) return 0;
    // Remove the timezone offset to negate the DST effect on calculations.
    const overlapLeft = rightStart < leftStart ? leftStart : rightStart;
    const left = overlapLeft - (0, $92dc0740ffabe180$export$113002b5eff6e430)(overlapLeft);
    const overlapRight = rightEnd > leftEnd ? leftEnd : rightEnd;
    const right = overlapRight - (0, $92dc0740ffabe180$export$113002b5eff6e430)(overlapRight);
    // Ceil the number to include partial days too.
    return Math.ceil((right - left) / $8540a44f59a4af84$export$b76b1809a2898f9a);
}


Object.keys($a50ac61c155d82aa$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a50ac61c155d82aa$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a50ac61c155d82aa$exports[key];
        }
    });
});

Object.keys($763325f0c93713da$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $763325f0c93713da$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $763325f0c93713da$exports[key];
        }
    });
});
var $a54ac051af9fd19a$exports = {};

$parcel$export($a54ac051af9fd19a$exports, "getSeconds", () => $a54ac051af9fd19a$export$5e9417507ff28427, (v) => $a54ac051af9fd19a$export$5e9417507ff28427 = v);
var $a54ac051af9fd19a$export$5e9417507ff28427;
"use strict";
$a54ac051af9fd19a$export$5e9417507ff28427 = $a54ac051af9fd19a$var$getSeconds;

/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */ function $a54ac051af9fd19a$var$getSeconds(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const seconds = _date.getSeconds();
    return seconds;
}


Object.keys($a54ac051af9fd19a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a54ac051af9fd19a$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a54ac051af9fd19a$exports[key];
        }
    });
});
var $9f25550354d2edec$exports = {};

$parcel$export($9f25550354d2edec$exports, "getTime", () => $9f25550354d2edec$export$1428f42a7de81803, (v) => $9f25550354d2edec$export$1428f42a7de81803 = v);
var $9f25550354d2edec$export$1428f42a7de81803;
"use strict";
$9f25550354d2edec$export$1428f42a7de81803 = $9f25550354d2edec$var$getTime;

/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */ function $9f25550354d2edec$var$getTime(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const timestamp = _date.getTime();
    return timestamp;
}


Object.keys($9f25550354d2edec$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $9f25550354d2edec$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $9f25550354d2edec$exports[key];
        }
    });
});
var $c60e78b2b3ab2c93$exports = {};

$parcel$export($c60e78b2b3ab2c93$exports, "getUnixTime", () => $c60e78b2b3ab2c93$export$1f77c0008d16313, (v) => $c60e78b2b3ab2c93$export$1f77c0008d16313 = v);
var $c60e78b2b3ab2c93$export$1f77c0008d16313;
"use strict";
$c60e78b2b3ab2c93$export$1f77c0008d16313 = $c60e78b2b3ab2c93$var$getUnixTime;

/**
 * @name getUnixTime
 * @category Timestamp Helpers
 * @summary Get the seconds timestamp of the given date.
 *
 * @description
 * Get the seconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05 CET:
 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 1330512305
 */ function $c60e78b2b3ab2c93$var$getUnixTime(date) {
    return Math.trunc(+(0, $231bfb8d72679740$export$e67a095c620b86fe)(date) / 1000);
}


Object.keys($c60e78b2b3ab2c93$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c60e78b2b3ab2c93$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c60e78b2b3ab2c93$exports[key];
        }
    });
});

Object.keys($11b38d723fd57381$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $11b38d723fd57381$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $11b38d723fd57381$exports[key];
        }
    });
});
var $6300d6356cdb10d1$exports = {};

$parcel$export($6300d6356cdb10d1$exports, "getWeekOfMonth", () => $6300d6356cdb10d1$export$59fb9b85a4d8d027, (v) => $6300d6356cdb10d1$export$59fb9b85a4d8d027 = v);
var $6300d6356cdb10d1$export$59fb9b85a4d8d027;
"use strict";
$6300d6356cdb10d1$export$59fb9b85a4d8d027 = $6300d6356cdb10d1$var$getWeekOfMonth;




/**
 * The {@link getWeekOfMonth} function options.
 */ /**
 * @name getWeekOfMonth
 * @category Week Helpers
 * @summary Get the week of the month of the given date.
 *
 * @description
 * Get the week of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The week of month
 *
 * @example
 * // Which week of the month is 9 November 2017?
 * const result = getWeekOfMonth(new Date(2017, 10, 9))
 * //=> 2
 */ function $6300d6356cdb10d1$var$getWeekOfMonth(date, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const currentDayOfMonth = (0, $d60f4829c70cb6da$export$aa350b96d91cd94)(date);
    if (isNaN(currentDayOfMonth)) return NaN;
    const startWeekDay = (0, $bd335e725902b989$export$1b64bc9c5306ed54)((0, $c0b4ec5551eca4c9$export$a5a3b454ada2268e)(date));
    let lastDayOfFirstWeek = weekStartsOn - startWeekDay;
    if (lastDayOfFirstWeek <= 0) lastDayOfFirstWeek += 7;
    const remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
    return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
}


Object.keys($6300d6356cdb10d1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $6300d6356cdb10d1$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $6300d6356cdb10d1$exports[key];
        }
    });
});

Object.keys($0170e230c8468ebb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $0170e230c8468ebb$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $0170e230c8468ebb$exports[key];
        }
    });
});
var $c1d6a42d4ff2e720$exports = {};

$parcel$export($c1d6a42d4ff2e720$exports, "getWeeksInMonth", () => $c1d6a42d4ff2e720$export$ccc1b2479e7dd654, (v) => $c1d6a42d4ff2e720$export$ccc1b2479e7dd654 = v);
var $c1d6a42d4ff2e720$export$ccc1b2479e7dd654;
"use strict";
$c1d6a42d4ff2e720$export$ccc1b2479e7dd654 = $c1d6a42d4ff2e720$var$getWeeksInMonth;

var $b94cbd258d877bc8$exports = {};

$parcel$export($b94cbd258d877bc8$exports, "lastDayOfMonth", () => $b94cbd258d877bc8$export$36818250d6c87922, (v) => $b94cbd258d877bc8$export$36818250d6c87922 = v);
var $b94cbd258d877bc8$export$36818250d6c87922;
"use strict";
$b94cbd258d877bc8$export$36818250d6c87922 = $b94cbd258d877bc8$var$lastDayOfMonth;

/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * const result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ function $b94cbd258d877bc8$var$lastDayOfMonth(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}



/**
 * The {@link getWeeksInMonth} function options.
 */ /**
 * @name getWeeksInMonth
 * @category Week Helpers
 * @summary Get the number of calendar weeks a month spans.
 *
 * @description
 * Get the number of calendar weeks the month in the given date spans.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks does February 2015 span?
 * const result = getWeeksInMonth(new Date(2015, 1, 8))
 * //=> 4
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks does July 2017 span?
 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
 * //=> 6
 */ function $c1d6a42d4ff2e720$var$getWeeksInMonth(date, options) {
    return (0, $c8670ac5b8c1edee$export$6ed034ce62348e4)((0, $b94cbd258d877bc8$export$36818250d6c87922)(date), (0, $c0b4ec5551eca4c9$export$a5a3b454ada2268e)(date), options) + 1;
}


Object.keys($c1d6a42d4ff2e720$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c1d6a42d4ff2e720$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c1d6a42d4ff2e720$exports[key];
        }
    });
});
var $4189f4c9c3b9878d$exports = {};

$parcel$export($4189f4c9c3b9878d$exports, "getYear", () => $4189f4c9c3b9878d$export$5846dc2d57a5c860, (v) => $4189f4c9c3b9878d$export$5846dc2d57a5c860 = v);
var $4189f4c9c3b9878d$export$5846dc2d57a5c860;
"use strict";
$4189f4c9c3b9878d$export$5846dc2d57a5c860 = $4189f4c9c3b9878d$var$getYear;

/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */ function $4189f4c9c3b9878d$var$getYear(date) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date).getFullYear();
}


Object.keys($4189f4c9c3b9878d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $4189f4c9c3b9878d$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $4189f4c9c3b9878d$exports[key];
        }
    });
});
var $9ae7ab1e5313bfc3$exports = {};

$parcel$export($9ae7ab1e5313bfc3$exports, "hoursToMilliseconds", () => $9ae7ab1e5313bfc3$export$5b42ab7a22898b69, (v) => $9ae7ab1e5313bfc3$export$5b42ab7a22898b69 = v);
var $9ae7ab1e5313bfc3$export$5b42ab7a22898b69;
"use strict";
$9ae7ab1e5313bfc3$export$5b42ab7a22898b69 = $9ae7ab1e5313bfc3$var$hoursToMilliseconds;

/**
 * @name hoursToMilliseconds
 * @category  Conversion Helpers
 * @summary Convert hours to milliseconds.
 *
 * @description
 * Convert a number of hours to a full number of milliseconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted to milliseconds
 *
 * @example
 * // Convert 2 hours to milliseconds:
 * const result = hoursToMilliseconds(2)
 * //=> 7200000
 */ function $9ae7ab1e5313bfc3$var$hoursToMilliseconds(hours) {
    return Math.trunc(hours * $8540a44f59a4af84$export$7f72910d6dfd237a);
}


Object.keys($9ae7ab1e5313bfc3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $9ae7ab1e5313bfc3$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $9ae7ab1e5313bfc3$exports[key];
        }
    });
});
var $d41fb6e1e630ebbd$exports = {};

$parcel$export($d41fb6e1e630ebbd$exports, "hoursToMinutes", () => $d41fb6e1e630ebbd$export$83bfc73cdf89a4d8, (v) => $d41fb6e1e630ebbd$export$83bfc73cdf89a4d8 = v);
var $d41fb6e1e630ebbd$export$83bfc73cdf89a4d8;
"use strict";
$d41fb6e1e630ebbd$export$83bfc73cdf89a4d8 = $d41fb6e1e630ebbd$var$hoursToMinutes;

/**
 * @name hoursToMinutes
 * @category Conversion Helpers
 * @summary Convert hours to minutes.
 *
 * @description
 * Convert a number of hours to a full number of minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted in minutes
 *
 * @example
 * // Convert 2 hours to minutes:
 * const result = hoursToMinutes(2)
 * //=> 120
 */ function $d41fb6e1e630ebbd$var$hoursToMinutes(hours) {
    return Math.trunc(hours * $8540a44f59a4af84$export$f2f5ae5a8e2d8f9f);
}


Object.keys($d41fb6e1e630ebbd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d41fb6e1e630ebbd$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d41fb6e1e630ebbd$exports[key];
        }
    });
});
var $fcb7e14c40da1793$exports = {};

$parcel$export($fcb7e14c40da1793$exports, "hoursToSeconds", () => $fcb7e14c40da1793$export$59b1396ccbd5a4e1, (v) => $fcb7e14c40da1793$export$59b1396ccbd5a4e1 = v);
var $fcb7e14c40da1793$export$59b1396ccbd5a4e1;
"use strict";
$fcb7e14c40da1793$export$59b1396ccbd5a4e1 = $fcb7e14c40da1793$var$hoursToSeconds;

/**
 * @name hoursToSeconds
 * @category Conversion Helpers
 * @summary Convert hours to seconds.
 *
 * @description
 * Convert a number of hours to a full number of seconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - The number of hours to be converted
 *
 * @returns The number of hours converted in seconds
 *
 * @example
 * // Convert 2 hours to seconds:
 * const result = hoursToSeconds(2)
 * //=> 7200
 */ function $fcb7e14c40da1793$var$hoursToSeconds(hours) {
    return Math.trunc(hours * $8540a44f59a4af84$export$698aec755e92c695);
}


Object.keys($fcb7e14c40da1793$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $fcb7e14c40da1793$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $fcb7e14c40da1793$exports[key];
        }
    });
});
var $6696c43013de930d$exports = {};

$parcel$export($6696c43013de930d$exports, "interval", () => $6696c43013de930d$export$3174cdbf0a0cbc84, (v) => $6696c43013de930d$export$3174cdbf0a0cbc84 = v);
var $6696c43013de930d$export$3174cdbf0a0cbc84;
"use strict";
$6696c43013de930d$export$3174cdbf0a0cbc84 = $6696c43013de930d$var$interval;

/**
 * The {@link interval} function options.
 */ /**
 * @name interval
 * @category Interval Helpers
 * @summary Creates an interval object and validates its values.
 *
 * @description
 * Creates a normalized interval object and validates its values. If the interval is invalid, an exception is thrown.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param start - The start of the interval.
 * @param end - The end of the interval.
 * @param options - The options object.
 *
 * @throws `Start date is invalid` when `start` is invalid.
 * @throws `End date is invalid` when `end` is invalid.
 * @throws `End date must be after start date` when end is before `start` and `options.assertPositive` is true.
 *
 * @returns The normalized and validated interval object.
 */ function $6696c43013de930d$var$interval(start, end, options) {
    const _start = (0, $231bfb8d72679740$export$e67a095c620b86fe)(start);
    if (isNaN(+_start)) throw new TypeError("Start date is invalid");
    const _end = (0, $231bfb8d72679740$export$e67a095c620b86fe)(end);
    if (isNaN(+_end)) throw new TypeError("End date is invalid");
    if (options?.assertPositive && +_start > +_end) throw new TypeError("End date must be after start date");
    return {
        start: _start,
        end: _end
    };
}


Object.keys($6696c43013de930d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $6696c43013de930d$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $6696c43013de930d$exports[key];
        }
    });
});
var $1164c85dc3b4daac$exports = {};

$parcel$export($1164c85dc3b4daac$exports, "intervalToDuration", () => $1164c85dc3b4daac$export$7b6c9a626316863, (v) => $1164c85dc3b4daac$export$7b6c9a626316863 = v);
var $1164c85dc3b4daac$export$7b6c9a626316863;
"use strict";
$1164c85dc3b4daac$export$7b6c9a626316863 = $1164c85dc3b4daac$var$intervalToDuration;








/**
 * @name intervalToDuration
 * @category Common Helpers
 * @summary Convert interval to duration
 *
 * @description
 * Convert a interval object to a duration object.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval to convert to duration
 *
 * @returns The duration object
 *
 * @example
 * // Get the duration between January 15, 1929 and April 4, 1968.
 * intervalToDuration({
 *   start: new Date(1929, 0, 15, 12, 0, 0),
 *   end: new Date(1968, 3, 4, 19, 5, 0)
 * })
 * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
 */ function $1164c85dc3b4daac$var$intervalToDuration(interval) {
    const start = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.start);
    const end = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.end);
    const duration = {};
    const years = (0, $bf315c5624a2ab0b$export$ed6bf486f68899ca)(end, start);
    if (years) duration.years = years;
    const remainingMonths = (0, $543e4b3aa35bec3b$export$e16d8520af44a096)(start, {
        years: duration.years
    });
    const months = (0, $4bb5df50b9b59298$export$fc1ed482c2861792)(end, remainingMonths);
    if (months) duration.months = months;
    const remainingDays = (0, $543e4b3aa35bec3b$export$e16d8520af44a096)(remainingMonths, {
        months: duration.months
    });
    const days = (0, $21c2b10d84e6b5ad$export$86415ebf4eb36b8c)(end, remainingDays);
    if (days) duration.days = days;
    const remainingHours = (0, $543e4b3aa35bec3b$export$e16d8520af44a096)(remainingDays, {
        days: duration.days
    });
    const hours = (0, $f1e71fcc3bd0bed6$export$5436ca250d4d6872)(end, remainingHours);
    if (hours) duration.hours = hours;
    const remainingMinutes = (0, $543e4b3aa35bec3b$export$e16d8520af44a096)(remainingHours, {
        hours: duration.hours
    });
    const minutes = (0, $67e743be56b112ce$export$d904251335be481a)(end, remainingMinutes);
    if (minutes) duration.minutes = minutes;
    const remainingSeconds = (0, $543e4b3aa35bec3b$export$e16d8520af44a096)(remainingMinutes, {
        minutes: duration.minutes
    });
    const seconds = (0, $e9186d0161460806$export$c1889aec51783710)(end, remainingSeconds);
    if (seconds) duration.seconds = seconds;
    return duration;
}


Object.keys($1164c85dc3b4daac$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $1164c85dc3b4daac$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $1164c85dc3b4daac$exports[key];
        }
    });
});
var $a3e44b502e508de0$exports = {};

$parcel$export($a3e44b502e508de0$exports, "intlFormat", () => $a3e44b502e508de0$export$f58f1234eed71f82, (v) => $a3e44b502e508de0$export$f58f1234eed71f82 = v);
var $a3e44b502e508de0$export$f58f1234eed71f82;
"use strict";
$a3e44b502e508de0$export$f58f1234eed71f82 = $a3e44b502e508de0$var$intlFormat;

/**
 * The locale string (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).
 */ /**
 * The format options (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#options)
 */ /**
 * The locale options.
 */ /**
 * @name intlFormat
 * @category Common Helpers
 * @summary Format the date with Intl.DateTimeFormat (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat).
 *
 * @description
 * Return the formatted date string in the given format.
 * The method uses [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) inside.
 * formatOptions are the same as [`Intl.DateTimeFormat` options](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat#using_options)
 *
 * > ⚠️ Please note that before Node version 13.0.0, only the locale data for en-US is available by default.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in middle-endian format:
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456))
 * //=> 10/4/2019
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in Korean.
 * // Convert the date with locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   locale: 'ko-KR',
 * })
 * //=> 2019. 10. 4.
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019.
 * // Convert the date with format's options.
 * const result = intlFormat.default(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   year: 'numeric',
 *   month: 'numeric',
 *   day: 'numeric',
 *   hour: 'numeric',
 * })
 * //=> 10/4/2019, 12 PM
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in German.
 * // Convert the date with format's options and locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   weekday: 'long',
 *   year: 'numeric',
 *   month: 'long',
 *   day: 'numeric',
 * }, {
 *   locale: 'de-DE',
 * })
 * //=> Freitag, 4. Oktober 2019
 */ function $a3e44b502e508de0$var$intlFormat(date, formatOrLocale, localeOptions) {
    let formatOptions;
    if ($a3e44b502e508de0$var$isFormatOptions(formatOrLocale)) formatOptions = formatOrLocale;
    else localeOptions = formatOrLocale;
    return new Intl.DateTimeFormat(localeOptions?.locale, formatOptions).format((0, $231bfb8d72679740$export$e67a095c620b86fe)(date));
}
function $a3e44b502e508de0$var$isFormatOptions(opts) {
    return opts !== undefined && !("locale" in opts);
}


Object.keys($a3e44b502e508de0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a3e44b502e508de0$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a3e44b502e508de0$exports[key];
        }
    });
});
var $97e1e87f40603cdb$exports = {};

$parcel$export($97e1e87f40603cdb$exports, "intlFormatDistance", () => $97e1e87f40603cdb$export$a110a4020280fd5, (v) => $97e1e87f40603cdb$export$a110a4020280fd5 = v);
var $97e1e87f40603cdb$export$a110a4020280fd5;
"use strict";
$97e1e87f40603cdb$export$a110a4020280fd5 = $97e1e87f40603cdb$var$intlFormatDistance;










/**
 * The {@link intlFormatDistance} function options.
 */ /**
 * The unit used to format the distance in {@link intlFormatDistance}.
 */ /**
 * @name intlFormatDistance
 * @category Common Helpers
 * @summary Formats distance between two dates in a human-readable format
 * @description
 * The function calculates the difference between two dates and formats it as a human-readable string.
 *
 * The function will pick the most appropriate unit depending on the distance between dates. For example, if the distance is a few hours, it might return `x hours`. If the distance is a few months, it might return `x months`.
 *
 * You can also specify a unit to force using it regardless of the distance to get a result like `123456 hours`.
 *
 * See the table below for the unit picking logic:
 *
 * | Distance between dates | Result (past)  | Result (future) |
 * | ---------------------- | -------------- | --------------- |
 * | 0 seconds              | now            | now             |
 * | 1-59 seconds           | X seconds ago  | in X seconds    |
 * | 1-59 minutes           | X minutes ago  | in X minutes    |
 * | 1-23 hours             | X hours ago    | in X hours      |
 * | 1 day                  | yesterday      | tomorrow        |
 * | 2-6 days               | X days ago     | in X days       |
 * | 7 days                 | last week      | next week       |
 * | 8 days-1 month         | X weeks ago    | in X weeks      |
 * | 1 month                | last month     | next month      |
 * | 2-3 months             | X months ago   | in X months     |
 * | 1 quarter              | last quarter   | next quarter    |
 * | 2-3 quarters           | X quarters ago | in X quarters   |
 * | 1 year                 | last year      | next year       |
 * | 2+ years               | X years ago    | in X years      |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with.
 * @param options - An object with options.
 * See MDN for details [Locale identification and negotiation](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation)
 * The narrow one could be similar to the short one for some locales.
 *
 * @returns The distance in words according to language-sensitive relative time formatting.
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must not be invalid Unit
 * @throws `options.locale` must not be invalid locale
 * @throws `options.localeMatcher` must not be invalid localeMatcher
 * @throws `options.numeric` must not be invalid numeric
 * @throws `options.style` must not be invalid style
 *
 * @example
 * // What is the distance between the dates when the fist date is after the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0)
 * )
 * //=> 'in 1 hour'
 *
 * // What is the distance between the dates when the fist date is before the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0)
 * )
 * //=> '1 hour ago'
 *
 * @example
 * // Use the unit option to force the function to output the result in quarters. Without setting it, the example would return "next year"
 * intlFormatDistance(
 *   new Date(1987, 6, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { unit: 'quarter' }
 * )
 * //=> 'in 5 quarters'
 *
 * @example
 * // Use the locale option to get the result in Spanish. Without setting it, the example would return "in 1 hour".
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { locale: 'es' }
 * )
 * //=> 'dentro de 1 hora'
 *
 * @example
 * // Use the numeric option to force the function to use numeric values. Without setting it, the example would return "tomorrow".
 * intlFormatDistance(
 *   new Date(1986, 3, 5, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { numeric: 'always' }
 * )
 * //=> 'in 1 day'
 *
 * @example
 * // Use the style option to force the function to use short values. Without setting it, the example would return "in 2 years".
 * intlFormatDistance(
 *   new Date(1988, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { style: 'short' }
 * )
 * //=> 'in 2 yr'
 */ function $97e1e87f40603cdb$var$intlFormatDistance(date, baseDate, options) {
    let value = 0;
    let unit;
    const dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(baseDate);
    if (!options?.unit) {
        // Get the unit based on diffInSeconds calculations if no unit is specified
        const diffInSeconds = (0, $e9186d0161460806$export$c1889aec51783710)(dateLeft, dateRight); // The smallest unit
        if (Math.abs(diffInSeconds) < $8540a44f59a4af84$export$a77c1a7ebebe2a5a) {
            value = (0, $e9186d0161460806$export$c1889aec51783710)(dateLeft, dateRight);
            unit = "second";
        } else if (Math.abs(diffInSeconds) < $8540a44f59a4af84$export$698aec755e92c695) {
            value = (0, $67e743be56b112ce$export$d904251335be481a)(dateLeft, dateRight);
            unit = "minute";
        } else if (Math.abs(diffInSeconds) < $8540a44f59a4af84$export$815a9362476d2fe3 && Math.abs((0, $737f54e9ffaddc15$export$4a02e9c37dab4871)(dateLeft, dateRight)) < 1) {
            value = (0, $f1e71fcc3bd0bed6$export$5436ca250d4d6872)(dateLeft, dateRight);
            unit = "hour";
        } else if (Math.abs(diffInSeconds) < $8540a44f59a4af84$export$34804a017b31e2fe && (value = (0, $737f54e9ffaddc15$export$4a02e9c37dab4871)(dateLeft, dateRight)) && Math.abs(value) < 7) unit = "day";
        else if (Math.abs(diffInSeconds) < $8540a44f59a4af84$export$8e6600bbdee7dabb) {
            value = (0, $c8670ac5b8c1edee$export$6ed034ce62348e4)(dateLeft, dateRight);
            unit = "week";
        } else if (Math.abs(diffInSeconds) < $8540a44f59a4af84$export$be1dccf2de902d31) {
            value = (0, $8aa264ebd3f03841$export$489984ac7c996389)(dateLeft, dateRight);
            unit = "month";
        } else if (Math.abs(diffInSeconds) < $8540a44f59a4af84$export$7271e9e3478110d1) {
            if ((0, $5806b276dadb0858$export$f62ae9fb13958c7a)(dateLeft, dateRight) < 4) {
                // To filter out cases that are less than a year but match 4 quarters
                value = (0, $5806b276dadb0858$export$f62ae9fb13958c7a)(dateLeft, dateRight);
                unit = "quarter";
            } else {
                value = (0, $539ce3f7450453a1$export$c06dce8b38891685)(dateLeft, dateRight);
                unit = "year";
            }
        } else {
            value = (0, $539ce3f7450453a1$export$c06dce8b38891685)(dateLeft, dateRight);
            unit = "year";
        }
    } else {
        // Get the value if unit is specified
        unit = options?.unit;
        if (unit === "second") value = (0, $e9186d0161460806$export$c1889aec51783710)(dateLeft, dateRight);
        else if (unit === "minute") value = (0, $67e743be56b112ce$export$d904251335be481a)(dateLeft, dateRight);
        else if (unit === "hour") value = (0, $f1e71fcc3bd0bed6$export$5436ca250d4d6872)(dateLeft, dateRight);
        else if (unit === "day") value = (0, $737f54e9ffaddc15$export$4a02e9c37dab4871)(dateLeft, dateRight);
        else if (unit === "week") value = (0, $c8670ac5b8c1edee$export$6ed034ce62348e4)(dateLeft, dateRight);
        else if (unit === "month") value = (0, $8aa264ebd3f03841$export$489984ac7c996389)(dateLeft, dateRight);
        else if (unit === "quarter") value = (0, $5806b276dadb0858$export$f62ae9fb13958c7a)(dateLeft, dateRight);
        else if (unit === "year") value = (0, $539ce3f7450453a1$export$c06dce8b38891685)(dateLeft, dateRight);
    }
    const rtf = new Intl.RelativeTimeFormat(options?.locale, {
        localeMatcher: options?.localeMatcher,
        numeric: options?.numeric || "auto",
        style: options?.style
    });
    return rtf.format(value, unit);
}


Object.keys($97e1e87f40603cdb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $97e1e87f40603cdb$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $97e1e87f40603cdb$exports[key];
        }
    });
});
var $7c47abeb099a42c0$exports = {};

$parcel$export($7c47abeb099a42c0$exports, "isAfter", () => $7c47abeb099a42c0$export$e4de839670987035, (v) => $7c47abeb099a42c0$export$e4de839670987035 = v);
var $7c47abeb099a42c0$export$e4de839670987035;
"use strict";
$7c47abeb099a42c0$export$e4de839670987035 = $7c47abeb099a42c0$var$isAfter;

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */ function $7c47abeb099a42c0$var$isAfter(date, dateToCompare) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const _dateToCompare = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateToCompare);
    return _date.getTime() > _dateToCompare.getTime();
}


Object.keys($7c47abeb099a42c0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $7c47abeb099a42c0$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $7c47abeb099a42c0$exports[key];
        }
    });
});
var $d2aab93838002ade$exports = {};

$parcel$export($d2aab93838002ade$exports, "isBefore", () => $d2aab93838002ade$export$5c007e10c6929c95, (v) => $d2aab93838002ade$export$5c007e10c6929c95 = v);
var $d2aab93838002ade$export$5c007e10c6929c95;
"use strict";
$d2aab93838002ade$export$5c007e10c6929c95 = $d2aab93838002ade$var$isBefore;

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */ function $d2aab93838002ade$var$isBefore(date, dateToCompare) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const _dateToCompare = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateToCompare);
    return +_date < +_dateToCompare;
}


Object.keys($d2aab93838002ade$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d2aab93838002ade$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d2aab93838002ade$exports[key];
        }
    });
});

Object.keys($1896b5e28554d57b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $1896b5e28554d57b$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $1896b5e28554d57b$exports[key];
        }
    });
});
var $7a7e68b5aa0b9077$exports = {};

$parcel$export($7a7e68b5aa0b9077$exports, "isEqual", () => $7a7e68b5aa0b9077$export$248d38f6296296c5, (v) => $7a7e68b5aa0b9077$export$248d38f6296296c5 = v);
var $7a7e68b5aa0b9077$export$248d38f6296296c5;
"use strict";
$7a7e68b5aa0b9077$export$248d38f6296296c5 = $7a7e68b5aa0b9077$var$isEqual;

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */ function $7a7e68b5aa0b9077$var$isEqual(leftDate, rightDate) {
    const _dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(leftDate);
    const _dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(rightDate);
    return +_dateLeft === +_dateRight;
}


Object.keys($7a7e68b5aa0b9077$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $7a7e68b5aa0b9077$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $7a7e68b5aa0b9077$exports[key];
        }
    });
});
var $2341c5e25fcfd1db$exports = {};

$parcel$export($2341c5e25fcfd1db$exports, "isExists", () => $2341c5e25fcfd1db$export$127519e0edcdc58b, (v) => $2341c5e25fcfd1db$export$127519e0edcdc58b = v);
var $2341c5e25fcfd1db$export$127519e0edcdc58b;
"use strict";
$2341c5e25fcfd1db$export$127519e0edcdc58b = $2341c5e25fcfd1db$var$isExists; /**
 * @name isExists
 * @category Common Helpers
 * @summary Is the given date exists?
 *
 * @description
 * Checks if the given arguments convert to an existing date.
 *
 * @param year - The year of the date to check
 * @param month - The month of the date to check
 * @param day - The day of the date to check
 *
 * @returns `true` if the date exists
 *
 * @example
 * // For the valid date:
 * const result = isExists(2018, 0, 31)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isExists(2018, 1, 31)
 * //=> false
 */ 
function $2341c5e25fcfd1db$var$isExists(year, month, day) {
    const date = new Date(year, month, day);
    return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
}


Object.keys($2341c5e25fcfd1db$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $2341c5e25fcfd1db$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $2341c5e25fcfd1db$exports[key];
        }
    });
});
var $82d868cdf6cf6fea$exports = {};

$parcel$export($82d868cdf6cf6fea$exports, "isFirstDayOfMonth", () => $82d868cdf6cf6fea$export$2716a425049f51dd, (v) => $82d868cdf6cf6fea$export$2716a425049f51dd = v);
var $82d868cdf6cf6fea$export$2716a425049f51dd;
"use strict";
$82d868cdf6cf6fea$export$2716a425049f51dd = $82d868cdf6cf6fea$var$isFirstDayOfMonth;

/**
 * @name isFirstDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the first day of a month
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * const result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */ function $82d868cdf6cf6fea$var$isFirstDayOfMonth(date) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date).getDate() === 1;
}


Object.keys($82d868cdf6cf6fea$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $82d868cdf6cf6fea$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $82d868cdf6cf6fea$exports[key];
        }
    });
});
var $add9570ccdd56579$exports = {};

$parcel$export($add9570ccdd56579$exports, "isFriday", () => $add9570ccdd56579$export$3b7d89f127884993, (v) => $add9570ccdd56579$export$3b7d89f127884993 = v);
var $add9570ccdd56579$export$3b7d89f127884993;
"use strict";
$add9570ccdd56579$export$3b7d89f127884993 = $add9570ccdd56579$var$isFriday;

/**
 * @name isFriday
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * const result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */ function $add9570ccdd56579$var$isFriday(date) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date).getDay() === 5;
}


Object.keys($add9570ccdd56579$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $add9570ccdd56579$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $add9570ccdd56579$exports[key];
        }
    });
});
var $a96d25a4d70c8926$exports = {};

$parcel$export($a96d25a4d70c8926$exports, "isFuture", () => $a96d25a4d70c8926$export$2baac2df6018cd7, (v) => $a96d25a4d70c8926$export$2baac2df6018cd7 = v);
var $a96d25a4d70c8926$export$2baac2df6018cd7;
"use strict";
$a96d25a4d70c8926$export$2baac2df6018cd7 = $a96d25a4d70c8926$var$isFuture;

/**
 * @name isFuture
 * @category Common Helpers
 * @summary Is the given date in the future?
 * @pure false
 *
 * @description
 * Is the given date in the future?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * const result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */ function $a96d25a4d70c8926$var$isFuture(date) {
    return +(0, $231bfb8d72679740$export$e67a095c620b86fe)(date) > Date.now();
}


Object.keys($a96d25a4d70c8926$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a96d25a4d70c8926$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a96d25a4d70c8926$exports[key];
        }
    });
});

Object.keys($d2050f4e5c1a3003$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d2050f4e5c1a3003$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d2050f4e5c1a3003$exports[key];
        }
    });
});

Object.keys($bf096f6f36c61b64$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $bf096f6f36c61b64$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $bf096f6f36c61b64$exports[key];
        }
    });
});
var $8e2fec4c70f4ef6b$exports = {};

$parcel$export($8e2fec4c70f4ef6b$exports, "isMatch", () => $8e2fec4c70f4ef6b$export$b74c33566721f70f, (v) => $8e2fec4c70f4ef6b$export$b74c33566721f70f = v);
var $8e2fec4c70f4ef6b$export$b74c33566721f70f;
"use strict";
$8e2fec4c70f4ef6b$export$b74c33566721f70f = $8e2fec4c70f4ef6b$var$isMatch;

var $8abb93379891fb3e$exports = {};
"use strict";
Object.defineProperty($8abb93379891fb3e$exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $54cd66db3e5e74df$export$70cc8fd02856fd58;
    }
});
$8abb93379891fb3e$exports.parse = $8abb93379891fb3e$var$parse;
Object.defineProperty($8abb93379891fb3e$exports, "parsers", {
    enumerable: true,
    get: function() {
        return $5cf2b811a6ff5b69$export$19131010e7fd8373;
    }
});






var $5cf2b811a6ff5b69$export$19131010e7fd8373;
"use strict";
$5cf2b811a6ff5b69$export$19131010e7fd8373 = void 0;
var $db0c34f9a22bf78d$export$8e5a1d3f85a9688;
"use strict";
$db0c34f9a22bf78d$export$8e5a1d3f85a9688 = void 0;
var $bc2b96d39fc4c3d8$export$7acfa6ed01010e37;
"use strict";
$bc2b96d39fc4c3d8$export$7acfa6ed01010e37 = void 0;
var $2c074b7ab8cd2d6d$export$9a09e32dd4990fd5;
var $2c074b7ab8cd2d6d$export$81d53e3678089a6;
var $2c074b7ab8cd2d6d$export$5aaf7ff7f09ea4ee;
"use strict";
$2c074b7ab8cd2d6d$export$9a09e32dd4990fd5 = $2c074b7ab8cd2d6d$export$81d53e3678089a6 = $2c074b7ab8cd2d6d$export$5aaf7ff7f09ea4ee = void 0;
var $59425df5ba0b4bea$exports = {};

$parcel$export($59425df5ba0b4bea$exports, "transpose", () => $59425df5ba0b4bea$export$9cb09a71b7d66923, (v) => $59425df5ba0b4bea$export$9cb09a71b7d66923 = v);
var $59425df5ba0b4bea$export$9cb09a71b7d66923;
"use strict";
$59425df5ba0b4bea$export$9cb09a71b7d66923 = $59425df5ba0b4bea$var$transpose;

/**
 * @name transpose
 * @category Generic Helpers
 * @summary Transpose the date to the given constructor.
 *
 * @description
 * The function transposes the date to the given constructor. It helps you
 * to transpose the date in the system time zone to say `UTCDate` or any other
 * date extension.
 *
 * @typeParam DateInputType - The input `Date` type derived from the passed argument.
 * @typeParam DateOutputType - The output `Date` type derived from the passed constructor.
 *
 * @param fromDate - The date to use values from
 * @param constructor - The date constructor to use
 *
 * @returns Date transposed to the given constructor
 *
 * @example
 * // Create July 10, 2022 00:00 in locale time zone
 * const date = new Date(2022, 6, 10)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0800 (Singapore Standard Time)'
 *
 * @example
 * // Transpose the date to July 10, 2022 00:00 in UTC
 * transpose(date, UTCDate)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0000 (Coordinated Universal Time)'
 */ function $59425df5ba0b4bea$var$transpose(fromDate, constructor) {
    const date = constructor instanceof Date ? (0, $abb9adbdb26342b3$export$ead8a1812b171991)(constructor, 0) : new constructor(0);
    date.setFullYear(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
    date.setHours(fromDate.getHours(), fromDate.getMinutes(), fromDate.getSeconds(), fromDate.getMilliseconds());
    return date;
}



const $2c074b7ab8cd2d6d$var$TIMEZONE_UNIT_PRIORITY = 10;
class $2c074b7ab8cd2d6d$var$Setter {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
$2c074b7ab8cd2d6d$export$81d53e3678089a6 = $2c074b7ab8cd2d6d$var$Setter;
class $2c074b7ab8cd2d6d$var$ValueSetter extends $2c074b7ab8cd2d6d$var$Setter {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
$2c074b7ab8cd2d6d$export$9a09e32dd4990fd5 = $2c074b7ab8cd2d6d$var$ValueSetter;
class $2c074b7ab8cd2d6d$var$DateToSystemTimezoneSetter extends $2c074b7ab8cd2d6d$var$Setter {
    priority = $2c074b7ab8cd2d6d$var$TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, (0, $59425df5ba0b4bea$export$9cb09a71b7d66923)(date, Date));
    }
}
$2c074b7ab8cd2d6d$export$5aaf7ff7f09ea4ee = $2c074b7ab8cd2d6d$var$DateToSystemTimezoneSetter;


class $bc2b96d39fc4c3d8$var$Parser {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new $2c074b7ab8cd2d6d$export$9a09e32dd4990fd5(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}
$bc2b96d39fc4c3d8$export$7acfa6ed01010e37 = $bc2b96d39fc4c3d8$var$Parser;


class $db0c34f9a22bf78d$var$EraParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}
$db0c34f9a22bf78d$export$8e5a1d3f85a9688 = $db0c34f9a22bf78d$var$EraParser;


var $66195bae0f19f15a$export$48d352de7cd4a988;
"use strict";
$66195bae0f19f15a$export$48d352de7cd4a988 = void 0;

var $7caea2161b2082cf$export$fb506d2676e7f207;
var $7caea2161b2082cf$export$3d50627710b84d75;
var $7caea2161b2082cf$export$4f84e3a82c7b538;
var $7caea2161b2082cf$export$29126f735cbf69f7;
var $7caea2161b2082cf$export$d931c43c4608a164;
var $7caea2161b2082cf$export$513bb01536146ab6;
var $7caea2161b2082cf$export$2c9307b2e29c533c;
var $7caea2161b2082cf$export$cc7cc9e2a3ff9388;
var $7caea2161b2082cf$export$6497f4c0ecdfba8e;
"use strict";
$7caea2161b2082cf$export$fb506d2676e7f207 = $7caea2161b2082cf$var$dayPeriodEnumToHours;
$7caea2161b2082cf$export$3d50627710b84d75 = $7caea2161b2082cf$var$isLeapYearIndex;
$7caea2161b2082cf$export$4f84e3a82c7b538 = $7caea2161b2082cf$var$mapValue;
$7caea2161b2082cf$export$29126f735cbf69f7 = $7caea2161b2082cf$var$normalizeTwoDigitYear;
$7caea2161b2082cf$export$d931c43c4608a164 = $7caea2161b2082cf$var$parseAnyDigitsSigned;
$7caea2161b2082cf$export$513bb01536146ab6 = $7caea2161b2082cf$var$parseNDigits;
$7caea2161b2082cf$export$2c9307b2e29c533c = $7caea2161b2082cf$var$parseNDigitsSigned;
$7caea2161b2082cf$export$cc7cc9e2a3ff9388 = $7caea2161b2082cf$var$parseNumericPattern;
$7caea2161b2082cf$export$6497f4c0ecdfba8e = $7caea2161b2082cf$var$parseTimezonePattern;

var $90ea69bf2b625c49$export$a7ee192b982af9c1;
var $90ea69bf2b625c49$export$c123ee06d9da8480;
"use strict";
$90ea69bf2b625c49$export$a7ee192b982af9c1 = $90ea69bf2b625c49$export$c123ee06d9da8480 = void 0;
const $90ea69bf2b625c49$var$numericPatterns = $90ea69bf2b625c49$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $90ea69bf2b625c49$var$timezonePatterns = $90ea69bf2b625c49$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $7caea2161b2082cf$var$mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $7caea2161b2082cf$var$parseNumericPattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $7caea2161b2082cf$var$parseTimezonePattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * $8540a44f59a4af84$export$7f72910d6dfd237a + minutes * $8540a44f59a4af84$export$91246f0b9bd9beff + seconds * $8540a44f59a4af84$export$397c2d5776aa9055),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $7caea2161b2082cf$var$parseAnyDigitsSigned(dateString) {
    return $7caea2161b2082cf$var$parseNumericPattern($90ea69bf2b625c49$export$c123ee06d9da8480.anyDigitsSigned, dateString);
}
function $7caea2161b2082cf$var$parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return $7caea2161b2082cf$var$parseNumericPattern($90ea69bf2b625c49$export$c123ee06d9da8480.singleDigit, dateString);
        case 2:
            return $7caea2161b2082cf$var$parseNumericPattern($90ea69bf2b625c49$export$c123ee06d9da8480.twoDigits, dateString);
        case 3:
            return $7caea2161b2082cf$var$parseNumericPattern($90ea69bf2b625c49$export$c123ee06d9da8480.threeDigits, dateString);
        case 4:
            return $7caea2161b2082cf$var$parseNumericPattern($90ea69bf2b625c49$export$c123ee06d9da8480.fourDigits, dateString);
        default:
            return $7caea2161b2082cf$var$parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $7caea2161b2082cf$var$parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return $7caea2161b2082cf$var$parseNumericPattern($90ea69bf2b625c49$export$c123ee06d9da8480.singleDigitSigned, dateString);
        case 2:
            return $7caea2161b2082cf$var$parseNumericPattern($90ea69bf2b625c49$export$c123ee06d9da8480.twoDigitsSigned, dateString);
        case 3:
            return $7caea2161b2082cf$var$parseNumericPattern($90ea69bf2b625c49$export$c123ee06d9da8480.threeDigitsSigned, dateString);
        case 4:
            return $7caea2161b2082cf$var$parseNumericPattern($90ea69bf2b625c49$export$c123ee06d9da8480.fourDigitsSigned, dateString);
        default:
            return $7caea2161b2082cf$var$parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $7caea2161b2082cf$var$dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $7caea2161b2082cf$var$normalizeTwoDigitYear(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $7caea2161b2082cf$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
class $66195bae0f19f15a$var$YearParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "yo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $7caea2161b2082cf$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
$66195bae0f19f15a$export$48d352de7cd4a988 = $66195bae0f19f15a$var$YearParser;


var $9fda39b31cab7345$export$b8ef38dfcf05d5db;
"use strict";
$9fda39b31cab7345$export$b8ef38dfcf05d5db = void 0;




// Local week-numbering year
class $9fda39b31cab7345$var$LocalWeekYearParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "Yo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $0170e230c8468ebb$export$12d572480ceb6e58)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $7caea2161b2082cf$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
$9fda39b31cab7345$export$b8ef38dfcf05d5db = $9fda39b31cab7345$var$LocalWeekYearParser;


var $1a189db5f2a1065c$export$951d1df011fde06f;
"use strict";
$1a189db5f2a1065c$export$951d1df011fde06f = void 0;




// ISO week-numbering year
class $1a189db5f2a1065c$var$ISOWeekYearParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, $7caea2161b2082cf$export$2c9307b2e29c533c)(4, dateString);
        return (0, $7caea2161b2082cf$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $1c9d32c6cb108460$export$6173213f95a4431e)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
$1a189db5f2a1065c$export$951d1df011fde06f = $1a189db5f2a1065c$var$ISOWeekYearParser;


var $c3854b7a937037cd$export$bad9d2ea38e8f1a;
"use strict";
$c3854b7a937037cd$export$bad9d2ea38e8f1a = void 0;


class $c3854b7a937037cd$var$ExtendedYearParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, $7caea2161b2082cf$export$2c9307b2e29c533c)(4, dateString);
        return (0, $7caea2161b2082cf$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$c3854b7a937037cd$export$bad9d2ea38e8f1a = $c3854b7a937037cd$var$ExtendedYearParser;


var $d1988bf983127f3e$export$5cb0f701186dde1d;
"use strict";
$d1988bf983127f3e$export$5cb0f701186dde1d = void 0;


class $d1988bf983127f3e$var$QuarterParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$d1988bf983127f3e$export$5cb0f701186dde1d = $d1988bf983127f3e$var$QuarterParser;


var $62b79555ac1f33b0$export$300c0c2990e20e6d;
"use strict";
$62b79555ac1f33b0$export$300c0c2990e20e6d = void 0;


class $62b79555ac1f33b0$var$StandAloneQuarterParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$62b79555ac1f33b0$export$300c0c2990e20e6d = $62b79555ac1f33b0$var$StandAloneQuarterParser;


var $44a198f4e488a239$export$400dd8b40ef138a3;
"use strict";
$44a198f4e488a239$export$400dd8b40ef138a3 = void 0;



class $44a198f4e488a239$var$MonthParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)($90ea69bf2b625c49$export$c123ee06d9da8480.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
$44a198f4e488a239$export$400dd8b40ef138a3 = $44a198f4e488a239$var$MonthParser;


var $f7643ab884280f91$export$1d7eaa53eaa5deba;
"use strict";
$f7643ab884280f91$export$1d7eaa53eaa5deba = void 0;



class $f7643ab884280f91$var$StandAloneMonthParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)($90ea69bf2b625c49$export$c123ee06d9da8480.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$f7643ab884280f91$export$1d7eaa53eaa5deba = $f7643ab884280f91$var$StandAloneMonthParser;


var $0da9b6c0b13ee7fd$export$c4005ffc174e07c0;
"use strict";
$0da9b6c0b13ee7fd$export$c4005ffc174e07c0 = void 0;
var $66c7729eb95aa501$exports = {};

$parcel$export($66c7729eb95aa501$exports, "setWeek", () => $66c7729eb95aa501$export$4b3066ce4afafd88, (v) => $66c7729eb95aa501$export$4b3066ce4afafd88 = v);
var $66c7729eb95aa501$export$4b3066ce4afafd88;
"use strict";
$66c7729eb95aa501$export$4b3066ce4afafd88 = $66c7729eb95aa501$var$setWeek;


/**
 * The {@link setWeek} function options.
 */ /**
 * @name setWeek
 * @category Week Helpers
 * @summary Set the local week to the given date.
 *
 * @description
 * Set the local week to the given date, saving the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The week of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week set
 *
 * @example
 * // Set the 1st week to 2 January 2005 with default options:
 * const result = setWeek(new Date(2005, 0, 2), 1)
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // Set the 1st week to 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January:
 * const result = setWeek(new Date(2005, 0, 2), 1, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sun Jan 4 2004 00:00:00
 */ function $66c7729eb95aa501$var$setWeek(date, week, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const diff = (0, $11b38d723fd57381$export$efe19b760242b2fc)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}






// Local week of year
class $0da9b6c0b13ee7fd$var$LocalWeekParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)($90ea69bf2b625c49$export$c123ee06d9da8480.week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)((0, $66c7729eb95aa501$export$4b3066ce4afafd88)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
$0da9b6c0b13ee7fd$export$c4005ffc174e07c0 = $0da9b6c0b13ee7fd$var$LocalWeekParser;


var $6803ee1ef2b46eaa$export$6fc8dbedd560a6af;
"use strict";
$6803ee1ef2b46eaa$export$6fc8dbedd560a6af = void 0;
var $d0815b4ed45bc80a$exports = {};

$parcel$export($d0815b4ed45bc80a$exports, "setISOWeek", () => $d0815b4ed45bc80a$export$6542bebf6be94082, (v) => $d0815b4ed45bc80a$export$6542bebf6be94082 = v);
var $d0815b4ed45bc80a$export$6542bebf6be94082;
"use strict";
$d0815b4ed45bc80a$export$6542bebf6be94082 = $d0815b4ed45bc80a$var$setISOWeek;


/**
 * @name setISOWeek
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The ISO week of the new date
 *
 * @returns The new date with the ISO week set
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * const result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */ function $d0815b4ed45bc80a$var$setISOWeek(date, week) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const diff = (0, $83e11b0db4cec366$export$7cabdc5698b63e2f)(_date) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}






// ISO week of year
class $6803ee1ef2b46eaa$var$ISOWeekParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)($90ea69bf2b625c49$export$c123ee06d9da8480.week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $1c9d32c6cb108460$export$6173213f95a4431e)((0, $d0815b4ed45bc80a$export$6542bebf6be94082)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
$6803ee1ef2b46eaa$export$6fc8dbedd560a6af = $6803ee1ef2b46eaa$var$ISOWeekParser;


var $e06f3f7fc9153746$export$e8d4b28a20981dd2;
"use strict";
$e06f3f7fc9153746$export$e8d4b28a20981dd2 = void 0;



const $e06f3f7fc9153746$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $e06f3f7fc9153746$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
// Day of the month
class $e06f3f7fc9153746$var$DateParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)($90ea69bf2b625c49$export$c123ee06d9da8480.date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $7caea2161b2082cf$export$3d50627710b84d75)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $e06f3f7fc9153746$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $e06f3f7fc9153746$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$e06f3f7fc9153746$export$e8d4b28a20981dd2 = $e06f3f7fc9153746$var$DateParser;


var $6b2b75646543924f$export$6cfe0d613455f615;
"use strict";
$6b2b75646543924f$export$6cfe0d613455f615 = void 0;



class $6b2b75646543924f$var$DayOfYearParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)($90ea69bf2b625c49$export$c123ee06d9da8480.dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $7caea2161b2082cf$export$3d50627710b84d75)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$6b2b75646543924f$export$6cfe0d613455f615 = $6b2b75646543924f$var$DayOfYearParser;


var $9c29ecc5d15fe12f$export$1b03c8b76262f7bd;
"use strict";
$9c29ecc5d15fe12f$export$1b03c8b76262f7bd = void 0;
var $13939a537621d91b$exports = {};

$parcel$export($13939a537621d91b$exports, "setDay", () => $13939a537621d91b$export$b04fdcda82decc6c, (v) => $13939a537621d91b$export$b04fdcda82decc6c = v);
var $13939a537621d91b$export$b04fdcda82decc6c;
"use strict";
$13939a537621d91b$export$b04fdcda82decc6c = $13939a537621d91b$var$setDay;



/**
 * The {@link setDay} function options.
 */ /**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the week of the new date
 * @param options - An object with options.
 *
 * @returns The new date with the day of the week set
 *
 * @example
 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
 * const result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Set week day to Sunday, with a weekStartsOn of Monday:
 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function $13939a537621d91b$var$setDay(date, day, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const currentDay = _date.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(_date, diff);
}



// Day of week
class $9c29ecc5d15fe12f$var$DayParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $13939a537621d91b$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$9c29ecc5d15fe12f$export$1b03c8b76262f7bd = $9c29ecc5d15fe12f$var$DayParser;


var $fff6beaa36b4d0e5$export$44d1c127ab42c480;
"use strict";
$fff6beaa36b4d0e5$export$44d1c127ab42c480 = void 0;



// Local day of week
class $fff6beaa36b4d0e5$var$LocalDayParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $13939a537621d91b$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}
$fff6beaa36b4d0e5$export$44d1c127ab42c480 = $fff6beaa36b4d0e5$var$LocalDayParser;


var $1516c9543f7b6045$export$e447a647caaaec1d;
"use strict";
$1516c9543f7b6045$export$e447a647caaaec1d = void 0;



// Stand-alone local day of week
class $1516c9543f7b6045$var$StandAloneLocalDayParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $13939a537621d91b$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}
$1516c9543f7b6045$export$e447a647caaaec1d = $1516c9543f7b6045$var$StandAloneLocalDayParser;


var $6410865f895f2a05$export$693fb1e525095b2a;
"use strict";
$6410865f895f2a05$export$693fb1e525095b2a = void 0;
var $87a68208fbd57247$exports = {};

$parcel$export($87a68208fbd57247$exports, "setISODay", () => $87a68208fbd57247$export$1fd9df65adb0d1aa, (v) => $87a68208fbd57247$export$1fd9df65adb0d1aa = v);
var $87a68208fbd57247$export$1fd9df65adb0d1aa;
"use strict";
$87a68208fbd57247$export$1fd9df65adb0d1aa = $87a68208fbd57247$var$setISODay;



/**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the ISO week of the new date
 *
 * @returns The new date with the day of the ISO week set
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * const result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */ function $87a68208fbd57247$var$setISODay(date, day) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const currentDay = (0, $6f80ca66d6710e40$export$c514f4c1a8ed5e9e)(_date);
    const diff = day - currentDay;
    return (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(_date, diff);
}




// ISO day of week
class $6410865f895f2a05$var$ISODayParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $87a68208fbd57247$export$1fd9df65adb0d1aa)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}
$6410865f895f2a05$export$693fb1e525095b2a = $6410865f895f2a05$var$ISODayParser;


var $d5f00db985cb1985$export$8d1e08492351df91;
"use strict";
$d5f00db985cb1985$export$8d1e08492351df91 = void 0;


class $d5f00db985cb1985$var$AMPMParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7caea2161b2082cf$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
$d5f00db985cb1985$export$8d1e08492351df91 = $d5f00db985cb1985$var$AMPMParser;


var $40ef93898dc5fd94$export$73ca2bd0a17d273;
"use strict";
$40ef93898dc5fd94$export$73ca2bd0a17d273 = void 0;


class $40ef93898dc5fd94$var$AMPMMidnightParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7caea2161b2082cf$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
$40ef93898dc5fd94$export$73ca2bd0a17d273 = $40ef93898dc5fd94$var$AMPMMidnightParser;


var $74a8f7a92cf7f4b7$export$bb9212adf05373db;
"use strict";
$74a8f7a92cf7f4b7$export$bb9212adf05373db = void 0;


// in the morning, in the afternoon, in the evening, at night
class $74a8f7a92cf7f4b7$var$DayPeriodParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7caea2161b2082cf$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}
$74a8f7a92cf7f4b7$export$bb9212adf05373db = $74a8f7a92cf7f4b7$var$DayPeriodParser;


var $c4e91a5550a4af76$export$8a04050a727a1756;
"use strict";
$c4e91a5550a4af76$export$8a04050a727a1756 = void 0;



class $c4e91a5550a4af76$var$Hour1to12Parser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)($90ea69bf2b625c49$export$c123ee06d9da8480.hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}
$c4e91a5550a4af76$export$8a04050a727a1756 = $c4e91a5550a4af76$var$Hour1to12Parser;


var $04e380d05021e0e6$export$e56f4dea2c3e56dd;
"use strict";
$04e380d05021e0e6$export$e56f4dea2c3e56dd = void 0;



class $04e380d05021e0e6$var$Hour0to23Parser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)($90ea69bf2b625c49$export$c123ee06d9da8480.hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}
$04e380d05021e0e6$export$e56f4dea2c3e56dd = $04e380d05021e0e6$var$Hour0to23Parser;


var $b7df994bc976acad$export$cbbe855312f87d77;
"use strict";
$b7df994bc976acad$export$cbbe855312f87d77 = void 0;



class $b7df994bc976acad$var$Hour0To11Parser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)($90ea69bf2b625c49$export$c123ee06d9da8480.hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}
$b7df994bc976acad$export$cbbe855312f87d77 = $b7df994bc976acad$var$Hour0To11Parser;


var $2a786c11f89b58f4$export$6008046d2b34b6a5;
"use strict";
$2a786c11f89b58f4$export$6008046d2b34b6a5 = void 0;



class $2a786c11f89b58f4$var$Hour1To24Parser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)($90ea69bf2b625c49$export$c123ee06d9da8480.hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}
$2a786c11f89b58f4$export$6008046d2b34b6a5 = $2a786c11f89b58f4$var$Hour1To24Parser;


var $fccac2a30b38ae4c$export$2b52670d9e2be53;
"use strict";
$fccac2a30b38ae4c$export$2b52670d9e2be53 = void 0;



class $fccac2a30b38ae4c$var$MinuteParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)($90ea69bf2b625c49$export$c123ee06d9da8480.minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$fccac2a30b38ae4c$export$2b52670d9e2be53 = $fccac2a30b38ae4c$var$MinuteParser;


var $1cf805ecbd4f0c4e$export$94d46d540cf1366a;
"use strict";
$1cf805ecbd4f0c4e$export$94d46d540cf1366a = void 0;



class $1cf805ecbd4f0c4e$var$SecondParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)($90ea69bf2b625c49$export$c123ee06d9da8480.second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$1cf805ecbd4f0c4e$export$94d46d540cf1366a = $1cf805ecbd4f0c4e$var$SecondParser;


var $93458d2bd887c060$export$b8e6f8b2d70893b1;
"use strict";
$93458d2bd887c060$export$b8e6f8b2d70893b1 = void 0;


class $93458d2bd887c060$var$FractionOfSecondParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$93458d2bd887c060$export$b8e6f8b2d70893b1 = $93458d2bd887c060$var$FractionOfSecondParser;


var $8e1ac7071c05f7b7$export$104d901d49fea29b;
"use strict";
$8e1ac7071c05f7b7$export$104d901d49fea29b = void 0;





// Timezone (ISO-8601. +00:00 is `'Z'`)
class $8e1ac7071c05f7b7$var$ISOTimezoneWithZParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)($90ea69bf2b625c49$export$a7ee192b982af9c1.basicOptionalMinutes, dateString);
            case "XX":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)($90ea69bf2b625c49$export$a7ee192b982af9c1.basic, dateString);
            case "XXXX":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)($90ea69bf2b625c49$export$a7ee192b982af9c1.basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)($90ea69bf2b625c49$export$a7ee192b982af9c1.extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)($90ea69bf2b625c49$export$a7ee192b982af9c1.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, date.getTime() - (0, $92dc0740ffabe180$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}
$8e1ac7071c05f7b7$export$104d901d49fea29b = $8e1ac7071c05f7b7$var$ISOTimezoneWithZParser;


var $817e75c4dd06b66a$export$12910e5204b52b9;
"use strict";
$817e75c4dd06b66a$export$12910e5204b52b9 = void 0;





// Timezone (ISO-8601)
class $817e75c4dd06b66a$var$ISOTimezoneParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)($90ea69bf2b625c49$export$a7ee192b982af9c1.basicOptionalMinutes, dateString);
            case "xx":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)($90ea69bf2b625c49$export$a7ee192b982af9c1.basic, dateString);
            case "xxxx":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)($90ea69bf2b625c49$export$a7ee192b982af9c1.basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)($90ea69bf2b625c49$export$a7ee192b982af9c1.extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)($90ea69bf2b625c49$export$a7ee192b982af9c1.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, date.getTime() - (0, $92dc0740ffabe180$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}
$817e75c4dd06b66a$export$12910e5204b52b9 = $817e75c4dd06b66a$var$ISOTimezoneParser;


var $a7e39061a4ba0a45$export$2cd8bf877a05e96;
"use strict";
$a7e39061a4ba0a45$export$2cd8bf877a05e96 = void 0;



class $a7e39061a4ba0a45$var$TimestampSecondsParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 40;
    parse(dateString) {
        return (0, $7caea2161b2082cf$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
$a7e39061a4ba0a45$export$2cd8bf877a05e96 = $a7e39061a4ba0a45$var$TimestampSecondsParser;


var $dff03ff1496c0b81$export$6d8f69c6906d6368;
"use strict";
$dff03ff1496c0b81$export$6d8f69c6906d6368 = void 0;



class $dff03ff1496c0b81$var$TimestampMillisecondsParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 20;
    parse(dateString) {
        return (0, $7caea2161b2082cf$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
$dff03ff1496c0b81$export$6d8f69c6906d6368 = $dff03ff1496c0b81$var$TimestampMillisecondsParser;


/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any -- It's ok, we want any here
const $5cf2b811a6ff5b69$var$parsers = $5cf2b811a6ff5b69$export$19131010e7fd8373 = {
    G: new $db0c34f9a22bf78d$export$8e5a1d3f85a9688(),
    y: new $66195bae0f19f15a$export$48d352de7cd4a988(),
    Y: new $9fda39b31cab7345$export$b8ef38dfcf05d5db(),
    R: new $1a189db5f2a1065c$export$951d1df011fde06f(),
    u: new $c3854b7a937037cd$export$bad9d2ea38e8f1a(),
    Q: new $d1988bf983127f3e$export$5cb0f701186dde1d(),
    q: new $62b79555ac1f33b0$export$300c0c2990e20e6d(),
    M: new $44a198f4e488a239$export$400dd8b40ef138a3(),
    L: new $f7643ab884280f91$export$1d7eaa53eaa5deba(),
    w: new $0da9b6c0b13ee7fd$export$c4005ffc174e07c0(),
    I: new $6803ee1ef2b46eaa$export$6fc8dbedd560a6af(),
    d: new $e06f3f7fc9153746$export$e8d4b28a20981dd2(),
    D: new $6b2b75646543924f$export$6cfe0d613455f615(),
    E: new $9c29ecc5d15fe12f$export$1b03c8b76262f7bd(),
    e: new $fff6beaa36b4d0e5$export$44d1c127ab42c480(),
    c: new $1516c9543f7b6045$export$e447a647caaaec1d(),
    i: new $6410865f895f2a05$export$693fb1e525095b2a(),
    a: new $d5f00db985cb1985$export$8d1e08492351df91(),
    b: new $40ef93898dc5fd94$export$73ca2bd0a17d273(),
    B: new $74a8f7a92cf7f4b7$export$bb9212adf05373db(),
    h: new $c4e91a5550a4af76$export$8a04050a727a1756(),
    H: new $04e380d05021e0e6$export$e56f4dea2c3e56dd(),
    K: new $b7df994bc976acad$export$cbbe855312f87d77(),
    k: new $2a786c11f89b58f4$export$6008046d2b34b6a5(),
    m: new $fccac2a30b38ae4c$export$2b52670d9e2be53(),
    s: new $1cf805ecbd4f0c4e$export$94d46d540cf1366a(),
    S: new $93458d2bd887c060$export$b8e6f8b2d70893b1(),
    X: new $8e1ac7071c05f7b7$export$104d901d49fea29b(),
    x: new $817e75c4dd06b66a$export$12910e5204b52b9(),
    t: new $a7e39061a4ba0a45$export$2cd8bf877a05e96(),
    T: new $dff03ff1496c0b81$export$6d8f69c6906d6368()
};



// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $8abb93379891fb3e$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $8abb93379891fb3e$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $8abb93379891fb3e$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $8abb93379891fb3e$var$doubleQuoteRegExp = /''/g;
const $8abb93379891fb3e$var$notWhitespaceRegExp = /\S/;
const $8abb93379891fb3e$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The string to parse
 * @param formatStr - The string of tokens
 * @param referenceDate - defines values missing from the parsed dateString
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns The parsed date
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */ function $8abb93379891fb3e$var$parse(dateStr, formatStr, referenceDate, options) {
    const defaultOptions = (0, $f3e2f0f906df8397$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? $e9531067c80a48a0$exports.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (formatStr === "") {
        if (dateStr === "") return (0, $231bfb8d72679740$export$e67a095c620b86fe)(referenceDate);
        else return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(referenceDate, NaN);
    }
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    const setters = [
        new $2c074b7ab8cd2d6d$export$5aaf7ff7f09ea4ee()
    ];
    const tokens = formatStr.match($8abb93379891fb3e$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in $54cd66db3e5e74df$export$70cc8fd02856fd58) {
            const longFormatter = $54cd66db3e5e74df$export$70cc8fd02856fd58[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($8abb93379891fb3e$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, $7e8a5b0b77bf77b9$export$c6b49d6dceb604a1)(token)) (0, $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, $7e8a5b0b77bf77b9$export$c6cc36aa33304772)(token)) (0, $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = $5cf2b811a6ff5b69$export$19131010e7fd8373[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(referenceDate, NaN);
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($8abb93379891fb3e$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $8abb93379891fb3e$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(referenceDate, NaN);
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $8abb93379891fb3e$var$notWhitespaceRegExp.test(dateStr)) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(referenceDate, NaN);
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(referenceDate);
    if (isNaN(date.getTime())) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(referenceDate, NaN);
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(referenceDate, NaN);
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(referenceDate, date);
}
function $8abb93379891fb3e$var$cleanEscapedString(input) {
    return input.match($8abb93379891fb3e$var$escapedStringRegExp)[1].replace($8abb93379891fb3e$var$doubleQuoteRegExp, "'");
}


/**
 * The {@link isMatch} function options.
 */ /**
 * @name isMatch
 * @category Common Helpers
 * @summary validates the date string against given formats
 *
 * @description
 * Return the true if given date is string correct against the given format else
 * will return false.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * isMatch('23 AM', 'HH a')
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `isMatch` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `isMatch('50', 'yy') //=> true`
 *
 *    `isMatch('75', 'yy') //=> true`
 *
 *    while `uu` will use the year as is:
 *
 *    `isMatch('50', 'uu') //=> true`
 *
 *    `isMatch('75', 'uu') //=> true`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be checked in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
 * the values will be taken from today's using `new Date()` date which works as a context of parsing.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The date string to verify
 * @param format - The string of tokens
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns Is format string a match for date string?
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Match 11 February 2014 from middle-endian format:
 * const result = isMatch('02/11/2014', 'MM/dd/yyyy')
 * //=> true
 *
 * @example
 * // Match 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * const result = isMatch('28-a de februaro', "do 'de' MMMM", {
 *   locale: eo
 * })
 * //=> true
 */ function $8e2fec4c70f4ef6b$var$isMatch(dateStr, formatStr, options) {
    return (0, $f2a682b251363bc2$export$1ea939691cdc45b8)((0, $8abb93379891fb3e$exports.parse)(dateStr, formatStr, new Date(), options));
}


Object.keys($8e2fec4c70f4ef6b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $8e2fec4c70f4ef6b$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $8e2fec4c70f4ef6b$exports[key];
        }
    });
});
var $3f9d573ef8d8a1fd$exports = {};

$parcel$export($3f9d573ef8d8a1fd$exports, "isMonday", () => $3f9d573ef8d8a1fd$export$9573fe9b7c9ac3f5, (v) => $3f9d573ef8d8a1fd$export$9573fe9b7c9ac3f5 = v);
var $3f9d573ef8d8a1fd$export$9573fe9b7c9ac3f5;
"use strict";
$3f9d573ef8d8a1fd$export$9573fe9b7c9ac3f5 = $3f9d573ef8d8a1fd$var$isMonday;

/**
 * @name isMonday
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Monday
 *
 * @example
 * // Is 22 September 2014 Monday?
 * const result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */ function $3f9d573ef8d8a1fd$var$isMonday(date) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date).getDay() === 1;
}


Object.keys($3f9d573ef8d8a1fd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $3f9d573ef8d8a1fd$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $3f9d573ef8d8a1fd$exports[key];
        }
    });
});
var $957ff381b38ac7b6$exports = {};

$parcel$export($957ff381b38ac7b6$exports, "isPast", () => $957ff381b38ac7b6$export$fc5014aa3db48558, (v) => $957ff381b38ac7b6$export$fc5014aa3db48558 = v);
var $957ff381b38ac7b6$export$fc5014aa3db48558;
"use strict";
$957ff381b38ac7b6$export$fc5014aa3db48558 = $957ff381b38ac7b6$var$isPast;

/**
 * @name isPast
 * @category Common Helpers
 * @summary Is the given date in the past?
 * @pure false
 *
 * @description
 * Is the given date in the past?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * const result = isPast(new Date(2014, 6, 2))
 * //=> true
 */ function $957ff381b38ac7b6$var$isPast(date) {
    return +(0, $231bfb8d72679740$export$e67a095c620b86fe)(date) < Date.now();
}


Object.keys($957ff381b38ac7b6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $957ff381b38ac7b6$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $957ff381b38ac7b6$exports[key];
        }
    });
});

Object.keys($27a7db21eafd685b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $27a7db21eafd685b$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $27a7db21eafd685b$exports[key];
        }
    });
});
var $3d9e3b90112ffc43$exports = {};

$parcel$export($3d9e3b90112ffc43$exports, "isSameHour", () => $3d9e3b90112ffc43$export$f9f3a94a0371013, (v) => $3d9e3b90112ffc43$export$f9f3a94a0371013 = v);
var $3d9e3b90112ffc43$export$f9f3a94a0371013;
"use strict";
$3d9e3b90112ffc43$export$f9f3a94a0371013 = $3d9e3b90112ffc43$var$isSameHour;
var $d153613108f3ff12$exports = {};

$parcel$export($d153613108f3ff12$exports, "startOfHour", () => $d153613108f3ff12$export$24f91f68e7c9d9d5, (v) => $d153613108f3ff12$export$24f91f68e7c9d9d5 = v);
var $d153613108f3ff12$export$24f91f68e7c9d9d5;
"use strict";
$d153613108f3ff12$export$24f91f68e7c9d9d5 = $d153613108f3ff12$var$startOfHour;

/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */ function $d153613108f3ff12$var$startOfHour(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setMinutes(0, 0, 0);
    return _date;
}


/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour (and same day)?
 *
 * @description
 * Are the given dates in the same hour (and same day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same hour (and same day)
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
 * //=> false
 */ function $3d9e3b90112ffc43$var$isSameHour(dateLeft, dateRight) {
    const dateLeftStartOfHour = (0, $d153613108f3ff12$export$24f91f68e7c9d9d5)(dateLeft);
    const dateRightStartOfHour = (0, $d153613108f3ff12$export$24f91f68e7c9d9d5)(dateRight);
    return +dateLeftStartOfHour === +dateRightStartOfHour;
}


Object.keys($3d9e3b90112ffc43$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $3d9e3b90112ffc43$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $3d9e3b90112ffc43$exports[key];
        }
    });
});
var $2f828403128a4c50$exports = {};

$parcel$export($2f828403128a4c50$exports, "isSameISOWeek", () => $2f828403128a4c50$export$1c6e74e3c7b27764, (v) => $2f828403128a4c50$export$1c6e74e3c7b27764 = v);
var $2f828403128a4c50$export$1c6e74e3c7b27764;
"use strict";
$2f828403128a4c50$export$1c6e74e3c7b27764 = $2f828403128a4c50$var$isSameISOWeek;
var $4398e052cc63a087$exports = {};

$parcel$export($4398e052cc63a087$exports, "isSameWeek", () => $4398e052cc63a087$export$6ea683876c36b8d2, (v) => $4398e052cc63a087$export$6ea683876c36b8d2 = v);
var $4398e052cc63a087$export$6ea683876c36b8d2;
"use strict";
$4398e052cc63a087$export$6ea683876c36b8d2 = $4398e052cc63a087$var$isSameWeek;

/**
 * The {@link isSameWeek} function options.
 */ /**
 * @name isSameWeek
 * @category Week Helpers
 * @summary Are the given dates in the same week (and month and year)?
 *
 * @description
 * Are the given dates in the same week (and month and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same week (and month and year)
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
 *   weekStartsOn: 1
 * })
 * //=> false
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same week?
 * const result = isSameWeek(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ function $4398e052cc63a087$var$isSameWeek(dateLeft, dateRight, options) {
    const dateLeftStartOfWeek = (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(dateLeft, options);
    const dateRightStartOfWeek = (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(dateRight, options);
    return +dateLeftStartOfWeek === +dateRightStartOfWeek;
}


/**
 * @name isSameISOWeek
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week (and year)?
 *
 * @description
 * Are the given dates in the same ISO week (and year)?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week (and year)
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
 * //=> true
 *
 * @example
 * // Are 1 September 2014 and 1 September 2015 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2015, 8, 1))
 * //=> false
 */ function $2f828403128a4c50$var$isSameISOWeek(dateLeft, dateRight) {
    return (0, $4398e052cc63a087$export$6ea683876c36b8d2)(dateLeft, dateRight, {
        weekStartsOn: 1
    });
}


Object.keys($2f828403128a4c50$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $2f828403128a4c50$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $2f828403128a4c50$exports[key];
        }
    });
});
var $d3ee8591ef34529f$exports = {};

$parcel$export($d3ee8591ef34529f$exports, "isSameISOWeekYear", () => $d3ee8591ef34529f$export$5f55dbf38a1aee81, (v) => $d3ee8591ef34529f$export$5f55dbf38a1aee81 = v);
var $d3ee8591ef34529f$export$5f55dbf38a1aee81;
"use strict";
$d3ee8591ef34529f$export$5f55dbf38a1aee81 = $d3ee8591ef34529f$var$isSameISOWeekYear;

/**
 * @name isSameISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week-numbering year
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * const result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
 * //=> true
 */ function $d3ee8591ef34529f$var$isSameISOWeekYear(dateLeft, dateRight) {
    const dateLeftStartOfYear = (0, $3b2e6199275b27d6$export$236bdfa374eb69a9)(dateLeft);
    const dateRightStartOfYear = (0, $3b2e6199275b27d6$export$236bdfa374eb69a9)(dateRight);
    return +dateLeftStartOfYear === +dateRightStartOfYear;
}


Object.keys($d3ee8591ef34529f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d3ee8591ef34529f$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d3ee8591ef34529f$exports[key];
        }
    });
});
var $dcee691fa8b5c110$exports = {};

$parcel$export($dcee691fa8b5c110$exports, "isSameMinute", () => $dcee691fa8b5c110$export$5d274bf63c8705cb, (v) => $dcee691fa8b5c110$export$5d274bf63c8705cb = v);
var $dcee691fa8b5c110$export$5d274bf63c8705cb;
"use strict";
$dcee691fa8b5c110$export$5d274bf63c8705cb = $dcee691fa8b5c110$var$isSameMinute;

/**
 * @name isSameMinute
 * @category Minute Helpers
 * @summary Are the given dates in the same minute (and hour and day)?
 *
 * @description
 * Are the given dates in the same minute (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same minute (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 5 September 2014 06:30:00 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 5, 6, 30)
 * )
 * //=> false
 */ function $dcee691fa8b5c110$var$isSameMinute(dateLeft, dateRight) {
    const dateLeftStartOfMinute = (0, $d1ad424e56672364$export$c66440458c6aa793)(dateLeft);
    const dateRightStartOfMinute = (0, $d1ad424e56672364$export$c66440458c6aa793)(dateRight);
    return +dateLeftStartOfMinute === +dateRightStartOfMinute;
}


Object.keys($dcee691fa8b5c110$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $dcee691fa8b5c110$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $dcee691fa8b5c110$exports[key];
        }
    });
});
var $06e3609fc2fbc2e2$exports = {};

$parcel$export($06e3609fc2fbc2e2$exports, "isSameMonth", () => $06e3609fc2fbc2e2$export$a18c89cbd24170ff, (v) => $06e3609fc2fbc2e2$export$a18c89cbd24170ff = v);
var $06e3609fc2fbc2e2$export$a18c89cbd24170ff;
"use strict";
$06e3609fc2fbc2e2$export$a18c89cbd24170ff = $06e3609fc2fbc2e2$var$isSameMonth;

/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */ function $06e3609fc2fbc2e2$var$isSameMonth(dateLeft, dateRight) {
    const _dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear() && _dateLeft.getMonth() === _dateRight.getMonth();
}


Object.keys($06e3609fc2fbc2e2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $06e3609fc2fbc2e2$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $06e3609fc2fbc2e2$exports[key];
        }
    });
});
var $b059a7637303f908$exports = {};

$parcel$export($b059a7637303f908$exports, "isSameQuarter", () => $b059a7637303f908$export$5c60e4190867161c, (v) => $b059a7637303f908$export$5c60e4190867161c = v);
var $b059a7637303f908$export$5c60e4190867161c;
"use strict";
$b059a7637303f908$export$5c60e4190867161c = $b059a7637303f908$var$isSameQuarter;

/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same quarter (and year)
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ function $b059a7637303f908$var$isSameQuarter(dateLeft, dateRight) {
    const dateLeftStartOfQuarter = (0, $c922a15e7d8774a7$export$69be7267a042ecb3)(dateLeft);
    const dateRightStartOfQuarter = (0, $c922a15e7d8774a7$export$69be7267a042ecb3)(dateRight);
    return +dateLeftStartOfQuarter === +dateRightStartOfQuarter;
}


Object.keys($b059a7637303f908$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $b059a7637303f908$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $b059a7637303f908$exports[key];
        }
    });
});
var $af3916f9a5384d82$exports = {};

$parcel$export($af3916f9a5384d82$exports, "isSameSecond", () => $af3916f9a5384d82$export$b88fbcfe038f3498, (v) => $af3916f9a5384d82$export$b88fbcfe038f3498 = v);
var $af3916f9a5384d82$export$b88fbcfe038f3498;
"use strict";
$af3916f9a5384d82$export$b88fbcfe038f3498 = $af3916f9a5384d82$var$isSameSecond;
var $fec0f854199fab32$exports = {};

$parcel$export($fec0f854199fab32$exports, "startOfSecond", () => $fec0f854199fab32$export$66c51f9715fdbff5, (v) => $fec0f854199fab32$export$66c51f9715fdbff5 = v);
var $fec0f854199fab32$export$66c51f9715fdbff5;
"use strict";
$fec0f854199fab32$export$66c51f9715fdbff5 = $fec0f854199fab32$var$startOfSecond;

/**
 * @name startOfSecond
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a second
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */ function $fec0f854199fab32$var$startOfSecond(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setMilliseconds(0);
    return _date;
}


/**
 * @name isSameSecond
 * @category Second Helpers
 * @summary Are the given dates in the same second (and hour and day)?
 *
 * @description
 * Are the given dates in the same second (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same second (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 4 September 2014 06:01.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 4, 6, 1, 15)
 * )
 * //=> false
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 5 September 2014 06:00.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 5, 6, 0, 15)
 * )
 * //=> false
 */ function $af3916f9a5384d82$var$isSameSecond(dateLeft, dateRight) {
    const dateLeftStartOfSecond = (0, $fec0f854199fab32$export$66c51f9715fdbff5)(dateLeft);
    const dateRightStartOfSecond = (0, $fec0f854199fab32$export$66c51f9715fdbff5)(dateRight);
    return +dateLeftStartOfSecond === +dateRightStartOfSecond;
}


Object.keys($af3916f9a5384d82$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $af3916f9a5384d82$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $af3916f9a5384d82$exports[key];
        }
    });
});

Object.keys($4398e052cc63a087$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $4398e052cc63a087$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $4398e052cc63a087$exports[key];
        }
    });
});
var $a4f3c61641c4093b$exports = {};

$parcel$export($a4f3c61641c4093b$exports, "isSameYear", () => $a4f3c61641c4093b$export$5841f9eb9773f25f, (v) => $a4f3c61641c4093b$export$5841f9eb9773f25f = v);
var $a4f3c61641c4093b$export$5841f9eb9773f25f;
"use strict";
$a4f3c61641c4093b$export$5841f9eb9773f25f = $a4f3c61641c4093b$var$isSameYear;

/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */ function $a4f3c61641c4093b$var$isSameYear(dateLeft, dateRight) {
    const _dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear();
}


Object.keys($a4f3c61641c4093b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a4f3c61641c4093b$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a4f3c61641c4093b$exports[key];
        }
    });
});

Object.keys($d84241a3868bd79f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d84241a3868bd79f$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d84241a3868bd79f$exports[key];
        }
    });
});

Object.keys($971b91a830c22187$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $971b91a830c22187$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $971b91a830c22187$exports[key];
        }
    });
});
var $1fcf523a61a65140$exports = {};

$parcel$export($1fcf523a61a65140$exports, "isThisHour", () => $1fcf523a61a65140$export$5d41bdc7172839b9, (v) => $1fcf523a61a65140$export$5d41bdc7172839b9 = v);
var $1fcf523a61a65140$export$5d41bdc7172839b9;
"use strict";
$1fcf523a61a65140$export$5d41bdc7172839b9 = $1fcf523a61a65140$var$isThisHour;


/**
 * @name isThisHour
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * const result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */ function $1fcf523a61a65140$var$isThisHour(date) {
    return (0, $3d9e3b90112ffc43$export$f9f3a94a0371013)(date, (0, $d8623e255497753b$export$18c3c6510fb97afc)(date));
}


Object.keys($1fcf523a61a65140$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $1fcf523a61a65140$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $1fcf523a61a65140$exports[key];
        }
    });
});
var $13e900ab202aea44$exports = {};

$parcel$export($13e900ab202aea44$exports, "isThisISOWeek", () => $13e900ab202aea44$export$4e987896c721f753, (v) => $13e900ab202aea44$export$4e987896c721f753 = v);
var $13e900ab202aea44$export$4e987896c721f753;
"use strict";
$13e900ab202aea44$export$4e987896c721f753 = $13e900ab202aea44$var$isThisISOWeek;


/**
 * @name isThisISOWeek
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this ISO week
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * const result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */ function $13e900ab202aea44$var$isThisISOWeek(date) {
    return (0, $2f828403128a4c50$export$1c6e74e3c7b27764)(date, (0, $d8623e255497753b$export$18c3c6510fb97afc)(date));
}


Object.keys($13e900ab202aea44$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $13e900ab202aea44$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $13e900ab202aea44$exports[key];
        }
    });
});
var $11c5b8927d0f9212$exports = {};

$parcel$export($11c5b8927d0f9212$exports, "isThisMinute", () => $11c5b8927d0f9212$export$fa55b7d29d8d957a, (v) => $11c5b8927d0f9212$export$fa55b7d29d8d957a = v);
var $11c5b8927d0f9212$export$fa55b7d29d8d957a;
"use strict";
$11c5b8927d0f9212$export$fa55b7d29d8d957a = $11c5b8927d0f9212$var$isThisMinute;


/**
 * @name isThisMinute
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * const result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */ function $11c5b8927d0f9212$var$isThisMinute(date) {
    return (0, $dcee691fa8b5c110$export$5d274bf63c8705cb)(date, (0, $d8623e255497753b$export$18c3c6510fb97afc)(date));
}


Object.keys($11c5b8927d0f9212$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $11c5b8927d0f9212$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $11c5b8927d0f9212$exports[key];
        }
    });
});
var $a513a065f29b721f$exports = {};

$parcel$export($a513a065f29b721f$exports, "isThisMonth", () => $a513a065f29b721f$export$173f1e1d92847276, (v) => $a513a065f29b721f$export$173f1e1d92847276 = v);
var $a513a065f29b721f$export$173f1e1d92847276;
"use strict";
$a513a065f29b721f$export$173f1e1d92847276 = $a513a065f29b721f$var$isThisMonth;


/**
 * @name isThisMonth
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * const result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */ function $a513a065f29b721f$var$isThisMonth(date) {
    return (0, $06e3609fc2fbc2e2$export$a18c89cbd24170ff)(date, (0, $d8623e255497753b$export$18c3c6510fb97afc)(date));
}


Object.keys($a513a065f29b721f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a513a065f29b721f$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a513a065f29b721f$exports[key];
        }
    });
});
var $7b97fc1be12623a5$exports = {};

$parcel$export($7b97fc1be12623a5$exports, "isThisQuarter", () => $7b97fc1be12623a5$export$3d88fd18ab599ccc, (v) => $7b97fc1be12623a5$export$3d88fd18ab599ccc = v);
var $7b97fc1be12623a5$export$3d88fd18ab599ccc;
"use strict";
$7b97fc1be12623a5$export$3d88fd18ab599ccc = $7b97fc1be12623a5$var$isThisQuarter;


/**
 * @name isThisQuarter
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * const result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */ function $7b97fc1be12623a5$var$isThisQuarter(date) {
    return (0, $b059a7637303f908$export$5c60e4190867161c)(date, (0, $d8623e255497753b$export$18c3c6510fb97afc)(date));
}


Object.keys($7b97fc1be12623a5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $7b97fc1be12623a5$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $7b97fc1be12623a5$exports[key];
        }
    });
});
var $c12a26020747be23$exports = {};

$parcel$export($c12a26020747be23$exports, "isThisSecond", () => $c12a26020747be23$export$8d7059b5bca087e6, (v) => $c12a26020747be23$export$8d7059b5bca087e6 = v);
var $c12a26020747be23$export$8d7059b5bca087e6;
"use strict";
$c12a26020747be23$export$8d7059b5bca087e6 = $c12a26020747be23$var$isThisSecond;


/**
 * @name isThisSecond
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this second
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * const result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */ function $c12a26020747be23$var$isThisSecond(date) {
    return (0, $af3916f9a5384d82$export$b88fbcfe038f3498)(date, (0, $d8623e255497753b$export$18c3c6510fb97afc)(date));
}


Object.keys($c12a26020747be23$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c12a26020747be23$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c12a26020747be23$exports[key];
        }
    });
});
var $def5a9154a6fce3c$exports = {};

$parcel$export($def5a9154a6fce3c$exports, "isThisWeek", () => $def5a9154a6fce3c$export$cfe4b66a69cdd8a, (v) => $def5a9154a6fce3c$export$cfe4b66a69cdd8a = v);
var $def5a9154a6fce3c$export$cfe4b66a69cdd8a;
"use strict";
$def5a9154a6fce3c$export$cfe4b66a69cdd8a = $def5a9154a6fce3c$var$isThisWeek;


/**
 * The {@link isThisWeek} function options.
 */ /**
 * @name isThisWeek
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param options - The object with options
 *
 * @returns The date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
 * //=> false
 */ function $def5a9154a6fce3c$var$isThisWeek(date, options) {
    return (0, $4398e052cc63a087$export$6ea683876c36b8d2)(date, (0, $d8623e255497753b$export$18c3c6510fb97afc)(date), options);
}


Object.keys($def5a9154a6fce3c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $def5a9154a6fce3c$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $def5a9154a6fce3c$exports[key];
        }
    });
});
var $0a1172148c7ecca3$exports = {};

$parcel$export($0a1172148c7ecca3$exports, "isThisYear", () => $0a1172148c7ecca3$export$a28c94941893a5ac, (v) => $0a1172148c7ecca3$export$a28c94941893a5ac = v);
var $0a1172148c7ecca3$export$a28c94941893a5ac;
"use strict";
$0a1172148c7ecca3$export$a28c94941893a5ac = $0a1172148c7ecca3$var$isThisYear;


/**
 * @name isThisYear
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * const result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */ function $0a1172148c7ecca3$var$isThisYear(date) {
    return (0, $a4f3c61641c4093b$export$5841f9eb9773f25f)(date, (0, $d8623e255497753b$export$18c3c6510fb97afc)(date));
}


Object.keys($0a1172148c7ecca3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $0a1172148c7ecca3$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $0a1172148c7ecca3$exports[key];
        }
    });
});
var $2a3ba7018817a2a8$exports = {};

$parcel$export($2a3ba7018817a2a8$exports, "isThursday", () => $2a3ba7018817a2a8$export$c8e7c906983ea347, (v) => $2a3ba7018817a2a8$export$c8e7c906983ea347 = v);
var $2a3ba7018817a2a8$export$c8e7c906983ea347;
"use strict";
$2a3ba7018817a2a8$export$c8e7c906983ea347 = $2a3ba7018817a2a8$var$isThursday;

/**
 * @name isThursday
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Thursday
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * const result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */ function $2a3ba7018817a2a8$var$isThursday(date) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date).getDay() === 4;
}


Object.keys($2a3ba7018817a2a8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $2a3ba7018817a2a8$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $2a3ba7018817a2a8$exports[key];
        }
    });
});
var $f574f3f9c5879b15$exports = {};

$parcel$export($f574f3f9c5879b15$exports, "isToday", () => $f574f3f9c5879b15$export$629b0a497aa65267, (v) => $f574f3f9c5879b15$export$629b0a497aa65267 = v);
var $f574f3f9c5879b15$export$629b0a497aa65267;
"use strict";
$f574f3f9c5879b15$export$629b0a497aa65267 = $f574f3f9c5879b15$var$isToday;


/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * const result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */ function $f574f3f9c5879b15$var$isToday(date) {
    return (0, $27a7db21eafd685b$export$ea39ec197993aef0)(date, (0, $d8623e255497753b$export$18c3c6510fb97afc)(date));
}


Object.keys($f574f3f9c5879b15$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $f574f3f9c5879b15$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $f574f3f9c5879b15$exports[key];
        }
    });
});
var $85ced2fb3637e354$exports = {};

$parcel$export($85ced2fb3637e354$exports, "isTomorrow", () => $85ced2fb3637e354$export$d6365ba92f0647f1, (v) => $85ced2fb3637e354$export$d6365ba92f0647f1 = v);
var $85ced2fb3637e354$export$d6365ba92f0647f1;
"use strict";
$85ced2fb3637e354$export$d6365ba92f0647f1 = $85ced2fb3637e354$var$isTomorrow;



/**
 * @name isTomorrow
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 * @pure false
 *
 * @description
 * Is the given date tomorrow?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is tomorrow
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * const result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */ function $85ced2fb3637e354$var$isTomorrow(date) {
    return (0, $27a7db21eafd685b$export$ea39ec197993aef0)(date, (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)((0, $d8623e255497753b$export$18c3c6510fb97afc)(date), 1));
}


Object.keys($85ced2fb3637e354$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $85ced2fb3637e354$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $85ced2fb3637e354$exports[key];
        }
    });
});
var $909cc556808367c9$exports = {};

$parcel$export($909cc556808367c9$exports, "isTuesday", () => $909cc556808367c9$export$90d50b8f209f5ac3, (v) => $909cc556808367c9$export$90d50b8f209f5ac3 = v);
var $909cc556808367c9$export$90d50b8f209f5ac3;
"use strict";
$909cc556808367c9$export$90d50b8f209f5ac3 = $909cc556808367c9$var$isTuesday;

/**
 * @name isTuesday
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Tuesday
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * const result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */ function $909cc556808367c9$var$isTuesday(date) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date).getDay() === 2;
}


Object.keys($909cc556808367c9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $909cc556808367c9$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $909cc556808367c9$exports[key];
        }
    });
});

Object.keys($f2a682b251363bc2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $f2a682b251363bc2$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $f2a682b251363bc2$exports[key];
        }
    });
});
var $300bf3048a829507$exports = {};

$parcel$export($300bf3048a829507$exports, "isWednesday", () => $300bf3048a829507$export$ec9de642cdd62944, (v) => $300bf3048a829507$export$ec9de642cdd62944 = v);
var $300bf3048a829507$export$ec9de642cdd62944;
"use strict";
$300bf3048a829507$export$ec9de642cdd62944 = $300bf3048a829507$var$isWednesday;

/**
 * @name isWednesday
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Wednesday
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * const result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */ function $300bf3048a829507$var$isWednesday(date) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date).getDay() === 3;
}


Object.keys($300bf3048a829507$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $300bf3048a829507$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $300bf3048a829507$exports[key];
        }
    });
});

Object.keys($126e0ee47695e680$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $126e0ee47695e680$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $126e0ee47695e680$exports[key];
        }
    });
});
var $9e26b76e988d89a9$exports = {};

$parcel$export($9e26b76e988d89a9$exports, "isWithinInterval", () => $9e26b76e988d89a9$export$d7deef7a3738e19d, (v) => $9e26b76e988d89a9$export$d7deef7a3738e19d = v);
var $9e26b76e988d89a9$export$d7deef7a3738e19d;
"use strict";
$9e26b76e988d89a9$export$d7deef7a3738e19d = $9e26b76e988d89a9$var$isWithinInterval;

/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param interval - The interval to check
 *
 * @returns The date is within the interval
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date })
 * // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end })
 * // => true
 */ function $9e26b76e988d89a9$var$isWithinInterval(date, interval) {
    const time = +(0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const [startTime, endTime] = [
        +(0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.start),
        +(0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.end)
    ].sort((a, b)=>a - b);
    return time >= startTime && time <= endTime;
}


Object.keys($9e26b76e988d89a9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $9e26b76e988d89a9$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $9e26b76e988d89a9$exports[key];
        }
    });
});
var $01ed96ff4a2923d1$exports = {};

$parcel$export($01ed96ff4a2923d1$exports, "isYesterday", () => $01ed96ff4a2923d1$export$221990270ebfe867, (v) => $01ed96ff4a2923d1$export$221990270ebfe867 = v);
var $01ed96ff4a2923d1$export$221990270ebfe867;
"use strict";
$01ed96ff4a2923d1$export$221990270ebfe867 = $01ed96ff4a2923d1$var$isYesterday;


var $43790e1a97254ab3$exports = {};

$parcel$export($43790e1a97254ab3$exports, "subDays", () => $43790e1a97254ab3$export$70823084e2deb1ea, (v) => $43790e1a97254ab3$export$70823084e2deb1ea = v);
var $43790e1a97254ab3$export$70823084e2deb1ea;
"use strict";
$43790e1a97254ab3$export$70823084e2deb1ea = $43790e1a97254ab3$var$subDays;

/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be subtracted.
 *
 * @returns The new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */ function $43790e1a97254ab3$var$subDays(date, amount) {
    return (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(date, -amount);
}


/**
 * @name isYesterday
 * @category Day Helpers
 * @summary Is the given date yesterday?
 * @pure false
 *
 * @description
 * Is the given date yesterday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * const result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */ function $01ed96ff4a2923d1$var$isYesterday(date) {
    return (0, $27a7db21eafd685b$export$ea39ec197993aef0)(date, (0, $43790e1a97254ab3$export$70823084e2deb1ea)((0, $d8623e255497753b$export$18c3c6510fb97afc)(date), 1));
}


Object.keys($01ed96ff4a2923d1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $01ed96ff4a2923d1$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $01ed96ff4a2923d1$exports[key];
        }
    });
});
var $60824d27a7e05259$exports = {};

$parcel$export($60824d27a7e05259$exports, "lastDayOfDecade", () => $60824d27a7e05259$export$2aaf6241f57dd605, (v) => $60824d27a7e05259$export$2aaf6241f57dd605 = v);
var $60824d27a7e05259$export$2aaf6241f57dd605;
"use strict";
$60824d27a7e05259$export$2aaf6241f57dd605 = $60824d27a7e05259$var$lastDayOfDecade;

/**
 * @name lastDayOfDecade
 * @category Decade Helpers
 * @summary Return the last day of a decade for the given date.
 *
 * @description
 * Return the last day of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a decade
 *
 * @example
 * // The last day of a decade for 21 December 2012 21:12:00:
 * const result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
 * //=> Wed Dec 31 2019 00:00:00
 */ function $60824d27a7e05259$var$lastDayOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const decade = 9 + Math.floor(year / 10) * 10;
    _date.setFullYear(decade + 1, 0, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


Object.keys($60824d27a7e05259$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $60824d27a7e05259$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $60824d27a7e05259$exports[key];
        }
    });
});
var $33b9d09203a4d772$exports = {};

$parcel$export($33b9d09203a4d772$exports, "lastDayOfISOWeek", () => $33b9d09203a4d772$export$b08a8fc26ae6d94b, (v) => $33b9d09203a4d772$export$b08a8fc26ae6d94b = v);
var $33b9d09203a4d772$export$b08a8fc26ae6d94b;
"use strict";
$33b9d09203a4d772$export$b08a8fc26ae6d94b = $33b9d09203a4d772$var$lastDayOfISOWeek;
var $c99e3df3cf1d9686$exports = {};

$parcel$export($c99e3df3cf1d9686$exports, "lastDayOfWeek", () => $c99e3df3cf1d9686$export$b73502c35a293b0a, (v) => $c99e3df3cf1d9686$export$b73502c35a293b0a = v);
var $c99e3df3cf1d9686$export$b73502c35a293b0a;
"use strict";
$c99e3df3cf1d9686$export$b73502c35a293b0a = $c99e3df3cf1d9686$var$lastDayOfWeek;


/**
 * The {@link lastDayOfWeek} function options.
 */ /**
 * @name lastDayOfWeek
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The last day of a week
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function $c99e3df3cf1d9686$var$lastDayOfWeek(date, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setHours(0, 0, 0, 0);
    _date.setDate(_date.getDate() + diff);
    return _date;
}


/**
 * @name lastDayOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of an ISO week
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * const result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */ function $33b9d09203a4d772$var$lastDayOfISOWeek(date) {
    return (0, $c99e3df3cf1d9686$export$b73502c35a293b0a)(date, {
        weekStartsOn: 1
    });
}


Object.keys($33b9d09203a4d772$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $33b9d09203a4d772$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $33b9d09203a4d772$exports[key];
        }
    });
});
var $f9abdbe2cf16ca3c$exports = {};

$parcel$export($f9abdbe2cf16ca3c$exports, "lastDayOfISOWeekYear", () => $f9abdbe2cf16ca3c$export$1810bada8cd02ee1, (v) => $f9abdbe2cf16ca3c$export$1810bada8cd02ee1 = v);
var $f9abdbe2cf16ca3c$export$1810bada8cd02ee1;
"use strict";
$f9abdbe2cf16ca3c$export$1810bada8cd02ee1 = $f9abdbe2cf16ca3c$var$lastDayOfISOWeekYear;



/**
 * @name lastDayOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * const result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */ function $f9abdbe2cf16ca3c$var$lastDayOfISOWeekYear(date) {
    const year = (0, $c95dff76bf2f692a$export$3dbc52535f6f8fcc)(date);
    const fourthOfJanuary = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
    fourthOfJanuary.setFullYear(year + 1, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    const _date = (0, $1c9d32c6cb108460$export$6173213f95a4431e)(fourthOfJanuary);
    _date.setDate(_date.getDate() - 1);
    return _date;
}


Object.keys($f9abdbe2cf16ca3c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $f9abdbe2cf16ca3c$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $f9abdbe2cf16ca3c$exports[key];
        }
    });
});

Object.keys($b94cbd258d877bc8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $b94cbd258d877bc8$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $b94cbd258d877bc8$exports[key];
        }
    });
});
var $b03274799f21cdd8$exports = {};

$parcel$export($b03274799f21cdd8$exports, "lastDayOfQuarter", () => $b03274799f21cdd8$export$8693c04228304c7, (v) => $b03274799f21cdd8$export$8693c04228304c7 = v);
var $b03274799f21cdd8$export$8693c04228304c7;
"use strict";
$b03274799f21cdd8$export$8693c04228304c7 = $b03274799f21cdd8$var$lastDayOfQuarter;

/**
 * @name lastDayOfQuarter
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a quarter
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * const result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ function $b03274799f21cdd8$var$lastDayOfQuarter(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


Object.keys($b03274799f21cdd8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $b03274799f21cdd8$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $b03274799f21cdd8$exports[key];
        }
    });
});

Object.keys($c99e3df3cf1d9686$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c99e3df3cf1d9686$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c99e3df3cf1d9686$exports[key];
        }
    });
});
var $46e16c3d8313f406$exports = {};

$parcel$export($46e16c3d8313f406$exports, "lastDayOfYear", () => $46e16c3d8313f406$export$323f7bc07b828bed, (v) => $46e16c3d8313f406$export$323f7bc07b828bed = v);
var $46e16c3d8313f406$export$323f7bc07b828bed;
"use strict";
$46e16c3d8313f406$export$323f7bc07b828bed = $46e16c3d8313f406$var$lastDayOfYear;

/**
 * @name lastDayOfYear
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a year
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * const result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */ function $46e16c3d8313f406$var$lastDayOfYear(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


Object.keys($46e16c3d8313f406$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $46e16c3d8313f406$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $46e16c3d8313f406$exports[key];
        }
    });
});
var $ce37c5e4ac88a02b$exports = {};
"use strict";
$ce37c5e4ac88a02b$exports.lightFormat = $ce37c5e4ac88a02b$var$lightFormat;
Object.defineProperty($ce37c5e4ac88a02b$exports, "lightFormatters", {
    enumerable: true,
    get: function() {
        return $71a5e81f1193b7a8$export$b0d4b338e1516f13;
    }
});



// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $ce37c5e4ac88a02b$var$formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
const $ce37c5e4ac88a02b$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $ce37c5e4ac88a02b$var$doubleQuoteRegExp = /''/g;
const $ce37c5e4ac88a02b$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @private
 */ /**
 * @name lightFormat
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. Unlike `format`,
 * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
 *
 * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   |
 * |---------------------------------|---------|-----------------------------------|
 * | AM, PM                          | a..aaa  | AM, PM                            |
 * |                                 | aaaa    | a.m., p.m.                        |
 * |                                 | aaaaa   | a, p                              |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
 * |                                 | yy      | 44, 01, 00, 17                    |
 * |                                 | yyy     | 044, 001, 000, 017                |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |
 * |                                 | MM      | 01, 02, ..., 12                   |
 * | Day of month                    | d       | 1, 2, ..., 31                     |
 * |                                 | dd      | 01, 02, ..., 31                   |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
 * |                                 | hh      | 01, 02, ..., 11, 12               |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
 * |                                 | HH      | 00, 01, 02, ..., 23               |
 * | Minute                          | m       | 0, 1, ..., 59                     |
 * |                                 | mm      | 00, 01, ..., 59                   |
 * | Second                          | s       | 0, 1, ..., 59                     |
 * |                                 | ss      | 00, 01, ..., 59                   |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |
 * |                                 | SS      | 00, 01, ..., 99                   |
 * |                                 | SSS     | 000, 001, ..., 999                |
 * |                                 | SSSS    | ...                               |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 *
 * @returns The formatted date string
 *
 * @throws `Invalid time value` if the date is invalid
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * const result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
 * //=> '2014-02-11'
 */ function $ce37c5e4ac88a02b$var$lightFormat(date, formatStr) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    if (!(0, $f2a682b251363bc2$export$1ea939691cdc45b8)(_date)) throw new RangeError("Invalid time value");
    const tokens = formatStr.match($ce37c5e4ac88a02b$var$formattingTokensRegExp);
    // The only case when formattingTokensRegExp doesn't match the string is when it's empty
    if (!tokens) return "";
    const result = tokens.map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return $ce37c5e4ac88a02b$var$cleanEscapedString(substring);
        const formatter = $71a5e81f1193b7a8$export$b0d4b338e1516f13[firstCharacter];
        if (formatter) return formatter(_date, substring);
        if (firstCharacter.match($ce37c5e4ac88a02b$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $ce37c5e4ac88a02b$var$cleanEscapedString(input) {
    const matches = input.match($ce37c5e4ac88a02b$var$escapedStringRegExp);
    if (!matches) return input;
    return matches[1].replace($ce37c5e4ac88a02b$var$doubleQuoteRegExp, "'");
}


Object.keys($ce37c5e4ac88a02b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $ce37c5e4ac88a02b$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $ce37c5e4ac88a02b$exports[key];
        }
    });
});

Object.keys($b70baca84fc92b6d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $b70baca84fc92b6d$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $b70baca84fc92b6d$exports[key];
        }
    });
});
var $97b365a16a43d25e$exports = {};

$parcel$export($97b365a16a43d25e$exports, "milliseconds", () => $97b365a16a43d25e$export$9a27fac83d67afd3, (v) => $97b365a16a43d25e$export$9a27fac83d67afd3 = v);
var $97b365a16a43d25e$export$9a27fac83d67afd3;
"use strict";
$97b365a16a43d25e$export$9a27fac83d67afd3 = $97b365a16a43d25e$var$milliseconds;

/**
 * @name milliseconds
 * @category Millisecond Helpers
 * @summary
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * @description
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * One month is a year divided by 12.
 *
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * @returns The milliseconds
 *
 * @example
 * // 1 year in milliseconds
 * milliseconds({ years: 1 })
 * //=> 31556952000
 *
 * // 3 months in milliseconds
 * milliseconds({ months: 3 })
 * //=> 7889238000
 */ function $97b365a16a43d25e$var$milliseconds({ years: years, months: months, weeks: weeks, days: days, hours: hours, minutes: minutes, seconds: seconds }) {
    let totalDays = 0;
    if (years) totalDays += years * $8540a44f59a4af84$export$3913210603d8e9ae;
    if (months) totalDays += months * ($8540a44f59a4af84$export$3913210603d8e9ae / 12);
    if (weeks) totalDays += weeks * 7;
    if (days) totalDays += days;
    let totalSeconds = totalDays * 86400;
    if (hours) totalSeconds += hours * 3600;
    if (minutes) totalSeconds += minutes * 60;
    if (seconds) totalSeconds += seconds;
    return Math.trunc(totalSeconds * 1000);
}


Object.keys($97b365a16a43d25e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $97b365a16a43d25e$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $97b365a16a43d25e$exports[key];
        }
    });
});
var $a89c280122b57cc6$exports = {};

$parcel$export($a89c280122b57cc6$exports, "millisecondsToHours", () => $a89c280122b57cc6$export$689a412b29fa9ed5, (v) => $a89c280122b57cc6$export$689a412b29fa9ed5 = v);
var $a89c280122b57cc6$export$689a412b29fa9ed5;
"use strict";
$a89c280122b57cc6$export$689a412b29fa9ed5 = $a89c280122b57cc6$var$millisecondsToHours;

/**
 * @name millisecondsToHours
 * @category Conversion Helpers
 * @summary Convert milliseconds to hours.
 *
 * @description
 * Convert a number of milliseconds to a full number of hours.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in hours
 *
 * @example
 * // Convert 7200000 milliseconds to hours:
 * const result = millisecondsToHours(7200000)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToHours(7199999)
 * //=> 1
 */ function $a89c280122b57cc6$var$millisecondsToHours(milliseconds) {
    const hours = milliseconds / $8540a44f59a4af84$export$7f72910d6dfd237a;
    return Math.trunc(hours);
}


Object.keys($a89c280122b57cc6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a89c280122b57cc6$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a89c280122b57cc6$exports[key];
        }
    });
});
var $9625f295f3161b5c$exports = {};

$parcel$export($9625f295f3161b5c$exports, "millisecondsToMinutes", () => $9625f295f3161b5c$export$a5f974e81e48cfc0, (v) => $9625f295f3161b5c$export$a5f974e81e48cfc0 = v);
var $9625f295f3161b5c$export$a5f974e81e48cfc0;
"use strict";
$9625f295f3161b5c$export$a5f974e81e48cfc0 = $9625f295f3161b5c$var$millisecondsToMinutes;

/**
 * @name millisecondsToMinutes
 * @category Conversion Helpers
 * @summary Convert milliseconds to minutes.
 *
 * @description
 * Convert a number of milliseconds to a full number of minutes.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in minutes
 *
 * @example
 * // Convert 60000 milliseconds to minutes:
 * const result = millisecondsToMinutes(60000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToMinutes(119999)
 * //=> 1
 */ function $9625f295f3161b5c$var$millisecondsToMinutes(milliseconds) {
    const minutes = milliseconds / $8540a44f59a4af84$export$91246f0b9bd9beff;
    return Math.trunc(minutes);
}


Object.keys($9625f295f3161b5c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $9625f295f3161b5c$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $9625f295f3161b5c$exports[key];
        }
    });
});
var $b31d11994e596a58$exports = {};

$parcel$export($b31d11994e596a58$exports, "millisecondsToSeconds", () => $b31d11994e596a58$export$f64c3bfbc58eec0f, (v) => $b31d11994e596a58$export$f64c3bfbc58eec0f = v);
var $b31d11994e596a58$export$f64c3bfbc58eec0f;
"use strict";
$b31d11994e596a58$export$f64c3bfbc58eec0f = $b31d11994e596a58$var$millisecondsToSeconds;

/**
 * @name millisecondsToSeconds
 * @category Conversion Helpers
 * @summary Convert milliseconds to seconds.
 *
 * @description
 * Convert a number of milliseconds to a full number of seconds.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in seconds
 *
 * @example
 * // Convert 1000 miliseconds to seconds:
 * const result = millisecondsToSeconds(1000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToSeconds(1999)
 * //=> 1
 */ function $b31d11994e596a58$var$millisecondsToSeconds(milliseconds) {
    const seconds = milliseconds / $8540a44f59a4af84$export$397c2d5776aa9055;
    return Math.trunc(seconds);
}


Object.keys($b31d11994e596a58$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $b31d11994e596a58$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $b31d11994e596a58$exports[key];
        }
    });
});

Object.keys($5d373ce01680b655$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $5d373ce01680b655$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $5d373ce01680b655$exports[key];
        }
    });
});
var $56f58edd96e5b9ca$exports = {};

$parcel$export($56f58edd96e5b9ca$exports, "minutesToHours", () => $56f58edd96e5b9ca$export$815164eb42530ae7, (v) => $56f58edd96e5b9ca$export$815164eb42530ae7 = v);
var $56f58edd96e5b9ca$export$815164eb42530ae7;
"use strict";
$56f58edd96e5b9ca$export$815164eb42530ae7 = $56f58edd96e5b9ca$var$minutesToHours;

/**
 * @name minutesToHours
 * @category Conversion Helpers
 * @summary Convert minutes to hours.
 *
 * @description
 * Convert a number of minutes to a full number of hours.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in hours
 *
 * @example
 * // Convert 140 minutes to hours:
 * const result = minutesToHours(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = minutesToHours(179)
 * //=> 2
 */ function $56f58edd96e5b9ca$var$minutesToHours(minutes) {
    const hours = minutes / $8540a44f59a4af84$export$f2f5ae5a8e2d8f9f;
    return Math.trunc(hours);
}


Object.keys($56f58edd96e5b9ca$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $56f58edd96e5b9ca$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $56f58edd96e5b9ca$exports[key];
        }
    });
});
var $0ad299455c4a7bce$exports = {};

$parcel$export($0ad299455c4a7bce$exports, "minutesToMilliseconds", () => $0ad299455c4a7bce$export$f6b9795ef9056e3d, (v) => $0ad299455c4a7bce$export$f6b9795ef9056e3d = v);
var $0ad299455c4a7bce$export$f6b9795ef9056e3d;
"use strict";
$0ad299455c4a7bce$export$f6b9795ef9056e3d = $0ad299455c4a7bce$var$minutesToMilliseconds;

/**
 * @name minutesToMilliseconds
 * @category Conversion Helpers
 * @summary Convert minutes to milliseconds.
 *
 * @description
 * Convert a number of minutes to a full number of milliseconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in milliseconds
 *
 * @example
 * // Convert 2 minutes to milliseconds
 * const result = minutesToMilliseconds(2)
 * //=> 120000
 */ function $0ad299455c4a7bce$var$minutesToMilliseconds(minutes) {
    return Math.trunc(minutes * $8540a44f59a4af84$export$91246f0b9bd9beff);
}


Object.keys($0ad299455c4a7bce$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $0ad299455c4a7bce$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $0ad299455c4a7bce$exports[key];
        }
    });
});
var $94c410dcdc963b83$exports = {};

$parcel$export($94c410dcdc963b83$exports, "minutesToSeconds", () => $94c410dcdc963b83$export$81ded4628c655103, (v) => $94c410dcdc963b83$export$81ded4628c655103 = v);
var $94c410dcdc963b83$export$81ded4628c655103;
"use strict";
$94c410dcdc963b83$export$81ded4628c655103 = $94c410dcdc963b83$var$minutesToSeconds;

/**
 * @name minutesToSeconds
 * @category Conversion Helpers
 * @summary Convert minutes to seconds.
 *
 * @description
 * Convert a number of minutes to a full number of seconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in seconds
 *
 * @example
 * // Convert 2 minutes to seconds
 * const result = minutesToSeconds(2)
 * //=> 120
 */ function $94c410dcdc963b83$var$minutesToSeconds(minutes) {
    return Math.trunc(minutes * $8540a44f59a4af84$export$a77c1a7ebebe2a5a);
}


Object.keys($94c410dcdc963b83$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $94c410dcdc963b83$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $94c410dcdc963b83$exports[key];
        }
    });
});
var $6cef6af716faa10c$exports = {};

$parcel$export($6cef6af716faa10c$exports, "monthsToQuarters", () => $6cef6af716faa10c$export$1932fa2a2068c849, (v) => $6cef6af716faa10c$export$1932fa2a2068c849 = v);
var $6cef6af716faa10c$export$1932fa2a2068c849;
"use strict";
$6cef6af716faa10c$export$1932fa2a2068c849 = $6cef6af716faa10c$var$monthsToQuarters;

/**
 * @name monthsToQuarters
 * @category Conversion Helpers
 * @summary Convert number of months to quarters.
 *
 * @description
 * Convert a number of months to a full number of quarters.
 *
 * @param months - The number of months to be converted.
 *
 * @returns The number of months converted in quarters
 *
 * @example
 * // Convert 6 months to quarters:
 * const result = monthsToQuarters(6)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = monthsToQuarters(7)
 * //=> 2
 */ function $6cef6af716faa10c$var$monthsToQuarters(months) {
    const quarters = months / $8540a44f59a4af84$export$3c58128db900d44e;
    return Math.trunc(quarters);
}


Object.keys($6cef6af716faa10c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $6cef6af716faa10c$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $6cef6af716faa10c$exports[key];
        }
    });
});
var $7d031190fd4018fe$exports = {};

$parcel$export($7d031190fd4018fe$exports, "monthsToYears", () => $7d031190fd4018fe$export$7489026ed27fc925, (v) => $7d031190fd4018fe$export$7489026ed27fc925 = v);
var $7d031190fd4018fe$export$7489026ed27fc925;
"use strict";
$7d031190fd4018fe$export$7489026ed27fc925 = $7d031190fd4018fe$var$monthsToYears;

/**
 * @name monthsToYears
 * @category Conversion Helpers
 * @summary Convert number of months to years.
 *
 * @description
 * Convert a number of months to a full number of years.
 *
 * @param months - The number of months to be converted
 *
 * @returns The number of months converted in years
 *
 * @example
 * // Convert 36 months to years:
 * const result = monthsToYears(36)
 * //=> 3
 *
 * // It uses floor rounding:
 * const result = monthsToYears(40)
 * //=> 3
 */ function $7d031190fd4018fe$var$monthsToYears(months) {
    const years = months / $8540a44f59a4af84$export$80d7e435f744f319;
    return Math.trunc(years);
}


Object.keys($7d031190fd4018fe$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $7d031190fd4018fe$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $7d031190fd4018fe$exports[key];
        }
    });
});
var $9f521a390e94151b$exports = {};

$parcel$export($9f521a390e94151b$exports, "nextDay", () => $9f521a390e94151b$export$992728922317ffc8, (v) => $9f521a390e94151b$export$992728922317ffc8 = v);
var $9f521a390e94151b$export$992728922317ffc8;
"use strict";
$9f521a390e94151b$export$992728922317ffc8 = $9f521a390e94151b$var$nextDay;


/**
 * @name nextDay
 * @category Weekday Helpers
 * @summary When is the next day of the week?
 *
 * @description
 * When is the next day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - day of the week
 *
 * @returns The date is the next day of week
 *
 * @example
 * // When is the next Monday after Mar, 20, 2020?
 * const result = nextDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 23 2020 00:00:00
 *
 * @example
 * // When is the next Tuesday after Mar, 21, 2020?
 * const result = nextDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 24 2020 00:00:00
 */ function $9f521a390e94151b$var$nextDay(date, day) {
    let delta = day - (0, $bd335e725902b989$export$1b64bc9c5306ed54)(date);
    if (delta <= 0) delta += 7;
    return (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(date, delta);
}


Object.keys($9f521a390e94151b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $9f521a390e94151b$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $9f521a390e94151b$exports[key];
        }
    });
});
var $bcfba8e94342fc2c$exports = {};

$parcel$export($bcfba8e94342fc2c$exports, "nextFriday", () => $bcfba8e94342fc2c$export$21d76934fce76327, (v) => $bcfba8e94342fc2c$export$21d76934fce76327 = v);
var $bcfba8e94342fc2c$export$21d76934fce76327;
"use strict";
$bcfba8e94342fc2c$export$21d76934fce76327 = $bcfba8e94342fc2c$var$nextFriday;

/**
 * @name nextFriday
 * @category Weekday Helpers
 * @summary When is the next Friday?
 *
 * @description
 * When is the next Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Friday
 *
 * @example
 * // When is the next Friday after Mar, 22, 2020?
 * const result = nextFriday(new Date(2020, 2, 22))
 * //=> Fri Mar 27 2020 00:00:00
 */ function $bcfba8e94342fc2c$var$nextFriday(date) {
    return (0, $9f521a390e94151b$export$992728922317ffc8)(date, 5);
}


Object.keys($bcfba8e94342fc2c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $bcfba8e94342fc2c$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $bcfba8e94342fc2c$exports[key];
        }
    });
});
var $c6f29a2a1ec58e88$exports = {};

$parcel$export($c6f29a2a1ec58e88$exports, "nextMonday", () => $c6f29a2a1ec58e88$export$a20373bb0df6efdd, (v) => $c6f29a2a1ec58e88$export$a20373bb0df6efdd = v);
var $c6f29a2a1ec58e88$export$a20373bb0df6efdd;
"use strict";
$c6f29a2a1ec58e88$export$a20373bb0df6efdd = $c6f29a2a1ec58e88$var$nextMonday;

/**
 * @name nextMonday
 * @category Weekday Helpers
 * @summary When is the next Monday?
 *
 * @description
 * When is the next Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Monday
 *
 * @example
 * // When is the next Monday after Mar, 22, 2020?
 * const result = nextMonday(new Date(2020, 2, 22))
 * //=> Mon Mar 23 2020 00:00:00
 */ function $c6f29a2a1ec58e88$var$nextMonday(date) {
    return (0, $9f521a390e94151b$export$992728922317ffc8)(date, 1);
}


Object.keys($c6f29a2a1ec58e88$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c6f29a2a1ec58e88$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c6f29a2a1ec58e88$exports[key];
        }
    });
});
var $4d0e39fd7f19b345$exports = {};

$parcel$export($4d0e39fd7f19b345$exports, "nextSaturday", () => $4d0e39fd7f19b345$export$c52f069246f7b032, (v) => $4d0e39fd7f19b345$export$c52f069246f7b032 = v);
var $4d0e39fd7f19b345$export$c52f069246f7b032;
"use strict";
$4d0e39fd7f19b345$export$c52f069246f7b032 = $4d0e39fd7f19b345$var$nextSaturday;

/**
 * @name nextSaturday
 * @category Weekday Helpers
 * @summary When is the next Saturday?
 *
 * @description
 * When is the next Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Saturday
 *
 * @example
 * // When is the next Saturday after Mar, 22, 2020?
 * const result = nextSaturday(new Date(2020, 2, 22))
 * //=> Sat Mar 28 2020 00:00:00
 */ function $4d0e39fd7f19b345$var$nextSaturday(date) {
    return (0, $9f521a390e94151b$export$992728922317ffc8)(date, 6);
}


Object.keys($4d0e39fd7f19b345$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $4d0e39fd7f19b345$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $4d0e39fd7f19b345$exports[key];
        }
    });
});
var $758840c198612cbb$exports = {};

$parcel$export($758840c198612cbb$exports, "nextSunday", () => $758840c198612cbb$export$a30adaa3ef47f854, (v) => $758840c198612cbb$export$a30adaa3ef47f854 = v);
var $758840c198612cbb$export$a30adaa3ef47f854;
"use strict";
$758840c198612cbb$export$a30adaa3ef47f854 = $758840c198612cbb$var$nextSunday;

/**
 * @name nextSunday
 * @category Weekday Helpers
 * @summary When is the next Sunday?
 *
 * @description
 * When is the next Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Sunday
 *
 * @example
 * // When is the next Sunday after Mar, 22, 2020?
 * const result = nextSunday(new Date(2020, 2, 22))
 * //=> Sun Mar 29 2020 00:00:00
 */ function $758840c198612cbb$var$nextSunday(date) {
    return (0, $9f521a390e94151b$export$992728922317ffc8)(date, 0);
}


Object.keys($758840c198612cbb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $758840c198612cbb$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $758840c198612cbb$exports[key];
        }
    });
});
var $cbaf36c74556d9ba$exports = {};

$parcel$export($cbaf36c74556d9ba$exports, "nextThursday", () => $cbaf36c74556d9ba$export$36d9a8523a98d5a4, (v) => $cbaf36c74556d9ba$export$36d9a8523a98d5a4 = v);
var $cbaf36c74556d9ba$export$36d9a8523a98d5a4;
"use strict";
$cbaf36c74556d9ba$export$36d9a8523a98d5a4 = $cbaf36c74556d9ba$var$nextThursday;

/**
 * @name nextThursday
 * @category Weekday Helpers
 * @summary When is the next Thursday?
 *
 * @description
 * When is the next Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Thursday
 *
 * @example
 * // When is the next Thursday after Mar, 22, 2020?
 * const result = nextThursday(new Date(2020, 2, 22))
 * //=> Thur Mar 26 2020 00:00:00
 */ function $cbaf36c74556d9ba$var$nextThursday(date) {
    return (0, $9f521a390e94151b$export$992728922317ffc8)(date, 4);
}


Object.keys($cbaf36c74556d9ba$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $cbaf36c74556d9ba$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $cbaf36c74556d9ba$exports[key];
        }
    });
});
var $2fbef82198987bdb$exports = {};

$parcel$export($2fbef82198987bdb$exports, "nextTuesday", () => $2fbef82198987bdb$export$391d63ff7dc2f668, (v) => $2fbef82198987bdb$export$391d63ff7dc2f668 = v);
var $2fbef82198987bdb$export$391d63ff7dc2f668;
"use strict";
$2fbef82198987bdb$export$391d63ff7dc2f668 = $2fbef82198987bdb$var$nextTuesday;

/**
 * @name nextTuesday
 * @category Weekday Helpers
 * @summary When is the next Tuesday?
 *
 * @description
 * When is the next Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Tuesday
 *
 * @example
 * // When is the next Tuesday after Mar, 22, 2020?
 * const result = nextTuesday(new Date(2020, 2, 22))
 * //=> Tue Mar 24 2020 00:00:00
 */ function $2fbef82198987bdb$var$nextTuesday(date) {
    return (0, $9f521a390e94151b$export$992728922317ffc8)(date, 2);
}


Object.keys($2fbef82198987bdb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $2fbef82198987bdb$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $2fbef82198987bdb$exports[key];
        }
    });
});
var $24bc8105eef6f180$exports = {};

$parcel$export($24bc8105eef6f180$exports, "nextWednesday", () => $24bc8105eef6f180$export$7a895c1ff204304e, (v) => $24bc8105eef6f180$export$7a895c1ff204304e = v);
var $24bc8105eef6f180$export$7a895c1ff204304e;
"use strict";
$24bc8105eef6f180$export$7a895c1ff204304e = $24bc8105eef6f180$var$nextWednesday;

/**
 * @name nextWednesday
 * @category Weekday Helpers
 * @summary When is the next Wednesday?
 *
 * @description
 * When is the next Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Wednesday
 *
 * @example
 * // When is the next Wednesday after Mar, 22, 2020?
 * const result = nextWednesday(new Date(2020, 2, 22))
 * //=> Wed Mar 25 2020 00:00:00
 */ function $24bc8105eef6f180$var$nextWednesday(date) {
    return (0, $9f521a390e94151b$export$992728922317ffc8)(date, 3);
}


Object.keys($24bc8105eef6f180$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $24bc8105eef6f180$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $24bc8105eef6f180$exports[key];
        }
    });
});

Object.keys($8abb93379891fb3e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $8abb93379891fb3e$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $8abb93379891fb3e$exports[key];
        }
    });
});
var $a92bacc669eda25d$exports = {};

$parcel$export($a92bacc669eda25d$exports, "parseISO", () => $a92bacc669eda25d$export$4393d2ccbbedb219, (v) => $a92bacc669eda25d$export$4393d2ccbbedb219 = v);
var $a92bacc669eda25d$export$4393d2ccbbedb219;
"use strict";
$a92bacc669eda25d$export$4393d2ccbbedb219 = $a92bacc669eda25d$var$parseISO;

/**
 * The {@link parseISO} function options.
 */ /**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 * @param options - An object with options
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */ function $a92bacc669eda25d$var$parseISO(argument, options) {
    const additionalDigits = options?.additionalDigits ?? 2;
    const dateStrings = $a92bacc669eda25d$var$splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = $a92bacc669eda25d$var$parseYear(dateStrings.date, additionalDigits);
        date = $a92bacc669eda25d$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    const timestamp = date.getTime();
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = $a92bacc669eda25d$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $a92bacc669eda25d$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        const dirtyDate = new Date(timestamp + time);
        // JS parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        const result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
const $a92bacc669eda25d$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const $a92bacc669eda25d$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const $a92bacc669eda25d$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const $a92bacc669eda25d$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $a92bacc669eda25d$var$splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split($a92bacc669eda25d$var$patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($a92bacc669eda25d$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($a92bacc669eda25d$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = $a92bacc669eda25d$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $a92bacc669eda25d$var$parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $a92bacc669eda25d$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match($a92bacc669eda25d$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = $a92bacc669eda25d$var$parseDateUnit(captures[1]);
    const month = $a92bacc669eda25d$var$parseDateUnit(captures[2]) - 1;
    const day = $a92bacc669eda25d$var$parseDateUnit(captures[3]);
    const week = $a92bacc669eda25d$var$parseDateUnit(captures[4]);
    const dayOfWeek = $a92bacc669eda25d$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$a92bacc669eda25d$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $a92bacc669eda25d$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!$a92bacc669eda25d$var$validateDate(year, month, day) || !$a92bacc669eda25d$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $a92bacc669eda25d$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $a92bacc669eda25d$var$parseTime(timeString) {
    const captures = timeString.match($a92bacc669eda25d$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = $a92bacc669eda25d$var$parseTimeUnit(captures[1]);
    const minutes = $a92bacc669eda25d$var$parseTimeUnit(captures[2]);
    const seconds = $a92bacc669eda25d$var$parseTimeUnit(captures[3]);
    if (!$a92bacc669eda25d$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * $8540a44f59a4af84$export$7f72910d6dfd237a + minutes * $8540a44f59a4af84$export$91246f0b9bd9beff + seconds * 1000;
}
function $a92bacc669eda25d$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $a92bacc669eda25d$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match($a92bacc669eda25d$var$timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$a92bacc669eda25d$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * $8540a44f59a4af84$export$7f72910d6dfd237a + minutes * $8540a44f59a4af84$export$91246f0b9bd9beff);
}
function $a92bacc669eda25d$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const $a92bacc669eda25d$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $a92bacc669eda25d$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $a92bacc669eda25d$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($a92bacc669eda25d$var$daysInMonths[month] || ($a92bacc669eda25d$var$isLeapYearIndex(year) ? 29 : 28));
}
function $a92bacc669eda25d$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($a92bacc669eda25d$var$isLeapYearIndex(year) ? 366 : 365);
}
function $a92bacc669eda25d$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $a92bacc669eda25d$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $a92bacc669eda25d$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}


Object.keys($a92bacc669eda25d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a92bacc669eda25d$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a92bacc669eda25d$exports[key];
        }
    });
});
var $0e33dc44389cd7c6$exports = {};

$parcel$export($0e33dc44389cd7c6$exports, "parseJSON", () => $0e33dc44389cd7c6$export$27924e57e9afff7f, (v) => $0e33dc44389cd7c6$export$27924e57e9afff7f = v);
var $0e33dc44389cd7c6$export$27924e57e9afff7f;
"use strict";
$0e33dc44389cd7c6$export$27924e57e9afff7f = $0e33dc44389cd7c6$var$parseJSON; /**
 * @name parseJSON
 * @category Common Helpers
 * @summary Parse a JSON date string
 *
 * @description
 * Converts a complete ISO date string in UTC time, the typical format for transmitting
 * a date in JSON, to a JavaScript `Date` instance.
 *
 * This is a minimal implementation for converting dates retrieved from a JSON API to
 * a `Date` instance which can be used with other functions in the `date-fns` library.
 * The following formats are supported:
 *
 * - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
 * - `2000-03-15T05:20:10Z`: Without milliseconds
 * - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+05:45`: With a positive or negative offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
 * - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
 * - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
 * - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
 *
 * For convenience and ease of use these other input types are also supported
 * via [toDate](https://date-fns.org/docs/toDate):
 *
 * - A `Date` instance will be cloned
 * - A `number` will be treated as a timestamp
 *
 * Any other input type or invalid date strings will return an `Invalid Date`.
 *
 * @param dateStr - A fully formed ISO8601 date string to convert
 *
 * @returns The parsed date in the local time zone
 */ 
function $0e33dc44389cd7c6$var$parseJSON(dateStr) {
    const parts = dateStr.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
    if (parts) // Group 8 matches the sign
    return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == "-" ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == "-" ? -1 : 1), +parts[6], +((parts[7] || "0") + "00").substring(0, 3)));
    return new Date(NaN);
}


Object.keys($0e33dc44389cd7c6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $0e33dc44389cd7c6$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $0e33dc44389cd7c6$exports[key];
        }
    });
});
var $1bfa1f6b04020399$exports = {};

$parcel$export($1bfa1f6b04020399$exports, "previousDay", () => $1bfa1f6b04020399$export$4caccb62df4eacc0, (v) => $1bfa1f6b04020399$export$4caccb62df4eacc0 = v);
var $1bfa1f6b04020399$export$4caccb62df4eacc0;
"use strict";
$1bfa1f6b04020399$export$4caccb62df4eacc0 = $1bfa1f6b04020399$var$previousDay;


/**
 * @name previousDay
 * @category Weekday Helpers
 * @summary When is the previous day of the week?
 *
 * @description
 * When is the previous day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - The day of the week
 *
 * @returns The date is the previous day of week
 *
 * @example
 * // When is the previous Monday before Mar, 20, 2020?
 * const result = previousDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 16 2020 00:00:00
 *
 * @example
 * // When is the previous Tuesday before Mar, 21, 2020?
 * const result = previousDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 17 2020 00:00:00
 */ function $1bfa1f6b04020399$var$previousDay(date, day) {
    let delta = (0, $bd335e725902b989$export$1b64bc9c5306ed54)(date) - day;
    if (delta <= 0) delta += 7;
    return (0, $43790e1a97254ab3$export$70823084e2deb1ea)(date, delta);
}


Object.keys($1bfa1f6b04020399$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $1bfa1f6b04020399$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $1bfa1f6b04020399$exports[key];
        }
    });
});
var $325dc36aced8b5fa$exports = {};

$parcel$export($325dc36aced8b5fa$exports, "previousFriday", () => $325dc36aced8b5fa$export$32d52646c338c11d, (v) => $325dc36aced8b5fa$export$32d52646c338c11d = v);
var $325dc36aced8b5fa$export$32d52646c338c11d;
"use strict";
$325dc36aced8b5fa$export$32d52646c338c11d = $325dc36aced8b5fa$var$previousFriday;

/**
 * @name previousFriday
 * @category Weekday Helpers
 * @summary When is the previous Friday?
 *
 * @description
 * When is the previous Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Friday
 *
 * @example
 * // When is the previous Friday before Jun, 19, 2021?
 * const result = previousFriday(new Date(2021, 5, 19))
 * //=> Fri June 18 2021 00:00:00
 */ function $325dc36aced8b5fa$var$previousFriday(date) {
    return (0, $1bfa1f6b04020399$export$4caccb62df4eacc0)(date, 5);
}


Object.keys($325dc36aced8b5fa$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $325dc36aced8b5fa$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $325dc36aced8b5fa$exports[key];
        }
    });
});
var $ef6774db45a223ab$exports = {};

$parcel$export($ef6774db45a223ab$exports, "previousMonday", () => $ef6774db45a223ab$export$398437ab6f45c582, (v) => $ef6774db45a223ab$export$398437ab6f45c582 = v);
var $ef6774db45a223ab$export$398437ab6f45c582;
"use strict";
$ef6774db45a223ab$export$398437ab6f45c582 = $ef6774db45a223ab$var$previousMonday;

/**
 * @name previousMonday
 * @category Weekday Helpers
 * @summary When is the previous Monday?
 *
 * @description
 * When is the previous Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Monday
 *
 * @example
 * // When is the previous Monday before Jun, 18, 2021?
 * const result = previousMonday(new Date(2021, 5, 18))
 * //=> Mon June 14 2021 00:00:00
 */ function $ef6774db45a223ab$var$previousMonday(date) {
    return (0, $1bfa1f6b04020399$export$4caccb62df4eacc0)(date, 1);
}


Object.keys($ef6774db45a223ab$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $ef6774db45a223ab$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $ef6774db45a223ab$exports[key];
        }
    });
});
var $95989668dcda1eb0$exports = {};

$parcel$export($95989668dcda1eb0$exports, "previousSaturday", () => $95989668dcda1eb0$export$36767a7e6101ecb0, (v) => $95989668dcda1eb0$export$36767a7e6101ecb0 = v);
var $95989668dcda1eb0$export$36767a7e6101ecb0;
"use strict";
$95989668dcda1eb0$export$36767a7e6101ecb0 = $95989668dcda1eb0$var$previousSaturday;

/**
 * @name previousSaturday
 * @category Weekday Helpers
 * @summary When is the previous Saturday?
 *
 * @description
 * When is the previous Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Saturday
 *
 * @example
 * // When is the previous Saturday before Jun, 20, 2021?
 * const result = previousSaturday(new Date(2021, 5, 20))
 * //=> Sat June 19 2021 00:00:00
 */ function $95989668dcda1eb0$var$previousSaturday(date) {
    return (0, $1bfa1f6b04020399$export$4caccb62df4eacc0)(date, 6);
}


Object.keys($95989668dcda1eb0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $95989668dcda1eb0$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $95989668dcda1eb0$exports[key];
        }
    });
});
var $42fdcdff82108acf$exports = {};

$parcel$export($42fdcdff82108acf$exports, "previousSunday", () => $42fdcdff82108acf$export$7d3d7d8fc5e81fd4, (v) => $42fdcdff82108acf$export$7d3d7d8fc5e81fd4 = v);
var $42fdcdff82108acf$export$7d3d7d8fc5e81fd4;
"use strict";
$42fdcdff82108acf$export$7d3d7d8fc5e81fd4 = $42fdcdff82108acf$var$previousSunday;

/**
 * @name previousSunday
 * @category Weekday Helpers
 * @summary When is the previous Sunday?
 *
 * @description
 * When is the previous Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Sunday
 *
 * @example
 * // When is the previous Sunday before Jun, 21, 2021?
 * const result = previousSunday(new Date(2021, 5, 21))
 * //=> Sun June 20 2021 00:00:00
 */ function $42fdcdff82108acf$var$previousSunday(date) {
    return (0, $1bfa1f6b04020399$export$4caccb62df4eacc0)(date, 0);
}


Object.keys($42fdcdff82108acf$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $42fdcdff82108acf$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $42fdcdff82108acf$exports[key];
        }
    });
});
var $d9be6ce747343891$exports = {};

$parcel$export($d9be6ce747343891$exports, "previousThursday", () => $d9be6ce747343891$export$1975b5b1f6b0e34e, (v) => $d9be6ce747343891$export$1975b5b1f6b0e34e = v);
var $d9be6ce747343891$export$1975b5b1f6b0e34e;
"use strict";
$d9be6ce747343891$export$1975b5b1f6b0e34e = $d9be6ce747343891$var$previousThursday;

/**
 * @name previousThursday
 * @category Weekday Helpers
 * @summary When is the previous Thursday?
 *
 * @description
 * When is the previous Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Thursday
 *
 * @example
 * // When is the previous Thursday before Jun, 18, 2021?
 * const result = previousThursday(new Date(2021, 5, 18))
 * //=> Thu June 17 2021 00:00:00
 */ function $d9be6ce747343891$var$previousThursday(date) {
    return (0, $1bfa1f6b04020399$export$4caccb62df4eacc0)(date, 4);
}


Object.keys($d9be6ce747343891$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d9be6ce747343891$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d9be6ce747343891$exports[key];
        }
    });
});
var $bf4153ed56fd16e2$exports = {};

$parcel$export($bf4153ed56fd16e2$exports, "previousTuesday", () => $bf4153ed56fd16e2$export$a034a75f093bcfaf, (v) => $bf4153ed56fd16e2$export$a034a75f093bcfaf = v);
var $bf4153ed56fd16e2$export$a034a75f093bcfaf;
"use strict";
$bf4153ed56fd16e2$export$a034a75f093bcfaf = $bf4153ed56fd16e2$var$previousTuesday;

/**
 * @name previousTuesday
 * @category Weekday Helpers
 * @summary When is the previous Tuesday?
 *
 * @description
 * When is the previous Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Tuesday
 *
 * @example
 * // When is the previous Tuesday before Jun, 18, 2021?
 * const result = previousTuesday(new Date(2021, 5, 18))
 * //=> Tue June 15 2021 00:00:00
 */ function $bf4153ed56fd16e2$var$previousTuesday(date) {
    return (0, $1bfa1f6b04020399$export$4caccb62df4eacc0)(date, 2);
}


Object.keys($bf4153ed56fd16e2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $bf4153ed56fd16e2$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $bf4153ed56fd16e2$exports[key];
        }
    });
});
var $160a53e351bf91a7$exports = {};

$parcel$export($160a53e351bf91a7$exports, "previousWednesday", () => $160a53e351bf91a7$export$26334f591e4ce672, (v) => $160a53e351bf91a7$export$26334f591e4ce672 = v);
var $160a53e351bf91a7$export$26334f591e4ce672;
"use strict";
$160a53e351bf91a7$export$26334f591e4ce672 = $160a53e351bf91a7$var$previousWednesday;

/**
 * @name previousWednesday
 * @category Weekday Helpers
 * @summary When is the previous Wednesday?
 *
 * @description
 * When is the previous Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Wednesday
 *
 * @example
 * // When is the previous Wednesday before Jun, 18, 2021?
 * const result = previousWednesday(new Date(2021, 5, 18))
 * //=> Wed June 16 2021 00:00:00
 */ function $160a53e351bf91a7$var$previousWednesday(date) {
    return (0, $1bfa1f6b04020399$export$4caccb62df4eacc0)(date, 3);
}


Object.keys($160a53e351bf91a7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $160a53e351bf91a7$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $160a53e351bf91a7$exports[key];
        }
    });
});
var $17537f6141548b99$exports = {};

$parcel$export($17537f6141548b99$exports, "quartersToMonths", () => $17537f6141548b99$export$a29d19ce21d74c57, (v) => $17537f6141548b99$export$a29d19ce21d74c57 = v);
var $17537f6141548b99$export$a29d19ce21d74c57;
"use strict";
$17537f6141548b99$export$a29d19ce21d74c57 = $17537f6141548b99$var$quartersToMonths;

/**
 * @name quartersToMonths
 * @category Conversion Helpers
 * @summary Convert number of quarters to months.
 *
 * @description
 * Convert a number of quarters to a full number of months.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in months
 *
 * @example
 * // Convert 2 quarters to months
 * const result = quartersToMonths(2)
 * //=> 6
 */ function $17537f6141548b99$var$quartersToMonths(quarters) {
    return Math.trunc(quarters * $8540a44f59a4af84$export$3c58128db900d44e);
}


Object.keys($17537f6141548b99$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $17537f6141548b99$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $17537f6141548b99$exports[key];
        }
    });
});
var $1d29c198f18d87e1$exports = {};

$parcel$export($1d29c198f18d87e1$exports, "quartersToYears", () => $1d29c198f18d87e1$export$c309fa8f184b4648, (v) => $1d29c198f18d87e1$export$c309fa8f184b4648 = v);
var $1d29c198f18d87e1$export$c309fa8f184b4648;
"use strict";
$1d29c198f18d87e1$export$c309fa8f184b4648 = $1d29c198f18d87e1$var$quartersToYears;

/**
 * @name quartersToYears
 * @category Conversion Helpers
 * @summary Convert number of quarters to years.
 *
 * @description
 * Convert a number of quarters to a full number of years.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in years
 *
 * @example
 * // Convert 8 quarters to years
 * const result = quartersToYears(8)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = quartersToYears(11)
 * //=> 2
 */ function $1d29c198f18d87e1$var$quartersToYears(quarters) {
    const years = quarters / $8540a44f59a4af84$export$4db7641526e3241f;
    return Math.trunc(years);
}


Object.keys($1d29c198f18d87e1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $1d29c198f18d87e1$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $1d29c198f18d87e1$exports[key];
        }
    });
});
var $fa663ccbe744c7f5$exports = {};

$parcel$export($fa663ccbe744c7f5$exports, "roundToNearestHours", () => $fa663ccbe744c7f5$export$a8b87649ebc0e3c2, (v) => $fa663ccbe744c7f5$export$a8b87649ebc0e3c2 = v);
var $fa663ccbe744c7f5$export$a8b87649ebc0e3c2;
"use strict";
$fa663ccbe744c7f5$export$a8b87649ebc0e3c2 = $fa663ccbe744c7f5$var$roundToNearestHours;



/**
 * The {@link roundToNearestHours} function options.
 */ /**
 * @name roundToNearestHours
 * @category Hour Helpers
 * @summary Rounds the given date to the nearest hour
 *
 * @description
 * Rounds the given date to the nearest hour (or number of hours).
 * Rounds up when the given date is exactly between the nearest round hours.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest hour
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56))
 * //=> Thu Jul 10 2014 13:00:00
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 6 })
 * //=> Thu Jul 10 2014 12:00:00

 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 8 })
 * //=> Thu Jul 10 2014 16:00:00

* @example
 * // Floor (rounds down) 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 1, 23, 45), { roundingMethod: 'ceil' })
 * //=> Thu Jul 10 2014 02:00:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:34:56 to nearest quarter hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { roundingMethod: 'floor', nearestTo: 8 })
 * //=> Thu Jul 10 2014 08:00:00
 */ function $fa663ccbe744c7f5$var$roundToNearestHours(date, options) {
    const nearestTo = options?.nearestTo ?? 1;
    if (nearestTo < 1 || nearestTo > 12) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, NaN);
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const fractionalMinutes = _date.getMinutes() / 60;
    const fractionalSeconds = _date.getSeconds() / 60 / 60;
    const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60 / 60;
    const hours = _date.getHours() + fractionalMinutes + fractionalSeconds + fractionalMilliseconds;
    // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
    const method = options?.roundingMethod ?? "round";
    const roundingMethod = (0, $495af4000bb18bf7$export$b6474a47258c1211)(method);
    // nearestTo option does not care daylight savings time
    const roundedHours = roundingMethod(hours / nearestTo) * nearestTo;
    const result = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, _date);
    result.setHours(roundedHours, 0, 0, 0);
    return result;
}


Object.keys($fa663ccbe744c7f5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $fa663ccbe744c7f5$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $fa663ccbe744c7f5$exports[key];
        }
    });
});
var $9d05b0f997098e6a$exports = {};

$parcel$export($9d05b0f997098e6a$exports, "roundToNearestMinutes", () => $9d05b0f997098e6a$export$d97410bb8cd0dff, (v) => $9d05b0f997098e6a$export$d97410bb8cd0dff = v);
var $9d05b0f997098e6a$export$d97410bb8cd0dff;
"use strict";
$9d05b0f997098e6a$export$d97410bb8cd0dff = $9d05b0f997098e6a$var$roundToNearestMinutes;



/**
 * The {@link roundToNearestMinutes} function options.
 */ /**
 * @name roundToNearestMinutes
 * @category Minute Helpers
 * @summary Rounds the given date to the nearest minute
 *
 * @description
 * Rounds the given date to the nearest minute (or number of minutes).
 * Rounds up when the given date is exactly between the nearest round minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest minute
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
 * //=> Thu Jul 10 2014 12:13:00
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest quarter hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
 * //=> Thu Jul 10 2014 12:15:00
 *
 * @example
 * // Floor (rounds down) 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'floor' })
 * //=> Thu Jul 10 2014 12:12:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:12:34 to nearest half hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'ceil', nearestTo: 30 })
 * //=> Thu Jul 10 2014 12:30:00
 */ function $9d05b0f997098e6a$var$roundToNearestMinutes(date, options) {
    const nearestTo = options?.nearestTo ?? 1;
    if (nearestTo < 1 || nearestTo > 30) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, NaN);
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const fractionalSeconds = _date.getSeconds() / 60;
    const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60;
    const minutes = _date.getMinutes() + fractionalSeconds + fractionalMilliseconds;
    // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
    const method = options?.roundingMethod ?? "round";
    const roundingMethod = (0, $495af4000bb18bf7$export$b6474a47258c1211)(method);
    const roundedMinutes = roundingMethod(minutes / nearestTo) * nearestTo;
    const result = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, _date);
    result.setMinutes(roundedMinutes, 0, 0);
    return result;
}


Object.keys($9d05b0f997098e6a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $9d05b0f997098e6a$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $9d05b0f997098e6a$exports[key];
        }
    });
});
var $95674078571389b0$exports = {};

$parcel$export($95674078571389b0$exports, "secondsToHours", () => $95674078571389b0$export$47d555ff5354096f, (v) => $95674078571389b0$export$47d555ff5354096f = v);
var $95674078571389b0$export$47d555ff5354096f;
"use strict";
$95674078571389b0$export$47d555ff5354096f = $95674078571389b0$var$secondsToHours;

/**
 * @name secondsToHours
 * @category Conversion Helpers
 * @summary Convert seconds to hours.
 *
 * @description
 * Convert a number of seconds to a full number of hours.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in hours
 *
 * @example
 * // Convert 7200 seconds into hours
 * const result = secondsToHours(7200)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToHours(7199)
 * //=> 1
 */ function $95674078571389b0$var$secondsToHours(seconds) {
    const hours = seconds / $8540a44f59a4af84$export$698aec755e92c695;
    return Math.trunc(hours);
}


Object.keys($95674078571389b0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $95674078571389b0$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $95674078571389b0$exports[key];
        }
    });
});
var $bccd0254996c4544$exports = {};

$parcel$export($bccd0254996c4544$exports, "secondsToMilliseconds", () => $bccd0254996c4544$export$fc3e7e8557f8c8c7, (v) => $bccd0254996c4544$export$fc3e7e8557f8c8c7 = v);
var $bccd0254996c4544$export$fc3e7e8557f8c8c7;
"use strict";
$bccd0254996c4544$export$fc3e7e8557f8c8c7 = $bccd0254996c4544$var$secondsToMilliseconds;

/**
 * @name secondsToMilliseconds
 * @category Conversion Helpers
 * @summary Convert seconds to milliseconds.
 *
 * @description
 * Convert a number of seconds to a full number of milliseconds.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in milliseconds
 *
 * @example
 * // Convert 2 seconds into milliseconds
 * const result = secondsToMilliseconds(2)
 * //=> 2000
 */ function $bccd0254996c4544$var$secondsToMilliseconds(seconds) {
    return seconds * $8540a44f59a4af84$export$397c2d5776aa9055;
}


Object.keys($bccd0254996c4544$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $bccd0254996c4544$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $bccd0254996c4544$exports[key];
        }
    });
});
var $c88c346e362dfbe8$exports = {};

$parcel$export($c88c346e362dfbe8$exports, "secondsToMinutes", () => $c88c346e362dfbe8$export$ed657adb62398e99, (v) => $c88c346e362dfbe8$export$ed657adb62398e99 = v);
var $c88c346e362dfbe8$export$ed657adb62398e99;
"use strict";
$c88c346e362dfbe8$export$ed657adb62398e99 = $c88c346e362dfbe8$var$secondsToMinutes;

/**
 * @name secondsToMinutes
 * @category Conversion Helpers
 * @summary Convert seconds to minutes.
 *
 * @description
 * Convert a number of seconds to a full number of minutes.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in minutes
 *
 * @example
 * // Convert 120 seconds into minutes
 * const result = secondsToMinutes(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToMinutes(119)
 * //=> 1
 */ function $c88c346e362dfbe8$var$secondsToMinutes(seconds) {
    const minutes = seconds / $8540a44f59a4af84$export$a77c1a7ebebe2a5a;
    return Math.trunc(minutes);
}


Object.keys($c88c346e362dfbe8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c88c346e362dfbe8$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c88c346e362dfbe8$exports[key];
        }
    });
});
var $e8b97269a8745db5$exports = {};

$parcel$export($e8b97269a8745db5$exports, "set", () => $e8b97269a8745db5$export$adaa4cf7ef1b65be, (v) => $e8b97269a8745db5$export$adaa4cf7ef1b65be = v);
var $e8b97269a8745db5$export$adaa4cf7ef1b65be;
"use strict";
$e8b97269a8745db5$export$adaa4cf7ef1b65be = $e8b97269a8745db5$var$set;

var $16856745969af5fc$exports = {};

$parcel$export($16856745969af5fc$exports, "setMonth", () => $16856745969af5fc$export$63264690f8e36790, (v) => $16856745969af5fc$export$63264690f8e36790 = v);
var $16856745969af5fc$export$63264690f8e36790;
"use strict";
$16856745969af5fc$export$63264690f8e36790 = $16856745969af5fc$var$setMonth;



/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param month - The month index to set (0-11)
 *
 * @returns The new date with the month set
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */ function $16856745969af5fc$var$setMonth(date, month) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const day = _date.getDate();
    const dateWithDesiredMonth = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    const daysInMonth = (0, $57397b9e44500b87$export$f645ddd439eb259d)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}



/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param values - The date values to be set
 *
 * @returns The new date with options set
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */ function $e8b97269a8745db5$var$set(date, values) {
    let _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, NaN);
    if (values.year != null) _date.setFullYear(values.year);
    if (values.month != null) _date = (0, $16856745969af5fc$export$63264690f8e36790)(_date, values.month);
    if (values.date != null) _date.setDate(values.date);
    if (values.hours != null) _date.setHours(values.hours);
    if (values.minutes != null) _date.setMinutes(values.minutes);
    if (values.seconds != null) _date.setSeconds(values.seconds);
    if (values.milliseconds != null) _date.setMilliseconds(values.milliseconds);
    return _date;
}


Object.keys($e8b97269a8745db5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $e8b97269a8745db5$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $e8b97269a8745db5$exports[key];
        }
    });
});
var $e4a235b7a447c4f0$exports = {};

$parcel$export($e4a235b7a447c4f0$exports, "setDate", () => $e4a235b7a447c4f0$export$566174fa40823587, (v) => $e4a235b7a447c4f0$export$566174fa40823587 = v);
var $e4a235b7a447c4f0$export$566174fa40823587;
"use strict";
$e4a235b7a447c4f0$export$566174fa40823587 = $e4a235b7a447c4f0$var$setDate;

/**
 * @name setDate
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfMonth - The day of the month of the new date
 *
 * @returns The new date with the day of the month set
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * const result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */ function $e4a235b7a447c4f0$var$setDate(date, dayOfMonth) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setDate(dayOfMonth);
    return _date;
}


Object.keys($e4a235b7a447c4f0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $e4a235b7a447c4f0$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $e4a235b7a447c4f0$exports[key];
        }
    });
});

Object.keys($13939a537621d91b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $13939a537621d91b$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $13939a537621d91b$exports[key];
        }
    });
});
var $21ddf0eaefea752e$exports = {};

$parcel$export($21ddf0eaefea752e$exports, "setDayOfYear", () => $21ddf0eaefea752e$export$2af590ffc7e7d7c5, (v) => $21ddf0eaefea752e$export$2af590ffc7e7d7c5 = v);
var $21ddf0eaefea752e$export$2af590ffc7e7d7c5;
"use strict";
$21ddf0eaefea752e$export$2af590ffc7e7d7c5 = $21ddf0eaefea752e$var$setDayOfYear;

/**
 * @name setDayOfYear
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfYear - The day of the year of the new date
 *
 * @returns The new date with the day of the year set
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * const result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */ function $21ddf0eaefea752e$var$setDayOfYear(date, dayOfYear) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setMonth(0);
    _date.setDate(dayOfYear);
    return _date;
}


Object.keys($21ddf0eaefea752e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $21ddf0eaefea752e$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $21ddf0eaefea752e$exports[key];
        }
    });
});
var $41d9aae4fa20420d$exports = {};

$parcel$export($41d9aae4fa20420d$exports, "setDefaultOptions", () => $41d9aae4fa20420d$export$95365be1b0704abc, (v) => $41d9aae4fa20420d$export$95365be1b0704abc = v);
var $41d9aae4fa20420d$export$95365be1b0704abc;
"use strict";
$41d9aae4fa20420d$export$95365be1b0704abc = $41d9aae4fa20420d$var$setDefaultOptions;

/**
 * @name setDefaultOptions
 * @category Common Helpers
 * @summary Set default options including locale.
 * @pure false
 *
 * @description
 * Sets the defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * @param options - An object with options
 *
 * @example
 * // Set global locale:
 * import { es } from 'date-fns/locale'
 * setDefaultOptions({ locale: es })
 * const result = format(new Date(2014, 8, 2), 'PPPP')
 * //=> 'martes, 2 de septiembre de 2014'
 *
 * @example
 * // Start of the week for 2 September 2014:
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Start of the week for 2 September 2014,
 * // when we set that week starts on Monday by default:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Mon Sep 01 2014 00:00:00
 *
 * @example
 * // Manually set options take priority over default options:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2), { weekStartsOn: 0 })
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Remove the option by setting it to `undefined`:
 * setDefaultOptions({ weekStartsOn: 1 })
 * setDefaultOptions({ weekStartsOn: undefined })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 */ function $41d9aae4fa20420d$var$setDefaultOptions(options) {
    const result = {};
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    for(const property in defaultOptions)if (Object.prototype.hasOwnProperty.call(defaultOptions, property)) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    result[property] = defaultOptions[property];
    for(const property in options)if (Object.prototype.hasOwnProperty.call(options, property)) {
        if (options[property] === undefined) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        delete result[property];
        else // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        result[property] = options[property];
    }
    (0, $39440020b58e1ef8$export$95365be1b0704abc)(result);
}


Object.keys($41d9aae4fa20420d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $41d9aae4fa20420d$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $41d9aae4fa20420d$exports[key];
        }
    });
});
var $612758c85246c1d0$exports = {};

$parcel$export($612758c85246c1d0$exports, "setHours", () => $612758c85246c1d0$export$f86b797a4659b781, (v) => $612758c85246c1d0$export$f86b797a4659b781 = v);
var $612758c85246c1d0$export$f86b797a4659b781;
"use strict";
$612758c85246c1d0$export$f86b797a4659b781 = $612758c85246c1d0$var$setHours;

/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param hours - The hours of the new date
 *
 * @returns The new date with the hours set
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */ function $612758c85246c1d0$var$setHours(date, hours) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setHours(hours);
    return _date;
}


Object.keys($612758c85246c1d0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $612758c85246c1d0$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $612758c85246c1d0$exports[key];
        }
    });
});

Object.keys($87a68208fbd57247$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $87a68208fbd57247$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $87a68208fbd57247$exports[key];
        }
    });
});

Object.keys($d0815b4ed45bc80a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d0815b4ed45bc80a$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d0815b4ed45bc80a$exports[key];
        }
    });
});

Object.keys($a1a2df6fabe9eb62$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a1a2df6fabe9eb62$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a1a2df6fabe9eb62$exports[key];
        }
    });
});
var $db2197e0fa774070$exports = {};

$parcel$export($db2197e0fa774070$exports, "setMilliseconds", () => $db2197e0fa774070$export$de5664029b35e06d, (v) => $db2197e0fa774070$export$de5664029b35e06d = v);
var $db2197e0fa774070$export$de5664029b35e06d;
"use strict";
$db2197e0fa774070$export$de5664029b35e06d = $db2197e0fa774070$var$setMilliseconds;

/**
 * @name setMilliseconds
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param milliseconds - The milliseconds of the new date
 *
 * @returns The new date with the milliseconds set
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */ function $db2197e0fa774070$var$setMilliseconds(date, milliseconds) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setMilliseconds(milliseconds);
    return _date;
}


Object.keys($db2197e0fa774070$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $db2197e0fa774070$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $db2197e0fa774070$exports[key];
        }
    });
});
var $089730068462d950$exports = {};

$parcel$export($089730068462d950$exports, "setMinutes", () => $089730068462d950$export$ad569bf1c79ea89d, (v) => $089730068462d950$export$ad569bf1c79ea89d = v);
var $089730068462d950$export$ad569bf1c79ea89d;
"use strict";
$089730068462d950$export$ad569bf1c79ea89d = $089730068462d950$var$setMinutes;

/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param minutes - The minutes of the new date
 *
 * @returns The new date with the minutes set
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */ function $089730068462d950$var$setMinutes(date, minutes) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setMinutes(minutes);
    return _date;
}


Object.keys($089730068462d950$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $089730068462d950$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $089730068462d950$exports[key];
        }
    });
});

Object.keys($16856745969af5fc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $16856745969af5fc$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $16856745969af5fc$exports[key];
        }
    });
});
var $a0d14eadad6d8ea7$exports = {};

$parcel$export($a0d14eadad6d8ea7$exports, "setQuarter", () => $a0d14eadad6d8ea7$export$8924d1de7efe1755, (v) => $a0d14eadad6d8ea7$export$8924d1de7efe1755 = v);
var $a0d14eadad6d8ea7$export$8924d1de7efe1755;
"use strict";
$a0d14eadad6d8ea7$export$8924d1de7efe1755 = $a0d14eadad6d8ea7$var$setQuarter;


/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param quarter - The quarter of the new date
 *
 * @returns The new date with the quarter set
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */ function $a0d14eadad6d8ea7$var$setQuarter(date, quarter) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const oldQuarter = Math.trunc(_date.getMonth() / 3) + 1;
    const diff = quarter - oldQuarter;
    return (0, $16856745969af5fc$export$63264690f8e36790)(_date, _date.getMonth() + diff * 3);
}


Object.keys($a0d14eadad6d8ea7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a0d14eadad6d8ea7$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a0d14eadad6d8ea7$exports[key];
        }
    });
});
var $af19e5fb9b37deaf$exports = {};

$parcel$export($af19e5fb9b37deaf$exports, "setSeconds", () => $af19e5fb9b37deaf$export$aec44746644cbf43, (v) => $af19e5fb9b37deaf$export$aec44746644cbf43 = v);
var $af19e5fb9b37deaf$export$aec44746644cbf43;
"use strict";
$af19e5fb9b37deaf$export$aec44746644cbf43 = $af19e5fb9b37deaf$var$setSeconds;

/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param seconds - The seconds of the new date
 *
 * @returns The new date with the seconds set
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */ function $af19e5fb9b37deaf$var$setSeconds(date, seconds) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setSeconds(seconds);
    return _date;
}


Object.keys($af19e5fb9b37deaf$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $af19e5fb9b37deaf$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $af19e5fb9b37deaf$exports[key];
        }
    });
});

Object.keys($66c7729eb95aa501$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $66c7729eb95aa501$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $66c7729eb95aa501$exports[key];
        }
    });
});
var $cff5bf5fa0193e74$exports = {};

$parcel$export($cff5bf5fa0193e74$exports, "setWeekYear", () => $cff5bf5fa0193e74$export$4340968d5939835e, (v) => $cff5bf5fa0193e74$export$4340968d5939835e = v);
var $cff5bf5fa0193e74$export$4340968d5939835e;
"use strict";
$cff5bf5fa0193e74$export$4340968d5939835e = $cff5bf5fa0193e74$var$setWeekYear;





/**
 * The {@link setWeekYear} function options.
 */ /**
 * @name setWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Set the local week-numbering year to the given date.
 *
 * @description
 * Set the local week-numbering year to the given date,
 * saving the week number and the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The local week-numbering year of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week-numbering year set
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004)
 * //=> Sat Jan 03 2004 00:00:00
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010,
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sat Jan 01 2005 00:00:00
 */ function $cff5bf5fa0193e74$var$setWeekYear(date, weekYear, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    let _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const diff = (0, $737f54e9ffaddc15$export$4a02e9c37dab4871)(_date, (0, $ac7640a7ade5a435$export$bb7b45bb8e74da0f)(_date, options));
    const firstWeek = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
    firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    _date = (0, $ac7640a7ade5a435$export$bb7b45bb8e74da0f)(firstWeek, options);
    _date.setDate(_date.getDate() + diff);
    return _date;
}


Object.keys($cff5bf5fa0193e74$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $cff5bf5fa0193e74$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $cff5bf5fa0193e74$exports[key];
        }
    });
});
var $529c31b1ede64581$exports = {};

$parcel$export($529c31b1ede64581$exports, "setYear", () => $529c31b1ede64581$export$a8408b6c5639cab7, (v) => $529c31b1ede64581$export$a8408b6c5639cab7 = v);
var $529c31b1ede64581$export$a8408b6c5639cab7;
"use strict";
$529c31b1ede64581$export$a8408b6c5639cab7 = $529c31b1ede64581$var$setYear;


/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param year - The year of the new date
 *
 * @returns The new date with the year set
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */ function $529c31b1ede64581$var$setYear(date, year) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, NaN);
    _date.setFullYear(year);
    return _date;
}


Object.keys($529c31b1ede64581$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $529c31b1ede64581$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $529c31b1ede64581$exports[key];
        }
    });
});

Object.keys($b6caff0bf13dcaf5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $b6caff0bf13dcaf5$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $b6caff0bf13dcaf5$exports[key];
        }
    });
});
var $27d7623072841c9e$exports = {};

$parcel$export($27d7623072841c9e$exports, "startOfDecade", () => $27d7623072841c9e$export$730492981c634308, (v) => $27d7623072841c9e$export$730492981c634308 = v);
var $27d7623072841c9e$export$730492981c634308;
"use strict";
$27d7623072841c9e$export$730492981c634308 = $27d7623072841c9e$var$startOfDecade;

/**
 * @name startOfDecade
 * @category Decade Helpers
 * @summary Return the start of a decade for the given date.
 *
 * @description
 * Return the start of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a decade
 *
 * @example
 * // The start of a decade for 21 October 2015 00:00:00:
 * const result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
 * //=> Jan 01 2010 00:00:00
 */ function $27d7623072841c9e$var$startOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const decade = Math.floor(year / 10) * 10;
    _date.setFullYear(decade, 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


Object.keys($27d7623072841c9e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $27d7623072841c9e$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $27d7623072841c9e$exports[key];
        }
    });
});

Object.keys($d153613108f3ff12$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d153613108f3ff12$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d153613108f3ff12$exports[key];
        }
    });
});

Object.keys($1c9d32c6cb108460$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $1c9d32c6cb108460$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $1c9d32c6cb108460$exports[key];
        }
    });
});

Object.keys($3b2e6199275b27d6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $3b2e6199275b27d6$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $3b2e6199275b27d6$exports[key];
        }
    });
});

Object.keys($d1ad424e56672364$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d1ad424e56672364$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d1ad424e56672364$exports[key];
        }
    });
});

Object.keys($c0b4ec5551eca4c9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c0b4ec5551eca4c9$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c0b4ec5551eca4c9$exports[key];
        }
    });
});

Object.keys($c922a15e7d8774a7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c922a15e7d8774a7$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c922a15e7d8774a7$exports[key];
        }
    });
});

Object.keys($fec0f854199fab32$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $fec0f854199fab32$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $fec0f854199fab32$exports[key];
        }
    });
});
var $1d1c05f420cd3819$exports = {};

$parcel$export($1d1c05f420cd3819$exports, "startOfToday", () => $1d1c05f420cd3819$export$444d742fd5a45a57, (v) => $1d1c05f420cd3819$export$444d742fd5a45a57 = v);
var $1d1c05f420cd3819$export$444d742fd5a45a57;
"use strict";
$1d1c05f420cd3819$export$444d742fd5a45a57 = $1d1c05f420cd3819$var$startOfToday;

/**
 * @name startOfToday
 * @category Day Helpers
 * @summary Return the start of today.
 * @pure false
 *
 * @description
 * Return the start of today.
 *
 * @returns The start of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */ function $1d1c05f420cd3819$var$startOfToday() {
    return (0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(Date.now());
}


Object.keys($1d1c05f420cd3819$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $1d1c05f420cd3819$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $1d1c05f420cd3819$exports[key];
        }
    });
});
var $cc76f6b1bb5f55ce$exports = {};

$parcel$export($cc76f6b1bb5f55ce$exports, "startOfTomorrow", () => $cc76f6b1bb5f55ce$export$7e8566c79d5bee07, (v) => $cc76f6b1bb5f55ce$export$7e8566c79d5bee07 = v);
var $cc76f6b1bb5f55ce$export$7e8566c79d5bee07;
"use strict";
$cc76f6b1bb5f55ce$export$7e8566c79d5bee07 = $cc76f6b1bb5f55ce$var$startOfTomorrow; /**
 * @name startOfTomorrow
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 * @pure false
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns The start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */ 
function $cc76f6b1bb5f55ce$var$startOfTomorrow() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(0, 0, 0, 0);
    return date;
}


Object.keys($cc76f6b1bb5f55ce$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $cc76f6b1bb5f55ce$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $cc76f6b1bb5f55ce$exports[key];
        }
    });
});

Object.keys($61f11f7a26b3ab78$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $61f11f7a26b3ab78$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $61f11f7a26b3ab78$exports[key];
        }
    });
});

Object.keys($ac7640a7ade5a435$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $ac7640a7ade5a435$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $ac7640a7ade5a435$exports[key];
        }
    });
});

Object.keys($29cc086f79701cd9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $29cc086f79701cd9$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $29cc086f79701cd9$exports[key];
        }
    });
});
var $cd81ad9ec468f6b4$exports = {};

$parcel$export($cd81ad9ec468f6b4$exports, "startOfYesterday", () => $cd81ad9ec468f6b4$export$23a16f3c6d143ce9, (v) => $cd81ad9ec468f6b4$export$23a16f3c6d143ce9 = v);
var $cd81ad9ec468f6b4$export$23a16f3c6d143ce9;
"use strict";
$cd81ad9ec468f6b4$export$23a16f3c6d143ce9 = $cd81ad9ec468f6b4$var$startOfYesterday; /**
 * @name startOfYesterday
 * @category Day Helpers
 * @summary Return the start of yesterday.
 * @pure false
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns The start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */ 
function $cd81ad9ec468f6b4$var$startOfYesterday() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(0, 0, 0, 0);
    return date;
}


Object.keys($cd81ad9ec468f6b4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $cd81ad9ec468f6b4$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $cd81ad9ec468f6b4$exports[key];
        }
    });
});
var $7aeb261fe061928a$exports = {};

$parcel$export($7aeb261fe061928a$exports, "sub", () => $7aeb261fe061928a$export$f93b5905241a7cca, (v) => $7aeb261fe061928a$export$f93b5905241a7cca = v);
var $7aeb261fe061928a$export$f93b5905241a7cca;
"use strict";
$7aeb261fe061928a$export$f93b5905241a7cca = $7aeb261fe061928a$var$sub;

var $c5e772d389bae063$exports = {};

$parcel$export($c5e772d389bae063$exports, "subMonths", () => $c5e772d389bae063$export$73d1c15a21f9fae5, (v) => $c5e772d389bae063$export$73d1c15a21f9fae5 = v);
var $c5e772d389bae063$export$73d1c15a21f9fae5;
"use strict";
$c5e772d389bae063$export$73d1c15a21f9fae5 = $c5e772d389bae063$var$subMonths;

/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be subtracted.
 *
 * @returns The new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */ function $c5e772d389bae063$var$subMonths(date, amount) {
    return (0, $8fcd3b0bf5df7635$export$17c93e242b2d3a22)(date, -amount);
}



/**
 * @name sub
 * @category Common Helpers
 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @description
 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be subtracted
 *
 * | Key     | Description                        |
 * |---------|------------------------------------|
 * | years   | Amount of years to be subtracted   |
 * | months  | Amount of months to be subtracted  |
 * | weeks   | Amount of weeks to be subtracted   |
 * | days    | Amount of days to be subtracted    |
 * | hours   | Amount of hours to be subtracted   |
 * | minutes | Amount of minutes to be subtracted |
 * | seconds | Amount of seconds to be subtracted |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract the following duration from 15 June 2017 15:29:20
 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> Mon Sep 1 2014 10:19:50
 */ function $7aeb261fe061928a$var$sub(date, duration) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Subtract years and months
    const dateWithoutMonths = (0, $c5e772d389bae063$export$73d1c15a21f9fae5)(date, months + years * 12);
    // Subtract weeks and days
    const dateWithoutDays = (0, $43790e1a97254ab3$export$70823084e2deb1ea)(dateWithoutMonths, days + weeks * 7);
    // Subtract hours, minutes and seconds
    const minutestoSub = minutes + hours * 60;
    const secondstoSub = seconds + minutestoSub * 60;
    const mstoSub = secondstoSub * 1000;
    const finalDate = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, dateWithoutDays.getTime() - mstoSub);
    return finalDate;
}


Object.keys($7aeb261fe061928a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $7aeb261fe061928a$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $7aeb261fe061928a$exports[key];
        }
    });
});
var $3c688c7c0e30b622$exports = {};

$parcel$export($3c688c7c0e30b622$exports, "subBusinessDays", () => $3c688c7c0e30b622$export$e5cc51ae28664a93, (v) => $3c688c7c0e30b622$export$e5cc51ae28664a93 = v);
var $3c688c7c0e30b622$export$e5cc51ae28664a93;
"use strict";
$3c688c7c0e30b622$export$e5cc51ae28664a93 = $3c688c7c0e30b622$var$subBusinessDays;

/**
 * @name subBusinessDays
 * @category Day Helpers
 * @summary Substract the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be subtracted.
 *
 * @returns The new date with the business days subtracted
 *
 * @example
 * // Substract 10 business days from 1 September 2014:
 * const result = subBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
 */ function $3c688c7c0e30b622$var$subBusinessDays(date, amount) {
    return (0, $370ee6dc5d0513ee$export$f087b9ada3136ae9)(date, -amount);
}


Object.keys($3c688c7c0e30b622$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $3c688c7c0e30b622$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $3c688c7c0e30b622$exports[key];
        }
    });
});

Object.keys($43790e1a97254ab3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $43790e1a97254ab3$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $43790e1a97254ab3$exports[key];
        }
    });
});
var $c1e1b7960398f22a$exports = {};

$parcel$export($c1e1b7960398f22a$exports, "subHours", () => $c1e1b7960398f22a$export$5e9fa51cd5bb1e71, (v) => $c1e1b7960398f22a$export$5e9fa51cd5bb1e71 = v);
var $c1e1b7960398f22a$export$5e9fa51cd5bb1e71;
"use strict";
$c1e1b7960398f22a$export$5e9fa51cd5bb1e71 = $c1e1b7960398f22a$var$subHours;

/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be subtracted.
 *
 * @returns The new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */ function $c1e1b7960398f22a$var$subHours(date, amount) {
    return (0, $dada8b88b0873e8d$export$4a4306ad4fa0e5e6)(date, -amount);
}


Object.keys($c1e1b7960398f22a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c1e1b7960398f22a$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c1e1b7960398f22a$exports[key];
        }
    });
});

Object.keys($0ee59b8ff17647f3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $0ee59b8ff17647f3$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $0ee59b8ff17647f3$exports[key];
        }
    });
});
var $9cfaf2369322ee51$exports = {};

$parcel$export($9cfaf2369322ee51$exports, "subMilliseconds", () => $9cfaf2369322ee51$export$5abaf57ab8e91640, (v) => $9cfaf2369322ee51$export$5abaf57ab8e91640 = v);
var $9cfaf2369322ee51$export$5abaf57ab8e91640;
"use strict";
$9cfaf2369322ee51$export$5abaf57ab8e91640 = $9cfaf2369322ee51$var$subMilliseconds;

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be subtracted.
 *
 * @returns The new date with the milliseconds subtracted
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $9cfaf2369322ee51$var$subMilliseconds(date, amount) {
    return (0, $a1665abf6052bbc9$export$baf757aaf0c95c94)(date, -amount);
}


Object.keys($9cfaf2369322ee51$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $9cfaf2369322ee51$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $9cfaf2369322ee51$exports[key];
        }
    });
});
var $a8bc0e11c60ff399$exports = {};

$parcel$export($a8bc0e11c60ff399$exports, "subMinutes", () => $a8bc0e11c60ff399$export$e12a970efb73fce5, (v) => $a8bc0e11c60ff399$export$e12a970efb73fce5 = v);
var $a8bc0e11c60ff399$export$e12a970efb73fce5;
"use strict";
$a8bc0e11c60ff399$export$e12a970efb73fce5 = $a8bc0e11c60ff399$var$subMinutes;

/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be subtracted.
 *
 * @returns The new date with the minutes subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */ function $a8bc0e11c60ff399$var$subMinutes(date, amount) {
    return (0, $e8dac3cf5df5dbc8$export$2287e3d29250119e)(date, -amount);
}


Object.keys($a8bc0e11c60ff399$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a8bc0e11c60ff399$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a8bc0e11c60ff399$exports[key];
        }
    });
});

Object.keys($c5e772d389bae063$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c5e772d389bae063$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c5e772d389bae063$exports[key];
        }
    });
});
var $8013f48d32fc8fb9$exports = {};

$parcel$export($8013f48d32fc8fb9$exports, "subQuarters", () => $8013f48d32fc8fb9$export$a31bfeeeee80cce6, (v) => $8013f48d32fc8fb9$export$a31bfeeeee80cce6 = v);
var $8013f48d32fc8fb9$export$a31bfeeeee80cce6;
"use strict";
$8013f48d32fc8fb9$export$a31bfeeeee80cce6 = $8013f48d32fc8fb9$var$subQuarters;

/**
 * @name subQuarters
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be subtracted.
 *
 * @returns The new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * const result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */ function $8013f48d32fc8fb9$var$subQuarters(date, amount) {
    return (0, $30e5a3aa581ecd23$export$c252a41d0fbed2ce)(date, -amount);
}


Object.keys($8013f48d32fc8fb9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $8013f48d32fc8fb9$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $8013f48d32fc8fb9$exports[key];
        }
    });
});
var $ad6954495f71f731$exports = {};

$parcel$export($ad6954495f71f731$exports, "subSeconds", () => $ad6954495f71f731$export$e95d8ad9981db689, (v) => $ad6954495f71f731$export$e95d8ad9981db689 = v);
var $ad6954495f71f731$export$e95d8ad9981db689;
"use strict";
$ad6954495f71f731$export$e95d8ad9981db689 = $ad6954495f71f731$var$subSeconds;

/**
 * @name subSeconds
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be subtracted.
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * const result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */ function $ad6954495f71f731$var$subSeconds(date, amount) {
    return (0, $ec74b6b01c6372f4$export$3cb31b0df13be68)(date, -amount);
}


Object.keys($ad6954495f71f731$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $ad6954495f71f731$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $ad6954495f71f731$exports[key];
        }
    });
});
var $065494b4a3debec8$exports = {};

$parcel$export($065494b4a3debec8$exports, "subWeeks", () => $065494b4a3debec8$export$b4d8ae6376193efb, (v) => $065494b4a3debec8$export$b4d8ae6376193efb = v);
var $065494b4a3debec8$export$b4d8ae6376193efb;
"use strict";
$065494b4a3debec8$export$b4d8ae6376193efb = $065494b4a3debec8$var$subWeeks;

/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be subtracted.
 *
 * @returns The new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */ function $065494b4a3debec8$var$subWeeks(date, amount) {
    return (0, $bce641bd93181421$export$ef501a2bb4f3ee6b)(date, -amount);
}


Object.keys($065494b4a3debec8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $065494b4a3debec8$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $065494b4a3debec8$exports[key];
        }
    });
});
var $7e3d370a917aaad9$exports = {};

$parcel$export($7e3d370a917aaad9$exports, "subYears", () => $7e3d370a917aaad9$export$14867687ff6c92e2, (v) => $7e3d370a917aaad9$export$14867687ff6c92e2 = v);
var $7e3d370a917aaad9$export$14867687ff6c92e2;
"use strict";
$7e3d370a917aaad9$export$14867687ff6c92e2 = $7e3d370a917aaad9$var$subYears;

/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be subtracted.
 *
 * @returns The new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */ function $7e3d370a917aaad9$var$subYears(date, amount) {
    return (0, $25460c542fb3bf74$export$3d83eec43f4ea476)(date, -amount);
}


Object.keys($7e3d370a917aaad9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $7e3d370a917aaad9$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $7e3d370a917aaad9$exports[key];
        }
    });
});

Object.keys($231bfb8d72679740$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $231bfb8d72679740$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $231bfb8d72679740$exports[key];
        }
    });
});

Object.keys($59425df5ba0b4bea$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $59425df5ba0b4bea$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $59425df5ba0b4bea$exports[key];
        }
    });
});
var $fd3f20e3d132724e$exports = {};

$parcel$export($fd3f20e3d132724e$exports, "weeksToDays", () => $fd3f20e3d132724e$export$b696b6eeb89501ad, (v) => $fd3f20e3d132724e$export$b696b6eeb89501ad = v);
var $fd3f20e3d132724e$export$b696b6eeb89501ad;
"use strict";
$fd3f20e3d132724e$export$b696b6eeb89501ad = $fd3f20e3d132724e$var$weeksToDays;

/**
 * @name weeksToDays
 * @category Conversion Helpers
 * @summary Convert weeks to days.
 *
 * @description
 * Convert a number of weeks to a full number of days.
 *
 * @param weeks - The number of weeks to be converted
 *
 * @returns The number of weeks converted in days
 *
 * @example
 * // Convert 2 weeks into days
 * const result = weeksToDays(2)
 * //=> 14
 */ function $fd3f20e3d132724e$var$weeksToDays(weeks) {
    return Math.trunc(weeks * $8540a44f59a4af84$export$dfd9b671c89acc8e);
}


Object.keys($fd3f20e3d132724e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $fd3f20e3d132724e$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $fd3f20e3d132724e$exports[key];
        }
    });
});
var $6ccc2e60f33c92b2$exports = {};

$parcel$export($6ccc2e60f33c92b2$exports, "yearsToDays", () => $6ccc2e60f33c92b2$export$862cb7b6e45c3b17, (v) => $6ccc2e60f33c92b2$export$862cb7b6e45c3b17 = v);
var $6ccc2e60f33c92b2$export$862cb7b6e45c3b17;
"use strict";
$6ccc2e60f33c92b2$export$862cb7b6e45c3b17 = $6ccc2e60f33c92b2$var$yearsToDays;

/**
 * @name yearsToDays
 * @category Conversion Helpers
 * @summary Convert years to days.
 *
 * @description
 * Convert a number of years to a full number of days.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in days
 *
 * @example
 * // Convert 2 years into days
 * const result = yearsToDays(2)
 * //=> 730
 */ function $6ccc2e60f33c92b2$var$yearsToDays(years) {
    return Math.trunc(years * $8540a44f59a4af84$export$3913210603d8e9ae);
}


Object.keys($6ccc2e60f33c92b2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $6ccc2e60f33c92b2$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $6ccc2e60f33c92b2$exports[key];
        }
    });
});
var $a6974b8bd1359f14$exports = {};

$parcel$export($a6974b8bd1359f14$exports, "yearsToMonths", () => $a6974b8bd1359f14$export$894abb0747b9a00, (v) => $a6974b8bd1359f14$export$894abb0747b9a00 = v);
var $a6974b8bd1359f14$export$894abb0747b9a00;
"use strict";
$a6974b8bd1359f14$export$894abb0747b9a00 = $a6974b8bd1359f14$var$yearsToMonths;

/**
 * @name yearsToMonths
 * @category Conversion Helpers
 * @summary Convert years to months.
 *
 * @description
 * Convert a number of years to a full number of months.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in months
 *
 * @example
 * // Convert 2 years into months
 * const result = yearsToMonths(2)
 * //=> 24
 */ function $a6974b8bd1359f14$var$yearsToMonths(years) {
    return Math.trunc(years * $8540a44f59a4af84$export$80d7e435f744f319);
}


Object.keys($a6974b8bd1359f14$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a6974b8bd1359f14$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a6974b8bd1359f14$exports[key];
        }
    });
});
var $0d4589c309e08ad6$exports = {};

$parcel$export($0d4589c309e08ad6$exports, "yearsToQuarters", () => $0d4589c309e08ad6$export$ab26576e5e7379d7, (v) => $0d4589c309e08ad6$export$ab26576e5e7379d7 = v);
var $0d4589c309e08ad6$export$ab26576e5e7379d7;
"use strict";
$0d4589c309e08ad6$export$ab26576e5e7379d7 = $0d4589c309e08ad6$var$yearsToQuarters;

/**
 * @name yearsToQuarters
 * @category Conversion Helpers
 * @summary Convert years to quarters.
 *
 * @description
 * Convert a number of years to a full number of quarters.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in quarters
 *
 * @example
 * // Convert 2 years to quarters
 * const result = yearsToQuarters(2)
 * //=> 8
 */ function $0d4589c309e08ad6$var$yearsToQuarters(years) {
    return Math.trunc(years * $8540a44f59a4af84$export$4db7641526e3241f);
}


Object.keys($0d4589c309e08ad6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $0d4589c309e08ad6$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $0d4589c309e08ad6$exports[key];
        }
    });
});


function $c188e18c3892cda7$export$90e6cdae187a86ac(length, date, options) {
    const defaultOptions = (0, $5b2b72156d2e39b5$exports.getDefaultOptions)();
    const dtf = $c188e18c3892cda7$var$getDTF(length, options.timeZone, options.locale ?? defaultOptions.locale);
    return 'formatToParts' in dtf ? $c188e18c3892cda7$var$partsTimeZone(dtf, date) : $c188e18c3892cda7$var$hackyTimeZone(dtf, date);
}
function $c188e18c3892cda7$var$partsTimeZone(dtf, date) {
    const formatted = dtf.formatToParts(date);
    for(let i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
    return undefined;
}
function $c188e18c3892cda7$var$hackyTimeZone(dtf, date) {
    const formatted = dtf.format(date).replace(/\u200E/g, '');
    const tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $c188e18c3892cda7$var$getDTF(length, timeZone, locale) {
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}


/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $ac3e95dde4ceb674$export$6f7bba78170cdfff(date, timeZone) {
    const dtf = $ac3e95dde4ceb674$var$getDateTimeFormat(timeZone);
    return 'formatToParts' in dtf ? $ac3e95dde4ceb674$var$partsOffset(dtf, date) : $ac3e95dde4ceb674$var$hackyOffset(dtf, date);
}
const $ac3e95dde4ceb674$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $ac3e95dde4ceb674$var$partsOffset(dtf, date) {
    try {
        const formatted = dtf.formatToParts(date);
        const filled = [];
        for(let i = 0; i < formatted.length; i++){
            const pos = $ac3e95dde4ceb674$var$typeToPos[formatted[i].type];
            if (pos !== undefined) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $ac3e95dde4ceb674$var$hackyOffset(dtf, date) {
    const formatted = dtf.format(date);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // const [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parseInt(parsed[3], 10),
        parseInt(parsed[1], 10),
        parseInt(parsed[2], 10),
        parseInt(parsed[4], 10),
        parseInt(parsed[5], 10),
        parseInt(parsed[6], 10)
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
const $ac3e95dde4ceb674$var$dtfCache = {};
// New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
const $ac3e95dde4ceb674$var$testDateFormatted = new Intl.DateTimeFormat('en-US', {
    hourCycle: 'h23',
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
}).format(new Date('2014-06-25T04:00:00.123Z'));
const $ac3e95dde4ceb674$var$hourCycleSupported = $ac3e95dde4ceb674$var$testDateFormatted === '06/25/2014, 00:00:00' || $ac3e95dde4ceb674$var$testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
function $ac3e95dde4ceb674$var$getDateTimeFormat(timeZone) {
    if (!$ac3e95dde4ceb674$var$dtfCache[timeZone]) $ac3e95dde4ceb674$var$dtfCache[timeZone] = $ac3e95dde4ceb674$var$hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
        hourCycle: 'h23',
        timeZone: timeZone,
        year: 'numeric',
        month: 'numeric',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    }) : new Intl.DateTimeFormat('en-US', {
        hour12: false,
        timeZone: timeZone,
        year: 'numeric',
        month: 'numeric',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });
    return $ac3e95dde4ceb674$var$dtfCache[timeZone];
}


/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $dbbc94b2c9b7796e$export$461165d00818234e(fullYear, month, day, hour, minute, second, millisecond) {
    const utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}


const $3a1a3d9713aae3cd$var$MILLISECONDS_IN_HOUR = 3600000;
const $3a1a3d9713aae3cd$var$MILLISECONDS_IN_MINUTE = 60000;
const $3a1a3d9713aae3cd$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $3a1a3d9713aae3cd$export$57649162eea44a93(timezoneString, date, isUtcDate) {
    // Empty string
    if (!timezoneString) return 0;
    // Z
    let token = $3a1a3d9713aae3cd$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    let hours;
    let absoluteOffset;
    // ±hh
    token = $3a1a3d9713aae3cd$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$3a1a3d9713aae3cd$var$validateTimezone(hours)) return NaN;
        return -(hours * $3a1a3d9713aae3cd$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $3a1a3d9713aae3cd$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        const minutes = parseInt(token[3], 10);
        if (!$3a1a3d9713aae3cd$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $3a1a3d9713aae3cd$var$MILLISECONDS_IN_HOUR + minutes * $3a1a3d9713aae3cd$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($3a1a3d9713aae3cd$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        const utcDate = isUtcDate ? date : $3a1a3d9713aae3cd$var$toUtcDate(date);
        const offset = $3a1a3d9713aae3cd$var$calcOffset(utcDate, timezoneString);
        const fixedOffset = isUtcDate ? offset : $3a1a3d9713aae3cd$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $3a1a3d9713aae3cd$var$toUtcDate(date) {
    return (0, $dbbc94b2c9b7796e$export$461165d00818234e)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $3a1a3d9713aae3cd$var$calcOffset(date, timezoneString) {
    const tokens = (0, $ac3e95dde4ceb674$export$6f7bba78170cdfff)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    const asUTC = (0, $dbbc94b2c9b7796e$export$461165d00818234e)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    let asTS = date.getTime();
    const over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $3a1a3d9713aae3cd$var$fixOffset(date, offset, timezoneString) {
    const localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    let utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    const o2 = $3a1a3d9713aae3cd$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    const o3 = $3a1a3d9713aae3cd$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $3a1a3d9713aae3cd$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
const $3a1a3d9713aae3cd$var$validIANATimezoneCache = {};
function $3a1a3d9713aae3cd$var$isValidTimezoneIANAString(timeZoneString) {
    if ($3a1a3d9713aae3cd$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $3a1a3d9713aae3cd$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}


const $1f8f18832af08047$var$MILLISECONDS_IN_MINUTE = 60000;
const $1f8f18832af08047$export$fe98a034cfb96d55 = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, options) {
        const timezoneOffset = $1f8f18832af08047$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $1f8f18832af08047$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $1f8f18832af08047$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $1f8f18832af08047$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, options) {
        const timezoneOffset = $1f8f18832af08047$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $1f8f18832af08047$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $1f8f18832af08047$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $1f8f18832af08047$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, options) {
        const timezoneOffset = $1f8f18832af08047$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $1f8f18832af08047$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $1f8f18832af08047$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $c188e18c3892cda7$export$90e6cdae187a86ac)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $c188e18c3892cda7$export$90e6cdae187a86ac)('long', date, options);
        }
    }
};
function $1f8f18832af08047$var$getTimeZoneOffset(timeZone, originalDate) {
    const timeZoneOffset = timeZone ? (0, $3a1a3d9713aae3cd$export$57649162eea44a93)(timeZone, originalDate, true) / $1f8f18832af08047$var$MILLISECONDS_IN_MINUTE : originalDate?.getTimezoneOffset() ?? 0;
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $1f8f18832af08047$var$addLeadingZeros(number, targetLength) {
    const sign = number < 0 ? '-' : '';
    let output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $1f8f18832af08047$var$formatTimezone(offset, delimiter = '') {
    const sign = offset > 0 ? '-' : '+';
    const absOffset = Math.abs(offset);
    const hours = $1f8f18832af08047$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    const minutes = $1f8f18832af08047$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimiter + minutes;
}
function $1f8f18832af08047$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? '-' : '+';
        return sign + $1f8f18832af08047$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $1f8f18832af08047$var$formatTimezone(offset, delimiter);
}
function $1f8f18832af08047$var$formatTimezoneShort(offset, delimiter = '') {
    const sign = offset > 0 ? '-' : '+';
    const absOffset = Math.abs(offset);
    const hours = Math.floor(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + $1f8f18832af08047$var$addLeadingZeros(minutes, 2);
}


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $bbd26179fb93fcf7$export$113002b5eff6e430(date) {
    const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return +date - +utcDate;
}



/** Regex to identify the presence of a time zone specifier in a date string */ const $86f91a3c7f9a9743$export$a859e97a80802e41 = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;


const $7a5e6daef75f68d9$var$MILLISECONDS_IN_HOUR = 3600000;
const $7a5e6daef75f68d9$var$MILLISECONDS_IN_MINUTE = 60000;
const $7a5e6daef75f68d9$var$DEFAULT_ADDITIONAL_DIGITS = 2;
const $7a5e6daef75f68d9$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $86f91a3c7f9a9743$export$a859e97a80802e41)
};
function $7a5e6daef75f68d9$export$e67a095c620b86fe(argument, options = {}) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    const additionalDigits = options.additionalDigits == null ? $7a5e6daef75f68d9$var$DEFAULT_ADDITIONAL_DIGITS : Number(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    const dateStrings = $7a5e6daef75f68d9$var$splitDateString(argument);
    const { year: year, restDateString: restDateString } = $7a5e6daef75f68d9$var$parseYear(dateStrings.date, additionalDigits);
    const date = $7a5e6daef75f68d9$var$parseDate(restDateString, year);
    if (date === null || isNaN(date.getTime())) return new Date(NaN);
    if (date) {
        const timestamp = date.getTime();
        let time = 0;
        let offset;
        if (dateStrings.time) {
            time = $7a5e6daef75f68d9$var$parseTime(dateStrings.time);
            if (time === null || isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $3a1a3d9713aae3cd$export$57649162eea44a93)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, $bbd26179fb93fcf7$export$113002b5eff6e430)(new Date(timestamp + time));
            offset = (0, $bbd26179fb93fcf7$export$113002b5eff6e430)(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $7a5e6daef75f68d9$var$splitDateString(dateString) {
    const dateStrings = {};
    let parts = $7a5e6daef75f68d9$var$patterns.dateTimePattern.exec(dateString);
    let timeString;
    if (!parts) {
        parts = $7a5e6daef75f68d9$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        const token = $7a5e6daef75f68d9$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $7a5e6daef75f68d9$var$parseYear(dateString, additionalDigits) {
    if (dateString) {
        const patternYYY = $7a5e6daef75f68d9$var$patterns.YYY[additionalDigits];
        const patternYYYYY = $7a5e6daef75f68d9$var$patterns.YYYYY[additionalDigits];
        // YYYY or ±YYYYY
        let token = $7a5e6daef75f68d9$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
        if (token) {
            const yearString = token[1];
            return {
                year: parseInt(yearString, 10),
                restDateString: dateString.slice(yearString.length)
            };
        }
        // YY or ±YYY
        token = $7a5e6daef75f68d9$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
        if (token) {
            const centuryString = token[1];
            return {
                year: parseInt(centuryString, 10) * 100,
                restDateString: dateString.slice(centuryString.length)
            };
        }
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $7a5e6daef75f68d9$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    let date;
    let month;
    let week;
    // YYYY
    if (!dateString || !dateString.length) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    let token = $7a5e6daef75f68d9$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$7a5e6daef75f68d9$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $7a5e6daef75f68d9$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        const dayOfYear = parseInt(token[1], 10);
        if (!$7a5e6daef75f68d9$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $7a5e6daef75f68d9$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        const day = parseInt(token[2], 10);
        if (!$7a5e6daef75f68d9$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $7a5e6daef75f68d9$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$7a5e6daef75f68d9$var$validateWeekDate(week)) return new Date(NaN);
        return $7a5e6daef75f68d9$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $7a5e6daef75f68d9$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        const dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$7a5e6daef75f68d9$var$validateWeekDate(week, dayOfWeek)) return new Date(NaN);
        return $7a5e6daef75f68d9$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $7a5e6daef75f68d9$var$parseTime(timeString) {
    let hours;
    let minutes;
    // hh
    let token = $7a5e6daef75f68d9$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$7a5e6daef75f68d9$var$validateTime(hours)) return NaN;
        return hours % 24 * $7a5e6daef75f68d9$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $7a5e6daef75f68d9$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$7a5e6daef75f68d9$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $7a5e6daef75f68d9$var$MILLISECONDS_IN_HOUR + minutes * $7a5e6daef75f68d9$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $7a5e6daef75f68d9$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        const seconds = parseFloat(token[3].replace(',', '.'));
        if (!$7a5e6daef75f68d9$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $7a5e6daef75f68d9$var$MILLISECONDS_IN_HOUR + minutes * $7a5e6daef75f68d9$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $7a5e6daef75f68d9$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
const $7a5e6daef75f68d9$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $7a5e6daef75f68d9$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $7a5e6daef75f68d9$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $7a5e6daef75f68d9$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        const isLeapYear = $7a5e6daef75f68d9$var$isLeapYearIndex(year);
        if (isLeapYear && date > $7a5e6daef75f68d9$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $7a5e6daef75f68d9$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $7a5e6daef75f68d9$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    const isLeapYear = $7a5e6daef75f68d9$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $7a5e6daef75f68d9$var$validateWeekDate(week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $7a5e6daef75f68d9$var$validateTime(hours, minutes, seconds) {
    if (hours < 0 || hours >= 25) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}


const $a752b949231e6c46$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $a752b949231e6c46$export$d9468344d3651243(date, formatStr, options = {}) {
    formatStr = String(formatStr);
    const matches = formatStr.match($a752b949231e6c46$var$tzFormattingTokensRegExp);
    if (matches) {
        const d = (0, $7a5e6daef75f68d9$export$e67a095c620b86fe)(options.originalDate || date, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result; // This is a quoted portion, matched only to ensure we don't match inside it
            const pos = result.indexOf(token);
            const precededByQuotedSection = result[pos - 1] === "'";
            const replaced = result.replace(token, "'" + (0, $1f8f18832af08047$export$fe98a034cfb96d55)[token[0]](d, token, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, $303ba10db2c74ab4$exports.format)(date, formatStr, options);
}





function $fb3cb721acf1a13d$export$3ee79d090bac6d33(date, timeZone, options) {
    date = (0, $7a5e6daef75f68d9$export$e67a095c620b86fe)(date, options);
    const offsetMilliseconds = (0, $3a1a3d9713aae3cd$export$57649162eea44a93)(timeZone, date, true);
    const d = new Date(date.getTime() - offsetMilliseconds);
    const resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}


function $a5f134591027a97b$export$b3ea52468069e196(date, timeZone, formatStr, options) {
    options = {
        ...options,
        timeZone: timeZone,
        originalDate: date
    };
    return (0, $a752b949231e6c46$export$d9468344d3651243)((0, $fb3cb721acf1a13d$export$3ee79d090bac6d33)(date, timeZone, {
        timeZone: options.timeZone
    }), formatStr, options);
}






function $2b10790150509276$export$7e1e8af4bb294f2b(date, timeZone, options) {
    if (typeof date === 'string' && !date.match((0, $86f91a3c7f9a9743$export$a859e97a80802e41))) return (0, $7a5e6daef75f68d9$export$e67a095c620b86fe)(date, {
        ...options,
        timeZone: timeZone
    });
    date = (0, $7a5e6daef75f68d9$export$e67a095c620b86fe)(date, options);
    const utc = (0, $dbbc94b2c9b7796e$export$461165d00818234e)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()).getTime();
    const offsetMilliseconds = (0, $3a1a3d9713aae3cd$export$57649162eea44a93)(timeZone, new Date(utc));
    return new Date(utc + offsetMilliseconds);
}




function $6e6234d3ea1e6c23$export$4c9db454e2785fd9(timeZone, date) {
    return -(0, $3a1a3d9713aae3cd$export$57649162eea44a93)(timeZone, date);
}











class $493596557172d52c$export$ea9999dae6eb05c6 extends (0, $b0909b9e9a636c9e$export$41bbd75702e612ef) {
    constructor(mapData, mapID, display, player){
        const viewportWidth = mapData.viewportWidth ? mapData.viewportWidth : (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_VIEWPORT_WIDTH;
        const viewportHeight = mapData.viewportHeight ? mapData.viewportHeight : (0, $1a153cf88c479932$export$db8153d4765fc5bb).DEFAULT_VIEWPORT_HEIGHT;
        super(mapID, display, player, mapData.width, mapData.height, viewportWidth, viewportHeight, mapData.enableFogOfWar);
        // 1. Build rooms
        let rooms = this.buildRooms(mapData);
        // 2. Add maze room(s)
        if (mapData.mazeRooms !== undefined) {
            const mazeRoomIndexes = this.addMazeRooms(mapData.mazeRooms, rooms);
            // exclude maze rooms for rest of build
            rooms = rooms.filter((_, idx)=>mazeRoomIndexes.includes(idx) == false);
        }
        // 3. Place portals
        let startPoint = this.placePortals(mapData.portals, rooms);
        // 4. Place the player (+1 to move right of the portal)
        startPoint.x += 1;
        this.player.setPosition(startPoint);
        // 5. Place popup triggers
        if (mapData.popups !== undefined) this.placePopups(mapData.popups, rooms);
        // 6. Place pigments
        if (mapData.palette !== undefined) this.placePigments(mapData.palette, rooms);
        // 7. Place items
        if (mapData.items !== undefined) this.placeItems(mapData.items, rooms);
        // 8. Place equipment
        if (mapData.equipment !== undefined) this.placeEquipment(mapData.equipment, rooms);
        // 9. Place enemies
        if (mapData.enemies !== undefined) this.placeEnemies(mapData.enemies, rooms);
    }
    buildRooms(mapData) {
        if (mapData.rooms === undefined) throw new Error("Static map must have at least one room");
        let rooms = new Array(mapData.rooms.length);
        if (mapData.rooms !== undefined) mapData.rooms.forEach((room, index)=>{
            const x = room.x;
            const y = room.y;
            const newRoom = new (0, $482590bcd9882d9a$export$525628e68e798fb4)(x, y, room.width, room.height);
            this.addRoom(newRoom.x, newRoom.y, newRoom.tiles);
            rooms[index] = newRoom;
        });
        if (mapData.corridors !== undefined) mapData.corridors.forEach((corr)=>{
            const room = rooms[corr.room];
            const position = (0, $b0909b9e9a636c9e$export$1b54bd80463a60ae)(room, corr.entry);
            const length = corr.length;
            const dir = corr.direction;
            if (dir == (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).UP) for(let y = position.y; y > position.y - length; --y){
                this._tiles[y][position.x] = {
                    ...(0, $25f08219a36211c0$export$99f00248b59b2065)
                };
                this._tiles[y][position.x].visible = true;
            }
            else if (dir == (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).DOWN) for(let y = position.y; y < position.y + length; ++y){
                this._tiles[y][position.x] = {
                    ...(0, $25f08219a36211c0$export$99f00248b59b2065)
                };
                this._tiles[y][position.x].visible = true;
            }
            else if (dir == (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).LEFT) for(let x = position.x; x > position.x - length; --x){
                this._tiles[position.y][x] = {
                    ...(0, $25f08219a36211c0$export$99f00248b59b2065)
                };
                this._tiles[position.y][x].visible = true;
            }
            else if (dir == (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).RIGHT) for(let x = position.x; x < position.x + length; ++x){
                this._tiles[position.y][x] = {
                    ...(0, $25f08219a36211c0$export$99f00248b59b2065)
                };
                this._tiles[position.y][x].visible = true;
            }
        });
        if (mapData.doors !== undefined) {
            const now = (0, $fb3cb721acf1a13d$export$3ee79d090bac6d33)(Date.now(), "America/New_York");
            mapData.doors.forEach((d)=>{
                let canBeUnlocked = false;
                const unlockTime = (0, $fb3cb721acf1a13d$export$3ee79d090bac6d33)((0, $08eadd31071dba99$export$63fa379ae8a9ba2)((0, $b2d0c66f58a40ae9$export$4393d2ccbbedb219)(d.unlockDate)), "America/New_York");
                if ((0, $6a377fdb36b5bd3e$export$fe114145ae75d197)(now, unlockTime) == 1) canBeUnlocked = true;
                const position = (0, $b0909b9e9a636c9e$export$1b54bd80463a60ae)(rooms[d.room], d.location);
                this.addEntity(new (0, $73fbffeae5ed3875$export$97e98b0c09b627f4)(d.target, position, d.unlockDate, canBeUnlocked));
            });
        }
        return rooms;
    }
}



// function diggerOptions(
//   roomWidthRange: [number, number],
//   roomHeightRange: [number, number],
//   dugPercentage: number,
//   timeLimit: number
// ) {
//   return {
//     roomWidth: roomWidthRange,
//     roomHeight: roomHeightRange,
//     dugPercentage: dugPercentage,
//     timeLimit: timeLimit,
//   }
// }
function $b296c6d74f581bce$export$5eea3cd0211a0bd7(roomWidthRange, roomHeightRange, dugPercentage, timeLimit) {
    return {
        roomWidth: roomWidthRange,
        roomHeight: roomHeightRange,
        roomDugPercentage: dugPercentage,
        timeLimit: timeLimit
    };
}
function $b296c6d74f581bce$export$acb17e9331e64c57(mapWidth, mapHeight, roomWidthRange, roomHeightRange, dugPercentage, timeLimit) {
    // TODO: try different ROT.Map generators
    //
    const map = new (0, $df239f4fd3d66381$export$2e2bcd8739ae039).Uniform(mapWidth, mapHeight, $b296c6d74f581bce$export$5eea3cd0211a0bd7(roomWidthRange, roomHeightRange, dugPercentage, timeLimit));
    // const map = new Map.Digger(
    //   mapWidth,
    //   mapHeight,
    //   diggerOptions(roomWidthRange, roomWidthRange, dugPercentage, timeLimit)
    // )
    // tileset is the full width and height
    let tiles = new Array(mapHeight);
    for(let i = 0; i < mapHeight; ++i)tiles[i] = new Array(mapWidth);
    map.create((x, y, contents)=>{
        if (contents == 0) tiles[y][x] = {
            ...(0, $25f08219a36211c0$export$99f00248b59b2065)
        };
        else tiles[y][x] = {
            ...(0, $25f08219a36211c0$export$2307bef266fe885b)
        };
    });
    let rooms = [];
    map.getRooms().forEach((room)=>{
        const width = room.getRight() - room.getLeft();
        const height = room.getBottom() - room.getTop();
        const newRoom = new (0, $482590bcd9882d9a$export$525628e68e798fb4)(room.getLeft(), room.getTop(), width, height);
        rooms.push(newRoom);
    });
    return [
        rooms,
        tiles
    ];
}
function $b296c6d74f581bce$export$6f46047ee61f45d3(mapID) {
    switch(mapID){
        case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).Playground:
            return (0, $70726f29900f2aba$export$d545c020b8b7b251).playground;
        case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).January:
            return (0, $70726f29900f2aba$export$d545c020b8b7b251).january;
        case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).February:
            return (0, $70726f29900f2aba$export$d545c020b8b7b251).february;
        case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).March:
            return (0, $70726f29900f2aba$export$d545c020b8b7b251).march;
        case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).April:
            return (0, $70726f29900f2aba$export$d545c020b8b7b251).april;
        case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).May:
            return (0, $70726f29900f2aba$export$d545c020b8b7b251).may;
        case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).June:
            return (0, $70726f29900f2aba$export$d545c020b8b7b251).june;
        case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).July:
            return (0, $70726f29900f2aba$export$d545c020b8b7b251).july;
        case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).August:
            return (0, $70726f29900f2aba$export$d545c020b8b7b251).august;
        case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).September:
            return (0, $70726f29900f2aba$export$d545c020b8b7b251).september;
        case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).October:
            return (0, $70726f29900f2aba$export$d545c020b8b7b251).october;
        case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).November:
            return (0, $70726f29900f2aba$export$d545c020b8b7b251).november;
        case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).December:
            return (0, $70726f29900f2aba$export$d545c020b8b7b251).december;
        case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).Portals:
        default:
            return (0, $70726f29900f2aba$export$d545c020b8b7b251).portals;
    }
    return (0, $70726f29900f2aba$export$d545c020b8b7b251).portals;
}
function $b296c6d74f581bce$export$b41394a5437791c8(mapID, mapData, display, player, offsets) {
    if (mapData.type == (0, $f0b5fa422dff3899$export$ded4562bce86da45).STATIC) return new (0, $493596557172d52c$export$ea9999dae6eb05c6)(mapData, mapID, display, player);
    else return new (0, $6e99b65e9f82c196$export$1d61da4fb9a8035b)(mapData, mapID, display, player, offsets);
}
function $b296c6d74f581bce$export$32f6dae5310d379c(mapID) {
    let mapString = "Central Chamber";
    if (mapID == (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).Playground) mapString = "Playground";
    else if (mapID == (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).January) mapString = "January";
    else if (mapID == (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).February) mapString = "February";
    else if (mapID == (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).March) mapString = "March";
    else if (mapID == (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).April) mapString = "April";
    else if (mapID == (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).May) mapString = "May";
    else if (mapID == (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).June) mapString = "June";
    else if (mapID == (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).July) mapString = "July";
    else if (mapID == (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).August) mapString = "August";
    else if (mapID == (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).September) mapString = "September";
    else if (mapID == (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).October) mapString = "October";
    else if (mapID == (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).November) mapString = "November";
    else if (mapID == (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).December) mapString = "December";
    return mapString;
}



class $73fbffeae5ed3875$export$97e98b0c09b627f4 extends (0, $f35331c222125435$export$bc644a473284d944) {
    constructor(target, position, unlockDate, canBeUnlocked){
        super(position, true, {
            symbol: [
                (0, $eb9de8f5086455e8$export$3e25e887b7a5b37b).LOCKED_DOOR
            ],
            light: (0, $248954e6cbd64b56$export$892596cec99bc70e).LOCKED_DOOR,
            dark: (0, $248954e6cbd64b56$export$892596cec99bc70e).LOCKED_DOOR_DARK
        }, "Door to " + (0, $b296c6d74f581bce$export$32f6dae5310d379c)(target) + " (locked)"), this.target = target;
        this._canBeUnlocked = canBeUnlocked;
        this._unlockDate = unlockDate;
    }
    canBeUnlocked() {
        return this._canBeUnlocked;
    }
    getUnlockDate() {
        return this._unlockDate;
    }
}




var $f89d8ffbdc18f2ab$export$c9d39ca3bcd93abb;
var $f89d8ffbdc18f2ab$export$b791fe48eec8032a;
/*!
 *  howler.js v2.2.4
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */ (function() {
    'use strict';
    /** Global Methods **/ /***************************************************************************/ /**
   * Create the global controller. All contained methods and properties apply
   * to all sounds that are currently playing or will be in the future.
   */ var HowlerGlobal1 = function() {
        this.init();
    };
    HowlerGlobal1.prototype = {
        /**
     * Initialize the global Howler object.
     * @return {Howler}
     */ init: function() {
            var self = this || Howler1;
            // Create a global ID counter.
            self._counter = 1000;
            // Pool of unlocked HTML5 Audio objects.
            self._html5AudioPool = [];
            self.html5PoolSize = 10;
            // Internal properties.
            self._codecs = {};
            self._howls = [];
            self._muted = false;
            self._volume = 1;
            self._canPlayEvent = 'canplaythrough';
            self._navigator = typeof window !== 'undefined' && window.navigator ? window.navigator : null;
            // Public properties.
            self.masterGain = null;
            self.noAudio = false;
            self.usingWebAudio = true;
            self.autoSuspend = true;
            self.ctx = null;
            // Set to false to disable the auto audio unlocker.
            self.autoUnlock = true;
            // Setup the various state values for global tracking.
            self._setup();
            return self;
        },
        /**
     * Get/set the global volume for all sounds.
     * @param  {Float} vol Volume from 0.0 to 1.0.
     * @return {Howler/Float}     Returns self or current volume.
     */ volume: function(vol) {
            var self = this || Howler1;
            vol = parseFloat(vol);
            // If we don't have an AudioContext created yet, run the setup.
            if (!self.ctx) setupAudioContext();
            if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
                self._volume = vol;
                // Don't update any of the nodes if we are muted.
                if (self._muted) return self;
                // When using Web Audio, we just need to adjust the master gain.
                if (self.usingWebAudio) self.masterGain.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                // Loop through and change volume for all HTML5 audio nodes.
                for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                    // Get all of the sounds in this Howl group.
                    var ids = self._howls[i]._getSoundIds();
                    // Loop through all sounds and change the volumes.
                    for(var j = 0; j < ids.length; j++){
                        var sound = self._howls[i]._soundById(ids[j]);
                        if (sound && sound._node) sound._node.volume = sound._volume * vol;
                    }
                }
                return self;
            }
            return self._volume;
        },
        /**
     * Handle muting and unmuting globally.
     * @param  {Boolean} muted Is muted or not.
     */ mute: function(muted) {
            var self = this || Howler1;
            // If we don't have an AudioContext created yet, run the setup.
            if (!self.ctx) setupAudioContext();
            self._muted = muted;
            // With Web Audio, we just need to mute the master gain.
            if (self.usingWebAudio) self.masterGain.gain.setValueAtTime(muted ? 0 : self._volume, Howler1.ctx.currentTime);
            // Loop through and mute all HTML5 Audio nodes.
            for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                // Get all of the sounds in this Howl group.
                var ids = self._howls[i]._getSoundIds();
                // Loop through all sounds and mark the audio node as muted.
                for(var j = 0; j < ids.length; j++){
                    var sound = self._howls[i]._soundById(ids[j]);
                    if (sound && sound._node) sound._node.muted = muted ? true : sound._muted;
                }
            }
            return self;
        },
        /**
     * Handle stopping all sounds globally.
     */ stop: function() {
            var self = this || Howler1;
            // Loop through all Howls and stop them.
            for(var i = 0; i < self._howls.length; i++)self._howls[i].stop();
            return self;
        },
        /**
     * Unload and destroy all currently loaded Howl objects.
     * @return {Howler}
     */ unload: function() {
            var self = this || Howler1;
            for(var i = self._howls.length - 1; i >= 0; i--)self._howls[i].unload();
            // Create a new AudioContext to make sure it is fully reset.
            if (self.usingWebAudio && self.ctx && typeof self.ctx.close !== 'undefined') {
                self.ctx.close();
                self.ctx = null;
                setupAudioContext();
            }
            return self;
        },
        /**
     * Check for codec support of specific extension.
     * @param  {String} ext Audio file extention.
     * @return {Boolean}
     */ codecs: function(ext) {
            return (this || Howler1)._codecs[ext.replace(/^x-/, '')];
        },
        /**
     * Setup various state values for global tracking.
     * @return {Howler}
     */ _setup: function() {
            var self = this || Howler1;
            // Keeps track of the suspend/resume state of the AudioContext.
            self.state = self.ctx ? self.ctx.state || 'suspended' : 'suspended';
            // Automatically begin the 30-second suspend process
            self._autoSuspend();
            // Check if audio is available.
            if (!self.usingWebAudio) {
                // No audio is available on this system if noAudio is set to true.
                if (typeof Audio !== 'undefined') try {
                    var test = new Audio();
                    // Check if the canplaythrough event is available.
                    if (typeof test.oncanplaythrough === 'undefined') self._canPlayEvent = 'canplay';
                } catch (e) {
                    self.noAudio = true;
                }
                else self.noAudio = true;
            }
            // Test to make sure audio isn't disabled in Internet Explorer.
            try {
                var test = new Audio();
                if (test.muted) self.noAudio = true;
            } catch (e) {}
            // Check for supported codecs.
            if (!self.noAudio) self._setupCodecs();
            return self;
        },
        /**
     * Check for browser support for various codecs and cache the results.
     * @return {Howler}
     */ _setupCodecs: function() {
            var self = this || Howler1;
            var audioTest = null;
            // Must wrap in a try/catch because IE11 in server mode throws an error.
            try {
                audioTest = typeof Audio !== 'undefined' ? new Audio() : null;
            } catch (err) {
                return self;
            }
            if (!audioTest || typeof audioTest.canPlayType !== 'function') return self;
            var mpegTest = audioTest.canPlayType('audio/mpeg;').replace(/^no$/, '');
            // Opera version <33 has mixed MP3 support, so we need to check for and block it.
            var ua = self._navigator ? self._navigator.userAgent : '';
            var checkOpera = ua.match(/OPR\/(\d+)/g);
            var isOldOpera = checkOpera && parseInt(checkOpera[0].split('/')[1], 10) < 33;
            var checkSafari = ua.indexOf('Safari') !== -1 && ua.indexOf('Chrome') === -1;
            var safariVersion = ua.match(/Version\/(.*?) /);
            var isOldSafari = checkSafari && safariVersion && parseInt(safariVersion[1], 10) < 15;
            self._codecs = {
                mp3: !!(!isOldOpera && (mpegTest || audioTest.canPlayType('audio/mp3;').replace(/^no$/, ''))),
                mpeg: !!mpegTest,
                opus: !!audioTest.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ''),
                ogg: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
                oga: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
                wav: !!(audioTest.canPlayType('audio/wav; codecs="1"') || audioTest.canPlayType('audio/wav')).replace(/^no$/, ''),
                aac: !!audioTest.canPlayType('audio/aac;').replace(/^no$/, ''),
                caf: !!audioTest.canPlayType('audio/x-caf;').replace(/^no$/, ''),
                m4a: !!(audioTest.canPlayType('audio/x-m4a;') || audioTest.canPlayType('audio/m4a;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
                m4b: !!(audioTest.canPlayType('audio/x-m4b;') || audioTest.canPlayType('audio/m4b;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
                mp4: !!(audioTest.canPlayType('audio/x-mp4;') || audioTest.canPlayType('audio/mp4;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
                weba: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, '')),
                webm: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, '')),
                dolby: !!audioTest.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, ''),
                flac: !!(audioTest.canPlayType('audio/x-flac;') || audioTest.canPlayType('audio/flac;')).replace(/^no$/, '')
            };
            return self;
        },
        /**
     * Some browsers/devices will only allow audio to be played after a user interaction.
     * Attempt to automatically unlock audio on the first user interaction.
     * Concept from: http://paulbakaus.com/tutorials/html5/web-audio-on-ios/
     * @return {Howler}
     */ _unlockAudio: function() {
            var self = this || Howler1;
            // Only run this if Web Audio is supported and it hasn't already been unlocked.
            if (self._audioUnlocked || !self.ctx) return;
            self._audioUnlocked = false;
            self.autoUnlock = false;
            // Some mobile devices/platforms have distortion issues when opening/closing tabs and/or web views.
            // Bugs in the browser (especially Mobile Safari) can cause the sampleRate to change from 44100 to 48000.
            // By calling Howler.unload(), we create a new AudioContext with the correct sampleRate.
            if (!self._mobileUnloaded && self.ctx.sampleRate !== 44100) {
                self._mobileUnloaded = true;
                self.unload();
            }
            // Scratch buffer for enabling iOS to dispose of web audio buffers correctly, as per:
            // http://stackoverflow.com/questions/24119684
            self._scratchBuffer = self.ctx.createBuffer(1, 1, 22050);
            // Call this method on touch start to create and play a buffer,
            // then check if the audio actually played to determine if
            // audio has now been unlocked on iOS, Android, etc.
            var unlock = function(e) {
                // Create a pool of unlocked HTML5 Audio objects that can
                // be used for playing sounds without user interaction. HTML5
                // Audio objects must be individually unlocked, as opposed
                // to the WebAudio API which only needs a single activation.
                // This must occur before WebAudio setup or the source.onended
                // event will not fire.
                while(self._html5AudioPool.length < self.html5PoolSize)try {
                    var audioNode = new Audio();
                    // Mark this Audio object as unlocked to ensure it can get returned
                    // to the unlocked pool when released.
                    audioNode._unlocked = true;
                    // Add the audio node to the pool.
                    self._releaseHtml5Audio(audioNode);
                } catch (e) {
                    self.noAudio = true;
                    break;
                }
                // Loop through any assigned audio nodes and unlock them.
                for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                    // Get all of the sounds in this Howl group.
                    var ids = self._howls[i]._getSoundIds();
                    // Loop through all sounds and unlock the audio nodes.
                    for(var j = 0; j < ids.length; j++){
                        var sound = self._howls[i]._soundById(ids[j]);
                        if (sound && sound._node && !sound._node._unlocked) {
                            sound._node._unlocked = true;
                            sound._node.load();
                        }
                    }
                }
                // Fix Android can not play in suspend state.
                self._autoResume();
                // Create an empty buffer.
                var source = self.ctx.createBufferSource();
                source.buffer = self._scratchBuffer;
                source.connect(self.ctx.destination);
                // Play the empty buffer.
                if (typeof source.start === 'undefined') source.noteOn(0);
                else source.start(0);
                // Calling resume() on a stack initiated by user gesture is what actually unlocks the audio on Android Chrome >= 55.
                if (typeof self.ctx.resume === 'function') self.ctx.resume();
                // Setup a timeout to check that we are unlocked on the next event loop.
                source.onended = function() {
                    source.disconnect(0);
                    // Update the unlocked state and prevent this check from happening again.
                    self._audioUnlocked = true;
                    // Remove the touch start listener.
                    document.removeEventListener('touchstart', unlock, true);
                    document.removeEventListener('touchend', unlock, true);
                    document.removeEventListener('click', unlock, true);
                    document.removeEventListener('keydown', unlock, true);
                    // Let all sounds know that audio has been unlocked.
                    for(var i = 0; i < self._howls.length; i++)self._howls[i]._emit('unlock');
                };
            };
            // Setup a touch start listener to attempt an unlock in.
            document.addEventListener('touchstart', unlock, true);
            document.addEventListener('touchend', unlock, true);
            document.addEventListener('click', unlock, true);
            document.addEventListener('keydown', unlock, true);
            return self;
        },
        /**
     * Get an unlocked HTML5 Audio object from the pool. If none are left,
     * return a new Audio object and throw a warning.
     * @return {Audio} HTML5 Audio object.
     */ _obtainHtml5Audio: function() {
            var self = this || Howler1;
            // Return the next object from the pool if one exists.
            if (self._html5AudioPool.length) return self._html5AudioPool.pop();
            //.Check if the audio is locked and throw a warning.
            var testPlay = new Audio().play();
            if (testPlay && typeof Promise !== 'undefined' && (testPlay instanceof Promise || typeof testPlay.then === 'function')) testPlay.catch(function() {
                console.warn('HTML5 Audio pool exhausted, returning potentially locked audio object.');
            });
            return new Audio();
        },
        /**
     * Return an activated HTML5 Audio object to the pool.
     * @return {Howler}
     */ _releaseHtml5Audio: function(audio) {
            var self = this || Howler1;
            // Don't add audio to the pool if we don't know if it has been unlocked.
            if (audio._unlocked) self._html5AudioPool.push(audio);
            return self;
        },
        /**
     * Automatically suspend the Web Audio AudioContext after no sound has played for 30 seconds.
     * This saves processing/energy and fixes various browser-specific bugs with audio getting stuck.
     * @return {Howler}
     */ _autoSuspend: function() {
            var self = this;
            if (!self.autoSuspend || !self.ctx || typeof self.ctx.suspend === 'undefined' || !Howler1.usingWebAudio) return;
            // Check if any sounds are playing.
            for(var i = 0; i < self._howls.length; i++){
                if (self._howls[i]._webAudio) for(var j = 0; j < self._howls[i]._sounds.length; j++){
                    if (!self._howls[i]._sounds[j]._paused) return self;
                }
            }
            if (self._suspendTimer) clearTimeout(self._suspendTimer);
            // If no sound has played after 30 seconds, suspend the context.
            self._suspendTimer = setTimeout(function() {
                if (!self.autoSuspend) return;
                self._suspendTimer = null;
                self.state = 'suspending';
                // Handle updating the state of the audio context after suspending.
                var handleSuspension = function() {
                    self.state = 'suspended';
                    if (self._resumeAfterSuspend) {
                        delete self._resumeAfterSuspend;
                        self._autoResume();
                    }
                };
                // Either the state gets suspended or it is interrupted.
                // Either way, we need to update the state to suspended.
                self.ctx.suspend().then(handleSuspension, handleSuspension);
            }, 30000);
            return self;
        },
        /**
     * Automatically resume the Web Audio AudioContext when a new sound is played.
     * @return {Howler}
     */ _autoResume: function() {
            var self = this;
            if (!self.ctx || typeof self.ctx.resume === 'undefined' || !Howler1.usingWebAudio) return;
            if (self.state === 'running' && self.ctx.state !== 'interrupted' && self._suspendTimer) {
                clearTimeout(self._suspendTimer);
                self._suspendTimer = null;
            } else if (self.state === 'suspended' || self.state === 'running' && self.ctx.state === 'interrupted') {
                self.ctx.resume().then(function() {
                    self.state = 'running';
                    // Emit to all Howls that the audio has resumed.
                    for(var i = 0; i < self._howls.length; i++)self._howls[i]._emit('resume');
                });
                if (self._suspendTimer) {
                    clearTimeout(self._suspendTimer);
                    self._suspendTimer = null;
                }
            } else if (self.state === 'suspending') self._resumeAfterSuspend = true;
            return self;
        }
    };
    // Setup the global audio controller.
    var Howler1 = new HowlerGlobal1();
    /** Group Methods **/ /***************************************************************************/ /**
   * Create an audio group controller.
   * @param {Object} o Passed in properties for this group.
   */ var Howl1 = function(o) {
        var self = this;
        // Throw an error if no source is provided.
        if (!o.src || o.src.length === 0) {
            console.error('An array of source files must be passed with any new Howl.');
            return;
        }
        self.init(o);
    };
    Howl1.prototype = {
        /**
     * Initialize a new Howl group object.
     * @param  {Object} o Passed in properties for this group.
     * @return {Howl}
     */ init: function(o) {
            var self = this;
            // If we don't have an AudioContext created yet, run the setup.
            if (!Howler1.ctx) setupAudioContext();
            // Setup user-defined default properties.
            self._autoplay = o.autoplay || false;
            self._format = typeof o.format !== 'string' ? o.format : [
                o.format
            ];
            self._html5 = o.html5 || false;
            self._muted = o.mute || false;
            self._loop = o.loop || false;
            self._pool = o.pool || 5;
            self._preload = typeof o.preload === 'boolean' || o.preload === 'metadata' ? o.preload : true;
            self._rate = o.rate || 1;
            self._sprite = o.sprite || {};
            self._src = typeof o.src !== 'string' ? o.src : [
                o.src
            ];
            self._volume = o.volume !== undefined ? o.volume : 1;
            self._xhr = {
                method: o.xhr && o.xhr.method ? o.xhr.method : 'GET',
                headers: o.xhr && o.xhr.headers ? o.xhr.headers : null,
                withCredentials: o.xhr && o.xhr.withCredentials ? o.xhr.withCredentials : false
            };
            // Setup all other default properties.
            self._duration = 0;
            self._state = 'unloaded';
            self._sounds = [];
            self._endTimers = {};
            self._queue = [];
            self._playLock = false;
            // Setup event listeners.
            self._onend = o.onend ? [
                {
                    fn: o.onend
                }
            ] : [];
            self._onfade = o.onfade ? [
                {
                    fn: o.onfade
                }
            ] : [];
            self._onload = o.onload ? [
                {
                    fn: o.onload
                }
            ] : [];
            self._onloaderror = o.onloaderror ? [
                {
                    fn: o.onloaderror
                }
            ] : [];
            self._onplayerror = o.onplayerror ? [
                {
                    fn: o.onplayerror
                }
            ] : [];
            self._onpause = o.onpause ? [
                {
                    fn: o.onpause
                }
            ] : [];
            self._onplay = o.onplay ? [
                {
                    fn: o.onplay
                }
            ] : [];
            self._onstop = o.onstop ? [
                {
                    fn: o.onstop
                }
            ] : [];
            self._onmute = o.onmute ? [
                {
                    fn: o.onmute
                }
            ] : [];
            self._onvolume = o.onvolume ? [
                {
                    fn: o.onvolume
                }
            ] : [];
            self._onrate = o.onrate ? [
                {
                    fn: o.onrate
                }
            ] : [];
            self._onseek = o.onseek ? [
                {
                    fn: o.onseek
                }
            ] : [];
            self._onunlock = o.onunlock ? [
                {
                    fn: o.onunlock
                }
            ] : [];
            self._onresume = [];
            // Web Audio or HTML5 Audio?
            self._webAudio = Howler1.usingWebAudio && !self._html5;
            // Automatically try to enable audio.
            if (typeof Howler1.ctx !== 'undefined' && Howler1.ctx && Howler1.autoUnlock) Howler1._unlockAudio();
            // Keep track of this Howl group in the global controller.
            Howler1._howls.push(self);
            // If they selected autoplay, add a play event to the load queue.
            if (self._autoplay) self._queue.push({
                event: 'play',
                action: function() {
                    self.play();
                }
            });
            // Load the source file unless otherwise specified.
            if (self._preload && self._preload !== 'none') self.load();
            return self;
        },
        /**
     * Load the audio file.
     * @return {Howler}
     */ load: function() {
            var self = this;
            var url = null;
            // If no audio is available, quit immediately.
            if (Howler1.noAudio) {
                self._emit('loaderror', null, 'No audio support.');
                return;
            }
            // Make sure our source is in an array.
            if (typeof self._src === 'string') self._src = [
                self._src
            ];
            // Loop through the sources and pick the first one that is compatible.
            for(var i = 0; i < self._src.length; i++){
                var ext, str;
                if (self._format && self._format[i]) // If an extension was specified, use that instead.
                ext = self._format[i];
                else {
                    // Make sure the source is a string.
                    str = self._src[i];
                    if (typeof str !== 'string') {
                        self._emit('loaderror', null, 'Non-string found in selected audio sources - ignoring.');
                        continue;
                    }
                    // Extract the file extension from the URL or base64 data URI.
                    ext = /^data:audio\/([^;,]+);/i.exec(str);
                    if (!ext) ext = /\.([^.]+)$/.exec(str.split('?', 1)[0]);
                    if (ext) ext = ext[1].toLowerCase();
                }
                // Log a warning if no extension was found.
                if (!ext) console.warn('No file extension was found. Consider using the "format" property or specify an extension.');
                // Check if this extension is available.
                if (ext && Howler1.codecs(ext)) {
                    url = self._src[i];
                    break;
                }
            }
            if (!url) {
                self._emit('loaderror', null, 'No codec support for selected audio sources.');
                return;
            }
            self._src = url;
            self._state = 'loading';
            // If the hosting page is HTTPS and the source isn't,
            // drop down to HTML5 Audio to avoid Mixed Content errors.
            if (window.location.protocol === 'https:' && url.slice(0, 5) === 'http:') {
                self._html5 = true;
                self._webAudio = false;
            }
            // Create a new sound object and add it to the pool.
            new Sound1(self);
            // Load and decode the audio data for playback.
            if (self._webAudio) loadBuffer(self);
            return self;
        },
        /**
     * Play a sound or resume previous playback.
     * @param  {String/Number} sprite   Sprite name for sprite playback or sound id to continue previous.
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Number}          Sound ID.
     */ play: function(sprite, internal) {
            var self = this;
            var id = null;
            // Determine if a sprite, sound id or nothing was passed
            if (typeof sprite === 'number') {
                id = sprite;
                sprite = null;
            } else if (typeof sprite === 'string' && self._state === 'loaded' && !self._sprite[sprite]) // If the passed sprite doesn't exist, do nothing.
            return null;
            else if (typeof sprite === 'undefined') {
                // Use the default sound sprite (plays the full audio length).
                sprite = '__default';
                // Check if there is a single paused sound that isn't ended.
                // If there is, play that sound. If not, continue as usual.
                if (!self._playLock) {
                    var num = 0;
                    for(var i = 0; i < self._sounds.length; i++)if (self._sounds[i]._paused && !self._sounds[i]._ended) {
                        num++;
                        id = self._sounds[i]._id;
                    }
                    if (num === 1) sprite = null;
                    else id = null;
                }
            }
            // Get the selected node, or get one from the pool.
            var sound = id ? self._soundById(id) : self._inactiveSound();
            // If the sound doesn't exist, do nothing.
            if (!sound) return null;
            // Select the sprite definition.
            if (id && !sprite) sprite = sound._sprite || '__default';
            // If the sound hasn't loaded, we must wait to get the audio's duration.
            // We also need to wait to make sure we don't run into race conditions with
            // the order of function calls.
            if (self._state !== 'loaded') {
                // Set the sprite value on this sound.
                sound._sprite = sprite;
                // Mark this sound as not ended in case another sound is played before this one loads.
                sound._ended = false;
                // Add the sound to the queue to be played on load.
                var soundId = sound._id;
                self._queue.push({
                    event: 'play',
                    action: function() {
                        self.play(soundId);
                    }
                });
                return soundId;
            }
            // Don't play the sound if an id was passed and it is already playing.
            if (id && !sound._paused) {
                // Trigger the play event, in order to keep iterating through queue.
                if (!internal) self._loadQueue('play');
                return sound._id;
            }
            // Make sure the AudioContext isn't suspended, and resume it if it is.
            if (self._webAudio) Howler1._autoResume();
            // Determine how long to play for and where to start playing.
            var seek = Math.max(0, sound._seek > 0 ? sound._seek : self._sprite[sprite][0] / 1000);
            var duration = Math.max(0, (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000 - seek);
            var timeout = duration * 1000 / Math.abs(sound._rate);
            var start = self._sprite[sprite][0] / 1000;
            var stop = (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000;
            sound._sprite = sprite;
            // Mark the sound as ended instantly so that this async playback
            // doesn't get grabbed by another call to play while this one waits to start.
            sound._ended = false;
            // Update the parameters of the sound.
            var setParams = function() {
                sound._paused = false;
                sound._seek = seek;
                sound._start = start;
                sound._stop = stop;
                sound._loop = !!(sound._loop || self._sprite[sprite][2]);
            };
            // End the sound instantly if seek is at the end.
            if (seek >= stop) {
                self._ended(sound);
                return;
            }
            // Begin the actual playback.
            var node = sound._node;
            if (self._webAudio) {
                // Fire this when the sound is ready to play to begin Web Audio playback.
                var playWebAudio = function() {
                    self._playLock = false;
                    setParams();
                    self._refreshBuffer(sound);
                    // Setup the playback params.
                    var vol = sound._muted || self._muted ? 0 : sound._volume;
                    node.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                    sound._playStart = Howler1.ctx.currentTime;
                    // Play the sound using the supported method.
                    if (typeof node.bufferSource.start === 'undefined') sound._loop ? node.bufferSource.noteGrainOn(0, seek, 86400) : node.bufferSource.noteGrainOn(0, seek, duration);
                    else sound._loop ? node.bufferSource.start(0, seek, 86400) : node.bufferSource.start(0, seek, duration);
                    // Start a new timer if none is present.
                    if (timeout !== Infinity) self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
                    if (!internal) setTimeout(function() {
                        self._emit('play', sound._id);
                        self._loadQueue();
                    }, 0);
                };
                if (Howler1.state === 'running' && Howler1.ctx.state !== 'interrupted') playWebAudio();
                else {
                    self._playLock = true;
                    // Wait for the audio context to resume before playing.
                    self.once('resume', playWebAudio);
                    // Cancel the end timer.
                    self._clearTimer(sound._id);
                }
            } else {
                // Fire this when the sound is ready to play to begin HTML5 Audio playback.
                var playHtml5 = function() {
                    node.currentTime = seek;
                    node.muted = sound._muted || self._muted || Howler1._muted || node.muted;
                    node.volume = sound._volume * Howler1.volume();
                    node.playbackRate = sound._rate;
                    // Some browsers will throw an error if this is called without user interaction.
                    try {
                        var play = node.play();
                        // Support older browsers that don't support promises, and thus don't have this issue.
                        if (play && typeof Promise !== 'undefined' && (play instanceof Promise || typeof play.then === 'function')) {
                            // Implements a lock to prevent DOMException: The play() request was interrupted by a call to pause().
                            self._playLock = true;
                            // Set param values immediately.
                            setParams();
                            // Releases the lock and executes queued actions.
                            play.then(function() {
                                self._playLock = false;
                                node._unlocked = true;
                                if (!internal) self._emit('play', sound._id);
                                else self._loadQueue();
                            }).catch(function() {
                                self._playLock = false;
                                self._emit('playerror', sound._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                                // Reset the ended and paused values.
                                sound._ended = true;
                                sound._paused = true;
                            });
                        } else if (!internal) {
                            self._playLock = false;
                            setParams();
                            self._emit('play', sound._id);
                        }
                        // Setting rate before playing won't work in IE, so we set it again here.
                        node.playbackRate = sound._rate;
                        // If the node is still paused, then we can assume there was a playback issue.
                        if (node.paused) {
                            self._emit('playerror', sound._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                            return;
                        }
                        // Setup the end timer on sprites or listen for the ended event.
                        if (sprite !== '__default' || sound._loop) self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
                        else {
                            self._endTimers[sound._id] = function() {
                                // Fire ended on this audio node.
                                self._ended(sound);
                                // Clear this listener.
                                node.removeEventListener('ended', self._endTimers[sound._id], false);
                            };
                            node.addEventListener('ended', self._endTimers[sound._id], false);
                        }
                    } catch (err) {
                        self._emit('playerror', sound._id, err);
                    }
                };
                // If this is streaming audio, make sure the src is set and load again.
                if (node.src === 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA') {
                    node.src = self._src;
                    node.load();
                }
                // Play immediately if ready, or wait for the 'canplaythrough'e vent.
                var loadedNoReadyState = window && window.ejecta || !node.readyState && Howler1._navigator.isCocoonJS;
                if (node.readyState >= 3 || loadedNoReadyState) playHtml5();
                else {
                    self._playLock = true;
                    self._state = 'loading';
                    var listener = function() {
                        self._state = 'loaded';
                        // Begin playback.
                        playHtml5();
                        // Clear this listener.
                        node.removeEventListener(Howler1._canPlayEvent, listener, false);
                    };
                    node.addEventListener(Howler1._canPlayEvent, listener, false);
                    // Cancel the end timer.
                    self._clearTimer(sound._id);
                }
            }
            return sound._id;
        },
        /**
     * Pause playback and save current position.
     * @param  {Number} id The sound ID (empty to pause all in group).
     * @return {Howl}
     */ pause: function(id) {
            var self = this;
            // If the sound hasn't loaded or a play() promise is pending, add it to the load queue to pause when capable.
            if (self._state !== 'loaded' || self._playLock) {
                self._queue.push({
                    event: 'pause',
                    action: function() {
                        self.pause(id);
                    }
                });
                return self;
            }
            // If no id is passed, get all ID's to be paused.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Clear the end timer.
                self._clearTimer(ids[i]);
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound && !sound._paused) {
                    // Reset the seek position.
                    sound._seek = self.seek(ids[i]);
                    sound._rateSeek = 0;
                    sound._paused = true;
                    // Stop currently running fades.
                    self._stopFade(ids[i]);
                    if (sound._node) {
                        if (self._webAudio) {
                            // Make sure the sound has been created.
                            if (!sound._node.bufferSource) continue;
                            if (typeof sound._node.bufferSource.stop === 'undefined') sound._node.bufferSource.noteOff(0);
                            else sound._node.bufferSource.stop(0);
                            // Clean up the buffer source.
                            self._cleanBuffer(sound._node);
                        } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) sound._node.pause();
                    }
                }
                // Fire the pause event, unless `true` is passed as the 2nd argument.
                if (!arguments[1]) self._emit('pause', sound ? sound._id : null);
            }
            return self;
        },
        /**
     * Stop playback and reset to start.
     * @param  {Number} id The sound ID (empty to stop all in group).
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Howl}
     */ stop: function(id, internal) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to stop when capable.
            if (self._state !== 'loaded' || self._playLock) {
                self._queue.push({
                    event: 'stop',
                    action: function() {
                        self.stop(id);
                    }
                });
                return self;
            }
            // If no id is passed, get all ID's to be stopped.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Clear the end timer.
                self._clearTimer(ids[i]);
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound) {
                    // Reset the seek position.
                    sound._seek = sound._start || 0;
                    sound._rateSeek = 0;
                    sound._paused = true;
                    sound._ended = true;
                    // Stop currently running fades.
                    self._stopFade(ids[i]);
                    if (sound._node) {
                        if (self._webAudio) // Make sure the sound's AudioBufferSourceNode has been created.
                        {
                            if (sound._node.bufferSource) {
                                if (typeof sound._node.bufferSource.stop === 'undefined') sound._node.bufferSource.noteOff(0);
                                else sound._node.bufferSource.stop(0);
                                // Clean up the buffer source.
                                self._cleanBuffer(sound._node);
                            }
                        } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
                            sound._node.currentTime = sound._start || 0;
                            sound._node.pause();
                            // If this is a live stream, stop download once the audio is stopped.
                            if (sound._node.duration === Infinity) self._clearSound(sound._node);
                        }
                    }
                    if (!internal) self._emit('stop', sound._id);
                }
            }
            return self;
        },
        /**
     * Mute/unmute a single sound or all sounds in this Howl group.
     * @param  {Boolean} muted Set to true to mute and false to unmute.
     * @param  {Number} id    The sound ID to update (omit to mute/unmute all).
     * @return {Howl}
     */ mute: function(muted, id) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to mute when capable.
            if (self._state !== 'loaded' || self._playLock) {
                self._queue.push({
                    event: 'mute',
                    action: function() {
                        self.mute(muted, id);
                    }
                });
                return self;
            }
            // If applying mute/unmute to all sounds, update the group's value.
            if (typeof id === 'undefined') {
                if (typeof muted === 'boolean') self._muted = muted;
                else return self._muted;
            }
            // If no id is passed, get all ID's to be muted.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound) {
                    sound._muted = muted;
                    // Cancel active fade and set the volume to the end value.
                    if (sound._interval) self._stopFade(sound._id);
                    if (self._webAudio && sound._node) sound._node.gain.setValueAtTime(muted ? 0 : sound._volume, Howler1.ctx.currentTime);
                    else if (sound._node) sound._node.muted = Howler1._muted ? true : muted;
                    self._emit('mute', sound._id);
                }
            }
            return self;
        },
        /**
     * Get/set the volume of this sound or of the Howl group. This method can optionally take 0, 1 or 2 arguments.
     *   volume() -> Returns the group's volume value.
     *   volume(id) -> Returns the sound id's current volume.
     *   volume(vol) -> Sets the volume of all sounds in this Howl group.
     *   volume(vol, id) -> Sets the volume of passed sound id.
     * @return {Howl/Number} Returns self or current volume.
     */ volume: function() {
            var self = this;
            var args = arguments;
            var vol, id;
            // Determine the values based on arguments.
            if (args.length === 0) // Return the value of the groups' volume.
            return self._volume;
            else if (args.length === 1 || args.length === 2 && typeof args[1] === 'undefined') {
                // First check if this is an ID, and if not, assume it is a new volume.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else vol = parseFloat(args[0]);
            } else if (args.length >= 2) {
                vol = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // Update the volume or return the current volume.
            var sound;
            if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
                // If the sound hasn't loaded, add it to the load queue to change volume when capable.
                if (self._state !== 'loaded' || self._playLock) {
                    self._queue.push({
                        event: 'volume',
                        action: function() {
                            self.volume.apply(self, args);
                        }
                    });
                    return self;
                }
                // Set the group volume.
                if (typeof id === 'undefined') self._volume = vol;
                // Update one or all volumes.
                id = self._getSoundIds(id);
                for(var i = 0; i < id.length; i++){
                    // Get the sound.
                    sound = self._soundById(id[i]);
                    if (sound) {
                        sound._volume = vol;
                        // Stop currently running fades.
                        if (!args[2]) self._stopFade(id[i]);
                        if (self._webAudio && sound._node && !sound._muted) sound._node.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                        else if (sound._node && !sound._muted) sound._node.volume = vol * Howler1.volume();
                        self._emit('volume', sound._id);
                    }
                }
            } else {
                sound = id ? self._soundById(id) : self._sounds[0];
                return sound ? sound._volume : 0;
            }
            return self;
        },
        /**
     * Fade a currently playing sound between two volumes (if no id is passed, all sounds will fade).
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id (omit to fade all sounds).
     * @return {Howl}
     */ fade: function(from, to, len, id) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to fade when capable.
            if (self._state !== 'loaded' || self._playLock) {
                self._queue.push({
                    event: 'fade',
                    action: function() {
                        self.fade(from, to, len, id);
                    }
                });
                return self;
            }
            // Make sure the to/from/len values are numbers.
            from = Math.min(Math.max(0, parseFloat(from)), 1);
            to = Math.min(Math.max(0, parseFloat(to)), 1);
            len = parseFloat(len);
            // Set the volume to the start position.
            self.volume(from, id);
            // Fade the volume of one or all sounds.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Get the sound.
                var sound = self._soundById(ids[i]);
                // Create a linear fade or fall back to timeouts with HTML5 Audio.
                if (sound) {
                    // Stop the previous fade if no sprite is being used (otherwise, volume handles this).
                    if (!id) self._stopFade(ids[i]);
                    // If we are using Web Audio, let the native methods do the actual fade.
                    if (self._webAudio && !sound._muted) {
                        var currentTime = Howler1.ctx.currentTime;
                        var end = currentTime + len / 1000;
                        sound._volume = from;
                        sound._node.gain.setValueAtTime(from, currentTime);
                        sound._node.gain.linearRampToValueAtTime(to, end);
                    }
                    self._startFadeInterval(sound, from, to, len, ids[i], typeof id === 'undefined');
                }
            }
            return self;
        },
        /**
     * Starts the internal interval to fade a sound.
     * @param  {Object} sound Reference to sound to fade.
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id to fade.
     * @param  {Boolean} isGroup   If true, set the volume on the group.
     */ _startFadeInterval: function(sound, from, to, len, id, isGroup) {
            var self = this;
            var vol = from;
            var diff = to - from;
            var steps = Math.abs(diff / 0.01);
            var stepLen = Math.max(4, steps > 0 ? len / steps : len);
            var lastTick = Date.now();
            // Store the value being faded to.
            sound._fadeTo = to;
            // Update the volume value on each interval tick.
            sound._interval = setInterval(function() {
                // Update the volume based on the time since the last tick.
                var tick = (Date.now() - lastTick) / len;
                lastTick = Date.now();
                vol += diff * tick;
                // Round to within 2 decimal points.
                vol = Math.round(vol * 100) / 100;
                // Make sure the volume is in the right bounds.
                if (diff < 0) vol = Math.max(to, vol);
                else vol = Math.min(to, vol);
                // Change the volume.
                if (self._webAudio) sound._volume = vol;
                else self.volume(vol, sound._id, true);
                // Set the group's volume.
                if (isGroup) self._volume = vol;
                // When the fade is complete, stop it and fire event.
                if (to < from && vol <= to || to > from && vol >= to) {
                    clearInterval(sound._interval);
                    sound._interval = null;
                    sound._fadeTo = null;
                    self.volume(to, sound._id);
                    self._emit('fade', sound._id);
                }
            }, stepLen);
        },
        /**
     * Internal method that stops the currently playing fade when
     * a new fade starts, volume is changed or the sound is stopped.
     * @param  {Number} id The sound id.
     * @return {Howl}
     */ _stopFade: function(id) {
            var self = this;
            var sound = self._soundById(id);
            if (sound && sound._interval) {
                if (self._webAudio) sound._node.gain.cancelScheduledValues(Howler1.ctx.currentTime);
                clearInterval(sound._interval);
                sound._interval = null;
                self.volume(sound._fadeTo, id);
                sound._fadeTo = null;
                self._emit('fade', id);
            }
            return self;
        },
        /**
     * Get/set the loop parameter on a sound. This method can optionally take 0, 1 or 2 arguments.
     *   loop() -> Returns the group's loop value.
     *   loop(id) -> Returns the sound id's loop value.
     *   loop(loop) -> Sets the loop value for all sounds in this Howl group.
     *   loop(loop, id) -> Sets the loop value of passed sound id.
     * @return {Howl/Boolean} Returns self or current loop value.
     */ loop: function() {
            var self = this;
            var args = arguments;
            var loop, id, sound;
            // Determine the values for loop and id.
            if (args.length === 0) // Return the grou's loop value.
            return self._loop;
            else if (args.length === 1) {
                if (typeof args[0] === 'boolean') {
                    loop = args[0];
                    self._loop = loop;
                } else {
                    // Return this sound's loop value.
                    sound = self._soundById(parseInt(args[0], 10));
                    return sound ? sound._loop : false;
                }
            } else if (args.length === 2) {
                loop = args[0];
                id = parseInt(args[1], 10);
            }
            // If no id is passed, get all ID's to be looped.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                sound = self._soundById(ids[i]);
                if (sound) {
                    sound._loop = loop;
                    if (self._webAudio && sound._node && sound._node.bufferSource) {
                        sound._node.bufferSource.loop = loop;
                        if (loop) {
                            sound._node.bufferSource.loopStart = sound._start || 0;
                            sound._node.bufferSource.loopEnd = sound._stop;
                            // If playing, restart playback to ensure looping updates.
                            if (self.playing(ids[i])) {
                                self.pause(ids[i], true);
                                self.play(ids[i], true);
                            }
                        }
                    }
                }
            }
            return self;
        },
        /**
     * Get/set the playback rate of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   rate() -> Returns the first sound node's current playback rate.
     *   rate(id) -> Returns the sound id's current playback rate.
     *   rate(rate) -> Sets the playback rate of all sounds in this Howl group.
     *   rate(rate, id) -> Sets the playback rate of passed sound id.
     * @return {Howl/Number} Returns self or the current playback rate.
     */ rate: function() {
            var self = this;
            var args = arguments;
            var rate, id;
            // Determine the values based on arguments.
            if (args.length === 0) // We will simply return the current rate of the first node.
            id = self._sounds[0]._id;
            else if (args.length === 1) {
                // First check if this is an ID, and if not, assume it is a new rate value.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else rate = parseFloat(args[0]);
            } else if (args.length === 2) {
                rate = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // Update the playback rate or return the current value.
            var sound;
            if (typeof rate === 'number') {
                // If the sound hasn't loaded, add it to the load queue to change playback rate when capable.
                if (self._state !== 'loaded' || self._playLock) {
                    self._queue.push({
                        event: 'rate',
                        action: function() {
                            self.rate.apply(self, args);
                        }
                    });
                    return self;
                }
                // Set the group rate.
                if (typeof id === 'undefined') self._rate = rate;
                // Update one or all volumes.
                id = self._getSoundIds(id);
                for(var i = 0; i < id.length; i++){
                    // Get the sound.
                    sound = self._soundById(id[i]);
                    if (sound) {
                        // Keep track of our position when the rate changed and update the playback
                        // start position so we can properly adjust the seek position for time elapsed.
                        if (self.playing(id[i])) {
                            sound._rateSeek = self.seek(id[i]);
                            sound._playStart = self._webAudio ? Howler1.ctx.currentTime : sound._playStart;
                        }
                        sound._rate = rate;
                        // Change the playback rate.
                        if (self._webAudio && sound._node && sound._node.bufferSource) sound._node.bufferSource.playbackRate.setValueAtTime(rate, Howler1.ctx.currentTime);
                        else if (sound._node) sound._node.playbackRate = rate;
                        // Reset the timers.
                        var seek = self.seek(id[i]);
                        var duration = (self._sprite[sound._sprite][0] + self._sprite[sound._sprite][1]) / 1000 - seek;
                        var timeout = duration * 1000 / Math.abs(sound._rate);
                        // Start a new end timer if sound is already playing.
                        if (self._endTimers[id[i]] || !sound._paused) {
                            self._clearTimer(id[i]);
                            self._endTimers[id[i]] = setTimeout(self._ended.bind(self, sound), timeout);
                        }
                        self._emit('rate', sound._id);
                    }
                }
            } else {
                sound = self._soundById(id);
                return sound ? sound._rate : self._rate;
            }
            return self;
        },
        /**
     * Get/set the seek position of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   seek() -> Returns the first sound node's current seek position.
     *   seek(id) -> Returns the sound id's current seek position.
     *   seek(seek) -> Sets the seek position of the first sound node.
     *   seek(seek, id) -> Sets the seek position of passed sound id.
     * @return {Howl/Number} Returns self or the current seek position.
     */ seek: function() {
            var self = this;
            var args = arguments;
            var seek, id;
            // Determine the values based on arguments.
            if (args.length === 0) // We will simply return the current position of the first node.
            {
                if (self._sounds.length) id = self._sounds[0]._id;
            } else if (args.length === 1) {
                // First check if this is an ID, and if not, assume it is a new seek position.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else if (self._sounds.length) {
                    id = self._sounds[0]._id;
                    seek = parseFloat(args[0]);
                }
            } else if (args.length === 2) {
                seek = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // If there is no ID, bail out.
            if (typeof id === 'undefined') return 0;
            // If the sound hasn't loaded, add it to the load queue to seek when capable.
            if (typeof seek === 'number' && (self._state !== 'loaded' || self._playLock)) {
                self._queue.push({
                    event: 'seek',
                    action: function() {
                        self.seek.apply(self, args);
                    }
                });
                return self;
            }
            // Get the sound.
            var sound = self._soundById(id);
            if (sound) {
                if (typeof seek === 'number' && seek >= 0) {
                    // Pause the sound and update position for restarting playback.
                    var playing = self.playing(id);
                    if (playing) self.pause(id, true);
                    // Move the position of the track and cancel timer.
                    sound._seek = seek;
                    sound._ended = false;
                    self._clearTimer(id);
                    // Update the seek position for HTML5 Audio.
                    if (!self._webAudio && sound._node && !isNaN(sound._node.duration)) sound._node.currentTime = seek;
                    // Seek and emit when ready.
                    var seekAndEmit = function() {
                        // Restart the playback if the sound was playing.
                        if (playing) self.play(id, true);
                        self._emit('seek', id);
                    };
                    // Wait for the play lock to be unset before emitting (HTML5 Audio).
                    if (playing && !self._webAudio) {
                        var emitSeek = function() {
                            if (!self._playLock) seekAndEmit();
                            else setTimeout(emitSeek, 0);
                        };
                        setTimeout(emitSeek, 0);
                    } else seekAndEmit();
                } else {
                    if (self._webAudio) {
                        var realTime = self.playing(id) ? Howler1.ctx.currentTime - sound._playStart : 0;
                        var rateSeek = sound._rateSeek ? sound._rateSeek - sound._seek : 0;
                        return sound._seek + (rateSeek + realTime * Math.abs(sound._rate));
                    } else return sound._node.currentTime;
                }
            }
            return self;
        },
        /**
     * Check if a specific sound is currently playing or not (if id is provided), or check if at least one of the sounds in the group is playing or not.
     * @param  {Number}  id The sound id to check. If none is passed, the whole sound group is checked.
     * @return {Boolean} True if playing and false if not.
     */ playing: function(id) {
            var self = this;
            // Check the passed sound ID (if any).
            if (typeof id === 'number') {
                var sound = self._soundById(id);
                return sound ? !sound._paused : false;
            }
            // Otherwise, loop through all sounds and check if any are playing.
            for(var i = 0; i < self._sounds.length; i++){
                if (!self._sounds[i]._paused) return true;
            }
            return false;
        },
        /**
     * Get the duration of this sound. Passing a sound id will return the sprite duration.
     * @param  {Number} id The sound id to check. If none is passed, return full source duration.
     * @return {Number} Audio duration in seconds.
     */ duration: function(id) {
            var self = this;
            var duration = self._duration;
            // If we pass an ID, get the sound and return the sprite length.
            var sound = self._soundById(id);
            if (sound) duration = self._sprite[sound._sprite][1] / 1000;
            return duration;
        },
        /**
     * Returns the current loaded state of this Howl.
     * @return {String} 'unloaded', 'loading', 'loaded'
     */ state: function() {
            return this._state;
        },
        /**
     * Unload and destroy the current Howl object.
     * This will immediately stop all sound instances attached to this group.
     */ unload: function() {
            var self = this;
            // Stop playing any active sounds.
            var sounds = self._sounds;
            for(var i = 0; i < sounds.length; i++){
                // Stop the sound if it is currently playing.
                if (!sounds[i]._paused) self.stop(sounds[i]._id);
                // Remove the source or disconnect.
                if (!self._webAudio) {
                    // Set the source to 0-second silence to stop any downloading (except in IE).
                    self._clearSound(sounds[i]._node);
                    // Remove any event listeners.
                    sounds[i]._node.removeEventListener('error', sounds[i]._errorFn, false);
                    sounds[i]._node.removeEventListener(Howler1._canPlayEvent, sounds[i]._loadFn, false);
                    sounds[i]._node.removeEventListener('ended', sounds[i]._endFn, false);
                    // Release the Audio object back to the pool.
                    Howler1._releaseHtml5Audio(sounds[i]._node);
                }
                // Empty out all of the nodes.
                delete sounds[i]._node;
                // Make sure all timers are cleared out.
                self._clearTimer(sounds[i]._id);
            }
            // Remove the references in the global Howler object.
            var index = Howler1._howls.indexOf(self);
            if (index >= 0) Howler1._howls.splice(index, 1);
            // Delete this sound from the cache (if no other Howl is using it).
            var remCache = true;
            for(i = 0; i < Howler1._howls.length; i++)if (Howler1._howls[i]._src === self._src || self._src.indexOf(Howler1._howls[i]._src) >= 0) {
                remCache = false;
                break;
            }
            if (cache && remCache) delete cache[self._src];
            // Clear global errors.
            Howler1.noAudio = false;
            // Clear out `self`.
            self._state = 'unloaded';
            self._sounds = [];
            self = null;
            return null;
        },
        /**
     * Listen to a custom event.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @param  {Number}   once  (INTERNAL) Marks event to fire only once.
     * @return {Howl}
     */ on: function(event, fn, id, once) {
            var self = this;
            var events = self['_on' + event];
            if (typeof fn === 'function') events.push(once ? {
                id: id,
                fn: fn,
                once: once
            } : {
                id: id,
                fn: fn
            });
            return self;
        },
        /**
     * Remove a custom event. Call without parameters to remove all events.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to remove. Leave empty to remove all.
     * @param  {Number}   id    (optional) Only remove events for this sound.
     * @return {Howl}
     */ off: function(event, fn, id) {
            var self = this;
            var events = self['_on' + event];
            var i = 0;
            // Allow passing just an event and ID.
            if (typeof fn === 'number') {
                id = fn;
                fn = null;
            }
            if (fn || id) // Loop through event store and remove the passed function.
            for(i = 0; i < events.length; i++){
                var isId = id === events[i].id;
                if (fn === events[i].fn && isId || !fn && isId) {
                    events.splice(i, 1);
                    break;
                }
            }
            else if (event) // Clear out all events of this type.
            self['_on' + event] = [];
            else {
                // Clear out all events of every type.
                var keys = Object.keys(self);
                for(i = 0; i < keys.length; i++)if (keys[i].indexOf('_on') === 0 && Array.isArray(self[keys[i]])) self[keys[i]] = [];
            }
            return self;
        },
        /**
     * Listen to a custom event and remove it once fired.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @return {Howl}
     */ once: function(event, fn, id) {
            var self = this;
            // Setup the event listener.
            self.on(event, fn, id, 1);
            return self;
        },
        /**
     * Emit all events of a specific type and pass the sound id.
     * @param  {String} event Event name.
     * @param  {Number} id    Sound ID.
     * @param  {Number} msg   Message to go with event.
     * @return {Howl}
     */ _emit: function(event, id, msg) {
            var self = this;
            var events = self['_on' + event];
            // Loop through event store and fire all functions.
            for(var i = events.length - 1; i >= 0; i--)// Only fire the listener if the correct ID is used.
            if (!events[i].id || events[i].id === id || event === 'load') {
                setTimeout((function(fn) {
                    fn.call(this, id, msg);
                }).bind(self, events[i].fn), 0);
                // If this event was setup with `once`, remove it.
                if (events[i].once) self.off(event, events[i].fn, events[i].id);
            }
            // Pass the event type into load queue so that it can continue stepping.
            self._loadQueue(event);
            return self;
        },
        /**
     * Queue of actions initiated before the sound has loaded.
     * These will be called in sequence, with the next only firing
     * after the previous has finished executing (even if async like play).
     * @return {Howl}
     */ _loadQueue: function(event) {
            var self = this;
            if (self._queue.length > 0) {
                var task = self._queue[0];
                // Remove this task if a matching event was passed.
                if (task.event === event) {
                    self._queue.shift();
                    self._loadQueue();
                }
                // Run the task if no event type is passed.
                if (!event) task.action();
            }
            return self;
        },
        /**
     * Fired when playback ends at the end of the duration.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */ _ended: function(sound) {
            var self = this;
            var sprite = sound._sprite;
            // If we are using IE and there was network latency we may be clipping
            // audio before it completes playing. Lets check the node to make sure it
            // believes it has completed, before ending the playback.
            if (!self._webAudio && sound._node && !sound._node.paused && !sound._node.ended && sound._node.currentTime < sound._stop) {
                setTimeout(self._ended.bind(self, sound), 100);
                return self;
            }
            // Should this sound loop?
            var loop = !!(sound._loop || self._sprite[sprite][2]);
            // Fire the ended event.
            self._emit('end', sound._id);
            // Restart the playback for HTML5 Audio loop.
            if (!self._webAudio && loop) self.stop(sound._id, true).play(sound._id);
            // Restart this timer if on a Web Audio loop.
            if (self._webAudio && loop) {
                self._emit('play', sound._id);
                sound._seek = sound._start || 0;
                sound._rateSeek = 0;
                sound._playStart = Howler1.ctx.currentTime;
                var timeout = (sound._stop - sound._start) * 1000 / Math.abs(sound._rate);
                self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
            }
            // Mark the node as paused.
            if (self._webAudio && !loop) {
                sound._paused = true;
                sound._ended = true;
                sound._seek = sound._start || 0;
                sound._rateSeek = 0;
                self._clearTimer(sound._id);
                // Clean up the buffer source.
                self._cleanBuffer(sound._node);
                // Attempt to auto-suspend AudioContext if no sounds are still playing.
                Howler1._autoSuspend();
            }
            // When using a sprite, end the track.
            if (!self._webAudio && !loop) self.stop(sound._id, true);
            return self;
        },
        /**
     * Clear the end timer for a sound playback.
     * @param  {Number} id The sound ID.
     * @return {Howl}
     */ _clearTimer: function(id) {
            var self = this;
            if (self._endTimers[id]) {
                // Clear the timeout or remove the ended listener.
                if (typeof self._endTimers[id] !== 'function') clearTimeout(self._endTimers[id]);
                else {
                    var sound = self._soundById(id);
                    if (sound && sound._node) sound._node.removeEventListener('ended', self._endTimers[id], false);
                }
                delete self._endTimers[id];
            }
            return self;
        },
        /**
     * Return the sound identified by this ID, or return null.
     * @param  {Number} id Sound ID
     * @return {Object}    Sound object or null.
     */ _soundById: function(id) {
            var self = this;
            // Loop through all sounds and find the one with this ID.
            for(var i = 0; i < self._sounds.length; i++){
                if (id === self._sounds[i]._id) return self._sounds[i];
            }
            return null;
        },
        /**
     * Return an inactive sound from the pool or create a new one.
     * @return {Sound} Sound playback object.
     */ _inactiveSound: function() {
            var self = this;
            self._drain();
            // Find the first inactive node to recycle.
            for(var i = 0; i < self._sounds.length; i++){
                if (self._sounds[i]._ended) return self._sounds[i].reset();
            }
            // If no inactive node was found, create a new one.
            return new Sound1(self);
        },
        /**
     * Drain excess inactive sounds from the pool.
     */ _drain: function() {
            var self = this;
            var limit = self._pool;
            var cnt = 0;
            var i = 0;
            // If there are less sounds than the max pool size, we are done.
            if (self._sounds.length < limit) return;
            // Count the number of inactive sounds.
            for(i = 0; i < self._sounds.length; i++)if (self._sounds[i]._ended) cnt++;
            // Remove excess inactive sounds, going in reverse order.
            for(i = self._sounds.length - 1; i >= 0; i--){
                if (cnt <= limit) return;
                if (self._sounds[i]._ended) {
                    // Disconnect the audio source when using Web Audio.
                    if (self._webAudio && self._sounds[i]._node) self._sounds[i]._node.disconnect(0);
                    // Remove sounds until we have the pool size.
                    self._sounds.splice(i, 1);
                    cnt--;
                }
            }
        },
        /**
     * Get all ID's from the sounds pool.
     * @param  {Number} id Only return one ID if one is passed.
     * @return {Array}    Array of IDs.
     */ _getSoundIds: function(id) {
            var self = this;
            if (typeof id === 'undefined') {
                var ids = [];
                for(var i = 0; i < self._sounds.length; i++)ids.push(self._sounds[i]._id);
                return ids;
            } else return [
                id
            ];
        },
        /**
     * Load the sound back into the buffer source.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */ _refreshBuffer: function(sound) {
            var self = this;
            // Setup the buffer source for playback.
            sound._node.bufferSource = Howler1.ctx.createBufferSource();
            sound._node.bufferSource.buffer = cache[self._src];
            // Connect to the correct node.
            if (sound._panner) sound._node.bufferSource.connect(sound._panner);
            else sound._node.bufferSource.connect(sound._node);
            // Setup looping and playback rate.
            sound._node.bufferSource.loop = sound._loop;
            if (sound._loop) {
                sound._node.bufferSource.loopStart = sound._start || 0;
                sound._node.bufferSource.loopEnd = sound._stop || 0;
            }
            sound._node.bufferSource.playbackRate.setValueAtTime(sound._rate, Howler1.ctx.currentTime);
            return self;
        },
        /**
     * Prevent memory leaks by cleaning up the buffer source after playback.
     * @param  {Object} node Sound's audio node containing the buffer source.
     * @return {Howl}
     */ _cleanBuffer: function(node) {
            var self = this;
            var isIOS = Howler1._navigator && Howler1._navigator.vendor.indexOf('Apple') >= 0;
            if (!node.bufferSource) return self;
            if (Howler1._scratchBuffer && node.bufferSource) {
                node.bufferSource.onended = null;
                node.bufferSource.disconnect(0);
                if (isIOS) try {
                    node.bufferSource.buffer = Howler1._scratchBuffer;
                } catch (e) {}
            }
            node.bufferSource = null;
            return self;
        },
        /**
     * Set the source to a 0-second silence to stop any downloading (except in IE).
     * @param  {Object} node Audio node to clear.
     */ _clearSound: function(node) {
            var checkIE = /MSIE |Trident\//.test(Howler1._navigator && Howler1._navigator.userAgent);
            if (!checkIE) node.src = 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA';
        }
    };
    /** Single Sound Methods **/ /***************************************************************************/ /**
   * Setup the sound object, which each node attached to a Howl group is contained in.
   * @param {Object} howl The Howl parent group.
   */ var Sound1 = function(howl) {
        this._parent = howl;
        this.init();
    };
    Sound1.prototype = {
        /**
     * Initialize a new Sound object.
     * @return {Sound}
     */ init: function() {
            var self = this;
            var parent = self._parent;
            // Setup the default parameters.
            self._muted = parent._muted;
            self._loop = parent._loop;
            self._volume = parent._volume;
            self._rate = parent._rate;
            self._seek = 0;
            self._paused = true;
            self._ended = true;
            self._sprite = '__default';
            // Generate a unique ID for this sound.
            self._id = ++Howler1._counter;
            // Add itself to the parent's pool.
            parent._sounds.push(self);
            // Create the new node.
            self.create();
            return self;
        },
        /**
     * Create and setup a new sound object, whether HTML5 Audio or Web Audio.
     * @return {Sound}
     */ create: function() {
            var self = this;
            var parent = self._parent;
            var volume = Howler1._muted || self._muted || self._parent._muted ? 0 : self._volume;
            if (parent._webAudio) {
                // Create the gain node for controlling volume (the source will connect to this).
                self._node = typeof Howler1.ctx.createGain === 'undefined' ? Howler1.ctx.createGainNode() : Howler1.ctx.createGain();
                self._node.gain.setValueAtTime(volume, Howler1.ctx.currentTime);
                self._node.paused = true;
                self._node.connect(Howler1.masterGain);
            } else if (!Howler1.noAudio) {
                // Get an unlocked Audio object from the pool.
                self._node = Howler1._obtainHtml5Audio();
                // Listen for errors (http://dev.w3.org/html5/spec-author-view/spec.html#mediaerror).
                self._errorFn = self._errorListener.bind(self);
                self._node.addEventListener('error', self._errorFn, false);
                // Listen for 'canplaythrough' event to let us know the sound is ready.
                self._loadFn = self._loadListener.bind(self);
                self._node.addEventListener(Howler1._canPlayEvent, self._loadFn, false);
                // Listen for the 'ended' event on the sound to account for edge-case where
                // a finite sound has a duration of Infinity.
                self._endFn = self._endListener.bind(self);
                self._node.addEventListener('ended', self._endFn, false);
                // Setup the new audio node.
                self._node.src = parent._src;
                self._node.preload = parent._preload === true ? 'auto' : parent._preload;
                self._node.volume = volume * Howler1.volume();
                // Begin loading the source.
                self._node.load();
            }
            return self;
        },
        /**
     * Reset the parameters of this sound to the original state (for recycle).
     * @return {Sound}
     */ reset: function() {
            var self = this;
            var parent = self._parent;
            // Reset all of the parameters of this sound.
            self._muted = parent._muted;
            self._loop = parent._loop;
            self._volume = parent._volume;
            self._rate = parent._rate;
            self._seek = 0;
            self._rateSeek = 0;
            self._paused = true;
            self._ended = true;
            self._sprite = '__default';
            // Generate a new ID so that it isn't confused with the previous sound.
            self._id = ++Howler1._counter;
            return self;
        },
        /**
     * HTML5 Audio error listener callback.
     */ _errorListener: function() {
            var self = this;
            // Fire an error event and pass back the code.
            self._parent._emit('loaderror', self._id, self._node.error ? self._node.error.code : 0);
            // Clear the event listener.
            self._node.removeEventListener('error', self._errorFn, false);
        },
        /**
     * HTML5 Audio canplaythrough listener callback.
     */ _loadListener: function() {
            var self = this;
            var parent = self._parent;
            // Round up the duration to account for the lower precision in HTML5 Audio.
            parent._duration = Math.ceil(self._node.duration * 10) / 10;
            // Setup a sprite if none is defined.
            if (Object.keys(parent._sprite).length === 0) parent._sprite = {
                __default: [
                    0,
                    parent._duration * 1000
                ]
            };
            if (parent._state !== 'loaded') {
                parent._state = 'loaded';
                parent._emit('load');
                parent._loadQueue();
            }
            // Clear the event listener.
            self._node.removeEventListener(Howler1._canPlayEvent, self._loadFn, false);
        },
        /**
     * HTML5 Audio ended listener callback.
     */ _endListener: function() {
            var self = this;
            var parent = self._parent;
            // Only handle the `ended`` event if the duration is Infinity.
            if (parent._duration === Infinity) {
                // Update the parent duration to match the real audio duration.
                // Round up the duration to account for the lower precision in HTML5 Audio.
                parent._duration = Math.ceil(self._node.duration * 10) / 10;
                // Update the sprite that corresponds to the real duration.
                if (parent._sprite.__default[1] === Infinity) parent._sprite.__default[1] = parent._duration * 1000;
                // Run the regular ended method.
                parent._ended(self);
            }
            // Clear the event listener since the duration is now correct.
            self._node.removeEventListener('ended', self._endFn, false);
        }
    };
    /** Helper Methods **/ /***************************************************************************/ var cache = {};
    /**
   * Buffer a sound from URL, Data URI or cache and decode to audio source (Web Audio API).
   * @param  {Howl} self
   */ var loadBuffer = function(self) {
        var url = self._src;
        // Check if the buffer has already been cached and use it instead.
        if (cache[url]) {
            // Set the duration from the cache.
            self._duration = cache[url].duration;
            // Load the sound into this Howl.
            loadSound(self);
            return;
        }
        if (/^data:[^;]+;base64,/.test(url)) {
            // Decode the base64 data URI without XHR, since some browsers don't support it.
            var data = atob(url.split(',')[1]);
            var dataView = new Uint8Array(data.length);
            for(var i = 0; i < data.length; ++i)dataView[i] = data.charCodeAt(i);
            decodeAudioData(dataView.buffer, self);
        } else {
            // Load the buffer from the URL.
            var xhr = new XMLHttpRequest();
            xhr.open(self._xhr.method, url, true);
            xhr.withCredentials = self._xhr.withCredentials;
            xhr.responseType = 'arraybuffer';
            // Apply any custom headers to the request.
            if (self._xhr.headers) Object.keys(self._xhr.headers).forEach(function(key) {
                xhr.setRequestHeader(key, self._xhr.headers[key]);
            });
            xhr.onload = function() {
                // Make sure we get a successful response back.
                var code = (xhr.status + '')[0];
                if (code !== '0' && code !== '2' && code !== '3') {
                    self._emit('loaderror', null, 'Failed loading audio file with status: ' + xhr.status + '.');
                    return;
                }
                decodeAudioData(xhr.response, self);
            };
            xhr.onerror = function() {
                // If there is an error, switch to HTML5 Audio.
                if (self._webAudio) {
                    self._html5 = true;
                    self._webAudio = false;
                    self._sounds = [];
                    delete cache[url];
                    self.load();
                }
            };
            safeXhrSend(xhr);
        }
    };
    /**
   * Send the XHR request wrapped in a try/catch.
   * @param  {Object} xhr XHR to send.
   */ var safeXhrSend = function(xhr) {
        try {
            xhr.send();
        } catch (e) {
            xhr.onerror();
        }
    };
    /**
   * Decode audio data from an array buffer.
   * @param  {ArrayBuffer} arraybuffer The audio data.
   * @param  {Howl}        self
   */ var decodeAudioData = function(arraybuffer, self) {
        // Fire a load error if something broke.
        var error = function() {
            self._emit('loaderror', null, 'Decoding audio data failed.');
        };
        // Load the sound on success.
        var success = function(buffer) {
            if (buffer && self._sounds.length > 0) {
                cache[self._src] = buffer;
                loadSound(self, buffer);
            } else error();
        };
        // Decode the buffer into an audio source.
        if (typeof Promise !== 'undefined' && Howler1.ctx.decodeAudioData.length === 1) Howler1.ctx.decodeAudioData(arraybuffer).then(success).catch(error);
        else Howler1.ctx.decodeAudioData(arraybuffer, success, error);
    };
    /**
   * Sound is now loaded, so finish setting everything up and fire the loaded event.
   * @param  {Howl} self
   * @param  {Object} buffer The decoded buffer sound source.
   */ var loadSound = function(self, buffer) {
        // Set the duration.
        if (buffer && !self._duration) self._duration = buffer.duration;
        // Setup a sprite if none is defined.
        if (Object.keys(self._sprite).length === 0) self._sprite = {
            __default: [
                0,
                self._duration * 1000
            ]
        };
        // Fire the loaded event.
        if (self._state !== 'loaded') {
            self._state = 'loaded';
            self._emit('load');
            self._loadQueue();
        }
    };
    /**
   * Setup the audio context when available, or switch to HTML5 Audio mode.
   */ var setupAudioContext = function() {
        // If we have already detected that Web Audio isn't supported, don't run this step again.
        if (!Howler1.usingWebAudio) return;
        // Check if we are using Web Audio and setup the AudioContext if we are.
        try {
            if (typeof AudioContext !== 'undefined') Howler1.ctx = new AudioContext();
            else if (typeof webkitAudioContext !== 'undefined') Howler1.ctx = new webkitAudioContext();
            else Howler1.usingWebAudio = false;
        } catch (e) {
            Howler1.usingWebAudio = false;
        }
        // If the audio context creation still failed, set using web audio to false.
        if (!Howler1.ctx) Howler1.usingWebAudio = false;
        // Check if a webview is being used on iOS8 or earlier (rather than the browser).
        // If it is, disable Web Audio as it causes crashing.
        var iOS = /iP(hone|od|ad)/.test(Howler1._navigator && Howler1._navigator.platform);
        var appVersion = Howler1._navigator && Howler1._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
        var version = appVersion ? parseInt(appVersion[1], 10) : null;
        if (iOS && version && version < 9) {
            var safari = /safari/.test(Howler1._navigator && Howler1._navigator.userAgent.toLowerCase());
            if (Howler1._navigator && !safari) Howler1.usingWebAudio = false;
        }
        // Create and expose the master GainNode when using Web Audio (useful for plugins or advanced usage).
        if (Howler1.usingWebAudio) {
            Howler1.masterGain = typeof Howler1.ctx.createGain === 'undefined' ? Howler1.ctx.createGainNode() : Howler1.ctx.createGain();
            Howler1.masterGain.gain.setValueAtTime(Howler1._muted ? 0 : Howler1._volume, Howler1.ctx.currentTime);
            Howler1.masterGain.connect(Howler1.ctx.destination);
        }
        // Re-run the setup on Howler.
        Howler1._setup();
    };
    // Add support for AMD (Asynchronous Module Definition) libraries such as require.js.
    if (typeof define === 'function' && define.amd) define([], function() {
        return {
            Howler: Howler1,
            Howl: Howl1
        };
    });
    $f89d8ffbdc18f2ab$export$c9d39ca3bcd93abb = Howler1;
    $f89d8ffbdc18f2ab$export$b791fe48eec8032a = Howl1;
    // Add to global in Node.js (for testing, etc).
    if (typeof $parcel$global !== 'undefined') {
        $parcel$global.HowlerGlobal = HowlerGlobal1;
        $parcel$global.Howler = Howler1;
        $parcel$global.Howl = Howl1;
        $parcel$global.Sound = Sound1;
    } else if (typeof window !== 'undefined') {
        window.HowlerGlobal = HowlerGlobal1;
        window.Howler = Howler1;
        window.Howl = Howl1;
        window.Sound = Sound1;
    }
})();
/*!
 *  Spatial Plugin - Adds support for stereo and 3D audio where Web Audio is supported.
 *  
 *  howler.js v2.2.4
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */ (function() {
    'use strict';
    // Setup default properties.
    HowlerGlobal.prototype._pos = [
        0,
        0,
        0
    ];
    HowlerGlobal.prototype._orientation = [
        0,
        0,
        -1,
        0,
        1,
        0
    ];
    /** Global Methods **/ /***************************************************************************/ /**
   * Helper method to update the stereo panning position of all current Howls.
   * Future Howls will not use this value unless explicitly set.
   * @param  {Number} pan A value of -1.0 is all the way left and 1.0 is all the way right.
   * @return {Howler/Number}     Self or current stereo panning value.
   */ HowlerGlobal.prototype.stereo = function(pan) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Loop through all Howls and update their stereo panning.
        for(var i = self._howls.length - 1; i >= 0; i--)self._howls[i].stereo(pan);
        return self;
    };
    /**
   * Get/set the position of the listener in 3D cartesian space. Sounds using
   * 3D position will be relative to the listener's position.
   * @param  {Number} x The x-position of the listener.
   * @param  {Number} y The y-position of the listener.
   * @param  {Number} z The z-position of the listener.
   * @return {Howler/Array}   Self or current listener position.
   */ HowlerGlobal.prototype.pos = function(x, y, z) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== 'number' ? self._pos[1] : y;
        z = typeof z !== 'number' ? self._pos[2] : z;
        if (typeof x === 'number') {
            self._pos = [
                x,
                y,
                z
            ];
            if (typeof self.ctx.listener.positionX !== 'undefined') {
                self.ctx.listener.positionX.setTargetAtTime(self._pos[0], Howler.ctx.currentTime, 0.1);
                self.ctx.listener.positionY.setTargetAtTime(self._pos[1], Howler.ctx.currentTime, 0.1);
                self.ctx.listener.positionZ.setTargetAtTime(self._pos[2], Howler.ctx.currentTime, 0.1);
            } else self.ctx.listener.setPosition(self._pos[0], self._pos[1], self._pos[2]);
        } else return self._pos;
        return self;
    };
    /**
   * Get/set the direction the listener is pointing in the 3D cartesian space.
   * A front and up vector must be provided. The front is the direction the
   * face of the listener is pointing, and up is the direction the top of the
   * listener is pointing. Thus, these values are expected to be at right angles
   * from each other.
   * @param  {Number} x   The x-orientation of the listener.
   * @param  {Number} y   The y-orientation of the listener.
   * @param  {Number} z   The z-orientation of the listener.
   * @param  {Number} xUp The x-orientation of the top of the listener.
   * @param  {Number} yUp The y-orientation of the top of the listener.
   * @param  {Number} zUp The z-orientation of the top of the listener.
   * @return {Howler/Array}     Returns self or the current orientation vectors.
   */ HowlerGlobal.prototype.orientation = function(x, y, z, xUp, yUp, zUp) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Set the defaults for optional 'y' & 'z'.
        var or = self._orientation;
        y = typeof y !== 'number' ? or[1] : y;
        z = typeof z !== 'number' ? or[2] : z;
        xUp = typeof xUp !== 'number' ? or[3] : xUp;
        yUp = typeof yUp !== 'number' ? or[4] : yUp;
        zUp = typeof zUp !== 'number' ? or[5] : zUp;
        if (typeof x === 'number') {
            self._orientation = [
                x,
                y,
                z,
                xUp,
                yUp,
                zUp
            ];
            if (typeof self.ctx.listener.forwardX !== 'undefined') {
                self.ctx.listener.forwardX.setTargetAtTime(x, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.forwardY.setTargetAtTime(y, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.forwardZ.setTargetAtTime(z, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upX.setTargetAtTime(xUp, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upY.setTargetAtTime(yUp, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upZ.setTargetAtTime(zUp, Howler.ctx.currentTime, 0.1);
            } else self.ctx.listener.setOrientation(x, y, z, xUp, yUp, zUp);
        } else return or;
        return self;
    };
    /** Group Methods **/ /***************************************************************************/ /**
   * Add new properties to the core init.
   * @param  {Function} _super Core init method.
   * @return {Howl}
   */ Howl.prototype.init = function(_super) {
        return function(o) {
            var self = this;
            // Setup user-defined default properties.
            self._orientation = o.orientation || [
                1,
                0,
                0
            ];
            self._stereo = o.stereo || null;
            self._pos = o.pos || null;
            self._pannerAttr = {
                coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : 360,
                coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : 360,
                coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : 0,
                distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : 'inverse',
                maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : 10000,
                panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : 'HRTF',
                refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : 1,
                rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : 1
            };
            // Setup event listeners.
            self._onstereo = o.onstereo ? [
                {
                    fn: o.onstereo
                }
            ] : [];
            self._onpos = o.onpos ? [
                {
                    fn: o.onpos
                }
            ] : [];
            self._onorientation = o.onorientation ? [
                {
                    fn: o.onorientation
                }
            ] : [];
            // Complete initilization with howler.js core's init function.
            return _super.call(this, o);
        };
    }(Howl.prototype.init);
    /**
   * Get/set the stereo panning of the audio source for this sound or all in the group.
   * @param  {Number} pan  A value of -1.0 is all the way left and 1.0 is all the way right.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Number}    Returns self or the current stereo panning value.
   */ Howl.prototype.stereo = function(pan, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change stereo pan when capable.
        if (self._state !== 'loaded') {
            self._queue.push({
                event: 'stereo',
                action: function() {
                    self.stereo(pan, id);
                }
            });
            return self;
        }
        // Check for PannerStereoNode support and fallback to PannerNode if it doesn't exist.
        var pannerType = typeof Howler.ctx.createStereoPanner === 'undefined' ? 'spatial' : 'stereo';
        // Setup the group's stereo panning if no ID is passed.
        if (typeof id === 'undefined') {
            // Return the group's stereo panning if no parameters are passed.
            if (typeof pan === 'number') {
                self._stereo = pan;
                self._pos = [
                    pan,
                    0,
                    0
                ];
            } else return self._stereo;
        }
        // Change the streo panning of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof pan === 'number') {
                    sound._stereo = pan;
                    sound._pos = [
                        pan,
                        0,
                        0
                    ];
                    if (sound._node) {
                        // If we are falling back, make sure the panningModel is equalpower.
                        sound._pannerAttr.panningModel = 'equalpower';
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner || !sound._panner.pan) setupPanner(sound, pannerType);
                        if (pannerType === 'spatial') {
                            if (typeof sound._panner.positionX !== 'undefined') {
                                sound._panner.positionX.setValueAtTime(pan, Howler.ctx.currentTime);
                                sound._panner.positionY.setValueAtTime(0, Howler.ctx.currentTime);
                                sound._panner.positionZ.setValueAtTime(0, Howler.ctx.currentTime);
                            } else sound._panner.setPosition(pan, 0, 0);
                        } else sound._panner.pan.setValueAtTime(pan, Howler.ctx.currentTime);
                    }
                    self._emit('stereo', sound._id);
                } else return sound._stereo;
            }
        }
        return self;
    };
    /**
   * Get/set the 3D spatial position of the audio source for this sound or group relative to the global listener.
   * @param  {Number} x  The x-position of the audio source.
   * @param  {Number} y  The y-position of the audio source.
   * @param  {Number} z  The z-position of the audio source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial position: [x, y, z].
   */ Howl.prototype.pos = function(x, y, z, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change position when capable.
        if (self._state !== 'loaded') {
            self._queue.push({
                event: 'pos',
                action: function() {
                    self.pos(x, y, z, id);
                }
            });
            return self;
        }
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== 'number' ? 0 : y;
        z = typeof z !== 'number' ? -0.5 : z;
        // Setup the group's spatial position if no ID is passed.
        if (typeof id === 'undefined') {
            // Return the group's spatial position if no parameters are passed.
            if (typeof x === 'number') self._pos = [
                x,
                y,
                z
            ];
            else return self._pos;
        }
        // Change the spatial position of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof x === 'number') {
                    sound._pos = [
                        x,
                        y,
                        z
                    ];
                    if (sound._node) {
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner || sound._panner.pan) setupPanner(sound, 'spatial');
                        if (typeof sound._panner.positionX !== 'undefined') {
                            sound._panner.positionX.setValueAtTime(x, Howler.ctx.currentTime);
                            sound._panner.positionY.setValueAtTime(y, Howler.ctx.currentTime);
                            sound._panner.positionZ.setValueAtTime(z, Howler.ctx.currentTime);
                        } else sound._panner.setPosition(x, y, z);
                    }
                    self._emit('pos', sound._id);
                } else return sound._pos;
            }
        }
        return self;
    };
    /**
   * Get/set the direction the audio source is pointing in the 3D cartesian coordinate
   * space. Depending on how direction the sound is, based on the `cone` attributes,
   * a sound pointing away from the listener can be quiet or silent.
   * @param  {Number} x  The x-orientation of the source.
   * @param  {Number} y  The y-orientation of the source.
   * @param  {Number} z  The z-orientation of the source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial orientation: [x, y, z].
   */ Howl.prototype.orientation = function(x, y, z, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change orientation when capable.
        if (self._state !== 'loaded') {
            self._queue.push({
                event: 'orientation',
                action: function() {
                    self.orientation(x, y, z, id);
                }
            });
            return self;
        }
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== 'number' ? self._orientation[1] : y;
        z = typeof z !== 'number' ? self._orientation[2] : z;
        // Setup the group's spatial orientation if no ID is passed.
        if (typeof id === 'undefined') {
            // Return the group's spatial orientation if no parameters are passed.
            if (typeof x === 'number') self._orientation = [
                x,
                y,
                z
            ];
            else return self._orientation;
        }
        // Change the spatial orientation of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof x === 'number') {
                    sound._orientation = [
                        x,
                        y,
                        z
                    ];
                    if (sound._node) {
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner) {
                            // Make sure we have a position to setup the node with.
                            if (!sound._pos) sound._pos = self._pos || [
                                0,
                                0,
                                -0.5
                            ];
                            setupPanner(sound, 'spatial');
                        }
                        if (typeof sound._panner.orientationX !== 'undefined') {
                            sound._panner.orientationX.setValueAtTime(x, Howler.ctx.currentTime);
                            sound._panner.orientationY.setValueAtTime(y, Howler.ctx.currentTime);
                            sound._panner.orientationZ.setValueAtTime(z, Howler.ctx.currentTime);
                        } else sound._panner.setOrientation(x, y, z);
                    }
                    self._emit('orientation', sound._id);
                } else return sound._orientation;
            }
        }
        return self;
    };
    /**
   * Get/set the panner node's attributes for a sound or group of sounds.
   * This method can optionall take 0, 1 or 2 arguments.
   *   pannerAttr() -> Returns the group's values.
   *   pannerAttr(id) -> Returns the sound id's values.
   *   pannerAttr(o) -> Set's the values of all sounds in this Howl group.
   *   pannerAttr(o, id) -> Set's the values of passed sound id.
   *
   *   Attributes:
   *     coneInnerAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      inside of which there will be no volume reduction.
   *     coneOuterAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      outside of which the volume will be reduced to a constant value of `coneOuterGain`.
   *     coneOuterGain - (0 by default) A parameter for directional audio sources, this is the gain outside of the
   *                     `coneOuterAngle`. It is a linear value in the range `[0, 1]`.
   *     distanceModel - ('inverse' by default) Determines algorithm used to reduce volume as audio moves away from
   *                     listener. Can be `linear`, `inverse` or `exponential.
   *     maxDistance - (10000 by default) The maximum distance between source and listener, after which the volume
   *                   will not be reduced any further.
   *     refDistance - (1 by default) A reference distance for reducing volume as source moves further from the listener.
   *                   This is simply a variable of the distance model and has a different effect depending on which model
   *                   is used and the scale of your coordinates. Generally, volume will be equal to 1 at this distance.
   *     rolloffFactor - (1 by default) How quickly the volume reduces as source moves from listener. This is simply a
   *                     variable of the distance model and can be in the range of `[0, 1]` with `linear` and `[0, ∞]`
   *                     with `inverse` and `exponential`.
   *     panningModel - ('HRTF' by default) Determines which spatialization algorithm is used to position audio.
   *                     Can be `HRTF` or `equalpower`.
   *
   * @return {Howl/Object} Returns self or current panner attributes.
   */ Howl.prototype.pannerAttr = function() {
        var self = this;
        var args = arguments;
        var o, id, sound;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // Determine the values based on arguments.
        if (args.length === 0) // Return the group's panner attribute values.
        return self._pannerAttr;
        else if (args.length === 1) {
            if (typeof args[0] === 'object') {
                o = args[0];
                // Set the grou's panner attribute values.
                if (typeof id === 'undefined') {
                    if (!o.pannerAttr) o.pannerAttr = {
                        coneInnerAngle: o.coneInnerAngle,
                        coneOuterAngle: o.coneOuterAngle,
                        coneOuterGain: o.coneOuterGain,
                        distanceModel: o.distanceModel,
                        maxDistance: o.maxDistance,
                        refDistance: o.refDistance,
                        rolloffFactor: o.rolloffFactor,
                        panningModel: o.panningModel
                    };
                    self._pannerAttr = {
                        coneInnerAngle: typeof o.pannerAttr.coneInnerAngle !== 'undefined' ? o.pannerAttr.coneInnerAngle : self._coneInnerAngle,
                        coneOuterAngle: typeof o.pannerAttr.coneOuterAngle !== 'undefined' ? o.pannerAttr.coneOuterAngle : self._coneOuterAngle,
                        coneOuterGain: typeof o.pannerAttr.coneOuterGain !== 'undefined' ? o.pannerAttr.coneOuterGain : self._coneOuterGain,
                        distanceModel: typeof o.pannerAttr.distanceModel !== 'undefined' ? o.pannerAttr.distanceModel : self._distanceModel,
                        maxDistance: typeof o.pannerAttr.maxDistance !== 'undefined' ? o.pannerAttr.maxDistance : self._maxDistance,
                        refDistance: typeof o.pannerAttr.refDistance !== 'undefined' ? o.pannerAttr.refDistance : self._refDistance,
                        rolloffFactor: typeof o.pannerAttr.rolloffFactor !== 'undefined' ? o.pannerAttr.rolloffFactor : self._rolloffFactor,
                        panningModel: typeof o.pannerAttr.panningModel !== 'undefined' ? o.pannerAttr.panningModel : self._panningModel
                    };
                }
            } else {
                // Return this sound's panner attribute values.
                sound = self._soundById(parseInt(args[0], 10));
                return sound ? sound._pannerAttr : self._pannerAttr;
            }
        } else if (args.length === 2) {
            o = args[0];
            id = parseInt(args[1], 10);
        }
        // Update the values of the specified sounds.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            sound = self._soundById(ids[i]);
            if (sound) {
                // Merge the new values into the sound.
                var pa = sound._pannerAttr;
                pa = {
                    coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : pa.coneInnerAngle,
                    coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : pa.coneOuterAngle,
                    coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : pa.coneOuterGain,
                    distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : pa.distanceModel,
                    maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : pa.maxDistance,
                    refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : pa.refDistance,
                    rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : pa.rolloffFactor,
                    panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : pa.panningModel
                };
                // Create a new panner node if one doesn't already exist.
                var panner = sound._panner;
                if (!panner) {
                    // Make sure we have a position to setup the node with.
                    if (!sound._pos) sound._pos = self._pos || [
                        0,
                        0,
                        -0.5
                    ];
                    // Create a new panner node.
                    setupPanner(sound, 'spatial');
                    panner = sound._panner;
                }
                // Update the panner values or create a new panner if none exists.
                panner.coneInnerAngle = pa.coneInnerAngle;
                panner.coneOuterAngle = pa.coneOuterAngle;
                panner.coneOuterGain = pa.coneOuterGain;
                panner.distanceModel = pa.distanceModel;
                panner.maxDistance = pa.maxDistance;
                panner.refDistance = pa.refDistance;
                panner.rolloffFactor = pa.rolloffFactor;
                panner.panningModel = pa.panningModel;
            }
        }
        return self;
    };
    /** Single Sound Methods **/ /***************************************************************************/ /**
   * Add new properties to the core Sound init.
   * @param  {Function} _super Core Sound init method.
   * @return {Sound}
   */ Sound.prototype.init = function(_super) {
        return function() {
            var self = this;
            var parent = self._parent;
            // Setup user-defined default properties.
            self._orientation = parent._orientation;
            self._stereo = parent._stereo;
            self._pos = parent._pos;
            self._pannerAttr = parent._pannerAttr;
            // Complete initilization with howler.js core Sound's init function.
            _super.call(this);
            // If a stereo or position was specified, set it up.
            if (self._stereo) parent.stereo(self._stereo);
            else if (self._pos) parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
        };
    }(Sound.prototype.init);
    /**
   * Override the Sound.reset method to clean up properties from the spatial plugin.
   * @param  {Function} _super Sound reset method.
   * @return {Sound}
   */ Sound.prototype.reset = function(_super) {
        return function() {
            var self = this;
            var parent = self._parent;
            // Reset all spatial plugin properties on this sound.
            self._orientation = parent._orientation;
            self._stereo = parent._stereo;
            self._pos = parent._pos;
            self._pannerAttr = parent._pannerAttr;
            // If a stereo or position was specified, set it up.
            if (self._stereo) parent.stereo(self._stereo);
            else if (self._pos) parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
            else if (self._panner) {
                // Disconnect the panner.
                self._panner.disconnect(0);
                self._panner = undefined;
                parent._refreshBuffer(self);
            }
            // Complete resetting of the sound.
            return _super.call(this);
        };
    }(Sound.prototype.reset);
    /** Helper Methods **/ /***************************************************************************/ /**
   * Create a new panner node and save it on the sound.
   * @param  {Sound} sound Specific sound to setup panning on.
   * @param {String} type Type of panner to create: 'stereo' or 'spatial'.
   */ var setupPanner = function(sound, type) {
        type = type || 'spatial';
        // Create the new panner node.
        if (type === 'spatial') {
            sound._panner = Howler.ctx.createPanner();
            sound._panner.coneInnerAngle = sound._pannerAttr.coneInnerAngle;
            sound._panner.coneOuterAngle = sound._pannerAttr.coneOuterAngle;
            sound._panner.coneOuterGain = sound._pannerAttr.coneOuterGain;
            sound._panner.distanceModel = sound._pannerAttr.distanceModel;
            sound._panner.maxDistance = sound._pannerAttr.maxDistance;
            sound._panner.refDistance = sound._pannerAttr.refDistance;
            sound._panner.rolloffFactor = sound._pannerAttr.rolloffFactor;
            sound._panner.panningModel = sound._pannerAttr.panningModel;
            if (typeof sound._panner.positionX !== 'undefined') {
                sound._panner.positionX.setValueAtTime(sound._pos[0], Howler.ctx.currentTime);
                sound._panner.positionY.setValueAtTime(sound._pos[1], Howler.ctx.currentTime);
                sound._panner.positionZ.setValueAtTime(sound._pos[2], Howler.ctx.currentTime);
            } else sound._panner.setPosition(sound._pos[0], sound._pos[1], sound._pos[2]);
            if (typeof sound._panner.orientationX !== 'undefined') {
                sound._panner.orientationX.setValueAtTime(sound._orientation[0], Howler.ctx.currentTime);
                sound._panner.orientationY.setValueAtTime(sound._orientation[1], Howler.ctx.currentTime);
                sound._panner.orientationZ.setValueAtTime(sound._orientation[2], Howler.ctx.currentTime);
            } else sound._panner.setOrientation(sound._orientation[0], sound._orientation[1], sound._orientation[2]);
        } else {
            sound._panner = Howler.ctx.createStereoPanner();
            sound._panner.pan.setValueAtTime(sound._stereo, Howler.ctx.currentTime);
        }
        sound._panner.connect(sound._node);
        // Update the connections.
        if (!sound._paused) sound._parent.pause(sound._id, true).play(sound._id, true);
    };
})();



class $01161cf60774ccdb$export$55a5cecb88257141 {
    constructor(sourceFile, firstScreen, autoplay, volume, muted){
        this._timeoutID = 0;
        const url = (0, $1a153cf88c479932$export$31acd2ae5bbde00f).MUSIC + sourceFile;
        this._audio = new (0, $f89d8ffbdc18f2ab$export$b791fe48eec8032a)({
            src: [
                url
            ],
            autoplay: autoplay,
            loop: false,
            volume: volume,
            onplay: ()=>{
                window.engine.showPauseButton();
                const fadeouttime = 2000;
                this._timeoutID = window.setTimeout(()=>{
                    const fadeouttime = 2000;
                    this._audio.fade(this._audio.volume(), 0, fadeouttime);
                }, (this._audio.duration() - this._audio.seek()) * 1000 - fadeouttime);
            },
            onend: ()=>{
                window.clearTimeout(this._timeoutID);
                this._audio.volume(window.engine.getMusicVolume());
                this._audio.fade(0, this._audio.volume(), 2000);
                this.play();
            },
            onload: ()=>{
                window.engine.audioReady(firstScreen);
            },
            onloaderror: ()=>{
                console.log("[ERROR] MusicPlayer failed to load: " + url);
            },
            onplayerror: ()=>{
                window.engine.showPlayButton();
            }
        });
        if (muted) this._audio.mute();
    }
    mute() {
        this._audio.mute(true);
    }
    unmute() {
        this._audio.mute(false);
    }
    pause() {
        this._audio.pause();
    }
    play() {
        this._audio.play();
    }
    setVolume(volume) {
        this._audio.volume(volume);
    }
    stop() {
        clearTimeout(this._timeoutID);
        this._audio.fade(this._audio.volume(), 0, 500);
        this._audio.seek(0);
        this._audio.stop();
    }
    unload() {
        clearTimeout(this._timeoutID);
        this._audio.unload();
    }
}




















function $57907ac0dd7a2328$export$b0227e222f85c7a5(optic) {
    let color = (0, $f0b5fa422dff3899$export$b1b64d948644442b).NONE;
    if (optic !== undefined) switch(optic){
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_RED:
            color = (0, $f0b5fa422dff3899$export$b1b64d948644442b).RED;
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_BLUE:
            color = (0, $f0b5fa422dff3899$export$b1b64d948644442b).BLUE;
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_GREEN:
            color = (0, $f0b5fa422dff3899$export$b1b64d948644442b).GREEN;
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_MAGENTA:
            color = (0, $f0b5fa422dff3899$export$b1b64d948644442b).MAGENTA;
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_CYAN:
            color = (0, $f0b5fa422dff3899$export$b1b64d948644442b).CYAN;
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_YELLOW:
            color = (0, $f0b5fa422dff3899$export$b1b64d948644442b).YELLOW;
            break;
    }
    return color;
}
function $57907ac0dd7a2328$export$8d85461fad8010ba(color) {
    switch(color.toUpperCase()){
        case "RED":
            return (0, $f0b5fa422dff3899$export$b1b64d948644442b).RED;
        case "GREEN":
            return (0, $f0b5fa422dff3899$export$b1b64d948644442b).GREEN;
        case "BLUE":
            return (0, $f0b5fa422dff3899$export$b1b64d948644442b).BLUE;
        case "YELLOW":
            return (0, $f0b5fa422dff3899$export$b1b64d948644442b).YELLOW;
        case "MAGENTA":
            return (0, $f0b5fa422dff3899$export$b1b64d948644442b).MAGENTA;
        case "CYAN":
            return (0, $f0b5fa422dff3899$export$b1b64d948644442b).CYAN;
    }
    return (0, $f0b5fa422dff3899$export$b1b64d948644442b).NONE;
}
function $57907ac0dd7a2328$export$1071895c7014e035(color) {
    let output = "unknown";
    switch(color){
        case (0, $f0b5fa422dff3899$export$b1b64d948644442b).RED:
            output = "red";
            break;
        case (0, $f0b5fa422dff3899$export$b1b64d948644442b).BLUE:
            output = "blue";
            break;
        case (0, $f0b5fa422dff3899$export$b1b64d948644442b).GREEN:
            output = "green";
            break;
        case (0, $f0b5fa422dff3899$export$b1b64d948644442b).YELLOW:
            output = "yellow";
            break;
        case (0, $f0b5fa422dff3899$export$b1b64d948644442b).MAGENTA:
            output = "magenta";
            break;
        case (0, $f0b5fa422dff3899$export$b1b64d948644442b).CYAN:
            output = "cyan";
            break;
    }
    return output;
}
function $57907ac0dd7a2328$export$400d6f4772940894(color) {
    let hex = "";
    switch(color){
        case (0, $f0b5fa422dff3899$export$b1b64d948644442b).RED:
            hex = "#f00";
            break;
        case (0, $f0b5fa422dff3899$export$b1b64d948644442b).GREEN:
            hex = "#0f0";
            break;
        case (0, $f0b5fa422dff3899$export$b1b64d948644442b).BLUE:
            hex = "#00f";
            break;
        case (0, $f0b5fa422dff3899$export$b1b64d948644442b).YELLOW:
            hex = "#ff0";
            break;
        case (0, $f0b5fa422dff3899$export$b1b64d948644442b).MAGENTA:
            hex = "#f0f";
            break;
        case (0, $f0b5fa422dff3899$export$b1b64d948644442b).CYAN:
            hex = "#0ff";
            break;
    }
    return hex;
}
function $57907ac0dd7a2328$export$331178d20d0fceea(red, green, blue) {
    if (red == 255 && green == 0 && blue == 0) return (0, $f0b5fa422dff3899$export$b1b64d948644442b).RED;
    else if (red == 0 && green == 255 && blue == 0) return (0, $f0b5fa422dff3899$export$b1b64d948644442b).GREEN;
    else if (red == 0 && green == 0 && blue == 255) return (0, $f0b5fa422dff3899$export$b1b64d948644442b).BLUE;
    else if (red == 255 && green == 255 && blue == 0) return (0, $f0b5fa422dff3899$export$b1b64d948644442b).YELLOW;
    else if (red == 255 && green == 0 && blue == 255) return (0, $f0b5fa422dff3899$export$b1b64d948644442b).MAGENTA;
    else if (red == 0 && green == 255 && blue == 255) return (0, $f0b5fa422dff3899$export$b1b64d948644442b).CYAN;
    return undefined;
}
function $57907ac0dd7a2328$export$b4153c7f22f466f5(color) {
    switch(color){
        case (0, $f0b5fa422dff3899$export$b1b64d948644442b).RED:
            return (0, $248954e6cbd64b56$export$b278fa1959b09b13).RED;
        case (0, $f0b5fa422dff3899$export$b1b64d948644442b).GREEN:
            return (0, $248954e6cbd64b56$export$b278fa1959b09b13).GREEN;
        case (0, $f0b5fa422dff3899$export$b1b64d948644442b).BLUE:
            return (0, $248954e6cbd64b56$export$b278fa1959b09b13).BLUE;
        case (0, $f0b5fa422dff3899$export$b1b64d948644442b).YELLOW:
            return (0, $248954e6cbd64b56$export$b278fa1959b09b13).YELLOW;
        case (0, $f0b5fa422dff3899$export$b1b64d948644442b).MAGENTA:
            return (0, $248954e6cbd64b56$export$b278fa1959b09b13).MAGENTA;
        case (0, $f0b5fa422dff3899$export$b1b64d948644442b).CYAN:
            return (0, $248954e6cbd64b56$export$b278fa1959b09b13).CYAN;
    }
    return undefined;
}
function $57907ac0dd7a2328$export$b5b1545233b45293(rgb) {
    const alpha = rgb.a !== undefined ? rgb.a : 1;
    return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha})`;
}





class $4eb913d747a4045d$export$c8cc3dd925ca4fe5 {
    constructor(type, usageTimer, cooldownTimer, player){
        this._timeoutID = undefined;
        this._active = false;
        this._onCooldown = false;
        this._callback = undefined;
        this._type = type;
        this._usageTimer = usageTimer;
        this._cooldownTimer = cooldownTimer;
        this._player = player;
    }
    set callback(c) {
        this._callback = c;
    }
    get active() {
        return this._active;
    }
    get onCooldown() {
        return this._onCooldown;
    }
    get type() {
        return this._type;
    }
    stop() {
        if (this._timeoutID !== undefined) {
            this._active = false;
            this._onCooldown = false;
            window.clearTimeout(this._timeoutID);
            this._timeoutID = undefined;
        }
    }
    activate() {
        this._active = true;
        this._timeoutID = window.setTimeout(()=>{
            this._active = false;
            this._onCooldown = true;
            if (this._callback !== undefined) this._callback(this._player);
            this.cooldown();
        }, this._usageTimer);
    }
    cooldown() {
        this._timeoutID = window.setInterval(()=>{
            this._onCooldown = false;
            if (this._callback !== undefined) this._callback(this._player);
        }, this._cooldownTimer);
    }
}


function $951bfacf562ab356$export$af6d2430b1867536(type, player) {
    let gizmo = undefined;
    switch(type){
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO1:
            gizmo = new (0, $4eb913d747a4045d$export$c8cc3dd925ca4fe5)((0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO1, 0, 0, player);
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO2:
            gizmo = new (0, $4eb913d747a4045d$export$c8cc3dd925ca4fe5)((0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO2, 0, 0, player);
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO3:
            gizmo = new (0, $4eb913d747a4045d$export$c8cc3dd925ca4fe5)((0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO3, (0, $1a153cf88c479932$export$2e8fd7f1bc5e2154).GIZMO3.ACTIVE, (0, $1a153cf88c479932$export$2e8fd7f1bc5e2154).GIZMO3.COOLDOWN, player);
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO4:
            gizmo = new (0, $4eb913d747a4045d$export$c8cc3dd925ca4fe5)((0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO4, (0, $1a153cf88c479932$export$2e8fd7f1bc5e2154).GIZMO4.ACTIVE, (0, $1a153cf88c479932$export$2e8fd7f1bc5e2154).GIZMO4.COOLDOWN, player);
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO5:
            gizmo = new (0, $4eb913d747a4045d$export$c8cc3dd925ca4fe5)((0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO5, (0, $1a153cf88c479932$export$2e8fd7f1bc5e2154).GIZMO5.ACTIVE, (0, $1a153cf88c479932$export$2e8fd7f1bc5e2154).GIZMO5.COOLDOWN, player);
            break;
    }
    return gizmo;
}







function $1eb61eaeba4c6dbc$export$9ee3990868f8c2a3(player) {
    let output = `%c{#fff}%b{#000}none`;
    switch(player.optic){
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_YELLOW:
            output = `%c{${(0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_YELLOW}}%b{#000}yellow`;
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_RED:
            output = `%c{${(0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_RED}}%b{#000}red`;
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_MAGENTA:
            output = `%c{${(0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_MAGENTA}}%b{#000}magenta`;
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_BLUE:
            output = `%c{${(0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_BLUE}}%b{#000}blue`;
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_CYAN:
            output = `%c{${(0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_CYAN}}%b{#000}cyan`;
            break;
        case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_GREEN:
            output = `%c{${(0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_GREEN}}%b{#000}green`;
            break;
        default:
            break;
    }
    return output;
}
function $1eb61eaeba4c6dbc$export$af9f2c0e67d602b4(level) {
    switch(level){
        case 2:
            return (0, $1a153cf88c479932$export$4906643e6c3605fc).EXP_LEVEL2;
        case 3:
            return (0, $1a153cf88c479932$export$4906643e6c3605fc).EXP_LEVEL3;
        case 4:
            return (0, $1a153cf88c479932$export$4906643e6c3605fc).EXP_LEVEL4;
        case 5:
            return (0, $1a153cf88c479932$export$4906643e6c3605fc).EXP_LEVEL5;
        case 6:
            return (0, $1a153cf88c479932$export$4906643e6c3605fc).EXP_LEVEL6;
        case 7:
            return (0, $1a153cf88c479932$export$4906643e6c3605fc).EXP_LEVEL7;
        case 8:
            return (0, $1a153cf88c479932$export$4906643e6c3605fc).EXP_LEVEL8;
        case 9:
            return (0, $1a153cf88c479932$export$4906643e6c3605fc).EXP_LEVEL9;
        case 10:
            return (0, $1a153cf88c479932$export$4906643e6c3605fc).EXP_LEVEL10;
    }
    return 0;
}
function $1eb61eaeba4c6dbc$export$a65570da70ec0f15(player) {
    const allKeys = [
        (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).January,
        (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).February,
        (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).March,
        (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).April,
        (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).May,
        (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).June,
        (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).July,
        (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).August,
        (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).September,
        (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).October,
        (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).November,
        (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).December
    ];
    const equipment = [
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD1,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD2,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD3,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD4,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD5,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD6,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD7,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD8,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO1,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO2,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO3,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO4,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO5,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO6,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO7,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO8,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET1,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET2,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET3,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET4,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET5,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET6,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET7,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET8,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON1,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON2,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON3,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON4,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON5,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON6,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON7
    ];
    const optics = [
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_RED,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_GREEN,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_BLUE,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_YELLOW,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_MAGENTA,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_CYAN
    ];
    const gizmos = [
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO_NONE,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO1,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO2,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO3,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO4,
        (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO5
    ];
    allKeys.forEach((k)=>{
        player.addKey(k);
    });
    equipment.forEach((e)=>{
        player.addEquipment(e);
    });
    optics.forEach((o)=>{
        player.addOptic(o);
    });
    gizmos.forEach((g)=>{
        player.addEquipment(g);
    });
    window.engine.requestPlayerSaveState();
    window.engine.sendMessage("You now have all keys/optics/equipment");
    return;
}




class $47e4dec76b7e0789$export$c8be6589e5a7471 {
    constructor(type, contents, year, month, dayOfMonth){
        this.type = type;
        this.contents = contents;
        if (year === undefined) {
            const date = new Date();
            this._year = date.getUTCFullYear();
            this._month = date.getUTCMonth() + 1;
            this._dayOfMonth = date.getUTCDate() % 100;
        } else {
            this._year = year > 100 ? year % 100 : year;
            if (month) this._month = month;
            if (dayOfMonth) this._dayOfMonth = dayOfMonth;
        }
    }
    get year() {
        return this._year;
    }
    get month() {
        return this._month;
    }
    get dayOfMonth() {
        return this._dayOfMonth;
    }
    toString(bg) {
        const date = this._month + "/" + this._dayOfMonth + "/" + this._year;
        return `%c{${(0, $248954e6cbd64b56$export$892596cec99bc70e).HINT_CONTENTS}}%b{${bg}}${this.contents} [found ` + `%c{${(0, $248954e6cbd64b56$export$892596cec99bc70e).HINT_DATE}}%b{${bg}}${date}` + `%c{#fff}%b{${bg}}]`;
    }
}


class $c7705b01e631e42c$export$2616165974278734 {
    static{
        this.DEFAULT_EQUIPMENT = [
            (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD_NONE,
            (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO_NONE,
            (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET_NONE,
            (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO_NONE,
            (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON_NONE
        ];
    }
    constructor(position){
        this.VERSION = 1.0;
        this._visits = {
            january: 0,
            february: 0,
            march: 0,
            april: 0,
            may: 0,
            june: 0,
            july: 0,
            august: 0,
            september: 0,
            october: 0,
            november: 0,
            december: 0
        };
        this._deaths = 0;
        this._level = 1;
        this._experience = 0;
        this._moved = false;
        this._hints = [];
        this._keys = [];
        this._items = [];
        this._equipment = {
            head: (0, $1a153cf88c479932$export$f78a7bc9efcc5615).NONE,
            torso: (0, $1a153cf88c479932$export$f78a7bc9efcc5615).NONE,
            feet: (0, $1a153cf88c479932$export$f78a7bc9efcc5615).NONE,
            leftHand: (0, $1a153cf88c479932$export$f78a7bc9efcc5615).NONE,
            rightHand: (0, $1a153cf88c479932$export$f78a7bc9efcc5615).NONE
        };
        this._gizmo = undefined;
        // for Polychrome Optic
        this._canSeeAll = false;
        // for Ring of Invincibility
        this._essenceInvincible = false;
        // for Antitheft Charm
        this._pigmentInvincible = false;
        this._position = {
            ...position
        };
        this._render = (0, $1a153cf88c479932$export$4906643e6c3605fc).RENDER;
        this._combat = {
            ...(0, $1a153cf88c479932$export$4906643e6c3605fc).COMBAT.LEVEL1
        };
        this._facing = (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).RIGHT;
        this._elixirs = (0, $1a153cf88c479932$export$4906643e6c3605fc).START_ELIXIRS;
        this._vision = (0, $1a153cf88c479932$export$4906643e6c3605fc).START_VISION;
        this._pigments = {
            ...(0, $248954e6cbd64b56$export$39034d5acc75bbc1)()
        };
        this._pigmentsCollected = {
            ...(0, $248954e6cbd64b56$export$39034d5acc75bbc1)()
        };
        this._binders = (0, $1a153cf88c479932$export$4906643e6c3605fc).START_BINDER;
        this._bindersCollected = {
            ...(0, $1a153cf88c479932$export$4906643e6c3605fc).START_BINDERS_COLLECTED
        };
        this._commonCollectibles = {
            ...(0, $0a0c617bf4bc5c84$export$c2867dfeeb3beaf9)()
        };
        this._mythicCollectibles = {
            ...(0, $0a0c617bf4bc5c84$export$c2867dfeeb3beaf9)()
        };
        this._optics = [
            (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_NONE
        ];
        this._currentOptic = 0;
        this._foundEquipment = [];
        $c7705b01e631e42c$export$2616165974278734.DEFAULT_EQUIPMENT.forEach((e)=>{
            this.addEquipment(e);
        });
        this.equip(this._foundEquipment);
    }
    get deaths() {
        return this._deaths;
    }
    get experience() {
        return this._experience;
    }
    get level() {
        return this._level;
    }
    get moved() {
        return this._moved;
    }
    get optics() {
        return this._optics;
    }
    overwriteOptics(optics) {
        this._optics = optics;
    }
    get stealth() {
        return this.computeStealthRange();
    }
    get bindersCollected() {
        return this._bindersCollected;
    }
    getTotalBindersCollected() {
        return this._bindersCollected.jan + this._bindersCollected.feb + this._bindersCollected.mar + this._bindersCollected.apr + this._bindersCollected.may + this._bindersCollected.jun + this._bindersCollected.jul + this._bindersCollected.aug + this._bindersCollected.sep + this._bindersCollected.oct + this._bindersCollected.nov + this._bindersCollected.dec;
    }
    getPigmentCollected() {
        return this._pigmentsCollected;
    }
    visit(month) {
        switch(month){
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).January:
                this._visits.january += 1;
                break;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).February:
                this._visits.february += 1;
                break;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).March:
                this._visits.march += 1;
                break;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).April:
                this._visits.april += 1;
                break;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).May:
                this._visits.may += 1;
                break;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).June:
                this._visits.june += 1;
                break;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).July:
                this._visits.july += 1;
                break;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).August:
                this._visits.august += 1;
                break;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).September:
                this._visits.september += 1;
                break;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).October:
                this._visits.october += 1;
                break;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).November:
                this._visits.november += 1;
                break;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).December:
                this._visits.december += 1;
                break;
        }
    }
    get visits() {
        return this._visits;
    }
    getGizmosCount() {
        let gizmos = 0;
        this._foundEquipment.forEach((e)=>{
            if (e.type != (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO_NONE && $95a3e0019f5651ca$export$59222e1cac6d5d6d(e.type)) gizmos += 1;
        });
        return gizmos;
    }
    getWeaponsCount() {
        let weapons = 0;
        this._foundEquipment.forEach((e)=>{
            if (e.type != (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON_NONE && $95a3e0019f5651ca$export$b22d0746a791758f(e.type)) weapons += 1;
        });
        return weapons;
    }
    getWearablesCount() {
        let wearables = 0;
        this._foundEquipment.forEach((e)=>{
            if (e.type != (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD_NONE && $95a3e0019f5651ca$export$f7147161cc4c402f(e.type) || e.type != (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO_NONE && $95a3e0019f5651ca$export$39fd1bf1c7e0a20d(e.type) || e.type != (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET_NONE && $95a3e0019f5651ca$export$6f5c86f1bae3a2f4(e.type)) wearables += 1;
        });
        return wearables;
    }
    getNextLevelExpString() {
        if (this._level < (0, $1a153cf88c479932$export$4906643e6c3605fc).MAX_LEVEL) {
            const next = this._level + 1;
            const nextExp = (0, $1eb61eaeba4c6dbc$export$af9f2c0e67d602b4)(next);
            return `(next -> ${nextExp})`;
        }
        return "(AT MAX)";
    }
    addDeath() {
        this._deaths += 1;
    }
    addElixir(amount) {
        if (this._elixirs >= (0, $1a153cf88c479932$export$4906643e6c3605fc).MAX_ELIXIRS) return 0;
        let canAdd = (0, $1a153cf88c479932$export$4906643e6c3605fc).MAX_ELIXIRS - this._elixirs;
        if (amount <= canAdd) {
            this._elixirs += amount;
            return amount;
        } else {
            this._elixirs += canAdd;
            return canAdd;
        }
    }
    addExperience(amount) {
        this._experience += amount;
        if (this._level < (0, $1a153cf88c479932$export$4906643e6c3605fc).MAX_LEVEL && this.shouldLevelUp()) this.setLevel(this._level + 1);
    }
    shouldLevelUp() {
        if (this._experience >= (0, $1a153cf88c479932$export$4906643e6c3605fc).EXP_LEVEL10 && this._level == 9) return true;
        else if (this._experience >= (0, $1a153cf88c479932$export$4906643e6c3605fc).EXP_LEVEL9 && this._level == 8) return true;
        else if (this._experience >= (0, $1a153cf88c479932$export$4906643e6c3605fc).EXP_LEVEL8 && this._level == 7) return true;
        else if (this._experience >= (0, $1a153cf88c479932$export$4906643e6c3605fc).EXP_LEVEL7 && this._level == 6) return true;
        else if (this._experience >= (0, $1a153cf88c479932$export$4906643e6c3605fc).EXP_LEVEL6 && this._level == 5) return true;
        else if (this._experience >= (0, $1a153cf88c479932$export$4906643e6c3605fc).EXP_LEVEL5 && this._level == 4) return true;
        else if (this._experience >= (0, $1a153cf88c479932$export$4906643e6c3605fc).EXP_LEVEL4 && this._level == 3) return true;
        else if (this._experience >= (0, $1a153cf88c479932$export$4906643e6c3605fc).EXP_LEVEL3 && this._level == 2) return true;
        else if (this._experience >= (0, $1a153cf88c479932$export$4906643e6c3605fc).EXP_LEVEL2 && this._level == 1) return true;
        return false;
    }
    setLevel(level) {
        if (level == 10) {
            this._level = 10;
            this._combat = {
                ...(0, $1a153cf88c479932$export$4906643e6c3605fc).COMBAT.LEVEL10
            };
        } else if (level == 9) {
            this._level = 9;
            this._combat = {
                ...(0, $1a153cf88c479932$export$4906643e6c3605fc).COMBAT.LEVEL9
            };
        } else if (level == 8) {
            this._level = 8;
            this._combat = {
                ...(0, $1a153cf88c479932$export$4906643e6c3605fc).COMBAT.LEVEL8
            };
        } else if (level == 7) {
            this._level = 7;
            this._combat = {
                ...(0, $1a153cf88c479932$export$4906643e6c3605fc).COMBAT.LEVEL7
            };
        } else if (level == 6) {
            this._level = 6;
            this._combat = {
                ...(0, $1a153cf88c479932$export$4906643e6c3605fc).COMBAT.LEVEL6
            };
        } else if (level == 5) {
            this._level = 5;
            this._combat = {
                ...(0, $1a153cf88c479932$export$4906643e6c3605fc).COMBAT.LEVEL5
            };
        } else if (level == 4) {
            this._level = 4;
            this._combat = {
                ...(0, $1a153cf88c479932$export$4906643e6c3605fc).COMBAT.LEVEL4
            };
        } else if (level == 3) {
            this._level = 3;
            this._combat = {
                ...(0, $1a153cf88c479932$export$4906643e6c3605fc).COMBAT.LEVEL3
            };
        } else if (level == 2) {
            this._level = 2;
            this._combat = {
                ...(0, $1a153cf88c479932$export$4906643e6c3605fc).COMBAT.LEVEL2
            };
        } else if (level == 1) {
            this._level = 1;
            this._combat = {
                ...(0, $1a153cf88c479932$export$4906643e6c3605fc).COMBAT.LEVEL1
            };
        }
    }
    isAlive() {
        return this.combat.essence > 0;
    }
    dealHit() {
        return this.computeEssenceAttack();
    }
    takeHit(amount) {
        if (this._essenceInvincible) return 0;
        const damage = amount - this.computeEssenceDefense();
        const damageTaken = damage > 0 ? damage : 0;
        this.combat.essence -= damageTaken;
        return damageTaken;
    }
    computeEssenceAttack() {
        let min = this.combat.minAttack;
        let max = this.combat.maxAttack;
        if (this._equipment.leftHand !== undefined) {
            min += this._equipment.leftHand.minEssenceAttack;
            max += this._equipment.leftHand.maxEssenceAttack;
        }
        if (this._equipment.rightHand !== undefined) {
            min += this._equipment.rightHand.minEssenceAttack;
            max += this._equipment.rightHand.maxEssenceAttack;
        }
        return (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(min, max);
    }
    computeEssenceMaxAttack() {
        let maxAttack = this.combat.maxAttack;
        if (this._equipment.leftHand !== undefined) maxAttack += this._equipment.leftHand.maxEssenceAttack;
        if (this._equipment.rightHand !== undefined) maxAttack += this._equipment.rightHand.maxEssenceAttack;
        return maxAttack;
    }
    computeEssenceDefense() {
        let defense = this.combat.essenceDefense;
        if (this._equipment.head !== undefined) defense += this._equipment.head.essenceDefense;
        if (this._equipment.torso !== undefined) defense += this._equipment.torso.essenceDefense;
        if (this._equipment.feet !== undefined) defense += this._equipment.feet.essenceDefense;
        return Math.min((0, $1a153cf88c479932$export$4906643e6c3605fc).MAX_STAT, defense);
    }
    computePigmentDefense() {
        let defense = this.combat.pigmentDefense ? this.combat.pigmentDefense : 0;
        if (this._equipment.head !== undefined) defense += this._equipment.head.pigmentDefense;
        if (this._equipment.torso !== undefined) defense += this._equipment.torso.pigmentDefense;
        if (this._equipment.feet !== undefined) defense += this._equipment.feet.pigmentDefense;
        return Math.min((0, $1a153cf88c479932$export$4906643e6c3605fc).MAX_STAT, defense);
    }
    computeStealthRange() {
        let range = this.combat.stealthRange ? this.combat.stealthRange : 0;
        if (this._equipment.head !== undefined) range += this._equipment.head.stealthRange;
        if (this._equipment.torso !== undefined) range += this._equipment.torso.stealthRange;
        if (this._equipment.feet !== undefined) range += this._equipment.feet.stealthRange;
        return Math.min((0, $1a153cf88c479932$export$4906643e6c3605fc).MAX_STAT, range);
    }
    addCollectible(c, mapID) {
        const month = (0, $b296c6d74f581bce$export$32f6dae5310d379c)(mapID).substring(0, 3).toUpperCase();
        if ((0, $0a0c617bf4bc5c84$export$fd176820b8063053)(c.type)) return this.addCollectibleToMonth(c, this._commonCollectibles, month);
        else if ((0, $0a0c617bf4bc5c84$export$23f70935b329f7fd)(c.type)) return this.addCollectibleToMonth(c, this._mythicCollectibles, month);
        return false;
    }
    addCollectibleToMonth(c, set, month) {
        switch(month){
            case "JAN":
                if (set.jan === undefined) {
                    set.jan = c;
                    return true;
                }
                break;
            case "FEB":
                if (set.feb === undefined) {
                    set.feb = c;
                    return true;
                }
                break;
            case "MAR":
                if (set.mar === undefined) {
                    set.mar = c;
                    return true;
                }
                break;
            case "APR":
                if (set.apr === undefined) {
                    set.apr = c;
                    return true;
                }
                break;
            case "MAY":
                if (set.may === undefined) {
                    set.may = c;
                    return true;
                }
                break;
            case "JUN":
                if (set.jun === undefined) {
                    set.jun = c;
                    return true;
                }
                break;
            case "JUL":
                if (set.jul === undefined) {
                    set.jul = c;
                    return true;
                }
                break;
            case "AUG":
                if (set.aug === undefined) {
                    set.aug = c;
                    return true;
                }
                break;
            case "SEP":
                if (set.sep === undefined) {
                    set.sep = c;
                    return true;
                }
                break;
            case "OCT":
                if (set.oct === undefined) {
                    set.oct = c;
                    return true;
                }
                break;
            case "NOV":
                if (set.nov === undefined) {
                    set.nov = c;
                    return true;
                }
                break;
            case "DEC":
                if (set.dec === undefined) {
                    set.dec = c;
                    return true;
                }
                break;
        }
        return false;
    }
    getCollectibles(type) {
        if (type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).COLLECTIBLE_COMMON) return this.commonCollectibles;
        else if (type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).COLLECTIBLE_MYTHIC) return this.mythicCollectibles;
        return [];
    }
    get commonCollectibles() {
        let collectibles = [];
        Object.entries(this._commonCollectibles).forEach(([_, coll])=>{
            if (coll !== undefined) collectibles.push(coll);
        });
        return collectibles;
    }
    hasCommonCollectible(mapID) {
        let result = false;
        const mapStr = (0, $b296c6d74f581bce$export$32f6dae5310d379c)(mapID).substring(0, 3).toLowerCase();
        Object.entries(this._commonCollectibles).every(([month, coll])=>{
            if (mapStr == month && coll !== undefined) {
                result = true;
                return false;
            }
            return true;
        });
        return result;
    }
    get mythicCollectibles() {
        let collectibles = [];
        Object.entries(this._mythicCollectibles).forEach(([_, coll])=>{
            if (coll !== undefined) collectibles.push(coll);
        });
        return collectibles;
    }
    hasMythicCollectible(mapID) {
        let result = false;
        const mapStr = (0, $b296c6d74f581bce$export$32f6dae5310d379c)(mapID).substring(0, 3).toLowerCase();
        Object.entries(this._mythicCollectibles).every(([month, coll])=>{
            if (mapStr == month && coll !== undefined) {
                result = true;
                return false;
            }
            return true;
        });
        return result;
    }
    get equipment() {
        return this._foundEquipment;
    }
    addEquipment(i) {
        if (!this.hasEquipment(i)) {
            let equipment = $95a3e0019f5651ca$export$f8e8d6996b9c24dc(i);
            if (equipment !== undefined) this._foundEquipment.push({
                ...equipment
            });
        }
    }
    hasEquipment(e) {
        for(let i = 0; i < this._foundEquipment.length; ++i){
            if (this._foundEquipment[i].type == e) return true;
        }
        return false;
    }
    // Items to avoid duplicates:
    // hints
    // keys
    // optics
    // equipment
    hasMapItem(item) {
        switch(item.type){
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).HINT_COLLECTIBLE:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).HINT_INFO:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).HINT_WARNING:
                if (item.textContents !== undefined) return this.hasHint(item.textContents);
                break;
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD1:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD2:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD3:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD4:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD5:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD6:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD7:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_HEAD8:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO1:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO2:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO3:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO4:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO5:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO6:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO7:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_TORSO8:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET1:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET2:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET3:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET4:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET5:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET6:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET7:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_FEET8:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO1:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO2:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO3:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO4:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO5:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO6:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON1:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON2:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON3:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON4:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON5:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON6:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_WEAPON7:
                return this.hasEquipment(item.type);
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).KEY:
                if (item.keyTarget !== undefined) return this.hasKey(item.keyTarget);
                break;
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_RED:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_GREEN:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_BLUE:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_MAGENTA:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_CYAN:
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_YELLOW:
                return this.hasOptic(item.type);
        }
        return false;
    }
    hasHint(find) {
        const upFind = find.toUpperCase();
        for(let i = 0; i < this._hints.length; ++i){
            const upHave = this._hints[i].contents.toUpperCase();
            if (upFind == upHave) return true;
        }
        return false;
    }
    addHint(hint) {
        if (!this._hints.find((c)=>{
            return c.type == hint.type && c.contents == hint.contents && c.year == hint.year && c.month == hint.month && c.dayOfMonth == hint.dayOfMonth;
        })) {
            this._hints.unshift(hint);
            return true;
        }
        return false;
    }
    bindPigment(color) {
        if (!this.canBind(color)) return false;
        else {
            switch(color){
                case (0, $f0b5fa422dff3899$export$b1b64d948644442b).RED:
                    this._pigments.red -= (0, $1a153cf88c479932$export$29ad37babd04e544).PIGMENT_PER_BIND;
                    break;
                case (0, $f0b5fa422dff3899$export$b1b64d948644442b).GREEN:
                    this._pigments.green -= (0, $1a153cf88c479932$export$29ad37babd04e544).PIGMENT_PER_BIND;
                    break;
                case (0, $f0b5fa422dff3899$export$b1b64d948644442b).BLUE:
                    this._pigments.blue -= (0, $1a153cf88c479932$export$29ad37babd04e544).PIGMENT_PER_BIND;
                    break;
                case (0, $f0b5fa422dff3899$export$b1b64d948644442b).YELLOW:
                    this._pigments.yellow -= (0, $1a153cf88c479932$export$29ad37babd04e544).PIGMENT_PER_BIND;
                    break;
                case (0, $f0b5fa422dff3899$export$b1b64d948644442b).MAGENTA:
                    this._pigments.magenta -= (0, $1a153cf88c479932$export$29ad37babd04e544).PIGMENT_PER_BIND;
                    break;
                case (0, $f0b5fa422dff3899$export$b1b64d948644442b).CYAN:
                    this._pigments.cyan -= (0, $1a153cf88c479932$export$29ad37babd04e544).PIGMENT_PER_BIND;
                    break;
                default:
                    return false;
            }
            this._binders -= 1;
            window.engine.requestPlayerSaveState();
            return true;
        }
    }
    canBind(color) {
        if (this._binders > 0) switch(color){
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).RED:
                if (this._pigments.red >= (0, $1a153cf88c479932$export$29ad37babd04e544).PIGMENT_PER_BIND) return true;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).GREEN:
                if (this._pigments.green >= (0, $1a153cf88c479932$export$29ad37babd04e544).PIGMENT_PER_BIND) return true;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).BLUE:
                if (this._pigments.blue >= (0, $1a153cf88c479932$export$29ad37babd04e544).PIGMENT_PER_BIND) return true;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).YELLOW:
                if (this._pigments.yellow >= (0, $1a153cf88c479932$export$29ad37babd04e544).PIGMENT_PER_BIND) return true;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).MAGENTA:
                if (this._pigments.magenta >= (0, $1a153cf88c479932$export$29ad37babd04e544).PIGMENT_PER_BIND) return true;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).CYAN:
                if (this._pigments.cyan >= (0, $1a153cf88c479932$export$29ad37babd04e544).PIGMENT_PER_BIND) return true;
                break;
            default:
                return false;
        }
        return false;
    }
    getBindablePigments() {
        let bindables = [
            {
                color: (0, $f0b5fa422dff3899$export$b1b64d948644442b).RED,
                bindable: false
            },
            {
                color: (0, $f0b5fa422dff3899$export$b1b64d948644442b).GREEN,
                bindable: false
            },
            {
                color: (0, $f0b5fa422dff3899$export$b1b64d948644442b).BLUE,
                bindable: false
            },
            {
                color: (0, $f0b5fa422dff3899$export$b1b64d948644442b).YELLOW,
                bindable: false
            },
            {
                color: (0, $f0b5fa422dff3899$export$b1b64d948644442b).MAGENTA,
                bindable: false
            },
            {
                color: (0, $f0b5fa422dff3899$export$b1b64d948644442b).CYAN,
                bindable: false
            }
        ];
        for(let i = 0; i < bindables.length; ++i)if (this.canBind(bindables[i].color)) bindables[i].bindable = true;
        return bindables;
    }
    getHints(type) {
        if (type === undefined) return this._hints;
        else return this._hints.filter((c)=>{
            return c.type == type;
        });
    }
    addKey(key) {
        if (!this._keys.includes(key)) this._keys.push(key);
    }
    hasKey(key) {
        return this._keys.includes(key);
    }
    addBinder(id) {
        this._binders += 1;
        switch(id){
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).January:
                this._bindersCollected.jan += 1;
                break;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).February:
                this._bindersCollected.feb += 1;
                break;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).March:
                this._bindersCollected.mar += 1;
                break;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).April:
                this._bindersCollected.apr += 1;
                break;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).May:
                this._bindersCollected.may += 1;
                break;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).June:
                this._bindersCollected.jun += 1;
                break;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).July:
                this._bindersCollected.jul += 1;
                break;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).August:
                this._bindersCollected.aug += 1;
                break;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).September:
                this._bindersCollected.sep += 1;
                break;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).October:
                this._bindersCollected.oct += 1;
                break;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).November:
                this._bindersCollected.nov += 1;
                break;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).December:
                this._bindersCollected.dec += 1;
                break;
        }
    }
    getBinders() {
        return this._binders;
    }
    getBindersCollected(id) {
        switch(id){
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).January:
                return this._bindersCollected.jan;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).February:
                return this._bindersCollected.feb;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).March:
                return this._bindersCollected.mar;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).April:
                return this._bindersCollected.apr;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).May:
                return this._bindersCollected.may;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).June:
                return this._bindersCollected.jun;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).July:
                return this._bindersCollected.jul;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).August:
                return this._bindersCollected.aug;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).September:
                return this._bindersCollected.sep;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).October:
                return this._bindersCollected.oct;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).November:
                return this._bindersCollected.nov;
            case (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).December:
                return this._bindersCollected.dec;
        }
        return 0;
    }
    get combat() {
        return this._combat;
    }
    get essence() {
        return this._combat.essence.toString();
    }
    equip(equipment) {
        equipment.forEach((e)=>{
            if ($95a3e0019f5651ca$export$f7147161cc4c402f(e.type)) this.setEquipment(e, (0, $f0b5fa422dff3899$export$45e36ab1b645cb80).HEAD);
            else if ($95a3e0019f5651ca$export$39fd1bf1c7e0a20d(e.type)) this.setEquipment(e, (0, $f0b5fa422dff3899$export$45e36ab1b645cb80).TORSO);
            else if ($95a3e0019f5651ca$export$6f5c86f1bae3a2f4(e.type)) this.setEquipment(e, (0, $f0b5fa422dff3899$export$45e36ab1b645cb80).FEET);
            else if ($95a3e0019f5651ca$export$59222e1cac6d5d6d(e.type)) {
                if (this.setEquipment(e, (0, $f0b5fa422dff3899$export$45e36ab1b645cb80).LEFT_HAND)) {
                    if (this._gizmo !== undefined) {
                        this._gizmo.stop();
                        this._gizmo = undefined;
                    }
                    this._gizmo = (0, $951bfacf562ab356$export$af6d2430b1867536)(e.type, this);
                    if (this._gizmo) {
                        if (e.type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO3) this._gizmo.callback = $c7705b01e631e42c$var$togglePolychromeOptic;
                        else if (e.type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO4) this._gizmo.callback = $c7705b01e631e42c$var$toggleEssenceInvincibility;
                        else if (e.type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO5) this._gizmo.callback = $c7705b01e631e42c$var$togglePigmentInvincibility;
                    }
                }
            } else if ($95a3e0019f5651ca$export$b22d0746a791758f(e.type)) this.setEquipment(e, (0, $f0b5fa422dff3899$export$45e36ab1b645cb80).RIGHT_HAND);
        });
    }
    setEquipment(e, loc) {
        let result = true;
        switch(loc){
            case (0, $f0b5fa422dff3899$export$45e36ab1b645cb80).HEAD:
                this._equipment.head.equipped = false;
                e.equipped = true;
                this._equipment.head = e;
                break;
            case (0, $f0b5fa422dff3899$export$45e36ab1b645cb80).TORSO:
                this._equipment.torso.equipped = false;
                e.equipped = true;
                this._equipment.torso = e;
                break;
            case (0, $f0b5fa422dff3899$export$45e36ab1b645cb80).FEET:
                this._equipment.feet.equipped = false;
                e.equipped = true;
                this._equipment.feet = e;
                break;
            case (0, $f0b5fa422dff3899$export$45e36ab1b645cb80).RIGHT_HAND:
                this._equipment.rightHand.equipped = false;
                e.equipped = true;
                this._equipment.rightHand = e;
                if (e.twoHanded) {
                    this._gizmo = undefined;
                    this._equipment.leftHand.equipped = false;
                    const e = this.getFoundEquipment((0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO_NONE);
                    if (e !== undefined) this._equipment.leftHand = e;
                }
                break;
            case (0, $f0b5fa422dff3899$export$45e36ab1b645cb80).LEFT_HAND:
                let canEquip = false;
                if (this._equipment.rightHand == null) canEquip = true;
                else if (!this._equipment.rightHand.twoHanded) canEquip = true;
                if (canEquip) {
                    this._equipment.leftHand.equipped = false;
                    e.equipped = true;
                    this._equipment.leftHand = e;
                } else result = false;
                break;
        }
        return result;
    }
    getEquipment(loc) {
        switch(loc){
            case (0, $f0b5fa422dff3899$export$45e36ab1b645cb80).HEAD:
                return this._equipment.head;
            case (0, $f0b5fa422dff3899$export$45e36ab1b645cb80).TORSO:
                return this._equipment.torso;
            case (0, $f0b5fa422dff3899$export$45e36ab1b645cb80).FEET:
                return this._equipment.feet;
            case (0, $f0b5fa422dff3899$export$45e36ab1b645cb80).LEFT_HAND:
                return this._equipment.leftHand;
            default:
                return this._equipment.rightHand;
        }
    }
    getFoundEquipment(type) {
        for(let i = 0; i < this._foundEquipment.length; ++i){
            if (this._foundEquipment[i].type == type) return this._foundEquipment[i];
        }
        return undefined;
    }
    // TODO: cap these stats? at 10?
    getEquipmentStats() {
        let stats = {
            ...(0, $1a153cf88c479932$export$f78a7bc9efcc5615).NONE
        };
        stats.maxEssenceAttack = this.computeEssenceMaxAttack();
        stats.essenceDefense = this.computeEssenceDefense();
        stats.pigmentDefense = this.computePigmentDefense();
        stats.stealthRange = this.computeStealthRange();
        return stats;
    }
    get position() {
        return this._position;
    }
    get elixirs() {
        return this._elixirs;
    }
    get optic() {
        let result = undefined;
        if (this._optics.length > 0) result = this._optics[this._currentOptic];
        return result;
    }
    get vision() {
        return this._vision;
    }
    setPosition(p) {
        this._position = {
            ...p
        };
    }
    addEssence(amount) {
        if (this._combat.essence < (0, $1a153cf88c479932$export$4906643e6c3605fc).MAX_ESSENCE) {
            this._combat.essence += amount;
            if (this._combat.essence > (0, $1a153cf88c479932$export$4906643e6c3605fc).MAX_ESSENCE) this._combat.essence = (0, $1a153cf88c479932$export$4906643e6c3605fc).MAX_ESSENCE;
            window.engine.sendMessage("You gain essence and become more solid");
        }
    }
    useElixir() {
        if (this._elixirs == 0) {
            window.engine.sendMessage("You have no elixirs", false);
            return false;
        } else if (this._combat.essence < this._combat.maxEssence) {
            this._combat.essence += (0, $1a153cf88c479932$export$4906643e6c3605fc).ELIXIR_HEALING;
            if (this._combat.essence > this._combat.maxEssence) this._combat.essence = this._combat.maxEssence;
            this._elixirs -= 1;
            window.engine.sendMessage("You consume elixir and become more solid");
            return true;
        }
        window.engine.sendMessage("You are already fully formed", false);
        return false;
    }
    decrementPigment(c, amount) {
        switch(c){
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).RED:
                this._pigments.red -= amount;
                if (this._pigments.red < 0) this._pigments.red = 0;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).GREEN:
                this._pigments.green -= amount;
                if (this._pigments.green < 0) this._pigments.green = 0;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).BLUE:
                this._pigments.blue -= amount;
                if (this._pigments.blue < 0) this._pigments.blue = 0;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).YELLOW:
                this._pigments.yellow -= amount;
                if (this._pigments.yellow < 0) this._pigments.yellow = 0;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).MAGENTA:
                this._pigments.magenta -= amount;
                if (this._pigments.magenta < 0) this._pigments.magenta = 0;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).CYAN:
                this._pigments.cyan -= amount;
                if (this._pigments.cyan < 0) this._pigments.cyan = 0;
                break;
            default:
                break;
        }
    }
    getPigment(c) {
        let amount = 0;
        switch(c){
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).YELLOW:
                amount = this._pigments.yellow;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).RED:
                amount = this._pigments.red;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).MAGENTA:
                amount = this._pigments.magenta;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).BLUE:
                amount = this._pigments.blue;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).CYAN:
                amount = this._pigments.cyan;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).GREEN:
                amount = this._pigments.green;
                break;
            default:
                break;
        }
        return amount;
    }
    setPigment(c, value) {
        switch(c){
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).YELLOW:
                this._pigments.yellow = value;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).RED:
                this._pigments.red = value;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).MAGENTA:
                this._pigments.magenta = value;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).BLUE:
                this._pigments.blue = value;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).CYAN:
                this._pigments.cyan = value;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).GREEN:
                this._pigments.green = value;
                break;
            default:
                break;
        }
    }
    meetsThreshhold(c) {
        switch(c){
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).YELLOW:
                return this._pigments.yellow >= (0, $1a153cf88c479932$export$4906643e6c3605fc).YELLOW_THRESHHOLD;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).RED:
                return this._pigments.red >= (0, $1a153cf88c479932$export$4906643e6c3605fc).RED_THRESHHOLD;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).MAGENTA:
                return this._pigments.magenta >= (0, $1a153cf88c479932$export$4906643e6c3605fc).MAGENTA_THRESHHOLD;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).BLUE:
                return this._pigments.blue >= (0, $1a153cf88c479932$export$4906643e6c3605fc).BLUE_THRESHHOLD;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).CYAN:
                return this._pigments.cyan >= (0, $1a153cf88c479932$export$4906643e6c3605fc).CYAN_THRESHHOLD;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).GREEN:
                return this._pigments.green >= (0, $1a153cf88c479932$export$4906643e6c3605fc).GREEN_THRESHHOLD;
        }
        return false;
    }
    getColorCountString(c) {
        const colorString = this.getPigment(c).toString().padStart((0, $1a153cf88c479932$export$4906643e6c3605fc).MAX_PIGMENT_CHARS, " ");
        return colorString;
    }
    getBinderCountString() {
        return this._binders.toString().padStart((0, $1a153cf88c479932$export$4906643e6c3605fc).MAX_BINDER_CHARS, " ");
    }
    addItem(item) {
        if (!this.hasItem(item)) {
            this._items.push(item);
            return true;
        }
        return false;
    }
    hasItem(item) {
        return this._items.includes(item);
    }
    addOptic(optic) {
        if (!this._optics.includes(optic)) this._optics.push(optic);
    }
    hasOpticEquipped(optic) {
        return this._optics[this._currentOptic] == optic;
    }
    hasOptic(optic) {
        return this._optics.includes(optic);
    }
    hasVision(optic) {
        if (this._canSeeAll) return true;
        if (optic == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_RED) return this.hasOpticEquipped(optic) || this.hasPassiveVision(optic);
        else if (optic == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_GREEN) return this.hasOpticEquipped(optic) || this.hasPassiveVision(optic);
        else if (optic == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_BLUE) return this.hasOpticEquipped(optic) || this.hasPassiveVision(optic);
        else if (optic == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_YELLOW) return this.hasVision((0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_RED) && this.hasVision((0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_GREEN);
        else if (optic == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_MAGENTA) return this.hasVision((0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_RED) && this.hasVision((0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_BLUE);
        else if (optic == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_CYAN) return this.hasVision((0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_GREEN) && this.hasVision((0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).OPTIC_BLUE);
        return false;
    }
    addPigment(type, amount) {
        if ((0, $f0b5fa422dff3899$export$4881cbfa38820e12)(type)) {
            const color = (0, $d6d4dd36e67b7d9f$export$a6cefe4269ad87ee)(type);
            this.addColor(color, amount);
            return true;
        }
        return false;
    }
    hasPassiveVision(optic) {
        return false;
    // let vision: boolean = false
    // if (
    //   optic == ItemType.OPTIC_YELLOW &&
    //   this._pigments.yellow >= PlayerDefaults.YELLOW_THRESHHOLD
    // ) {
    //   vision = true
    // } else if (
    //   optic == ItemType.OPTIC_MAGENTA &&
    //   this._pigments.magenta >= PlayerDefaults.MAGENTA_THRESHHOLD
    // ) {
    //   vision = true
    // } else if (
    //   optic == ItemType.OPTIC_RED &&
    //   this._pigments.red >= PlayerDefaults.RED_THRESHHOLD
    // ) {
    //   vision = true
    // } else if (
    //   optic == ItemType.OPTIC_BLUE &&
    //   this._pigments.blue >= PlayerDefaults.BLUE_THRESHHOLD
    // ) {
    //   vision = true
    // } else if (
    //   optic == ItemType.OPTIC_CYAN &&
    //   this._pigments.cyan >= PlayerDefaults.CYAN_THRESHHOLD
    // ) {
    //   vision = true
    // } else if (
    //   optic == ItemType.OPTIC_GREEN &&
    //   this._pigments.green >= PlayerDefaults.GREEN_THRESHHOLD
    // ) {
    //   vision = true
    // }
    // return vision
    }
    addColor(color, amount = 1) {
        let toAdd = 0;
        switch(color){
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).RED:
                if (this._pigments.red + amount <= (0, $1a153cf88c479932$export$4906643e6c3605fc).MAX_PIGMENT) toAdd = amount;
                else toAdd = (0, $1a153cf88c479932$export$4906643e6c3605fc).MAX_PIGMENT - this._pigments.red;
                this._pigments.red += toAdd;
                this._pigmentsCollected.red += toAdd;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).GREEN:
                if (this._pigments.green + amount <= (0, $1a153cf88c479932$export$4906643e6c3605fc).MAX_PIGMENT) toAdd = amount;
                else toAdd = (0, $1a153cf88c479932$export$4906643e6c3605fc).MAX_PIGMENT - this._pigments.green;
                this._pigments.green += toAdd;
                this._pigmentsCollected.green += toAdd;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).BLUE:
                if (this._pigments.blue + amount <= (0, $1a153cf88c479932$export$4906643e6c3605fc).MAX_PIGMENT) toAdd = amount;
                else toAdd = (0, $1a153cf88c479932$export$4906643e6c3605fc).MAX_PIGMENT - this._pigments.blue;
                this._pigments.blue += toAdd;
                this._pigmentsCollected.blue += toAdd;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).YELLOW:
                if (this._pigments.yellow + amount <= (0, $1a153cf88c479932$export$4906643e6c3605fc).MAX_PIGMENT) toAdd = amount;
                else toAdd = (0, $1a153cf88c479932$export$4906643e6c3605fc).MAX_PIGMENT - this._pigments.yellow;
                this._pigments.yellow += toAdd;
                this._pigmentsCollected.yellow += toAdd;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).MAGENTA:
                if (this._pigments.magenta + amount <= (0, $1a153cf88c479932$export$4906643e6c3605fc).MAX_PIGMENT) toAdd = amount;
                else toAdd = (0, $1a153cf88c479932$export$4906643e6c3605fc).MAX_PIGMENT - this._pigments.magenta;
                this._pigments.magenta += toAdd;
                this._pigmentsCollected.magenta += toAdd;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).CYAN:
                if (this._pigments.cyan + amount <= (0, $1a153cf88c479932$export$4906643e6c3605fc).MAX_PIGMENT) toAdd = amount;
                else toAdd = (0, $1a153cf88c479932$export$4906643e6c3605fc).MAX_PIGMENT - this._pigments.cyan;
                this._pigments.cyan += toAdd;
                this._pigmentsCollected.cyan += toAdd;
                break;
            default:
                break;
        }
        window.engine.requestPlayerSaveState();
    }
    getPigmentsOfAmount(amount) {
        let pigments = [];
        Object.entries(this._pigments).forEach(([color, quant])=>{
            if (quant >= amount) pigments.push(color);
        });
        return pigments;
    }
    loseColorFromPalette(amount, color) {
        if (amount <= this.getPigment((0, $57907ac0dd7a2328$export$8d85461fad8010ba)(color))) {
            this.decrementPigment((0, $57907ac0dd7a2328$export$8d85461fad8010ba)(color), amount);
            return amount;
        } else {
            const amountLost = this.getPigment((0, $57907ac0dd7a2328$export$8d85461fad8010ba)(color));
            this.setPigment((0, $57907ac0dd7a2328$export$8d85461fad8010ba)(color), 0);
            return amountLost;
        }
    }
    loseColor(amount) {
        let result = [];
        let amountToLose = amount - this.computePigmentDefense();
        if (this._pigmentInvincible || amountToLose <= 0) return result;
        let pigmentsCanLose = this.getPigmentsOfAmount(amountToLose);
        if (pigmentsCanLose.length > 0) {
            const idx = (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(0, pigmentsCanLose.length - 1);
            amountToLose = this.loseColorFromPalette(amountToLose, pigmentsCanLose[idx]);
            result.push({
                amount: amountToLose,
                color: pigmentsCanLose[idx]
            });
        } else {
            // take pigment from different colors until amount is reached, or
            // player runs out of pigments
            pigmentsCanLose = this.getPigmentsOfAmount(1);
            // sort by most to least
            pigmentsCanLose.sort((a, b)=>{
                return this.getPigment((0, $57907ac0dd7a2328$export$8d85461fad8010ba)(a)) - this.getPigment((0, $57907ac0dd7a2328$export$8d85461fad8010ba)(b));
            });
            let remains = amountToLose;
            let justLost = 0;
            pigmentsCanLose.every((p)=>{
                if (remains > 0) {
                    justLost = this.loseColorFromPalette(remains, p);
                    remains -= justLost;
                    result.push({
                        amount: justLost,
                        color: p
                    });
                    return true;
                }
                return false;
            });
        }
        return result;
    }
    resurrect() {
        this.addDeath();
        this.setLevel(this._level);
    }
    renderDark() {
        const symbol = this._render.symbol[0];
        return {
            symbol: symbol,
            color: this._render.dark
        };
    }
    renderLight() {
        const symbol = this._render.symbol[0];
        return {
            symbol: symbol,
            color: this._render.light
        };
    }
    update(action) {
        this._moved = false;
        let stateUpdated = false;
        if (action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).INTERACT) {
            const interactables = window.engine.getNearestInteractables(this.position, this._facing);
            if (interactables.length > 0) window.engine.interact(interactables[0]);
            return;
        }
        if (action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).USE_ELIXIR) {
            this.useElixir();
            stateUpdated = true;
            return;
        }
        if (action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).USE_GIZMO) {
            this.activateGizmo(this._equipment.leftHand.type);
            return;
        }
        if (action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).CYCLE_OPTIC) {
            if (this._optics.length > 0) {
                this._currentOptic += 1;
                if (this._currentOptic >= this._optics.length) this._currentOptic = 0;
            }
            return;
        }
        if ((0, $4df2accce7c7f382$export$c5d7be0b11a66073)(action)) {
            let targetPosition = this.projectMove(action);
            const group = window.engine.getEntitiesAtLocation(targetPosition);
            group.forEach((e)=>{
                if (e) {
                    if (!e.blocks) {
                        if (e instanceof (0, $3ef95fa959568bd4$export$9e1c3038ae586738)) {
                            const aStr = e.amount.toString();
                            const message = "You collected " + aStr + " " + e.displayName;
                            window.engine.sendMessage(message);
                            this.addColor((0, $d6d4dd36e67b7d9f$export$a6cefe4269ad87ee)(e.type), e.amount);
                            window.engine.removeEntityAtLocation(targetPosition);
                            stateUpdated = true;
                        } else if (e instanceof (0, $517927198014b318$export$6d91f4614964de77)) {
                            if (e.optic && this.hasVision(e.optic)) {
                                window.engine.sendMessage("You collected " + e.displayName);
                                if (e.optic) {
                                    this.addColor((0, $d6d4dd36e67b7d9f$export$a6cefe4269ad87ee)(e.optic));
                                    stateUpdated = true;
                                }
                                window.engine.removeEntityAtLocation(targetPosition);
                            } else window.engine.sendMessage("You sense something interesting here");
                        } else if (e instanceof (0, $51ac2b1cc9acd541$export$6d08773d2e66f8f2)) {
                            let canHave = true;
                            let message = "You found ";
                            if (e instanceof (0, $30ba2372b2d807f2$export$ed38ddda6ae2a7ea)) {
                                message += e.displayName;
                                this.addBinder(window.engine.currentMapID);
                                stateUpdated = true;
                            } else if (e instanceof (0, $92da5905bb1565d7$export$be5c6394b8b5ed45)) {
                                message += e.displayName;
                                this.addElixir(1);
                            } else if (e instanceof (0, $debb5793f226d08f$export$cd0f44441c3b7719)) {
                                message += e.displayName;
                                this.addKey(e.target);
                                stateUpdated = true;
                            } else if (e instanceof (0, $9e760da142a553a6$export$8d13340382210b65)) {
                                this.addHint(new (0, $47e4dec76b7e0789$export$c8be6589e5a7471)(e.type, e.contents));
                                stateUpdated = true;
                                window.engine.removeItemAtLocation(targetPosition, e.type);
                                message = "A hint! " + e.contents;
                            } else if (e instanceof (0, $5c81942153c3b66e$export$753ff581ff35bf97)) {
                                message += e.displayName;
                                this.addOptic(e.type);
                                stateUpdated = true;
                            } else if (e instanceof (0, $e3fe6d379840d8da$export$671c4d75d51eb219) && !this.hasEquipment(e.type)) {
                                if (this._level >= e.levelRequired) {
                                    message += e.displayName;
                                    this.addEquipment(e.type);
                                    stateUpdated = true;
                                } else {
                                    canHave = false;
                                    message = "You must be level " + e.levelRequired + " to have " + e.displayName;
                                }
                            } else if ((0, $0a0c617bf4bc5c84$export$73682718bdc832e8)(e.type)) {
                                if ((0, $0a0c617bf4bc5c84$export$fd176820b8063053)(e.type)) {
                                    const coll = (0, $0a0c617bf4bc5c84$export$1617645e1caec7ff)(this);
                                    if (coll !== undefined) {
                                        message += coll.name + " (" + e.displayName + ")";
                                        this.addCollectible(coll, window.engine.currentMapID);
                                        stateUpdated = true;
                                    }
                                } else if ((0, $0a0c617bf4bc5c84$export$23f70935b329f7fd)(e.type)) {
                                    const coll = (0, $0a0c617bf4bc5c84$export$a2b74886b4ba8bb3)(this);
                                    if (coll !== undefined) {
                                        message += coll.name + " (" + e.displayName + ")";
                                        this.addCollectible(coll, window.engine.currentMapID);
                                        stateUpdated = true;
                                    }
                                }
                            }
                            if (canHave) {
                                window.engine.removeItemAtLocation(targetPosition, e.type);
                                window.engine.sendMessage(message);
                            }
                        } else if (e instanceof (0, $d66f070054175cf7$export$4aa8d1180ba213b0)) window.engine.sendMessage("Remains of " + e.displayName);
                    } else {
                        targetPosition = this.position;
                        if (e.baseClass == "Enemy") {
                            if (e instanceof (0, $b57ed82ad2b089c0$export$c73930c4dbc20a69)) {
                                window.engine.sendMessage("A trap drains you of all essence; a wind sweeps you away");
                                this.combat.essence = 0;
                            } else window.engine.processPlayerAttack(e, true);
                        } else window.engine.sendMessage(e.displayName, false);
                    }
                }
            });
            if (stateUpdated) window.engine.requestPlayerSaveState();
            if (this.isAlive()) {
                if (targetPosition.x != this._position.x || targetPosition.y != this._position.y) {
                    this._position = targetPosition;
                    this._moved = true;
                }
            }
        }
    }
    activateGizmo(type) {
        if (this._gizmo !== undefined && (this._gizmo.active || this._gizmo.onCooldown)) return;
        switch(type){
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO_NONE:
                return;
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO1:
                // Escape Rope
                window.engine.sendMessage("You have activated " + (0, $1a153cf88c479932$export$f78a7bc9efcc5615).GIZMO.GIZMO1.name);
                window.engine.enterPortal((0, $f0b5fa422dff3899$export$8800d5c3a30bb568).Portals);
                break;
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO2:
                // Map Scanner
                window.engine.sendMessage("You have activated " + (0, $1a153cf88c479932$export$f78a7bc9efcc5615).GIZMO.GIZMO2.name);
                window.engine.showMapSummaryStats();
                break;
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO3:
                // Polychrome Optic
                if (this._gizmo) {
                    window.engine.sendMessage("You have activated " + (0, $1a153cf88c479932$export$f78a7bc9efcc5615).GIZMO.GIZMO3.name);
                    this._gizmo.activate();
                    this._canSeeAll = true;
                }
                break;
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO4:
                // Ring of Invincibility
                if (this._gizmo) {
                    window.engine.sendMessage("You have activated " + (0, $1a153cf88c479932$export$f78a7bc9efcc5615).GIZMO.GIZMO4.name);
                    this._gizmo.activate();
                    this._essenceInvincible = true;
                }
                break;
            case (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO5:
                // Antitheft Charm
                if (this._gizmo) {
                    window.engine.sendMessage("You have activated " + (0, $1a153cf88c479932$export$f78a7bc9efcc5615).GIZMO.GIZMO5.name);
                    this._gizmo.activate();
                    this._pigmentInvincible = true;
                }
                break;
        }
        window.engine.requestUpdate();
    }
    toggleEssenceInvincibility() {
        if (this._essenceInvincible) this._essenceInvincible = false;
        else if (this._gizmo !== undefined) this._gizmo.stop();
        window.engine.requestUpdate();
    }
    togglePigmentInvincibility() {
        if (this._pigmentInvincible) this._pigmentInvincible = false;
        else if (this._gizmo !== undefined) this._gizmo.stop();
        window.engine.requestUpdate();
    }
    togglePolychromeOptic() {
        if (this._canSeeAll) this._canSeeAll = false;
        else if (this._gizmo !== undefined) this._gizmo.stop();
        window.engine.requestUpdate();
    }
    getGizmoStats() {
        if (this._gizmo === undefined || this._gizmo.type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO_NONE) return "none";
        let stats = "";
        if (this._gizmo.type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO1) stats = (0, $1a153cf88c479932$export$f78a7bc9efcc5615).GIZMO.GIZMO1.name;
        else if (this._gizmo.type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO2) stats = (0, $1a153cf88c479932$export$f78a7bc9efcc5615).GIZMO.GIZMO2.name;
        else if (this._gizmo.type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO3) stats = (0, $1a153cf88c479932$export$f78a7bc9efcc5615).GIZMO.GIZMO3.name;
        else if (this._gizmo.type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO4) stats = (0, $1a153cf88c479932$export$f78a7bc9efcc5615).GIZMO.GIZMO4.name;
        else if (this._gizmo.type == (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).EQUIPMENT_GIZMO5) stats = (0, $1a153cf88c479932$export$f78a7bc9efcc5615).GIZMO.GIZMO5.name;
        if (this._gizmo.active) stats += " (%c{#ff0}%b{#000}active%c{#fff}%b{#000})";
        else if (this._gizmo.onCooldown) stats += " (%c{#f00}%b{#000}cooldown%c{#fff}%b{#000})";
        else stats += " (%c{#0f0}%b{#000}ready%c{#fff}%b{#000})";
        return stats;
    }
    projectMove(action) {
        // let nextPosition = cloneDeep(this.position)
        let nextPosition = {
            ...this.position
        };
        if (action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_LEFT && window.engine.inBounds(nextPosition.x - 1, nextPosition.y)) {
            this._facing = (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).LEFT;
            nextPosition.x -= 1;
        } else if (action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_RIGHT && window.engine.inBounds(nextPosition.x + 1, nextPosition.y)) {
            this._facing = (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).RIGHT;
            nextPosition.x += 1;
        } else if (action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_UP && window.engine.inBounds(nextPosition.x, nextPosition.y - 1)) {
            this._facing = (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).UP;
            nextPosition.y -= 1;
        } else if (action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_DOWN && window.engine.inBounds(nextPosition.x, nextPosition.y + 1)) {
            this._facing = (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).DOWN;
            nextPosition.y += 1;
        }
        return nextPosition;
    }
}
// GIZMO callbacks
function $c7705b01e631e42c$var$toggleEssenceInvincibility(player) {
    player.toggleEssenceInvincibility();
}
function $c7705b01e631e42c$var$togglePigmentInvincibility(player) {
    player.togglePigmentInvincibility();
}
function $c7705b01e631e42c$var$togglePolychromeOptic(player) {
    player.togglePolychromeOptic();
}







class $566c8d9d74c4fb47$export$129a32eedafa97c5 {
    constructor(width, height, offsets, name){
        this.width = width;
        this.height = height;
        this.offsets = offsets;
        this.name = name;
        this._showConfirmDialog = false;
    }
    hideConfirmDialog() {
        this._showConfirmDialog = false;
    }
    showConfirmDialog() {
        this._showConfirmDialog = true;
    }
    showingConfirmDialog() {
        return this._showConfirmDialog;
    }
}


class $9433eb3e6eeed544$export$767c3cfd836ab901 extends (0, $566c8d9d74c4fb47$export$129a32eedafa97c5) {
    constructor(offsets, name){
        super((0, $1a153cf88c479932$export$cc91196ccdb51fef).TROPHY_CASE_WIDTH, (0, $1a153cf88c479932$export$cc91196ccdb51fef).TROPHY_CASE_HEIGHT, offsets, name), this._tiles = [];
        this.initTiles();
    }
    prepareToRender() {
        return;
    }
    postRender() {}
    render(display) {
        for(let y = 0; y < this._tiles.length; ++y){
            const row = this._tiles[y];
            for(let x = 0; x < row.length; ++x){
                const tile = row[x];
                display.draw(x + this.offsets.xOffset, y + this.offsets.yOffset, tile.symbol, (0, $57907ac0dd7a2328$export$b5b1545233b45293)(tile.fg), (0, $57907ac0dd7a2328$export$b5b1545233b45293)(tile.bg));
            }
        }
        const colors = "%c{#fff}%b{#000}";
        const blankColors = "%c{#000}%b{#000}";
        const title = "Archive";
        let printRow = 1;
        let xStart = this.width / 2 - title.length / 2;
        display.drawText(xStart, printRow, colors + title);
        printRow += 1;
        xStart = this.offsets.xOffset + 1;
        display.drawText(xStart, printRow, colors + "-".padEnd(this.width - 2, "-") // 2 accounts for walls
        );
        // 6 is the rows consumed by walls + the header
        // 5 is the number of sections
        const sectionHeight = (this.height - 6) / 5;
        const headingColors = "%c{#0ff}%b{#000}";
        let titleXStart = xStart + 1;
        let statsXStart = titleXStart + 2;
        printRow += 1;
        // Tapestry
        display.drawText(titleXStart, printRow, headingColors + "Completing the tapestry");
        printRow += 1;
        let tapestryOutput = "";
        const tapestryStats = window.engine.getTapestryStats();
        if (tapestryStats !== undefined) {
            const percent = tapestryStats.percentCompleted.toFixed(1);
            tapestryOutput = "You have restored " + percent + "% of the tapestry.";
            display.drawText(statsXStart, printRow, colors + tapestryOutput);
            printRow += 1;
            const tiles = tapestryStats.tilesCompleted;
            const totalTiles = tapestryStats.totalColorTiles;
            tapestryOutput = "You have bound pigment to " + tiles + " of " + totalTiles + " tiles.";
            display.drawText(statsXStart, printRow, colors + tapestryOutput);
        } else printRow += 1;
        printRow += 1;
        // Blank line
        tapestryOutput = ".".repeat(this.width - 2);
        display.drawText(2, printRow, blankColors + tapestryOutput);
        // Pigments/binders
        printRow += 1;
        display.drawText(titleXStart, printRow, headingColors + "Gathering pigments and binders");
        const player = window.engine.getPlayer();
        const pigments = player.getPigmentCollected();
        const binders = player.bindersCollected;
        const bindersAvailable = (0, $0584ddc2e3cbe9e6$export$299ae9f00a8be38d)();
        printRow += 1;
        let lead = "Binders gathered ->  ";
        tapestryOutput = "Jan (" + binders.jan + "/" + bindersAvailable.jan + "), Feb (" + binders.feb + "/" + bindersAvailable.feb + "), Mar (" + binders.mar + "/" + bindersAvailable.mar + "), Apr (" + binders.apr + "/" + bindersAvailable.apr + ")";
        display.drawText(statsXStart, printRow, colors + lead + tapestryOutput);
        printRow += 1;
        tapestryOutput = ".".repeat(statsXStart + lead.length);
        display.drawText(statsXStart, printRow, blankColors + tapestryOutput);
        tapestryOutput = "May (" + binders.may + "/" + bindersAvailable.may + "), Jun (" + binders.jun + "/" + bindersAvailable.jun + "), Jul (" + binders.jul + "/" + bindersAvailable.jul + "), Aug (" + binders.aug + "/" + bindersAvailable.aug + ")";
        display.drawText(statsXStart + lead.length, printRow, colors + tapestryOutput);
        printRow += 1;
        tapestryOutput = "Sep (" + binders.sep + "/" + bindersAvailable.sep + "), Oct (" + binders.oct + "/" + bindersAvailable.oct + "), Nov (" + binders.nov + "/" + bindersAvailable.nov + "), Dec (" + binders.dec + "/" + bindersAvailable.dec + ")";
        display.drawText(statsXStart + lead.length, printRow, colors + tapestryOutput);
        printRow += 2;
        lead = "Pigments gathered -> ";
        tapestryOutput = "Red (" + pigments.red.toString().padStart(3) + "), Gre (" + pigments.green.toString().padStart(3) + "), Blu (" + pigments.blue.toString().padStart(3) + ")";
        display.drawText(statsXStart, printRow, colors + lead + tapestryOutput);
        printRow += 1;
        tapestryOutput = ".".repeat(statsXStart + lead.length);
        display.drawText(statsXStart, printRow, blankColors + tapestryOutput);
        tapestryOutput = "Yel (" + pigments.yellow.toString().padStart(3) + "), Mag (" + pigments.magenta.toString().padStart(3) + "), Cyn (" + pigments.cyan.toString().padStart(3) + ")";
        display.drawText(statsXStart + lead.length, printRow, colors + tapestryOutput);
        // Blank line
        printRow += 1;
        tapestryOutput = ".".repeat(this.width - 2);
        display.drawText(2, printRow, blankColors + tapestryOutput);
        // Map visits + deaths
        printRow += 1;
        display.drawText(titleXStart, printRow, headingColors + "Exploring the map");
        printRow += 1;
        const visits = player.visits;
        lead = "You have explored -> ";
        tapestryOutput = "Jan (" + visits.january.toString().padStart(3) + "), Feb (" + visits.february.toString().padStart(3) + "), Mar (" + visits.march.toString().padStart(3) + "), Apr (" + visits.april.toString().padStart(3) + ")";
        display.drawText(statsXStart, printRow, colors + lead + tapestryOutput);
        printRow += 1;
        tapestryOutput = "May (" + visits.may.toString().padStart(3) + "), Jun (" + visits.june.toString().padStart(3) + "), Jul (" + visits.july.toString().padStart(3) + "), Aug (" + visits.august.toString().padStart(3) + ")";
        display.drawText(statsXStart + lead.length, printRow, colors + tapestryOutput);
        printRow += 1;
        tapestryOutput = "Sep (" + visits.september.toString().padStart(3) + "), Oct (" + visits.october.toString().padStart(3) + "), Nov (" + visits.november.toString().padStart(3) + "), Dec (" + visits.december.toString().padStart(3) + ")";
        display.drawText(statsXStart + lead.length, printRow, colors + tapestryOutput);
        // Equipment
        printRow += 2;
        display.drawText(titleXStart, printRow, headingColors + "Finding equipment");
        const wearables = player.getWearablesCount();
        printRow += 1;
        tapestryOutput = "You have found " + wearables + " wearable item";
        if (wearables != 1) tapestryOutput += "s";
        tapestryOutput += ".";
        display.drawText(statsXStart, printRow, colors + tapestryOutput);
        const weapons = player.getWeaponsCount();
        const gizmos = player.getGizmosCount();
        printRow += 1;
        tapestryOutput = "You have found " + weapons + " weapon";
        if (weapons != 1) tapestryOutput += "s";
        tapestryOutput += " and " + gizmos + " gizmo";
        if (gizmos != 1) tapestryOutput += "s";
        tapestryOutput += ".";
        display.drawText(statsXStart, printRow, colors + tapestryOutput);
        // Blank line
        printRow += 1;
        tapestryOutput = ".".repeat(this.width - 2);
        display.drawText(2, printRow, blankColors + tapestryOutput);
        // Hints
        printRow += 1;
        display.drawText(titleXStart, printRow, headingColors + "Discovering hints");
        const infoHints = player.getHints((0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).HINT_INFO);
        const warningHints = player.getHints((0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).HINT_WARNING);
        const hints = infoHints.length + warningHints.length;
        printRow += 1;
        tapestryOutput = "You have discovered " + hints + " hint";
        if (hints != 1) tapestryOutput += "s";
        tapestryOutput += ".";
        display.drawText(statsXStart, printRow, colors + tapestryOutput);
        // Deaths
        printRow += 2;
        display.drawText(titleXStart, printRow, headingColors + "Facing challenges");
        const deaths = player.deaths;
        printRow += 1;
        tapestryOutput = "You have been drained of your essence " + deaths + " time";
        if (deaths != 1) tapestryOutput += "s";
        tapestryOutput += ".";
        display.drawText(statsXStart, printRow, colors + tapestryOutput);
    }
    update(action) {
        if (action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_DOWN) ;
        else (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_UP;
    }
    initTiles() {
        this._tiles = new Array(this.height);
        for(let y = 0; y < this.height; y++){
            const row = new Array(this.width);
            for(let x = 0; x < this.width; x++){
                const isWall = x === 0 || x === this.width - 1 || y === 0 || y === this.height - 1;
                row[x] = isWall ? {
                    ...(0, $25f08219a36211c0$export$c3247160a5feeab2)
                } : {
                    ...(0, $25f08219a36211c0$export$c203f9d0903db330)
                };
            }
            this._tiles[y] = row;
        }
    }
}







function $d7c3a40a3660cac0$export$fe7d22cffc9134c7(type) {
    const config = (0, $2de2e4dc08289f56$export$4bf5c6c4018de228)(type);
    if (config === undefined) return undefined;
    let beast = {
        type: type,
        name: config.name,
        symbol: config.render.symbol[0],
        color: config.render.light,
        description: "",
        seen: false,
        killCount: 0
    };
    switch(type){
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_ESSENCE:
            beast.description = (0, $1a153cf88c479932$export$a568d24c6bb32da8).RIFT_ESSENCE;
            break;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_PIGMENT:
            beast.description = (0, $1a153cf88c479932$export$a568d24c6bb32da8).RIFT_PIGMENT;
            break;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).RIFT_BOTH:
            beast.description = (0, $1a153cf88c479932$export$a568d24c6bb32da8).RIFT_BOTH;
            break;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_ESSENCE:
            beast.description = (0, $1a153cf88c479932$export$a568d24c6bb32da8).VOID_ESSENCE;
            break;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_PIGMENT:
            beast.description = (0, $1a153cf88c479932$export$a568d24c6bb32da8).VOID_PIGMENT;
            break;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).VOID_BOTH:
            beast.description = (0, $1a153cf88c479932$export$a568d24c6bb32da8).VOID_BOTH;
            break;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_ESSENCE:
            beast.description = (0, $1a153cf88c479932$export$a568d24c6bb32da8).BLADE_ESSENCE;
            break;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_PIGMENT:
            beast.description = (0, $1a153cf88c479932$export$a568d24c6bb32da8).BLADE_PIGMENT;
            break;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).BLADE_BOTH:
            beast.description = (0, $1a153cf88c479932$export$a568d24c6bb32da8).BLADE_BOTH;
            break;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).SPECTRE_ESSENCE:
            beast.description = (0, $1a153cf88c479932$export$a568d24c6bb32da8).SPECTRE_ESSENCE;
            break;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).SPECTRE_PIGMENT:
            beast.description = (0, $1a153cf88c479932$export$a568d24c6bb32da8).SPECTRE_PIGMENT;
            break;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).SPECTRE_BOTH:
            beast.description = (0, $1a153cf88c479932$export$a568d24c6bb32da8).SPECTRE_BOTH;
            break;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).REAVER_ESSENCE:
            beast.description = (0, $1a153cf88c479932$export$a568d24c6bb32da8).REAVER_ESSENCE;
            break;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).REAVER_PIGMENT:
            beast.description = (0, $1a153cf88c479932$export$a568d24c6bb32da8).REAVER_PIGMENT;
            break;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).REAVER_BOTH:
            beast.description = (0, $1a153cf88c479932$export$a568d24c6bb32da8).REAVER_BOTH;
            break;
        case (0, $f0b5fa422dff3899$export$1a91c501cca01afe).DEVOURER:
            beast.description = (0, $1a153cf88c479932$export$a568d24c6bb32da8).DEVOURER;
            break;
    }
    return beast;
}




class $0f24a2512fffcf54$export$2cb1d7a364db3021 extends (0, $566c8d9d74c4fb47$export$129a32eedafa97c5) {
    constructor(offsets, name){
        super((0, $1a153cf88c479932$export$cc91196ccdb51fef).TROPHY_CASE_WIDTH, (0, $1a153cf88c479932$export$cc91196ccdb51fef).TROPHY_CASE_HEIGHT, offsets, name), this._tiles = [], this._beasts = [];
        this.initTiles();
    }
    addBeast(type) {
        const config = (0, $d7c3a40a3660cac0$export$fe7d22cffc9134c7)(type);
        if (config === undefined) return false;
        const beast = {
            ...config
        };
        if (beast === undefined) return false;
        for(let i = 0; i < this._beasts.length; ++i){
            if (beast.name == this._beasts[i].name) return false;
        }
        this._beasts.push(beast);
        this._beasts.sort((b1, b2)=>{
            if (b1.name.toUpperCase() < b2.name.toUpperCase()) return -1;
            else if (b1.name.toUpperCase() == b2.name.toUpperCase()) return 0;
            return 1;
        });
        return true;
    }
    seeBeast(type) {
        for(let i = 0; i < this._beasts.length; ++i)if (this._beasts[i].type == type) {
            this._beasts[i].seen = true;
            return;
        }
    }
    killBeast(type) {
        for(let i = 0; i < this._beasts.length; ++i)if (this._beasts[i].type == type) {
            this._beasts[i].seen = true;
            this._beasts[i].killCount += 1;
            return;
        }
    }
    prepareToRender() {
        return;
    }
    postRender() {}
    render(display) {
        for(let y = 0; y < this._tiles.length; ++y){
            const row = this._tiles[y];
            for(let x = 0; x < row.length; ++x){
                const tile = row[x];
                display.draw(x + this.offsets.xOffset, y + this.offsets.yOffset, tile.symbol, (0, $57907ac0dd7a2328$export$b5b1545233b45293)(tile.fg), (0, $57907ac0dd7a2328$export$b5b1545233b45293)(tile.bg));
            }
        }
        let colors = "%c{#fff}%b{#000}";
        const title = "Bestiary";
        let printRow = 1;
        let xStart = this.width / 2 - title.length / 2;
        display.drawText(xStart, printRow, colors + title);
        let output = `A record of the ethereal creatures you have encountered.`;
        printRow += 2;
        xStart = this.width / 2 - output.length / 2;
        display.drawText(xStart, printRow, colors + output);
        printRow += 1;
        xStart = this.offsets.xOffset + 1;
        display.drawText(xStart, printRow, colors + "-".padEnd(this.width - 2, "-") // 2 accounts for walls
        );
        let beastsKilled = 0;
        this._beasts.forEach((b)=>{
            beastsKilled += b.killCount;
        });
        const tag = " vanquished]";
        const outputLength = beastsKilled + tag.length + 1 // leading [
        ;
        const counterColors = "%c{#0ff}%b{#000}";
        output = `%c{#fff}%b{#000}[` + `${counterColors}${beastsKilled}` + `%c{#fff}%b{#000}${tag}`;
        printRow += 1;
        xStart = this.width / 2 - outputLength / 2;
        display.drawText(xStart, printRow, output);
        // NOTE: the values 3, 15, 35 below are manually counted against
        //       longest possible strings for these fields
        printRow += 3;
        for(let i = 0; i < this._beasts.length; ++i){
            const beast = this._beasts[i];
            if (beast.seen) {
                let output = `%c{${beast.color}}%b{#000}${beast.symbol.padEnd(3, " ")} `;
                output += `%c{#fff}%b{#000}${beast.name.padEnd(15)}`;
                if (beast.killCount > 0) {
                    output += " -> " + beast.description.padEnd(35, " ");
                    output += " [x %c{#0ff}%b{#000}" + beast.killCount + "%c{#fff}%b{#000}]";
                } else output += " -> %c{#ff0}%b{#000}seen";
                display.drawText(3, printRow, output);
            } else display.drawText(3, printRow, `%c{#fff}%b{#000}?`);
            printRow += 1;
        }
        // key
        printRow = this.height - 3;
        xStart = 2;
        display.drawText(xStart, printRow, "KEY");
        printRow += 1;
        display.drawText(xStart, printRow, "  ? new enemy type on map, unseen");
    }
    update(action) {
        return;
    }
    initTiles() {
        this._tiles = new Array(this.height);
        for(let y = 0; y < this.height; y++){
            const isOddRow = y % 2 != 0 ? true : false;
            const row = new Array(this.width);
            for(let x = 0; x < this.width; x++){
                const isWall = x === 0 || x === this.width - 1 || y === 0 || y === this.height - 1;
                row[x] = isWall ? {
                    ...(0, $25f08219a36211c0$export$c3247160a5feeab2)
                } : {
                    ...(0, $25f08219a36211c0$export$c203f9d0903db330)
                };
            }
            this._tiles[y] = row;
        }
    }
}








class $73c2eb62c7c5aba6$export$f1c1812ed2ac1602 extends (0, $566c8d9d74c4fb47$export$129a32eedafa97c5) {
    constructor(offsets, name){
        super((0, $1a153cf88c479932$export$cc91196ccdb51fef).TROPHY_CASE_WIDTH, (0, $1a153cf88c479932$export$cc91196ccdb51fef).TROPHY_CASE_HEIGHT, offsets, name), this._tiles = [];
        this.initTiles();
    }
    prepareToRender() {
        return;
    }
    postRender() {}
    render(display) {
        for(let y = 0; y < this._tiles.length; ++y){
            const row = this._tiles[y];
            for(let x = 0; x < row.length; ++x){
                const tile = row[x];
                display.draw(x + this.offsets.xOffset, y + this.offsets.yOffset, tile.symbol, (0, $57907ac0dd7a2328$export$b5b1545233b45293)(tile.fg), (0, $57907ac0dd7a2328$export$b5b1545233b45293)(tile.bg));
            }
        }
        const colors = "%c{#fff}%b{#000}";
        const title = "Equipment Loadout";
        let printRow = 1;
        let xStart = this.width / 2 - title.length / 2;
        display.drawText(xStart, printRow, colors + title);
        let output = `Your current loadout.`;
        printRow += 2;
        xStart = this.width / 2 - output.length / 2;
        display.drawText(xStart, printRow, colors + output);
        printRow += 1;
        xStart = this.offsets.xOffset + 1;
        display.drawText(xStart, printRow, colors + "-".padEnd(this.width - 2, "-") // 2 accounts for walls
        );
        xStart += 1;
        const none = "none";
        const player = window.engine.getPlayer();
        let head = none;
        const headItem = player.getEquipment((0, $f0b5fa422dff3899$export$45e36ab1b645cb80).HEAD);
        if (headItem !== undefined) head = headItem.name;
        let torso = none;
        const torsoItem = player.getEquipment((0, $f0b5fa422dff3899$export$45e36ab1b645cb80).TORSO);
        if (torsoItem !== undefined) torso = torsoItem.name;
        let feet = none;
        const feetItem = player.getEquipment((0, $f0b5fa422dff3899$export$45e36ab1b645cb80).FEET);
        if (feetItem !== undefined) feet = feetItem.name;
        let lHand = none;
        const lHandItem = player.getEquipment((0, $f0b5fa422dff3899$export$45e36ab1b645cb80).LEFT_HAND);
        if (lHandItem !== undefined) {
            lHand = lHandItem.name;
            if (lHandItem.twoHanded) lHand += " (two-handed)";
        }
        let rHand = none;
        const rHandItem = player.getEquipment((0, $f0b5fa422dff3899$export$45e36ab1b645cb80).RIGHT_HAND);
        if (rHandItem !== undefined) rHand = rHandItem.name;
        printRow += 2;
        const longestLabel = 12;
        const padColors = `%c{#000}%b{#000}`;
        let label = "Head:";
        let pad = ".".padEnd(longestLabel - label.length, ".");
        display.drawText(xStart, printRow, padColors + pad + `%c{#fff}%b{#000}${label} ${head}`);
        printRow += 2;
        label = "Torso:";
        pad = ".".padEnd(longestLabel - label.length, ".");
        display.drawText(xStart, printRow, padColors + pad + `%c{#fff}%b{#000}${label} ${torso}`);
        printRow += 2;
        label = "Feet:";
        pad = ".".padEnd(longestLabel - label.length, ".");
        display.drawText(xStart, printRow, padColors + pad + `%c{#fff}%b{#000}${label} ${feet}`);
        printRow += 2;
        label = "Left hand:";
        pad = ".".padEnd(longestLabel - label.length, ".");
        display.drawText(xStart, printRow, padColors + pad + `%c{#fff}%b{#000}${label} ${lHand}`);
        printRow += 2;
        label = "Right hand:";
        pad = ".".padEnd(longestLabel - label.length, ".");
        display.drawText(xStart, printRow, padColors + pad + `%c{#fff}%b{#000}${label} ${rHand}`);
        printRow += 2;
        label = "Optic:";
        pad = ".".padEnd(longestLabel - label.length, ".");
        display.drawText(xStart, printRow, padColors + pad + `%c{#fff}%b{#000}${label} ` + (0, $1eb61eaeba4c6dbc$export$9ee3990868f8c2a3)(player));
    }
    update(action) {}
    initTiles() {
        this._tiles = new Array(this.height);
        for(let y = 0; y < this.height; y++){
            const row = new Array(this.width);
            for(let x = 0; x < this.width; x++){
                const isWall = x === 0 || x === this.width - 1 || y === 0 || y === this.height - 1;
                row[x] = isWall ? {
                    ...(0, $25f08219a36211c0$export$c3247160a5feeab2)
                } : {
                    ...(0, $25f08219a36211c0$export$c203f9d0903db330)
                };
            }
            this._tiles[y] = row;
        }
    }
}












class $865fdc4517d1c112$export$38c733d2195e496 extends (0, $566c8d9d74c4fb47$export$129a32eedafa97c5) {
    static{
        this.PADDING = 2;
    }
    static{
        this.TIMER_INCREMENT = 500;
    }
    constructor(offsets, name){
        super((0, $1a153cf88c479932$export$cc91196ccdb51fef).TROPHY_CASE_WIDTH, (0, $1a153cf88c479932$export$cc91196ccdb51fef).TROPHY_CASE_HEIGHT, offsets, name), this.VERSION = 1.0, this._percentCompleted = 0, this._tilesCompleted = 0, this._totalColorTiles = 0, this._tapestryComplete = false, this.colorCounts = {
            red: {
                have: 0,
                need: 0
            },
            green: {
                have: 0,
                need: 0
            },
            blue: {
                have: 0,
                need: 0
            },
            magenta: {
                have: 0,
                need: 0
            },
            yellow: {
                have: 0,
                need: 0
            },
            cyan: {
                have: 0,
                need: 0
            }
        }, this._tiles = [], this._statics = [], this._blinks = [], this._nextBlinkGroup = 0, this._nextBlinkColor = 0, this._blinkTimer = undefined, this._selectedPigment = 0, this._bindablePigments = [], this._availableOptions = 0;
        this.initTiles();
        this.initTapestryArt();
        this.initStatics();
        this._totalColorTiles = this.computeTotalColorTiles();
    }
    get complete() {
        return this._tapestryComplete;
    }
    get percentCompleted() {
        return this._percentCompleted;
    }
    get tilesCompleted() {
        return this._tilesCompleted;
    }
    get totalColorTiles() {
        return this._totalColorTiles;
    }
    set display(display) {
        this._display = display;
    }
    getStats() {
        return {
            percentCompleted: this._percentCompleted,
            tilesCompleted: this._tilesCompleted,
            totalColorTiles: this._totalColorTiles
        };
    }
    computeTotalColorTiles() {
        return this.colorCounts.red.have + this.colorCounts.blue.have + this.colorCounts.green.have + this.colorCounts.magenta.have + this.colorCounts.yellow.have + this.colorCounts.cyan.have;
    }
    initTiles() {
        this._tiles = new Array(this.height);
        for(let y = 0; y < this.height; y++){
            const row = new Array(this.width);
            for(let x = 0; x < this.width; x++){
                const isWall = x === 0 || x === this.width - 1 || y === 0 || y === this.height - 1;
                row[x] = isWall ? {
                    ...(0, $25f08219a36211c0$export$c3247160a5feeab2)
                } : {
                    ...(0, $25f08219a36211c0$export$c203f9d0903db330)
                };
            }
            this._tiles[y] = row;
        }
    }
    initPigment(id, pigment) {
        let newColor = pigment;
        newColor.a = 0.0;
        return newColor;
    }
    initTapestryArt() {
        for(let y = 0; y < (0, $d2641ced5019691c$export$3bac4e187a4a8ffd).length; ++y){
            let col = 0;
            for(let x = 0; x < (0, $d2641ced5019691c$export$3bac4e187a4a8ffd)[y].length; ++x){
                if ((0, $d2641ced5019691c$export$3bac4e187a4a8ffd)[y][x] != " ") {
                    const tile = this.getTapestryTile((0, $d2641ced5019691c$export$3bac4e187a4a8ffd)[y].substring(x, x + 2));
                    this._tiles[y][col] = tile;
                    x += 1;
                }
                col += 1;
            }
        }
    }
    initStatics() {
        this._tiles.forEach((row, y)=>{
            row.forEach((_, x)=>{
                this._statics.push({
                    x: x,
                    y: y
                });
            });
        });
    }
    bindPigmentToTiles(color) {
        const rgbColor = (0, $57907ac0dd7a2328$export$b4153c7f22f466f5)(color);
        if (rgbColor !== undefined) {
            const tiles = this.findRandomTilesOfRGB(rgbColor, (0, $1a153cf88c479932$export$29ad37babd04e544).TILES_PER_BIND);
            if (tiles !== undefined) for(let i = 0; i < tiles.length; ++i){
                const pos = tiles[i];
                const updateTile = this._tiles[pos.y][pos.x];
                if (updateTile !== undefined && updateTile.fg.a !== undefined) {
                    updateTile.fg.a = 1.0;
                    const color = (0, $57907ac0dd7a2328$export$331178d20d0fceea)(updateTile.fg.r, updateTile.fg.g, updateTile.fg.b);
                    if (color !== undefined) this.decrementNeed(color);
                }
            }
            this.computeCompletion();
            this.prepareToRender();
        }
    }
    decrementNeed(color) {
        switch(color){
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).RED:
                this.colorCounts.red.need -= 1;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).GREEN:
                this.colorCounts.green.need -= 1;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).BLUE:
                this.colorCounts.blue.need -= 1;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).YELLOW:
                this.colorCounts.yellow.need -= 1;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).MAGENTA:
                this.colorCounts.magenta.need -= 1;
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).CYAN:
                this.colorCounts.cyan.need -= 1;
                break;
        }
    }
    findRandomTilesOfRGB(color, count) {
        let matchingTiles = [];
        this._tiles.forEach((row, y)=>{
            row.forEach((tile, x)=>{
                const c = tile.fg;
                if (c.r == color.r && c.g == color.g && c.b == color.b) {
                    if (c.a !== undefined && c.a < 1.0) matchingTiles.push({
                        x: x,
                        y: y
                    });
                }
            });
        });
        if (matchingTiles.length > 0) {
            (0, $0584ddc2e3cbe9e6$export$448332262467e042)(matchingTiles);
            return matchingTiles.slice(0, count);
        }
        return undefined;
    }
    fillTapestry() {
        for(let i = 0; i < this._tiles.length; ++i)for(let j = 0; j < this._tiles[i].length; ++j){
            const updateTile = this._tiles[i][j];
            if (updateTile !== undefined && updateTile.fg.a !== undefined) updateTile.fg.a = 1.0;
        }
        this.computeCompletion();
        this.prepareToRender();
    }
    clearTapestry() {
        for(let i = 0; i < this._tiles.length; ++i)for(let j = 0; j < this._tiles[i].length; ++j){
            const updateTile = this._tiles[i][j];
            if (updateTile && updateTile.fg.a) updateTile.fg.a = 0.0;
        }
        this._blinks = [];
        if (this._blinkTimer !== undefined) {
            this._blinkTimer.stop();
            this._blinkTimer = undefined;
        }
        this.initStatics();
    }
    getTapestryTile(code) {
        const newSymbol = code[1];
        let fg = (0, $248954e6cbd64b56$export$b278fa1959b09b13).TAPESTRY_NOTHING;
        switch(code[0]){
            case "y":
                this.colorCounts.yellow.have += 1;
                this.colorCounts.yellow.need += 1;
                fg = this.initPigment((0, $f0b5fa422dff3899$export$b1b64d948644442b).YELLOW, (0, $248954e6cbd64b56$export$b278fa1959b09b13).YELLOW);
                break;
            case "r":
                this.colorCounts.red.have += 1;
                this.colorCounts.red.need += 1;
                fg = this.initPigment((0, $f0b5fa422dff3899$export$b1b64d948644442b).RED, (0, $248954e6cbd64b56$export$b278fa1959b09b13).RED);
                break;
            case "m":
                this.colorCounts.magenta.have += 1;
                this.colorCounts.magenta.need += 1;
                fg = this.initPigment((0, $f0b5fa422dff3899$export$b1b64d948644442b).MAGENTA, (0, $248954e6cbd64b56$export$b278fa1959b09b13).MAGENTA);
                break;
            case "b":
                this.colorCounts.blue.have += 1;
                this.colorCounts.blue.need += 1;
                fg = this.initPigment((0, $f0b5fa422dff3899$export$b1b64d948644442b).BLUE, (0, $248954e6cbd64b56$export$b278fa1959b09b13).BLUE);
                break;
            case "c":
                this.colorCounts.cyan.have += 1;
                this.colorCounts.cyan.need += 1;
                fg = this.initPigment((0, $f0b5fa422dff3899$export$b1b64d948644442b).CYAN, (0, $248954e6cbd64b56$export$b278fa1959b09b13).CYAN);
                break;
            case "g":
                this.colorCounts.green.have += 1;
                this.colorCounts.green.need += 1;
                fg = this.initPigment((0, $f0b5fa422dff3899$export$b1b64d948644442b).GREEN, (0, $248954e6cbd64b56$export$b278fa1959b09b13).GREEN);
                break;
            default:
                break;
        }
        return {
            symbol: newSymbol,
            fg: {
                ...fg
            },
            bg: (0, $248954e6cbd64b56$export$b278fa1959b09b13).BLACK
        };
    }
    blink() {
        if (this._display) {
            const color = (0, $1a153cf88c479932$export$29ad37babd04e544).BLINK_COLORS[this._nextBlinkColor];
            const group = this._blinks[this._nextBlinkGroup];
            group.forEach((b, idx)=>{
                const tile = this._tiles[b.y][b.x];
                if (this._display !== undefined) this._display.draw(b.x + this.offsets.xOffset, b.y + this.offsets.yOffset, tile.symbol, (0, $57907ac0dd7a2328$export$b5b1545233b45293)(color), (0, $57907ac0dd7a2328$export$b5b1545233b45293)(tile.bg));
            });
            this._nextBlinkGroup += 1;
            if (this._nextBlinkGroup >= this._blinks.length) this._nextBlinkGroup = 0;
            this._nextBlinkColor += 1;
            if (this._nextBlinkColor >= (0, $1a153cf88c479932$export$29ad37babd04e544).BLINK_COLORS.length) this._nextBlinkColor = 0;
        }
    }
    startBlinkTimer() {
        if (this._blinkTimer !== undefined) this._blinkTimer.start(true, ()=>{
            this.blink();
        });
    }
    prepareToRender() {
        if (this._tapestryComplete) {
            window.engine.changeMusic((0, $1a153cf88c479932$export$29ad37babd04e544).MUSIC, false, true);
            if (this._blinks.length == 0) {
                this._statics = [];
                this._blinks = new Array((0, $1a153cf88c479932$export$29ad37babd04e544).BLINK_GROUPS);
                for(let i = 0; i < this._blinks.length; ++i)this._blinks[i] = [];
                if (this._blinkTimer === undefined) this._blinkTimer = new (0, $b36b515e341ce35e$export$c57e9b2d8b9e4de)($865fdc4517d1c112$export$38c733d2195e496.TIMER_INCREMENT);
                this._tiles.forEach((row, y)=>{
                    row.forEach((t, x)=>{
                        if (t.symbol == (0, $1a153cf88c479932$export$29ad37babd04e544).BLINK_SYMBOL) {
                            const idx = (0, $0eb0e6f5b56b7df1$export$8ad8ee91ff91d9b5)(0, this._blinks.length - 1);
                            this._blinks[idx].push({
                                x: x,
                                y: y,
                                on: true
                            });
                        } else this._statics.push({
                            x: x,
                            y: y
                        });
                    });
                });
            }
            this.startBlinkTimer();
            return;
        }
        this.prepareSelectablePigments();
    }
    postRender() {
        if (this._blinkTimer !== undefined) this._blinkTimer.stop();
    }
    computeTilesCompleted() {
        let tilesCompleted = 0;
        this._tiles.forEach((row)=>{
            row.forEach((t)=>{
                if (t.symbol != " " && t.fg.a !== undefined && t.fg.a >= 1.0) tilesCompleted += 1;
            });
        });
        return tilesCompleted;
    }
    computeCompletion() {
        if (this._tapestryComplete) return;
        this._tilesCompleted = this.computeTilesCompleted();
        this._percentCompleted = this._tilesCompleted / this.totalColorTiles * 100;
        if (this._percentCompleted >= 100.0) this._tapestryComplete = true;
    }
    prepareSelectablePigments() {
        const player = window.engine.getPlayer();
        this._bindablePigments = player.getBindablePigments();
        this._availableOptions = 0;
        this._bindablePigments.forEach((p)=>{
            if (p.bindable && this.needsPigment(p.color)) this._availableOptions += 1;
        });
    }
    needsPigment(color) {
        switch(color){
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).RED:
                return this.colorCounts.red.need > 0;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).GREEN:
                return this.colorCounts.green.need > 0;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).BLUE:
                return this.colorCounts.blue.need > 0;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).YELLOW:
                return this.colorCounts.yellow.need > 0;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).MAGENTA:
                return this.colorCounts.magenta.need > 0;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).CYAN:
                return this.colorCounts.cyan.need > 0;
        }
        return false;
    }
    canSelectPigment() {
        return this._availableOptions > 0;
    }
    render(display) {
        // this.debugColorCounts()
        window.engine.sendMessage("Viewing " + this.name, false);
        this._statics.forEach((pos)=>{
            const tile = this._tiles[pos.y][pos.x];
            display.draw(pos.x + this.offsets.xOffset, pos.y + this.offsets.yOffset, tile.symbol, (0, $57907ac0dd7a2328$export$b5b1545233b45293)(tile.fg), (0, $57907ac0dd7a2328$export$b5b1545233b45293)(tile.bg));
        });
        const percentage = this._percentCompleted.toFixed(1) + "%";
        const colors = "%c{#fff}%b{#000}";
        display.drawText(this.width - percentage.length - 1, this.height - 2, colors + percentage);
        if (this._showConfirmDialog) {
            if (this._availableOptions == 0) {
                const message = "Unable to bind pigments at present. N|n or ESC to cancel";
                const blank = ".".padStart(message.length, ".");
                display.drawText(10, 12, `%c{#000}%b{#000}${blank}`);
                display.drawText(10, 13, `%c{#fff}%b{#000}${message}`);
                display.drawText(10, 14, `%c{#000}%b{#000}${blank}`);
            } else {
                let optionString = "";
                let optionStringActualLength = 0;
                this._bindablePigments.forEach((pigment, idx)=>{
                    let colorString = (0, $57907ac0dd7a2328$export$1071895c7014e035)(pigment.color);
                    optionStringActualLength += colorString.length + 2;
                    optionString += `%c{#000}%b{#000}.`;
                    if (pigment.bindable) {
                        optionString += `%c{${(0, $57907ac0dd7a2328$export$400d6f4772940894)(pigment.color)}}`;
                        if (idx == this._selectedPigment) optionString += `%b{#b4b4b4}`;
                        else optionString += `%b{#000}`;
                        optionString += colorString;
                    } else optionString += `%c{${(0, $248954e6cbd64b56$export$892596cec99bc70e).DARK_GRAY}}%b{#000}${colorString}`;
                    optionString += `%c{#000}%b{#000}.`;
                });
                const blank = ".".padStart(optionStringActualLength, ".");
                display.drawText(18, 11, `%c{#000}%b{#000}${blank}`);
                display.drawText(18, 12, optionString);
                display.drawText(18 + optionStringActualLength - 1, 12, `%c{#000}%b{#000}.`);
                display.drawText(18, 13, `%c{#000}%b{#000}${blank}`);
                display.drawText(18, 14, `%c{#000}%b{#000}.`);
                let confirmStr = "Y|y to bind selected pigment";
                display.drawText(19, 14, `%c{#fff}%b{#000}${confirmStr}`);
                let padding = ".".padEnd(optionStringActualLength - confirmStr.length - 1, ".");
                display.drawText(19 + confirmStr.length, 14, `%c{#000}%b{#000}${padding}`);
                display.drawText(18, 15, `%c{#000}%b{#000}${blank}`);
                display.drawText(18, 16, `%c{#000}%b{#000}.`);
                confirmStr = "N|n or ESC to cancel";
                display.drawText(19, 16, `%c{#fff}%b{#000}${confirmStr}`);
                padding = ".".padEnd(optionStringActualLength - confirmStr.length - 1, ".");
                display.drawText(19 + confirmStr.length, 16, `%c{#000}%b{#000}${padding}`);
                display.drawText(18, 17, `%c{#000}%b{#000}${blank}`);
            }
        }
    }
    update(action) {
        return;
    }
    changePigmentSelection(direction) {
        if (direction == (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).LEFT) do {
            this._selectedPigment -= 1;
            if (this._selectedPigment < 0) this._selectedPigment = this._bindablePigments.length - 1;
        }while (!this._bindablePigments[this._selectedPigment].bindable);
        else if (direction == (0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).RIGHT) do {
            this._selectedPigment += 1;
            if (this._selectedPigment >= this._bindablePigments.length) this._selectedPigment = 0;
        }while (!this._bindablePigments[this._selectedPigment].bindable);
    }
    getSelectedPigment() {
        return this._bindablePigments[this._selectedPigment].color;
    }
}








class $e4cb996cf1b3c32d$export$fe3cf7bac7de6d6d extends (0, $566c8d9d74c4fb47$export$129a32eedafa97c5) {
    constructor(offsets, name, fgItem, collectibleType){
        super((0, $1a153cf88c479932$export$cc91196ccdb51fef).TROPHY_CASE_WIDTH, (0, $1a153cf88c479932$export$cc91196ccdb51fef).TROPHY_CASE_HEIGHT, offsets, name), this._tiles = [];
        this._fgItem = fgItem;
        this._collectibleType = collectibleType;
        this._collectibles = new Array((0, $1a153cf88c479932$export$2ef8aa71201ee06b).COLLECTIBLES_ROWS);
        for(let i = 0; i < this._collectibles.length; ++i)this._collectibles[i] = new Array((0, $1a153cf88c479932$export$2ef8aa71201ee06b).COLLECTIBLES_COLUMNS);
        this.initTiles();
        this.initCubbies();
        this._selectedRow = 0;
        this._selectedColumn = 0;
        this.highlightSelection();
    }
    resetGrid() {
        this._collectibles = new Array((0, $1a153cf88c479932$export$2ef8aa71201ee06b).COLLECTIBLES_ROWS);
        for(let i = 0; i < this._collectibles.length; ++i)this._collectibles[i] = new Array((0, $1a153cf88c479932$export$2ef8aa71201ee06b).COLLECTIBLES_COLUMNS);
    }
    prepareToRender() {
        this.resetGrid();
        const player = window.engine.getPlayer();
        if (player !== undefined) {
            let collectibles = player.getCollectibles(this._collectibleType);
            let row = 0;
            let column = 0;
            collectibles.forEach((c)=>{
                const ascii = (0, $0a0c617bf4bc5c84$export$11c1b9f01df47363)(this._collectibleType, c.name);
                this._collectibles[row][column] = c;
                this.placeCollectible(column, row, ascii);
                column += 1;
                if (column == (0, $1a153cf88c479932$export$2ef8aa71201ee06b).COLLECTIBLES_COLUMNS) {
                    row += 1;
                    column = 0;
                }
            });
        }
    }
    postRender() {}
    render(display) {
        this.sendItemViewMessage();
        for(let y = 0; y < this._tiles.length; ++y){
            const row = this._tiles[y];
            for(let x = 0; x < row.length; ++x){
                const tile = row[x];
                display.draw(x + this.offsets.xOffset, y + this.offsets.yOffset, tile.light.symbol, tile.light.fg, tile.light.bg);
            }
        }
        window.engine.requestUpdate();
    }
    update(action) {
        let dX = this._selectedColumn;
        let dY = this._selectedRow;
        if (action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_UP && dY > 0) dY -= 1;
        else if (action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_DOWN && dY < (0, $1a153cf88c479932$export$2ef8aa71201ee06b).COLLECTIBLES_ROWS - 1) dY += 1;
        else if (action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_LEFT && dX > 0) dX -= 1;
        else if (action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_RIGHT && dX < (0, $1a153cf88c479932$export$2ef8aa71201ee06b).COLLECTIBLES_COLUMNS - 1) dX += 1;
        if (dX != this._selectedColumn || dY != this._selectedRow) {
            this.unHighlightSelection();
            this._selectedColumn = dX;
            this._selectedRow = dY;
            this.highlightSelection();
        }
    }
    sendItemViewMessage() {
        const item = this._collectibles[this._selectedRow][this._selectedColumn];
        if (item != undefined) window.engine.sendMessage(`%c{${(0, $248954e6cbd64b56$export$892596cec99bc70e).MESSAGE_ITEM_FG}}%b{${(0, $248954e6cbd64b56$export$892596cec99bc70e).MESSAGE_ITEM_BG}}${item.name}` + `%c{${(0, $248954e6cbd64b56$export$892596cec99bc70e).MESSAGE_ANY_FG}}%b{${(0, $248954e6cbd64b56$export$892596cec99bc70e).MESSAGE_ITEM_BG}} (found ${item.found})`, false);
        else window.engine.sendMessage(".....empty.....", false);
    }
    placeCollectible(col, row, t) {
        const coords = this.getCubbyDisplayCoordinates(row, col);
        let y = coords.y;
        let x = coords.x;
        for(let artY = 0; artY < t.length; ++artY){
            x = coords.x;
            const row = this._tiles[y];
            for(let artX = 0; artX < t[artY].length; ++artX){
                row[x] = this.replaceTile(t[artY][artX], this._fgItem);
                x += 1;
            }
            y += 1;
        }
    }
    getCubbyDisplayCoordinates(row, col) {
        const x = (0, $1a153cf88c479932$export$2ef8aa71201ee06b).PADDING_LEFT + col * (0, $1a153cf88c479932$export$2ef8aa71201ee06b).CUBBIE_WIDTH + col * (0, $1a153cf88c479932$export$2ef8aa71201ee06b).CUBBIE_COL_SPACING;
        const y = (0, $1a153cf88c479932$export$2ef8aa71201ee06b).PADDING_TOP + row * (0, $1a153cf88c479932$export$2ef8aa71201ee06b).CUBBIE_HEIGHT + row * (0, $1a153cf88c479932$export$2ef8aa71201ee06b).CUBBIE_ROW_SPACING;
        return {
            x: x,
            y: y
        };
    }
    highlightSelection() {
        const startX = (0, $1a153cf88c479932$export$2ef8aa71201ee06b).PADDING_LEFT + this._selectedColumn * (0, $1a153cf88c479932$export$2ef8aa71201ee06b).CUBBIE_WIDTH + this._selectedColumn * (0, $1a153cf88c479932$export$2ef8aa71201ee06b).CUBBIE_COL_SPACING - 1;
        const startY = (0, $1a153cf88c479932$export$2ef8aa71201ee06b).PADDING_TOP + this._selectedRow * (0, $1a153cf88c479932$export$2ef8aa71201ee06b).CUBBIE_HEIGHT + this._selectedRow * (0, $1a153cf88c479932$export$2ef8aa71201ee06b).CUBBIE_ROW_SPACING - 1;
        for(let hiliteY = startY; hiliteY < startY + (0, $1a153cf88c479932$export$2ef8aa71201ee06b).CUBBIE_HEIGHT + 2; ++hiliteY){
            const row = this._tiles[hiliteY];
            if (hiliteY == startY || hiliteY == startY + (0, $1a153cf88c479932$export$2ef8aa71201ee06b).CUBBIE_HEIGHT + 1) for(let hiliteX = startX; hiliteX < startX + (0, $1a153cf88c479932$export$2ef8aa71201ee06b).CUBBIE_WIDTH + 1; ++hiliteX)row[hiliteX] = {
                ...(0, $25f08219a36211c0$export$dbec788495c5680c)
            };
            else {
                row[startX] = {
                    ...(0, $25f08219a36211c0$export$dbec788495c5680c)
                };
                row[startX + (0, $1a153cf88c479932$export$2ef8aa71201ee06b).CUBBIE_WIDTH] = {
                    ...(0, $25f08219a36211c0$export$dbec788495c5680c)
                };
            }
        }
    // window.engine.sendMessage("Viewing " + this.name)
    }
    unHighlightSelection() {
        const startX = (0, $1a153cf88c479932$export$2ef8aa71201ee06b).PADDING_LEFT + this._selectedColumn * (0, $1a153cf88c479932$export$2ef8aa71201ee06b).CUBBIE_WIDTH + this._selectedColumn * (0, $1a153cf88c479932$export$2ef8aa71201ee06b).CUBBIE_COL_SPACING - 1;
        const startY = (0, $1a153cf88c479932$export$2ef8aa71201ee06b).PADDING_TOP + this._selectedRow * (0, $1a153cf88c479932$export$2ef8aa71201ee06b).CUBBIE_HEIGHT + this._selectedRow * (0, $1a153cf88c479932$export$2ef8aa71201ee06b).CUBBIE_ROW_SPACING - 1;
        for(let hiliteY = startY; hiliteY < startY + (0, $1a153cf88c479932$export$2ef8aa71201ee06b).CUBBIE_HEIGHT + 2; ++hiliteY){
            const row = this._tiles[hiliteY];
            if (hiliteY == startY || hiliteY == startY + (0, $1a153cf88c479932$export$2ef8aa71201ee06b).CUBBIE_HEIGHT + 1) for(let hiliteX = startX; hiliteX < startX + (0, $1a153cf88c479932$export$2ef8aa71201ee06b).CUBBIE_WIDTH + 1; ++hiliteX)row[hiliteX] = {
                ...(0, $25f08219a36211c0$export$99f00248b59b2065)
            };
            else {
                row[startX] = {
                    ...(0, $25f08219a36211c0$export$99f00248b59b2065)
                };
                row[startX + (0, $1a153cf88c479932$export$2ef8aa71201ee06b).CUBBIE_WIDTH] = {
                    ...(0, $25f08219a36211c0$export$99f00248b59b2065)
                };
            }
        }
    }
    initCubbies() {
        let spaceX = 0;
        let spaceY = 0;
        for(let y = (0, $1a153cf88c479932$export$2ef8aa71201ee06b).PADDING_TOP; y < this._tiles.length - (0, $1a153cf88c479932$export$2ef8aa71201ee06b).PADDING_TOP; ++y){
            spaceY += 1;
            spaceX = 0;
            for(let x = (0, $1a153cf88c479932$export$2ef8aa71201ee06b).PADDING_LEFT; x < this._tiles[y].length - (0, $1a153cf88c479932$export$2ef8aa71201ee06b).PADDING_LEFT; ++x){
                spaceX += 1;
                if (spaceX < (0, $1a153cf88c479932$export$2ef8aa71201ee06b).CUBBIE_WIDTH) this._tiles[y][x] = {
                    ...(0, $25f08219a36211c0$export$2307bef266fe885b)
                };
                else if (spaceX == (0, $1a153cf88c479932$export$2ef8aa71201ee06b).CUBBIE_WIDTH + (0, $1a153cf88c479932$export$2ef8aa71201ee06b).CUBBIE_COL_SPACING) spaceX = 0;
            }
            if (spaceY == (0, $1a153cf88c479932$export$2ef8aa71201ee06b).CUBBIE_HEIGHT) {
                spaceY = 0;
                y += (0, $1a153cf88c479932$export$2ef8aa71201ee06b).CUBBIE_ROW_SPACING;
            }
        }
    }
    initTiles() {
        this._tiles = new Array(this.height);
        for(let y = 0; y < this.height; ++y){
            const row = new Array(this.width);
            for(let x = 0; x < this.width; ++x){
                const isWall = x === 0 || x === this.width - 1 || y === 0 || y === this.height - 1;
                row[x] = isWall ? {
                    ...(0, $25f08219a36211c0$export$2307bef266fe885b)
                } : {
                    ...(0, $25f08219a36211c0$export$99f00248b59b2065)
                };
            }
            this._tiles[y] = row;
        }
    }
    replaceTile(symbol, fg) {
        return {
            walkable: false,
            target: null,
            light: {
                symbol: symbol,
                fg: fg,
                bg: (0, $248954e6cbd64b56$export$892596cec99bc70e).WALL_TILE_DARK_BG
            },
            dark: {
                symbol: symbol,
                fg: (0, $248954e6cbd64b56$export$892596cec99bc70e).WALL_TILE_DARK_FG,
                bg: (0, $248954e6cbd64b56$export$892596cec99bc70e).WALL_TILE_DARK_BG
            },
            transparent: true,
            visible: true,
            seen: true
        };
    }
}









class $fb7915359dc1a14b$export$e1da4b2fd0862559 extends (0, $566c8d9d74c4fb47$export$129a32eedafa97c5) {
    constructor(offsets, name, description, displayFunc){
        super((0, $1a153cf88c479932$export$cc91196ccdb51fef).TROPHY_CASE_WIDTH, (0, $1a153cf88c479932$export$cc91196ccdb51fef).TROPHY_CASE_HEIGHT, offsets, name), this._tiles = [], this._columnWidth = 0, this._newStats = (0, $1a153cf88c479932$export$f78a7bc9efcc5615).NONE, this._startingStats = (0, $1a153cf88c479932$export$f78a7bc9efcc5615).NONE, this._playerItems = [], this._playerItemsCount = 0, this._selectedItems = [], this._currentColumn = 0, this._currentRow = 0, this._errorMsg = "";
        this._displayFunc = displayFunc;
        this._description = description;
        this.initTiles();
    }
    getSelectedEquipment() {
        let equipped = [];
        this._selectedItems.forEach((item, idx)=>{
            const e = this._playerItems[idx][item];
            equipped.push(e);
        });
        return equipped;
    }
    prepareToRender() {
        const player = window.engine.getPlayer();
        this._playerItems = this._displayFunc(player.equipment);
        this._columnWidth = (this.width - 4) / this._playerItems.length;
        this._selectedItems = new Array(this._playerItems.length);
        for(let i = 0; i < this._selectedItems.length; ++i)this._selectedItems[i] = 0;
        // Mark currently equipped items
        this._playerItems.forEach((group, column)=>{
            this._playerItemsCount += group.length;
            group.forEach((item, row)=>{
                if (item.equipped) this._selectedItems[column] = row;
            });
        });
        this._startingStats = player.getEquipmentStats();
        this._newStats = {
            ...this._startingStats
        };
    }
    postRender() {}
    render(display) {
        for(let y = 0; y < this._tiles.length; ++y){
            const row = this._tiles[y];
            for(let x = 0; x < row.length; ++x){
                const tile = row[x];
                display.draw(x + this.offsets.xOffset, y + this.offsets.yOffset, tile.symbol, (0, $57907ac0dd7a2328$export$b5b1545233b45293)(tile.fg), (0, $57907ac0dd7a2328$export$b5b1545233b45293)(tile.bg));
            }
        }
        if (this._playerItemsCount == 0) {
            this._errorMsg = "No equipment available to select.";
            this._showConfirmDialog = true;
        }
        if (this._showConfirmDialog) {
            const message = this._errorMsg + " ESC to cancel";
            const xStart = this.width / 2 - message.length / 2;
            const yStart = this.height / 2 - 2;
            const blank = ".".padStart(message.length, ".");
            display.drawText(xStart, yStart, `%c{#fff}%b{#000}${message}`);
        } else {
            let colors = "%c{#fff}%b{#000}";
            const title = this.name;
            let printRow = 1;
            let xStart = this.width / 2 - title.length / 2 + this.offsets.xOffset;
            display.drawText(xStart, printRow, colors + title);
            let output = this._description;
            printRow += 2;
            xStart = this.width / 2 - output.length / 2;
            display.drawText(xStart, printRow, colors + output);
            printRow += 1;
            xStart = this.offsets.xOffset + 1;
            display.drawText(xStart, printRow, colors + "-".padEnd(this.width - 2, "-") // 2 accounts for walls
            );
            printRow += 1;
            output = (0, $0584ddc2e3cbe9e6$export$deba16b6f81aa4a3)(this._startingStats, this._newStats);
            let padding = (this.width - 2 - output.length) / 2;
            const padStrFront = ".".padStart(padding, ".");
            if ((this.width - output.length) % 2 == 1) padding += 1;
            const padStrBack = ".".padStart(padding, ".");
            xStart += 1;
            display.drawText(xStart, printRow, `%c{${(0, $248954e6cbd64b56$export$892596cec99bc70e).STATS_BG}}%b{${(0, $248954e6cbd64b56$export$892596cec99bc70e).STATS_BG}}` + padStrFront);
            xStart = padStrFront.length + 1;
            display.drawText(xStart, printRow, `%c{#000}%b{${(0, $248954e6cbd64b56$export$892596cec99bc70e).STATS_BG}}` + output);
            display.drawText(xStart + output.length, printRow, `%c{${(0, $248954e6cbd64b56$export$892596cec99bc70e).STATS_BG}}%b{${(0, $248954e6cbd64b56$export$892596cec99bc70e).STATS_BG}}` + padStrBack);
            printRow += 1;
            xStart = this.offsets.xOffset + 2;
            const rowTop = printRow;
            this._playerItems.forEach((group, column)=>{
                if (column == this._currentColumn) {
                    const marker = ".".padStart(this._columnWidth / 2, ".");
                    display.drawText(xStart, printRow, "%c{#0ff}%b{#0ff}" + marker);
                }
                group.forEach((e, row)=>{
                    let colors = "%c{#fff}%b{#000}";
                    if (this._selectedItems[column] == -1) this._selectedItems[column] = row;
                    if (row == this._selectedItems[column]) colors = "%c{#000}%b{#fff}";
                    printRow += 1;
                    let eStr = e.name;
                    if (e.twoHanded) eStr += " (two-handed)";
                    const max = this._columnWidth - 2;
                    eStr = eStr.substring(0, max);
                    display.drawText(xStart, printRow, colors + eStr);
                });
                xStart += this._columnWidth;
                printRow = rowTop;
            });
        }
    }
    update(action) {
        if (action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_DOWN) {
            if (this._playerItems[this._currentColumn].length > 0) {
                this._currentRow += 1;
                if (this._currentRow >= this._playerItems[this._currentColumn].length) this._currentRow = 0;
                this._selectedItems[this._currentColumn] = this._currentRow;
            }
        } else if (action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_UP) {
            if (this._playerItems[this._currentColumn].length > 0) {
                this._currentRow -= 1;
                if (this._currentRow < 0) this._currentRow = this._playerItems[this._currentColumn].length - 1;
                this._selectedItems[this._currentColumn] = this._currentRow;
            }
        } else if (action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_LEFT) {
            this._currentColumn -= 1;
            if (this._currentColumn < 0) this._currentColumn = this._playerItems.length - 1;
            if (this._selectedItems[this._currentColumn] != -1) this._currentRow = this._selectedItems[this._currentColumn];
        } else if (action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_RIGHT) {
            this._currentColumn += 1;
            if (this._currentColumn >= this._playerItems.length) this._currentColumn = 0;
            if (this._selectedItems[this._currentColumn] != -1) this._currentRow = this._selectedItems[this._currentColumn];
        }
        this.updateStats();
    }
    updateStats() {
        const player = window.engine.getPlayer();
        player.equip(this.getSelectedEquipment());
        this._newStats = player.getEquipmentStats();
    }
    initTiles() {
        this._tiles = new Array(this.height);
        for(let y = 0; y < this.height; y++){
            const isOddRow = y % 2 != 0 ? true : false;
            const row = new Array(this.width);
            for(let x = 0; x < this.width; x++){
                const isWall = x === 0 || x === this.width - 1 || y === 0 || y === this.height - 1;
                row[x] = isWall ? {
                    ...(0, $25f08219a36211c0$export$c3247160a5feeab2)
                } : {
                    ...(0, $25f08219a36211c0$export$c203f9d0903db330)
                };
            }
            this._tiles[y] = row;
        }
    }
}




class $d0630a952a1bf350$export$16e6e22d5240d458 extends (0, $fb7915359dc1a14b$export$e1da4b2fd0862559) {
    constructor(offsets, name, description, displayFunc){
        super(offsets, name, description, displayFunc);
    }
    prepareToRender() {
        const player = window.engine.getPlayer();
        const e = player.getEquipment((0, $f0b5fa422dff3899$export$45e36ab1b645cb80).RIGHT_HAND);
        if (e !== undefined && e.twoHanded) {
            this._errorMsg = "Cannot carry a gizmo and a two-handed weapon.";
            this._showConfirmDialog = true;
        } else this._showConfirmDialog = false;
        super.prepareToRender();
    }
}



function $02016429b660c4b1$export$3c19caacbdd4b859(offsets, name, description) {
    const arsenal = new (0, $fb7915359dc1a14b$export$e1da4b2fd0862559)(offsets, name, description, $02016429b660c4b1$export$561134a4fb0546fa);
    return arsenal;
}
function $02016429b660c4b1$export$561134a4fb0546fa(e) {
    const arsenal = new Array(1);
    arsenal[0] = [];
    // 1 column
    e.forEach((item)=>{
        if ((0, $95a3e0019f5651ca$export$b22d0746a791758f)(item.type)) arsenal[0].push(item);
    });
    return arsenal;
}
function $02016429b660c4b1$export$b6d2a5d897066649(offsets, name, description) {
    const gizmos = new (0, $d0630a952a1bf350$export$16e6e22d5240d458)(offsets, name, description, $02016429b660c4b1$export$e5b2b7db3d688c4);
    return gizmos;
}
function $02016429b660c4b1$export$e5b2b7db3d688c4(e) {
    const gizmos = new Array(1);
    gizmos[0] = [];
    // 1 column
    e.forEach((item)=>{
        if ((0, $95a3e0019f5651ca$export$59222e1cac6d5d6d)(item.type)) gizmos[0].push(item);
    });
    return gizmos;
}
function $02016429b660c4b1$export$3423bdae01dff296(offsets, name, description) {
    const wardrobe = new (0, $fb7915359dc1a14b$export$e1da4b2fd0862559)(offsets, name, description, $02016429b660c4b1$export$f212ad613134c377);
    return wardrobe;
}
function $02016429b660c4b1$export$f212ad613134c377(e) {
    const wardrobe = new Array(3);
    for(let i = 0; i < wardrobe.length; ++i)wardrobe[i] = [];
    // head = 0, torso = 1, feet = 2
    e.forEach((item)=>{
        let column = -1;
        if ((0, $95a3e0019f5651ca$export$f7147161cc4c402f)(item.type)) column = 0;
        else if ((0, $95a3e0019f5651ca$export$39fd1bf1c7e0a20d)(item.type)) column = 1;
        else if ((0, $95a3e0019f5651ca$export$6f5c86f1bae3a2f4)(item.type)) column = 2;
        if (column >= 0) wardrobe[column].push(item);
    });
    return wardrobe;
}








/// <reference types="../types/index.d.ts" />
// (c) 2020-present Andrea Giammarchi
const { parse: $c6b19882761ce7ac$var$$parse, stringify: $c6b19882761ce7ac$var$$stringify } = JSON;
const { keys: $c6b19882761ce7ac$var$keys } = Object;
const $c6b19882761ce7ac$var$Primitive = String; // it could be Number
const $c6b19882761ce7ac$var$primitive = 'string'; // it could be 'number'
const $c6b19882761ce7ac$var$ignore = {};
const $c6b19882761ce7ac$var$object = 'object';
const $c6b19882761ce7ac$var$noop = (_, value)=>value;
const $c6b19882761ce7ac$var$primitives = (value)=>value instanceof $c6b19882761ce7ac$var$Primitive ? $c6b19882761ce7ac$var$Primitive(value) : value;
const $c6b19882761ce7ac$var$Primitives = (_, value)=>typeof value === $c6b19882761ce7ac$var$primitive ? new $c6b19882761ce7ac$var$Primitive(value) : value;
const $c6b19882761ce7ac$var$revive = (input, parsed, output, $)=>{
    const lazy = [];
    for(let ke = $c6b19882761ce7ac$var$keys(output), { length: length } = ke, y = 0; y < length; y++){
        const k = ke[y];
        const value = output[k];
        if (value instanceof $c6b19882761ce7ac$var$Primitive) {
            const tmp = input[value];
            if (typeof tmp === $c6b19882761ce7ac$var$object && !parsed.has(tmp)) {
                parsed.add(tmp);
                output[k] = $c6b19882761ce7ac$var$ignore;
                lazy.push({
                    k: k,
                    a: [
                        input,
                        parsed,
                        tmp,
                        $
                    ]
                });
            } else output[k] = $.call(output, k, tmp);
        } else if (output[k] !== $c6b19882761ce7ac$var$ignore) output[k] = $.call(output, k, value);
    }
    for(let { length: length } = lazy, i = 0; i < length; i++){
        const { k: k, a: a } = lazy[i];
        output[k] = $.call(output, k, $c6b19882761ce7ac$var$revive.apply(null, a));
    }
    return output;
};
const $c6b19882761ce7ac$var$set = (known, input, value)=>{
    const index = $c6b19882761ce7ac$var$Primitive(input.push(value) - 1);
    known.set(value, index);
    return index;
};
const $c6b19882761ce7ac$export$98e6a39c04603d36 = (text, reviver)=>{
    const input = $c6b19882761ce7ac$var$$parse(text, $c6b19882761ce7ac$var$Primitives).map($c6b19882761ce7ac$var$primitives);
    const value = input[0];
    const $ = reviver || $c6b19882761ce7ac$var$noop;
    const tmp = typeof value === $c6b19882761ce7ac$var$object && value ? $c6b19882761ce7ac$var$revive(input, new Set, value, $) : value;
    return $.call({
        '': tmp
    }, '', tmp);
};
const $c6b19882761ce7ac$export$fac44ee5b035f737 = (value, replacer, space)=>{
    const $ = replacer && typeof replacer === $c6b19882761ce7ac$var$object ? (k, v)=>k === '' || -1 < replacer.indexOf(k) ? v : void 0 : replacer || $c6b19882761ce7ac$var$noop;
    const known = new Map;
    const input = [];
    const output = [];
    let i = +$c6b19882761ce7ac$var$set(known, input, $.call({
        '': value
    }, '', value));
    let firstRun = !i;
    while(i < input.length){
        firstRun = true;
        output[i] = $c6b19882761ce7ac$var$$stringify(input[i++], replace, space);
    }
    return '[' + output.join(',') + ']';
    function replace(key, value) {
        if (firstRun) {
            firstRun = !firstRun;
            return value;
        }
        const after = $.call(this, key, value);
        switch(typeof after){
            case $c6b19882761ce7ac$var$object:
                if (after === null) return after;
            case $c6b19882761ce7ac$var$primitive:
                return known.get(after) || $c6b19882761ce7ac$var$set(known, input, after);
        }
        return after;
    }
};
const $c6b19882761ce7ac$export$54fd2c36b5cc6731 = (value)=>$c6b19882761ce7ac$var$$parse($c6b19882761ce7ac$export$fac44ee5b035f737(value));
const $c6b19882761ce7ac$export$21625637effda04 = (value)=>$c6b19882761ce7ac$export$98e6a39c04603d36($c6b19882761ce7ac$var$$stringify(value));



function $2aa9bb548e720ccf$export$c12b7b0e1d99a309() {
    localStorage.removeItem((0, $1a153cf88c479932$export$1986a3279c8087ed).KEY_TAPESTRY);
    localStorage.removeItem((0, $1a153cf88c479932$export$1986a3279c8087ed).KEY_PLAYER);
}
function $2aa9bb548e720ccf$export$4ae66c4fe67aa1e4(key = (0, $1a153cf88c479932$export$1986a3279c8087ed).KEY_PLAYER) {
    const json = localStorage.getItem(key);
    if (json) return (0, $c6b19882761ce7ac$export$98e6a39c04603d36)(json);
    return undefined;
}
function $2aa9bb548e720ccf$export$be21701813bf5d1c(key = (0, $1a153cf88c479932$export$1986a3279c8087ed).KEY_TAPESTRY) {
    const json = localStorage.getItem(key);
    if (json) return (0, $c6b19882761ce7ac$export$98e6a39c04603d36)(json);
    return undefined;
}
function $2aa9bb548e720ccf$export$4bc3e69368520616(key, object) {
    localStorage.setItem(key, (0, $c6b19882761ce7ac$export$fac44ee5b035f737)(object));
}
function $2aa9bb548e720ccf$export$b85c84b2abcbeae5(key = (0, $1a153cf88c479932$export$1986a3279c8087ed).KEY_PLAYER) {
    localStorage.removeItem(key);
}




var $5xx0W = parcelRequire("5xx0W");
class $16de3851ce156f32$export$2c3b404bf3a77a1f {
    constructor(messagesTarget, gameTarget, statsTarget, currentMapID){
        this.currentMapID = currentMapID;
        this._musicPlayer = undefined;
        // MESSAGES DISPLAY
        this.messagesDisplay = new $c6091c547a8eac13$export$2e2bcd8739ae039({
            width: (0, $1a153cf88c479932$export$cc91196ccdb51fef).WIDTH,
            height: (0, $1a153cf88c479932$export$cc91196ccdb51fef).MESSAGES_HEIGHT
        });
        let container = this.messagesDisplay.getContainer();
        messagesTarget.appendChild(container);
        // GAME DISPLAY
        this.gameDisplay = new $c6091c547a8eac13$export$2e2bcd8739ae039({
            width: (0, $1a153cf88c479932$export$cc91196ccdb51fef).WIDTH,
            height: (0, $1a153cf88c479932$export$cc91196ccdb51fef).GAME_HEIGHT
        });
        container = this.gameDisplay.getContainer();
        gameTarget.appendChild(container);
        // STATS DISPLAY
        this.statsDisplay = new $c6091c547a8eac13$export$2e2bcd8739ae039({
            width: (0, $1a153cf88c479932$export$cc91196ccdb51fef).WIDTH,
            height: (0, $1a153cf88c479932$export$cc91196ccdb51fef).STATS_HEIGHT
        });
        container = this.statsDisplay.getContainer();
        statsTarget.appendChild(container);
        this._updateRequested = false;
        this._updateTimer = new (0, $b36b515e341ce35e$export$c57e9b2d8b9e4de)((0, $1a153cf88c479932$export$cc91196ccdb51fef).UPDATE_FREQ);
        this._updateTimer.start(true, ()=>{
            this.checkUpdateRequests();
        });
        this._clock = 0;
        this._timer = new (0, $b36b515e341ce35e$export$c57e9b2d8b9e4de)(1000);
        this._timer.start(true, ()=>{
            this.tickClock();
        });
        // Have to be in order:
        // 1. Init player
        // 2. Init map
        // 3. Place player in map
        // 4. Init displays
        this.player = $16de3851ce156f32$var$loadPlayer();
        const mapData = (0, $b296c6d74f581bce$export$6f46047ee61f45d3)(currentMapID);
        this.map = (0, $b296c6d74f581bce$export$b41394a5437791c8)(currentMapID, mapData, this.gameDisplay, this.player, (0, $1a153cf88c479932$export$cc91196ccdb51fef).DISPLAY_OFFSETS);
        if (mapData.music !== undefined) {
            (0, $5xx0W.updateSongInfo)(mapData.music.title);
            this.changeMusic(mapData.music, true);
        } else (0, $5xx0W.enableStartGameButton)();
        window.addEventListener("keydown", (event)=>{
            this.update(event);
        });
        this.messages = [
            {
                count: 1,
                message: "You ride the wind into " + (0, $b296c6d74f581bce$export$32f6dae5310d379c)(this.currentMapID)
            }
        ];
        this.popup = (0, $f0b5fa422dff3899$export$fe68bdb23e385108).NONE;
        this.trophyCases = $16de3851ce156f32$var$buildPopups();
        this.map.updateFov();
        this.render();
    }
    getPlayer() {
        return this.player;
    }
    checkUpdateRequests() {
        if (this._updateRequested) {
            this.update();
            this._updateRequested = false;
        }
    }
    processPlayerAttack(e, allowReturnFire) {
        const damageDealt = e.takeHit(this.player.dealHit());
        this.sendMessage("You drain " + damageDealt + " essence from " + e.displayName);
        if (!e.isAlive()) {
            this.sendMessage("A faint residue remains of " + e.displayName);
            this.sendMessage("You gain " + e.experience + " experience.");
            this.player.addExperience(e.experience);
            this.processEnemyKill(e);
            this.killBeast(e.type);
        } else if (allowReturnFire) this.processEnemyAttack(e, false);
        return;
    }
    processEssenceAttack(amount, mob) {
        const essenceLost = this.player.takeHit(amount);
        this.sendMessage("You lose " + essenceLost + " essence to " + mob);
    }
    processPigmentAttack(amount, mob) {
        const pigmentLost = this.player.loseColor(amount);
        this.requestPlayerSaveState();
        if (pigmentLost.length == 0) this.sendMessage(mob + " tries but fails to steal pigment");
        pigmentLost.forEach((p)=>{
            this.sendMessage("You lose " + p.amount + " " + p.color + " pigment to " + mob);
        });
    }
    processEnemyAttack(e, allowReturnFire) {
        const attack = e.attack;
        const amount = attack.amount;
        if (attack.type == (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_ESSENCE) this.processEssenceAttack(amount, e.displayName);
        else if (attack.type == (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_PIGMENT) this.processPigmentAttack(amount, e.displayName);
        else if (attack.type == (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_ESSENCE_AND_PIGMENT) {
            this.processEssenceAttack(amount, e.displayName);
            this.processPigmentAttack(amount, e.displayName);
        }
    }
    requestPlayerSaveState() {
        (0, $2aa9bb548e720ccf$export$4bc3e69368520616)((0, $1a153cf88c479932$export$1986a3279c8087ed).KEY_PLAYER, this.player);
    }
    requestUpdate() {
        this._updateRequested = true;
    }
    showMapSummaryStats() {
        const collectibles = this.map.getCollectibleCount();
        const pigments = this.map.getPigmentCount();
        const items = this.map.getItemCount();
        const enemies = this.map.getEnemyCount();
        let message = "Scan reveals - > ";
        message += pigments.toString() + " pigment";
        if (pigments != 1) message += "s";
        message += ", ";
        message += items.toString() + " item";
        if (items != 1) message += "s";
        message += ", ";
        message += enemies.toString() + " enem";
        if (enemies != 1) message += "ies";
        else message += "y";
        message += ", ";
        message += collectibles.toString() + " collectible";
        if (collectibles != 1) message += "s";
        this.sendMessage(message);
    }
    tickClock() {
        this._clock++;
        this.renderClock();
    }
    displayRandomRoomsGenerated(rooms) {
        (0, $5xx0W.appendRandomRoomsTotal)(rooms);
    }
    displayGizmoTimer(output) {
        (0, $5xx0W.updateGizmoDisplay)(output);
    }
    addBeastToBestiary(type) {
        const b = this.trophyCases.get((0, $f0b5fa422dff3899$export$fe68bdb23e385108).BESTIARY);
        if (b !== undefined) b.addBeast(type);
    }
    seeBeast(type) {
        const b = this.trophyCases.get((0, $f0b5fa422dff3899$export$fe68bdb23e385108).BESTIARY);
        if (b !== undefined) b.seeBeast(type);
    }
    killBeast(type) {
        const b = this.trophyCases.get((0, $f0b5fa422dff3899$export$fe68bdb23e385108).BESTIARY);
        if (b !== undefined) b.killBeast(type);
    }
    audioReady(firstScreen) {
        if (this._musicPlayer !== undefined) {
            (0, $5xx0W.closeLoadingPopup)();
            if (firstScreen) (0, $5xx0W.enableStartGameButton)();
        } else (0, $5xx0W.enableStartGameButton)();
    }
    changeMusic(config, firstScreen, fromTapestry = false) {
        if (config !== undefined) {
            if (this._musicPlayer !== undefined) {
                this._musicPlayer.stop();
                this._musicPlayer.unload();
            }
            if (!fromTapestry) (0, $5xx0W.openLoadingPopup)();
            (0, $5xx0W.updateSongInfo)(config.title);
            const volume = (0, $5xx0W.musicVolume)();
            const muted = (0, $5xx0W.musicIsMuted)();
            const autoplay = (0, $5xx0W.musicIsStopped)() ? false : true;
            this._musicPlayer = new (0, $01161cf60774ccdb$export$55a5cecb88257141)(config.source, firstScreen, autoplay, volume, muted);
        }
    }
    muteMusic() {
        if (this._musicPlayer !== undefined) this._musicPlayer.mute();
    }
    unmuteMusic() {
        if (this._musicPlayer !== undefined) this._musicPlayer.unmute();
    }
    pauseMusic() {
        if (this._musicPlayer !== undefined) this._musicPlayer.pause();
    }
    startMusic() {
        if (this._musicPlayer !== undefined) this._musicPlayer.play();
    }
    getMusicVolume() {
        if (this._musicPlayer !== undefined) return (0, $5xx0W.musicVolume)();
        return 0.5;
    }
    setMusicVolume(volume) {
        if (this._musicPlayer !== undefined) this._musicPlayer.setVolume(volume);
    }
    showPlayButton() {
        (0, $5xx0W.showPlayButton)();
    }
    showPauseButton() {
        (0, $5xx0W.showPauseButton)();
    }
    getEntitiesAtLocation(position) {
        // TODO: need entities whose AOE reaches x,y
        return this.map.findEntities(position);
    }
    getNearestInteractables(position, direction) {
        return this.map.findInteractables(position, direction);
    }
    interact(e) {
        if (e instanceof (0, $cb91172ccfffa818$export$95d4acdbab2fc6ef)) this.popup = e.target;
        else if (e instanceof (0, $73fbffeae5ed3875$export$97e98b0c09b627f4)) {
            if (e.canBeUnlocked()) {
                if (this.player.hasKey(e.target)) {
                    this.sendMessage("You unlock the door to " + (0, $b296c6d74f581bce$export$32f6dae5310d379c)(e.target));
                    this.map.removeTopmostEntity(e.position);
                } else this.sendMessage("You do not have the key for " + (0, $b296c6d74f581bce$export$32f6dae5310d379c)(e.target), false);
            } else this.sendMessage("This door cannot be unlocked until " + e.getUnlockDate(), false);
        } else if (e instanceof (0, $cdaf355186b7e8f3$export$ee92a44c6f1de009)) {
            if (this.currentMapID != e.target) this.enterPortal(e.target);
        }
    }
    processEnemyKill(enemy) {
        if (enemy instanceof (0, $c0d3e0f22e872a9a$export$2dd8a177a759b9f9) || enemy instanceof (0, $f049ee08ee081312$export$7b6a390f24537dda)) enemy.stopTimer();
        const drop = (0, $0eb0e6f5b56b7df1$export$dd9aaf1372304467)();
        let essence = 0;
        let pigment = undefined;
        if (drop < (0, $1a153cf88c479932$export$62d95f0373aed4f6).ITEM_DROP_PROB) {
            if (enemy.attack.type == (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_ESSENCE) essence = (0, $0584ddc2e3cbe9e6$export$98bc0edab7e91143)();
            else if (enemy.attack.type == (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_PIGMENT) pigment = (0, $0584ddc2e3cbe9e6$export$c5946c1c8844ff16)(this.player.optics);
            else if (enemy.attack.type == (0, $f0b5fa422dff3899$export$889fea6127a16d48).DRAIN_ESSENCE_AND_PIGMENT) {
                const half = (0, $0eb0e6f5b56b7df1$export$dd9aaf1372304467)();
                if (half < 0.5) essence = (0, $0584ddc2e3cbe9e6$export$98bc0edab7e91143)();
                else pigment = (0, $0584ddc2e3cbe9e6$export$c5946c1c8844ff16)(this.player.optics);
            }
        }
        if (essence > 0) this.player.addEssence(essence);
        else if (pigment && pigment.amount > 0) {
            const converted = (0, $d6d4dd36e67b7d9f$export$a6cefe4269ad87ee)(pigment.type);
            this.sendMessage("You collected " + (0, $57907ac0dd7a2328$export$1071895c7014e035)(converted) + " pigment");
            this.player.addPigment(pigment.type, pigment.amount);
        }
    }
    removeEntityAtLocation(position) {
        this.map.removeTopmostEntity(position);
    }
    removeItemAtLocation(position, type) {
        this.map.removeItem(position, type);
    }
    restart() {
        this.map.destroy();
        this.currentMapID = (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).Portals;
        this.sendMessage("You re-form at " + (0, $b296c6d74f581bce$export$32f6dae5310d379c)(this.currentMapID));
        this.player.resurrect();
        const mapData = (0, $b296c6d74f581bce$export$6f46047ee61f45d3)(this.currentMapID);
        if (mapData.music !== undefined) this.changeMusic(mapData.music, false);
        this.map = (0, $b296c6d74f581bce$export$b41394a5437791c8)(this.currentMapID, mapData, this.gameDisplay, this.player, (0, $1a153cf88c479932$export$cc91196ccdb51fef).DISPLAY_OFFSETS);
    }
    sendMessage(msg, showRepetition = true) {
        msg = msg.trim();
        if (msg.length > 0) {
            if (this.messages.length > 0) {
                if (msg == this.messages[0].message) {
                    if (showRepetition) this.messages[0].count += 1;
                } else this.messages.unshift({
                    count: 1,
                    message: msg
                });
            } else this.messages.push({
                count: 1,
                message: msg
            });
            if (this.messages.length > 6) this.messages = this.messages.slice(0, 6);
        }
    }
    inBounds(x, y) {
        return this.map.inBounds(x, y);
    }
    isVisible(x, y) {
        return this.map.isVisible(x, y);
    }
    enterPortal(mapID) {
        this.map.destroy();
        this.currentMapID = mapID;
        const mapData = (0, $b296c6d74f581bce$export$6f46047ee61f45d3)(this.currentMapID);
        if (mapData.music !== undefined) this.changeMusic(mapData.music, false);
        this.map = (0, $b296c6d74f581bce$export$b41394a5437791c8)(this.currentMapID, mapData, this.gameDisplay, this.player, (0, $1a153cf88c479932$export$cc91196ccdb51fef).DISPLAY_OFFSETS);
        this.player.visit(this.currentMapID);
        this.sendMessage("You ride the wind into " + (0, $b296c6d74f581bce$export$32f6dae5310d379c)(this.currentMapID));
    }
    // TODO: static enemies can be sync enemies with speed=0
    //       has knock-on for this function
    updateEnemies(updateSyncs = false) {
        this.map.placeResidues();
        if (updateSyncs) {
            this.map.bounceSyncEnemies.forEach((e)=>{
                const state = e.projectMove();
            });
            this.map.pathSyncEnemies.forEach((e)=>{
                const state = e.projectMove();
            });
        }
    }
    clearDisplays() {
        this.messagesDisplay.clear();
        this.gameDisplay.clear();
        this.statsDisplay.clear();
    }
    update(event) {
        if (!event) {
            this.clearDisplays();
            this.updateEnemies();
            if (!this.player.isAlive()) this.restart();
            this.map.updateFov();
            this.render();
            return;
        }
        const action = (0, $4df2accce7c7f382$export$412508d679148d5c)(event);
        if (this.popup == (0, $f0b5fa422dff3899$export$fe68bdb23e385108).TAPESTRY && action != (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).NONE) {
            const popup = this.trophyCases.get(this.popup);
            if (popup !== undefined) {
                if (action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_LEFT && popup.showingConfirmDialog() && popup.canSelectPigment()) popup.changePigmentSelection((0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).LEFT);
                else if (action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).MOVE_RIGHT && popup.showingConfirmDialog() && popup.canSelectPigment()) popup.changePigmentSelection((0, $f0b5fa422dff3899$export$cacd6541cfeeb6c1).RIGHT);
                else if (action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).BIND_PIGMENT) popup.showConfirmDialog();
                else if (action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).CONFIRM_YES && popup.canSelectPigment()) {
                    popup.hideConfirmDialog();
                    const selected = popup.getSelectedPigment();
                    popup.bindPigmentToTiles(selected);
                    this.player.bindPigment(selected);
                    (0, $2aa9bb548e720ccf$export$4bc3e69368520616)((0, $1a153cf88c479932$export$1986a3279c8087ed).KEY_TAPESTRY, popup);
                } else if (action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).CONFIRM_NO) popup.hideConfirmDialog();
                else if (action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).CLOSE_POPUP) {
                    if (popup.showingConfirmDialog()) popup.hideConfirmDialog();
                    else {
                        popup.postRender();
                        if (popup.complete) {
                            const mapData = (0, $b296c6d74f581bce$export$6f46047ee61f45d3)(this.currentMapID);
                            if (mapData.music !== undefined) this.changeMusic(mapData.music, false, true);
                        }
                        this.popup = (0, $f0b5fa422dff3899$export$fe68bdb23e385108).NONE;
                    }
                }
            }
            this.clearDisplays();
            this.render();
            return;
        }
        if (action != (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).NONE) {
            if (action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).GO_HOME) this.enterPortal((0, $f0b5fa422dff3899$export$8800d5c3a30bb568).Portals);
            else if (action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).CLOSE_POPUP && this.popup != (0, $f0b5fa422dff3899$export$fe68bdb23e385108).NONE) this.popup = (0, $f0b5fa422dff3899$export$fe68bdb23e385108).NONE;
            else if (action == (0, $f0b5fa422dff3899$export$59e1210cf9f377b3).VIEW_LOADOUT) this.popup = (0, $f0b5fa422dff3899$export$fe68bdb23e385108).VIEW_LOADOUT;
            else {
                if (this.popup == (0, $f0b5fa422dff3899$export$fe68bdb23e385108).NONE) this.player.update(action);
                else if (this.popup != (0, $f0b5fa422dff3899$export$fe68bdb23e385108).TAPESTRY) {
                    const popup = this.trophyCases.get(this.popup);
                    if (popup !== undefined) popup.update(action);
                }
            }
            this.updateEnemies(this.player.moved);
            if (!this.player.isAlive()) this.restart();
            this.map.updateFov();
            this.clearDisplays();
            this.render();
        }
    }
    renderClock() {
        const clock = this.clockString();
        this.messagesDisplay.drawText((0, $1a153cf88c479932$export$cc91196ccdb51fef).WIDTH - clock.length - (0, $1a153cf88c479932$export$cc91196ccdb51fef).DISPLAY_OFFSETS.xOffset, 2, `%c{${(0, $248954e6cbd64b56$export$892596cec99bc70e).CLOCK}}%b{${(0, $248954e6cbd64b56$export$892596cec99bc70e).BLACK}}${clock}`);
    }
    renderMessages() {
        // title
        const title = "Tapestry";
        this.messagesDisplay.drawText((0, $1a153cf88c479932$export$cc91196ccdb51fef).WIDTH - title.length - (0, $1a153cf88c479932$export$cc91196ccdb51fef).DISPLAY_OFFSETS.xOffset, 1, `%c{${(0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_RED}}%b{#000}${title[0]}` + `%c{${(0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_YELLOW}}%b{#000}${title[1]}` + `%c{${(0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_MAGENTA}}%b{#000}${title[2]}` + `%c{${(0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_BLUE}}%b{#000}${title[3]}` + `%c{${(0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_CYAN}}%b{#000}${title[4]}` + `%c{${(0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_GREEN}}%b{#000}${title[5]}` + `%c{${(0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_YELLOW}}%b{#000}${title[6]}` + `%c{${(0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_RED}}%b{#000}${title[7]}`);
        // Last 3 messages
        for(let i = 0; i < this.messages.length && i < 3; ++i){
            let text = ".".repeat(i) + this.messages[i].message;
            let count = this.messages[i].count > 1 ? "x" + this.messages[i].count : "";
            let textColor = i == 0 ? "#fff" : "#808080";
            this.messagesDisplay.drawText(1, i + 1, `%c{${textColor}}%b{#000}${text} ${count}`);
        }
    }
    renderGame() {
        if (this.popup == (0, $f0b5fa422dff3899$export$fe68bdb23e385108).NONE) {
            const offset = this.map.render();
            const render = this.player.renderLight();
            this.gameDisplay.drawOver(this.player.position.x - offset.xOffset, this.player.position.y - offset.yOffset, render.symbol, render.color, null);
        } else {
            const tc = this.trophyCases.get(this.popup);
            if (tc) {
                if (tc instanceof (0, $865fdc4517d1c112$export$38c733d2195e496)) tc.display = this.gameDisplay;
                tc.prepareToRender();
                tc.render(this.gameDisplay);
            }
        }
    }
    clockString() {
        if (this._clock >= 86400) this._clock = 0;
        const hours = String(Math.trunc(this._clock / 3600)).padStart(2, "0");
        const minutes = String(Math.trunc(this._clock % 3600 / 60)).padStart(2, "0");
        const seconds = String(Math.trunc(this._clock % 3600 % 60)).padStart(2, "0");
        return hours + ":" + minutes + ":" + seconds;
    }
    renderStats() {
        // Location
        const loc = "Location: " + (0, $b296c6d74f581bce$export$32f6dae5310d379c)(this.currentMapID);
        this.statsDisplay.drawText(1, 1, `%c{#fff}%b{#000}${loc}`);
        // Gizmo
        const gizmo = "Gizmo: " + this.player.getGizmoStats();
        this.statsDisplay.drawText((0, $1a153cf88c479932$export$cc91196ccdb51fef).WIDTH / 2, 1, `%c{#fff}%b{#000}${gizmo}`);
        // Level and experience
        const level = this.player.level.toString().padStart(3);
        const exp = this.player.experience.toString().padStart(3);
        const nextExp = this.player.getNextLevelExpString();
        const elixirs = this.player.elixirs.toString().padStart(3);
        this.statsDisplay.drawText(1, 2, `%c{#fff}%b{#000}Level: ${level}, ` + `%c{#fff}%b{#000}Exp: ${exp} ${nextExp}, ` + `%c{#fff}%b{#000}Elx: ${elixirs}, ` + `%c{#fff}%b{#000}Optic: ` + (0, $1eb61eaeba4c6dbc$export$9ee3990868f8c2a3)(this.player));
        // Main stats
        const playerStats = this.player.getEquipmentStats();
        const eAttack = playerStats.maxEssenceAttack.toString();
        const eDefense = playerStats.essenceDefense.toString();
        const pDefense = playerStats.pigmentDefense.toString();
        const sRange = playerStats.stealthRange.toString();
        this.statsDisplay.drawText(1, 3, `%c{#fff}%b{#000}Ess: ${this.player.essence.toString().padStart(3)}, ` + `%c{#fff}%b{#000}Atk: ${eAttack.padStart(3)}, ` + `%c{#fff}%b{#000}Ess def: ${eDefense.padStart(3)}, ` + `%c{#fff}%b{#000}Col def: ${pDefense.padStart(3)}, ` + `%c{#fff}%b{#000}Stlh: ${sRange.padStart(3)}`);
        // Palette
        let pigmentString = "";
        (0, $1a153cf88c479932$export$88f18ddea8961844).forEach((p)=>{
            pigmentString += " " + this.getPigmentString(p);
        });
        const binder = this.player.getBinders().toString().padStart(3);
        const binderString = `%c{#fff}%b{#000}Bnd: ${binder}`;
        this.statsDisplay.drawText(1, 4, pigmentString + " " + binderString);
    }
    render() {
        this.renderMessages();
        this.renderClock();
        this.renderGame();
        this.renderStats();
    }
    getPigmentString(color) {
        const fg = this.getPigmentForeground(color);
        const label = this.getPigmentLabel(color);
        return `%c{${fg}}%b{#000}${label}: ${this.player.getColorCountString(color)}`;
    }
    clearTile(x, y) {
        this.map.clearTile(x, y, this.gameDisplay, this.player);
    }
    renderEntity(e) {
        this.map.renderEntity(e);
    }
    getTapestryStats() {
        const tapestry = this.trophyCases.get((0, $f0b5fa422dff3899$export$fe68bdb23e385108).TAPESTRY);
        if (tapestry !== undefined) return tapestry.getStats();
        return undefined;
    }
    getPigmentForeground(color) {
        let fg = "#000";
        switch(color){
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).RED:
                fg = "#f00";
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).GREEN:
                fg = "#0f0";
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).BLUE:
                fg = "#00f";
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).YELLOW:
                fg = "#ff0";
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).MAGENTA:
                fg = "#f0f";
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).CYAN:
                fg = "#0ff";
                break;
        }
        return fg;
    }
    getPigmentLabel(color) {
        let label = "";
        switch(color){
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).RED:
                label = "Red";
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).GREEN:
                label = "Grn";
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).BLUE:
                label = "Blu";
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).YELLOW:
                label = "Yel";
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).MAGENTA:
                label = "Mag";
                break;
            case (0, $f0b5fa422dff3899$export$b1b64d948644442b).CYAN:
                label = "Cya";
                break;
        }
        return label;
    }
}
function $16de3851ce156f32$var$loadPlayer() {
    const player = new (0, $c7705b01e631e42c$export$2616165974278734)({
        x: 0,
        y: 0
    });
    const p = (0, $2aa9bb548e720ccf$export$4ae66c4fe67aa1e4)();
    if (p !== undefined) Object.assign(player, p);
    const oSet = new Set(player.optics);
    player.overwriteOptics(Array.from(oSet));
    return player;
}
function $16de3851ce156f32$var$loadTapestry() {
    const tapestry = new (0, $865fdc4517d1c112$export$38c733d2195e496)((0, $1a153cf88c479932$export$cc91196ccdb51fef).DISPLAY_OFFSETS, "Tapestry");
    const t = (0, $2aa9bb548e720ccf$export$be21701813bf5d1c)();
    if (t !== undefined) Object.assign(tapestry, t);
    return tapestry;
}
function $16de3851ce156f32$var$buildPopups() {
    let tc = new globalThis.Map();
    // Tapestry
    const tapestry = $16de3851ce156f32$var$loadTapestry();
    tc.set((0, $f0b5fa422dff3899$export$fe68bdb23e385108).TAPESTRY, tapestry);
    0, $2aa9bb548e720ccf$export$4bc3e69368520616;
    // Archive
    const archive = new (0, $9433eb3e6eeed544$export$767c3cfd836ab901)((0, $1a153cf88c479932$export$cc91196ccdb51fef).DISPLAY_OFFSETS, "Archive");
    tc.set((0, $f0b5fa422dff3899$export$fe68bdb23e385108).ARCHIVE, archive);
    // Bestiary
    const bestiary = new (0, $0f24a2512fffcf54$export$2cb1d7a364db3021)((0, $1a153cf88c479932$export$cc91196ccdb51fef).DISPLAY_OFFSETS, "Bestiary");
    // TODO: remove after testing
    // bestiaryTestData(bestiary)
    tc.set((0, $f0b5fa422dff3899$export$fe68bdb23e385108).BESTIARY, bestiary);
    // Wardrobe
    const wardrobe = (0, $02016429b660c4b1$export$3423bdae01dff296)((0, $1a153cf88c479932$export$cc91196ccdb51fef).DISPLAY_OFFSETS, "Wardrobe", "The wardrobe items you have found, and can wear.");
    tc.set((0, $f0b5fa422dff3899$export$fe68bdb23e385108).WARDROBE, wardrobe);
    // Arsenal
    const arsenal = (0, $02016429b660c4b1$export$3c19caacbdd4b859)((0, $1a153cf88c479932$export$cc91196ccdb51fef).DISPLAY_OFFSETS, "Arsenal", "The weapons you have found, and can wield.");
    tc.set((0, $f0b5fa422dff3899$export$fe68bdb23e385108).ARSENAL, arsenal);
    // Gizmos
    const gizmos = (0, $02016429b660c4b1$export$b6d2a5d897066649)((0, $1a153cf88c479932$export$cc91196ccdb51fef).DISPLAY_OFFSETS, "Gizmos", "The gizmos you have found, and can carry on your explorations.");
    tc.set((0, $f0b5fa422dff3899$export$fe68bdb23e385108).GIZMOS, gizmos);
    // Common Finds
    const commonFinds = new (0, $e4cb996cf1b3c32d$export$fe3cf7bac7de6d6d)((0, $1a153cf88c479932$export$cc91196ccdb51fef).DISPLAY_OFFSETS, "Vault of Common Finds", (0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_WHITE, (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).COLLECTIBLE_COMMON);
    tc.set((0, $f0b5fa422dff3899$export$fe68bdb23e385108).COMMON_FINDS, commonFinds);
    // Mythic Finds
    const mythicFinds = new (0, $e4cb996cf1b3c32d$export$fe3cf7bac7de6d6d)((0, $1a153cf88c479932$export$cc91196ccdb51fef).DISPLAY_OFFSETS, "Vault of Mythic Finds", (0, $248954e6cbd64b56$export$892596cec99bc70e).PIGMENT_LIGHT_WHITE, (0, $f0b5fa422dff3899$export$1fc8f52ad1810e52).COLLECTIBLE_MYTHIC);
    tc.set((0, $f0b5fa422dff3899$export$fe68bdb23e385108).MYTHIC_FINDS, mythicFinds);
    // Loadout viewer
    const loadout = new (0, $73c2eb62c7c5aba6$export$f1c1812ed2ac1602)((0, $1a153cf88c479932$export$cc91196ccdb51fef).DISPLAY_OFFSETS, "Equipment Loadout");
    tc.set((0, $f0b5fa422dff3899$export$fe68bdb23e385108).VIEW_LOADOUT, loadout);
    return tc;
}


window.addEventListener("DOMContentLoaded", ()=>{
    const messages = window.document.getElementById("messages");
    const game = window.document.getElementById("game");
    const stats = window.document.getElementById("stats");
    if (messages && game && stats) {
        window.engine = new (0, $16de3851ce156f32$export$2c3b404bf3a77a1f)(messages, game, stats, (0, $f0b5fa422dff3899$export$8800d5c3a30bb568).Portals);
        const ticker = document.getElementById("ticker");
        const canvas = document.querySelector("canvas");
        if (ticker && canvas) ticker.setAttribute("style", "width: " + String(canvas.width) + "px");
    }
});


//# sourceMappingURL=index.3511d72e.js.map
